const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "assets/TimerUsa-MV41g.js",
      "assets/vendor-MV119.js",
      "assets/qrcode-DpynCwP9.js",
      "assets/DealsList-MV41g.js",
      "assets/ManualDealsTab-MV41g.js",
      "assets/NetworkLeadsTab-MV41g.js",
      "assets/DocModal-MV41g.js",
    ]),
) => i.map((i) => d[i]);
import {
  r as Ap,
  a as Tp,
  R as bd,
  b as x,
  S as _p,
  P as zx,
  C as Dp,
  D as Zx,
  c as Jx,
  d as Wx,
  e as ii,
  X as hs,
  I as Zr,
  T as qa,
  f as ci,
  g as zp,
  H as Lp,
  L as Bp,
  h as di,
  G as Op,
  i as Up,
  E as tr,
  j as er,
  k as ms,
  l as Px,
  m as ar,
  n as ui,
  Z as ef,
  o as Mp,
  p as Rp,
  q as Gp,
  s as tf,
  t as af,
  u as Hp,
  M as Xp,
  F as Yp,
  v as Ip,
  Y as qp,
  Q as Lx,
  w as cd,
  x as Bx,
  U as Fp,
} from "./vendor-MV119.js";
import { r as Vp } from "./qrcode-DpynCwP9.js";
const MvFbPre = "https://l.facebook.com/l.php?u=";
const MvFbUn = (f) => {
  if (typeof f !== "string") return f;
  const m =
    /^\s*https?:\/\/(?:l|lm|m|www|web|mbasic)\.facebook\.com\/l\.php\?u=(\S+)/i.exec(
      f,
    );
  if (!m) return f;
  let u = m[1];
  if (/^https?%3A/i.test(u)) {
    u = u.split("&")[0];
    try {
      u = decodeURIComponent(u);
    } catch {}
  }
  return u;
};
const MvFbOpt = x.memo(function MvFbOpt({
  on: o,
  set: s,
  off: d,
  neon: n,
  ar: r,
}) {
  return l.jsxs("label", {
    className: "mv-fbl-opt cursor-pointer select-none",
    "data-no-i18n": "",
    translate: "no",
    title: r
      ? "كل رابط قصير جديد سيبدأ بـ " + MvFbPre
      : "Every new short link will start with " + MvFbPre,
    children: [
      l.jsx("input", {
        type: "checkbox",
        checked: o,
        onChange: (e) => s(e.target.checked),
        disabled: d,
        className:
          "w-4.5 h-4.5 accent-cyan-500 cursor-pointer rounded mv-fbl-cb",
      }),
      l.jsxs("span", {
        className:
          (n ? "text-cyan-100" : "text-slate-900") +
          " font-extrabold mv-fbl-txt",
        dir: "ltr",
        children: [
          l.jsx("span", { className: "mv-fbl-k", children: "ADD FB LINK:" }),
          " ",
          l.jsxs("span", {
            className: "mv-fbl-u",
            children: [
              l.jsx("span", {
                className: "mv-fbl-n",
                children: "https://l.facebook.com/",
              }),
              l.jsx("wbr", {}),
              l.jsx("span", { className: "mv-fbl-n", children: "l.php?u=" }),
            ],
          }),
        ],
      }),
    ],
  });
});
let MvIm = null;
const MvNets = x.memo(function MvNets(p) {
  const [s, S] = x.useState(!1);
  x.useEffect(() => {
    let d = !1;
    const go = () => {
      if (d) return;
      typeof x.startTransition == "function"
        ? x.startTransition(() => S(!0))
        : S(!0);
    };
    const ric = window.requestIdleCallback,
      id = ric ? ric(go, { timeout: 1500 }) : setTimeout(go, 300);
    return () => {
      d = !0;
      try {
        ric && window.cancelIdleCallback
          ? window.cancelIdleCallback(id)
          : clearTimeout(id);
      } catch {}
    };
  }, []);
  return s
    ? l.jsx(MvIm || (MvIm = x.memo(im)), p)
    : l.jsx("section", {
        className:
          "w-full my-6 glass-header border-y border-white/10 py-6 px-4 sm:px-6 relative overflow-hidden select-none mv-rd-nets mv-rd-nets-ph",
        "aria-hidden": "true",
      });
});
const MvAppRef = (el) => {
  try {
    document.documentElement.classList.toggle("mv-rd-has-app", !!el);
  } catch {}
};
const MvTw = x.memo(function MvTw({ lang: L }) {
  const W =
    L === "ar"
      ? ["التسويق بالعمولة.", "مواقع التواصل."]
      : ["affiliate links.", "social media."];
  const [T, S] = x.useState(W[0]);
  x.useEffect(() => {
    const q =
      L === "ar"
        ? ["التسويق بالعمولة.", "مواقع التواصل."]
        : ["affiliate links.", "social media."];
    let me = 0,
      ge = q[0].length,
      xe = !0,
      Ce;
    S(q[0]);
    const Zt = () => {
      const ca = q[me];
      let Ot = xe ? 45 : 85;
      (xe
        ? (S(ca.slice(0, ge - 1)),
          ge--,
          ge === 0 && ((xe = !1), (me = (me + 1) % q.length), (Ot = 250)))
        : (S(ca.slice(0, ge + 1)),
          ge++,
          ge === ca.length && ((xe = !0), (Ot = 1500))),
        (Ce = window.setTimeout(Zt, Ot)));
    };
    return ((Ce = window.setTimeout(Zt, 1500)), () => clearTimeout(Ce));
  }, [L]);
  return T;
});
function MvMarq(R) {
  const el = R && R.current;
  if (!el) return;
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  )
    return;
  let vis = !("IntersectionObserver" in window),
    raf = 0,
    last = 0,
    acc = 0,
    third = 0,
    io = null,
    dead = !1,
    tick = 0;
  const measure = () => {
    third = el.scrollWidth / 3;
  };
  const stop = () => {
    raf && cancelAnimationFrame(raf);
    raf = 0;
    last = 0;
  };
  const loop = (t) => {
    raf = 0;
    if (dead || !vis || document.hidden) {
      last = 0;
      return;
    }
    if (last) {
      acc += (t - last) / 25;
      if (acc > 8) acc = 8;
    }
    last = t;
    if (acc >= 1) {
      const n = Math.floor(acc);
      acc -= n;
      if (!third || ++tick % 120 === 0) measure();
      el.scrollLeft >= third ? (el.scrollLeft = 0) : (el.scrollLeft += n);
    }
    raf = requestAnimationFrame(loop);
  };
  const kick = () => {
    if (!raf && !dead && vis && !document.hidden)
      raf = requestAnimationFrame(loop);
  };
  if (!vis) {
    io = new IntersectionObserver((e) => {
      vis = e[e.length - 1].isIntersecting;
      vis ? kick() : stop();
    });
    io.observe(el);
  }
  document.addEventListener("visibilitychange", kick);
  kick();
  return () => {
    dead = !0;
    stop();
    io && io.disconnect();
    document.removeEventListener("visibilitychange", kick);
  };
}
(function () {
  const V = document.createElement("link").relList;
  if (V && V.supports && V.supports("modulepreload")) return;
  for (const I of document.querySelectorAll('link[rel="modulepreload"]')) h(I);
  new MutationObserver((I) => {
    for (const j of I)
      if (j.type === "childList")
        for (const se of j.addedNodes)
          se.tagName === "LINK" && se.rel === "modulepreload" && h(se);
  }).observe(document, { childList: !0, subtree: !0 });
  function b(I) {
    const j = {};
    return (
      I.integrity && (j.integrity = I.integrity),
      I.referrerPolicy && (j.referrerPolicy = I.referrerPolicy),
      I.crossOrigin === "use-credentials"
        ? (j.credentials = "include")
        : I.crossOrigin === "anonymous"
          ? (j.credentials = "omit")
          : (j.credentials = "same-origin"),
      j
    );
  }
  function h(I) {
    if (I.ep) return;
    I.ep = !0;
    const j = b(I);
    fetch(I.href, j);
  }
})();
var dd = { exports: {} },
  Qr = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Ox;
function $p() {
  if (Ox) return Qr;
  Ox = 1;
  var f = Symbol.for("react.transitional.element"),
    V = Symbol.for("react.fragment");
  function b(h, I, j) {
    var se = null;
    if (
      (j !== void 0 && (se = "" + j),
      I.key !== void 0 && (se = "" + I.key),
      "key" in I)
    ) {
      j = {};
      for (var J in I) J !== "key" && (j[J] = I[J]);
    } else j = I;
    return (
      (I = j.ref),
      { $$typeof: f, type: h, key: se, ref: I !== void 0 ? I : null, props: j }
    );
  }
  return ((Qr.Fragment = V), (Qr.jsx = b), (Qr.jsxs = b), Qr);
}
var Ux;
function Qp() {
  return (Ux || ((Ux = 1), (dd.exports = $p())), dd.exports);
}
var l = Qp(),
  ud = { exports: {} },
  Kr = {},
  xd = { exports: {} },
  fd = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Mx;
function Kp() {
  return (
    Mx ||
      ((Mx = 1),
      (function (f) {
        function V(C, D) {
          var U = C.length;
          C.push(D);
          e: for (; 0 < U;) {
            var y = (U - 1) >>> 1,
              X = C[y];
            if (0 < I(X, D)) ((C[y] = D), (C[U] = X), (U = y));
            else break e;
          }
        }
        function b(C) {
          return C.length === 0 ? null : C[0];
        }
        function h(C) {
          if (C.length === 0) return null;
          var D = C[0],
            U = C.pop();
          if (U !== D) {
            C[0] = U;
            e: for (var y = 0, X = C.length, O = X >>> 1; y < O;) {
              var H = 2 * (y + 1) - 1,
                G = C[H],
                F = H + 1,
                le = C[F];
              if (0 > I(G, U))
                F < X && 0 > I(le, G)
                  ? ((C[y] = le), (C[F] = U), (y = F))
                  : ((C[y] = G), (C[H] = U), (y = H));
              else if (F < X && 0 > I(le, U))
                ((C[y] = le), (C[F] = U), (y = F));
              else break e;
            }
          }
          return D;
        }
        function I(C, D) {
          var U = C.sortIndex - D.sortIndex;
          return U !== 0 ? U : C.id - D.id;
        }
        if (
          ((f.unstable_now = void 0),
          typeof performance == "object" &&
            typeof performance.now == "function")
        ) {
          var j = performance;
          f.unstable_now = function () {
            return j.now();
          };
        } else {
          var se = Date,
            J = se.now();
          f.unstable_now = function () {
            return se.now() - J;
          };
        }
        var ee = [],
          W = [],
          Ae = 1,
          R = null,
          de = 3,
          Ge = !1,
          $ = !1,
          te = !1,
          Ve = !1,
          st = typeof setTimeout == "function" ? setTimeout : null,
          ot = typeof clearTimeout == "function" ? clearTimeout : null,
          ue = typeof setImmediate < "u" ? setImmediate : null;
        function Me(C) {
          for (var D = b(W); D !== null;) {
            if (D.callback === null) h(W);
            else if (D.startTime <= C)
              (h(W), (D.sortIndex = D.expirationTime), V(ee, D));
            else break;
            D = b(W);
          }
        }
        function ke(C) {
          if (((te = !1), Me(C), !$))
            if (b(ee) !== null) (($ = !0), Ze || ((Ze = !0), Oe()));
            else {
              var D = b(W);
              D !== null && Re(ke, D.startTime - C);
            }
        }
        var Ze = !1,
          it = -1,
          $e = 5,
          Nt = -1;
        function oe() {
          return Ve ? !0 : !(f.unstable_now() - Nt < $e);
        }
        function kt() {
          if (((Ve = !1), Ze)) {
            var C = f.unstable_now();
            Nt = C;
            var D = !0;
            try {
              e: {
                (($ = !1), te && ((te = !1), ot(it), (it = -1)), (Ge = !0));
                var U = de;
                try {
                  t: {
                    for (
                      Me(C), R = b(ee);
                      R !== null && !(R.expirationTime > C && oe());
                    ) {
                      var y = R.callback;
                      if (typeof y == "function") {
                        ((R.callback = null), (de = R.priorityLevel));
                        var X = y(R.expirationTime <= C);
                        if (((C = f.unstable_now()), typeof X == "function")) {
                          ((R.callback = X), Me(C), (D = !0));
                          break t;
                        }
                        (R === b(ee) && h(ee), Me(C));
                      } else h(ee);
                      R = b(ee);
                    }
                    if (R !== null) D = !0;
                    else {
                      var O = b(W);
                      (O !== null && Re(ke, O.startTime - C), (D = !1));
                    }
                  }
                  break e;
                } finally {
                  ((R = null), (de = U), (Ge = !1));
                }
                D = void 0;
              }
            } finally {
              D ? Oe() : (Ze = !1);
            }
          }
        }
        var Oe;
        if (typeof ue == "function")
          Oe = function () {
            ue(kt);
          };
        else if (typeof MessageChannel < "u") {
          var Pe = new MessageChannel(),
            nt = Pe.port2;
          ((Pe.port1.onmessage = kt),
            (Oe = function () {
              nt.postMessage(null);
            }));
        } else
          Oe = function () {
            st(kt, 0);
          };
        function Re(C, D) {
          it = st(function () {
            C(f.unstable_now());
          }, D);
        }
        ((f.unstable_IdlePriority = 5),
          (f.unstable_ImmediatePriority = 1),
          (f.unstable_LowPriority = 4),
          (f.unstable_NormalPriority = 3),
          (f.unstable_Profiling = null),
          (f.unstable_UserBlockingPriority = 2),
          (f.unstable_cancelCallback = function (C) {
            C.callback = null;
          }),
          (f.unstable_forceFrameRate = function (C) {
            0 > C || 125 < C
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : ($e = 0 < C ? Math.floor(1e3 / C) : 5);
          }),
          (f.unstable_getCurrentPriorityLevel = function () {
            return de;
          }),
          (f.unstable_next = function (C) {
            switch (de) {
              case 1:
              case 2:
              case 3:
                var D = 3;
                break;
              default:
                D = de;
            }
            var U = de;
            de = D;
            try {
              return C();
            } finally {
              de = U;
            }
          }),
          (f.unstable_requestPaint = function () {
            Ve = !0;
          }),
          (f.unstable_runWithPriority = function (C, D) {
            switch (C) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                C = 3;
            }
            var U = de;
            de = C;
            try {
              return D();
            } finally {
              de = U;
            }
          }),
          (f.unstable_scheduleCallback = function (C, D, U) {
            var y = f.unstable_now();
            switch (
              (typeof U == "object" && U !== null
                ? ((U = U.delay),
                  (U = typeof U == "number" && 0 < U ? y + U : y))
                : (U = y),
              C)
            ) {
              case 1:
                var X = -1;
                break;
              case 2:
                X = 250;
                break;
              case 5:
                X = 1073741823;
                break;
              case 4:
                X = 1e4;
                break;
              default:
                X = 5e3;
            }
            return (
              (X = U + X),
              (C = {
                id: Ae++,
                callback: D,
                priorityLevel: C,
                startTime: U,
                expirationTime: X,
                sortIndex: -1,
              }),
              U > y
                ? ((C.sortIndex = U),
                  V(W, C),
                  b(ee) === null &&
                    C === b(W) &&
                    (te ? (ot(it), (it = -1)) : (te = !0), Re(ke, U - y)))
                : ((C.sortIndex = X),
                  V(ee, C),
                  $ || Ge || (($ = !0), Ze || ((Ze = !0), Oe()))),
              C
            );
          }),
          (f.unstable_shouldYield = oe),
          (f.unstable_wrapCallback = function (C) {
            var D = de;
            return function () {
              var U = de;
              de = D;
              try {
                return C.apply(this, arguments);
              } finally {
                de = U;
              }
            };
          }));
      })(fd)),
    fd
  );
}
var Rx;
function Zp() {
  return (Rx || ((Rx = 1), (xd.exports = Kp())), xd.exports);
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Gx;
function Jp() {
  if (Gx) return Kr;
  Gx = 1;
  var f = Zp(),
    V = Ap(),
    b = Tp();
  function h(e) {
    var t = "https://react.dev/errors/" + e;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var a = 2; a < arguments.length; a++)
        t += "&args[]=" + encodeURIComponent(arguments[a]);
    }
    return (
      "Minified React error #" +
      e +
      "; visit " +
      t +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function I(e) {
    return !(!e || (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11));
  }
  function j(e) {
    var t = e,
      a = e;
    if (e.alternate) for (; t.return;) t = t.return;
    else {
      e = t;
      do ((t = e), (t.flags & 4098) !== 0 && (a = t.return), (e = t.return));
      while (e);
    }
    return t.tag === 3 ? a : null;
  }
  function se(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (
        (t === null && ((e = e.alternate), e !== null && (t = e.memoizedState)),
        t !== null)
      )
        return t.dehydrated;
    }
    return null;
  }
  function J(e) {
    if (e.tag === 31) {
      var t = e.memoizedState;
      if (
        (t === null && ((e = e.alternate), e !== null && (t = e.memoizedState)),
        t !== null)
      )
        return t.dehydrated;
    }
    return null;
  }
  function ee(e) {
    if (j(e) !== e) throw Error(h(188));
  }
  function W(e) {
    var t = e.alternate;
    if (!t) {
      if (((t = j(e)), t === null)) throw Error(h(188));
      return t !== e ? null : e;
    }
    for (var a = e, s = t; ;) {
      var n = a.return;
      if (n === null) break;
      var r = n.alternate;
      if (r === null) {
        if (((s = n.return), s !== null)) {
          a = s;
          continue;
        }
        break;
      }
      if (n.child === r.child) {
        for (r = n.child; r;) {
          if (r === a) return (ee(n), e);
          if (r === s) return (ee(n), t);
          r = r.sibling;
        }
        throw Error(h(188));
      }
      if (a.return !== s.return) ((a = n), (s = r));
      else {
        for (var o = !1, c = n.child; c;) {
          if (c === a) {
            ((o = !0), (a = n), (s = r));
            break;
          }
          if (c === s) {
            ((o = !0), (s = n), (a = r));
            break;
          }
          c = c.sibling;
        }
        if (!o) {
          for (c = r.child; c;) {
            if (c === a) {
              ((o = !0), (a = r), (s = n));
              break;
            }
            if (c === s) {
              ((o = !0), (s = r), (a = n));
              break;
            }
            c = c.sibling;
          }
          if (!o) throw Error(h(189));
        }
      }
      if (a.alternate !== s) throw Error(h(190));
    }
    if (a.tag !== 3) throw Error(h(188));
    return a.stateNode.current === a ? e : t;
  }
  function Ae(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e;
    for (e = e.child; e !== null;) {
      if (((t = Ae(e)), t !== null)) return t;
      e = e.sibling;
    }
    return null;
  }
  var R = Object.assign,
    de = Symbol.for("react.element"),
    Ge = Symbol.for("react.transitional.element"),
    $ = Symbol.for("react.portal"),
    te = Symbol.for("react.fragment"),
    Ve = Symbol.for("react.strict_mode"),
    st = Symbol.for("react.profiler"),
    ot = Symbol.for("react.consumer"),
    ue = Symbol.for("react.context"),
    Me = Symbol.for("react.forward_ref"),
    ke = Symbol.for("react.suspense"),
    Ze = Symbol.for("react.suspense_list"),
    it = Symbol.for("react.memo"),
    $e = Symbol.for("react.lazy"),
    Nt = Symbol.for("react.activity"),
    oe = Symbol.for("react.memo_cache_sentinel"),
    kt = Symbol.iterator;
  function Oe(e) {
    return e === null || typeof e != "object"
      ? null
      : ((e = (kt && e[kt]) || e["@@iterator"]),
        typeof e == "function" ? e : null);
  }
  var Pe = Symbol.for("react.client.reference");
  function nt(e) {
    if (e == null) return null;
    if (typeof e == "function")
      return e.$$typeof === Pe ? null : e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case te:
        return "Fragment";
      case st:
        return "Profiler";
      case Ve:
        return "StrictMode";
      case ke:
        return "Suspense";
      case Ze:
        return "SuspenseList";
      case Nt:
        return "Activity";
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case $:
          return "Portal";
        case ue:
          return e.displayName || "Context";
        case ot:
          return (e._context.displayName || "Context") + ".Consumer";
        case Me:
          var t = e.render;
          return (
            (e = e.displayName),
            e ||
              ((e = t.displayName || t.name || ""),
              (e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef")),
            e
          );
        case it:
          return (
            (t = e.displayName || null),
            t !== null ? t : nt(e.type) || "Memo"
          );
        case $e:
          ((t = e._payload), (e = e._init));
          try {
            return nt(e(t));
          } catch {}
      }
    return null;
  }
  var Re = Array.isArray,
    C = V.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    D = b.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    U = { pending: !1, data: null, method: null, action: null },
    y = [],
    X = -1;
  function O(e) {
    return { current: e };
  }
  function H(e) {
    0 > X || ((e.current = y[X]), (y[X] = null), X--);
  }
  function G(e, t) {
    (X++, (y[X] = e.current), (e.current = t));
  }
  var F = O(null),
    le = O(null),
    ie = O(null),
    pe = O(null);
  function Ie(e, t) {
    switch ((G(ie, t), G(le, e), G(F, null), t.nodeType)) {
      case 9:
      case 11:
        e = (e = t.documentElement) && (e = e.namespaceURI) ? tx(e) : 0;
        break;
      default:
        if (((e = t.tagName), (t = t.namespaceURI)))
          ((t = tx(t)), (e = ax(t, e)));
        else
          switch (e) {
            case "svg":
              e = 1;
              break;
            case "math":
              e = 2;
              break;
            default:
              e = 0;
          }
    }
    (H(F), G(F, e));
  }
  function Ct() {
    (H(F), H(le), H(ie));
  }
  function Ht(e) {
    e.memoizedState !== null && G(pe, e);
    var t = F.current,
      a = ax(t, e.type);
    t !== a && (G(le, e), G(F, a));
  }
  function Xt(e) {
    (le.current === e && (H(F), H(le)),
      pe.current === e && (H(pe), (qr._currentValue = U)));
  }
  var St, ba;
  function Vt(e) {
    if (St === void 0)
      try {
        throw Error();
      } catch (a) {
        var t = a.stack.trim().match(/\n( *(at )?)/);
        ((St = (t && t[1]) || ""),
          (ba =
            -1 <
            a.stack.indexOf(`
    at`)
              ? " (<anonymous>)"
              : -1 < a.stack.indexOf("@")
                ? "@unknown:0:0"
                : ""));
      }
    return (
      `
` +
      St +
      e +
      ba
    );
  }
  var Yt = !1;
  function Y(e, t) {
    if (!e || Yt) return "";
    Yt = !0;
    var a = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var s = {
        DetermineComponentFrameRoot: function () {
          try {
            if (t) {
              var L = function () {
                throw Error();
              };
              if (
                (Object.defineProperty(L.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                typeof Reflect == "object" && Reflect.construct)
              ) {
                try {
                  Reflect.construct(L, []);
                } catch (k) {
                  var N = k;
                }
                Reflect.construct(e, [], L);
              } else {
                try {
                  L.call();
                } catch (k) {
                  N = k;
                }
                e.call(L.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (k) {
                N = k;
              }
              (L = e()) &&
                typeof L.catch == "function" &&
                L.catch(function () {});
            }
          } catch (k) {
            if (k && N && typeof k.stack == "string") return [k.stack, N.stack];
          }
          return [null, null];
        },
      };
      s.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var n = Object.getOwnPropertyDescriptor(
        s.DetermineComponentFrameRoot,
        "name",
      );
      n &&
        n.configurable &&
        Object.defineProperty(s.DetermineComponentFrameRoot, "name", {
          value: "DetermineComponentFrameRoot",
        });
      var r = s.DetermineComponentFrameRoot(),
        o = r[0],
        c = r[1];
      if (o && c) {
        var u = o.split(`
`),
          w = c.split(`
`);
        for (
          n = s = 0;
          s < u.length && !u[s].includes("DetermineComponentFrameRoot");
        )
          s++;
        for (; n < w.length && !w[n].includes("DetermineComponentFrameRoot");)
          n++;
        if (s === u.length || n === w.length)
          for (
            s = u.length - 1, n = w.length - 1;
            1 <= s && 0 <= n && u[s] !== w[n];
          )
            n--;
        for (; 1 <= s && 0 <= n; s--, n--)
          if (u[s] !== w[n]) {
            if (s !== 1 || n !== 1)
              do
                if ((s--, n--, 0 > n || u[s] !== w[n])) {
                  var T =
                    `
` + u[s].replace(" at new ", " at ");
                  return (
                    e.displayName &&
                      T.includes("<anonymous>") &&
                      (T = T.replace("<anonymous>", e.displayName)),
                    T
                  );
                }
              while (1 <= s && 0 <= n);
            break;
          }
      }
    } finally {
      ((Yt = !1), (Error.prepareStackTrace = a));
    }
    return (a = e ? e.displayName || e.name : "") ? Vt(a) : "";
  }
  function re(e, t) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return Vt(e.type);
      case 16:
        return Vt("Lazy");
      case 13:
        return e.child !== t && t !== null
          ? Vt("Suspense Fallback")
          : Vt("Suspense");
      case 19:
        return Vt("SuspenseList");
      case 0:
      case 15:
        return Y(e.type, !1);
      case 11:
        return Y(e.type.render, !1);
      case 1:
        return Y(e.type, !0);
      case 31:
        return Vt("Activity");
      default:
        return "";
    }
  }
  function ve(e) {
    try {
      var t = "",
        a = null;
      do ((t += re(e, a)), (a = e), (e = e.return));
      while (e);
      return t;
    } catch (s) {
      return (
        `
Error generating stack: ` +
        s.message +
        `
` +
        s.stack
      );
    }
  }
  var Te = Object.prototype.hasOwnProperty,
    _e = f.unstable_scheduleCallback,
    ht = f.unstable_cancelCallback,
    ye = f.unstable_shouldYield,
    dl = f.unstable_requestPaint,
    we = f.unstable_now,
    Fa = f.unstable_getCurrentPriorityLevel,
    Qe = f.unstable_ImmediatePriority,
    da = f.unstable_UserBlockingPriority,
    Aa = f.unstable_NormalPriority,
    Va = f.unstable_LowPriority,
    bs = f.unstable_IdlePriority,
    $a = f.log,
    gs = f.unstable_setDisableYieldValue,
    ul = null,
    $t = null;
  function bt(e) {
    if (
      (typeof $a == "function" && gs(e),
      $t && typeof $t.setStrictMode == "function")
    )
      try {
        $t.setStrictMode(ul, e);
      } catch {}
  }
  var zt = Math.clz32 ? Math.clz32 : Il,
    vs = Math.log,
    Qa = Math.LN2;
  function Il(e) {
    return ((e >>>= 0), e === 0 ? 32 : (31 - ((vs(e) / Qa) | 0)) | 0);
  }
  var Ka = 256,
    Wt = 262144,
    Za = 4194304;
  function ga(e) {
    var t = e & 42;
    if (t !== 0) return t;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function Ja(e, t, a) {
    var s = e.pendingLanes;
    if (s === 0) return 0;
    var n = 0,
      r = e.suspendedLanes,
      o = e.pingedLanes;
    e = e.warmLanes;
    var c = s & 134217727;
    return (
      c !== 0
        ? ((s = c & ~r),
          s !== 0
            ? (n = ga(s))
            : ((o &= c),
              o !== 0
                ? (n = ga(o))
                : a || ((a = c & ~e), a !== 0 && (n = ga(a)))))
        : ((c = s & ~r),
          c !== 0
            ? (n = ga(c))
            : o !== 0
              ? (n = ga(o))
              : a || ((a = s & ~e), a !== 0 && (n = ga(a)))),
      n === 0
        ? 0
        : t !== 0 &&
            t !== n &&
            (t & r) === 0 &&
            ((r = n & -n),
            (a = t & -t),
            r >= a || (r === 32 && (a & 4194048) !== 0))
          ? t
          : n
    );
  }
  function Wa(e, t) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
  }
  function Pa(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function xl() {
    var e = Za;
    return ((Za <<= 1), (Za & 62914560) === 0 && (Za = 4194304), e);
  }
  function fl(e) {
    for (var t = [], a = 0; 31 > a; a++) t.push(e);
    return t;
  }
  function pl(e, t) {
    ((e.pendingLanes |= t),
      t !== 268435456 &&
        ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0)));
  }
  function ql(e, t, a, s, n, r) {
    var o = e.pendingLanes;
    ((e.pendingLanes = a),
      (e.suspendedLanes = 0),
      (e.pingedLanes = 0),
      (e.warmLanes = 0),
      (e.expiredLanes &= a),
      (e.entangledLanes &= a),
      (e.errorRecoveryDisabledLanes &= a),
      (e.shellSuspendCounter = 0));
    var c = e.entanglements,
      u = e.expirationTimes,
      w = e.hiddenUpdates;
    for (a = o & ~a; 0 < a;) {
      var T = 31 - zt(a),
        L = 1 << T;
      ((c[T] = 0), (u[T] = -1));
      var N = w[T];
      if (N !== null)
        for (w[T] = null, T = 0; T < N.length; T++) {
          var k = N[T];
          k !== null && (k.lane &= -536870913);
        }
      a &= ~L;
    }
    (s !== 0 && Vs(e, s, 0),
      r !== 0 && n === 0 && e.tag !== 0 && (e.suspendedLanes |= r & ~(o & ~t)));
  }
  function Vs(e, t, a) {
    ((e.pendingLanes |= t), (e.suspendedLanes &= ~t));
    var s = 31 - zt(t);
    ((e.entangledLanes |= t),
      (e.entanglements[s] = e.entanglements[s] | 1073741824 | (a & 261930)));
  }
  function ml(e, t) {
    var a = (e.entangledLanes |= t);
    for (e = e.entanglements; a;) {
      var s = 31 - zt(a),
        n = 1 << s;
      ((n & t) | (e[s] & t) && (e[s] |= t), (a &= ~n));
    }
  }
  function hl(e, t) {
    var a = t & -t;
    return (
      (a = (a & 42) !== 0 ? 1 : Ke(a)),
      (a & (e.suspendedLanes | t)) !== 0 ? 0 : a
    );
  }
  function Ke(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function Fl(e) {
    return (
      (e &= -e),
      2 < e ? (8 < e ? ((e & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
    );
  }
  function xt() {
    var e = D.p;
    return e !== 0 ? e : ((e = window.event), e === void 0 ? 32 : Cx(e.type));
  }
  function ys(e, t) {
    var a = D.p;
    try {
      return ((D.p = e), t());
    } finally {
      D.p = a;
    }
  }
  var Lt = Math.random().toString(36).slice(2),
    ft = "__reactFiber$" + Lt,
    Bt = "__reactProps$" + Lt,
    Pt = "__reactContainer$" + Lt,
    bl = "__reactEvents$" + Lt,
    el = "__reactListeners$" + Lt,
    bn = "__reactHandles$" + Lt,
    gn = "__reactResources$" + Lt,
    gl = "__reactMarker$" + Lt;
  function qe(e) {
    (delete e[ft], delete e[Bt], delete e[bl], delete e[el], delete e[bn]);
  }
  function ea(e) {
    var t = e[ft];
    if (t) return t;
    for (var a = e.parentNode; a;) {
      if ((t = a[Pt] || a[ft])) {
        if (
          ((a = t.alternate),
          t.child !== null || (a !== null && a.child !== null))
        )
          for (e = cx(e); e !== null;) {
            if ((a = e[ft])) return a;
            e = cx(e);
          }
        return t;
      }
      ((e = a), (a = e.parentNode));
    }
    return null;
  }
  function Vl(e) {
    if ((e = e[ft] || e[Pt])) {
      var t = e.tag;
      if (
        t === 5 ||
        t === 6 ||
        t === 13 ||
        t === 31 ||
        t === 26 ||
        t === 27 ||
        t === 3
      )
        return e;
    }
    return null;
  }
  function ua(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
    throw Error(h(33));
  }
  function Et(e) {
    var t = e[gn];
    return (
      t ||
        (t = e[gn] =
          { hoistableStyles: new Map(), hoistableScripts: new Map() }),
      t
    );
  }
  function et(e) {
    e[gl] = !0;
  }
  var tl = new Set(),
    vl = {};
  function It(e, t) {
    (xa(e, t), xa(e + "Capture", t));
  }
  function xa(e, t) {
    for (vl[e] = t, e = 0; e < t.length; e++) tl.add(t[e]);
  }
  var vn = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$",
    ),
    At = {},
    yl = {};
  function Bl(e) {
    return Te.call(yl, e)
      ? !0
      : Te.call(At, e)
        ? !1
        : vn.test(e)
          ? (yl[e] = !0)
          : ((At[e] = !0), !1);
  }
  function Qt(e, t, a) {
    if (Bl(t))
      if (a === null) e.removeAttribute(t);
      else {
        switch (typeof a) {
          case "undefined":
          case "function":
          case "symbol":
            e.removeAttribute(t);
            return;
          case "boolean":
            var s = t.toLowerCase().slice(0, 5);
            if (s !== "data-" && s !== "aria-") {
              e.removeAttribute(t);
              return;
            }
        }
        e.setAttribute(t, "" + a);
      }
  }
  function $l(e, t, a) {
    if (a === null) e.removeAttribute(t);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(t);
          return;
      }
      e.setAttribute(t, "" + a);
    }
  }
  function fa(e, t, a, s) {
    if (s === null) e.removeAttribute(a);
    else {
      switch (typeof s) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(a);
          return;
      }
      e.setAttributeNS(t, a, "" + s);
    }
  }
  function je(e) {
    switch (typeof e) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function ws(e) {
    var t = e.type;
    return (
      (e = e.nodeName) &&
      e.toLowerCase() === "input" &&
      (t === "checkbox" || t === "radio")
    );
  }
  function gt(e, t, a) {
    var s = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
    if (
      !e.hasOwnProperty(t) &&
      typeof s < "u" &&
      typeof s.get == "function" &&
      typeof s.set == "function"
    ) {
      var n = s.get,
        r = s.set;
      return (
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function () {
            return n.call(this);
          },
          set: function (o) {
            ((a = "" + o), r.call(this, o));
          },
        }),
        Object.defineProperty(e, t, { enumerable: s.enumerable }),
        {
          getValue: function () {
            return a;
          },
          setValue: function (o) {
            a = "" + o;
          },
          stopTracking: function () {
            ((e._valueTracker = null), delete e[t]);
          },
        }
      );
    }
  }
  function js(e) {
    if (!e._valueTracker) {
      var t = ws(e) ? "checked" : "value";
      e._valueTracker = gt(e, t, "" + e[t]);
    }
  }
  function va(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var a = t.getValue(),
      s = "";
    return (
      e && (s = ws(e) ? (e.checked ? "true" : "false") : e.value),
      (e = s),
      e !== a ? (t.setValue(e), !0) : !1
    );
  }
  function wl(e) {
    if (
      ((e = e || (typeof document < "u" ? document : void 0)), typeof e > "u")
    )
      return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var Ta = /[\n"\\]/g;
  function qt(e) {
    return e.replace(Ta, function (t) {
      return "\\" + t.charCodeAt(0).toString(16) + " ";
    });
  }
  function ta(e, t, a, s, n, r, o, c) {
    ((e.name = ""),
      o != null &&
      typeof o != "function" &&
      typeof o != "symbol" &&
      typeof o != "boolean"
        ? (e.type = o)
        : e.removeAttribute("type"),
      t != null
        ? o === "number"
          ? ((t === 0 && e.value === "") || e.value != t) &&
            (e.value = "" + je(t))
          : e.value !== "" + je(t) && (e.value = "" + je(t))
        : (o !== "submit" && o !== "reset") || e.removeAttribute("value"),
      t != null
        ? jl(e, o, je(t))
        : a != null
          ? jl(e, o, je(a))
          : s != null && e.removeAttribute("value"),
      n == null && r != null && (e.defaultChecked = !!r),
      n != null &&
        (e.checked = n && typeof n != "function" && typeof n != "symbol"),
      c != null &&
      typeof c != "function" &&
      typeof c != "symbol" &&
      typeof c != "boolean"
        ? (e.name = "" + je(c))
        : e.removeAttribute("name"));
  }
  function yn(e, t, a, s, n, r, o, c) {
    if (
      (r != null &&
        typeof r != "function" &&
        typeof r != "symbol" &&
        typeof r != "boolean" &&
        (e.type = r),
      t != null || a != null)
    ) {
      if (!((r !== "submit" && r !== "reset") || t != null)) {
        js(e);
        return;
      }
      ((a = a != null ? "" + je(a) : ""),
        (t = t != null ? "" + je(t) : a),
        c || t === e.value || (e.value = t),
        (e.defaultValue = t));
    }
    ((s = s ?? n),
      (s = typeof s != "function" && typeof s != "symbol" && !!s),
      (e.checked = c ? e.checked : !!s),
      (e.defaultChecked = !!s),
      o != null &&
        typeof o != "function" &&
        typeof o != "symbol" &&
        typeof o != "boolean" &&
        (e.name = o),
      js(e));
  }
  function jl(e, t, a) {
    (t === "number" && wl(e.ownerDocument) === e) ||
      e.defaultValue === "" + a ||
      (e.defaultValue = "" + a);
  }
  function aa(e, t, a, s) {
    if (((e = e.options), t)) {
      t = {};
      for (var n = 0; n < a.length; n++) t["$" + a[n]] = !0;
      for (a = 0; a < e.length; a++)
        ((n = t.hasOwnProperty("$" + e[a].value)),
          e[a].selected !== n && (e[a].selected = n),
          n && s && (e[a].defaultSelected = !0));
    } else {
      for (a = "" + je(a), t = null, n = 0; n < e.length; n++) {
        if (e[n].value === a) {
          ((e[n].selected = !0), s && (e[n].defaultSelected = !0));
          return;
        }
        t !== null || e[n].disabled || (t = e[n]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function ya(e, t, a) {
    if (
      t != null &&
      ((t = "" + je(t)), t !== e.value && (e.value = t), a == null)
    ) {
      e.defaultValue !== t && (e.defaultValue = t);
      return;
    }
    e.defaultValue = a != null ? "" + je(a) : "";
  }
  function Ql(e, t, a, s) {
    if (t == null) {
      if (s != null) {
        if (a != null) throw Error(h(92));
        if (Re(s)) {
          if (1 < s.length) throw Error(h(93));
          s = s[0];
        }
        a = s;
      }
      (a == null && (a = ""), (t = a));
    }
    ((a = je(t)),
      (e.defaultValue = a),
      (s = e.textContent),
      s === a && s !== "" && s !== null && (e.value = s),
      js(e));
  }
  function Nl(e, t) {
    if (t) {
      var a = e.firstChild;
      if (a && a === e.lastChild && a.nodeType === 3) {
        a.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var Ol = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " ",
    ),
  );
  function $s(e, t, a) {
    var s = t.indexOf("--") === 0;
    a == null || typeof a == "boolean" || a === ""
      ? s
        ? e.setProperty(t, "")
        : t === "float"
          ? (e.cssFloat = "")
          : (e[t] = "")
      : s
        ? e.setProperty(t, a)
        : typeof a != "number" || a === 0 || Ol.has(t)
          ? t === "float"
            ? (e.cssFloat = a)
            : (e[t] = ("" + a).trim())
          : (e[t] = a + "px");
  }
  function wn(e, t, a) {
    if (t != null && typeof t != "object") throw Error(h(62));
    if (((e = e.style), a != null)) {
      for (var s in a)
        !a.hasOwnProperty(s) ||
          (t != null && t.hasOwnProperty(s)) ||
          (s.indexOf("--") === 0
            ? e.setProperty(s, "")
            : s === "float"
              ? (e.cssFloat = "")
              : (e[s] = ""));
      for (var n in t)
        ((s = t[n]), t.hasOwnProperty(n) && a[n] !== s && $s(e, n, s));
    } else for (var r in t) t.hasOwnProperty(r) && $s(e, r, t[r]);
  }
  function Qs(e) {
    if (e.indexOf("-") === -1) return !1;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var _a = new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"],
    ]),
    Kl =
      /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function kl(e) {
    return Kl.test("" + e)
      ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
      : e;
  }
  function Da() {}
  var Ul = null;
  function za(e) {
    return (
      (e = e.target || e.srcElement || window),
      e.correspondingUseElement && (e = e.correspondingUseElement),
      e.nodeType === 3 ? e.parentNode : e
    );
  }
  var d = null,
    S = null;
  function p(e) {
    var t = Vl(e);
    if (t && (e = t.stateNode)) {
      var a = e[Bt] || null;
      e: switch (((e = t.stateNode), t.type)) {
        case "input":
          if (
            (ta(
              e,
              a.value,
              a.defaultValue,
              a.defaultValue,
              a.checked,
              a.defaultChecked,
              a.type,
              a.name,
            ),
            (t = a.name),
            a.type === "radio" && t != null)
          ) {
            for (a = e; a.parentNode;) a = a.parentNode;
            for (
              a = a.querySelectorAll(
                'input[name="' + qt("" + t) + '"][type="radio"]',
              ),
                t = 0;
              t < a.length;
              t++
            ) {
              var s = a[t];
              if (s !== e && s.form === e.form) {
                var n = s[Bt] || null;
                if (!n) throw Error(h(90));
                ta(
                  s,
                  n.value,
                  n.defaultValue,
                  n.defaultValue,
                  n.checked,
                  n.defaultChecked,
                  n.type,
                  n.name,
                );
              }
            }
            for (t = 0; t < a.length; t++)
              ((s = a[t]), s.form === e.form && va(s));
          }
          break e;
        case "textarea":
          ya(e, a.value, a.defaultValue);
          break e;
        case "select":
          ((t = a.value), t != null && aa(e, !!a.multiple, t, !1));
      }
    }
  }
  var Q = !1;
  function E(e, t, a) {
    if (Q) return e(t, a);
    Q = !0;
    try {
      var s = e(t);
      return s;
    } finally {
      if (
        ((Q = !1),
        (d !== null || S !== null) &&
          (Mo(), d && ((t = d), (e = S), (S = d = null), p(t), e)))
      )
        for (t = 0; t < e.length; t++) p(e[t]);
    }
  }
  function Z(e, t) {
    var a = e.stateNode;
    if (a === null) return null;
    var s = a[Bt] || null;
    if (s === null) return null;
    a = s[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        ((s = !s.disabled) ||
          ((e = e.type),
          (s = !(
            e === "button" ||
            e === "input" ||
            e === "select" ||
            e === "textarea"
          ))),
          (e = !s));
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (a && typeof a != "function") throw Error(h(231, t, typeof a));
    return a;
  }
  var M = !(
      typeof window > "u" ||
      typeof window.document > "u" ||
      typeof window.document.createElement > "u"
    ),
    K = !1;
  if (M)
    try {
      var ne = {};
      (Object.defineProperty(ne, "passive", {
        get: function () {
          K = !0;
        },
      }),
        window.addEventListener("test", ne, ne),
        window.removeEventListener("test", ne, ne));
    } catch {
      K = !1;
    }
  var ce = null,
    he = null,
    pt = null;
  function pa() {
    if (pt) return pt;
    var e,
      t = he,
      a = t.length,
      s,
      n = "value" in ce ? ce.value : ce.textContent,
      r = n.length;
    for (e = 0; e < a && t[e] === n[e]; e++);
    var o = a - e;
    for (s = 1; s <= o && t[a - s] === n[r - s]; s++);
    return (pt = n.slice(e, 1 < s ? 1 - s : void 0));
  }
  function Tt(e) {
    var t = e.keyCode;
    return (
      "charCode" in e
        ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
        : (e = t),
      e === 10 && (e = 13),
      32 <= e || e === 13 ? e : 0
    );
  }
  function wa() {
    return !0;
  }
  function Ee() {
    return !1;
  }
  function He(e) {
    function t(a, s, n, r, o) {
      ((this._reactName = a),
        (this._targetInst = n),
        (this.type = s),
        (this.nativeEvent = r),
        (this.target = o),
        (this.currentTarget = null));
      for (var c in e)
        e.hasOwnProperty(c) && ((a = e[c]), (this[c] = a ? a(r) : r[c]));
      return (
        (this.isDefaultPrevented = (
          r.defaultPrevented != null ? r.defaultPrevented : r.returnValue === !1
        )
          ? wa
          : Ee),
        (this.isPropagationStopped = Ee),
        this
      );
    }
    return (
      R(t.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a &&
            (a.preventDefault
              ? a.preventDefault()
              : typeof a.returnValue != "unknown" && (a.returnValue = !1),
            (this.isDefaultPrevented = wa));
        },
        stopPropagation: function () {
          var a = this.nativeEvent;
          a &&
            (a.stopPropagation
              ? a.stopPropagation()
              : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0),
            (this.isPropagationStopped = wa));
        },
        persist: function () {},
        isPersistent: wa,
      }),
      t
    );
  }
  var ia = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0,
    },
    Cl = He(ia),
    La = R({}, ia, { view: 0, detail: 0 }),
    Sl = He(La),
    Ba,
    vt,
    Oa,
    Zl = R({}, La, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: rr,
      button: 0,
      buttons: 0,
      relatedTarget: function (e) {
        return e.relatedTarget === void 0
          ? e.fromElement === e.srcElement
            ? e.toElement
            : e.fromElement
          : e.relatedTarget;
      },
      movementX: function (e) {
        return "movementX" in e
          ? e.movementX
          : (e !== Oa &&
              (Oa && e.type === "mousemove"
                ? ((Ba = e.screenX - Oa.screenX), (vt = e.screenY - Oa.screenY))
                : (vt = Ba = 0),
              (Oa = e)),
            Ba);
      },
      movementY: function (e) {
        return "movementY" in e ? e.movementY : vt;
      },
    }),
    Ks = He(Zl),
    El = R({}, Zl, { dataTransfer: 0 }),
    Al = He(El),
    xi = R({}, La, { relatedTarget: 0 }),
    sr = He(xi),
    Jr = R({}, ia, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
    Wr = He(Jr),
    nr = R({}, ia, {
      clipboardData: function (e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      },
    }),
    Jl = He(nr),
    gd = R({}, ia, { data: 0 }),
    Ns = He(gd),
    la = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified",
    },
    jn = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta",
    },
    fi = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey",
    };
  function Ml(e) {
    var t = this.nativeEvent;
    return t.getModifierState
      ? t.getModifierState(e)
      : (e = fi[e])
        ? !!t[e]
        : !1;
  }
  function rr() {
    return Ml;
  }
  var Wl = R({}, La, {
      key: function (e) {
        if (e.key) {
          var t = la[e.key] || e.key;
          if (t !== "Unidentified") return t;
        }
        return e.type === "keypress"
          ? ((e = Tt(e)), e === 13 ? "Enter" : String.fromCharCode(e))
          : e.type === "keydown" || e.type === "keyup"
            ? jn[e.keyCode] || "Unidentified"
            : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: rr,
      charCode: function (e) {
        return e.type === "keypress" ? Tt(e) : 0;
      },
      keyCode: function (e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function (e) {
        return e.type === "keypress"
          ? Tt(e)
          : e.type === "keydown" || e.type === "keyup"
            ? e.keyCode
            : 0;
      },
    }),
    Pr = He(Wl),
    Zs = R({}, Zl, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0,
    }),
    or = He(Zs),
    Js = R({}, La, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: rr,
    }),
    Ua = He(Js),
    eo = R({}, ia, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
    Ws = He(eo),
    pi = R({}, Zl, {
      deltaX: function (e) {
        return "deltaX" in e
          ? e.deltaX
          : "wheelDeltaX" in e
            ? -e.wheelDeltaX
            : 0;
      },
      deltaY: function (e) {
        return "deltaY" in e
          ? e.deltaY
          : "wheelDeltaY" in e
            ? -e.wheelDeltaY
            : "wheelDelta" in e
              ? -e.wheelDelta
              : 0;
      },
      deltaZ: 0,
      deltaMode: 0,
    }),
    mi = He(pi),
    hi = R({}, ia, { newState: 0, oldState: 0 }),
    ja = He(hi),
    ir = [9, 13, 27, 32],
    Nn = M && "CompositionEvent" in window,
    Ps = null;
  M && "documentMode" in document && (Ps = document.documentMode);
  var Rl = M && "TextEvent" in window && !Ps,
    en = M && (!Nn || (Ps && 8 < Ps && 11 >= Ps)),
    cr = " ",
    dr = !1;
  function ur(e, t) {
    switch (e) {
      case "keyup":
        return ir.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function xr(e) {
    return (
      (e = e.detail),
      typeof e == "object" && "data" in e ? e.data : null
    );
  }
  var Pl = !1;
  function Kt(e, t) {
    switch (e) {
      case "compositionend":
        return xr(t);
      case "keypress":
        return t.which !== 32 ? null : ((dr = !0), cr);
      case "textInput":
        return ((e = t.data), e === cr && dr ? null : e);
      default:
        return null;
    }
  }
  function to(e, t) {
    if (Pl)
      return e === "compositionend" || (!Nn && ur(e, t))
        ? ((e = pa()), (pt = he = ce = null), (Pl = !1), e)
        : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
          if (t.char && 1 < t.char.length) return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return en && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var bi = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
  };
  function fr(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!bi[e.type] : t === "textarea";
  }
  function kn(e, t, a, s) {
    (d ? (S ? S.push(s) : (S = [s])) : (d = s),
      (t = qo(t, "onChange")),
      0 < t.length &&
        ((a = new Cl("onChange", "change", null, a, s)),
        e.push({ event: a, listeners: t })));
  }
  var _ = null,
    ct = null;
  function A(e) {
    K0(e, 0);
  }
  function Cn(e) {
    var t = ua(e);
    if (va(t)) return e;
  }
  function i(e, t) {
    if (e === "change") return t;
  }
  var B = !1;
  if (M) {
    var q;
    if (M) {
      var me = "oninput" in document;
      if (!me) {
        var ge = document.createElement("div");
        (ge.setAttribute("oninput", "return;"),
          (me = typeof ge.oninput == "function"));
      }
      q = me;
    } else q = !1;
    B = q && (!document.documentMode || 9 < document.documentMode);
  }
  function xe() {
    _ && (_.detachEvent("onpropertychange", Ce), (ct = _ = null));
  }
  function Ce(e) {
    if (e.propertyName === "value" && Cn(ct)) {
      var t = [];
      (kn(t, ct, e, za(e)), E(A, t));
    }
  }
  function Zt(e, t, a) {
    e === "focusin"
      ? (xe(), (_ = t), (ct = a), _.attachEvent("onpropertychange", Ce))
      : e === "focusout" && xe();
  }
  function ca(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown")
      return Cn(ct);
  }
  function Ot(e, t) {
    if (e === "click") return Cn(t);
  }
  function Tl(e, t) {
    if (e === "input" || e === "change") return Cn(t);
  }
  function Ma(e, t) {
    return (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t);
  }
  var ma = typeof Object.is == "function" ? Object.is : Ma;
  function pr(e, t) {
    if (ma(e, t)) return !0;
    if (
      typeof e != "object" ||
      e === null ||
      typeof t != "object" ||
      t === null
    )
      return !1;
    var a = Object.keys(e),
      s = Object.keys(t);
    if (a.length !== s.length) return !1;
    for (s = 0; s < a.length; s++) {
      var n = a[s];
      if (!Te.call(t, n) || !ma(e[n], t[n])) return !1;
    }
    return !0;
  }
  function vd(e) {
    for (; e && e.firstChild;) e = e.firstChild;
    return e;
  }
  function yd(e, t) {
    var a = vd(e);
    e = 0;
    for (var s; a;) {
      if (a.nodeType === 3) {
        if (((s = e + a.textContent.length), e <= t && s >= t))
          return { node: a, offset: t - e };
        e = s;
      }
      e: {
        for (; a;) {
          if (a.nextSibling) {
            a = a.nextSibling;
            break e;
          }
          a = a.parentNode;
        }
        a = void 0;
      }
      a = vd(a);
    }
  }
  function wd(e, t) {
    return e && t
      ? e === t
        ? !0
        : e && e.nodeType === 3
          ? !1
          : t && t.nodeType === 3
            ? wd(e, t.parentNode)
            : "contains" in e
              ? e.contains(t)
              : e.compareDocumentPosition
                ? !!(e.compareDocumentPosition(t) & 16)
                : !1
      : !1;
  }
  function jd(e) {
    e =
      e != null &&
      e.ownerDocument != null &&
      e.ownerDocument.defaultView != null
        ? e.ownerDocument.defaultView
        : window;
    for (var t = wl(e.document); t instanceof e.HTMLIFrameElement;) {
      try {
        var a = typeof t.contentWindow.location.href == "string";
      } catch {
        a = !1;
      }
      if (a) e = t.contentWindow;
      else break;
      t = wl(e.document);
    }
    return t;
  }
  function gi(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return (
      t &&
      ((t === "input" &&
        (e.type === "text" ||
          e.type === "search" ||
          e.type === "tel" ||
          e.type === "url" ||
          e.type === "password")) ||
        t === "textarea" ||
        e.contentEditable === "true")
    );
  }
  var rf = M && "documentMode" in document && 11 >= document.documentMode,
    Sn = null,
    vi = null,
    mr = null,
    yi = !1;
  function Nd(e, t, a) {
    var s =
      a.window === a ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
    yi ||
      Sn == null ||
      Sn !== wl(s) ||
      ((s = Sn),
      "selectionStart" in s && gi(s)
        ? (s = { start: s.selectionStart, end: s.selectionEnd })
        : ((s = (
            (s.ownerDocument && s.ownerDocument.defaultView) ||
            window
          ).getSelection()),
          (s = {
            anchorNode: s.anchorNode,
            anchorOffset: s.anchorOffset,
            focusNode: s.focusNode,
            focusOffset: s.focusOffset,
          })),
      (mr && pr(mr, s)) ||
        ((mr = s),
        (s = qo(vi, "onSelect")),
        0 < s.length &&
          ((t = new Cl("onSelect", "select", null, t, a)),
          e.push({ event: t, listeners: s }),
          (t.target = Sn))));
  }
  function tn(e, t) {
    var a = {};
    return (
      (a[e.toLowerCase()] = t.toLowerCase()),
      (a["Webkit" + e] = "webkit" + t),
      (a["Moz" + e] = "moz" + t),
      a
    );
  }
  var En = {
      animationend: tn("Animation", "AnimationEnd"),
      animationiteration: tn("Animation", "AnimationIteration"),
      animationstart: tn("Animation", "AnimationStart"),
      transitionrun: tn("Transition", "TransitionRun"),
      transitionstart: tn("Transition", "TransitionStart"),
      transitioncancel: tn("Transition", "TransitionCancel"),
      transitionend: tn("Transition", "TransitionEnd"),
    },
    wi = {},
    kd = {};
  M &&
    ((kd = document.createElement("div").style),
    "AnimationEvent" in window ||
      (delete En.animationend.animation,
      delete En.animationiteration.animation,
      delete En.animationstart.animation),
    "TransitionEvent" in window || delete En.transitionend.transition);
  function an(e) {
    if (wi[e]) return wi[e];
    if (!En[e]) return e;
    var t = En[e],
      a;
    for (a in t) if (t.hasOwnProperty(a) && a in kd) return (wi[e] = t[a]);
    return e;
  }
  var Cd = an("animationend"),
    Sd = an("animationiteration"),
    Ed = an("animationstart"),
    of = an("transitionrun"),
    cf = an("transitionstart"),
    df = an("transitioncancel"),
    Ad = an("transitionend"),
    Td = new Map(),
    ji =
      "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
        " ",
      );
  ji.push("scrollEnd");
  function _l(e, t) {
    (Td.set(e, t), It(t, [e]));
  }
  var ao =
      typeof reportError == "function"
        ? reportError
        : function (e) {
            if (
              typeof window == "object" &&
              typeof window.ErrorEvent == "function"
            ) {
              var t = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message:
                  typeof e == "object" &&
                  e !== null &&
                  typeof e.message == "string"
                    ? String(e.message)
                    : String(e),
                error: e,
              });
              if (!window.dispatchEvent(t)) return;
            } else if (
              typeof process == "object" &&
              typeof process.emit == "function"
            ) {
              process.emit("uncaughtException", e);
              return;
            }
            console.error(e);
          },
    al = [],
    An = 0,
    Ni = 0;
  function lo() {
    for (var e = An, t = (Ni = An = 0); t < e;) {
      var a = al[t];
      al[t++] = null;
      var s = al[t];
      al[t++] = null;
      var n = al[t];
      al[t++] = null;
      var r = al[t];
      if (((al[t++] = null), s !== null && n !== null)) {
        var o = s.pending;
        (o === null ? (n.next = n) : ((n.next = o.next), (o.next = n)),
          (s.pending = n));
      }
      r !== 0 && _d(a, n, r);
    }
  }
  function so(e, t, a, s) {
    ((al[An++] = e),
      (al[An++] = t),
      (al[An++] = a),
      (al[An++] = s),
      (Ni |= s),
      (e.lanes |= s),
      (e = e.alternate),
      e !== null && (e.lanes |= s));
  }
  function ki(e, t, a, s) {
    return (so(e, t, a, s), no(e));
  }
  function ln(e, t) {
    return (so(e, null, null, t), no(e));
  }
  function _d(e, t, a) {
    e.lanes |= a;
    var s = e.alternate;
    s !== null && (s.lanes |= a);
    for (var n = !1, r = e.return; r !== null;)
      ((r.childLanes |= a),
        (s = r.alternate),
        s !== null && (s.childLanes |= a),
        r.tag === 22 &&
          ((e = r.stateNode), e === null || e._visibility & 1 || (n = !0)),
        (e = r),
        (r = r.return));
    return e.tag === 3
      ? ((r = e.stateNode),
        n &&
          t !== null &&
          ((n = 31 - zt(a)),
          (e = r.hiddenUpdates),
          (s = e[n]),
          s === null ? (e[n] = [t]) : s.push(t),
          (t.lane = a | 536870912)),
        r)
      : null;
  }
  function no(e) {
    if (50 < Mr) throw ((Mr = 0), (Lc = null), Error(h(185)));
    for (var t = e.return; t !== null;) ((e = t), (t = e.return));
    return e.tag === 3 ? e.stateNode : null;
  }
  var Tn = {};
  function uf(e, t, a, s) {
    ((this.tag = e),
      (this.key = a),
      (this.sibling =
        this.child =
        this.return =
        this.stateNode =
        this.type =
        this.elementType =
          null),
      (this.index = 0),
      (this.refCleanup = this.ref = null),
      (this.pendingProps = t),
      (this.dependencies =
        this.memoizedState =
        this.updateQueue =
        this.memoizedProps =
          null),
      (this.mode = s),
      (this.subtreeFlags = this.flags = 0),
      (this.deletions = null),
      (this.childLanes = this.lanes = 0),
      (this.alternate = null));
  }
  function Ra(e, t, a, s) {
    return new uf(e, t, a, s);
  }
  function Ci(e) {
    return ((e = e.prototype), !(!e || !e.isReactComponent));
  }
  function es(e, t) {
    var a = e.alternate;
    return (
      a === null
        ? ((a = Ra(e.tag, t, e.key, e.mode)),
          (a.elementType = e.elementType),
          (a.type = e.type),
          (a.stateNode = e.stateNode),
          (a.alternate = e),
          (e.alternate = a))
        : ((a.pendingProps = t),
          (a.type = e.type),
          (a.flags = 0),
          (a.subtreeFlags = 0),
          (a.deletions = null)),
      (a.flags = e.flags & 65011712),
      (a.childLanes = e.childLanes),
      (a.lanes = e.lanes),
      (a.child = e.child),
      (a.memoizedProps = e.memoizedProps),
      (a.memoizedState = e.memoizedState),
      (a.updateQueue = e.updateQueue),
      (t = e.dependencies),
      (a.dependencies =
        t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }),
      (a.sibling = e.sibling),
      (a.index = e.index),
      (a.ref = e.ref),
      (a.refCleanup = e.refCleanup),
      a
    );
  }
  function Dd(e, t) {
    e.flags &= 65011714;
    var a = e.alternate;
    return (
      a === null
        ? ((e.childLanes = 0),
          (e.lanes = t),
          (e.child = null),
          (e.subtreeFlags = 0),
          (e.memoizedProps = null),
          (e.memoizedState = null),
          (e.updateQueue = null),
          (e.dependencies = null),
          (e.stateNode = null))
        : ((e.childLanes = a.childLanes),
          (e.lanes = a.lanes),
          (e.child = a.child),
          (e.subtreeFlags = 0),
          (e.deletions = null),
          (e.memoizedProps = a.memoizedProps),
          (e.memoizedState = a.memoizedState),
          (e.updateQueue = a.updateQueue),
          (e.type = a.type),
          (t = a.dependencies),
          (e.dependencies =
            t === null
              ? null
              : { lanes: t.lanes, firstContext: t.firstContext })),
      e
    );
  }
  function ro(e, t, a, s, n, r) {
    var o = 0;
    if (((s = e), typeof e == "function")) Ci(e) && (o = 1);
    else if (typeof e == "string")
      o = hp(e, a, F.current)
        ? 26
        : e === "html" || e === "head" || e === "body"
          ? 27
          : 5;
    else
      e: switch (e) {
        case Nt:
          return (
            (e = Ra(31, a, t, n)),
            (e.elementType = Nt),
            (e.lanes = r),
            e
          );
        case te:
          return sn(a.children, n, r, t);
        case Ve:
          ((o = 8), (n |= 24));
          break;
        case st:
          return (
            (e = Ra(12, a, t, n | 2)),
            (e.elementType = st),
            (e.lanes = r),
            e
          );
        case ke:
          return (
            (e = Ra(13, a, t, n)),
            (e.elementType = ke),
            (e.lanes = r),
            e
          );
        case Ze:
          return (
            (e = Ra(19, a, t, n)),
            (e.elementType = Ze),
            (e.lanes = r),
            e
          );
        default:
          if (typeof e == "object" && e !== null)
            switch (e.$$typeof) {
              case ue:
                o = 10;
                break e;
              case ot:
                o = 9;
                break e;
              case Me:
                o = 11;
                break e;
              case it:
                o = 14;
                break e;
              case $e:
                ((o = 16), (s = null));
                break e;
            }
          ((o = 29),
            (a = Error(h(130, e === null ? "null" : typeof e, ""))),
            (s = null));
      }
    return (
      (t = Ra(o, a, t, n)),
      (t.elementType = e),
      (t.type = s),
      (t.lanes = r),
      t
    );
  }
  function sn(e, t, a, s) {
    return ((e = Ra(7, e, s, t)), (e.lanes = a), e);
  }
  function Si(e, t, a) {
    return ((e = Ra(6, e, null, t)), (e.lanes = a), e);
  }
  function zd(e) {
    var t = Ra(18, null, null, 0);
    return ((t.stateNode = e), t);
  }
  function Ei(e, t, a) {
    return (
      (t = Ra(4, e.children !== null ? e.children : [], e.key, t)),
      (t.lanes = a),
      (t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation,
      }),
      t
    );
  }
  var Ld = new WeakMap();
  function ll(e, t) {
    if (typeof e == "object" && e !== null) {
      var a = Ld.get(e);
      return a !== void 0
        ? a
        : ((t = { value: e, source: t, stack: ve(t) }), Ld.set(e, t), t);
    }
    return { value: e, source: t, stack: ve(t) };
  }
  var _n = [],
    Dn = 0,
    oo = null,
    hr = 0,
    sl = [],
    nl = 0,
    ks = null,
    Gl = 1,
    Hl = "";
  function ts(e, t) {
    ((_n[Dn++] = hr), (_n[Dn++] = oo), (oo = e), (hr = t));
  }
  function Bd(e, t, a) {
    ((sl[nl++] = Gl), (sl[nl++] = Hl), (sl[nl++] = ks), (ks = e));
    var s = Gl;
    e = Hl;
    var n = 32 - zt(s) - 1;
    ((s &= ~(1 << n)), (a += 1));
    var r = 32 - zt(t) + n;
    if (30 < r) {
      var o = n - (n % 5);
      ((r = (s & ((1 << o) - 1)).toString(32)),
        (s >>= o),
        (n -= o),
        (Gl = (1 << (32 - zt(t) + n)) | (a << n) | s),
        (Hl = r + e));
    } else ((Gl = (1 << r) | (a << n) | s), (Hl = e));
  }
  function Ai(e) {
    e.return !== null && (ts(e, 1), Bd(e, 1, 0));
  }
  function Ti(e) {
    for (; e === oo;)
      ((oo = _n[--Dn]), (_n[Dn] = null), (hr = _n[--Dn]), (_n[Dn] = null));
    for (; e === ks;)
      ((ks = sl[--nl]),
        (sl[nl] = null),
        (Hl = sl[--nl]),
        (sl[nl] = null),
        (Gl = sl[--nl]),
        (sl[nl] = null));
  }
  function Od(e, t) {
    ((sl[nl++] = Gl),
      (sl[nl++] = Hl),
      (sl[nl++] = ks),
      (Gl = t.id),
      (Hl = t.overflow),
      (ks = e));
  }
  var sa = null,
    dt = null,
    Ue = !1,
    Cs = null,
    rl = !1,
    _i = Error(h(519));
  function Ss(e) {
    var t = Error(
      h(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1]
          ? "text"
          : "HTML",
        "",
      ),
    );
    throw (br(ll(t, e)), _i);
  }
  function Ud(e) {
    var t = e.stateNode,
      a = e.type,
      s = e.memoizedProps;
    switch (((t[ft] = e), (t[Bt] = s), a)) {
      case "dialog":
        (ze("cancel", t), ze("close", t));
        break;
      case "iframe":
      case "object":
      case "embed":
        ze("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Gr.length; a++) ze(Gr[a], t);
        break;
      case "source":
        ze("error", t);
        break;
      case "img":
      case "image":
      case "link":
        (ze("error", t), ze("load", t));
        break;
      case "details":
        ze("toggle", t);
        break;
      case "input":
        (ze("invalid", t),
          yn(
            t,
            s.value,
            s.defaultValue,
            s.checked,
            s.defaultChecked,
            s.type,
            s.name,
            !0,
          ));
        break;
      case "select":
        ze("invalid", t);
        break;
      case "textarea":
        (ze("invalid", t), Ql(t, s.value, s.defaultValue, s.children));
    }
    ((a = s.children),
      (typeof a != "string" && typeof a != "number" && typeof a != "bigint") ||
      t.textContent === "" + a ||
      s.suppressHydrationWarning === !0 ||
      P0(t.textContent, a)
        ? (s.popover != null && (ze("beforetoggle", t), ze("toggle", t)),
          s.onScroll != null && ze("scroll", t),
          s.onScrollEnd != null && ze("scrollend", t),
          s.onClick != null && (t.onclick = Da),
          (t = !0))
        : (t = !1),
      t || Ss(e, !0));
  }
  function Md(e) {
    for (sa = e.return; sa;)
      switch (sa.tag) {
        case 5:
        case 31:
        case 13:
          rl = !1;
          return;
        case 27:
        case 3:
          rl = !0;
          return;
        default:
          sa = sa.return;
      }
  }
  function zn(e) {
    if (e !== sa) return !1;
    if (!Ue) return (Md(e), (Ue = !0), !1);
    var t = e.tag,
      a;
    if (
      ((a = t !== 3 && t !== 27) &&
        ((a = t === 5) &&
          ((a = e.type),
          (a =
            !(a !== "form" && a !== "button") || Qc(e.type, e.memoizedProps))),
        (a = !a)),
      a && dt && Ss(e),
      Md(e),
      t === 13)
    ) {
      if (((e = e.memoizedState), (e = e !== null ? e.dehydrated : null), !e))
        throw Error(h(317));
      dt = ix(e);
    } else if (t === 31) {
      if (((e = e.memoizedState), (e = e !== null ? e.dehydrated : null), !e))
        throw Error(h(317));
      dt = ix(e);
    } else
      t === 27
        ? ((t = dt), Hs(e.type) ? ((e = Pc), (Pc = null), (dt = e)) : (dt = t))
        : (dt = sa ? il(e.stateNode.nextSibling) : null);
    return !0;
  }
  function nn() {
    ((dt = sa = null), (Ue = !1));
  }
  function Di() {
    var e = Cs;
    return (
      e !== null &&
        (Sa === null ? (Sa = e) : Sa.push.apply(Sa, e), (Cs = null)),
      e
    );
  }
  function br(e) {
    Cs === null ? (Cs = [e]) : Cs.push(e);
  }
  var zi = O(null),
    rn = null,
    as = null;
  function Es(e, t, a) {
    (G(zi, t._currentValue), (t._currentValue = a));
  }
  function ls(e) {
    ((e._currentValue = zi.current), H(zi));
  }
  function Li(e, t, a) {
    for (; e !== null;) {
      var s = e.alternate;
      if (
        ((e.childLanes & t) !== t
          ? ((e.childLanes |= t), s !== null && (s.childLanes |= t))
          : s !== null && (s.childLanes & t) !== t && (s.childLanes |= t),
        e === a)
      )
        break;
      e = e.return;
    }
  }
  function Bi(e, t, a, s) {
    var n = e.child;
    for (n !== null && (n.return = e); n !== null;) {
      var r = n.dependencies;
      if (r !== null) {
        var o = n.child;
        r = r.firstContext;
        e: for (; r !== null;) {
          var c = r;
          r = n;
          for (var u = 0; u < t.length; u++)
            if (c.context === t[u]) {
              ((r.lanes |= a),
                (c = r.alternate),
                c !== null && (c.lanes |= a),
                Li(r.return, a, e),
                s || (o = null));
              break e;
            }
          r = c.next;
        }
      } else if (n.tag === 18) {
        if (((o = n.return), o === null)) throw Error(h(341));
        ((o.lanes |= a),
          (r = o.alternate),
          r !== null && (r.lanes |= a),
          Li(o, a, e),
          (o = null));
      } else o = n.child;
      if (o !== null) o.return = n;
      else
        for (o = n; o !== null;) {
          if (o === e) {
            o = null;
            break;
          }
          if (((n = o.sibling), n !== null)) {
            ((n.return = o.return), (o = n));
            break;
          }
          o = o.return;
        }
      n = o;
    }
  }
  function Ln(e, t, a, s) {
    e = null;
    for (var n = t, r = !1; n !== null;) {
      if (!r) {
        if ((n.flags & 524288) !== 0) r = !0;
        else if ((n.flags & 262144) !== 0) break;
      }
      if (n.tag === 10) {
        var o = n.alternate;
        if (o === null) throw Error(h(387));
        if (((o = o.memoizedProps), o !== null)) {
          var c = n.type;
          ma(n.pendingProps.value, o.value) ||
            (e !== null ? e.push(c) : (e = [c]));
        }
      } else if (n === pe.current) {
        if (((o = n.alternate), o === null)) throw Error(h(387));
        o.memoizedState.memoizedState !== n.memoizedState.memoizedState &&
          (e !== null ? e.push(qr) : (e = [qr]));
      }
      n = n.return;
    }
    (e !== null && Bi(t, e, a, s), (t.flags |= 262144));
  }
  function io(e) {
    for (e = e.firstContext; e !== null;) {
      if (!ma(e.context._currentValue, e.memoizedValue)) return !0;
      e = e.next;
    }
    return !1;
  }
  function on(e) {
    ((rn = e),
      (as = null),
      (e = e.dependencies),
      e !== null && (e.firstContext = null));
  }
  function na(e) {
    return Rd(rn, e);
  }
  function co(e, t) {
    return (rn === null && on(e), Rd(e, t));
  }
  function Rd(e, t) {
    var a = t._currentValue;
    if (((t = { context: t, memoizedValue: a, next: null }), as === null)) {
      if (e === null) throw Error(h(308));
      ((as = t),
        (e.dependencies = { lanes: 0, firstContext: t }),
        (e.flags |= 524288));
    } else as = as.next = t;
    return a;
  }
  var xf =
      typeof AbortController < "u"
        ? AbortController
        : function () {
            var e = [],
              t = (this.signal = {
                aborted: !1,
                addEventListener: function (a, s) {
                  e.push(s);
                },
              });
            this.abort = function () {
              ((t.aborted = !0),
                e.forEach(function (a) {
                  return a();
                }));
            };
          },
    ff = f.unstable_scheduleCallback,
    pf = f.unstable_NormalPriority,
    Ut = {
      $$typeof: ue,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
    };
  function Oi() {
    return { controller: new xf(), data: new Map(), refCount: 0 };
  }
  function gr(e) {
    (e.refCount--,
      e.refCount === 0 &&
        ff(pf, function () {
          e.controller.abort();
        }));
  }
  var vr = null,
    Ui = 0,
    Bn = 0,
    On = null;
  function mf(e, t) {
    if (vr === null) {
      var a = (vr = []);
      ((Ui = 0),
        (Bn = Gc()),
        (On = {
          status: "pending",
          value: void 0,
          then: function (s) {
            a.push(s);
          },
        }));
    }
    return (Ui++, t.then(Gd, Gd), t);
  }
  function Gd() {
    if (--Ui === 0 && vr !== null) {
      On !== null && (On.status = "fulfilled");
      var e = vr;
      ((vr = null), (Bn = 0), (On = null));
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
  }
  function hf(e, t) {
    var a = [],
      s = {
        status: "pending",
        value: null,
        reason: null,
        then: function (n) {
          a.push(n);
        },
      };
    return (
      e.then(
        function () {
          ((s.status = "fulfilled"), (s.value = t));
          for (var n = 0; n < a.length; n++) (0, a[n])(t);
        },
        function (n) {
          for (s.status = "rejected", s.reason = n, n = 0; n < a.length; n++)
            (0, a[n])(void 0);
        },
      ),
      s
    );
  }
  var Hd = C.S;
  C.S = function (e, t) {
    ((N0 = we()),
      typeof t == "object" &&
        t !== null &&
        typeof t.then == "function" &&
        mf(e, t),
      Hd !== null && Hd(e, t));
  };
  var cn = O(null);
  function Mi() {
    var e = cn.current;
    return e !== null ? e : rt.pooledCache;
  }
  function uo(e, t) {
    t === null ? G(cn, cn.current) : G(cn, t.pool);
  }
  function Xd() {
    var e = Mi();
    return e === null ? null : { parent: Ut._currentValue, pool: e };
  }
  var Un = Error(h(460)),
    Ri = Error(h(474)),
    xo = Error(h(542)),
    fo = { then: function () {} };
  function Yd(e) {
    return ((e = e.status), e === "fulfilled" || e === "rejected");
  }
  function Id(e, t, a) {
    switch (
      ((a = e[a]),
      a === void 0 ? e.push(t) : a !== t && (t.then(Da, Da), (t = a)),
      t.status)
    ) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw ((e = t.reason), Fd(e), e);
      default:
        if (typeof t.status == "string") t.then(Da, Da);
        else {
          if (((e = rt), e !== null && 100 < e.shellSuspendCounter))
            throw Error(h(482));
          ((e = t),
            (e.status = "pending"),
            e.then(
              function (s) {
                if (t.status === "pending") {
                  var n = t;
                  ((n.status = "fulfilled"), (n.value = s));
                }
              },
              function (s) {
                if (t.status === "pending") {
                  var n = t;
                  ((n.status = "rejected"), (n.reason = s));
                }
              },
            ));
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw ((e = t.reason), Fd(e), e);
        }
        throw ((un = t), Un);
    }
  }
  function dn(e) {
    try {
      var t = e._init;
      return t(e._payload);
    } catch (a) {
      throw a !== null && typeof a == "object" && typeof a.then == "function"
        ? ((un = a), Un)
        : a;
    }
  }
  var un = null;
  function qd() {
    if (un === null) throw Error(h(459));
    var e = un;
    return ((un = null), e);
  }
  function Fd(e) {
    if (e === Un || e === xo) throw Error(h(483));
  }
  var Mn = null,
    yr = 0;
  function po(e) {
    var t = yr;
    return ((yr += 1), Mn === null && (Mn = []), Id(Mn, e, t));
  }
  function wr(e, t) {
    ((t = t.props.ref), (e.ref = t !== void 0 ? t : null));
  }
  function mo(e, t) {
    throw t.$$typeof === de
      ? Error(h(525))
      : ((e = Object.prototype.toString.call(t)),
        Error(
          h(
            31,
            e === "[object Object]"
              ? "object with keys {" + Object.keys(t).join(", ") + "}"
              : e,
          ),
        ));
  }
  function Vd(e) {
    function t(g, m) {
      if (e) {
        var v = g.deletions;
        v === null ? ((g.deletions = [m]), (g.flags |= 16)) : v.push(m);
      }
    }
    function a(g, m) {
      if (!e) return null;
      for (; m !== null;) (t(g, m), (m = m.sibling));
      return null;
    }
    function s(g) {
      for (var m = new Map(); g !== null;)
        (g.key !== null ? m.set(g.key, g) : m.set(g.index, g), (g = g.sibling));
      return m;
    }
    function n(g, m) {
      return ((g = es(g, m)), (g.index = 0), (g.sibling = null), g);
    }
    function r(g, m, v) {
      return (
        (g.index = v),
        e
          ? ((v = g.alternate),
            v !== null
              ? ((v = v.index), v < m ? ((g.flags |= 67108866), m) : v)
              : ((g.flags |= 67108866), m))
          : ((g.flags |= 1048576), m)
      );
    }
    function o(g) {
      return (e && g.alternate === null && (g.flags |= 67108866), g);
    }
    function c(g, m, v, z) {
      return m === null || m.tag !== 6
        ? ((m = Si(v, g.mode, z)), (m.return = g), m)
        : ((m = n(m, v)), (m.return = g), m);
    }
    function u(g, m, v, z) {
      var fe = v.type;
      return fe === te
        ? T(g, m, v.props.children, z, v.key)
        : m !== null &&
            (m.elementType === fe ||
              (typeof fe == "object" &&
                fe !== null &&
                fe.$$typeof === $e &&
                dn(fe) === m.type))
          ? ((m = n(m, v.props)), wr(m, v), (m.return = g), m)
          : ((m = ro(v.type, v.key, v.props, null, g.mode, z)),
            wr(m, v),
            (m.return = g),
            m);
    }
    function w(g, m, v, z) {
      return m === null ||
        m.tag !== 4 ||
        m.stateNode.containerInfo !== v.containerInfo ||
        m.stateNode.implementation !== v.implementation
        ? ((m = Ei(v, g.mode, z)), (m.return = g), m)
        : ((m = n(m, v.children || [])), (m.return = g), m);
    }
    function T(g, m, v, z, fe) {
      return m === null || m.tag !== 7
        ? ((m = sn(v, g.mode, z, fe)), (m.return = g), m)
        : ((m = n(m, v)), (m.return = g), m);
    }
    function L(g, m, v) {
      if (
        (typeof m == "string" && m !== "") ||
        typeof m == "number" ||
        typeof m == "bigint"
      )
        return ((m = Si("" + m, g.mode, v)), (m.return = g), m);
      if (typeof m == "object" && m !== null) {
        switch (m.$$typeof) {
          case Ge:
            return (
              (v = ro(m.type, m.key, m.props, null, g.mode, v)),
              wr(v, m),
              (v.return = g),
              v
            );
          case $:
            return ((m = Ei(m, g.mode, v)), (m.return = g), m);
          case $e:
            return ((m = dn(m)), L(g, m, v));
        }
        if (Re(m) || Oe(m))
          return ((m = sn(m, g.mode, v, null)), (m.return = g), m);
        if (typeof m.then == "function") return L(g, po(m), v);
        if (m.$$typeof === ue) return L(g, co(g, m), v);
        mo(g, m);
      }
      return null;
    }
    function N(g, m, v, z) {
      var fe = m !== null ? m.key : null;
      if (
        (typeof v == "string" && v !== "") ||
        typeof v == "number" ||
        typeof v == "bigint"
      )
        return fe !== null ? null : c(g, m, "" + v, z);
      if (typeof v == "object" && v !== null) {
        switch (v.$$typeof) {
          case Ge:
            return v.key === fe ? u(g, m, v, z) : null;
          case $:
            return v.key === fe ? w(g, m, v, z) : null;
          case $e:
            return ((v = dn(v)), N(g, m, v, z));
        }
        if (Re(v) || Oe(v)) return fe !== null ? null : T(g, m, v, z, null);
        if (typeof v.then == "function") return N(g, m, po(v), z);
        if (v.$$typeof === ue) return N(g, m, co(g, v), z);
        mo(g, v);
      }
      return null;
    }
    function k(g, m, v, z, fe) {
      if (
        (typeof z == "string" && z !== "") ||
        typeof z == "number" ||
        typeof z == "bigint"
      )
        return ((g = g.get(v) || null), c(m, g, "" + z, fe));
      if (typeof z == "object" && z !== null) {
        switch (z.$$typeof) {
          case Ge:
            return (
              (g = g.get(z.key === null ? v : z.key) || null),
              u(m, g, z, fe)
            );
          case $:
            return (
              (g = g.get(z.key === null ? v : z.key) || null),
              w(m, g, z, fe)
            );
          case $e:
            return ((z = dn(z)), k(g, m, v, z, fe));
        }
        if (Re(z) || Oe(z))
          return ((g = g.get(v) || null), T(m, g, z, fe, null));
        if (typeof z.then == "function") return k(g, m, v, po(z), fe);
        if (z.$$typeof === ue) return k(g, m, v, co(m, z), fe);
        mo(m, z);
      }
      return null;
    }
    function P(g, m, v, z) {
      for (
        var fe = null, Xe = null, ae = m, Se = (m = 0), Be = null;
        ae !== null && Se < v.length;
        Se++
      ) {
        ae.index > Se ? ((Be = ae), (ae = null)) : (Be = ae.sibling);
        var Ye = N(g, ae, v[Se], z);
        if (Ye === null) {
          ae === null && (ae = Be);
          break;
        }
        (e && ae && Ye.alternate === null && t(g, ae),
          (m = r(Ye, m, Se)),
          Xe === null ? (fe = Ye) : (Xe.sibling = Ye),
          (Xe = Ye),
          (ae = Be));
      }
      if (Se === v.length) return (a(g, ae), Ue && ts(g, Se), fe);
      if (ae === null) {
        for (; Se < v.length; Se++)
          ((ae = L(g, v[Se], z)),
            ae !== null &&
              ((m = r(ae, m, Se)),
              Xe === null ? (fe = ae) : (Xe.sibling = ae),
              (Xe = ae)));
        return (Ue && ts(g, Se), fe);
      }
      for (ae = s(ae); Se < v.length; Se++)
        ((Be = k(ae, g, Se, v[Se], z)),
          Be !== null &&
            (e &&
              Be.alternate !== null &&
              ae.delete(Be.key === null ? Se : Be.key),
            (m = r(Be, m, Se)),
            Xe === null ? (fe = Be) : (Xe.sibling = Be),
            (Xe = Be)));
      return (
        e &&
          ae.forEach(function (Fs) {
            return t(g, Fs);
          }),
        Ue && ts(g, Se),
        fe
      );
    }
    function be(g, m, v, z) {
      if (v == null) throw Error(h(151));
      for (
        var fe = null,
          Xe = null,
          ae = m,
          Se = (m = 0),
          Be = null,
          Ye = v.next();
        ae !== null && !Ye.done;
        Se++, Ye = v.next()
      ) {
        ae.index > Se ? ((Be = ae), (ae = null)) : (Be = ae.sibling);
        var Fs = N(g, ae, Ye.value, z);
        if (Fs === null) {
          ae === null && (ae = Be);
          break;
        }
        (e && ae && Fs.alternate === null && t(g, ae),
          (m = r(Fs, m, Se)),
          Xe === null ? (fe = Fs) : (Xe.sibling = Fs),
          (Xe = Fs),
          (ae = Be));
      }
      if (Ye.done) return (a(g, ae), Ue && ts(g, Se), fe);
      if (ae === null) {
        for (; !Ye.done; Se++, Ye = v.next())
          ((Ye = L(g, Ye.value, z)),
            Ye !== null &&
              ((m = r(Ye, m, Se)),
              Xe === null ? (fe = Ye) : (Xe.sibling = Ye),
              (Xe = Ye)));
        return (Ue && ts(g, Se), fe);
      }
      for (ae = s(ae); !Ye.done; Se++, Ye = v.next())
        ((Ye = k(ae, g, Se, Ye.value, z)),
          Ye !== null &&
            (e &&
              Ye.alternate !== null &&
              ae.delete(Ye.key === null ? Se : Ye.key),
            (m = r(Ye, m, Se)),
            Xe === null ? (fe = Ye) : (Xe.sibling = Ye),
            (Xe = Ye)));
      return (
        e &&
          ae.forEach(function (Ep) {
            return t(g, Ep);
          }),
        Ue && ts(g, Se),
        fe
      );
    }
    function lt(g, m, v, z) {
      if (
        (typeof v == "object" &&
          v !== null &&
          v.type === te &&
          v.key === null &&
          (v = v.props.children),
        typeof v == "object" && v !== null)
      ) {
        switch (v.$$typeof) {
          case Ge:
            e: {
              for (var fe = v.key; m !== null;) {
                if (m.key === fe) {
                  if (((fe = v.type), fe === te)) {
                    if (m.tag === 7) {
                      (a(g, m.sibling),
                        (z = n(m, v.props.children)),
                        (z.return = g),
                        (g = z));
                      break e;
                    }
                  } else if (
                    m.elementType === fe ||
                    (typeof fe == "object" &&
                      fe !== null &&
                      fe.$$typeof === $e &&
                      dn(fe) === m.type)
                  ) {
                    (a(g, m.sibling),
                      (z = n(m, v.props)),
                      wr(z, v),
                      (z.return = g),
                      (g = z));
                    break e;
                  }
                  a(g, m);
                  break;
                } else t(g, m);
                m = m.sibling;
              }
              v.type === te
                ? ((z = sn(v.props.children, g.mode, z, v.key)),
                  (z.return = g),
                  (g = z))
                : ((z = ro(v.type, v.key, v.props, null, g.mode, z)),
                  wr(z, v),
                  (z.return = g),
                  (g = z));
            }
            return o(g);
          case $:
            e: {
              for (fe = v.key; m !== null;) {
                if (m.key === fe)
                  if (
                    m.tag === 4 &&
                    m.stateNode.containerInfo === v.containerInfo &&
                    m.stateNode.implementation === v.implementation
                  ) {
                    (a(g, m.sibling),
                      (z = n(m, v.children || [])),
                      (z.return = g),
                      (g = z));
                    break e;
                  } else {
                    a(g, m);
                    break;
                  }
                else t(g, m);
                m = m.sibling;
              }
              ((z = Ei(v, g.mode, z)), (z.return = g), (g = z));
            }
            return o(g);
          case $e:
            return ((v = dn(v)), lt(g, m, v, z));
        }
        if (Re(v)) return P(g, m, v, z);
        if (Oe(v)) {
          if (((fe = Oe(v)), typeof fe != "function")) throw Error(h(150));
          return ((v = fe.call(v)), be(g, m, v, z));
        }
        if (typeof v.then == "function") return lt(g, m, po(v), z);
        if (v.$$typeof === ue) return lt(g, m, co(g, v), z);
        mo(g, v);
      }
      return (typeof v == "string" && v !== "") ||
        typeof v == "number" ||
        typeof v == "bigint"
        ? ((v = "" + v),
          m !== null && m.tag === 6
            ? (a(g, m.sibling), (z = n(m, v)), (z.return = g), (g = z))
            : (a(g, m), (z = Si(v, g.mode, z)), (z.return = g), (g = z)),
          o(g))
        : a(g, m);
    }
    return function (g, m, v, z) {
      try {
        yr = 0;
        var fe = lt(g, m, v, z);
        return ((Mn = null), fe);
      } catch (ae) {
        if (ae === Un || ae === xo) throw ae;
        var Xe = Ra(29, ae, null, g.mode);
        return ((Xe.lanes = z), (Xe.return = g), Xe);
      } finally {
      }
    };
  }
  var xn = Vd(!0),
    $d = Vd(!1),
    As = !1;
  function Gi(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null,
    };
  }
  function Hi(e, t) {
    ((e = e.updateQueue),
      t.updateQueue === e &&
        (t.updateQueue = {
          baseState: e.baseState,
          firstBaseUpdate: e.firstBaseUpdate,
          lastBaseUpdate: e.lastBaseUpdate,
          shared: e.shared,
          callbacks: null,
        }));
  }
  function Ts(e) {
    return { lane: e, tag: 0, payload: null, callback: null, next: null };
  }
  function _s(e, t, a) {
    var s = e.updateQueue;
    if (s === null) return null;
    if (((s = s.shared), (Fe & 2) !== 0)) {
      var n = s.pending;
      return (
        n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)),
        (s.pending = t),
        (t = no(e)),
        _d(e, null, a),
        t
      );
    }
    return (so(e, s, t, a), no(e));
  }
  function jr(e, t, a) {
    if (
      ((t = t.updateQueue), t !== null && ((t = t.shared), (a & 4194048) !== 0))
    ) {
      var s = t.lanes;
      ((s &= e.pendingLanes), (a |= s), (t.lanes = a), ml(e, a));
    }
  }
  function Xi(e, t) {
    var a = e.updateQueue,
      s = e.alternate;
    if (s !== null && ((s = s.updateQueue), a === s)) {
      var n = null,
        r = null;
      if (((a = a.firstBaseUpdate), a !== null)) {
        do {
          var o = {
            lane: a.lane,
            tag: a.tag,
            payload: a.payload,
            callback: null,
            next: null,
          };
          (r === null ? (n = r = o) : (r = r.next = o), (a = a.next));
        } while (a !== null);
        r === null ? (n = r = t) : (r = r.next = t);
      } else n = r = t;
      ((a = {
        baseState: s.baseState,
        firstBaseUpdate: n,
        lastBaseUpdate: r,
        shared: s.shared,
        callbacks: s.callbacks,
      }),
        (e.updateQueue = a));
      return;
    }
    ((e = a.lastBaseUpdate),
      e === null ? (a.firstBaseUpdate = t) : (e.next = t),
      (a.lastBaseUpdate = t));
  }
  var Yi = !1;
  function Nr() {
    if (Yi) {
      var e = On;
      if (e !== null) throw e;
    }
  }
  function kr(e, t, a, s) {
    Yi = !1;
    var n = e.updateQueue;
    As = !1;
    var r = n.firstBaseUpdate,
      o = n.lastBaseUpdate,
      c = n.shared.pending;
    if (c !== null) {
      n.shared.pending = null;
      var u = c,
        w = u.next;
      ((u.next = null), o === null ? (r = w) : (o.next = w), (o = u));
      var T = e.alternate;
      T !== null &&
        ((T = T.updateQueue),
        (c = T.lastBaseUpdate),
        c !== o &&
          (c === null ? (T.firstBaseUpdate = w) : (c.next = w),
          (T.lastBaseUpdate = u)));
    }
    if (r !== null) {
      var L = n.baseState;
      ((o = 0), (T = w = u = null), (c = r));
      do {
        var N = c.lane & -536870913,
          k = N !== c.lane;
        if (k ? (Le & N) === N : (s & N) === N) {
          (N !== 0 && N === Bn && (Yi = !0),
            T !== null &&
              (T = T.next =
                {
                  lane: 0,
                  tag: c.tag,
                  payload: c.payload,
                  callback: null,
                  next: null,
                }));
          e: {
            var P = e,
              be = c;
            N = t;
            var lt = a;
            switch (be.tag) {
              case 1:
                if (((P = be.payload), typeof P == "function")) {
                  L = P.call(lt, L, N);
                  break e;
                }
                L = P;
                break e;
              case 3:
                P.flags = (P.flags & -65537) | 128;
              case 0:
                if (
                  ((P = be.payload),
                  (N = typeof P == "function" ? P.call(lt, L, N) : P),
                  N == null)
                )
                  break e;
                L = R({}, L, N);
                break e;
              case 2:
                As = !0;
            }
          }
          ((N = c.callback),
            N !== null &&
              ((e.flags |= 64),
              k && (e.flags |= 8192),
              (k = n.callbacks),
              k === null ? (n.callbacks = [N]) : k.push(N)));
        } else
          ((k = {
            lane: N,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null,
          }),
            T === null ? ((w = T = k), (u = L)) : (T = T.next = k),
            (o |= N));
        if (((c = c.next), c === null)) {
          if (((c = n.shared.pending), c === null)) break;
          ((k = c),
            (c = k.next),
            (k.next = null),
            (n.lastBaseUpdate = k),
            (n.shared.pending = null));
        }
      } while (!0);
      (T === null && (u = L),
        (n.baseState = u),
        (n.firstBaseUpdate = w),
        (n.lastBaseUpdate = T),
        r === null && (n.shared.lanes = 0),
        (Os |= o),
        (e.lanes = o),
        (e.memoizedState = L));
    }
  }
  function Qd(e, t) {
    if (typeof e != "function") throw Error(h(191, e));
    e.call(t);
  }
  function Kd(e, t) {
    var a = e.callbacks;
    if (a !== null)
      for (e.callbacks = null, e = 0; e < a.length; e++) Qd(a[e], t);
  }
  var Rn = O(null),
    ho = O(0);
  function Zd(e, t) {
    ((e = xs), G(ho, e), G(Rn, t), (xs = e | t.baseLanes));
  }
  function Ii() {
    (G(ho, xs), G(Rn, Rn.current));
  }
  function qi() {
    ((xs = ho.current), H(Rn), H(ho));
  }
  var Ga = O(null),
    ol = null;
  function Ds(e) {
    var t = e.alternate;
    (G(_t, _t.current & 1),
      G(Ga, e),
      ol === null &&
        (t === null || Rn.current !== null || t.memoizedState !== null) &&
        (ol = e));
  }
  function Fi(e) {
    (G(_t, _t.current), G(Ga, e), ol === null && (ol = e));
  }
  function Jd(e) {
    e.tag === 22
      ? (G(_t, _t.current), G(Ga, e), ol === null && (ol = e))
      : zs();
  }
  function zs() {
    (G(_t, _t.current), G(Ga, Ga.current));
  }
  function Ha(e) {
    (H(Ga), ol === e && (ol = null), H(_t));
  }
  var _t = O(0);
  function bo(e) {
    for (var t = e; t !== null;) {
      if (t.tag === 13) {
        var a = t.memoizedState;
        if (a !== null && ((a = a.dehydrated), a === null || Jc(a) || Wc(a)))
          return t;
      } else if (
        t.tag === 19 &&
        (t.memoizedProps.revealOrder === "forwards" ||
          t.memoizedProps.revealOrder === "backwards" ||
          t.memoizedProps.revealOrder === "unstable_legacy-backwards" ||
          t.memoizedProps.revealOrder === "together")
      ) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        ((t.child.return = t), (t = t.child));
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null;) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      ((t.sibling.return = t.return), (t = t.sibling));
    }
    return null;
  }
  var ss = 0,
    Ne = null,
    tt = null,
    Mt = null,
    go = !1,
    Gn = !1,
    fn = !1,
    vo = 0,
    Cr = 0,
    Hn = null,
    bf = 0;
  function yt() {
    throw Error(h(321));
  }
  function Vi(e, t) {
    if (t === null) return !1;
    for (var a = 0; a < t.length && a < e.length; a++)
      if (!ma(e[a], t[a])) return !1;
    return !0;
  }
  function $i(e, t, a, s, n, r) {
    return (
      (ss = r),
      (Ne = t),
      (t.memoizedState = null),
      (t.updateQueue = null),
      (t.lanes = 0),
      (C.H = e === null || e.memoizedState === null ? Bu : ic),
      (fn = !1),
      (r = a(s, n)),
      (fn = !1),
      Gn && (r = Pd(t, a, s, n)),
      Wd(e),
      r
    );
  }
  function Wd(e) {
    C.H = Ar;
    var t = tt !== null && tt.next !== null;
    if (((ss = 0), (Mt = tt = Ne = null), (go = !1), (Cr = 0), (Hn = null), t))
      throw Error(h(300));
    e === null ||
      Rt ||
      ((e = e.dependencies), e !== null && io(e) && (Rt = !0));
  }
  function Pd(e, t, a, s) {
    Ne = e;
    var n = 0;
    do {
      if ((Gn && (Hn = null), (Cr = 0), (Gn = !1), 25 <= n))
        throw Error(h(301));
      if (((n += 1), (Mt = tt = null), e.updateQueue != null)) {
        var r = e.updateQueue;
        ((r.lastEffect = null),
          (r.events = null),
          (r.stores = null),
          r.memoCache != null && (r.memoCache.index = 0));
      }
      ((C.H = Ou), (r = t(a, s)));
    } while (Gn);
    return r;
  }
  function gf() {
    var e = C.H,
      t = e.useState()[0];
    return (
      (t = typeof t.then == "function" ? Sr(t) : t),
      (e = e.useState()[0]),
      (tt !== null ? tt.memoizedState : null) !== e && (Ne.flags |= 1024),
      t
    );
  }
  function Qi() {
    var e = vo !== 0;
    return ((vo = 0), e);
  }
  function Ki(e, t, a) {
    ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~a));
  }
  function Zi(e) {
    if (go) {
      for (e = e.memoizedState; e !== null;) {
        var t = e.queue;
        (t !== null && (t.pending = null), (e = e.next));
      }
      go = !1;
    }
    ((ss = 0), (Mt = tt = Ne = null), (Gn = !1), (Cr = vo = 0), (Hn = null));
  }
  function ha() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null,
    };
    return (Mt === null ? (Ne.memoizedState = Mt = e) : (Mt = Mt.next = e), Mt);
  }
  function Dt() {
    if (tt === null) {
      var e = Ne.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = tt.next;
    var t = Mt === null ? Ne.memoizedState : Mt.next;
    if (t !== null) ((Mt = t), (tt = e));
    else {
      if (e === null)
        throw Ne.alternate === null ? Error(h(467)) : Error(h(310));
      ((tt = e),
        (e = {
          memoizedState: tt.memoizedState,
          baseState: tt.baseState,
          baseQueue: tt.baseQueue,
          queue: tt.queue,
          next: null,
        }),
        Mt === null ? (Ne.memoizedState = Mt = e) : (Mt = Mt.next = e));
    }
    return Mt;
  }
  function yo() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Sr(e) {
    var t = Cr;
    return (
      (Cr += 1),
      Hn === null && (Hn = []),
      (e = Id(Hn, e, t)),
      (t = Ne),
      (Mt === null ? t.memoizedState : Mt.next) === null &&
        ((t = t.alternate),
        (C.H = t === null || t.memoizedState === null ? Bu : ic)),
      e
    );
  }
  function wo(e) {
    if (e !== null && typeof e == "object") {
      if (typeof e.then == "function") return Sr(e);
      if (e.$$typeof === ue) return na(e);
    }
    throw Error(h(438, String(e)));
  }
  function Ji(e) {
    var t = null,
      a = Ne.updateQueue;
    if ((a !== null && (t = a.memoCache), t == null)) {
      var s = Ne.alternate;
      s !== null &&
        ((s = s.updateQueue),
        s !== null &&
          ((s = s.memoCache),
          s != null &&
            (t = {
              data: s.data.map(function (n) {
                return n.slice();
              }),
              index: 0,
            })));
    }
    if (
      (t == null && (t = { data: [], index: 0 }),
      a === null && ((a = yo()), (Ne.updateQueue = a)),
      (a.memoCache = t),
      (a = t.data[t.index]),
      a === void 0)
    )
      for (a = t.data[t.index] = Array(e), s = 0; s < e; s++) a[s] = oe;
    return (t.index++, a);
  }
  function ns(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function jo(e) {
    var t = Dt();
    return Wi(t, tt, e);
  }
  function Wi(e, t, a) {
    var s = e.queue;
    if (s === null) throw Error(h(311));
    s.lastRenderedReducer = a;
    var n = e.baseQueue,
      r = s.pending;
    if (r !== null) {
      if (n !== null) {
        var o = n.next;
        ((n.next = r.next), (r.next = o));
      }
      ((t.baseQueue = n = r), (s.pending = null));
    }
    if (((r = e.baseState), n === null)) e.memoizedState = r;
    else {
      t = n.next;
      var c = (o = null),
        u = null,
        w = t,
        T = !1;
      do {
        var L = w.lane & -536870913;
        if (L !== w.lane ? (Le & L) === L : (ss & L) === L) {
          var N = w.revertLane;
          if (N === 0)
            (u !== null &&
              (u = u.next =
                {
                  lane: 0,
                  revertLane: 0,
                  gesture: null,
                  action: w.action,
                  hasEagerState: w.hasEagerState,
                  eagerState: w.eagerState,
                  next: null,
                }),
              L === Bn && (T = !0));
          else if ((ss & N) === N) {
            ((w = w.next), N === Bn && (T = !0));
            continue;
          } else
            ((L = {
              lane: 0,
              revertLane: w.revertLane,
              gesture: null,
              action: w.action,
              hasEagerState: w.hasEagerState,
              eagerState: w.eagerState,
              next: null,
            }),
              u === null ? ((c = u = L), (o = r)) : (u = u.next = L),
              (Ne.lanes |= N),
              (Os |= N));
          ((L = w.action),
            fn && a(r, L),
            (r = w.hasEagerState ? w.eagerState : a(r, L)));
        } else
          ((N = {
            lane: L,
            revertLane: w.revertLane,
            gesture: w.gesture,
            action: w.action,
            hasEagerState: w.hasEagerState,
            eagerState: w.eagerState,
            next: null,
          }),
            u === null ? ((c = u = N), (o = r)) : (u = u.next = N),
            (Ne.lanes |= L),
            (Os |= L));
        w = w.next;
      } while (w !== null && w !== t);
      if (
        (u === null ? (o = r) : (u.next = c),
        !ma(r, e.memoizedState) && ((Rt = !0), T && ((a = On), a !== null)))
      )
        throw a;
      ((e.memoizedState = r),
        (e.baseState = o),
        (e.baseQueue = u),
        (s.lastRenderedState = r));
    }
    return (n === null && (s.lanes = 0), [e.memoizedState, s.dispatch]);
  }
  function Pi(e) {
    var t = Dt(),
      a = t.queue;
    if (a === null) throw Error(h(311));
    a.lastRenderedReducer = e;
    var s = a.dispatch,
      n = a.pending,
      r = t.memoizedState;
    if (n !== null) {
      a.pending = null;
      var o = (n = n.next);
      do ((r = e(r, o.action)), (o = o.next));
      while (o !== n);
      (ma(r, t.memoizedState) || (Rt = !0),
        (t.memoizedState = r),
        t.baseQueue === null && (t.baseState = r),
        (a.lastRenderedState = r));
    }
    return [r, s];
  }
  function eu(e, t, a) {
    var s = Ne,
      n = Dt(),
      r = Ue;
    if (r) {
      if (a === void 0) throw Error(h(407));
      a = a();
    } else a = t();
    var o = !ma((tt || n).memoizedState, a);
    if (
      (o && ((n.memoizedState = a), (Rt = !0)),
      (n = n.queue),
      ac(lu.bind(null, s, n, e), [e]),
      n.getSnapshot !== t || o || (Mt !== null && Mt.memoizedState.tag & 1))
    ) {
      if (
        ((s.flags |= 2048),
        Xn(9, { destroy: void 0 }, au.bind(null, s, n, a, t), null),
        rt === null)
      )
        throw Error(h(349));
      r || (ss & 127) !== 0 || tu(s, t, a);
    }
    return a;
  }
  function tu(e, t, a) {
    ((e.flags |= 16384),
      (e = { getSnapshot: t, value: a }),
      (t = Ne.updateQueue),
      t === null
        ? ((t = yo()), (Ne.updateQueue = t), (t.stores = [e]))
        : ((a = t.stores), a === null ? (t.stores = [e]) : a.push(e)));
  }
  function au(e, t, a, s) {
    ((t.value = a), (t.getSnapshot = s), su(t) && nu(e));
  }
  function lu(e, t, a) {
    return a(function () {
      su(t) && nu(e);
    });
  }
  function su(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var a = t();
      return !ma(e, a);
    } catch {
      return !0;
    }
  }
  function nu(e) {
    var t = ln(e, 2);
    t !== null && Ea(t, e, 2);
  }
  function ec(e) {
    var t = ha();
    if (typeof e == "function") {
      var a = e;
      if (((e = a()), fn)) {
        bt(!0);
        try {
          a();
        } finally {
          bt(!1);
        }
      }
    }
    return (
      (t.memoizedState = t.baseState = e),
      (t.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ns,
        lastRenderedState: e,
      }),
      t
    );
  }
  function ru(e, t, a, s) {
    return ((e.baseState = a), Wi(e, tt, typeof s == "function" ? s : ns));
  }
  function vf(e, t, a, s, n) {
    if (Co(e)) throw Error(h(485));
    if (((e = t.action), e !== null)) {
      var r = {
        payload: n,
        action: e,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function (o) {
          r.listeners.push(o);
        },
      };
      (C.T !== null ? a(!0) : (r.isTransition = !1),
        s(r),
        (a = t.pending),
        a === null
          ? ((r.next = t.pending = r), ou(t, r))
          : ((r.next = a.next), (t.pending = a.next = r)));
    }
  }
  function ou(e, t) {
    var a = t.action,
      s = t.payload,
      n = e.state;
    if (t.isTransition) {
      var r = C.T,
        o = {};
      C.T = o;
      try {
        var c = a(n, s),
          u = C.S;
        (u !== null && u(o, c), iu(e, t, c));
      } catch (w) {
        tc(e, t, w);
      } finally {
        (r !== null && o.types !== null && (r.types = o.types), (C.T = r));
      }
    } else
      try {
        ((r = a(n, s)), iu(e, t, r));
      } catch (w) {
        tc(e, t, w);
      }
  }
  function iu(e, t, a) {
    a !== null && typeof a == "object" && typeof a.then == "function"
      ? a.then(
          function (s) {
            cu(e, t, s);
          },
          function (s) {
            return tc(e, t, s);
          },
        )
      : cu(e, t, a);
  }
  function cu(e, t, a) {
    ((t.status = "fulfilled"),
      (t.value = a),
      du(t),
      (e.state = a),
      (t = e.pending),
      t !== null &&
        ((a = t.next),
        a === t ? (e.pending = null) : ((a = a.next), (t.next = a), ou(e, a))));
  }
  function tc(e, t, a) {
    var s = e.pending;
    if (((e.pending = null), s !== null)) {
      s = s.next;
      do ((t.status = "rejected"), (t.reason = a), du(t), (t = t.next));
      while (t !== s);
    }
    e.action = null;
  }
  function du(e) {
    e = e.listeners;
    for (var t = 0; t < e.length; t++) (0, e[t])();
  }
  function uu(e, t) {
    return t;
  }
  function xu(e, t) {
    if (Ue) {
      var a = rt.formState;
      if (a !== null) {
        e: {
          var s = Ne;
          if (Ue) {
            if (dt) {
              t: {
                for (var n = dt, r = rl; n.nodeType !== 8;) {
                  if (!r) {
                    n = null;
                    break t;
                  }
                  if (((n = il(n.nextSibling)), n === null)) {
                    n = null;
                    break t;
                  }
                }
                ((r = n.data), (n = r === "F!" || r === "F" ? n : null));
              }
              if (n) {
                ((dt = il(n.nextSibling)), (s = n.data === "F!"));
                break e;
              }
            }
            Ss(s);
          }
          s = !1;
        }
        s && (t = a[0]);
      }
    }
    return (
      (a = ha()),
      (a.memoizedState = a.baseState = t),
      (s = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: uu,
        lastRenderedState: t,
      }),
      (a.queue = s),
      (a = Du.bind(null, Ne, s)),
      (s.dispatch = a),
      (s = ec(!1)),
      (r = oc.bind(null, Ne, !1, s.queue)),
      (s = ha()),
      (n = { state: t, dispatch: null, action: e, pending: null }),
      (s.queue = n),
      (a = vf.bind(null, Ne, n, r, a)),
      (n.dispatch = a),
      (s.memoizedState = e),
      [t, a, !1]
    );
  }
  function fu(e) {
    var t = Dt();
    return pu(t, tt, e);
  }
  function pu(e, t, a) {
    if (
      ((t = Wi(e, t, uu)[0]),
      (e = jo(ns)[0]),
      typeof t == "object" && t !== null && typeof t.then == "function")
    )
      try {
        var s = Sr(t);
      } catch (o) {
        throw o === Un ? xo : o;
      }
    else s = t;
    t = Dt();
    var n = t.queue,
      r = n.dispatch;
    return (
      a !== t.memoizedState &&
        ((Ne.flags |= 2048),
        Xn(9, { destroy: void 0 }, yf.bind(null, n, a), null)),
      [s, r, e]
    );
  }
  function yf(e, t) {
    e.action = t;
  }
  function mu(e) {
    var t = Dt(),
      a = tt;
    if (a !== null) return pu(t, a, e);
    (Dt(), (t = t.memoizedState), (a = Dt()));
    var s = a.queue.dispatch;
    return ((a.memoizedState = e), [t, s, !1]);
  }
  function Xn(e, t, a, s) {
    return (
      (e = { tag: e, create: a, deps: s, inst: t, next: null }),
      (t = Ne.updateQueue),
      t === null && ((t = yo()), (Ne.updateQueue = t)),
      (a = t.lastEffect),
      a === null
        ? (t.lastEffect = e.next = e)
        : ((s = a.next), (a.next = e), (e.next = s), (t.lastEffect = e)),
      e
    );
  }
  function hu() {
    return Dt().memoizedState;
  }
  function No(e, t, a, s) {
    var n = ha();
    ((Ne.flags |= e),
      (n.memoizedState = Xn(
        1 | t,
        { destroy: void 0 },
        a,
        s === void 0 ? null : s,
      )));
  }
  function ko(e, t, a, s) {
    var n = Dt();
    s = s === void 0 ? null : s;
    var r = n.memoizedState.inst;
    tt !== null && s !== null && Vi(s, tt.memoizedState.deps)
      ? (n.memoizedState = Xn(t, r, a, s))
      : ((Ne.flags |= e), (n.memoizedState = Xn(1 | t, r, a, s)));
  }
  function bu(e, t) {
    No(8390656, 8, e, t);
  }
  function ac(e, t) {
    ko(2048, 8, e, t);
  }
  function wf(e) {
    Ne.flags |= 4;
    var t = Ne.updateQueue;
    if (t === null) ((t = yo()), (Ne.updateQueue = t), (t.events = [e]));
    else {
      var a = t.events;
      a === null ? (t.events = [e]) : a.push(e);
    }
  }
  function gu(e) {
    var t = Dt().memoizedState;
    return (
      wf({ ref: t, nextImpl: e }),
      function () {
        if ((Fe & 2) !== 0) throw Error(h(440));
        return t.impl.apply(void 0, arguments);
      }
    );
  }
  function vu(e, t) {
    return ko(4, 2, e, t);
  }
  function yu(e, t) {
    return ko(4, 4, e, t);
  }
  function wu(e, t) {
    if (typeof t == "function") {
      e = e();
      var a = t(e);
      return function () {
        typeof a == "function" ? a() : t(null);
      };
    }
    if (t != null)
      return (
        (e = e()),
        (t.current = e),
        function () {
          t.current = null;
        }
      );
  }
  function ju(e, t, a) {
    ((a = a != null ? a.concat([e]) : null), ko(4, 4, wu.bind(null, t, e), a));
  }
  function lc() {}
  function Nu(e, t) {
    var a = Dt();
    t = t === void 0 ? null : t;
    var s = a.memoizedState;
    return t !== null && Vi(t, s[1]) ? s[0] : ((a.memoizedState = [e, t]), e);
  }
  function ku(e, t) {
    var a = Dt();
    t = t === void 0 ? null : t;
    var s = a.memoizedState;
    if (t !== null && Vi(t, s[1])) return s[0];
    if (((s = e()), fn)) {
      bt(!0);
      try {
        e();
      } finally {
        bt(!1);
      }
    }
    return ((a.memoizedState = [s, t]), s);
  }
  function sc(e, t, a) {
    return a === void 0 || ((ss & 1073741824) !== 0 && (Le & 261930) === 0)
      ? (e.memoizedState = t)
      : ((e.memoizedState = a), (e = C0()), (Ne.lanes |= e), (Os |= e), a);
  }
  function Cu(e, t, a, s) {
    return ma(a, t)
      ? a
      : Rn.current !== null
        ? ((e = sc(e, a, s)), ma(e, t) || (Rt = !0), e)
        : (ss & 42) === 0 || ((ss & 1073741824) !== 0 && (Le & 261930) === 0)
          ? ((Rt = !0), (e.memoizedState = a))
          : ((e = C0()), (Ne.lanes |= e), (Os |= e), t);
  }
  function Su(e, t, a, s, n) {
    var r = D.p;
    D.p = r !== 0 && 8 > r ? r : 8;
    var o = C.T,
      c = {};
    ((C.T = c), oc(e, !1, t, a));
    try {
      var u = n(),
        w = C.S;
      if (
        (w !== null && w(c, u),
        u !== null && typeof u == "object" && typeof u.then == "function")
      ) {
        var T = hf(u, s);
        Er(e, t, T, Ia(e));
      } else Er(e, t, s, Ia(e));
    } catch (L) {
      Er(e, t, { then: function () {}, status: "rejected", reason: L }, Ia());
    } finally {
      ((D.p = r),
        o !== null && c.types !== null && (o.types = c.types),
        (C.T = o));
    }
  }
  function jf() {}
  function nc(e, t, a, s) {
    if (e.tag !== 5) throw Error(h(476));
    var n = Eu(e).queue;
    Su(
      e,
      n,
      t,
      U,
      a === null
        ? jf
        : function () {
            return (Au(e), a(s));
          },
    );
  }
  function Eu(e) {
    var t = e.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: U,
      baseState: U,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ns,
        lastRenderedState: U,
      },
      next: null,
    };
    var a = {};
    return (
      (t.next = {
        memoizedState: a,
        baseState: a,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: ns,
          lastRenderedState: a,
        },
        next: null,
      }),
      (e.memoizedState = t),
      (e = e.alternate),
      e !== null && (e.memoizedState = t),
      t
    );
  }
  function Au(e) {
    var t = Eu(e);
    (t.next === null && (t = e.alternate.memoizedState),
      Er(e, t.next.queue, {}, Ia()));
  }
  function rc() {
    return na(qr);
  }
  function Tu() {
    return Dt().memoizedState;
  }
  function _u() {
    return Dt().memoizedState;
  }
  function Nf(e) {
    for (var t = e.return; t !== null;) {
      switch (t.tag) {
        case 24:
        case 3:
          var a = Ia();
          e = Ts(a);
          var s = _s(t, e, a);
          (s !== null && (Ea(s, t, a), jr(s, t, a)),
            (t = { cache: Oi() }),
            (e.payload = t));
          return;
      }
      t = t.return;
    }
  }
  function kf(e, t, a) {
    var s = Ia();
    ((a = {
      lane: s,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    }),
      Co(e)
        ? zu(t, a)
        : ((a = ki(e, t, a, s)), a !== null && (Ea(a, e, s), Lu(a, t, s))));
  }
  function Du(e, t, a) {
    var s = Ia();
    Er(e, t, a, s);
  }
  function Er(e, t, a, s) {
    var n = {
      lane: s,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    };
    if (Co(e)) zu(t, n);
    else {
      var r = e.alternate;
      if (
        e.lanes === 0 &&
        (r === null || r.lanes === 0) &&
        ((r = t.lastRenderedReducer), r !== null)
      )
        try {
          var o = t.lastRenderedState,
            c = r(o, a);
          if (((n.hasEagerState = !0), (n.eagerState = c), ma(c, o)))
            return (so(e, t, n, 0), rt === null && lo(), !1);
        } catch {
        } finally {
        }
      if (((a = ki(e, t, n, s)), a !== null))
        return (Ea(a, e, s), Lu(a, t, s), !0);
    }
    return !1;
  }
  function oc(e, t, a, s) {
    if (
      ((s = {
        lane: 2,
        revertLane: Gc(),
        gesture: null,
        action: s,
        hasEagerState: !1,
        eagerState: null,
        next: null,
      }),
      Co(e))
    ) {
      if (t) throw Error(h(479));
    } else ((t = ki(e, a, s, 2)), t !== null && Ea(t, e, 2));
  }
  function Co(e) {
    var t = e.alternate;
    return e === Ne || (t !== null && t === Ne);
  }
  function zu(e, t) {
    Gn = go = !0;
    var a = e.pending;
    (a === null ? (t.next = t) : ((t.next = a.next), (a.next = t)),
      (e.pending = t));
  }
  function Lu(e, t, a) {
    if ((a & 4194048) !== 0) {
      var s = t.lanes;
      ((s &= e.pendingLanes), (a |= s), (t.lanes = a), ml(e, a));
    }
  }
  var Ar = {
    readContext: na,
    use: wo,
    useCallback: yt,
    useContext: yt,
    useEffect: yt,
    useImperativeHandle: yt,
    useLayoutEffect: yt,
    useInsertionEffect: yt,
    useMemo: yt,
    useReducer: yt,
    useRef: yt,
    useState: yt,
    useDebugValue: yt,
    useDeferredValue: yt,
    useTransition: yt,
    useSyncExternalStore: yt,
    useId: yt,
    useHostTransitionStatus: yt,
    useFormState: yt,
    useActionState: yt,
    useOptimistic: yt,
    useMemoCache: yt,
    useCacheRefresh: yt,
  };
  Ar.useEffectEvent = yt;
  var Bu = {
      readContext: na,
      use: wo,
      useCallback: function (e, t) {
        return ((ha().memoizedState = [e, t === void 0 ? null : t]), e);
      },
      useContext: na,
      useEffect: bu,
      useImperativeHandle: function (e, t, a) {
        ((a = a != null ? a.concat([e]) : null),
          No(4194308, 4, wu.bind(null, t, e), a));
      },
      useLayoutEffect: function (e, t) {
        return No(4194308, 4, e, t);
      },
      useInsertionEffect: function (e, t) {
        No(4, 2, e, t);
      },
      useMemo: function (e, t) {
        var a = ha();
        t = t === void 0 ? null : t;
        var s = e();
        if (fn) {
          bt(!0);
          try {
            e();
          } finally {
            bt(!1);
          }
        }
        return ((a.memoizedState = [s, t]), s);
      },
      useReducer: function (e, t, a) {
        var s = ha();
        if (a !== void 0) {
          var n = a(t);
          if (fn) {
            bt(!0);
            try {
              a(t);
            } finally {
              bt(!1);
            }
          }
        } else n = t;
        return (
          (s.memoizedState = s.baseState = n),
          (e = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: e,
            lastRenderedState: n,
          }),
          (s.queue = e),
          (e = e.dispatch = kf.bind(null, Ne, e)),
          [s.memoizedState, e]
        );
      },
      useRef: function (e) {
        var t = ha();
        return ((e = { current: e }), (t.memoizedState = e));
      },
      useState: function (e) {
        e = ec(e);
        var t = e.queue,
          a = Du.bind(null, Ne, t);
        return ((t.dispatch = a), [e.memoizedState, a]);
      },
      useDebugValue: lc,
      useDeferredValue: function (e, t) {
        var a = ha();
        return sc(a, e, t);
      },
      useTransition: function () {
        var e = ec(!1);
        return (
          (e = Su.bind(null, Ne, e.queue, !0, !1)),
          (ha().memoizedState = e),
          [!1, e]
        );
      },
      useSyncExternalStore: function (e, t, a) {
        var s = Ne,
          n = ha();
        if (Ue) {
          if (a === void 0) throw Error(h(407));
          a = a();
        } else {
          if (((a = t()), rt === null)) throw Error(h(349));
          (Le & 127) !== 0 || tu(s, t, a);
        }
        n.memoizedState = a;
        var r = { value: a, getSnapshot: t };
        return (
          (n.queue = r),
          bu(lu.bind(null, s, r, e), [e]),
          (s.flags |= 2048),
          Xn(9, { destroy: void 0 }, au.bind(null, s, r, a, t), null),
          a
        );
      },
      useId: function () {
        var e = ha(),
          t = rt.identifierPrefix;
        if (Ue) {
          var a = Hl,
            s = Gl;
          ((a = (s & ~(1 << (32 - zt(s) - 1))).toString(32) + a),
            (t = "_" + t + "R_" + a),
            (a = vo++),
            0 < a && (t += "H" + a.toString(32)),
            (t += "_"));
        } else ((a = bf++), (t = "_" + t + "r_" + a.toString(32) + "_"));
        return (e.memoizedState = t);
      },
      useHostTransitionStatus: rc,
      useFormState: xu,
      useActionState: xu,
      useOptimistic: function (e) {
        var t = ha();
        t.memoizedState = t.baseState = e;
        var a = {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: null,
          lastRenderedState: null,
        };
        return (
          (t.queue = a),
          (t = oc.bind(null, Ne, !0, a)),
          (a.dispatch = t),
          [e, t]
        );
      },
      useMemoCache: Ji,
      useCacheRefresh: function () {
        return (ha().memoizedState = Nf.bind(null, Ne));
      },
      useEffectEvent: function (e) {
        var t = ha(),
          a = { impl: e };
        return (
          (t.memoizedState = a),
          function () {
            if ((Fe & 2) !== 0) throw Error(h(440));
            return a.impl.apply(void 0, arguments);
          }
        );
      },
    },
    ic = {
      readContext: na,
      use: wo,
      useCallback: Nu,
      useContext: na,
      useEffect: ac,
      useImperativeHandle: ju,
      useInsertionEffect: vu,
      useLayoutEffect: yu,
      useMemo: ku,
      useReducer: jo,
      useRef: hu,
      useState: function () {
        return jo(ns);
      },
      useDebugValue: lc,
      useDeferredValue: function (e, t) {
        var a = Dt();
        return Cu(a, tt.memoizedState, e, t);
      },
      useTransition: function () {
        var e = jo(ns)[0],
          t = Dt().memoizedState;
        return [typeof e == "boolean" ? e : Sr(e), t];
      },
      useSyncExternalStore: eu,
      useId: Tu,
      useHostTransitionStatus: rc,
      useFormState: fu,
      useActionState: fu,
      useOptimistic: function (e, t) {
        var a = Dt();
        return ru(a, tt, e, t);
      },
      useMemoCache: Ji,
      useCacheRefresh: _u,
    };
  ic.useEffectEvent = gu;
  var Ou = {
    readContext: na,
    use: wo,
    useCallback: Nu,
    useContext: na,
    useEffect: ac,
    useImperativeHandle: ju,
    useInsertionEffect: vu,
    useLayoutEffect: yu,
    useMemo: ku,
    useReducer: Pi,
    useRef: hu,
    useState: function () {
      return Pi(ns);
    },
    useDebugValue: lc,
    useDeferredValue: function (e, t) {
      var a = Dt();
      return tt === null ? sc(a, e, t) : Cu(a, tt.memoizedState, e, t);
    },
    useTransition: function () {
      var e = Pi(ns)[0],
        t = Dt().memoizedState;
      return [typeof e == "boolean" ? e : Sr(e), t];
    },
    useSyncExternalStore: eu,
    useId: Tu,
    useHostTransitionStatus: rc,
    useFormState: mu,
    useActionState: mu,
    useOptimistic: function (e, t) {
      var a = Dt();
      return tt !== null
        ? ru(a, tt, e, t)
        : ((a.baseState = e), [e, a.queue.dispatch]);
    },
    useMemoCache: Ji,
    useCacheRefresh: _u,
  };
  Ou.useEffectEvent = gu;
  function cc(e, t, a, s) {
    ((t = e.memoizedState),
      (a = a(s, t)),
      (a = a == null ? t : R({}, t, a)),
      (e.memoizedState = a),
      e.lanes === 0 && (e.updateQueue.baseState = a));
  }
  var dc = {
    enqueueSetState: function (e, t, a) {
      e = e._reactInternals;
      var s = Ia(),
        n = Ts(s);
      ((n.payload = t),
        a != null && (n.callback = a),
        (t = _s(e, n, s)),
        t !== null && (Ea(t, e, s), jr(t, e, s)));
    },
    enqueueReplaceState: function (e, t, a) {
      e = e._reactInternals;
      var s = Ia(),
        n = Ts(s);
      ((n.tag = 1),
        (n.payload = t),
        a != null && (n.callback = a),
        (t = _s(e, n, s)),
        t !== null && (Ea(t, e, s), jr(t, e, s)));
    },
    enqueueForceUpdate: function (e, t) {
      e = e._reactInternals;
      var a = Ia(),
        s = Ts(a);
      ((s.tag = 2),
        t != null && (s.callback = t),
        (t = _s(e, s, a)),
        t !== null && (Ea(t, e, a), jr(t, e, a)));
    },
  };
  function Uu(e, t, a, s, n, r, o) {
    return (
      (e = e.stateNode),
      typeof e.shouldComponentUpdate == "function"
        ? e.shouldComponentUpdate(s, r, o)
        : t.prototype && t.prototype.isPureReactComponent
          ? !pr(a, s) || !pr(n, r)
          : !0
    );
  }
  function Mu(e, t, a, s) {
    ((e = t.state),
      typeof t.componentWillReceiveProps == "function" &&
        t.componentWillReceiveProps(a, s),
      typeof t.UNSAFE_componentWillReceiveProps == "function" &&
        t.UNSAFE_componentWillReceiveProps(a, s),
      t.state !== e && dc.enqueueReplaceState(t, t.state, null));
  }
  function pn(e, t) {
    var a = t;
    if ("ref" in t) {
      a = {};
      for (var s in t) s !== "ref" && (a[s] = t[s]);
    }
    if ((e = e.defaultProps)) {
      a === t && (a = R({}, a));
      for (var n in e) a[n] === void 0 && (a[n] = e[n]);
    }
    return a;
  }
  function Ru(e) {
    ao(e);
  }
  function Gu(e) {
    console.error(e);
  }
  function Hu(e) {
    ao(e);
  }
  function So(e, t) {
    try {
      var a = e.onUncaughtError;
      a(t.value, { componentStack: t.stack });
    } catch (s) {
      setTimeout(function () {
        throw s;
      });
    }
  }
  function Xu(e, t, a) {
    try {
      var s = e.onCaughtError;
      s(a.value, {
        componentStack: a.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null,
      });
    } catch (n) {
      setTimeout(function () {
        throw n;
      });
    }
  }
  function uc(e, t, a) {
    return (
      (a = Ts(a)),
      (a.tag = 3),
      (a.payload = { element: null }),
      (a.callback = function () {
        So(e, t);
      }),
      a
    );
  }
  function Yu(e) {
    return ((e = Ts(e)), (e.tag = 3), e);
  }
  function Iu(e, t, a, s) {
    var n = a.type.getDerivedStateFromError;
    if (typeof n == "function") {
      var r = s.value;
      ((e.payload = function () {
        return n(r);
      }),
        (e.callback = function () {
          Xu(t, a, s);
        }));
    }
    var o = a.stateNode;
    o !== null &&
      typeof o.componentDidCatch == "function" &&
      (e.callback = function () {
        (Xu(t, a, s),
          typeof n != "function" &&
            (Us === null ? (Us = new Set([this])) : Us.add(this)));
        var c = s.stack;
        this.componentDidCatch(s.value, {
          componentStack: c !== null ? c : "",
        });
      });
  }
  function Cf(e, t, a, s, n) {
    if (
      ((a.flags |= 32768),
      s !== null && typeof s == "object" && typeof s.then == "function")
    ) {
      if (
        ((t = a.alternate),
        t !== null && Ln(t, a, n, !0),
        (a = Ga.current),
        a !== null)
      ) {
        switch (a.tag) {
          case 31:
          case 13:
            return (
              ol === null ? Ro() : a.alternate === null && wt === 0 && (wt = 3),
              (a.flags &= -257),
              (a.flags |= 65536),
              (a.lanes = n),
              s === fo
                ? (a.flags |= 16384)
                : ((t = a.updateQueue),
                  t === null ? (a.updateQueue = new Set([s])) : t.add(s),
                  Uc(e, s, n)),
              !1
            );
          case 22:
            return (
              (a.flags |= 65536),
              s === fo
                ? (a.flags |= 16384)
                : ((t = a.updateQueue),
                  t === null
                    ? ((t = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([s]),
                      }),
                      (a.updateQueue = t))
                    : ((a = t.retryQueue),
                      a === null ? (t.retryQueue = new Set([s])) : a.add(s)),
                  Uc(e, s, n)),
              !1
            );
        }
        throw Error(h(435, a.tag));
      }
      return (Uc(e, s, n), Ro(), !1);
    }
    if (Ue)
      return (
        (t = Ga.current),
        t !== null
          ? ((t.flags & 65536) === 0 && (t.flags |= 256),
            (t.flags |= 65536),
            (t.lanes = n),
            s !== _i && ((e = Error(h(422), { cause: s })), br(ll(e, a))))
          : (s !== _i && ((t = Error(h(423), { cause: s })), br(ll(t, a))),
            (e = e.current.alternate),
            (e.flags |= 65536),
            (n &= -n),
            (e.lanes |= n),
            (s = ll(s, a)),
            (n = uc(e.stateNode, s, n)),
            Xi(e, n),
            wt !== 4 && (wt = 2)),
        !1
      );
    var r = Error(h(520), { cause: s });
    if (
      ((r = ll(r, a)),
      Ur === null ? (Ur = [r]) : Ur.push(r),
      wt !== 4 && (wt = 2),
      t === null)
    )
      return !0;
    ((s = ll(s, a)), (a = t));
    do {
      switch (a.tag) {
        case 3:
          return (
            (a.flags |= 65536),
            (e = n & -n),
            (a.lanes |= e),
            (e = uc(a.stateNode, s, e)),
            Xi(a, e),
            !1
          );
        case 1:
          if (
            ((t = a.type),
            (r = a.stateNode),
            (a.flags & 128) === 0 &&
              (typeof t.getDerivedStateFromError == "function" ||
                (r !== null &&
                  typeof r.componentDidCatch == "function" &&
                  (Us === null || !Us.has(r)))))
          )
            return (
              (a.flags |= 65536),
              (n &= -n),
              (a.lanes |= n),
              (n = Yu(n)),
              Iu(n, e, a, s),
              Xi(a, n),
              !1
            );
      }
      a = a.return;
    } while (a !== null);
    return !1;
  }
  var xc = Error(h(461)),
    Rt = !1;
  function ra(e, t, a, s) {
    t.child = e === null ? $d(t, null, a, s) : xn(t, e.child, a, s);
  }
  function qu(e, t, a, s, n) {
    a = a.render;
    var r = t.ref;
    if ("ref" in s) {
      var o = {};
      for (var c in s) c !== "ref" && (o[c] = s[c]);
    } else o = s;
    return (
      on(t),
      (s = $i(e, t, a, o, r, n)),
      (c = Qi()),
      e !== null && !Rt
        ? (Ki(e, t, n), rs(e, t, n))
        : (Ue && c && Ai(t), (t.flags |= 1), ra(e, t, s, n), t.child)
    );
  }
  function Fu(e, t, a, s, n) {
    if (e === null) {
      var r = a.type;
      return typeof r == "function" &&
        !Ci(r) &&
        r.defaultProps === void 0 &&
        a.compare === null
        ? ((t.tag = 15), (t.type = r), Vu(e, t, r, s, n))
        : ((e = ro(a.type, null, s, t, t.mode, n)),
          (e.ref = t.ref),
          (e.return = t),
          (t.child = e));
    }
    if (((r = e.child), !yc(e, n))) {
      var o = r.memoizedProps;
      if (
        ((a = a.compare), (a = a !== null ? a : pr), a(o, s) && e.ref === t.ref)
      )
        return rs(e, t, n);
    }
    return (
      (t.flags |= 1),
      (e = es(r, s)),
      (e.ref = t.ref),
      (e.return = t),
      (t.child = e)
    );
  }
  function Vu(e, t, a, s, n) {
    if (e !== null) {
      var r = e.memoizedProps;
      if (pr(r, s) && e.ref === t.ref)
        if (((Rt = !1), (t.pendingProps = s = r), yc(e, n)))
          (e.flags & 131072) !== 0 && (Rt = !0);
        else return ((t.lanes = e.lanes), rs(e, t, n));
    }
    return fc(e, t, a, s, n);
  }
  function $u(e, t, a, s) {
    var n = s.children,
      r = e !== null ? e.memoizedState : null;
    if (
      (e === null &&
        t.stateNode === null &&
        (t.stateNode = {
          _visibility: 1,
          _pendingMarkers: null,
          _retryCache: null,
          _transitions: null,
        }),
      s.mode === "hidden")
    ) {
      if ((t.flags & 128) !== 0) {
        if (((r = r !== null ? r.baseLanes | a : a), e !== null)) {
          for (s = t.child = e.child, n = 0; s !== null;)
            ((n = n | s.lanes | s.childLanes), (s = s.sibling));
          s = n & ~r;
        } else ((s = 0), (t.child = null));
        return Qu(e, t, r, a, s);
      }
      if ((a & 536870912) !== 0)
        ((t.memoizedState = { baseLanes: 0, cachePool: null }),
          e !== null && uo(t, r !== null ? r.cachePool : null),
          r !== null ? Zd(t, r) : Ii(),
          Jd(t));
      else
        return (
          (s = t.lanes = 536870912),
          Qu(e, t, r !== null ? r.baseLanes | a : a, a, s)
        );
    } else
      r !== null
        ? (uo(t, r.cachePool), Zd(t, r), zs(), (t.memoizedState = null))
        : (e !== null && uo(t, null), Ii(), zs());
    return (ra(e, t, n, a), t.child);
  }
  function Tr(e, t) {
    return (
      (e !== null && e.tag === 22) ||
        t.stateNode !== null ||
        (t.stateNode = {
          _visibility: 1,
          _pendingMarkers: null,
          _retryCache: null,
          _transitions: null,
        }),
      t.sibling
    );
  }
  function Qu(e, t, a, s, n) {
    var r = Mi();
    return (
      (r = r === null ? null : { parent: Ut._currentValue, pool: r }),
      (t.memoizedState = { baseLanes: a, cachePool: r }),
      e !== null && uo(t, null),
      Ii(),
      Jd(t),
      e !== null && Ln(e, t, s, !0),
      (t.childLanes = n),
      null
    );
  }
  function Eo(e, t) {
    return (
      (t = To({ mode: t.mode, children: t.children }, e.mode)),
      (t.ref = e.ref),
      (e.child = t),
      (t.return = e),
      t
    );
  }
  function Ku(e, t, a) {
    return (
      xn(t, e.child, null, a),
      (e = Eo(t, t.pendingProps)),
      (e.flags |= 2),
      Ha(t),
      (t.memoizedState = null),
      e
    );
  }
  function Sf(e, t, a) {
    var s = t.pendingProps,
      n = (t.flags & 128) !== 0;
    if (((t.flags &= -129), e === null)) {
      if (Ue) {
        if (s.mode === "hidden")
          return ((e = Eo(t, s)), (t.lanes = 536870912), Tr(null, e));
        if (
          (Fi(t),
          (e = dt)
            ? ((e = ox(e, rl)),
              (e = e !== null && e.data === "&" ? e : null),
              e !== null &&
                ((t.memoizedState = {
                  dehydrated: e,
                  treeContext: ks !== null ? { id: Gl, overflow: Hl } : null,
                  retryLane: 536870912,
                  hydrationErrors: null,
                }),
                (a = zd(e)),
                (a.return = t),
                (t.child = a),
                (sa = t),
                (dt = null)))
            : (e = null),
          e === null)
        )
          throw Ss(t);
        return ((t.lanes = 536870912), null);
      }
      return Eo(t, s);
    }
    var r = e.memoizedState;
    if (r !== null) {
      var o = r.dehydrated;
      if ((Fi(t), n))
        if (t.flags & 256) ((t.flags &= -257), (t = Ku(e, t, a)));
        else if (t.memoizedState !== null)
          ((t.child = e.child), (t.flags |= 128), (t = null));
        else throw Error(h(558));
      else if (
        (Rt || Ln(e, t, a, !1), (n = (a & e.childLanes) !== 0), Rt || n)
      ) {
        if (
          ((s = rt),
          s !== null && ((o = hl(s, a)), o !== 0 && o !== r.retryLane))
        )
          throw ((r.retryLane = o), ln(e, o), Ea(s, e, o), xc);
        (Ro(), (t = Ku(e, t, a)));
      } else
        ((e = r.treeContext),
          (dt = il(o.nextSibling)),
          (sa = t),
          (Ue = !0),
          (Cs = null),
          (rl = !1),
          e !== null && Od(t, e),
          (t = Eo(t, s)),
          (t.flags |= 4096));
      return t;
    }
    return (
      (e = es(e.child, { mode: s.mode, children: s.children })),
      (e.ref = t.ref),
      (t.child = e),
      (e.return = t),
      e
    );
  }
  function Ao(e, t) {
    var a = t.ref;
    if (a === null) e !== null && e.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof a != "function" && typeof a != "object") throw Error(h(284));
      (e === null || e.ref !== a) && (t.flags |= 4194816);
    }
  }
  function fc(e, t, a, s, n) {
    return (
      on(t),
      (a = $i(e, t, a, s, void 0, n)),
      (s = Qi()),
      e !== null && !Rt
        ? (Ki(e, t, n), rs(e, t, n))
        : (Ue && s && Ai(t), (t.flags |= 1), ra(e, t, a, n), t.child)
    );
  }
  function Zu(e, t, a, s, n, r) {
    return (
      on(t),
      (t.updateQueue = null),
      (a = Pd(t, s, a, n)),
      Wd(e),
      (s = Qi()),
      e !== null && !Rt
        ? (Ki(e, t, r), rs(e, t, r))
        : (Ue && s && Ai(t), (t.flags |= 1), ra(e, t, a, r), t.child)
    );
  }
  function Ju(e, t, a, s, n) {
    if ((on(t), t.stateNode === null)) {
      var r = Tn,
        o = a.contextType;
      (typeof o == "object" && o !== null && (r = na(o)),
        (r = new a(s, r)),
        (t.memoizedState =
          r.state !== null && r.state !== void 0 ? r.state : null),
        (r.updater = dc),
        (t.stateNode = r),
        (r._reactInternals = t),
        (r = t.stateNode),
        (r.props = s),
        (r.state = t.memoizedState),
        (r.refs = {}),
        Gi(t),
        (o = a.contextType),
        (r.context = typeof o == "object" && o !== null ? na(o) : Tn),
        (r.state = t.memoizedState),
        (o = a.getDerivedStateFromProps),
        typeof o == "function" && (cc(t, a, o, s), (r.state = t.memoizedState)),
        typeof a.getDerivedStateFromProps == "function" ||
          typeof r.getSnapshotBeforeUpdate == "function" ||
          (typeof r.UNSAFE_componentWillMount != "function" &&
            typeof r.componentWillMount != "function") ||
          ((o = r.state),
          typeof r.componentWillMount == "function" && r.componentWillMount(),
          typeof r.UNSAFE_componentWillMount == "function" &&
            r.UNSAFE_componentWillMount(),
          o !== r.state && dc.enqueueReplaceState(r, r.state, null),
          kr(t, s, r, n),
          Nr(),
          (r.state = t.memoizedState)),
        typeof r.componentDidMount == "function" && (t.flags |= 4194308),
        (s = !0));
    } else if (e === null) {
      r = t.stateNode;
      var c = t.memoizedProps,
        u = pn(a, c);
      r.props = u;
      var w = r.context,
        T = a.contextType;
      ((o = Tn), typeof T == "object" && T !== null && (o = na(T)));
      var L = a.getDerivedStateFromProps;
      ((T =
        typeof L == "function" ||
        typeof r.getSnapshotBeforeUpdate == "function"),
        (c = t.pendingProps !== c),
        T ||
          (typeof r.UNSAFE_componentWillReceiveProps != "function" &&
            typeof r.componentWillReceiveProps != "function") ||
          ((c || w !== o) && Mu(t, r, s, o)),
        (As = !1));
      var N = t.memoizedState;
      ((r.state = N),
        kr(t, s, r, n),
        Nr(),
        (w = t.memoizedState),
        c || N !== w || As
          ? (typeof L == "function" && (cc(t, a, L, s), (w = t.memoizedState)),
            (u = As || Uu(t, a, u, s, N, w, o))
              ? (T ||
                  (typeof r.UNSAFE_componentWillMount != "function" &&
                    typeof r.componentWillMount != "function") ||
                  (typeof r.componentWillMount == "function" &&
                    r.componentWillMount(),
                  typeof r.UNSAFE_componentWillMount == "function" &&
                    r.UNSAFE_componentWillMount()),
                typeof r.componentDidMount == "function" &&
                  (t.flags |= 4194308))
              : (typeof r.componentDidMount == "function" &&
                  (t.flags |= 4194308),
                (t.memoizedProps = s),
                (t.memoizedState = w)),
            (r.props = s),
            (r.state = w),
            (r.context = o),
            (s = u))
          : (typeof r.componentDidMount == "function" && (t.flags |= 4194308),
            (s = !1)));
    } else {
      ((r = t.stateNode),
        Hi(e, t),
        (o = t.memoizedProps),
        (T = pn(a, o)),
        (r.props = T),
        (L = t.pendingProps),
        (N = r.context),
        (w = a.contextType),
        (u = Tn),
        typeof w == "object" && w !== null && (u = na(w)),
        (c = a.getDerivedStateFromProps),
        (w =
          typeof c == "function" ||
          typeof r.getSnapshotBeforeUpdate == "function") ||
          (typeof r.UNSAFE_componentWillReceiveProps != "function" &&
            typeof r.componentWillReceiveProps != "function") ||
          ((o !== L || N !== u) && Mu(t, r, s, u)),
        (As = !1),
        (N = t.memoizedState),
        (r.state = N),
        kr(t, s, r, n),
        Nr());
      var k = t.memoizedState;
      o !== L ||
      N !== k ||
      As ||
      (e !== null && e.dependencies !== null && io(e.dependencies))
        ? (typeof c == "function" && (cc(t, a, c, s), (k = t.memoizedState)),
          (T =
            As ||
            Uu(t, a, T, s, N, k, u) ||
            (e !== null && e.dependencies !== null && io(e.dependencies)))
            ? (w ||
                (typeof r.UNSAFE_componentWillUpdate != "function" &&
                  typeof r.componentWillUpdate != "function") ||
                (typeof r.componentWillUpdate == "function" &&
                  r.componentWillUpdate(s, k, u),
                typeof r.UNSAFE_componentWillUpdate == "function" &&
                  r.UNSAFE_componentWillUpdate(s, k, u)),
              typeof r.componentDidUpdate == "function" && (t.flags |= 4),
              typeof r.getSnapshotBeforeUpdate == "function" &&
                (t.flags |= 1024))
            : (typeof r.componentDidUpdate != "function" ||
                (o === e.memoizedProps && N === e.memoizedState) ||
                (t.flags |= 4),
              typeof r.getSnapshotBeforeUpdate != "function" ||
                (o === e.memoizedProps && N === e.memoizedState) ||
                (t.flags |= 1024),
              (t.memoizedProps = s),
              (t.memoizedState = k)),
          (r.props = s),
          (r.state = k),
          (r.context = u),
          (s = T))
        : (typeof r.componentDidUpdate != "function" ||
            (o === e.memoizedProps && N === e.memoizedState) ||
            (t.flags |= 4),
          typeof r.getSnapshotBeforeUpdate != "function" ||
            (o === e.memoizedProps && N === e.memoizedState) ||
            (t.flags |= 1024),
          (s = !1));
    }
    return (
      (r = s),
      Ao(e, t),
      (s = (t.flags & 128) !== 0),
      r || s
        ? ((r = t.stateNode),
          (a =
            s && typeof a.getDerivedStateFromError != "function"
              ? null
              : r.render()),
          (t.flags |= 1),
          e !== null && s
            ? ((t.child = xn(t, e.child, null, n)),
              (t.child = xn(t, null, a, n)))
            : ra(e, t, a, n),
          (t.memoizedState = r.state),
          (e = t.child))
        : (e = rs(e, t, n)),
      e
    );
  }
  function Wu(e, t, a, s) {
    return (nn(), (t.flags |= 256), ra(e, t, a, s), t.child);
  }
  var pc = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null,
  };
  function mc(e) {
    return { baseLanes: e, cachePool: Xd() };
  }
  function hc(e, t, a) {
    return ((e = e !== null ? e.childLanes & ~a : 0), t && (e |= Ya), e);
  }
  function Pu(e, t, a) {
    var s = t.pendingProps,
      n = !1,
      r = (t.flags & 128) !== 0,
      o;
    if (
      ((o = r) ||
        (o =
          e !== null && e.memoizedState === null ? !1 : (_t.current & 2) !== 0),
      o && ((n = !0), (t.flags &= -129)),
      (o = (t.flags & 32) !== 0),
      (t.flags &= -33),
      e === null)
    ) {
      if (Ue) {
        if (
          (n ? Ds(t) : zs(),
          (e = dt)
            ? ((e = ox(e, rl)),
              (e = e !== null && e.data !== "&" ? e : null),
              e !== null &&
                ((t.memoizedState = {
                  dehydrated: e,
                  treeContext: ks !== null ? { id: Gl, overflow: Hl } : null,
                  retryLane: 536870912,
                  hydrationErrors: null,
                }),
                (a = zd(e)),
                (a.return = t),
                (t.child = a),
                (sa = t),
                (dt = null)))
            : (e = null),
          e === null)
        )
          throw Ss(t);
        return (Wc(e) ? (t.lanes = 32) : (t.lanes = 536870912), null);
      }
      var c = s.children;
      return (
        (s = s.fallback),
        n
          ? (zs(),
            (n = t.mode),
            (c = To({ mode: "hidden", children: c }, n)),
            (s = sn(s, n, a, null)),
            (c.return = t),
            (s.return = t),
            (c.sibling = s),
            (t.child = c),
            (s = t.child),
            (s.memoizedState = mc(a)),
            (s.childLanes = hc(e, o, a)),
            (t.memoizedState = pc),
            Tr(null, s))
          : (Ds(t), bc(t, c))
      );
    }
    var u = e.memoizedState;
    if (u !== null && ((c = u.dehydrated), c !== null)) {
      if (r)
        t.flags & 256
          ? (Ds(t), (t.flags &= -257), (t = gc(e, t, a)))
          : t.memoizedState !== null
            ? (zs(), (t.child = e.child), (t.flags |= 128), (t = null))
            : (zs(),
              (c = s.fallback),
              (n = t.mode),
              (s = To({ mode: "visible", children: s.children }, n)),
              (c = sn(c, n, a, null)),
              (c.flags |= 2),
              (s.return = t),
              (c.return = t),
              (s.sibling = c),
              (t.child = s),
              xn(t, e.child, null, a),
              (s = t.child),
              (s.memoizedState = mc(a)),
              (s.childLanes = hc(e, o, a)),
              (t.memoizedState = pc),
              (t = Tr(null, s)));
      else if ((Ds(t), Wc(c))) {
        if (((o = c.nextSibling && c.nextSibling.dataset), o)) var w = o.dgst;
        ((o = w),
          (s = Error(h(419))),
          (s.stack = ""),
          (s.digest = o),
          br({ value: s, source: null, stack: null }),
          (t = gc(e, t, a)));
      } else if (
        (Rt || Ln(e, t, a, !1), (o = (a & e.childLanes) !== 0), Rt || o)
      ) {
        if (
          ((o = rt),
          o !== null && ((s = hl(o, a)), s !== 0 && s !== u.retryLane))
        )
          throw ((u.retryLane = s), ln(e, s), Ea(o, e, s), xc);
        (Jc(c) || Ro(), (t = gc(e, t, a)));
      } else
        Jc(c)
          ? ((t.flags |= 192), (t.child = e.child), (t = null))
          : ((e = u.treeContext),
            (dt = il(c.nextSibling)),
            (sa = t),
            (Ue = !0),
            (Cs = null),
            (rl = !1),
            e !== null && Od(t, e),
            (t = bc(t, s.children)),
            (t.flags |= 4096));
      return t;
    }
    return n
      ? (zs(),
        (c = s.fallback),
        (n = t.mode),
        (u = e.child),
        (w = u.sibling),
        (s = es(u, { mode: "hidden", children: s.children })),
        (s.subtreeFlags = u.subtreeFlags & 65011712),
        w !== null ? (c = es(w, c)) : ((c = sn(c, n, a, null)), (c.flags |= 2)),
        (c.return = t),
        (s.return = t),
        (s.sibling = c),
        (t.child = s),
        Tr(null, s),
        (s = t.child),
        (c = e.child.memoizedState),
        c === null
          ? (c = mc(a))
          : ((n = c.cachePool),
            n !== null
              ? ((u = Ut._currentValue),
                (n = n.parent !== u ? { parent: u, pool: u } : n))
              : (n = Xd()),
            (c = { baseLanes: c.baseLanes | a, cachePool: n })),
        (s.memoizedState = c),
        (s.childLanes = hc(e, o, a)),
        (t.memoizedState = pc),
        Tr(e.child, s))
      : (Ds(t),
        (a = e.child),
        (e = a.sibling),
        (a = es(a, { mode: "visible", children: s.children })),
        (a.return = t),
        (a.sibling = null),
        e !== null &&
          ((o = t.deletions),
          o === null ? ((t.deletions = [e]), (t.flags |= 16)) : o.push(e)),
        (t.child = a),
        (t.memoizedState = null),
        a);
  }
  function bc(e, t) {
    return (
      (t = To({ mode: "visible", children: t }, e.mode)),
      (t.return = e),
      (e.child = t)
    );
  }
  function To(e, t) {
    return ((e = Ra(22, e, null, t)), (e.lanes = 0), e);
  }
  function gc(e, t, a) {
    return (
      xn(t, e.child, null, a),
      (e = bc(t, t.pendingProps.children)),
      (e.flags |= 2),
      (t.memoizedState = null),
      e
    );
  }
  function e0(e, t, a) {
    e.lanes |= t;
    var s = e.alternate;
    (s !== null && (s.lanes |= t), Li(e.return, t, a));
  }
  function vc(e, t, a, s, n, r) {
    var o = e.memoizedState;
    o === null
      ? (e.memoizedState = {
          isBackwards: t,
          rendering: null,
          renderingStartTime: 0,
          last: s,
          tail: a,
          tailMode: n,
          treeForkCount: r,
        })
      : ((o.isBackwards = t),
        (o.rendering = null),
        (o.renderingStartTime = 0),
        (o.last = s),
        (o.tail = a),
        (o.tailMode = n),
        (o.treeForkCount = r));
  }
  function t0(e, t, a) {
    var s = t.pendingProps,
      n = s.revealOrder,
      r = s.tail;
    s = s.children;
    var o = _t.current,
      c = (o & 2) !== 0;
    if (
      (c ? ((o = (o & 1) | 2), (t.flags |= 128)) : (o &= 1),
      G(_t, o),
      ra(e, t, s, a),
      (s = Ue ? hr : 0),
      !c && e !== null && (e.flags & 128) !== 0)
    )
      e: for (e = t.child; e !== null;) {
        if (e.tag === 13) e.memoizedState !== null && e0(e, a, t);
        else if (e.tag === 19) e0(e, a, t);
        else if (e.child !== null) {
          ((e.child.return = e), (e = e.child));
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null;) {
          if (e.return === null || e.return === t) break e;
          e = e.return;
        }
        ((e.sibling.return = e.return), (e = e.sibling));
      }
    switch (n) {
      case "forwards":
        for (a = t.child, n = null; a !== null;)
          ((e = a.alternate),
            e !== null && bo(e) === null && (n = a),
            (a = a.sibling));
        ((a = n),
          a === null
            ? ((n = t.child), (t.child = null))
            : ((n = a.sibling), (a.sibling = null)),
          vc(t, !1, n, a, r, s));
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (a = null, n = t.child, t.child = null; n !== null;) {
          if (((e = n.alternate), e !== null && bo(e) === null)) {
            t.child = n;
            break;
          }
          ((e = n.sibling), (n.sibling = a), (a = n), (n = e));
        }
        vc(t, !0, a, null, r, s);
        break;
      case "together":
        vc(t, !1, null, null, void 0, s);
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function rs(e, t, a) {
    if (
      (e !== null && (t.dependencies = e.dependencies),
      (Os |= t.lanes),
      (a & t.childLanes) === 0)
    )
      if (e !== null) {
        if ((Ln(e, t, a, !1), (a & t.childLanes) === 0)) return null;
      } else return null;
    if (e !== null && t.child !== e.child) throw Error(h(153));
    if (t.child !== null) {
      for (
        e = t.child, a = es(e, e.pendingProps), t.child = a, a.return = t;
        e.sibling !== null;
      )
        ((e = e.sibling),
          (a = a.sibling = es(e, e.pendingProps)),
          (a.return = t));
      a.sibling = null;
    }
    return t.child;
  }
  function yc(e, t) {
    return (e.lanes & t) !== 0
      ? !0
      : ((e = e.dependencies), !!(e !== null && io(e)));
  }
  function Ef(e, t, a) {
    switch (t.tag) {
      case 3:
        (Ie(t, t.stateNode.containerInfo),
          Es(t, Ut, e.memoizedState.cache),
          nn());
        break;
      case 27:
      case 5:
        Ht(t);
        break;
      case 4:
        Ie(t, t.stateNode.containerInfo);
        break;
      case 10:
        Es(t, t.type, t.memoizedProps.value);
        break;
      case 31:
        if (t.memoizedState !== null) return ((t.flags |= 128), Fi(t), null);
        break;
      case 13:
        var s = t.memoizedState;
        if (s !== null)
          return s.dehydrated !== null
            ? (Ds(t), (t.flags |= 128), null)
            : (a & t.child.childLanes) !== 0
              ? Pu(e, t, a)
              : (Ds(t), (e = rs(e, t, a)), e !== null ? e.sibling : null);
        Ds(t);
        break;
      case 19:
        var n = (e.flags & 128) !== 0;
        if (
          ((s = (a & t.childLanes) !== 0),
          s || (Ln(e, t, a, !1), (s = (a & t.childLanes) !== 0)),
          n)
        ) {
          if (s) return t0(e, t, a);
          t.flags |= 128;
        }
        if (
          ((n = t.memoizedState),
          n !== null &&
            ((n.rendering = null), (n.tail = null), (n.lastEffect = null)),
          G(_t, _t.current),
          s)
        )
          break;
        return null;
      case 22:
        return ((t.lanes = 0), $u(e, t, a, t.pendingProps));
      case 24:
        Es(t, Ut, e.memoizedState.cache);
    }
    return rs(e, t, a);
  }
  function a0(e, t, a) {
    if (e !== null)
      if (e.memoizedProps !== t.pendingProps) Rt = !0;
      else {
        if (!yc(e, a) && (t.flags & 128) === 0) return ((Rt = !1), Ef(e, t, a));
        Rt = (e.flags & 131072) !== 0;
      }
    else ((Rt = !1), Ue && (t.flags & 1048576) !== 0 && Bd(t, hr, t.index));
    switch (((t.lanes = 0), t.tag)) {
      case 16:
        e: {
          var s = t.pendingProps;
          if (((e = dn(t.elementType)), (t.type = e), typeof e == "function"))
            Ci(e)
              ? ((s = pn(e, s)), (t.tag = 1), (t = Ju(null, t, e, s, a)))
              : ((t.tag = 0), (t = fc(null, t, e, s, a)));
          else {
            if (e != null) {
              var n = e.$$typeof;
              if (n === Me) {
                ((t.tag = 11), (t = qu(null, t, e, s, a)));
                break e;
              } else if (n === it) {
                ((t.tag = 14), (t = Fu(null, t, e, s, a)));
                break e;
              }
            }
            throw ((t = nt(e) || e), Error(h(306, t, "")));
          }
        }
        return t;
      case 0:
        return fc(e, t, t.type, t.pendingProps, a);
      case 1:
        return ((s = t.type), (n = pn(s, t.pendingProps)), Ju(e, t, s, n, a));
      case 3:
        e: {
          if ((Ie(t, t.stateNode.containerInfo), e === null))
            throw Error(h(387));
          s = t.pendingProps;
          var r = t.memoizedState;
          ((n = r.element), Hi(e, t), kr(t, s, null, a));
          var o = t.memoizedState;
          if (
            ((s = o.cache),
            Es(t, Ut, s),
            s !== r.cache && Bi(t, [Ut], a, !0),
            Nr(),
            (s = o.element),
            r.isDehydrated)
          )
            if (
              ((r = { element: s, isDehydrated: !1, cache: o.cache }),
              (t.updateQueue.baseState = r),
              (t.memoizedState = r),
              t.flags & 256)
            ) {
              t = Wu(e, t, s, a);
              break e;
            } else if (s !== n) {
              ((n = ll(Error(h(424)), t)), br(n), (t = Wu(e, t, s, a)));
              break e;
            } else {
              switch (((e = t.stateNode.containerInfo), e.nodeType)) {
                case 9:
                  e = e.body;
                  break;
                default:
                  e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
              }
              for (
                dt = il(e.firstChild),
                  sa = t,
                  Ue = !0,
                  Cs = null,
                  rl = !0,
                  a = $d(t, null, s, a),
                  t.child = a;
                a;
              )
                ((a.flags = (a.flags & -3) | 4096), (a = a.sibling));
            }
          else {
            if ((nn(), s === n)) {
              t = rs(e, t, a);
              break e;
            }
            ra(e, t, s, a);
          }
          t = t.child;
        }
        return t;
      case 26:
        return (
          Ao(e, t),
          e === null
            ? (a = fx(t.type, null, t.pendingProps, null))
              ? (t.memoizedState = a)
              : Ue ||
                ((a = t.type),
                (e = t.pendingProps),
                (s = Fo(ie.current).createElement(a)),
                (s[ft] = t),
                (s[Bt] = e),
                oa(s, a, e),
                et(s),
                (t.stateNode = s))
            : (t.memoizedState = fx(
                t.type,
                e.memoizedProps,
                t.pendingProps,
                e.memoizedState,
              )),
          null
        );
      case 27:
        return (
          Ht(t),
          e === null &&
            Ue &&
            ((s = t.stateNode = dx(t.type, t.pendingProps, ie.current)),
            (sa = t),
            (rl = !0),
            (n = dt),
            Hs(t.type) ? ((Pc = n), (dt = il(s.firstChild))) : (dt = n)),
          ra(e, t, t.pendingProps.children, a),
          Ao(e, t),
          e === null && (t.flags |= 4194304),
          t.child
        );
      case 5:
        return (
          e === null &&
            Ue &&
            ((n = s = dt) &&
              ((s = lp(s, t.type, t.pendingProps, rl)),
              s !== null
                ? ((t.stateNode = s),
                  (sa = t),
                  (dt = il(s.firstChild)),
                  (rl = !1),
                  (n = !0))
                : (n = !1)),
            n || Ss(t)),
          Ht(t),
          (n = t.type),
          (r = t.pendingProps),
          (o = e !== null ? e.memoizedProps : null),
          (s = r.children),
          Qc(n, r) ? (s = null) : o !== null && Qc(n, o) && (t.flags |= 32),
          t.memoizedState !== null &&
            ((n = $i(e, t, gf, null, null, a)), (qr._currentValue = n)),
          Ao(e, t),
          ra(e, t, s, a),
          t.child
        );
      case 6:
        return (
          e === null &&
            Ue &&
            ((e = a = dt) &&
              ((a = sp(a, t.pendingProps, rl)),
              a !== null
                ? ((t.stateNode = a), (sa = t), (dt = null), (e = !0))
                : (e = !1)),
            e || Ss(t)),
          null
        );
      case 13:
        return Pu(e, t, a);
      case 4:
        return (
          Ie(t, t.stateNode.containerInfo),
          (s = t.pendingProps),
          e === null ? (t.child = xn(t, null, s, a)) : ra(e, t, s, a),
          t.child
        );
      case 11:
        return qu(e, t, t.type, t.pendingProps, a);
      case 7:
        return (ra(e, t, t.pendingProps, a), t.child);
      case 8:
        return (ra(e, t, t.pendingProps.children, a), t.child);
      case 12:
        return (ra(e, t, t.pendingProps.children, a), t.child);
      case 10:
        return (
          (s = t.pendingProps),
          Es(t, t.type, s.value),
          ra(e, t, s.children, a),
          t.child
        );
      case 9:
        return (
          (n = t.type._context),
          (s = t.pendingProps.children),
          on(t),
          (n = na(n)),
          (s = s(n)),
          (t.flags |= 1),
          ra(e, t, s, a),
          t.child
        );
      case 14:
        return Fu(e, t, t.type, t.pendingProps, a);
      case 15:
        return Vu(e, t, t.type, t.pendingProps, a);
      case 19:
        return t0(e, t, a);
      case 31:
        return Sf(e, t, a);
      case 22:
        return $u(e, t, a, t.pendingProps);
      case 24:
        return (
          on(t),
          (s = na(Ut)),
          e === null
            ? ((n = Mi()),
              n === null &&
                ((n = rt),
                (r = Oi()),
                (n.pooledCache = r),
                r.refCount++,
                r !== null && (n.pooledCacheLanes |= a),
                (n = r)),
              (t.memoizedState = { parent: s, cache: n }),
              Gi(t),
              Es(t, Ut, n))
            : ((e.lanes & a) !== 0 && (Hi(e, t), kr(t, null, null, a), Nr()),
              (n = e.memoizedState),
              (r = t.memoizedState),
              n.parent !== s
                ? ((n = { parent: s, cache: s }),
                  (t.memoizedState = n),
                  t.lanes === 0 &&
                    (t.memoizedState = t.updateQueue.baseState = n),
                  Es(t, Ut, s))
                : ((s = r.cache),
                  Es(t, Ut, s),
                  s !== n.cache && Bi(t, [Ut], a, !0))),
          ra(e, t, t.pendingProps.children, a),
          t.child
        );
      case 29:
        throw t.pendingProps;
    }
    throw Error(h(156, t.tag));
  }
  function os(e) {
    e.flags |= 4;
  }
  function wc(e, t, a, s, n) {
    if (((t = (e.mode & 32) !== 0) && (t = !1), t)) {
      if (((e.flags |= 16777216), (n & 335544128) === n))
        if (e.stateNode.complete) e.flags |= 8192;
        else if (T0()) e.flags |= 8192;
        else throw ((un = fo), Ri);
    } else e.flags &= -16777217;
  }
  function l0(e, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      e.flags &= -16777217;
    else if (((e.flags |= 16777216), !gx(t)))
      if (T0()) e.flags |= 8192;
      else throw ((un = fo), Ri);
  }
  function _o(e, t) {
    (t !== null && (e.flags |= 4),
      e.flags & 16384 &&
        ((t = e.tag !== 22 ? xl() : 536870912), (e.lanes |= t), (Fn |= t)));
  }
  function _r(e, t) {
    if (!Ue)
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;
          for (var a = null; t !== null;)
            (t.alternate !== null && (a = t), (t = t.sibling));
          a === null ? (e.tail = null) : (a.sibling = null);
          break;
        case "collapsed":
          a = e.tail;
          for (var s = null; a !== null;)
            (a.alternate !== null && (s = a), (a = a.sibling));
          s === null
            ? t || e.tail === null
              ? (e.tail = null)
              : (e.tail.sibling = null)
            : (s.sibling = null);
      }
  }
  function ut(e) {
    var t = e.alternate !== null && e.alternate.child === e.child,
      a = 0,
      s = 0;
    if (t)
      for (var n = e.child; n !== null;)
        ((a |= n.lanes | n.childLanes),
          (s |= n.subtreeFlags & 65011712),
          (s |= n.flags & 65011712),
          (n.return = e),
          (n = n.sibling));
    else
      for (n = e.child; n !== null;)
        ((a |= n.lanes | n.childLanes),
          (s |= n.subtreeFlags),
          (s |= n.flags),
          (n.return = e),
          (n = n.sibling));
    return ((e.subtreeFlags |= s), (e.childLanes = a), t);
  }
  function Af(e, t, a) {
    var s = t.pendingProps;
    switch ((Ti(t), t.tag)) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return (ut(t), null);
      case 1:
        return (ut(t), null);
      case 3:
        return (
          (a = t.stateNode),
          (s = null),
          e !== null && (s = e.memoizedState.cache),
          t.memoizedState.cache !== s && (t.flags |= 2048),
          ls(Ut),
          Ct(),
          a.pendingContext &&
            ((a.context = a.pendingContext), (a.pendingContext = null)),
          (e === null || e.child === null) &&
            (zn(t)
              ? os(t)
              : e === null ||
                (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
                ((t.flags |= 1024), Di())),
          ut(t),
          null
        );
      case 26:
        var n = t.type,
          r = t.memoizedState;
        return (
          e === null
            ? (os(t),
              r !== null ? (ut(t), l0(t, r)) : (ut(t), wc(t, n, null, s, a)))
            : r
              ? r !== e.memoizedState
                ? (os(t), ut(t), l0(t, r))
                : (ut(t), (t.flags &= -16777217))
              : ((e = e.memoizedProps),
                e !== s && os(t),
                ut(t),
                wc(t, n, e, s, a)),
          null
        );
      case 27:
        if (
          (Xt(t),
          (a = ie.current),
          (n = t.type),
          e !== null && t.stateNode != null)
        )
          e.memoizedProps !== s && os(t);
        else {
          if (!s) {
            if (t.stateNode === null) throw Error(h(166));
            return (ut(t), null);
          }
          ((e = F.current),
            zn(t) ? Ud(t) : ((e = dx(n, s, a)), (t.stateNode = e), os(t)));
        }
        return (ut(t), null);
      case 5:
        if ((Xt(t), (n = t.type), e !== null && t.stateNode != null))
          e.memoizedProps !== s && os(t);
        else {
          if (!s) {
            if (t.stateNode === null) throw Error(h(166));
            return (ut(t), null);
          }
          if (((r = F.current), zn(t))) Ud(t);
          else {
            var o = Fo(ie.current);
            switch (r) {
              case 1:
                r = o.createElementNS("http://www.w3.org/2000/svg", n);
                break;
              case 2:
                r = o.createElementNS("http://www.w3.org/1998/Math/MathML", n);
                break;
              default:
                switch (n) {
                  case "svg":
                    r = o.createElementNS("http://www.w3.org/2000/svg", n);
                    break;
                  case "math":
                    r = o.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      n,
                    );
                    break;
                  case "script":
                    ((r = o.createElement("div")),
                      (r.innerHTML = "<script><\/script>"),
                      (r = r.removeChild(r.firstChild)));
                    break;
                  case "select":
                    ((r =
                      typeof s.is == "string"
                        ? o.createElement("select", { is: s.is })
                        : o.createElement("select")),
                      s.multiple
                        ? (r.multiple = !0)
                        : s.size && (r.size = s.size));
                    break;
                  default:
                    r =
                      typeof s.is == "string"
                        ? o.createElement(n, { is: s.is })
                        : o.createElement(n);
                }
            }
            ((r[ft] = t), (r[Bt] = s));
            e: for (o = t.child; o !== null;) {
              if (o.tag === 5 || o.tag === 6) r.appendChild(o.stateNode);
              else if (o.tag !== 4 && o.tag !== 27 && o.child !== null) {
                ((o.child.return = o), (o = o.child));
                continue;
              }
              if (o === t) break e;
              for (; o.sibling === null;) {
                if (o.return === null || o.return === t) break e;
                o = o.return;
              }
              ((o.sibling.return = o.return), (o = o.sibling));
            }
            t.stateNode = r;
            e: switch ((oa(r, n, s), n)) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                s = !!s.autoFocus;
                break e;
              case "img":
                s = !0;
                break e;
              default:
                s = !1;
            }
            s && os(t);
          }
        }
        return (
          ut(t),
          wc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, a),
          null
        );
      case 6:
        if (e && t.stateNode != null) e.memoizedProps !== s && os(t);
        else {
          if (typeof s != "string" && t.stateNode === null) throw Error(h(166));
          if (((e = ie.current), zn(t))) {
            if (
              ((e = t.stateNode),
              (a = t.memoizedProps),
              (s = null),
              (n = sa),
              n !== null)
            )
              switch (n.tag) {
                case 27:
                case 5:
                  s = n.memoizedProps;
              }
            ((e[ft] = t),
              (e = !!(
                e.nodeValue === a ||
                (s !== null && s.suppressHydrationWarning === !0) ||
                P0(e.nodeValue, a)
              )),
              e || Ss(t, !0));
          } else
            ((e = Fo(e).createTextNode(s)), (e[ft] = t), (t.stateNode = e));
        }
        return (ut(t), null);
      case 31:
        if (((a = t.memoizedState), e === null || e.memoizedState !== null)) {
          if (((s = zn(t)), a !== null)) {
            if (e === null) {
              if (!s) throw Error(h(318));
              if (
                ((e = t.memoizedState),
                (e = e !== null ? e.dehydrated : null),
                !e)
              )
                throw Error(h(557));
              e[ft] = t;
            } else
              (nn(),
                (t.flags & 128) === 0 && (t.memoizedState = null),
                (t.flags |= 4));
            (ut(t), (e = !1));
          } else
            ((a = Di()),
              e !== null &&
                e.memoizedState !== null &&
                (e.memoizedState.hydrationErrors = a),
              (e = !0));
          if (!e) return t.flags & 256 ? (Ha(t), t) : (Ha(t), null);
          if ((t.flags & 128) !== 0) throw Error(h(558));
        }
        return (ut(t), null);
      case 13:
        if (
          ((s = t.memoizedState),
          e === null ||
            (e.memoizedState !== null && e.memoizedState.dehydrated !== null))
        ) {
          if (((n = zn(t)), s !== null && s.dehydrated !== null)) {
            if (e === null) {
              if (!n) throw Error(h(318));
              if (
                ((n = t.memoizedState),
                (n = n !== null ? n.dehydrated : null),
                !n)
              )
                throw Error(h(317));
              n[ft] = t;
            } else
              (nn(),
                (t.flags & 128) === 0 && (t.memoizedState = null),
                (t.flags |= 4));
            (ut(t), (n = !1));
          } else
            ((n = Di()),
              e !== null &&
                e.memoizedState !== null &&
                (e.memoizedState.hydrationErrors = n),
              (n = !0));
          if (!n) return t.flags & 256 ? (Ha(t), t) : (Ha(t), null);
        }
        return (
          Ha(t),
          (t.flags & 128) !== 0
            ? ((t.lanes = a), t)
            : ((a = s !== null),
              (e = e !== null && e.memoizedState !== null),
              a &&
                ((s = t.child),
                (n = null),
                s.alternate !== null &&
                  s.alternate.memoizedState !== null &&
                  s.alternate.memoizedState.cachePool !== null &&
                  (n = s.alternate.memoizedState.cachePool.pool),
                (r = null),
                s.memoizedState !== null &&
                  s.memoizedState.cachePool !== null &&
                  (r = s.memoizedState.cachePool.pool),
                r !== n && (s.flags |= 2048)),
              a !== e && a && (t.child.flags |= 8192),
              _o(t, t.updateQueue),
              ut(t),
              null)
        );
      case 4:
        return (Ct(), e === null && Ic(t.stateNode.containerInfo), ut(t), null);
      case 10:
        return (ls(t.type), ut(t), null);
      case 19:
        if ((H(_t), (s = t.memoizedState), s === null)) return (ut(t), null);
        if (((n = (t.flags & 128) !== 0), (r = s.rendering), r === null))
          if (n) _r(s, !1);
          else {
            if (wt !== 0 || (e !== null && (e.flags & 128) !== 0))
              for (e = t.child; e !== null;) {
                if (((r = bo(e)), r !== null)) {
                  for (
                    t.flags |= 128,
                      _r(s, !1),
                      e = r.updateQueue,
                      t.updateQueue = e,
                      _o(t, e),
                      t.subtreeFlags = 0,
                      e = a,
                      a = t.child;
                    a !== null;
                  )
                    (Dd(a, e), (a = a.sibling));
                  return (
                    G(_t, (_t.current & 1) | 2),
                    Ue && ts(t, s.treeForkCount),
                    t.child
                  );
                }
                e = e.sibling;
              }
            s.tail !== null &&
              we() > Oo &&
              ((t.flags |= 128), (n = !0), _r(s, !1), (t.lanes = 4194304));
          }
        else {
          if (!n)
            if (((e = bo(r)), e !== null)) {
              if (
                ((t.flags |= 128),
                (n = !0),
                (e = e.updateQueue),
                (t.updateQueue = e),
                _o(t, e),
                _r(s, !0),
                s.tail === null &&
                  s.tailMode === "hidden" &&
                  !r.alternate &&
                  !Ue)
              )
                return (ut(t), null);
            } else
              2 * we() - s.renderingStartTime > Oo &&
                a !== 536870912 &&
                ((t.flags |= 128), (n = !0), _r(s, !1), (t.lanes = 4194304));
          s.isBackwards
            ? ((r.sibling = t.child), (t.child = r))
            : ((e = s.last),
              e !== null ? (e.sibling = r) : (t.child = r),
              (s.last = r));
        }
        return s.tail !== null
          ? ((e = s.tail),
            (s.rendering = e),
            (s.tail = e.sibling),
            (s.renderingStartTime = we()),
            (e.sibling = null),
            (a = _t.current),
            G(_t, n ? (a & 1) | 2 : a & 1),
            Ue && ts(t, s.treeForkCount),
            e)
          : (ut(t), null);
      case 22:
      case 23:
        return (
          Ha(t),
          qi(),
          (s = t.memoizedState !== null),
          e !== null
            ? (e.memoizedState !== null) !== s && (t.flags |= 8192)
            : s && (t.flags |= 8192),
          s
            ? (a & 536870912) !== 0 &&
              (t.flags & 128) === 0 &&
              (ut(t), t.subtreeFlags & 6 && (t.flags |= 8192))
            : ut(t),
          (a = t.updateQueue),
          a !== null && _o(t, a.retryQueue),
          (a = null),
          e !== null &&
            e.memoizedState !== null &&
            e.memoizedState.cachePool !== null &&
            (a = e.memoizedState.cachePool.pool),
          (s = null),
          t.memoizedState !== null &&
            t.memoizedState.cachePool !== null &&
            (s = t.memoizedState.cachePool.pool),
          s !== a && (t.flags |= 2048),
          e !== null && H(cn),
          null
        );
      case 24:
        return (
          (a = null),
          e !== null && (a = e.memoizedState.cache),
          t.memoizedState.cache !== a && (t.flags |= 2048),
          ls(Ut),
          ut(t),
          null
        );
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(h(156, t.tag));
  }
  function Tf(e, t) {
    switch ((Ti(t), t.tag)) {
      case 1:
        return (
          (e = t.flags),
          e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
        );
      case 3:
        return (
          ls(Ut),
          Ct(),
          (e = t.flags),
          (e & 65536) !== 0 && (e & 128) === 0
            ? ((t.flags = (e & -65537) | 128), t)
            : null
        );
      case 26:
      case 27:
      case 5:
        return (Xt(t), null);
      case 31:
        if (t.memoizedState !== null) {
          if ((Ha(t), t.alternate === null)) throw Error(h(340));
          nn();
        }
        return (
          (e = t.flags),
          e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
        );
      case 13:
        if (
          (Ha(t), (e = t.memoizedState), e !== null && e.dehydrated !== null)
        ) {
          if (t.alternate === null) throw Error(h(340));
          nn();
        }
        return (
          (e = t.flags),
          e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
        );
      case 19:
        return (H(_t), null);
      case 4:
        return (Ct(), null);
      case 10:
        return (ls(t.type), null);
      case 22:
      case 23:
        return (
          Ha(t),
          qi(),
          e !== null && H(cn),
          (e = t.flags),
          e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
        );
      case 24:
        return (ls(Ut), null);
      case 25:
        return null;
      default:
        return null;
    }
  }
  function s0(e, t) {
    switch ((Ti(t), t.tag)) {
      case 3:
        (ls(Ut), Ct());
        break;
      case 26:
      case 27:
      case 5:
        Xt(t);
        break;
      case 4:
        Ct();
        break;
      case 31:
        t.memoizedState !== null && Ha(t);
        break;
      case 13:
        Ha(t);
        break;
      case 19:
        H(_t);
        break;
      case 10:
        ls(t.type);
        break;
      case 22:
      case 23:
        (Ha(t), qi(), e !== null && H(cn));
        break;
      case 24:
        ls(Ut);
    }
  }
  function Dr(e, t) {
    try {
      var a = t.updateQueue,
        s = a !== null ? a.lastEffect : null;
      if (s !== null) {
        var n = s.next;
        a = n;
        do {
          if ((a.tag & e) === e) {
            s = void 0;
            var r = a.create,
              o = a.inst;
            ((s = r()), (o.destroy = s));
          }
          a = a.next;
        } while (a !== n);
      }
    } catch (c) {
      We(t, t.return, c);
    }
  }
  function Ls(e, t, a) {
    try {
      var s = t.updateQueue,
        n = s !== null ? s.lastEffect : null;
      if (n !== null) {
        var r = n.next;
        s = r;
        do {
          if ((s.tag & e) === e) {
            var o = s.inst,
              c = o.destroy;
            if (c !== void 0) {
              ((o.destroy = void 0), (n = t));
              var u = a,
                w = c;
              try {
                w();
              } catch (T) {
                We(n, u, T);
              }
            }
          }
          s = s.next;
        } while (s !== r);
      }
    } catch (T) {
      We(t, t.return, T);
    }
  }
  function n0(e) {
    var t = e.updateQueue;
    if (t !== null) {
      var a = e.stateNode;
      try {
        Kd(t, a);
      } catch (s) {
        We(e, e.return, s);
      }
    }
  }
  function r0(e, t, a) {
    ((a.props = pn(e.type, e.memoizedProps)), (a.state = e.memoizedState));
    try {
      a.componentWillUnmount();
    } catch (s) {
      We(e, t, s);
    }
  }
  function zr(e, t) {
    try {
      var a = e.ref;
      if (a !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var s = e.stateNode;
            break;
          case 30:
            s = e.stateNode;
            break;
          default:
            s = e.stateNode;
        }
        typeof a == "function" ? (e.refCleanup = a(s)) : (a.current = s);
      }
    } catch (n) {
      We(e, t, n);
    }
  }
  function Xl(e, t) {
    var a = e.ref,
      s = e.refCleanup;
    if (a !== null)
      if (typeof s == "function")
        try {
          s();
        } catch (n) {
          We(e, t, n);
        } finally {
          ((e.refCleanup = null),
            (e = e.alternate),
            e != null && (e.refCleanup = null));
        }
      else if (typeof a == "function")
        try {
          a(null);
        } catch (n) {
          We(e, t, n);
        }
      else a.current = null;
  }
  function o0(e) {
    var t = e.type,
      a = e.memoizedProps,
      s = e.stateNode;
    try {
      e: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && s.focus();
          break e;
        case "img":
          a.src ? (s.src = a.src) : a.srcSet && (s.srcset = a.srcSet);
      }
    } catch (n) {
      We(e, e.return, n);
    }
  }
  function jc(e, t, a) {
    try {
      var s = e.stateNode;
      (Jf(s, e.type, a, t), (s[Bt] = t));
    } catch (n) {
      We(e, e.return, n);
    }
  }
  function i0(e) {
    return (
      e.tag === 5 ||
      e.tag === 3 ||
      e.tag === 26 ||
      (e.tag === 27 && Hs(e.type)) ||
      e.tag === 4
    );
  }
  function Nc(e) {
    e: for (;;) {
      for (; e.sibling === null;) {
        if (e.return === null || i0(e.return)) return null;
        e = e.return;
      }
      for (
        e.sibling.return = e.return, e = e.sibling;
        e.tag !== 5 && e.tag !== 6 && e.tag !== 18;
      ) {
        if (
          (e.tag === 27 && Hs(e.type)) ||
          e.flags & 2 ||
          e.child === null ||
          e.tag === 4
        )
          continue e;
        ((e.child.return = e), (e = e.child));
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function kc(e, t, a) {
    var s = e.tag;
    if (s === 5 || s === 6)
      ((e = e.stateNode),
        t
          ? (a.nodeType === 9
              ? a.body
              : a.nodeName === "HTML"
                ? a.ownerDocument.body
                : a
            ).insertBefore(e, t)
          : ((t =
              a.nodeType === 9
                ? a.body
                : a.nodeName === "HTML"
                  ? a.ownerDocument.body
                  : a),
            t.appendChild(e),
            (a = a._reactRootContainer),
            a != null || t.onclick !== null || (t.onclick = Da)));
    else if (
      s !== 4 &&
      (s === 27 && Hs(e.type) && ((a = e.stateNode), (t = null)),
      (e = e.child),
      e !== null)
    )
      for (kc(e, t, a), e = e.sibling; e !== null;)
        (kc(e, t, a), (e = e.sibling));
  }
  function Do(e, t, a) {
    var s = e.tag;
    if (s === 5 || s === 6)
      ((e = e.stateNode), t ? a.insertBefore(e, t) : a.appendChild(e));
    else if (
      s !== 4 &&
      (s === 27 && Hs(e.type) && (a = e.stateNode), (e = e.child), e !== null)
    )
      for (Do(e, t, a), e = e.sibling; e !== null;)
        (Do(e, t, a), (e = e.sibling));
  }
  function c0(e) {
    var t = e.stateNode,
      a = e.memoizedProps;
    try {
      for (var s = e.type, n = t.attributes; n.length;)
        t.removeAttributeNode(n[0]);
      (oa(t, s, a), (t[ft] = e), (t[Bt] = a));
    } catch (r) {
      We(e, e.return, r);
    }
  }
  var is = !1,
    Gt = !1,
    Cc = !1,
    d0 = typeof WeakSet == "function" ? WeakSet : Set,
    Jt = null;
  function _f(e, t) {
    if (((e = e.containerInfo), (Vc = Wo), (e = jd(e)), gi(e))) {
      if ("selectionStart" in e)
        var a = { start: e.selectionStart, end: e.selectionEnd };
      else
        e: {
          a = ((a = e.ownerDocument) && a.defaultView) || window;
          var s = a.getSelection && a.getSelection();
          if (s && s.rangeCount !== 0) {
            a = s.anchorNode;
            var n = s.anchorOffset,
              r = s.focusNode;
            s = s.focusOffset;
            try {
              (a.nodeType, r.nodeType);
            } catch {
              a = null;
              break e;
            }
            var o = 0,
              c = -1,
              u = -1,
              w = 0,
              T = 0,
              L = e,
              N = null;
            t: for (;;) {
              for (
                var k;
                L !== a || (n !== 0 && L.nodeType !== 3) || (c = o + n),
                  L !== r || (s !== 0 && L.nodeType !== 3) || (u = o + s),
                  L.nodeType === 3 && (o += L.nodeValue.length),
                  (k = L.firstChild) !== null;
              )
                ((N = L), (L = k));
              for (;;) {
                if (L === e) break t;
                if (
                  (N === a && ++w === n && (c = o),
                  N === r && ++T === s && (u = o),
                  (k = L.nextSibling) !== null)
                )
                  break;
                ((L = N), (N = L.parentNode));
              }
              L = k;
            }
            a = c === -1 || u === -1 ? null : { start: c, end: u };
          } else a = null;
        }
      a = a || { start: 0, end: 0 };
    } else a = null;
    for (
      $c = { focusedElem: e, selectionRange: a }, Wo = !1, Jt = t;
      Jt !== null;
    )
      if (
        ((t = Jt), (e = t.child), (t.subtreeFlags & 1028) !== 0 && e !== null)
      )
        ((e.return = t), (Jt = e));
      else
        for (; Jt !== null;) {
          switch (((t = Jt), (r = t.alternate), (e = t.flags), t.tag)) {
            case 0:
              if (
                (e & 4) !== 0 &&
                ((e = t.updateQueue),
                (e = e !== null ? e.events : null),
                e !== null)
              )
                for (a = 0; a < e.length; a++)
                  ((n = e[a]), (n.ref.impl = n.nextImpl));
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((e & 1024) !== 0 && r !== null) {
                ((e = void 0),
                  (a = t),
                  (n = r.memoizedProps),
                  (r = r.memoizedState),
                  (s = a.stateNode));
                try {
                  var P = pn(a.type, n);
                  ((e = s.getSnapshotBeforeUpdate(P, r)),
                    (s.__reactInternalSnapshotBeforeUpdate = e));
                } catch (be) {
                  We(a, a.return, be);
                }
              }
              break;
            case 3:
              if ((e & 1024) !== 0) {
                if (
                  ((e = t.stateNode.containerInfo), (a = e.nodeType), a === 9)
                )
                  Zc(e);
                else if (a === 1)
                  switch (e.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Zc(e);
                      break;
                    default:
                      e.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((e & 1024) !== 0) throw Error(h(163));
          }
          if (((e = t.sibling), e !== null)) {
            ((e.return = t.return), (Jt = e));
            break;
          }
          Jt = t.return;
        }
  }
  function u0(e, t, a) {
    var s = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        (ds(e, a), s & 4 && Dr(5, a));
        break;
      case 1:
        if ((ds(e, a), s & 4))
          if (((e = a.stateNode), t === null))
            try {
              e.componentDidMount();
            } catch (o) {
              We(a, a.return, o);
            }
          else {
            var n = pn(a.type, t.memoizedProps);
            t = t.memoizedState;
            try {
              e.componentDidUpdate(n, t, e.__reactInternalSnapshotBeforeUpdate);
            } catch (o) {
              We(a, a.return, o);
            }
          }
        (s & 64 && n0(a), s & 512 && zr(a, a.return));
        break;
      case 3:
        if ((ds(e, a), s & 64 && ((e = a.updateQueue), e !== null))) {
          if (((t = null), a.child !== null))
            switch (a.child.tag) {
              case 27:
              case 5:
                t = a.child.stateNode;
                break;
              case 1:
                t = a.child.stateNode;
            }
          try {
            Kd(e, t);
          } catch (o) {
            We(a, a.return, o);
          }
        }
        break;
      case 27:
        t === null && s & 4 && c0(a);
      case 26:
      case 5:
        (ds(e, a), t === null && s & 4 && o0(a), s & 512 && zr(a, a.return));
        break;
      case 12:
        ds(e, a);
        break;
      case 31:
        (ds(e, a), s & 4 && p0(e, a));
        break;
      case 13:
        (ds(e, a),
          s & 4 && m0(e, a),
          s & 64 &&
            ((e = a.memoizedState),
            e !== null &&
              ((e = e.dehydrated),
              e !== null && ((a = Gf.bind(null, a)), np(e, a)))));
        break;
      case 22:
        if (((s = a.memoizedState !== null || is), !s)) {
          ((t = (t !== null && t.memoizedState !== null) || Gt), (n = is));
          var r = Gt;
          ((is = s),
            (Gt = t) && !r ? us(e, a, (a.subtreeFlags & 8772) !== 0) : ds(e, a),
            (is = n),
            (Gt = r));
        }
        break;
      case 30:
        break;
      default:
        ds(e, a);
    }
  }
  function x0(e) {
    var t = e.alternate;
    (t !== null && ((e.alternate = null), x0(t)),
      (e.child = null),
      (e.deletions = null),
      (e.sibling = null),
      e.tag === 5 && ((t = e.stateNode), t !== null && qe(t)),
      (e.stateNode = null),
      (e.return = null),
      (e.dependencies = null),
      (e.memoizedProps = null),
      (e.memoizedState = null),
      (e.pendingProps = null),
      (e.stateNode = null),
      (e.updateQueue = null));
  }
  var mt = null,
    Na = !1;
  function cs(e, t, a) {
    for (a = a.child; a !== null;) (f0(e, t, a), (a = a.sibling));
  }
  function f0(e, t, a) {
    if ($t && typeof $t.onCommitFiberUnmount == "function")
      try {
        $t.onCommitFiberUnmount(ul, a);
      } catch {}
    switch (a.tag) {
      case 26:
        (Gt || Xl(a, t),
          cs(e, t, a),
          a.memoizedState
            ? a.memoizedState.count--
            : a.stateNode && ((a = a.stateNode), a.parentNode.removeChild(a)));
        break;
      case 27:
        Gt || Xl(a, t);
        var s = mt,
          n = Na;
        (Hs(a.type) && ((mt = a.stateNode), (Na = !1)),
          cs(e, t, a),
          Xr(a.stateNode),
          (mt = s),
          (Na = n));
        break;
      case 5:
        Gt || Xl(a, t);
      case 6:
        if (
          ((s = mt),
          (n = Na),
          (mt = null),
          cs(e, t, a),
          (mt = s),
          (Na = n),
          mt !== null)
        )
          if (Na)
            try {
              (mt.nodeType === 9
                ? mt.body
                : mt.nodeName === "HTML"
                  ? mt.ownerDocument.body
                  : mt
              ).removeChild(a.stateNode);
            } catch (r) {
              We(a, t, r);
            }
          else
            try {
              mt.removeChild(a.stateNode);
            } catch (r) {
              We(a, t, r);
            }
        break;
      case 18:
        mt !== null &&
          (Na
            ? ((e = mt),
              nx(
                e.nodeType === 9
                  ? e.body
                  : e.nodeName === "HTML"
                    ? e.ownerDocument.body
                    : e,
                a.stateNode,
              ),
              Pn(e))
            : nx(mt, a.stateNode));
        break;
      case 4:
        ((s = mt),
          (n = Na),
          (mt = a.stateNode.containerInfo),
          (Na = !0),
          cs(e, t, a),
          (mt = s),
          (Na = n));
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        (Ls(2, a, t), Gt || Ls(4, a, t), cs(e, t, a));
        break;
      case 1:
        (Gt ||
          (Xl(a, t),
          (s = a.stateNode),
          typeof s.componentWillUnmount == "function" && r0(a, t, s)),
          cs(e, t, a));
        break;
      case 21:
        cs(e, t, a);
        break;
      case 22:
        ((Gt = (s = Gt) || a.memoizedState !== null), cs(e, t, a), (Gt = s));
        break;
      default:
        cs(e, t, a);
    }
  }
  function p0(e, t) {
    if (
      t.memoizedState === null &&
      ((e = t.alternate), e !== null && ((e = e.memoizedState), e !== null))
    ) {
      e = e.dehydrated;
      try {
        Pn(e);
      } catch (a) {
        We(t, t.return, a);
      }
    }
  }
  function m0(e, t) {
    if (
      t.memoizedState === null &&
      ((e = t.alternate),
      e !== null &&
        ((e = e.memoizedState), e !== null && ((e = e.dehydrated), e !== null)))
    )
      try {
        Pn(e);
      } catch (a) {
        We(t, t.return, a);
      }
  }
  function Df(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var t = e.stateNode;
        return (t === null && (t = e.stateNode = new d0()), t);
      case 22:
        return (
          (e = e.stateNode),
          (t = e._retryCache),
          t === null && (t = e._retryCache = new d0()),
          t
        );
      default:
        throw Error(h(435, e.tag));
    }
  }
  function zo(e, t) {
    var a = Df(e);
    t.forEach(function (s) {
      if (!a.has(s)) {
        a.add(s);
        var n = Hf.bind(null, e, s);
        s.then(n, n);
      }
    });
  }
  function ka(e, t) {
    var a = t.deletions;
    if (a !== null)
      for (var s = 0; s < a.length; s++) {
        var n = a[s],
          r = e,
          o = t,
          c = o;
        e: for (; c !== null;) {
          switch (c.tag) {
            case 27:
              if (Hs(c.type)) {
                ((mt = c.stateNode), (Na = !1));
                break e;
              }
              break;
            case 5:
              ((mt = c.stateNode), (Na = !1));
              break e;
            case 3:
            case 4:
              ((mt = c.stateNode.containerInfo), (Na = !0));
              break e;
          }
          c = c.return;
        }
        if (mt === null) throw Error(h(160));
        (f0(r, o, n),
          (mt = null),
          (Na = !1),
          (r = n.alternate),
          r !== null && (r.return = null),
          (n.return = null));
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null;) (h0(t, e), (t = t.sibling));
  }
  var Dl = null;
  function h0(e, t) {
    var a = e.alternate,
      s = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        (ka(t, e),
          Ca(e),
          s & 4 && (Ls(3, e, e.return), Dr(3, e), Ls(5, e, e.return)));
        break;
      case 1:
        (ka(t, e),
          Ca(e),
          s & 512 && (Gt || a === null || Xl(a, a.return)),
          s & 64 &&
            is &&
            ((e = e.updateQueue),
            e !== null &&
              ((s = e.callbacks),
              s !== null &&
                ((a = e.shared.hiddenCallbacks),
                (e.shared.hiddenCallbacks = a === null ? s : a.concat(s))))));
        break;
      case 26:
        var n = Dl;
        if (
          (ka(t, e),
          Ca(e),
          s & 512 && (Gt || a === null || Xl(a, a.return)),
          s & 4)
        ) {
          var r = a !== null ? a.memoizedState : null;
          if (((s = e.memoizedState), a === null))
            if (s === null)
              if (e.stateNode === null) {
                e: {
                  ((s = e.type),
                    (a = e.memoizedProps),
                    (n = n.ownerDocument || n));
                  t: switch (s) {
                    case "title":
                      ((r = n.getElementsByTagName("title")[0]),
                        (!r ||
                          r[gl] ||
                          r[ft] ||
                          r.namespaceURI === "http://www.w3.org/2000/svg" ||
                          r.hasAttribute("itemprop")) &&
                          ((r = n.createElement(s)),
                          n.head.insertBefore(
                            r,
                            n.querySelector("head > title"),
                          )),
                        oa(r, s, a),
                        (r[ft] = e),
                        et(r),
                        (s = r));
                      break e;
                    case "link":
                      var o = hx("link", "href", n).get(s + (a.href || ""));
                      if (o) {
                        for (var c = 0; c < o.length; c++)
                          if (
                            ((r = o[c]),
                            r.getAttribute("href") ===
                              (a.href == null || a.href === ""
                                ? null
                                : a.href) &&
                              r.getAttribute("rel") ===
                                (a.rel == null ? null : a.rel) &&
                              r.getAttribute("title") ===
                                (a.title == null ? null : a.title) &&
                              r.getAttribute("crossorigin") ===
                                (a.crossOrigin == null ? null : a.crossOrigin))
                          ) {
                            o.splice(c, 1);
                            break t;
                          }
                      }
                      ((r = n.createElement(s)),
                        oa(r, s, a),
                        n.head.appendChild(r));
                      break;
                    case "meta":
                      if (
                        (o = hx("meta", "content", n).get(
                          s + (a.content || ""),
                        ))
                      ) {
                        for (c = 0; c < o.length; c++)
                          if (
                            ((r = o[c]),
                            r.getAttribute("content") ===
                              (a.content == null ? null : "" + a.content) &&
                              r.getAttribute("name") ===
                                (a.name == null ? null : a.name) &&
                              r.getAttribute("property") ===
                                (a.property == null ? null : a.property) &&
                              r.getAttribute("http-equiv") ===
                                (a.httpEquiv == null ? null : a.httpEquiv) &&
                              r.getAttribute("charset") ===
                                (a.charSet == null ? null : a.charSet))
                          ) {
                            o.splice(c, 1);
                            break t;
                          }
                      }
                      ((r = n.createElement(s)),
                        oa(r, s, a),
                        n.head.appendChild(r));
                      break;
                    default:
                      throw Error(h(468, s));
                  }
                  ((r[ft] = e), et(r), (s = r));
                }
                e.stateNode = s;
              } else bx(n, e.type, e.stateNode);
            else e.stateNode = mx(n, s, e.memoizedProps);
          else
            r !== s
              ? (r === null
                  ? a.stateNode !== null &&
                    ((a = a.stateNode), a.parentNode.removeChild(a))
                  : r.count--,
                s === null
                  ? bx(n, e.type, e.stateNode)
                  : mx(n, s, e.memoizedProps))
              : s === null &&
                e.stateNode !== null &&
                jc(e, e.memoizedProps, a.memoizedProps);
        }
        break;
      case 27:
        (ka(t, e),
          Ca(e),
          s & 512 && (Gt || a === null || Xl(a, a.return)),
          a !== null && s & 4 && jc(e, e.memoizedProps, a.memoizedProps));
        break;
      case 5:
        if (
          (ka(t, e),
          Ca(e),
          s & 512 && (Gt || a === null || Xl(a, a.return)),
          e.flags & 32)
        ) {
          n = e.stateNode;
          try {
            Nl(n, "");
          } catch (P) {
            We(e, e.return, P);
          }
        }
        (s & 4 &&
          e.stateNode != null &&
          ((n = e.memoizedProps), jc(e, n, a !== null ? a.memoizedProps : n)),
          s & 1024 && (Cc = !0));
        break;
      case 6:
        if ((ka(t, e), Ca(e), s & 4)) {
          if (e.stateNode === null) throw Error(h(162));
          ((s = e.memoizedProps), (a = e.stateNode));
          try {
            a.nodeValue = s;
          } catch (P) {
            We(e, e.return, P);
          }
        }
        break;
      case 3:
        if (
          ((Qo = null),
          (n = Dl),
          (Dl = Vo(t.containerInfo)),
          ka(t, e),
          (Dl = n),
          Ca(e),
          s & 4 && a !== null && a.memoizedState.isDehydrated)
        )
          try {
            Pn(t.containerInfo);
          } catch (P) {
            We(e, e.return, P);
          }
        Cc && ((Cc = !1), b0(e));
        break;
      case 4:
        ((s = Dl),
          (Dl = Vo(e.stateNode.containerInfo)),
          ka(t, e),
          Ca(e),
          (Dl = s));
        break;
      case 12:
        (ka(t, e), Ca(e));
        break;
      case 31:
        (ka(t, e),
          Ca(e),
          s & 4 &&
            ((s = e.updateQueue),
            s !== null && ((e.updateQueue = null), zo(e, s))));
        break;
      case 13:
        (ka(t, e),
          Ca(e),
          e.child.flags & 8192 &&
            (e.memoizedState !== null) !=
              (a !== null && a.memoizedState !== null) &&
            (Bo = we()),
          s & 4 &&
            ((s = e.updateQueue),
            s !== null && ((e.updateQueue = null), zo(e, s))));
        break;
      case 22:
        n = e.memoizedState !== null;
        var u = a !== null && a.memoizedState !== null,
          w = is,
          T = Gt;
        if (
          ((is = w || n),
          (Gt = T || u),
          ka(t, e),
          (Gt = T),
          (is = w),
          Ca(e),
          s & 8192)
        )
          e: for (
            t = e.stateNode,
              t._visibility = n ? t._visibility & -2 : t._visibility | 1,
              n && (a === null || u || is || Gt || mn(e)),
              a = null,
              t = e;
            ;
          ) {
            if (t.tag === 5 || t.tag === 26) {
              if (a === null) {
                u = a = t;
                try {
                  if (((r = u.stateNode), n))
                    ((o = r.style),
                      typeof o.setProperty == "function"
                        ? o.setProperty("display", "none", "important")
                        : (o.display = "none"));
                  else {
                    c = u.stateNode;
                    var L = u.memoizedProps.style,
                      N =
                        L != null && L.hasOwnProperty("display")
                          ? L.display
                          : null;
                    c.style.display =
                      N == null || typeof N == "boolean" ? "" : ("" + N).trim();
                  }
                } catch (P) {
                  We(u, u.return, P);
                }
              }
            } else if (t.tag === 6) {
              if (a === null) {
                u = t;
                try {
                  u.stateNode.nodeValue = n ? "" : u.memoizedProps;
                } catch (P) {
                  We(u, u.return, P);
                }
              }
            } else if (t.tag === 18) {
              if (a === null) {
                u = t;
                try {
                  var k = u.stateNode;
                  n ? rx(k, !0) : rx(u.stateNode, !1);
                } catch (P) {
                  We(u, u.return, P);
                }
              }
            } else if (
              ((t.tag !== 22 && t.tag !== 23) ||
                t.memoizedState === null ||
                t === e) &&
              t.child !== null
            ) {
              ((t.child.return = t), (t = t.child));
              continue;
            }
            if (t === e) break e;
            for (; t.sibling === null;) {
              if (t.return === null || t.return === e) break e;
              (a === t && (a = null), (t = t.return));
            }
            (a === t && (a = null),
              (t.sibling.return = t.return),
              (t = t.sibling));
          }
        s & 4 &&
          ((s = e.updateQueue),
          s !== null &&
            ((a = s.retryQueue),
            a !== null && ((s.retryQueue = null), zo(e, a))));
        break;
      case 19:
        (ka(t, e),
          Ca(e),
          s & 4 &&
            ((s = e.updateQueue),
            s !== null && ((e.updateQueue = null), zo(e, s))));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        (ka(t, e), Ca(e));
    }
  }
  function Ca(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        for (var a, s = e.return; s !== null;) {
          if (i0(s)) {
            a = s;
            break;
          }
          s = s.return;
        }
        if (a == null) throw Error(h(160));
        switch (a.tag) {
          case 27:
            var n = a.stateNode,
              r = Nc(e);
            Do(e, r, n);
            break;
          case 5:
            var o = a.stateNode;
            a.flags & 32 && (Nl(o, ""), (a.flags &= -33));
            var c = Nc(e);
            Do(e, c, o);
            break;
          case 3:
          case 4:
            var u = a.stateNode.containerInfo,
              w = Nc(e);
            kc(e, w, u);
            break;
          default:
            throw Error(h(161));
        }
      } catch (T) {
        We(e, e.return, T);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function b0(e) {
    if (e.subtreeFlags & 1024)
      for (e = e.child; e !== null;) {
        var t = e;
        (b0(t),
          t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
          (e = e.sibling));
      }
  }
  function ds(e, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null;) (u0(e, t.alternate, t), (t = t.sibling));
  }
  function mn(e) {
    for (e = e.child; e !== null;) {
      var t = e;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          (Ls(4, t, t.return), mn(t));
          break;
        case 1:
          Xl(t, t.return);
          var a = t.stateNode;
          (typeof a.componentWillUnmount == "function" && r0(t, t.return, a),
            mn(t));
          break;
        case 27:
          Xr(t.stateNode);
        case 26:
        case 5:
          (Xl(t, t.return), mn(t));
          break;
        case 22:
          t.memoizedState === null && mn(t);
          break;
        case 30:
          mn(t);
          break;
        default:
          mn(t);
      }
      e = e.sibling;
    }
  }
  function us(e, t, a) {
    for (a = a && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null;) {
      var s = t.alternate,
        n = e,
        r = t,
        o = r.flags;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          (us(n, r, a), Dr(4, r));
          break;
        case 1:
          if (
            (us(n, r, a),
            (s = r),
            (n = s.stateNode),
            typeof n.componentDidMount == "function")
          )
            try {
              n.componentDidMount();
            } catch (w) {
              We(s, s.return, w);
            }
          if (((s = r), (n = s.updateQueue), n !== null)) {
            var c = s.stateNode;
            try {
              var u = n.shared.hiddenCallbacks;
              if (u !== null)
                for (n.shared.hiddenCallbacks = null, n = 0; n < u.length; n++)
                  Qd(u[n], c);
            } catch (w) {
              We(s, s.return, w);
            }
          }
          (a && o & 64 && n0(r), zr(r, r.return));
          break;
        case 27:
          c0(r);
        case 26:
        case 5:
          (us(n, r, a), a && s === null && o & 4 && o0(r), zr(r, r.return));
          break;
        case 12:
          us(n, r, a);
          break;
        case 31:
          (us(n, r, a), a && o & 4 && p0(n, r));
          break;
        case 13:
          (us(n, r, a), a && o & 4 && m0(n, r));
          break;
        case 22:
          (r.memoizedState === null && us(n, r, a), zr(r, r.return));
          break;
        case 30:
          break;
        default:
          us(n, r, a);
      }
      t = t.sibling;
    }
  }
  function Sc(e, t) {
    var a = null;
    (e !== null &&
      e.memoizedState !== null &&
      e.memoizedState.cachePool !== null &&
      (a = e.memoizedState.cachePool.pool),
      (e = null),
      t.memoizedState !== null &&
        t.memoizedState.cachePool !== null &&
        (e = t.memoizedState.cachePool.pool),
      e !== a && (e != null && e.refCount++, a != null && gr(a)));
  }
  function Ec(e, t) {
    ((e = null),
      t.alternate !== null && (e = t.alternate.memoizedState.cache),
      (t = t.memoizedState.cache),
      t !== e && (t.refCount++, e != null && gr(e)));
  }
  function zl(e, t, a, s) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null;) (g0(e, t, a, s), (t = t.sibling));
  }
  function g0(e, t, a, s) {
    var n = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        (zl(e, t, a, s), n & 2048 && Dr(9, t));
        break;
      case 1:
        zl(e, t, a, s);
        break;
      case 3:
        (zl(e, t, a, s),
          n & 2048 &&
            ((e = null),
            t.alternate !== null && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache),
            t !== e && (t.refCount++, e != null && gr(e))));
        break;
      case 12:
        if (n & 2048) {
          (zl(e, t, a, s), (e = t.stateNode));
          try {
            var r = t.memoizedProps,
              o = r.id,
              c = r.onPostCommit;
            typeof c == "function" &&
              c(
                o,
                t.alternate === null ? "mount" : "update",
                e.passiveEffectDuration,
                -0,
              );
          } catch (u) {
            We(t, t.return, u);
          }
        } else zl(e, t, a, s);
        break;
      case 31:
        zl(e, t, a, s);
        break;
      case 13:
        zl(e, t, a, s);
        break;
      case 23:
        break;
      case 22:
        ((r = t.stateNode),
          (o = t.alternate),
          t.memoizedState !== null
            ? r._visibility & 2
              ? zl(e, t, a, s)
              : Lr(e, t)
            : r._visibility & 2
              ? zl(e, t, a, s)
              : ((r._visibility |= 2),
                Yn(e, t, a, s, (t.subtreeFlags & 10256) !== 0 || !1)),
          n & 2048 && Sc(o, t));
        break;
      case 24:
        (zl(e, t, a, s), n & 2048 && Ec(t.alternate, t));
        break;
      default:
        zl(e, t, a, s);
    }
  }
  function Yn(e, t, a, s, n) {
    for (
      n = n && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child;
      t !== null;
    ) {
      var r = e,
        o = t,
        c = a,
        u = s,
        w = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          (Yn(r, o, c, u, n), Dr(8, o));
          break;
        case 23:
          break;
        case 22:
          var T = o.stateNode;
          (o.memoizedState !== null
            ? T._visibility & 2
              ? Yn(r, o, c, u, n)
              : Lr(r, o)
            : ((T._visibility |= 2), Yn(r, o, c, u, n)),
            n && w & 2048 && Sc(o.alternate, o));
          break;
        case 24:
          (Yn(r, o, c, u, n), n && w & 2048 && Ec(o.alternate, o));
          break;
        default:
          Yn(r, o, c, u, n);
      }
      t = t.sibling;
    }
  }
  function Lr(e, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null;) {
        var a = e,
          s = t,
          n = s.flags;
        switch (s.tag) {
          case 22:
            (Lr(a, s), n & 2048 && Sc(s.alternate, s));
            break;
          case 24:
            (Lr(a, s), n & 2048 && Ec(s.alternate, s));
            break;
          default:
            Lr(a, s);
        }
        t = t.sibling;
      }
  }
  var Br = 8192;
  function In(e, t, a) {
    if (e.subtreeFlags & Br)
      for (e = e.child; e !== null;) (v0(e, t, a), (e = e.sibling));
  }
  function v0(e, t, a) {
    switch (e.tag) {
      case 26:
        (In(e, t, a),
          e.flags & Br &&
            e.memoizedState !== null &&
            bp(a, Dl, e.memoizedState, e.memoizedProps));
        break;
      case 5:
        In(e, t, a);
        break;
      case 3:
      case 4:
        var s = Dl;
        ((Dl = Vo(e.stateNode.containerInfo)), In(e, t, a), (Dl = s));
        break;
      case 22:
        e.memoizedState === null &&
          ((s = e.alternate),
          s !== null && s.memoizedState !== null
            ? ((s = Br), (Br = 16777216), In(e, t, a), (Br = s))
            : In(e, t, a));
        break;
      default:
        In(e, t, a);
    }
  }
  function y0(e) {
    var t = e.alternate;
    if (t !== null && ((e = t.child), e !== null)) {
      t.child = null;
      do ((t = e.sibling), (e.sibling = null), (e = t));
      while (e !== null);
    }
  }
  function Or(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var s = t[a];
          ((Jt = s), j0(s, e));
        }
      y0(e);
    }
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null;) (w0(e), (e = e.sibling));
  }
  function w0(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        (Or(e), e.flags & 2048 && Ls(9, e, e.return));
        break;
      case 3:
        Or(e);
        break;
      case 12:
        Or(e);
        break;
      case 22:
        var t = e.stateNode;
        e.memoizedState !== null &&
        t._visibility & 2 &&
        (e.return === null || e.return.tag !== 13)
          ? ((t._visibility &= -3), Lo(e))
          : Or(e);
        break;
      default:
        Or(e);
    }
  }
  function Lo(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var s = t[a];
          ((Jt = s), j0(s, e));
        }
      y0(e);
    }
    for (e = e.child; e !== null;) {
      switch (((t = e), t.tag)) {
        case 0:
        case 11:
        case 15:
          (Ls(8, t, t.return), Lo(t));
          break;
        case 22:
          ((a = t.stateNode),
            a._visibility & 2 && ((a._visibility &= -3), Lo(t)));
          break;
        default:
          Lo(t);
      }
      e = e.sibling;
    }
  }
  function j0(e, t) {
    for (; Jt !== null;) {
      var a = Jt;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          Ls(8, a, t);
          break;
        case 23:
        case 22:
          if (a.memoizedState !== null && a.memoizedState.cachePool !== null) {
            var s = a.memoizedState.cachePool.pool;
            s != null && s.refCount++;
          }
          break;
        case 24:
          gr(a.memoizedState.cache);
      }
      if (((s = a.child), s !== null)) ((s.return = a), (Jt = s));
      else
        e: for (a = e; Jt !== null;) {
          s = Jt;
          var n = s.sibling,
            r = s.return;
          if ((x0(s), s === a)) {
            Jt = null;
            break e;
          }
          if (n !== null) {
            ((n.return = r), (Jt = n));
            break e;
          }
          Jt = r;
        }
    }
  }
  var zf = {
      getCacheForType: function (e) {
        var t = na(Ut),
          a = t.data.get(e);
        return (a === void 0 && ((a = e()), t.data.set(e, a)), a);
      },
      cacheSignal: function () {
        return na(Ut).controller.signal;
      },
    },
    Lf = typeof WeakMap == "function" ? WeakMap : Map,
    Fe = 0,
    rt = null,
    De = null,
    Le = 0,
    Je = 0,
    Xa = null,
    Bs = !1,
    qn = !1,
    Ac = !1,
    xs = 0,
    wt = 0,
    Os = 0,
    hn = 0,
    Tc = 0,
    Ya = 0,
    Fn = 0,
    Ur = null,
    Sa = null,
    _c = !1,
    Bo = 0,
    N0 = 0,
    Oo = 1 / 0,
    Uo = null,
    Us = null,
    Ft = 0,
    Ms = null,
    Vn = null,
    fs = 0,
    Dc = 0,
    zc = null,
    k0 = null,
    Mr = 0,
    Lc = null;
  function Ia() {
    return (Fe & 2) !== 0 && Le !== 0 ? Le & -Le : C.T !== null ? Gc() : xt();
  }
  function C0() {
    if (Ya === 0)
      if ((Le & 536870912) === 0 || Ue) {
        var e = Wt;
        ((Wt <<= 1), (Wt & 3932160) === 0 && (Wt = 262144), (Ya = e));
      } else Ya = 536870912;
    return ((e = Ga.current), e !== null && (e.flags |= 32), Ya);
  }
  function Ea(e, t, a) {
    (((e === rt && (Je === 2 || Je === 9)) || e.cancelPendingCommit !== null) &&
      ($n(e, 0), Rs(e, Le, Ya, !1)),
      pl(e, a),
      ((Fe & 2) === 0 || e !== rt) &&
        (e === rt &&
          ((Fe & 2) === 0 && (hn |= a), wt === 4 && Rs(e, Le, Ya, !1)),
        Yl(e)));
  }
  function S0(e, t, a) {
    if ((Fe & 6) !== 0) throw Error(h(327));
    var s = (!a && (t & 127) === 0 && (t & e.expiredLanes) === 0) || Wa(e, t),
      n = s ? Uf(e, t) : Oc(e, t, !0),
      r = s;
    do {
      if (n === 0) {
        qn && !s && Rs(e, t, 0, !1);
        break;
      } else {
        if (((a = e.current.alternate), r && !Bf(a))) {
          ((n = Oc(e, t, !1)), (r = !1));
          continue;
        }
        if (n === 2) {
          if (((r = t), e.errorRecoveryDisabledLanes & r)) var o = 0;
          else
            ((o = e.pendingLanes & -536870913),
              (o = o !== 0 ? o : o & 536870912 ? 536870912 : 0));
          if (o !== 0) {
            t = o;
            e: {
              var c = e;
              n = Ur;
              var u = c.current.memoizedState.isDehydrated;
              if ((u && ($n(c, o).flags |= 256), (o = Oc(c, o, !1)), o !== 2)) {
                if (Ac && !u) {
                  ((c.errorRecoveryDisabledLanes |= r), (hn |= r), (n = 4));
                  break e;
                }
                ((r = Sa),
                  (Sa = n),
                  r !== null &&
                    (Sa === null ? (Sa = r) : Sa.push.apply(Sa, r)));
              }
              n = o;
            }
            if (((r = !1), n !== 2)) continue;
          }
        }
        if (n === 1) {
          ($n(e, 0), Rs(e, t, 0, !0));
          break;
        }
        e: {
          switch (((s = e), (r = n), r)) {
            case 0:
            case 1:
              throw Error(h(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              Rs(s, t, Ya, !Bs);
              break e;
            case 2:
              Sa = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(h(329));
          }
          if ((t & 62914560) === t && ((n = Bo + 300 - we()), 10 < n)) {
            if ((Rs(s, t, Ya, !Bs), Ja(s, 0, !0) !== 0)) break e;
            ((fs = t),
              (s.timeoutHandle = lx(
                E0.bind(
                  null,
                  s,
                  a,
                  Sa,
                  Uo,
                  _c,
                  t,
                  Ya,
                  hn,
                  Fn,
                  Bs,
                  r,
                  "Throttled",
                  -0,
                  0,
                ),
                n,
              )));
            break e;
          }
          E0(s, a, Sa, Uo, _c, t, Ya, hn, Fn, Bs, r, null, -0, 0);
        }
      }
      break;
    } while (!0);
    Yl(e);
  }
  function E0(e, t, a, s, n, r, o, c, u, w, T, L, N, k) {
    if (
      ((e.timeoutHandle = -1),
      (L = t.subtreeFlags),
      L & 8192 || (L & 16785408) === 16785408)
    ) {
      ((L = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Da,
      }),
        v0(t, r, L));
      var P =
        (r & 62914560) === r ? Bo - we() : (r & 4194048) === r ? N0 - we() : 0;
      if (((P = gp(L, P)), P !== null)) {
        ((fs = r),
          (e.cancelPendingCommit = P(
            O0.bind(null, e, t, r, a, s, n, o, c, u, T, L, null, N, k),
          )),
          Rs(e, r, o, !w));
        return;
      }
    }
    O0(e, t, r, a, s, n, o, c, u);
  }
  function Bf(e) {
    for (var t = e; ;) {
      var a = t.tag;
      if (
        (a === 0 || a === 11 || a === 15) &&
        t.flags & 16384 &&
        ((a = t.updateQueue), a !== null && ((a = a.stores), a !== null))
      )
        for (var s = 0; s < a.length; s++) {
          var n = a[s],
            r = n.getSnapshot;
          n = n.value;
          try {
            if (!ma(r(), n)) return !1;
          } catch {
            return !1;
          }
        }
      if (((a = t.child), t.subtreeFlags & 16384 && a !== null))
        ((a.return = t), (t = a));
      else {
        if (t === e) break;
        for (; t.sibling === null;) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        ((t.sibling.return = t.return), (t = t.sibling));
      }
    }
    return !0;
  }
  function Rs(e, t, a, s) {
    ((t &= ~Tc),
      (t &= ~hn),
      (e.suspendedLanes |= t),
      (e.pingedLanes &= ~t),
      s && (e.warmLanes |= t),
      (s = e.expirationTimes));
    for (var n = t; 0 < n;) {
      var r = 31 - zt(n),
        o = 1 << r;
      ((s[r] = -1), (n &= ~o));
    }
    a !== 0 && Vs(e, a, t);
  }
  function Mo() {
    return (Fe & 6) === 0 ? (Rr(0), !1) : !0;
  }
  function Bc() {
    if (De !== null) {
      if (Je === 0) var e = De.return;
      else ((e = De), (as = rn = null), Zi(e), (Mn = null), (yr = 0), (e = De));
      for (; e !== null;) (s0(e.alternate, e), (e = e.return));
      De = null;
    }
  }
  function $n(e, t) {
    var a = e.timeoutHandle;
    (a !== -1 && ((e.timeoutHandle = -1), ep(a)),
      (a = e.cancelPendingCommit),
      a !== null && ((e.cancelPendingCommit = null), a()),
      (fs = 0),
      Bc(),
      (rt = e),
      (De = a = es(e.current, null)),
      (Le = t),
      (Je = 0),
      (Xa = null),
      (Bs = !1),
      (qn = Wa(e, t)),
      (Ac = !1),
      (Fn = Ya = Tc = hn = Os = wt = 0),
      (Sa = Ur = null),
      (_c = !1),
      (t & 8) !== 0 && (t |= t & 32));
    var s = e.entangledLanes;
    if (s !== 0)
      for (e = e.entanglements, s &= t; 0 < s;) {
        var n = 31 - zt(s),
          r = 1 << n;
        ((t |= e[n]), (s &= ~r));
      }
    return ((xs = t), lo(), a);
  }
  function A0(e, t) {
    ((Ne = null),
      (C.H = Ar),
      t === Un || t === xo
        ? ((t = qd()), (Je = 3))
        : t === Ri
          ? ((t = qd()), (Je = 4))
          : (Je =
              t === xc
                ? 8
                : t !== null &&
                    typeof t == "object" &&
                    typeof t.then == "function"
                  ? 6
                  : 1),
      (Xa = t),
      De === null && ((wt = 1), So(e, ll(t, e.current))));
  }
  function T0() {
    var e = Ga.current;
    return e === null
      ? !0
      : (Le & 4194048) === Le
        ? ol === null
        : (Le & 62914560) === Le || (Le & 536870912) !== 0
          ? e === ol
          : !1;
  }
  function _0() {
    var e = C.H;
    return ((C.H = Ar), e === null ? Ar : e);
  }
  function D0() {
    var e = C.A;
    return ((C.A = zf), e);
  }
  function Ro() {
    ((wt = 4),
      Bs || ((Le & 4194048) !== Le && Ga.current !== null) || (qn = !0),
      ((Os & 134217727) === 0 && (hn & 134217727) === 0) ||
        rt === null ||
        Rs(rt, Le, Ya, !1));
  }
  function Oc(e, t, a) {
    var s = Fe;
    Fe |= 2;
    var n = _0(),
      r = D0();
    ((rt !== e || Le !== t) && ((Uo = null), $n(e, t)), (t = !1));
    var o = wt;
    e: do
      try {
        if (Je !== 0 && De !== null) {
          var c = De,
            u = Xa;
          switch (Je) {
            case 8:
              (Bc(), (o = 6));
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              Ga.current === null && (t = !0);
              var w = Je;
              if (((Je = 0), (Xa = null), Qn(e, c, u, w), a && qn)) {
                o = 0;
                break e;
              }
              break;
            default:
              ((w = Je), (Je = 0), (Xa = null), Qn(e, c, u, w));
          }
        }
        (Of(), (o = wt));
        break;
      } catch (T) {
        A0(e, T);
      }
    while (!0);
    return (
      t && e.shellSuspendCounter++,
      (as = rn = null),
      (Fe = s),
      (C.H = n),
      (C.A = r),
      De === null && ((rt = null), (Le = 0), lo()),
      o
    );
  }
  function Of() {
    for (; De !== null;) z0(De);
  }
  function Uf(e, t) {
    var a = Fe;
    Fe |= 2;
    var s = _0(),
      n = D0();
    rt !== e || Le !== t
      ? ((Uo = null), (Oo = we() + 500), $n(e, t))
      : (qn = Wa(e, t));
    e: do
      try {
        if (Je !== 0 && De !== null) {
          t = De;
          var r = Xa;
          t: switch (Je) {
            case 1:
              ((Je = 0), (Xa = null), Qn(e, t, r, 1));
              break;
            case 2:
            case 9:
              if (Yd(r)) {
                ((Je = 0), (Xa = null), L0(t));
                break;
              }
              ((t = function () {
                ((Je !== 2 && Je !== 9) || rt !== e || (Je = 7), Yl(e));
              }),
                r.then(t, t));
              break e;
            case 3:
              Je = 7;
              break e;
            case 4:
              Je = 5;
              break e;
            case 7:
              Yd(r)
                ? ((Je = 0), (Xa = null), L0(t))
                : ((Je = 0), (Xa = null), Qn(e, t, r, 7));
              break;
            case 5:
              var o = null;
              switch (De.tag) {
                case 26:
                  o = De.memoizedState;
                case 5:
                case 27:
                  var c = De;
                  if (o ? gx(o) : c.stateNode.complete) {
                    ((Je = 0), (Xa = null));
                    var u = c.sibling;
                    if (u !== null) De = u;
                    else {
                      var w = c.return;
                      w !== null ? ((De = w), Go(w)) : (De = null);
                    }
                    break t;
                  }
              }
              ((Je = 0), (Xa = null), Qn(e, t, r, 5));
              break;
            case 6:
              ((Je = 0), (Xa = null), Qn(e, t, r, 6));
              break;
            case 8:
              (Bc(), (wt = 6));
              break e;
            default:
              throw Error(h(462));
          }
        }
        Mf();
        break;
      } catch (T) {
        A0(e, T);
      }
    while (!0);
    return (
      (as = rn = null),
      (C.H = s),
      (C.A = n),
      (Fe = a),
      De !== null ? 0 : ((rt = null), (Le = 0), lo(), wt)
    );
  }
  function Mf() {
    for (; De !== null && !ye();) z0(De);
  }
  function z0(e) {
    var t = a0(e.alternate, e, xs);
    ((e.memoizedProps = e.pendingProps), t === null ? Go(e) : (De = t));
  }
  function L0(e) {
    var t = e,
      a = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = Zu(a, t, t.pendingProps, t.type, void 0, Le);
        break;
      case 11:
        t = Zu(a, t, t.pendingProps, t.type.render, t.ref, Le);
        break;
      case 5:
        Zi(t);
      default:
        (s0(a, t), (t = De = Dd(t, xs)), (t = a0(a, t, xs)));
    }
    ((e.memoizedProps = e.pendingProps), t === null ? Go(e) : (De = t));
  }
  function Qn(e, t, a, s) {
    ((as = rn = null), Zi(t), (Mn = null), (yr = 0));
    var n = t.return;
    try {
      if (Cf(e, n, t, a, Le)) {
        ((wt = 1), So(e, ll(a, e.current)), (De = null));
        return;
      }
    } catch (r) {
      if (n !== null) throw ((De = n), r);
      ((wt = 1), So(e, ll(a, e.current)), (De = null));
      return;
    }
    t.flags & 32768
      ? (Ue || s === 1
          ? (e = !0)
          : qn || (Le & 536870912) !== 0
            ? (e = !1)
            : ((Bs = e = !0),
              (s === 2 || s === 9 || s === 3 || s === 6) &&
                ((s = Ga.current),
                s !== null && s.tag === 13 && (s.flags |= 16384))),
        B0(t, e))
      : Go(t);
  }
  function Go(e) {
    var t = e;
    do {
      if ((t.flags & 32768) !== 0) {
        B0(t, Bs);
        return;
      }
      e = t.return;
      var a = Af(t.alternate, t, xs);
      if (a !== null) {
        De = a;
        return;
      }
      if (((t = t.sibling), t !== null)) {
        De = t;
        return;
      }
      De = t = e;
    } while (t !== null);
    wt === 0 && (wt = 5);
  }
  function B0(e, t) {
    do {
      var a = Tf(e.alternate, e);
      if (a !== null) {
        ((a.flags &= 32767), (De = a));
        return;
      }
      if (
        ((a = e.return),
        a !== null &&
          ((a.flags |= 32768), (a.subtreeFlags = 0), (a.deletions = null)),
        !t && ((e = e.sibling), e !== null))
      ) {
        De = e;
        return;
      }
      De = e = a;
    } while (e !== null);
    ((wt = 6), (De = null));
  }
  function O0(e, t, a, s, n, r, o, c, u) {
    e.cancelPendingCommit = null;
    do Ho();
    while (Ft !== 0);
    if ((Fe & 6) !== 0) throw Error(h(327));
    if (t !== null) {
      if (t === e.current) throw Error(h(177));
      if (
        ((r = t.lanes | t.childLanes),
        (r |= Ni),
        ql(e, a, r, o, c, u),
        e === rt && ((De = rt = null), (Le = 0)),
        (Vn = t),
        (Ms = e),
        (fs = a),
        (Dc = r),
        (zc = n),
        (k0 = s),
        (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
          ? ((e.callbackNode = null),
            (e.callbackPriority = 0),
            Xf(Aa, function () {
              return (H0(), null);
            }))
          : ((e.callbackNode = null), (e.callbackPriority = 0)),
        (s = (t.flags & 13878) !== 0),
        (t.subtreeFlags & 13878) !== 0 || s)
      ) {
        ((s = C.T), (C.T = null), (n = D.p), (D.p = 2), (o = Fe), (Fe |= 4));
        try {
          _f(e, t, a);
        } finally {
          ((Fe = o), (D.p = n), (C.T = s));
        }
      }
      ((Ft = 1), U0(), M0(), R0());
    }
  }
  function U0() {
    if (Ft === 1) {
      Ft = 0;
      var e = Ms,
        t = Vn,
        a = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || a) {
        ((a = C.T), (C.T = null));
        var s = D.p;
        D.p = 2;
        var n = Fe;
        Fe |= 4;
        try {
          h0(t, e);
          var r = $c,
            o = jd(e.containerInfo),
            c = r.focusedElem,
            u = r.selectionRange;
          if (
            o !== c &&
            c &&
            c.ownerDocument &&
            wd(c.ownerDocument.documentElement, c)
          ) {
            if (u !== null && gi(c)) {
              var w = u.start,
                T = u.end;
              if ((T === void 0 && (T = w), "selectionStart" in c))
                ((c.selectionStart = w),
                  (c.selectionEnd = Math.min(T, c.value.length)));
              else {
                var L = c.ownerDocument || document,
                  N = (L && L.defaultView) || window;
                if (N.getSelection) {
                  var k = N.getSelection(),
                    P = c.textContent.length,
                    be = Math.min(u.start, P),
                    lt = u.end === void 0 ? be : Math.min(u.end, P);
                  !k.extend && be > lt && ((o = lt), (lt = be), (be = o));
                  var g = yd(c, be),
                    m = yd(c, lt);
                  if (
                    g &&
                    m &&
                    (k.rangeCount !== 1 ||
                      k.anchorNode !== g.node ||
                      k.anchorOffset !== g.offset ||
                      k.focusNode !== m.node ||
                      k.focusOffset !== m.offset)
                  ) {
                    var v = L.createRange();
                    (v.setStart(g.node, g.offset),
                      k.removeAllRanges(),
                      be > lt
                        ? (k.addRange(v), k.extend(m.node, m.offset))
                        : (v.setEnd(m.node, m.offset), k.addRange(v)));
                  }
                }
              }
            }
            for (L = [], k = c; (k = k.parentNode);)
              k.nodeType === 1 &&
                L.push({ element: k, left: k.scrollLeft, top: k.scrollTop });
            for (
              typeof c.focus == "function" && c.focus(), c = 0;
              c < L.length;
              c++
            ) {
              var z = L[c];
              ((z.element.scrollLeft = z.left), (z.element.scrollTop = z.top));
            }
          }
          ((Wo = !!Vc), ($c = Vc = null));
        } finally {
          ((Fe = n), (D.p = s), (C.T = a));
        }
      }
      ((e.current = t), (Ft = 2));
    }
  }
  function M0() {
    if (Ft === 2) {
      Ft = 0;
      var e = Ms,
        t = Vn,
        a = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || a) {
        ((a = C.T), (C.T = null));
        var s = D.p;
        D.p = 2;
        var n = Fe;
        Fe |= 4;
        try {
          u0(e, t.alternate, t);
        } finally {
          ((Fe = n), (D.p = s), (C.T = a));
        }
      }
      Ft = 3;
    }
  }
  function R0() {
    if (Ft === 4 || Ft === 3) {
      ((Ft = 0), dl());
      var e = Ms,
        t = Vn,
        a = fs,
        s = k0;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
        ? (Ft = 5)
        : ((Ft = 0), (Vn = Ms = null), G0(e, e.pendingLanes));
      var n = e.pendingLanes;
      if (
        (n === 0 && (Us = null),
        Fl(a),
        (t = t.stateNode),
        $t && typeof $t.onCommitFiberRoot == "function")
      )
        try {
          $t.onCommitFiberRoot(ul, t, void 0, (t.current.flags & 128) === 128);
        } catch {}
      if (s !== null) {
        ((t = C.T), (n = D.p), (D.p = 2), (C.T = null));
        try {
          for (var r = e.onRecoverableError, o = 0; o < s.length; o++) {
            var c = s[o];
            r(c.value, { componentStack: c.stack });
          }
        } finally {
          ((C.T = t), (D.p = n));
        }
      }
      ((fs & 3) !== 0 && Ho(),
        Yl(e),
        (n = e.pendingLanes),
        (a & 261930) !== 0 && (n & 42) !== 0
          ? e === Lc
            ? Mr++
            : ((Mr = 0), (Lc = e))
          : (Mr = 0),
        Rr(0));
    }
  }
  function G0(e, t) {
    (e.pooledCacheLanes &= t) === 0 &&
      ((t = e.pooledCache), t != null && ((e.pooledCache = null), gr(t)));
  }
  function Ho() {
    return (U0(), M0(), R0(), H0());
  }
  function H0() {
    if (Ft !== 5) return !1;
    var e = Ms,
      t = Dc;
    Dc = 0;
    var a = Fl(fs),
      s = C.T,
      n = D.p;
    try {
      ((D.p = 32 > a ? 32 : a), (C.T = null), (a = zc), (zc = null));
      var r = Ms,
        o = fs;
      if (((Ft = 0), (Vn = Ms = null), (fs = 0), (Fe & 6) !== 0))
        throw Error(h(331));
      var c = Fe;
      if (
        ((Fe |= 4),
        w0(r.current),
        g0(r, r.current, o, a),
        (Fe = c),
        Rr(0, !1),
        $t && typeof $t.onPostCommitFiberRoot == "function")
      )
        try {
          $t.onPostCommitFiberRoot(ul, r);
        } catch {}
      return !0;
    } finally {
      ((D.p = n), (C.T = s), G0(e, t));
    }
  }
  function X0(e, t, a) {
    ((t = ll(a, t)),
      (t = uc(e.stateNode, t, 2)),
      (e = _s(e, t, 2)),
      e !== null && (pl(e, 2), Yl(e)));
  }
  function We(e, t, a) {
    if (e.tag === 3) X0(e, e, a);
    else
      for (; t !== null;) {
        if (t.tag === 3) {
          X0(t, e, a);
          break;
        } else if (t.tag === 1) {
          var s = t.stateNode;
          if (
            typeof t.type.getDerivedStateFromError == "function" ||
            (typeof s.componentDidCatch == "function" &&
              (Us === null || !Us.has(s)))
          ) {
            ((e = ll(a, e)),
              (a = Yu(2)),
              (s = _s(t, a, 2)),
              s !== null && (Iu(a, s, t, e), pl(s, 2), Yl(s)));
            break;
          }
        }
        t = t.return;
      }
  }
  function Uc(e, t, a) {
    var s = e.pingCache;
    if (s === null) {
      s = e.pingCache = new Lf();
      var n = new Set();
      s.set(t, n);
    } else ((n = s.get(t)), n === void 0 && ((n = new Set()), s.set(t, n)));
    n.has(a) ||
      ((Ac = !0), n.add(a), (e = Rf.bind(null, e, t, a)), t.then(e, e));
  }
  function Rf(e, t, a) {
    var s = e.pingCache;
    (s !== null && s.delete(t),
      (e.pingedLanes |= e.suspendedLanes & a),
      (e.warmLanes &= ~a),
      rt === e &&
        (Le & a) === a &&
        (wt === 4 || (wt === 3 && (Le & 62914560) === Le && 300 > we() - Bo)
          ? (Fe & 2) === 0 && $n(e, 0)
          : (Tc |= a),
        Fn === Le && (Fn = 0)),
      Yl(e));
  }
  function Y0(e, t) {
    (t === 0 && (t = xl()), (e = ln(e, t)), e !== null && (pl(e, t), Yl(e)));
  }
  function Gf(e) {
    var t = e.memoizedState,
      a = 0;
    (t !== null && (a = t.retryLane), Y0(e, a));
  }
  function Hf(e, t) {
    var a = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var s = e.stateNode,
          n = e.memoizedState;
        n !== null && (a = n.retryLane);
        break;
      case 19:
        s = e.stateNode;
        break;
      case 22:
        s = e.stateNode._retryCache;
        break;
      default:
        throw Error(h(314));
    }
    (s !== null && s.delete(t), Y0(e, a));
  }
  function Xf(e, t) {
    return _e(e, t);
  }
  var Xo = null,
    Kn = null,
    Mc = !1,
    Yo = !1,
    Rc = !1,
    Gs = 0;
  function Yl(e) {
    (e !== Kn &&
      e.next === null &&
      (Kn === null ? (Xo = Kn = e) : (Kn = Kn.next = e)),
      (Yo = !0),
      Mc || ((Mc = !0), If()));
  }
  function Rr(e, t) {
    if (!Rc && Yo) {
      Rc = !0;
      do
        for (var a = !1, s = Xo; s !== null;) {
          if (e !== 0) {
            var n = s.pendingLanes;
            if (n === 0) var r = 0;
            else {
              var o = s.suspendedLanes,
                c = s.pingedLanes;
              ((r = (1 << (31 - zt(42 | e) + 1)) - 1),
                (r &= n & ~(o & ~c)),
                (r = r & 201326741 ? (r & 201326741) | 1 : r ? r | 2 : 0));
            }
            r !== 0 && ((a = !0), V0(s, r));
          } else
            ((r = Le),
              (r = Ja(
                s,
                s === rt ? r : 0,
                s.cancelPendingCommit !== null || s.timeoutHandle !== -1,
              )),
              (r & 3) === 0 || Wa(s, r) || ((a = !0), V0(s, r)));
          s = s.next;
        }
      while (a);
      Rc = !1;
    }
  }
  function Yf() {
    I0();
  }
  function I0() {
    Yo = Mc = !1;
    var e = 0;
    Gs !== 0 && Pf() && (e = Gs);
    for (var t = we(), a = null, s = Xo; s !== null;) {
      var n = s.next,
        r = q0(s, t);
      (r === 0
        ? ((s.next = null),
          a === null ? (Xo = n) : (a.next = n),
          n === null && (Kn = a))
        : ((a = s), (e !== 0 || (r & 3) !== 0) && (Yo = !0)),
        (s = n));
    }
    ((Ft !== 0 && Ft !== 5) || Rr(e), Gs !== 0 && (Gs = 0));
  }
  function q0(e, t) {
    for (
      var a = e.suspendedLanes,
        s = e.pingedLanes,
        n = e.expirationTimes,
        r = e.pendingLanes & -62914561;
      0 < r;
    ) {
      var o = 31 - zt(r),
        c = 1 << o,
        u = n[o];
      (u === -1
        ? ((c & a) === 0 || (c & s) !== 0) && (n[o] = Pa(c, t))
        : u <= t && (e.expiredLanes |= c),
        (r &= ~c));
    }
    if (
      ((t = rt),
      (a = Le),
      (a = Ja(
        e,
        e === t ? a : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== -1,
      )),
      (s = e.callbackNode),
      a === 0 ||
        (e === t && (Je === 2 || Je === 9)) ||
        e.cancelPendingCommit !== null)
    )
      return (
        s !== null && s !== null && ht(s),
        (e.callbackNode = null),
        (e.callbackPriority = 0)
      );
    if ((a & 3) === 0 || Wa(e, a)) {
      if (((t = a & -a), t === e.callbackPriority)) return t;
      switch ((s !== null && ht(s), Fl(a))) {
        case 2:
        case 8:
          a = da;
          break;
        case 32:
          a = Aa;
          break;
        case 268435456:
          a = bs;
          break;
        default:
          a = Aa;
      }
      return (
        (s = F0.bind(null, e)),
        (a = _e(a, s)),
        (e.callbackPriority = t),
        (e.callbackNode = a),
        t
      );
    }
    return (
      s !== null && s !== null && ht(s),
      (e.callbackPriority = 2),
      (e.callbackNode = null),
      2
    );
  }
  function F0(e, t) {
    if (Ft !== 0 && Ft !== 5)
      return ((e.callbackNode = null), (e.callbackPriority = 0), null);
    var a = e.callbackNode;
    if (Ho() && e.callbackNode !== a) return null;
    var s = Le;
    return (
      (s = Ja(
        e,
        e === rt ? s : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== -1,
      )),
      s === 0
        ? null
        : (S0(e, s, t),
          q0(e, we()),
          e.callbackNode != null && e.callbackNode === a
            ? F0.bind(null, e)
            : null)
    );
  }
  function V0(e, t) {
    if (Ho()) return null;
    S0(e, t, !0);
  }
  function If() {
    tp(function () {
      (Fe & 6) !== 0 ? _e(Qe, Yf) : I0();
    });
  }
  function Gc() {
    if (Gs === 0) {
      var e = Bn;
      (e === 0 && ((e = Ka), (Ka <<= 1), (Ka & 261888) === 0 && (Ka = 256)),
        (Gs = e));
    }
    return Gs;
  }
  function $0(e) {
    return e == null || typeof e == "symbol" || typeof e == "boolean"
      ? null
      : typeof e == "function"
        ? e
        : kl("" + e);
  }
  function Q0(e, t) {
    var a = t.ownerDocument.createElement("input");
    return (
      (a.name = t.name),
      (a.value = t.value),
      e.id && a.setAttribute("form", e.id),
      t.parentNode.insertBefore(a, t),
      (e = new FormData(e)),
      a.parentNode.removeChild(a),
      e
    );
  }
  function qf(e, t, a, s, n) {
    if (t === "submit" && a && a.stateNode === n) {
      var r = $0((n[Bt] || null).action),
        o = s.submitter;
      o &&
        ((t = (t = o[Bt] || null)
          ? $0(t.formAction)
          : o.getAttribute("formAction")),
        t !== null && ((r = t), (o = null)));
      var c = new Cl("action", "action", null, s, n);
      e.push({
        event: c,
        listeners: [
          {
            instance: null,
            listener: function () {
              if (s.defaultPrevented) {
                if (Gs !== 0) {
                  var u = o ? Q0(n, o) : new FormData(n);
                  nc(
                    a,
                    { pending: !0, data: u, method: n.method, action: r },
                    null,
                    u,
                  );
                }
              } else
                typeof r == "function" &&
                  (c.preventDefault(),
                  (u = o ? Q0(n, o) : new FormData(n)),
                  nc(
                    a,
                    { pending: !0, data: u, method: n.method, action: r },
                    r,
                    u,
                  ));
            },
            currentTarget: n,
          },
        ],
      });
    }
  }
  for (var Hc = 0; Hc < ji.length; Hc++) {
    var Xc = ji[Hc],
      Ff = Xc.toLowerCase(),
      Vf = Xc[0].toUpperCase() + Xc.slice(1);
    _l(Ff, "on" + Vf);
  }
  (_l(Cd, "onAnimationEnd"),
    _l(Sd, "onAnimationIteration"),
    _l(Ed, "onAnimationStart"),
    _l("dblclick", "onDoubleClick"),
    _l("focusin", "onFocus"),
    _l("focusout", "onBlur"),
    _l(of, "onTransitionRun"),
    _l(cf, "onTransitionStart"),
    _l(df, "onTransitionCancel"),
    _l(Ad, "onTransitionEnd"),
    xa("onMouseEnter", ["mouseout", "mouseover"]),
    xa("onMouseLeave", ["mouseout", "mouseover"]),
    xa("onPointerEnter", ["pointerout", "pointerover"]),
    xa("onPointerLeave", ["pointerout", "pointerover"]),
    It(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " ",
      ),
    ),
    It(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " ",
      ),
    ),
    It("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
    It(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" "),
    ),
    It(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" "),
    ),
    It(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" "),
    ));
  var Gr =
      "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
        " ",
      ),
    $f = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle"
        .split(" ")
        .concat(Gr),
    );
  function K0(e, t) {
    t = (t & 4) !== 0;
    for (var a = 0; a < e.length; a++) {
      var s = e[a],
        n = s.event;
      s = s.listeners;
      e: {
        var r = void 0;
        if (t)
          for (var o = s.length - 1; 0 <= o; o--) {
            var c = s[o],
              u = c.instance,
              w = c.currentTarget;
            if (((c = c.listener), u !== r && n.isPropagationStopped()))
              break e;
            ((r = c), (n.currentTarget = w));
            try {
              r(n);
            } catch (T) {
              ao(T);
            }
            ((n.currentTarget = null), (r = u));
          }
        else
          for (o = 0; o < s.length; o++) {
            if (
              ((c = s[o]),
              (u = c.instance),
              (w = c.currentTarget),
              (c = c.listener),
              u !== r && n.isPropagationStopped())
            )
              break e;
            ((r = c), (n.currentTarget = w));
            try {
              r(n);
            } catch (T) {
              ao(T);
            }
            ((n.currentTarget = null), (r = u));
          }
      }
    }
  }
  function ze(e, t) {
    var a = t[bl];
    a === void 0 && (a = t[bl] = new Set());
    var s = e + "__bubble";
    a.has(s) || (Z0(t, e, 2, !1), a.add(s));
  }
  function Yc(e, t, a) {
    var s = 0;
    (t && (s |= 4), Z0(a, e, s, t));
  }
  var Io = "_reactListening" + Math.random().toString(36).slice(2);
  function Ic(e) {
    if (!e[Io]) {
      ((e[Io] = !0),
        tl.forEach(function (a) {
          a !== "selectionchange" && ($f.has(a) || Yc(a, !1, e), Yc(a, !0, e));
        }));
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[Io] || ((t[Io] = !0), Yc("selectionchange", !1, t));
    }
  }
  function Z0(e, t, a, s) {
    switch (Cx(t)) {
      case 2:
        var n = wp;
        break;
      case 8:
        n = jp;
        break;
      default:
        n = sd;
    }
    ((a = n.bind(null, t, a, e)),
      (n = void 0),
      !K ||
        (t !== "touchstart" && t !== "touchmove" && t !== "wheel") ||
        (n = !0),
      s
        ? n !== void 0
          ? e.addEventListener(t, a, { capture: !0, passive: n })
          : e.addEventListener(t, a, !0)
        : n !== void 0
          ? e.addEventListener(t, a, { passive: n })
          : e.addEventListener(t, a, !1));
  }
  function qc(e, t, a, s, n) {
    var r = s;
    if ((t & 1) === 0 && (t & 2) === 0 && s !== null)
      e: for (;;) {
        if (s === null) return;
        var o = s.tag;
        if (o === 3 || o === 4) {
          var c = s.stateNode.containerInfo;
          if (c === n) break;
          if (o === 4)
            for (o = s.return; o !== null;) {
              var u = o.tag;
              if ((u === 3 || u === 4) && o.stateNode.containerInfo === n)
                return;
              o = o.return;
            }
          for (; c !== null;) {
            if (((o = ea(c)), o === null)) return;
            if (((u = o.tag), u === 5 || u === 6 || u === 26 || u === 27)) {
              s = r = o;
              continue e;
            }
            c = c.parentNode;
          }
        }
        s = s.return;
      }
    E(function () {
      var w = r,
        T = za(a),
        L = [];
      e: {
        var N = Td.get(e);
        if (N !== void 0) {
          var k = Cl,
            P = e;
          switch (e) {
            case "keypress":
              if (Tt(a) === 0) break e;
            case "keydown":
            case "keyup":
              k = Pr;
              break;
            case "focusin":
              ((P = "focus"), (k = sr));
              break;
            case "focusout":
              ((P = "blur"), (k = sr));
              break;
            case "beforeblur":
            case "afterblur":
              k = sr;
              break;
            case "click":
              if (a.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              k = Ks;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              k = Al;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              k = Ua;
              break;
            case Cd:
            case Sd:
            case Ed:
              k = Wr;
              break;
            case Ad:
              k = Ws;
              break;
            case "scroll":
            case "scrollend":
              k = Sl;
              break;
            case "wheel":
              k = mi;
              break;
            case "copy":
            case "cut":
            case "paste":
              k = Jl;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              k = or;
              break;
            case "toggle":
            case "beforetoggle":
              k = ja;
          }
          var be = (t & 4) !== 0,
            lt = !be && (e === "scroll" || e === "scrollend"),
            g = be ? (N !== null ? N + "Capture" : null) : N;
          be = [];
          for (var m = w, v; m !== null;) {
            var z = m;
            if (
              ((v = z.stateNode),
              (z = z.tag),
              (z !== 5 && z !== 26 && z !== 27) ||
                v === null ||
                g === null ||
                ((z = Z(m, g)), z != null && be.push(Hr(m, z, v))),
              lt)
            )
              break;
            m = m.return;
          }
          0 < be.length &&
            ((N = new k(N, P, null, a, T)),
            L.push({ event: N, listeners: be }));
        }
      }
      if ((t & 7) === 0) {
        e: {
          if (
            ((N = e === "mouseover" || e === "pointerover"),
            (k = e === "mouseout" || e === "pointerout"),
            N &&
              a !== Ul &&
              (P = a.relatedTarget || a.fromElement) &&
              (ea(P) || P[Pt]))
          )
            break e;
          if (
            (k || N) &&
            ((N =
              T.window === T
                ? T
                : (N = T.ownerDocument)
                  ? N.defaultView || N.parentWindow
                  : window),
            k
              ? ((P = a.relatedTarget || a.toElement),
                (k = w),
                (P = P ? ea(P) : null),
                P !== null &&
                  ((lt = j(P)),
                  (be = P.tag),
                  P !== lt || (be !== 5 && be !== 27 && be !== 6)) &&
                  (P = null))
              : ((k = null), (P = w)),
            k !== P)
          ) {
            if (
              ((be = Ks),
              (z = "onMouseLeave"),
              (g = "onMouseEnter"),
              (m = "mouse"),
              (e === "pointerout" || e === "pointerover") &&
                ((be = or),
                (z = "onPointerLeave"),
                (g = "onPointerEnter"),
                (m = "pointer")),
              (lt = k == null ? N : ua(k)),
              (v = P == null ? N : ua(P)),
              (N = new be(z, m + "leave", k, a, T)),
              (N.target = lt),
              (N.relatedTarget = v),
              (z = null),
              ea(T) === w &&
                ((be = new be(g, m + "enter", P, a, T)),
                (be.target = v),
                (be.relatedTarget = lt),
                (z = be)),
              (lt = z),
              k && P)
            )
              t: {
                for (be = Qf, g = k, m = P, v = 0, z = g; z; z = be(z)) v++;
                z = 0;
                for (var fe = m; fe; fe = be(fe)) z++;
                for (; 0 < v - z;) ((g = be(g)), v--);
                for (; 0 < z - v;) ((m = be(m)), z--);
                for (; v--;) {
                  if (g === m || (m !== null && g === m.alternate)) {
                    be = g;
                    break t;
                  }
                  ((g = be(g)), (m = be(m)));
                }
                be = null;
              }
            else be = null;
            (k !== null && J0(L, N, k, be, !1),
              P !== null && lt !== null && J0(L, lt, P, be, !0));
          }
        }
        e: {
          if (
            ((N = w ? ua(w) : window),
            (k = N.nodeName && N.nodeName.toLowerCase()),
            k === "select" || (k === "input" && N.type === "file"))
          )
            var Xe = i;
          else if (fr(N))
            if (B) Xe = Tl;
            else {
              Xe = ca;
              var ae = Zt;
            }
          else
            ((k = N.nodeName),
              !k ||
              k.toLowerCase() !== "input" ||
              (N.type !== "checkbox" && N.type !== "radio")
                ? w && Qs(w.elementType) && (Xe = i)
                : (Xe = Ot));
          if (Xe && (Xe = Xe(e, w))) {
            kn(L, Xe, a, T);
            break e;
          }
          (ae && ae(e, N, w),
            e === "focusout" &&
              w &&
              N.type === "number" &&
              w.memoizedProps.value != null &&
              jl(N, "number", N.value));
        }
        switch (((ae = w ? ua(w) : window), e)) {
          case "focusin":
            (fr(ae) || ae.contentEditable === "true") &&
              ((Sn = ae), (vi = w), (mr = null));
            break;
          case "focusout":
            mr = vi = Sn = null;
            break;
          case "mousedown":
            yi = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ((yi = !1), Nd(L, a, T));
            break;
          case "selectionchange":
            if (rf) break;
          case "keydown":
          case "keyup":
            Nd(L, a, T);
        }
        var Se;
        if (Nn)
          e: {
            switch (e) {
              case "compositionstart":
                var Be = "onCompositionStart";
                break e;
              case "compositionend":
                Be = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Be = "onCompositionUpdate";
                break e;
            }
            Be = void 0;
          }
        else
          Pl
            ? ur(e, a) && (Be = "onCompositionEnd")
            : e === "keydown" &&
              a.keyCode === 229 &&
              (Be = "onCompositionStart");
        (Be &&
          (en &&
            a.locale !== "ko" &&
            (Pl || Be !== "onCompositionStart"
              ? Be === "onCompositionEnd" && Pl && (Se = pa())
              : ((ce = T),
                (he = "value" in ce ? ce.value : ce.textContent),
                (Pl = !0))),
          (ae = qo(w, Be)),
          0 < ae.length &&
            ((Be = new Ns(Be, e, null, a, T)),
            L.push({ event: Be, listeners: ae }),
            Se
              ? (Be.data = Se)
              : ((Se = xr(a)), Se !== null && (Be.data = Se)))),
          (Se = Rl ? Kt(e, a) : to(e, a)) &&
            ((Be = qo(w, "onBeforeInput")),
            0 < Be.length &&
              ((ae = new Ns("onBeforeInput", "beforeinput", null, a, T)),
              L.push({ event: ae, listeners: Be }),
              (ae.data = Se))),
          qf(L, e, w, a, T));
      }
      K0(L, t);
    });
  }
  function Hr(e, t, a) {
    return { instance: e, listener: t, currentTarget: a };
  }
  function qo(e, t) {
    for (var a = t + "Capture", s = []; e !== null;) {
      var n = e,
        r = n.stateNode;
      if (
        ((n = n.tag),
        (n !== 5 && n !== 26 && n !== 27) ||
          r === null ||
          ((n = Z(e, a)),
          n != null && s.unshift(Hr(e, n, r)),
          (n = Z(e, t)),
          n != null && s.push(Hr(e, n, r))),
        e.tag === 3)
      )
        return s;
      e = e.return;
    }
    return [];
  }
  function Qf(e) {
    if (e === null) return null;
    do e = e.return;
    while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function J0(e, t, a, s, n) {
    for (var r = t._reactName, o = []; a !== null && a !== s;) {
      var c = a,
        u = c.alternate,
        w = c.stateNode;
      if (((c = c.tag), u !== null && u === s)) break;
      ((c !== 5 && c !== 26 && c !== 27) ||
        w === null ||
        ((u = w),
        n
          ? ((w = Z(a, r)), w != null && o.unshift(Hr(a, w, u)))
          : n || ((w = Z(a, r)), w != null && o.push(Hr(a, w, u)))),
        (a = a.return));
    }
    o.length !== 0 && e.push({ event: t, listeners: o });
  }
  var Kf = /\r\n?/g,
    Zf = /\u0000|\uFFFD/g;
  function W0(e) {
    return (typeof e == "string" ? e : "" + e)
      .replace(
        Kf,
        `
`,
      )
      .replace(Zf, "");
  }
  function P0(e, t) {
    return ((t = W0(t)), W0(e) === t);
  }
  function at(e, t, a, s, n, r) {
    switch (a) {
      case "children":
        typeof s == "string"
          ? t === "body" || (t === "textarea" && s === "") || Nl(e, s)
          : (typeof s == "number" || typeof s == "bigint") &&
            t !== "body" &&
            Nl(e, "" + s);
        break;
      case "className":
        $l(e, "class", s);
        break;
      case "tabIndex":
        $l(e, "tabindex", s);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        $l(e, a, s);
        break;
      case "style":
        wn(e, s, r);
        break;
      case "data":
        if (t !== "object") {
          $l(e, "data", s);
          break;
        }
      case "src":
      case "href":
        if (s === "" && (t !== "a" || a !== "href")) {
          e.removeAttribute(a);
          break;
        }
        if (
          s == null ||
          typeof s == "function" ||
          typeof s == "symbol" ||
          typeof s == "boolean"
        ) {
          e.removeAttribute(a);
          break;
        }
        ((s = kl("" + s)), e.setAttribute(a, s));
        break;
      case "action":
      case "formAction":
        if (typeof s == "function") {
          e.setAttribute(
            a,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')",
          );
          break;
        } else
          typeof r == "function" &&
            (a === "formAction"
              ? (t !== "input" && at(e, t, "name", n.name, n, null),
                at(e, t, "formEncType", n.formEncType, n, null),
                at(e, t, "formMethod", n.formMethod, n, null),
                at(e, t, "formTarget", n.formTarget, n, null))
              : (at(e, t, "encType", n.encType, n, null),
                at(e, t, "method", n.method, n, null),
                at(e, t, "target", n.target, n, null)));
        if (s == null || typeof s == "symbol" || typeof s == "boolean") {
          e.removeAttribute(a);
          break;
        }
        ((s = kl("" + s)), e.setAttribute(a, s));
        break;
      case "onClick":
        s != null && (e.onclick = Da);
        break;
      case "onScroll":
        s != null && ze("scroll", e);
        break;
      case "onScrollEnd":
        s != null && ze("scrollend", e);
        break;
      case "dangerouslySetInnerHTML":
        if (s != null) {
          if (typeof s != "object" || !("__html" in s)) throw Error(h(61));
          if (((a = s.__html), a != null)) {
            if (n.children != null) throw Error(h(60));
            e.innerHTML = a;
          }
        }
        break;
      case "multiple":
        e.multiple = s && typeof s != "function" && typeof s != "symbol";
        break;
      case "muted":
        e.muted = s && typeof s != "function" && typeof s != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (
          s == null ||
          typeof s == "function" ||
          typeof s == "boolean" ||
          typeof s == "symbol"
        ) {
          e.removeAttribute("xlink:href");
          break;
        }
        ((a = kl("" + s)),
          e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", a));
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        s != null && typeof s != "function" && typeof s != "symbol"
          ? e.setAttribute(a, "" + s)
          : e.removeAttribute(a);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        s && typeof s != "function" && typeof s != "symbol"
          ? e.setAttribute(a, "")
          : e.removeAttribute(a);
        break;
      case "capture":
      case "download":
        s === !0
          ? e.setAttribute(a, "")
          : s !== !1 &&
              s != null &&
              typeof s != "function" &&
              typeof s != "symbol"
            ? e.setAttribute(a, s)
            : e.removeAttribute(a);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        s != null &&
        typeof s != "function" &&
        typeof s != "symbol" &&
        !isNaN(s) &&
        1 <= s
          ? e.setAttribute(a, s)
          : e.removeAttribute(a);
        break;
      case "rowSpan":
      case "start":
        s == null || typeof s == "function" || typeof s == "symbol" || isNaN(s)
          ? e.removeAttribute(a)
          : e.setAttribute(a, s);
        break;
      case "popover":
        (ze("beforetoggle", e), ze("toggle", e), Qt(e, "popover", s));
        break;
      case "xlinkActuate":
        fa(e, "http://www.w3.org/1999/xlink", "xlink:actuate", s);
        break;
      case "xlinkArcrole":
        fa(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", s);
        break;
      case "xlinkRole":
        fa(e, "http://www.w3.org/1999/xlink", "xlink:role", s);
        break;
      case "xlinkShow":
        fa(e, "http://www.w3.org/1999/xlink", "xlink:show", s);
        break;
      case "xlinkTitle":
        fa(e, "http://www.w3.org/1999/xlink", "xlink:title", s);
        break;
      case "xlinkType":
        fa(e, "http://www.w3.org/1999/xlink", "xlink:type", s);
        break;
      case "xmlBase":
        fa(e, "http://www.w3.org/XML/1998/namespace", "xml:base", s);
        break;
      case "xmlLang":
        fa(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", s);
        break;
      case "xmlSpace":
        fa(e, "http://www.w3.org/XML/1998/namespace", "xml:space", s);
        break;
      case "is":
        Qt(e, "is", s);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < a.length) ||
          (a[0] !== "o" && a[0] !== "O") ||
          (a[1] !== "n" && a[1] !== "N")) &&
          ((a = _a.get(a) || a), Qt(e, a, s));
    }
  }
  function Fc(e, t, a, s, n, r) {
    switch (a) {
      case "style":
        wn(e, s, r);
        break;
      case "dangerouslySetInnerHTML":
        if (s != null) {
          if (typeof s != "object" || !("__html" in s)) throw Error(h(61));
          if (((a = s.__html), a != null)) {
            if (n.children != null) throw Error(h(60));
            e.innerHTML = a;
          }
        }
        break;
      case "children":
        typeof s == "string"
          ? Nl(e, s)
          : (typeof s == "number" || typeof s == "bigint") && Nl(e, "" + s);
        break;
      case "onScroll":
        s != null && ze("scroll", e);
        break;
      case "onScrollEnd":
        s != null && ze("scrollend", e);
        break;
      case "onClick":
        s != null && (e.onclick = Da);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!vl.hasOwnProperty(a))
          e: {
            if (
              a[0] === "o" &&
              a[1] === "n" &&
              ((n = a.endsWith("Capture")),
              (t = a.slice(2, n ? a.length - 7 : void 0)),
              (r = e[Bt] || null),
              (r = r != null ? r[a] : null),
              typeof r == "function" && e.removeEventListener(t, r, n),
              typeof s == "function")
            ) {
              (typeof r != "function" &&
                r !== null &&
                (a in e
                  ? (e[a] = null)
                  : e.hasAttribute(a) && e.removeAttribute(a)),
                e.addEventListener(t, s, n));
              break e;
            }
            a in e
              ? (e[a] = s)
              : s === !0
                ? e.setAttribute(a, "")
                : Qt(e, a, s);
          }
    }
  }
  function oa(e, t, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        (ze("error", e), ze("load", e));
        var s = !1,
          n = !1,
          r;
        for (r in a)
          if (a.hasOwnProperty(r)) {
            var o = a[r];
            if (o != null)
              switch (r) {
                case "src":
                  s = !0;
                  break;
                case "srcSet":
                  n = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(h(137, t));
                default:
                  at(e, t, r, o, a, null);
              }
          }
        (n && at(e, t, "srcSet", a.srcSet, a, null),
          s && at(e, t, "src", a.src, a, null));
        return;
      case "input":
        ze("invalid", e);
        var c = (r = o = n = null),
          u = null,
          w = null;
        for (s in a)
          if (a.hasOwnProperty(s)) {
            var T = a[s];
            if (T != null)
              switch (s) {
                case "name":
                  n = T;
                  break;
                case "type":
                  o = T;
                  break;
                case "checked":
                  u = T;
                  break;
                case "defaultChecked":
                  w = T;
                  break;
                case "value":
                  r = T;
                  break;
                case "defaultValue":
                  c = T;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (T != null) throw Error(h(137, t));
                  break;
                default:
                  at(e, t, s, T, a, null);
              }
          }
        yn(e, r, c, u, w, o, n, !1);
        return;
      case "select":
        (ze("invalid", e), (s = o = r = null));
        for (n in a)
          if (a.hasOwnProperty(n) && ((c = a[n]), c != null))
            switch (n) {
              case "value":
                r = c;
                break;
              case "defaultValue":
                o = c;
                break;
              case "multiple":
                s = c;
              default:
                at(e, t, n, c, a, null);
            }
        ((t = r),
          (a = o),
          (e.multiple = !!s),
          t != null ? aa(e, !!s, t, !1) : a != null && aa(e, !!s, a, !0));
        return;
      case "textarea":
        (ze("invalid", e), (r = n = s = null));
        for (o in a)
          if (a.hasOwnProperty(o) && ((c = a[o]), c != null))
            switch (o) {
              case "value":
                s = c;
                break;
              case "defaultValue":
                n = c;
                break;
              case "children":
                r = c;
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(h(91));
                break;
              default:
                at(e, t, o, c, a, null);
            }
        Ql(e, s, n, r);
        return;
      case "option":
        for (u in a)
          if (a.hasOwnProperty(u) && ((s = a[u]), s != null))
            switch (u) {
              case "selected":
                e.selected =
                  s && typeof s != "function" && typeof s != "symbol";
                break;
              default:
                at(e, t, u, s, a, null);
            }
        return;
      case "dialog":
        (ze("beforetoggle", e),
          ze("toggle", e),
          ze("cancel", e),
          ze("close", e));
        break;
      case "iframe":
      case "object":
        ze("load", e);
        break;
      case "video":
      case "audio":
        for (s = 0; s < Gr.length; s++) ze(Gr[s], e);
        break;
      case "image":
        (ze("error", e), ze("load", e));
        break;
      case "details":
        ze("toggle", e);
        break;
      case "embed":
      case "source":
      case "link":
        (ze("error", e), ze("load", e));
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (w in a)
          if (a.hasOwnProperty(w) && ((s = a[w]), s != null))
            switch (w) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(h(137, t));
              default:
                at(e, t, w, s, a, null);
            }
        return;
      default:
        if (Qs(t)) {
          for (T in a)
            a.hasOwnProperty(T) &&
              ((s = a[T]), s !== void 0 && Fc(e, t, T, s, a, void 0));
          return;
        }
    }
    for (c in a)
      a.hasOwnProperty(c) && ((s = a[c]), s != null && at(e, t, c, s, a, null));
  }
  function Jf(e, t, a, s) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var n = null,
          r = null,
          o = null,
          c = null,
          u = null,
          w = null,
          T = null;
        for (k in a) {
          var L = a[k];
          if (a.hasOwnProperty(k) && L != null)
            switch (k) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                u = L;
              default:
                s.hasOwnProperty(k) || at(e, t, k, null, s, L);
            }
        }
        for (var N in s) {
          var k = s[N];
          if (((L = a[N]), s.hasOwnProperty(N) && (k != null || L != null)))
            switch (N) {
              case "type":
                r = k;
                break;
              case "name":
                n = k;
                break;
              case "checked":
                w = k;
                break;
              case "defaultChecked":
                T = k;
                break;
              case "value":
                o = k;
                break;
              case "defaultValue":
                c = k;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (k != null) throw Error(h(137, t));
                break;
              default:
                k !== L && at(e, t, N, k, s, L);
            }
        }
        ta(e, o, c, u, w, T, r, n);
        return;
      case "select":
        k = o = c = N = null;
        for (r in a)
          if (((u = a[r]), a.hasOwnProperty(r) && u != null))
            switch (r) {
              case "value":
                break;
              case "multiple":
                k = u;
              default:
                s.hasOwnProperty(r) || at(e, t, r, null, s, u);
            }
        for (n in s)
          if (
            ((r = s[n]),
            (u = a[n]),
            s.hasOwnProperty(n) && (r != null || u != null))
          )
            switch (n) {
              case "value":
                N = r;
                break;
              case "defaultValue":
                c = r;
                break;
              case "multiple":
                o = r;
              default:
                r !== u && at(e, t, n, r, s, u);
            }
        ((t = c),
          (a = o),
          (s = k),
          N != null
            ? aa(e, !!a, N, !1)
            : !!s != !!a &&
              (t != null ? aa(e, !!a, t, !0) : aa(e, !!a, a ? [] : "", !1)));
        return;
      case "textarea":
        k = N = null;
        for (c in a)
          if (
            ((n = a[c]),
            a.hasOwnProperty(c) && n != null && !s.hasOwnProperty(c))
          )
            switch (c) {
              case "value":
                break;
              case "children":
                break;
              default:
                at(e, t, c, null, s, n);
            }
        for (o in s)
          if (
            ((n = s[o]),
            (r = a[o]),
            s.hasOwnProperty(o) && (n != null || r != null))
          )
            switch (o) {
              case "value":
                N = n;
                break;
              case "defaultValue":
                k = n;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (n != null) throw Error(h(91));
                break;
              default:
                n !== r && at(e, t, o, n, s, r);
            }
        ya(e, N, k);
        return;
      case "option":
        for (var P in a)
          if (
            ((N = a[P]),
            a.hasOwnProperty(P) && N != null && !s.hasOwnProperty(P))
          )
            switch (P) {
              case "selected":
                e.selected = !1;
                break;
              default:
                at(e, t, P, null, s, N);
            }
        for (u in s)
          if (
            ((N = s[u]),
            (k = a[u]),
            s.hasOwnProperty(u) && N !== k && (N != null || k != null))
          )
            switch (u) {
              case "selected":
                e.selected =
                  N && typeof N != "function" && typeof N != "symbol";
                break;
              default:
                at(e, t, u, N, s, k);
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var be in a)
          ((N = a[be]),
            a.hasOwnProperty(be) &&
              N != null &&
              !s.hasOwnProperty(be) &&
              at(e, t, be, null, s, N));
        for (w in s)
          if (
            ((N = s[w]),
            (k = a[w]),
            s.hasOwnProperty(w) && N !== k && (N != null || k != null))
          )
            switch (w) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (N != null) throw Error(h(137, t));
                break;
              default:
                at(e, t, w, N, s, k);
            }
        return;
      default:
        if (Qs(t)) {
          for (var lt in a)
            ((N = a[lt]),
              a.hasOwnProperty(lt) &&
                N !== void 0 &&
                !s.hasOwnProperty(lt) &&
                Fc(e, t, lt, void 0, s, N));
          for (T in s)
            ((N = s[T]),
              (k = a[T]),
              !s.hasOwnProperty(T) ||
                N === k ||
                (N === void 0 && k === void 0) ||
                Fc(e, t, T, N, s, k));
          return;
        }
    }
    for (var g in a)
      ((N = a[g]),
        a.hasOwnProperty(g) &&
          N != null &&
          !s.hasOwnProperty(g) &&
          at(e, t, g, null, s, N));
    for (L in s)
      ((N = s[L]),
        (k = a[L]),
        !s.hasOwnProperty(L) ||
          N === k ||
          (N == null && k == null) ||
          at(e, t, L, N, s, k));
  }
  function ex(e) {
    switch (e) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Wf() {
    if (typeof performance.getEntriesByType == "function") {
      for (
        var e = 0, t = 0, a = performance.getEntriesByType("resource"), s = 0;
        s < a.length;
        s++
      ) {
        var n = a[s],
          r = n.transferSize,
          o = n.initiatorType,
          c = n.duration;
        if (r && c && ex(o)) {
          for (o = 0, c = n.responseEnd, s += 1; s < a.length; s++) {
            var u = a[s],
              w = u.startTime;
            if (w > c) break;
            var T = u.transferSize,
              L = u.initiatorType;
            T &&
              ex(L) &&
              ((u = u.responseEnd), (o += T * (u < c ? 1 : (c - w) / (u - w))));
          }
          if ((--s, (t += (8 * (r + o)) / (n.duration / 1e3)), e++, 10 < e))
            break;
        }
      }
      if (0 < e) return t / e / 1e6;
    }
    return navigator.connection &&
      ((e = navigator.connection.downlink), typeof e == "number")
      ? e
      : 5;
  }
  var Vc = null,
    $c = null;
  function Fo(e) {
    return e.nodeType === 9 ? e : e.ownerDocument;
  }
  function tx(e) {
    switch (e) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function ax(e, t) {
    if (e === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return e === 1 && t === "foreignObject" ? 0 : e;
  }
  function Qc(e, t) {
    return (
      e === "textarea" ||
      e === "noscript" ||
      typeof t.children == "string" ||
      typeof t.children == "number" ||
      typeof t.children == "bigint" ||
      (typeof t.dangerouslySetInnerHTML == "object" &&
        t.dangerouslySetInnerHTML !== null &&
        t.dangerouslySetInnerHTML.__html != null)
    );
  }
  var Kc = null;
  function Pf() {
    var e = window.event;
    return e && e.type === "popstate"
      ? e === Kc
        ? !1
        : ((Kc = e), !0)
      : ((Kc = null), !1);
  }
  var lx = typeof setTimeout == "function" ? setTimeout : void 0,
    ep = typeof clearTimeout == "function" ? clearTimeout : void 0,
    sx = typeof Promise == "function" ? Promise : void 0,
    tp =
      typeof queueMicrotask == "function"
        ? queueMicrotask
        : typeof sx < "u"
          ? function (e) {
              return sx.resolve(null).then(e).catch(ap);
            }
          : lx;
  function ap(e) {
    setTimeout(function () {
      throw e;
    });
  }
  function Hs(e) {
    return e === "head";
  }
  function nx(e, t) {
    var a = t,
      s = 0;
    do {
      var n = a.nextSibling;
      if ((e.removeChild(a), n && n.nodeType === 8))
        if (((a = n.data), a === "/$" || a === "/&")) {
          if (s === 0) {
            (e.removeChild(n), Pn(t));
            return;
          }
          s--;
        } else if (
          a === "$" ||
          a === "$?" ||
          a === "$~" ||
          a === "$!" ||
          a === "&"
        )
          s++;
        else if (a === "html") Xr(e.ownerDocument.documentElement);
        else if (a === "head") {
          ((a = e.ownerDocument.head), Xr(a));
          for (var r = a.firstChild; r;) {
            var o = r.nextSibling,
              c = r.nodeName;
            (r[gl] ||
              c === "SCRIPT" ||
              c === "STYLE" ||
              (c === "LINK" && r.rel.toLowerCase() === "stylesheet") ||
              a.removeChild(r),
              (r = o));
          }
        } else a === "body" && Xr(e.ownerDocument.body);
      a = n;
    } while (a);
    Pn(t);
  }
  function rx(e, t) {
    var a = e;
    e = 0;
    do {
      var s = a.nextSibling;
      if (
        (a.nodeType === 1
          ? t
            ? ((a._stashedDisplay = a.style.display),
              (a.style.display = "none"))
            : ((a.style.display = a._stashedDisplay || ""),
              a.getAttribute("style") === "" && a.removeAttribute("style"))
          : a.nodeType === 3 &&
            (t
              ? ((a._stashedText = a.nodeValue), (a.nodeValue = ""))
              : (a.nodeValue = a._stashedText || "")),
        s && s.nodeType === 8)
      )
        if (((a = s.data), a === "/$")) {
          if (e === 0) break;
          e--;
        } else (a !== "$" && a !== "$?" && a !== "$~" && a !== "$!") || e++;
      a = s;
    } while (a);
  }
  function Zc(e) {
    var t = e.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
      var a = t;
      switch (((t = t.nextSibling), a.nodeName)) {
        case "HTML":
        case "HEAD":
        case "BODY":
          (Zc(a), qe(a));
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (a.rel.toLowerCase() === "stylesheet") continue;
      }
      e.removeChild(a);
    }
  }
  function lp(e, t, a, s) {
    for (; e.nodeType === 1;) {
      var n = a;
      if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!s && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
      } else if (s) {
        if (!e[gl])
          switch (t) {
            case "meta":
              if (!e.hasAttribute("itemprop")) break;
              return e;
            case "link":
              if (
                ((r = e.getAttribute("rel")),
                r === "stylesheet" && e.hasAttribute("data-precedence"))
              )
                break;
              if (
                r !== n.rel ||
                e.getAttribute("href") !==
                  (n.href == null || n.href === "" ? null : n.href) ||
                e.getAttribute("crossorigin") !==
                  (n.crossOrigin == null ? null : n.crossOrigin) ||
                e.getAttribute("title") !== (n.title == null ? null : n.title)
              )
                break;
              return e;
            case "style":
              if (e.hasAttribute("data-precedence")) break;
              return e;
            case "script":
              if (
                ((r = e.getAttribute("src")),
                (r !== (n.src == null ? null : n.src) ||
                  e.getAttribute("type") !== (n.type == null ? null : n.type) ||
                  e.getAttribute("crossorigin") !==
                    (n.crossOrigin == null ? null : n.crossOrigin)) &&
                  r &&
                  e.hasAttribute("async") &&
                  !e.hasAttribute("itemprop"))
              )
                break;
              return e;
            default:
              return e;
          }
      } else if (t === "input" && e.type === "hidden") {
        var r = n.name == null ? null : "" + n.name;
        if (n.type === "hidden" && e.getAttribute("name") === r) return e;
      } else return e;
      if (((e = il(e.nextSibling)), e === null)) break;
    }
    return null;
  }
  function sp(e, t, a) {
    if (t === "") return null;
    for (; e.nodeType !== 3;)
      if (
        ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") &&
          !a) ||
        ((e = il(e.nextSibling)), e === null)
      )
        return null;
    return e;
  }
  function ox(e, t) {
    for (; e.nodeType !== 8;)
      if (
        ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") &&
          !t) ||
        ((e = il(e.nextSibling)), e === null)
      )
        return null;
    return e;
  }
  function Jc(e) {
    return e.data === "$?" || e.data === "$~";
  }
  function Wc(e) {
    return (
      e.data === "$!" ||
      (e.data === "$?" && e.ownerDocument.readyState !== "loading")
    );
  }
  function np(e, t) {
    var a = e.ownerDocument;
    if (e.data === "$~") e._reactRetry = t;
    else if (e.data !== "$?" || a.readyState !== "loading") t();
    else {
      var s = function () {
        (t(), a.removeEventListener("DOMContentLoaded", s));
      };
      (a.addEventListener("DOMContentLoaded", s), (e._reactRetry = s));
    }
  }
  function il(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (
          ((t = e.data),
          t === "$" ||
            t === "$!" ||
            t === "$?" ||
            t === "$~" ||
            t === "&" ||
            t === "F!" ||
            t === "F")
        )
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return e;
  }
  var Pc = null;
  function ix(e) {
    e = e.nextSibling;
    for (var t = 0; e;) {
      if (e.nodeType === 8) {
        var a = e.data;
        if (a === "/$" || a === "/&") {
          if (t === 0) return il(e.nextSibling);
          t--;
        } else
          (a !== "$" && a !== "$!" && a !== "$?" && a !== "$~" && a !== "&") ||
            t++;
      }
      e = e.nextSibling;
    }
    return null;
  }
  function cx(e) {
    e = e.previousSibling;
    for (var t = 0; e;) {
      if (e.nodeType === 8) {
        var a = e.data;
        if (a === "$" || a === "$!" || a === "$?" || a === "$~" || a === "&") {
          if (t === 0) return e;
          t--;
        } else (a !== "/$" && a !== "/&") || t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function dx(e, t, a) {
    switch (((t = Fo(a)), e)) {
      case "html":
        if (((e = t.documentElement), !e)) throw Error(h(452));
        return e;
      case "head":
        if (((e = t.head), !e)) throw Error(h(453));
        return e;
      case "body":
        if (((e = t.body), !e)) throw Error(h(454));
        return e;
      default:
        throw Error(h(451));
    }
  }
  function Xr(e) {
    for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
    qe(e);
  }
  var cl = new Map(),
    ux = new Set();
  function Vo(e) {
    return typeof e.getRootNode == "function"
      ? e.getRootNode()
      : e.nodeType === 9
        ? e
        : e.ownerDocument;
  }
  var ps = D.d;
  D.d = { f: rp, r: op, D: ip, C: cp, L: dp, m: up, X: fp, S: xp, M: pp };
  function rp() {
    var e = ps.f(),
      t = Mo();
    return e || t;
  }
  function op(e) {
    var t = Vl(e);
    t !== null && t.tag === 5 && t.type === "form" ? Au(t) : ps.r(e);
  }
  var Zn = typeof document > "u" ? null : document;
  function xx(e, t, a) {
    var s = Zn;
    if (s && typeof t == "string" && t) {
      var n = qt(t);
      ((n = 'link[rel="' + e + '"][href="' + n + '"]'),
        typeof a == "string" && (n += '[crossorigin="' + a + '"]'),
        ux.has(n) ||
          (ux.add(n),
          (e = { rel: e, crossOrigin: a, href: t }),
          s.querySelector(n) === null &&
            ((t = s.createElement("link")),
            oa(t, "link", e),
            et(t),
            s.head.appendChild(t))));
    }
  }
  function ip(e) {
    (ps.D(e), xx("dns-prefetch", e, null));
  }
  function cp(e, t) {
    (ps.C(e, t), xx("preconnect", e, t));
  }
  function dp(e, t, a) {
    ps.L(e, t, a);
    var s = Zn;
    if (s && e && t) {
      var n = 'link[rel="preload"][as="' + qt(t) + '"]';
      t === "image" && a && a.imageSrcSet
        ? ((n += '[imagesrcset="' + qt(a.imageSrcSet) + '"]'),
          typeof a.imageSizes == "string" &&
            (n += '[imagesizes="' + qt(a.imageSizes) + '"]'))
        : (n += '[href="' + qt(e) + '"]');
      var r = n;
      switch (t) {
        case "style":
          r = Jn(e);
          break;
        case "script":
          r = Wn(e);
      }
      cl.has(r) ||
        ((e = R(
          {
            rel: "preload",
            href: t === "image" && a && a.imageSrcSet ? void 0 : e,
            as: t,
          },
          a,
        )),
        cl.set(r, e),
        s.querySelector(n) !== null ||
          (t === "style" && s.querySelector(Yr(r))) ||
          (t === "script" && s.querySelector(Ir(r))) ||
          ((t = s.createElement("link")),
          oa(t, "link", e),
          et(t),
          s.head.appendChild(t)));
    }
  }
  function up(e, t) {
    ps.m(e, t);
    var a = Zn;
    if (a && e) {
      var s = t && typeof t.as == "string" ? t.as : "script",
        n =
          'link[rel="modulepreload"][as="' + qt(s) + '"][href="' + qt(e) + '"]',
        r = n;
      switch (s) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          r = Wn(e);
      }
      if (
        !cl.has(r) &&
        ((e = R({ rel: "modulepreload", href: e }, t)),
        cl.set(r, e),
        a.querySelector(n) === null)
      ) {
        switch (s) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (a.querySelector(Ir(r))) return;
        }
        ((s = a.createElement("link")),
          oa(s, "link", e),
          et(s),
          a.head.appendChild(s));
      }
    }
  }
  function xp(e, t, a) {
    ps.S(e, t, a);
    var s = Zn;
    if (s && e) {
      var n = Et(s).hoistableStyles,
        r = Jn(e);
      t = t || "default";
      var o = n.get(r);
      if (!o) {
        var c = { loading: 0, preload: null };
        if ((o = s.querySelector(Yr(r)))) c.loading = 5;
        else {
          ((e = R({ rel: "stylesheet", href: e, "data-precedence": t }, a)),
            (a = cl.get(r)) && ed(e, a));
          var u = (o = s.createElement("link"));
          (et(u),
            oa(u, "link", e),
            (u._p = new Promise(function (w, T) {
              ((u.onload = w), (u.onerror = T));
            })),
            u.addEventListener("load", function () {
              c.loading |= 1;
            }),
            u.addEventListener("error", function () {
              c.loading |= 2;
            }),
            (c.loading |= 4),
            $o(o, t, s));
        }
        ((o = { type: "stylesheet", instance: o, count: 1, state: c }),
          n.set(r, o));
      }
    }
  }
  function fp(e, t) {
    ps.X(e, t);
    var a = Zn;
    if (a && e) {
      var s = Et(a).hoistableScripts,
        n = Wn(e),
        r = s.get(n);
      r ||
        ((r = a.querySelector(Ir(n))),
        r ||
          ((e = R({ src: e, async: !0 }, t)),
          (t = cl.get(n)) && td(e, t),
          (r = a.createElement("script")),
          et(r),
          oa(r, "link", e),
          a.head.appendChild(r)),
        (r = { type: "script", instance: r, count: 1, state: null }),
        s.set(n, r));
    }
  }
  function pp(e, t) {
    ps.M(e, t);
    var a = Zn;
    if (a && e) {
      var s = Et(a).hoistableScripts,
        n = Wn(e),
        r = s.get(n);
      r ||
        ((r = a.querySelector(Ir(n))),
        r ||
          ((e = R({ src: e, async: !0, type: "module" }, t)),
          (t = cl.get(n)) && td(e, t),
          (r = a.createElement("script")),
          et(r),
          oa(r, "link", e),
          a.head.appendChild(r)),
        (r = { type: "script", instance: r, count: 1, state: null }),
        s.set(n, r));
    }
  }
  function fx(e, t, a, s) {
    var n = (n = ie.current) ? Vo(n) : null;
    if (!n) throw Error(h(446));
    switch (e) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof a.precedence == "string" && typeof a.href == "string"
          ? ((t = Jn(a.href)),
            (a = Et(n).hoistableStyles),
            (s = a.get(t)),
            s ||
              ((s = { type: "style", instance: null, count: 0, state: null }),
              a.set(t, s)),
            s)
          : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (
          a.rel === "stylesheet" &&
          typeof a.href == "string" &&
          typeof a.precedence == "string"
        ) {
          e = Jn(a.href);
          var r = Et(n).hoistableStyles,
            o = r.get(e);
          if (
            (o ||
              ((n = n.ownerDocument || n),
              (o = {
                type: "stylesheet",
                instance: null,
                count: 0,
                state: { loading: 0, preload: null },
              }),
              r.set(e, o),
              (r = n.querySelector(Yr(e))) &&
                !r._p &&
                ((o.instance = r), (o.state.loading = 5)),
              cl.has(e) ||
                ((a = {
                  rel: "preload",
                  as: "style",
                  href: a.href,
                  crossOrigin: a.crossOrigin,
                  integrity: a.integrity,
                  media: a.media,
                  hrefLang: a.hrefLang,
                  referrerPolicy: a.referrerPolicy,
                }),
                cl.set(e, a),
                r || mp(n, e, a, o.state))),
            t && s === null)
          )
            throw Error(h(528, ""));
          return o;
        }
        if (t && s !== null) throw Error(h(529, ""));
        return null;
      case "script":
        return (
          (t = a.async),
          (a = a.src),
          typeof a == "string" &&
          t &&
          typeof t != "function" &&
          typeof t != "symbol"
            ? ((t = Wn(a)),
              (a = Et(n).hoistableScripts),
              (s = a.get(t)),
              s ||
                ((s = {
                  type: "script",
                  instance: null,
                  count: 0,
                  state: null,
                }),
                a.set(t, s)),
              s)
            : { type: "void", instance: null, count: 0, state: null }
        );
      default:
        throw Error(h(444, e));
    }
  }
  function Jn(e) {
    return 'href="' + qt(e) + '"';
  }
  function Yr(e) {
    return 'link[rel="stylesheet"][' + e + "]";
  }
  function px(e) {
    return R({}, e, { "data-precedence": e.precedence, precedence: null });
  }
  function mp(e, t, a, s) {
    e.querySelector('link[rel="preload"][as="style"][' + t + "]")
      ? (s.loading = 1)
      : ((t = e.createElement("link")),
        (s.preload = t),
        t.addEventListener("load", function () {
          return (s.loading |= 1);
        }),
        t.addEventListener("error", function () {
          return (s.loading |= 2);
        }),
        oa(t, "link", a),
        et(t),
        e.head.appendChild(t));
  }
  function Wn(e) {
    return '[src="' + qt(e) + '"]';
  }
  function Ir(e) {
    return "script[async]" + e;
  }
  function mx(e, t, a) {
    if ((t.count++, t.instance === null))
      switch (t.type) {
        case "style":
          var s = e.querySelector('style[data-href~="' + qt(a.href) + '"]');
          if (s) return ((t.instance = s), et(s), s);
          var n = R({}, a, {
            "data-href": a.href,
            "data-precedence": a.precedence,
            href: null,
            precedence: null,
          });
          return (
            (s = (e.ownerDocument || e).createElement("style")),
            et(s),
            oa(s, "style", n),
            $o(s, a.precedence, e),
            (t.instance = s)
          );
        case "stylesheet":
          n = Jn(a.href);
          var r = e.querySelector(Yr(n));
          if (r) return ((t.state.loading |= 4), (t.instance = r), et(r), r);
          ((s = px(a)),
            (n = cl.get(n)) && ed(s, n),
            (r = (e.ownerDocument || e).createElement("link")),
            et(r));
          var o = r;
          return (
            (o._p = new Promise(function (c, u) {
              ((o.onload = c), (o.onerror = u));
            })),
            oa(r, "link", s),
            (t.state.loading |= 4),
            $o(r, a.precedence, e),
            (t.instance = r)
          );
        case "script":
          return (
            (r = Wn(a.src)),
            (n = e.querySelector(Ir(r)))
              ? ((t.instance = n), et(n), n)
              : ((s = a),
                (n = cl.get(r)) && ((s = R({}, a)), td(s, n)),
                (e = e.ownerDocument || e),
                (n = e.createElement("script")),
                et(n),
                oa(n, "link", s),
                e.head.appendChild(n),
                (t.instance = n))
          );
        case "void":
          return null;
        default:
          throw Error(h(443, t.type));
      }
    else
      t.type === "stylesheet" &&
        (t.state.loading & 4) === 0 &&
        ((s = t.instance), (t.state.loading |= 4), $o(s, a.precedence, e));
    return t.instance;
  }
  function $o(e, t, a) {
    for (
      var s = a.querySelectorAll(
          'link[rel="stylesheet"][data-precedence],style[data-precedence]',
        ),
        n = s.length ? s[s.length - 1] : null,
        r = n,
        o = 0;
      o < s.length;
      o++
    ) {
      var c = s[o];
      if (c.dataset.precedence === t) r = c;
      else if (r !== n) break;
    }
    r
      ? r.parentNode.insertBefore(e, r.nextSibling)
      : ((t = a.nodeType === 9 ? a.head : a), t.insertBefore(e, t.firstChild));
  }
  function ed(e, t) {
    (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
      e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
      e.title == null && (e.title = t.title));
  }
  function td(e, t) {
    (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
      e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
      e.integrity == null && (e.integrity = t.integrity));
  }
  var Qo = null;
  function hx(e, t, a) {
    if (Qo === null) {
      var s = new Map(),
        n = (Qo = new Map());
      n.set(a, s);
    } else ((n = Qo), (s = n.get(a)), s || ((s = new Map()), n.set(a, s)));
    if (s.has(e)) return s;
    for (
      s.set(e, null), a = a.getElementsByTagName(e), n = 0;
      n < a.length;
      n++
    ) {
      var r = a[n];
      if (
        !(
          r[gl] ||
          r[ft] ||
          (e === "link" && r.getAttribute("rel") === "stylesheet")
        ) &&
        r.namespaceURI !== "http://www.w3.org/2000/svg"
      ) {
        var o = r.getAttribute(t) || "";
        o = e + o;
        var c = s.get(o);
        c ? c.push(r) : s.set(o, [r]);
      }
    }
    return s;
  }
  function bx(e, t, a) {
    ((e = e.ownerDocument || e),
      e.head.insertBefore(
        a,
        t === "title" ? e.querySelector("head > title") : null,
      ));
  }
  function hp(e, t, a) {
    if (a === 1 || t.itemProp != null) return !1;
    switch (e) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (
          typeof t.precedence != "string" ||
          typeof t.href != "string" ||
          t.href === ""
        )
          break;
        return !0;
      case "link":
        if (
          typeof t.rel != "string" ||
          typeof t.href != "string" ||
          t.href === "" ||
          t.onLoad ||
          t.onError
        )
          break;
        switch (t.rel) {
          case "stylesheet":
            return (
              (e = t.disabled),
              typeof t.precedence == "string" && e == null
            );
          default:
            return !0;
        }
      case "script":
        if (
          t.async &&
          typeof t.async != "function" &&
          typeof t.async != "symbol" &&
          !t.onLoad &&
          !t.onError &&
          t.src &&
          typeof t.src == "string"
        )
          return !0;
    }
    return !1;
  }
  function gx(e) {
    return !(e.type === "stylesheet" && (e.state.loading & 3) === 0);
  }
  function bp(e, t, a, s) {
    if (
      a.type === "stylesheet" &&
      (typeof s.media != "string" || matchMedia(s.media).matches !== !1) &&
      (a.state.loading & 4) === 0
    ) {
      if (a.instance === null) {
        var n = Jn(s.href),
          r = t.querySelector(Yr(n));
        if (r) {
          ((t = r._p),
            t !== null &&
              typeof t == "object" &&
              typeof t.then == "function" &&
              (e.count++, (e = Ko.bind(e)), t.then(e, e)),
            (a.state.loading |= 4),
            (a.instance = r),
            et(r));
          return;
        }
        ((r = t.ownerDocument || t),
          (s = px(s)),
          (n = cl.get(n)) && ed(s, n),
          (r = r.createElement("link")),
          et(r));
        var o = r;
        ((o._p = new Promise(function (c, u) {
          ((o.onload = c), (o.onerror = u));
        })),
          oa(r, "link", s),
          (a.instance = r));
      }
      (e.stylesheets === null && (e.stylesheets = new Map()),
        e.stylesheets.set(a, t),
        (t = a.state.preload) &&
          (a.state.loading & 3) === 0 &&
          (e.count++,
          (a = Ko.bind(e)),
          t.addEventListener("load", a),
          t.addEventListener("error", a)));
    }
  }
  var ad = 0;
  function gp(e, t) {
    return (
      e.stylesheets && e.count === 0 && Jo(e, e.stylesheets),
      0 < e.count || 0 < e.imgCount
        ? function (a) {
            var s = setTimeout(function () {
              if ((e.stylesheets && Jo(e, e.stylesheets), e.unsuspend)) {
                var r = e.unsuspend;
                ((e.unsuspend = null), r());
              }
            }, 6e4 + t);
            0 < e.imgBytes && ad === 0 && (ad = 62500 * Wf());
            var n = setTimeout(
              function () {
                if (
                  ((e.waitingForImages = !1),
                  e.count === 0 &&
                    (e.stylesheets && Jo(e, e.stylesheets), e.unsuspend))
                ) {
                  var r = e.unsuspend;
                  ((e.unsuspend = null), r());
                }
              },
              (e.imgBytes > ad ? 50 : 800) + t,
            );
            return (
              (e.unsuspend = a),
              function () {
                ((e.unsuspend = null), clearTimeout(s), clearTimeout(n));
              }
            );
          }
        : null
    );
  }
  function Ko() {
    if (
      (this.count--,
      this.count === 0 && (this.imgCount === 0 || !this.waitingForImages))
    ) {
      if (this.stylesheets) Jo(this, this.stylesheets);
      else if (this.unsuspend) {
        var e = this.unsuspend;
        ((this.unsuspend = null), e());
      }
    }
  }
  var Zo = null;
  function Jo(e, t) {
    ((e.stylesheets = null),
      e.unsuspend !== null &&
        (e.count++,
        (Zo = new Map()),
        t.forEach(vp, e),
        (Zo = null),
        Ko.call(e)));
  }
  function vp(e, t) {
    if (!(t.state.loading & 4)) {
      var a = Zo.get(e);
      if (a) var s = a.get(null);
      else {
        ((a = new Map()), Zo.set(e, a));
        for (
          var n = e.querySelectorAll(
              "link[data-precedence],style[data-precedence]",
            ),
            r = 0;
          r < n.length;
          r++
        ) {
          var o = n[r];
          (o.nodeName === "LINK" || o.getAttribute("media") !== "not all") &&
            (a.set(o.dataset.precedence, o), (s = o));
        }
        s && a.set(null, s);
      }
      ((n = t.instance),
        (o = n.getAttribute("data-precedence")),
        (r = a.get(o) || s),
        r === s && a.set(null, n),
        a.set(o, n),
        this.count++,
        (s = Ko.bind(this)),
        n.addEventListener("load", s),
        n.addEventListener("error", s),
        r
          ? r.parentNode.insertBefore(n, r.nextSibling)
          : ((e = e.nodeType === 9 ? e.head : e),
            e.insertBefore(n, e.firstChild)),
        (t.state.loading |= 4));
    }
  }
  var qr = {
    $$typeof: ue,
    Provider: null,
    Consumer: null,
    _currentValue: U,
    _currentValue2: U,
    _threadCount: 0,
  };
  function yp(e, t, a, s, n, r, o, c, u) {
    ((this.tag = 1),
      (this.containerInfo = e),
      (this.pingCache = this.current = this.pendingChildren = null),
      (this.timeoutHandle = -1),
      (this.callbackNode =
        this.next =
        this.pendingContext =
        this.context =
        this.cancelPendingCommit =
          null),
      (this.callbackPriority = 0),
      (this.expirationTimes = fl(-1)),
      (this.entangledLanes =
        this.shellSuspendCounter =
        this.errorRecoveryDisabledLanes =
        this.expiredLanes =
        this.warmLanes =
        this.pingedLanes =
        this.suspendedLanes =
        this.pendingLanes =
          0),
      (this.entanglements = fl(0)),
      (this.hiddenUpdates = fl(null)),
      (this.identifierPrefix = s),
      (this.onUncaughtError = n),
      (this.onCaughtError = r),
      (this.onRecoverableError = o),
      (this.pooledCache = null),
      (this.pooledCacheLanes = 0),
      (this.formState = u),
      (this.incompleteTransitions = new Map()));
  }
  function vx(e, t, a, s, n, r, o, c, u, w, T, L) {
    return (
      (e = new yp(e, t, a, o, u, w, T, L, c)),
      (t = 1),
      r === !0 && (t |= 24),
      (r = Ra(3, null, null, t)),
      (e.current = r),
      (r.stateNode = e),
      (t = Oi()),
      t.refCount++,
      (e.pooledCache = t),
      t.refCount++,
      (r.memoizedState = { element: s, isDehydrated: a, cache: t }),
      Gi(r),
      e
    );
  }
  function yx(e) {
    return e ? ((e = Tn), e) : Tn;
  }
  function wx(e, t, a, s, n, r) {
    ((n = yx(n)),
      s.context === null ? (s.context = n) : (s.pendingContext = n),
      (s = Ts(t)),
      (s.payload = { element: a }),
      (r = r === void 0 ? null : r),
      r !== null && (s.callback = r),
      (a = _s(e, s, t)),
      a !== null && (Ea(a, e, t), jr(a, e, t)));
  }
  function jx(e, t) {
    if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
      var a = e.retryLane;
      e.retryLane = a !== 0 && a < t ? a : t;
    }
  }
  function ld(e, t) {
    (jx(e, t), (e = e.alternate) && jx(e, t));
  }
  function Nx(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = ln(e, 67108864);
      (t !== null && Ea(t, e, 67108864), ld(e, 67108864));
    }
  }
  function kx(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = Ia();
      t = Ke(t);
      var a = ln(e, t);
      (a !== null && Ea(a, e, t), ld(e, t));
    }
  }
  var Wo = !0;
  function wp(e, t, a, s) {
    var n = C.T;
    C.T = null;
    var r = D.p;
    try {
      ((D.p = 2), sd(e, t, a, s));
    } finally {
      ((D.p = r), (C.T = n));
    }
  }
  function jp(e, t, a, s) {
    var n = C.T;
    C.T = null;
    var r = D.p;
    try {
      ((D.p = 8), sd(e, t, a, s));
    } finally {
      ((D.p = r), (C.T = n));
    }
  }
  function sd(e, t, a, s) {
    if (Wo) {
      var n = nd(s);
      if (n === null) (qc(e, t, s, Po, a), Sx(e, s));
      else if (kp(n, e, t, a, s)) s.stopPropagation();
      else if ((Sx(e, s), t & 4 && -1 < Np.indexOf(e))) {
        for (; n !== null;) {
          var r = Vl(n);
          if (r !== null)
            switch (r.tag) {
              case 3:
                if (((r = r.stateNode), r.current.memoizedState.isDehydrated)) {
                  var o = ga(r.pendingLanes);
                  if (o !== 0) {
                    var c = r;
                    for (c.pendingLanes |= 2, c.entangledLanes |= 2; o;) {
                      var u = 1 << (31 - zt(o));
                      ((c.entanglements[1] |= u), (o &= ~u));
                    }
                    (Yl(r), (Fe & 6) === 0 && ((Oo = we() + 500), Rr(0)));
                  }
                }
                break;
              case 31:
              case 13:
                ((c = ln(r, 2)), c !== null && Ea(c, r, 2), Mo(), ld(r, 2));
            }
          if (((r = nd(s)), r === null && qc(e, t, s, Po, a), r === n)) break;
          n = r;
        }
        n !== null && s.stopPropagation();
      } else qc(e, t, s, null, a);
    }
  }
  function nd(e) {
    return ((e = za(e)), rd(e));
  }
  var Po = null;
  function rd(e) {
    if (((Po = null), (e = ea(e)), e !== null)) {
      var t = j(e);
      if (t === null) e = null;
      else {
        var a = t.tag;
        if (a === 13) {
          if (((e = se(t)), e !== null)) return e;
          e = null;
        } else if (a === 31) {
          if (((e = J(t)), e !== null)) return e;
          e = null;
        } else if (a === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          e = null;
        } else t !== e && (e = null);
      }
    }
    return ((Po = e), null);
  }
  function Cx(e) {
    switch (e) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (Fa()) {
          case Qe:
            return 2;
          case da:
            return 8;
          case Aa:
          case Va:
            return 32;
          case bs:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var od = !1,
    Xs = null,
    Ys = null,
    Is = null,
    Fr = new Map(),
    Vr = new Map(),
    qs = [],
    Np =
      "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
        " ",
      );
  function Sx(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        Xs = null;
        break;
      case "dragenter":
      case "dragleave":
        Ys = null;
        break;
      case "mouseover":
      case "mouseout":
        Is = null;
        break;
      case "pointerover":
      case "pointerout":
        Fr.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Vr.delete(t.pointerId);
    }
  }
  function $r(e, t, a, s, n, r) {
    return e === null || e.nativeEvent !== r
      ? ((e = {
          blockedOn: t,
          domEventName: a,
          eventSystemFlags: s,
          nativeEvent: r,
          targetContainers: [n],
        }),
        t !== null && ((t = Vl(t)), t !== null && Nx(t)),
        e)
      : ((e.eventSystemFlags |= s),
        (t = e.targetContainers),
        n !== null && t.indexOf(n) === -1 && t.push(n),
        e);
  }
  function kp(e, t, a, s, n) {
    switch (t) {
      case "focusin":
        return ((Xs = $r(Xs, e, t, a, s, n)), !0);
      case "dragenter":
        return ((Ys = $r(Ys, e, t, a, s, n)), !0);
      case "mouseover":
        return ((Is = $r(Is, e, t, a, s, n)), !0);
      case "pointerover":
        var r = n.pointerId;
        return (Fr.set(r, $r(Fr.get(r) || null, e, t, a, s, n)), !0);
      case "gotpointercapture":
        return (
          (r = n.pointerId),
          Vr.set(r, $r(Vr.get(r) || null, e, t, a, s, n)),
          !0
        );
    }
    return !1;
  }
  function Ex(e) {
    var t = ea(e.target);
    if (t !== null) {
      var a = j(t);
      if (a !== null) {
        if (((t = a.tag), t === 13)) {
          if (((t = se(a)), t !== null)) {
            ((e.blockedOn = t),
              ys(e.priority, function () {
                kx(a);
              }));
            return;
          }
        } else if (t === 31) {
          if (((t = J(a)), t !== null)) {
            ((e.blockedOn = t),
              ys(e.priority, function () {
                kx(a);
              }));
            return;
          }
        } else if (t === 3 && a.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function ei(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length;) {
      var a = nd(e.nativeEvent);
      if (a === null) {
        a = e.nativeEvent;
        var s = new a.constructor(a.type, a);
        ((Ul = s), a.target.dispatchEvent(s), (Ul = null));
      } else return ((t = Vl(a)), t !== null && Nx(t), (e.blockedOn = a), !1);
      t.shift();
    }
    return !0;
  }
  function Ax(e, t, a) {
    ei(e) && a.delete(t);
  }
  function Cp() {
    ((od = !1),
      Xs !== null && ei(Xs) && (Xs = null),
      Ys !== null && ei(Ys) && (Ys = null),
      Is !== null && ei(Is) && (Is = null),
      Fr.forEach(Ax),
      Vr.forEach(Ax));
  }
  function ti(e, t) {
    e.blockedOn === t &&
      ((e.blockedOn = null),
      od ||
        ((od = !0),
        f.unstable_scheduleCallback(f.unstable_NormalPriority, Cp)));
  }
  var ai = null;
  function Tx(e) {
    ai !== e &&
      ((ai = e),
      f.unstable_scheduleCallback(f.unstable_NormalPriority, function () {
        ai === e && (ai = null);
        for (var t = 0; t < e.length; t += 3) {
          var a = e[t],
            s = e[t + 1],
            n = e[t + 2];
          if (typeof s != "function") {
            if (rd(s || a) === null) continue;
            break;
          }
          var r = Vl(a);
          r !== null &&
            (e.splice(t, 3),
            (t -= 3),
            nc(r, { pending: !0, data: n, method: a.method, action: s }, s, n));
        }
      }));
  }
  function Pn(e) {
    function t(u) {
      return ti(u, e);
    }
    (Xs !== null && ti(Xs, e),
      Ys !== null && ti(Ys, e),
      Is !== null && ti(Is, e),
      Fr.forEach(t),
      Vr.forEach(t));
    for (var a = 0; a < qs.length; a++) {
      var s = qs[a];
      s.blockedOn === e && (s.blockedOn = null);
    }
    for (; 0 < qs.length && ((a = qs[0]), a.blockedOn === null);)
      (Ex(a), a.blockedOn === null && qs.shift());
    if (((a = (e.ownerDocument || e).$$reactFormReplay), a != null))
      for (s = 0; s < a.length; s += 3) {
        var n = a[s],
          r = a[s + 1],
          o = n[Bt] || null;
        if (typeof r == "function") o || Tx(a);
        else if (o) {
          var c = null;
          if (r && r.hasAttribute("formAction")) {
            if (((n = r), (o = r[Bt] || null))) c = o.formAction;
            else if (rd(n) !== null) continue;
          } else c = o.action;
          (typeof c == "function" ? (a[s + 1] = c) : (a.splice(s, 3), (s -= 3)),
            Tx(a));
        }
      }
  }
  function _x() {
    function e(r) {
      r.canIntercept &&
        r.info === "react-transition" &&
        r.intercept({
          handler: function () {
            return new Promise(function (o) {
              return (n = o);
            });
          },
          focusReset: "manual",
          scroll: "manual",
        });
    }
    function t() {
      (n !== null && (n(), (n = null)), s || setTimeout(a, 20));
    }
    function a() {
      if (!s && !navigation.transition) {
        var r = navigation.currentEntry;
        r &&
          r.url != null &&
          navigation.navigate(r.url, {
            state: r.getState(),
            info: "react-transition",
            history: "replace",
          });
      }
    }
    if (typeof navigation == "object") {
      var s = !1,
        n = null;
      return (
        navigation.addEventListener("navigate", e),
        navigation.addEventListener("navigatesuccess", t),
        navigation.addEventListener("navigateerror", t),
        setTimeout(a, 100),
        function () {
          ((s = !0),
            navigation.removeEventListener("navigate", e),
            navigation.removeEventListener("navigatesuccess", t),
            navigation.removeEventListener("navigateerror", t),
            n !== null && (n(), (n = null)));
        }
      );
    }
  }
  function id(e) {
    this._internalRoot = e;
  }
  ((li.prototype.render = id.prototype.render =
    function (e) {
      var t = this._internalRoot;
      if (t === null) throw Error(h(409));
      var a = t.current,
        s = Ia();
      wx(a, s, e, t, null, null);
    }),
    (li.prototype.unmount = id.prototype.unmount =
      function () {
        var e = this._internalRoot;
        if (e !== null) {
          this._internalRoot = null;
          var t = e.containerInfo;
          (wx(e.current, 2, null, e, null, null), Mo(), (t[Pt] = null));
        }
      }));
  function li(e) {
    this._internalRoot = e;
  }
  li.prototype.unstable_scheduleHydration = function (e) {
    if (e) {
      var t = xt();
      e = { blockedOn: null, target: e, priority: t };
      for (var a = 0; a < qs.length && t !== 0 && t < qs[a].priority; a++);
      (qs.splice(a, 0, e), a === 0 && Ex(e));
    }
  };
  var Dx = V.version;
  if (Dx !== "19.2.7") throw Error(h(527, Dx, "19.2.7"));
  D.findDOMNode = function (e) {
    var t = e._reactInternals;
    if (t === void 0)
      throw typeof e.render == "function"
        ? Error(h(188))
        : ((e = Object.keys(e).join(",")), Error(h(268, e)));
    return (
      (e = W(t)),
      (e = e !== null ? Ae(e) : null),
      (e = e === null ? null : e.stateNode),
      e
    );
  };
  var Sp = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: C,
    reconcilerVersion: "19.2.7",
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var si = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!si.isDisabled && si.supportsFiber)
      try {
        ((ul = si.inject(Sp)), ($t = si));
      } catch {}
  }
  return (
    (Kr.createRoot = function (e, t) {
      if (!I(e)) throw Error(h(299));
      var a = !1,
        s = "",
        n = Ru,
        r = Gu,
        o = Hu;
      return (
        t != null &&
          (t.unstable_strictMode === !0 && (a = !0),
          t.identifierPrefix !== void 0 && (s = t.identifierPrefix),
          t.onUncaughtError !== void 0 && (n = t.onUncaughtError),
          t.onCaughtError !== void 0 && (r = t.onCaughtError),
          t.onRecoverableError !== void 0 && (o = t.onRecoverableError)),
        (t = vx(e, 1, !1, null, null, a, s, null, n, r, o, _x)),
        (e[Pt] = t.current),
        Ic(e),
        new id(t)
      );
    }),
    (Kr.hydrateRoot = function (e, t, a) {
      if (!I(e)) throw Error(h(299));
      var s = !1,
        n = "",
        r = Ru,
        o = Gu,
        c = Hu,
        u = null;
      return (
        a != null &&
          (a.unstable_strictMode === !0 && (s = !0),
          a.identifierPrefix !== void 0 && (n = a.identifierPrefix),
          a.onUncaughtError !== void 0 && (r = a.onUncaughtError),
          a.onCaughtError !== void 0 && (o = a.onCaughtError),
          a.onRecoverableError !== void 0 && (c = a.onRecoverableError),
          a.formState !== void 0 && (u = a.formState)),
        (t = vx(e, 1, !0, t, a ?? null, s, n, u, r, o, c, _x)),
        (t.context = yx(null)),
        (a = t.current),
        (s = Ia()),
        (s = Ke(s)),
        (n = Ts(s)),
        (n.callback = null),
        _s(a, n, s),
        (a = s),
        (t.current.lanes = a),
        pl(t, a),
        Yl(t),
        (e[Pt] = t.current),
        Ic(e),
        new li(t)
      );
    }),
    (Kr.version = "19.2.7"),
    Kr
  );
}
var Hx;
function Wp() {
  if (Hx) return ud.exports;
  Hx = 1;
  function f() {
    if (!(
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
    ))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(f);
      } catch (V) {
        console.error(V);
      }
  }
  return (f(), (ud.exports = Jp()), ud.exports);
}
var Pp = Wp();
const em = "modulepreload",
  tm = function (f) {
    return "/" + f;
  },
  Xx = {},
  lr = function (V, b, h) {
    let I = Promise.resolve();
    if (b && b.length > 0) {
      let se = function (W) {
        return Promise.all(
          W.map((Ae) =>
            Promise.resolve(Ae).then(
              (R) => ({ status: "fulfilled", value: R }),
              (R) => ({ status: "rejected", reason: R }),
            ),
          ),
        );
      };
      document.getElementsByTagName("link");
      const J = document.querySelector("meta[property=csp-nonce]"),
        ee = J?.nonce || J?.getAttribute("nonce");
      I = se(
        b.map((W) => {
          if (((W = tm(W)), W in Xx)) return;
          Xx[W] = !0;
          const Ae = W.endsWith(".css"),
            R = Ae ? '[rel="stylesheet"]' : "";
          if (document.querySelector(`link[href="${W}"]${R}`)) return;
          const de = document.createElement("link");
          if (
            ((de.rel = Ae ? "stylesheet" : em),
            Ae || (de.as = "script"),
            (de.crossOrigin = ""),
            (de.href = W),
            ee && de.setAttribute("nonce", ee),
            document.head.appendChild(de),
            Ae)
          )
            return new Promise((Ge, $) => {
              (de.addEventListener("load", Ge),
                de.addEventListener("error", () =>
                  $(new Error(`Unable to preload CSS for ${W}`)),
                ));
            });
        }),
      );
    }
    function j(se) {
      const J = new Event("vite:preloadError", { cancelable: !0 });
      if (((J.payload = se), window.dispatchEvent(J), !J.defaultPrevented))
        throw se;
    }
    return I.then((se) => {
      for (const J of se || []) J.status === "rejected" && j(J.reason);
      return V().catch(j);
    });
  };
function am(f) {
  if (!f) return "";
  const V = (f.store || "deal").toLowerCase().replace(/[^a-z0-9]/g, ""),
    b = (f.description || "item")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .slice(0, 45),
    h = `${V}-${b}`.replace(/-+/g, "-").replace(/^-|-$/g, "") || "deal",
    I = f.id ? f.id.slice(-6).toLowerCase() : "000000";
  return `${h}-${I}`;
}
function jm(f, V) {
  if (!f || !V || V.length === 0) return null;
  const b = f.toLowerCase().trim();
  for (const j of V) if (am(j).toLowerCase() === b) return j;
  const h = b.split("-"),
    I = h[h.length - 1];
  if (I && I.length >= 4) {
    for (const j of V) if (j.id && j.id.toLowerCase().endsWith(I)) return j;
  }
  for (const j of V) if (j.id && b.includes(j.id.toLowerCase())) return j;
  return null;
}
function Ll(f, V) {
  typeof window > "u" ||
    (window.location.pathname !== f &&
      (window.history.pushState({ path: f }, V || "", f),
      V && (document.title = V)));
}
const Yx = {
  "modern-dark": {
    key: "modern-dark",
    nameEn: "Modern Dark (Default)",
    nameAr: "الداكن العصري (الافتراضي)",
    icon: "🌃",
    wrapperBgClass:
      "bg-city-skyline min-h-screen text-slate-900 font-sans antialiased relative transition-colors duration-300",
    headerClass:
      "sticky top-0 z-40 glass-header text-white shadow-xl transition-all duration-300",
    cardClass:
      "glass-card rounded-3xl p-5 sm:p-6 shadow-2xl text-slate-900 transition-all duration-300",
    primaryBtnClass:
      "bg-blue-600 hover:bg-blue-700 active:scale-95 text-white font-extrabold shadow-md shadow-blue-600/20 border border-blue-500/30 transition-all cursor-pointer rounded-xl px-6 py-3.5 text-sm",
    secondaryBtnClass:
      "bg-slate-200 hover:bg-slate-300 active:scale-95 text-slate-800 font-extrabold border border-slate-300 transition-all cursor-pointer rounded-xl px-4 py-2.5 text-xs",
    inputClass:
      "border-2 border-slate-300 bg-white text-slate-900 placeholder:text-slate-400 focus:border-blue-600 shadow-sm rounded-xl px-4 py-3.5 text-sm sm:text-base font-bold",
    headingTextClass:
      "text-white drop-shadow-md text-3xl sm:text-4xl md:text-5xl font-black tracking-tight leading-tight mb-4",
    subTextClass:
      "text-slate-100 drop-shadow-md font-medium text-sm sm:text-base md:text-lg max-w-xl leading-relaxed mb-8",
    accentTextClass: "text-sky-300 font-bold",
    typewriterClass: "text-sky-300 font-bold",
    activeTabClass:
      "bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-xl shadow-blue-600/30 border border-blue-400/30 rounded-xl px-4.5 py-2.5 font-extrabold text-xs sm:text-sm",
    inactiveTabClass:
      "bg-white/95 hover:bg-white text-slate-800 border border-slate-200/80 shadow-md rounded-xl px-4.5 py-2.5 font-extrabold text-xs sm:text-sm",
    badgeClass:
      "bg-white/95 text-slate-800 border border-slate-200 shadow-md rounded-full px-4 py-2 text-xs font-extrabold",
    footerClass: "bg-[#060d18]/90 text-slate-300 border-t border-slate-800",
    widgetCardClass:
      "bg-[#0b1424]/95 backdrop-blur-md border border-slate-700/80 rounded-3xl shadow-2xl text-white p-5",
    layoutType: "standard",
    heroGridClass:
      "grid grid-cols-1 lg:grid-cols-12 gap-8 items-start max-w-7xl mx-auto",
    formOrderClass:
      "lg:col-span-7 flex flex-col items-start text-start order-1",
    timerOrderClass: "lg:col-span-5 order-2",
    heroAlignClass: "items-start text-start",
    tabsLayoutClass: "flex flex-wrap gap-2.5 mb-5 select-none",
    badgeContainerClass: "inline-flex items-center gap-2 mb-6",
    recentLinksLayoutClass: "grid grid-cols-1 md:grid-cols-2 gap-4",
    stepWorkflowVisible: !1,
  },
  "light-clean": {
    key: "light-clean",
    nameEn: "Executive Light (Corporate & Centered)",
    nameAr: "التنفيذي الفاتح (شركات ومحاذات للوسط)",
    icon: "🏛️",
    wrapperBgClass:
      "bg-slate-50 min-h-screen text-slate-900 font-serif antialiased relative transition-colors duration-300 bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:16px_16px]",
    headerClass:
      "sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200/80 text-slate-900 shadow-sm transition-all duration-300 font-sans",
    cardClass:
      "bg-white border border-slate-200/90 rounded-2xl p-6 sm:p-8 shadow-xl shadow-slate-200/50 text-slate-900 transition-all duration-300 font-sans",
    primaryBtnClass:
      "bg-slate-900 hover:bg-slate-800 active:scale-98 text-white font-serif font-semibold shadow-lg shadow-slate-900/10 border border-slate-800 transition-all cursor-pointer rounded-full px-6 py-3.5 text-sm sm:text-base",
    secondaryBtnClass:
      "bg-slate-100 hover:bg-slate-200 active:scale-98 text-slate-800 font-serif font-medium border border-slate-300 transition-all cursor-pointer rounded-full px-5 py-3 text-xs sm:text-sm",
    inputClass:
      "border border-slate-300 bg-slate-50/60 text-slate-900 placeholder:text-slate-400 focus:border-slate-800 focus:bg-white shadow-sm rounded-full px-6 py-3.5 font-sans text-sm sm:text-base",
    headingTextClass:
      "text-slate-950 font-serif font-semibold tracking-tight text-3xl sm:text-5xl md:text-6xl text-center leading-tight mb-4",
    subTextClass:
      "text-slate-600 font-sans font-normal text-base sm:text-lg text-center max-w-2xl mx-auto leading-relaxed mb-8",
    accentTextClass: "text-slate-900 font-serif italic font-bold",
    typewriterClass: "text-emerald-700 font-serif italic font-bold",
    activeTabClass:
      "bg-slate-900 text-white shadow-md border border-slate-800 rounded-full px-6 py-2.5 font-serif font-medium text-xs sm:text-sm",
    inactiveTabClass:
      "bg-white hover:bg-slate-100 text-slate-700 border border-slate-200/90 shadow-sm rounded-full px-6 py-2.5 font-serif text-xs sm:text-sm",
    badgeClass:
      "bg-slate-100 text-slate-800 border border-slate-300/80 shadow-sm rounded-full px-5 py-1.5 font-sans font-medium text-xs",
    footerClass:
      "bg-slate-950 text-slate-300 border-t border-slate-800 font-sans",
    widgetCardClass:
      "bg-white border border-slate-200 rounded-2xl shadow-xl shadow-slate-200/60 text-slate-900 p-6 font-sans",
    layoutType: "executive-centered",
    heroGridClass:
      "flex flex-col items-center max-w-3xl mx-auto px-4 py-6 text-center gap-6",
    formOrderClass: "w-full flex flex-col items-center text-center order-1",
    timerOrderClass: "w-full order-2 mt-6",
    heroAlignClass: "items-center text-center",
    tabsLayoutClass:
      "flex justify-center flex-wrap gap-2.5 mb-6 select-none bg-slate-200/50 p-1.5 rounded-full border border-slate-300/60 shadow-inner max-w-md mx-auto",
    badgeContainerClass: "inline-flex items-center justify-center gap-2 mb-4",
    recentLinksLayoutClass:
      "grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto",
    stepWorkflowVisible: !1,
  },
  "neon-cyber": {
    key: "neon-cyber",
    nameEn: "Cyber Dashboard (Control Panel & Grid)",
    nameAr: "لوحة السايبر (لوحة تحكم وشبكة)",
    icon: "⚡",
    wrapperBgClass:
      "bg-[#030712] min-h-screen text-cyan-100 font-mono antialiased relative transition-colors duration-300 bg-[linear-gradient(to_right,#0e172a_1px,transparent_1px),linear-gradient(to_bottom,#0e172a_1px,transparent_1px)] [background-size:24px_24px]",
    headerClass:
      "sticky top-0 z-40 bg-[#0a0f24]/95 border-b-2 border-cyan-500/60 text-cyan-300 shadow-[0_4px_25px_rgba(6,182,212,0.2)] transition-all duration-300 font-mono",
    cardClass:
      "bg-[#090e24]/95 border-2 border-cyan-500/60 rounded-md p-5 sm:p-6 shadow-[0_0_20px_rgba(6,182,212,0.25)] text-cyan-100 transition-all duration-300 font-mono",
    primaryBtnClass:
      "bg-cyan-500 hover:bg-cyan-400 active:scale-95 text-slate-950 font-black shadow-[0_0_15px_rgba(6,182,212,0.6)] border border-cyan-300 transition-all cursor-pointer rounded-sm uppercase tracking-wider px-6 py-3.5 text-xs sm:text-sm",
    secondaryBtnClass:
      "bg-[#0c132c] hover:bg-[#162148] active:scale-95 text-cyan-300 font-bold border border-cyan-500/50 transition-all cursor-pointer rounded-sm uppercase tracking-wider px-4 py-2.5 text-xs",
    inputClass:
      "border-2 border-cyan-500/70 bg-[#050814] text-cyan-100 placeholder:text-cyan-600/80 focus:border-fuchsia-500 focus:shadow-[0_0_15px_rgba(217,70,239,0.3)] shadow-inner rounded-sm font-mono px-4 py-3.5 text-xs sm:text-sm font-bold",
    headingTextClass:
      "text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-fuchsia-300 to-pink-300 drop-shadow-[0_0_12px_rgba(6,182,212,0.5)] font-mono font-black uppercase tracking-wider text-2xl sm:text-4xl md:text-5xl mb-4",
    subTextClass:
      "text-cyan-200/90 font-mono text-xs sm:text-sm leading-relaxed max-w-2xl mb-8",
    accentTextClass: "text-fuchsia-400 font-bold font-mono",
    typewriterClass: "text-fuchsia-400 font-bold font-mono",
    activeTabClass:
      "bg-gradient-to-r from-cyan-500 to-fuchsia-600 text-slate-950 font-black shadow-[0_0_15px_rgba(6,182,212,0.5)] border border-cyan-300 rounded-sm uppercase tracking-wider px-4 py-2 text-xs",
    inactiveTabClass:
      "bg-[#090e24] hover:bg-[#131d45] text-cyan-300 border border-cyan-500/40 shadow-sm rounded-sm uppercase tracking-wider px-4 py-2 text-xs",
    badgeClass:
      "bg-[#090e24] text-cyan-300 border border-cyan-500/60 shadow-[0_0_10px_rgba(6,182,212,0.3)] rounded-sm font-mono uppercase tracking-widest px-3 py-1 text-[10px]",
    footerClass:
      "bg-[#02050e] text-cyan-300 border-t-2 border-cyan-500/40 font-mono",
    widgetCardClass:
      "bg-[#090e24]/95 border-2 border-cyan-500/60 rounded-md shadow-[0_0_20px_rgba(6,182,212,0.25)] text-cyan-100 p-4 font-mono",
    layoutType: "cyber-grid",
    heroGridClass:
      "grid grid-cols-1 lg:grid-cols-12 gap-5 max-w-7xl mx-auto items-start",
    formOrderClass:
      "lg:col-span-7 flex flex-col items-start text-start order-1 lg:order-1",
    timerOrderClass: "lg:col-span-5 order-2 lg:order-2",
    heroAlignClass: "items-start text-start",
    tabsLayoutClass:
      "flex flex-wrap gap-2 mb-4 p-1.5 bg-[#050814] rounded-sm border border-cyan-500/50 shadow-[0_0_15px_rgba(6,182,212,0.15)]",
    badgeContainerClass: "inline-flex items-center gap-2 mb-3",
    recentLinksLayoutClass:
      "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
    stepWorkflowVisible: !1,
  },
  "warm-sunset": {
    key: "warm-sunset",
    nameEn: "Soft Magazine (Editorial & Warm)",
    nameAr: "المجلة الناعمة (محرري ودافئ)",
    icon: "📰",
    wrapperBgClass:
      "bg-[#f8f5ee] min-h-screen text-amber-950 font-serif antialiased relative transition-colors duration-300",
    headerClass:
      "sticky top-0 z-40 bg-[#f8f5ee]/90 backdrop-blur-md border-b border-amber-200/80 text-amber-950 shadow-sm transition-all duration-300 font-serif",
    cardClass:
      "bg-white/95 backdrop-blur-md border border-amber-200/80 rounded-[36px] p-7 sm:p-9 shadow-2xl shadow-amber-900/5 text-amber-950 transition-all duration-300",
    primaryBtnClass:
      "bg-amber-900 hover:bg-amber-800 active:scale-95 text-amber-50 font-serif font-medium shadow-xl shadow-amber-900/10 border border-amber-800 transition-all cursor-pointer rounded-2xl px-6 py-3.5 text-sm sm:text-base",
    secondaryBtnClass:
      "bg-amber-100/80 hover:bg-amber-200/80 active:scale-95 text-amber-900 font-serif border border-amber-300/80 transition-all cursor-pointer rounded-2xl px-5 py-3 text-xs sm:text-sm",
    inputClass:
      "border border-amber-200 bg-amber-50/40 text-amber-950 placeholder:text-amber-800/40 focus:border-amber-700 focus:bg-white shadow-inner rounded-2xl px-5 py-3.5 font-sans text-sm sm:text-base",
    headingTextClass:
      "text-amber-950 font-serif italic text-3xl sm:text-4xl md:text-5xl font-normal leading-snug tracking-normal mb-4",
    subTextClass:
      "text-amber-900/80 font-sans text-sm sm:text-base leading-relaxed max-w-xl font-normal mb-8",
    accentTextClass: "text-rose-800 font-serif italic font-bold",
    typewriterClass: "text-rose-800 font-serif italic font-bold",
    activeTabClass:
      "bg-amber-900 text-amber-50 shadow-md border border-amber-800 rounded-full px-5 py-2 font-serif text-xs sm:text-sm",
    inactiveTabClass:
      "bg-white hover:bg-amber-100/60 text-amber-900 border border-amber-200 shadow-sm rounded-full px-5 py-2 font-serif text-xs sm:text-sm",
    badgeClass:
      "bg-amber-100/80 text-amber-900 border border-amber-300/70 shadow-sm rounded-full px-4 py-1.5 font-sans text-xs",
    footerClass:
      "bg-amber-950 text-amber-100 border-t border-amber-900 font-serif",
    widgetCardClass:
      "bg-white border border-amber-200 rounded-[36px] shadow-2xl shadow-amber-900/5 text-amber-950 p-6 font-sans",
    layoutType: "soft-magazine",
    heroGridClass:
      "grid grid-cols-1 lg:grid-cols-12 gap-10 max-w-7xl mx-auto items-start",
    formOrderClass:
      "lg:col-span-7 flex flex-col items-start text-start order-1 lg:order-1",
    timerOrderClass: "lg:col-span-5 order-2 lg:order-2",
    heroAlignClass: "items-start text-start",
    tabsLayoutClass:
      "flex flex-wrap gap-2.5 mb-6 select-none bg-amber-100/60 p-1.5 rounded-full border border-amber-200/80 shadow-inner",
    badgeContainerClass: "inline-flex items-center gap-2 mb-6",
    recentLinksLayoutClass: "grid grid-cols-1 md:grid-cols-2 gap-5",
    stepWorkflowVisible: !1,
  },
  "minimal-pro": {
    key: "minimal-pro",
    nameEn: "Bold Minimal (Monochrome & Agency)",
    nameAr: "البسيط الجريء (أحادي وثقيل)",
    icon: "⬛",
    wrapperBgClass:
      "bg-white min-h-screen text-black font-sans antialiased relative transition-colors duration-300",
    headerClass:
      "sticky top-0 z-40 bg-white border-b-2 border-black text-black transition-all duration-300 font-sans",
    cardClass:
      "bg-white border-2 border-black rounded-none p-6 sm:p-8 shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] text-black transition-all duration-300",
    primaryBtnClass:
      "bg-black hover:bg-neutral-800 active:translate-x-0.5 active:translate-y-0.5 text-white font-black uppercase tracking-widest border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:shadow-none transition-all cursor-pointer rounded-none px-8 py-4 text-xs sm:text-sm",
    secondaryBtnClass:
      "bg-white hover:bg-neutral-100 active:translate-x-0.5 active:translate-y-0.5 text-black font-bold uppercase tracking-wider border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] transition-all cursor-pointer rounded-none px-5 py-3 text-xs",
    inputClass:
      "border-2 border-black bg-white text-black placeholder:text-neutral-500 focus:bg-neutral-50 font-bold rounded-none px-5 py-3.5 text-sm sm:text-base font-mono",
    headingTextClass:
      "text-black font-black uppercase tracking-tighter text-4xl sm:text-6xl md:text-7xl leading-none mb-4",
    subTextClass:
      "text-neutral-800 font-bold text-base sm:text-lg max-w-xl leading-relaxed mb-8",
    accentTextClass:
      "text-black font-black uppercase underline decoration-4 decoration-black",
    typewriterClass:
      "text-black font-black uppercase underline decoration-4 decoration-black",
    activeTabClass:
      "bg-black text-white font-black uppercase tracking-wider border-2 border-black rounded-none px-6 py-2.5 text-xs sm:text-sm shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]",
    inactiveTabClass:
      "bg-white text-black hover:bg-neutral-100 font-bold uppercase tracking-wider border-2 border-black rounded-none px-6 py-2.5 text-xs sm:text-sm",
    badgeClass:
      "bg-black text-white font-mono uppercase tracking-widest px-4 py-1.5 text-xs font-bold border-2 border-black rounded-none",
    footerClass: "bg-black text-white border-t-2 border-black font-mono",
    widgetCardClass:
      "bg-white border-2 border-black rounded-none shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] text-black p-5 font-mono",
    layoutType: "bold-minimal",
    heroGridClass:
      "grid grid-cols-1 lg:grid-cols-12 gap-8 max-w-7xl mx-auto items-start",
    formOrderClass:
      "lg:col-span-8 flex flex-col items-start text-start order-1",
    timerOrderClass: "lg:col-span-4 order-2",
    heroAlignClass: "items-start text-start",
    tabsLayoutClass: "flex flex-wrap gap-3 mb-6 select-none",
    badgeContainerClass: "inline-flex items-center gap-2 mb-4",
    recentLinksLayoutClass: "grid grid-cols-1 md:grid-cols-2 gap-4",
    stepWorkflowVisible: !0,
  },
};
function lf(f, V) {
  const b = f && f in Yx ? f : "modern-dark",
    h = { ...Yx[b] };
  if (V && Ix[V]) {
    const I = Ix[V],
      j = h.primaryBtnClass.match(/rounded-[a-z0-9]+/)?.[0] || "rounded-xl",
      se = h.activeTabClass.match(/rounded-[a-z0-9]+/)?.[0] || "rounded-xl",
      J = h.activeTabClass.match(/p[xy]?-[0-9.]+/g)?.join(" ") || "",
      ee = h.key === "neon-cyber" ? "uppercase tracking-wider" : "";
    ((h.primaryBtnClass = `${I.btnGrad} ${j} ${ee} font-extrabold shadow-md active:scale-95 transition-all cursor-pointer`),
      (h.activeTabClass = `${I.tabGrad} ${se} ${J} ${ee} transition-all`),
      (h.accentTextClass = I.accentText),
      (h.typewriterClass = I.typewriterText));
  }
  return h;
}
const Ix = {
    blue: {
      btnGrad:
        "bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-700 hover:from-blue-700 hover:to-indigo-800 text-white shadow-blue-600/30 border border-blue-400/30",
      tabGrad:
        "bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg shadow-blue-600/30 border border-blue-400/30",
      accentText: "text-blue-500 font-bold",
      typewriterText: "text-sky-300 font-bold",
    },
    emerald: {
      btnGrad:
        "bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-700 hover:from-emerald-700 hover:to-teal-800 text-white shadow-emerald-600/30 border border-emerald-400/30",
      tabGrad:
        "bg-gradient-to-r from-emerald-600 to-teal-700 text-white shadow-lg shadow-emerald-600/30 border border-emerald-400/30",
      accentText: "text-emerald-500 font-bold",
      typewriterText: "text-emerald-400 font-bold",
    },
    violet: {
      btnGrad:
        "bg-gradient-to-r from-purple-600 via-violet-600 to-indigo-700 hover:from-purple-700 hover:to-indigo-800 text-white shadow-purple-600/30 border border-purple-400/30",
      tabGrad:
        "bg-gradient-to-r from-purple-600 to-violet-700 text-white shadow-lg shadow-purple-600/30 border border-purple-400/30",
      accentText: "text-purple-500 font-bold",
      typewriterText: "text-purple-300 font-bold",
    },
    amber: {
      btnGrad:
        "bg-gradient-to-r from-amber-500 via-orange-600 to-rose-600 hover:from-amber-600 hover:to-rose-700 text-white shadow-orange-500/30 border border-amber-400/30",
      tabGrad:
        "bg-gradient-to-r from-amber-500 to-orange-600 text-white shadow-lg shadow-orange-500/30 border border-amber-400/30",
      accentText: "text-amber-500 font-bold",
      typewriterText: "text-amber-400 font-bold",
    },
    dark: {
      btnGrad:
        "bg-gradient-to-r from-slate-800 via-slate-900 to-zinc-900 hover:from-slate-900 hover:to-black text-white shadow-slate-900/40 border border-slate-700",
      tabGrad:
        "bg-gradient-to-r from-slate-800 to-zinc-900 text-white shadow-lg shadow-slate-900/40 border border-slate-700",
      accentText: "text-slate-300 font-bold",
      typewriterText: "text-slate-200 font-bold",
    },
  },
  qx = {
    "classic-store": {
      key: "classic-store",
      containerBg: "bg-[#F4F5F7]",
      heroTextClass:
        "font-black text-lg sm:text-2xl uppercase tracking-tight text-white drop-shadow-md font-sans leading-tight",
      heroSubtextClass:
        "text-[10px] sm:text-xs text-white/90 font-bold uppercase tracking-wider flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "text-white rounded-2xl overflow-hidden shadow-2xl flex flex-col justify-between transition-all duration-300 hover:shadow-3xl transform hover:-translate-y-1 h-full w-full min-h-0 relative border-2",
      mainCardTopBarClass:
        "bg-[#0a192f] text-white py-1 px-3 flex items-center justify-center gap-1.5 text-xs font-black uppercase tracking-wider shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-white rounded-xl flex items-center justify-center overflow-hidden mb-2.5 p-2 shadow-sm border border-white/20 relative shrink-0",
      mainCardTitleClass:
        "font-black text-xs sm:text-sm text-white line-clamp-2 leading-snug mb-1 block group-hover:text-blue-100 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-blue-100 line-clamp-2 leading-snug mb-2 font-medium",
      mainCardVerifClass: "text-emerald-300",
      mainCardButtonClass:
        "w-full py-2.5 sm:py-3 bg-white font-black text-center rounded-xl shadow-md uppercase tracking-wide flex items-center justify-center gap-1.5 text-xs sm:text-sm border-2 border-white group-hover:bg-blue-50 transition-colors",
      sideCardWrapperClass:
        "bg-white rounded-xl overflow-hidden border border-slate-200/90 shadow-sm flex flex-col justify-between transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-[#0a192f] text-white py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-black uppercase tracking-wider shrink-0",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-white rounded-lg flex items-center justify-center overflow-hidden mb-2 p-1.5 shadow-inner border border-slate-100 relative shrink-0",
      sideCardTitleClass:
        "font-black text-xs text-slate-900 line-clamp-2 leading-tight mb-1 group-hover:text-blue-600 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-slate-500 line-clamp-2 leading-tight mb-2 font-medium",
      sideCardVerifClass: "text-emerald-600",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 text-white font-black text-center rounded-lg shadow-sm group-hover:brightness-110 transition-all text-xs uppercase tracking-wide flex items-center justify-center gap-1",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-[#081026] text-white rounded-2xl p-4 sm:p-5 shadow-xl border border-slate-800 text-center space-y-2",
    },
    "dark-premium": {
      key: "dark-premium",
      containerBg: "bg-[#070b14] text-slate-100",
      headerBgClass:
        "bg-[#0c1324]/95 backdrop-blur-md border-b border-amber-500/30 shadow-lg shadow-black/40",
      heroBgClass:
        "bg-gradient-to-r from-slate-950 via-indigo-950 to-slate-950 border-b border-amber-500/30 shadow-xl",
      heroTextClass:
        "text-amber-300 font-extrabold text-lg sm:text-2xl uppercase tracking-wider drop-shadow-md font-sans leading-tight",
      heroSubtextClass:
        "text-amber-200/90 font-semibold text-[10px] sm:text-xs uppercase tracking-widest flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "text-white rounded-2xl overflow-hidden shadow-[0_10px_35px_rgba(0,0,0,0.8)] flex flex-col justify-between transition-all duration-300 hover:shadow-[0_15px_45px_rgba(234,179,8,0.25)] transform hover:-translate-y-1 h-full w-full min-h-0 relative border-2 border-amber-500/40 bg-[#0d1527]",
      mainCardTopBarClass:
        "bg-[#040812] text-amber-300 border-b border-amber-500/30 py-1 px-3 flex items-center justify-center gap-1.5 text-xs font-black uppercase tracking-widest shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-[#070d1a] rounded-xl flex items-center justify-center overflow-hidden mb-2.5 p-2 shadow-inner border border-amber-500/20 relative shrink-0",
      mainCardTitleClass:
        "font-black text-xs sm:text-sm text-amber-100 line-clamp-2 leading-snug mb-1 block group-hover:text-amber-300 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-slate-300 line-clamp-2 leading-snug mb-2 font-medium",
      mainCardVerifClass: "text-emerald-400",
      mainCardButtonClass:
        "w-full py-2.5 sm:py-3 bg-gradient-to-r from-amber-500 via-amber-400 to-yellow-500 text-slate-950 font-black text-center rounded-xl shadow-lg shadow-amber-500/20 uppercase tracking-widest flex items-center justify-center gap-1.5 text-xs sm:text-sm border border-amber-300 group-hover:brightness-110 transition-all",
      sideCardWrapperClass:
        "bg-[#0e1628] rounded-xl overflow-hidden border border-amber-500/30 shadow-lg flex flex-col justify-between transition-all duration-200 hover:shadow-xl hover:border-amber-400 hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-[#050914] text-amber-300 py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-black uppercase tracking-widest shrink-0 border-b border-amber-500/20",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-[#070c18] rounded-lg flex items-center justify-center overflow-hidden mb-2 p-1.5 shadow-inner border border-amber-500/20 relative shrink-0",
      sideCardTitleClass:
        "font-black text-xs text-amber-100 line-clamp-2 leading-tight mb-1 group-hover:text-amber-300 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-slate-400 line-clamp-2 leading-tight mb-2 font-medium",
      sideCardVerifClass: "text-emerald-400",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-gradient-to-r from-amber-500 to-amber-600 text-slate-950 font-black text-center rounded-lg shadow-md group-hover:brightness-110 transition-all text-xs uppercase tracking-wider flex items-center justify-center gap-1 border border-amber-400",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-[#0a1120] text-amber-100 rounded-2xl p-4 sm:p-5 shadow-2xl border border-amber-500/30 text-center space-y-2",
    },
    "minimal-white": {
      key: "minimal-white",
      containerBg: "bg-[#FAFAFA] text-slate-900",
      headerBgClass:
        "bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-xs text-slate-900",
      heroBgClass: "bg-slate-100 border-b border-slate-200 text-slate-900",
      heroTextClass:
        "text-slate-900 font-extrabold text-lg sm:text-2xl uppercase tracking-tight font-sans leading-tight",
      heroSubtextClass:
        "text-slate-600 font-semibold text-[10px] sm:text-xs uppercase tracking-wider flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "bg-white text-slate-900 rounded-3xl overflow-hidden shadow-xl shadow-slate-200/60 flex flex-col justify-between transition-all duration-300 hover:shadow-2xl transform hover:-translate-y-1 h-full w-full min-h-0 relative border border-slate-200",
      mainCardTopBarClass:
        "bg-slate-900 text-white py-1.5 px-3 flex items-center justify-center gap-1.5 text-xs font-bold uppercase tracking-wider shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-slate-50 rounded-2xl flex items-center justify-center overflow-hidden mb-2.5 p-2 border border-slate-100 relative shrink-0",
      mainCardTitleClass:
        "font-extrabold text-xs sm:text-sm text-slate-900 line-clamp-2 leading-snug mb-1 block group-hover:text-blue-600 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-slate-600 line-clamp-2 leading-snug mb-2 font-normal",
      mainCardVerifClass: "text-emerald-600",
      mainCardButtonClass:
        "w-full py-3 bg-slate-900 text-white font-extrabold text-center rounded-full shadow-md uppercase tracking-wide flex items-center justify-center gap-1.5 text-xs sm:text-sm group-hover:bg-slate-800 transition-colors",
      sideCardWrapperClass:
        "bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-sm flex flex-col justify-between transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-slate-900 text-white py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-bold uppercase tracking-wider shrink-0",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-slate-50 rounded-xl flex items-center justify-center overflow-hidden mb-2 p-1.5 border border-slate-100 relative shrink-0",
      sideCardTitleClass:
        "font-extrabold text-xs text-slate-900 line-clamp-2 leading-tight mb-1 group-hover:text-blue-600 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-slate-500 line-clamp-2 leading-tight mb-2 font-normal",
      sideCardVerifClass: "text-emerald-600",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-slate-900 text-white font-extrabold text-center rounded-full shadow-xs group-hover:bg-slate-800 transition-all text-xs uppercase tracking-wide flex items-center justify-center gap-1",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-white text-slate-800 rounded-3xl p-4 sm:p-5 shadow-lg border border-slate-200 text-center space-y-2",
    },
    "gradient-neon": {
      key: "gradient-neon",
      containerBg:
        "bg-[#030712] text-cyan-100 bg-[linear-gradient(to_right,#0e172a_1px,transparent_1px),linear-gradient(to_bottom,#0e172a_1px,transparent_1px)] bg-[size:24px_24px]",
      headerBgClass:
        "bg-[#0a0f24]/95 backdrop-blur-md border-b-2 border-cyan-500/60 shadow-[0_4px_25px_rgba(6,182,212,0.3)]",
      heroBgClass:
        "bg-gradient-to-r from-fuchsia-950 via-purple-900 to-cyan-950 border-b-2 border-cyan-500/60 shadow-[0_0_30px_rgba(6,182,212,0.25)]",
      heroTextClass:
        "text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-fuchsia-300 to-pink-300 font-black text-lg sm:text-2xl uppercase tracking-widest drop-shadow-[0_0_12px_rgba(6,182,212,0.6)] font-mono leading-tight",
      heroSubtextClass:
        "text-cyan-200 font-bold text-[10px] sm:text-xs uppercase tracking-widest flex items-center justify-center gap-1.5 pt-0.5 font-mono",
      mainCardWrapperClass:
        "text-white rounded-xl overflow-hidden shadow-[0_0_30px_rgba(6,182,212,0.35)] flex flex-col justify-between transition-all duration-300 hover:shadow-[0_0_45px_rgba(217,70,239,0.45)] transform hover:-translate-y-1 h-full w-full min-h-0 relative border-2 border-cyan-400 bg-[#090e24]",
      mainCardTopBarClass:
        "bg-[#02050e] text-cyan-300 py-1 px-3 flex items-center justify-center gap-1.5 text-xs font-black uppercase tracking-widest border-b border-cyan-500/50 shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-[#050814] rounded-lg flex items-center justify-center overflow-hidden mb-2.5 p-2 border border-cyan-500/40 relative shrink-0",
      mainCardTitleClass:
        "font-black text-xs sm:text-sm text-cyan-100 line-clamp-2 leading-snug mb-1 block group-hover:text-fuchsia-300 transition-colors font-mono",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-cyan-200/80 line-clamp-2 leading-snug mb-2 font-medium font-mono",
      mainCardVerifClass: "text-cyan-300",
      mainCardButtonClass:
        "w-full py-2.5 sm:py-3 bg-gradient-to-r from-cyan-400 via-fuchsia-500 to-pink-500 text-slate-950 font-black text-center rounded-md shadow-[0_0_20px_rgba(6,182,212,0.6)] uppercase tracking-widest flex items-center justify-center gap-1.5 text-xs sm:text-sm border border-cyan-300 group-hover:brightness-125 transition-all font-mono",
      sideCardWrapperClass:
        "bg-[#090e24] rounded-lg overflow-hidden border-2 border-cyan-500/60 shadow-[0_0_15px_rgba(6,182,212,0.2)] flex flex-col justify-between transition-all duration-200 hover:shadow-[0_0_25px_rgba(6,182,212,0.4)] hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-[#02050e] text-cyan-300 py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-black uppercase tracking-widest shrink-0 border-b border-cyan-500/40",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-[#050814] rounded-md flex items-center justify-center overflow-hidden mb-2 p-1.5 border border-cyan-500/40 relative shrink-0",
      sideCardTitleClass:
        "font-black text-xs text-cyan-100 line-clamp-2 leading-tight mb-1 group-hover:text-fuchsia-300 transition-colors block font-mono",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-cyan-200/70 line-clamp-2 leading-tight mb-2 font-medium font-mono",
      sideCardVerifClass: "text-cyan-300",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-gradient-to-r from-cyan-500 to-fuchsia-600 text-slate-950 font-black text-center rounded-sm shadow-[0_0_12px_rgba(6,182,212,0.4)] group-hover:brightness-110 transition-all text-xs uppercase tracking-wider flex items-center justify-center gap-1 border border-cyan-400 font-mono",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-[#090e24] text-cyan-300 rounded-md p-4 sm:p-5 shadow-[0_0_25px_rgba(6,182,212,0.3)] border-2 border-cyan-500/60 text-center space-y-2 font-mono",
    },
    "soft-pastel": {
      key: "soft-pastel",
      containerBg: "bg-[#FDF4F5] text-slate-800",
      headerBgClass:
        "bg-rose-500/95 backdrop-blur-md text-white border-b border-rose-300 shadow-sm",
      heroBgClass:
        "bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400 border-b border-purple-200 shadow-sm",
      heroTextClass:
        "text-white font-black text-lg sm:text-2xl uppercase tracking-tight drop-shadow-sm leading-tight",
      heroSubtextClass:
        "text-white/95 font-bold text-[10px] sm:text-xs uppercase tracking-wider flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "bg-white text-slate-800 rounded-[32px] overflow-hidden shadow-xl shadow-pink-200/50 flex flex-col justify-between transition-all duration-300 hover:shadow-2xl hover:shadow-pink-300/60 transform hover:-translate-y-1 h-full w-full min-h-0 relative border-2 border-pink-200",
      mainCardTopBarClass:
        "bg-pink-600 text-white py-1.5 px-3 flex items-center justify-center gap-1.5 text-xs font-bold uppercase tracking-wider shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-pink-50/60 rounded-2xl flex items-center justify-center overflow-hidden mb-2.5 p-2 border border-pink-100 relative shrink-0",
      mainCardTitleClass:
        "font-extrabold text-xs sm:text-sm text-slate-900 line-clamp-2 leading-snug mb-1 block group-hover:text-pink-600 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-slate-600 line-clamp-2 leading-snug mb-2 font-medium",
      mainCardVerifClass: "text-emerald-600",
      mainCardButtonClass:
        "w-full py-3 bg-gradient-to-r from-pink-500 via-rose-500 to-purple-500 text-white font-extrabold text-center rounded-full shadow-lg shadow-pink-500/30 uppercase tracking-wide flex items-center justify-center gap-1.5 text-xs sm:text-sm group-hover:brightness-105 transition-all",
      sideCardWrapperClass:
        "bg-white rounded-[24px] overflow-hidden border border-pink-200 shadow-md flex flex-col justify-between transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-pink-600 text-white py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-bold uppercase tracking-wider shrink-0",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-pink-50/50 rounded-xl flex items-center justify-center overflow-hidden mb-2 p-1.5 border border-pink-100 relative shrink-0",
      sideCardTitleClass:
        "font-extrabold text-xs text-slate-900 line-clamp-2 leading-tight mb-1 group-hover:text-pink-600 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-slate-500 line-clamp-2 leading-tight mb-2 font-medium",
      sideCardVerifClass: "text-emerald-600",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-gradient-to-r from-pink-500 to-rose-500 text-white font-extrabold text-center rounded-full shadow-sm group-hover:brightness-105 transition-all text-xs uppercase tracking-wide flex items-center justify-center gap-1",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-white text-slate-800 rounded-[28px] p-4 sm:p-5 shadow-lg shadow-pink-200/40 border border-pink-200 text-center space-y-2",
    },
    "bold-magazine": {
      key: "bold-magazine",
      containerBg: "bg-[#F8F6F0] text-black",
      headerBgClass:
        "bg-black text-white border-b-4 border-amber-400 shadow-md",
      heroBgClass: "bg-amber-400 text-black border-b-4 border-black",
      heroTextClass:
        "text-black font-black text-xl sm:text-3xl uppercase tracking-tighter drop-shadow-xs leading-none",
      heroSubtextClass:
        "text-black font-black text-[11px] sm:text-xs uppercase tracking-widest flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "bg-white text-black rounded-none overflow-hidden shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] flex flex-col justify-between transition-all duration-200 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] transform hover:-translate-y-0.5 h-full w-full min-h-0 relative border-3 border-black",
      mainCardTopBarClass:
        "bg-black text-amber-300 py-1.5 px-3 flex items-center justify-center gap-1.5 text-xs font-black uppercase tracking-widest border-b-2 border-black shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-amber-50 rounded-none flex items-center justify-center overflow-hidden mb-2.5 p-2 border-2 border-black relative shrink-0",
      mainCardTitleClass:
        "font-black text-xs sm:text-sm text-black line-clamp-2 leading-tight mb-1 block uppercase tracking-tight group-hover:text-amber-600 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-neutral-800 line-clamp-2 leading-tight mb-2 font-bold",
      mainCardVerifClass: "text-black font-black",
      mainCardButtonClass:
        "w-full py-3 bg-black text-amber-400 font-black text-center rounded-none shadow-[3px_3px_0px_0px_rgba(251,191,36,1)] uppercase tracking-widest flex items-center justify-center gap-1.5 text-xs sm:text-sm border-2 border-black group-hover:bg-neutral-900 transition-colors",
      sideCardWrapperClass:
        "bg-white rounded-none overflow-hidden border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] flex flex-col justify-between transition-all duration-200 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-black text-amber-300 py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-black uppercase tracking-widest shrink-0 border-b-2 border-black",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-amber-50 rounded-none flex items-center justify-center overflow-hidden mb-2 p-1.5 border-2 border-black relative shrink-0",
      sideCardTitleClass:
        "font-black text-xs text-black line-clamp-2 leading-tight mb-1 uppercase tracking-tight group-hover:text-amber-600 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-neutral-800 line-clamp-2 leading-tight mb-2 font-bold",
      sideCardVerifClass: "text-black font-black",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-black text-amber-400 font-black text-center rounded-none shadow-[2px_2px_0px_0px_rgba(251,191,36,1)] group-hover:bg-neutral-900 transition-all text-xs uppercase tracking-widest flex items-center justify-center gap-1 border-2 border-black",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-white text-black rounded-none p-4 sm:p-5 shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] border-3 border-black text-center space-y-2",
    },
    "elegant-gold": {
      key: "elegant-gold",
      containerBg: "bg-[#08080a] text-amber-100",
      headerBgClass:
        "bg-[#0f0e13]/95 backdrop-blur-md border-b border-amber-500/40 shadow-xl",
      heroBgClass:
        "bg-gradient-to-r from-[#1c1917] via-[#292524] to-[#1c1917] border-b border-amber-500/40 shadow-xl",
      heroTextClass:
        "text-amber-400 font-black text-lg sm:text-2xl uppercase tracking-widest drop-shadow-md font-serif leading-tight",
      heroSubtextClass:
        "text-amber-200/90 font-bold text-[10px] sm:text-xs uppercase tracking-widest flex items-center justify-center gap-1.5 pt-0.5 font-serif",
      mainCardWrapperClass:
        "bg-[#121016] text-amber-100 rounded-2xl overflow-hidden shadow-[0_15px_40px_rgba(245,158,11,0.2)] flex flex-col justify-between transition-all duration-300 hover:shadow-[0_20px_50px_rgba(245,158,11,0.35)] transform hover:-translate-y-1 h-full w-full min-h-0 relative border-2 border-amber-500/50",
      mainCardTopBarClass:
        "bg-[#050407] text-amber-400 py-1.5 px-3 flex items-center justify-center gap-1.5 text-xs font-black uppercase tracking-widest border-b border-amber-500/40 shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-[#0a080e] rounded-xl flex items-center justify-center overflow-hidden mb-2.5 p-2 border border-amber-500/30 relative shrink-0",
      mainCardTitleClass:
        "font-black text-xs sm:text-sm text-amber-100 line-clamp-2 leading-snug mb-1 block group-hover:text-amber-300 transition-colors font-serif",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-amber-200/80 line-clamp-2 leading-snug mb-2 font-medium",
      mainCardVerifClass: "text-amber-400",
      mainCardButtonClass:
        "w-full py-3 bg-gradient-to-r from-amber-400 via-amber-500 to-yellow-500 text-slate-950 font-black text-center rounded-xl shadow-lg shadow-amber-500/30 uppercase tracking-widest flex items-center justify-center gap-1.5 text-xs sm:text-sm border border-amber-300 group-hover:brightness-110 transition-all font-serif",
      sideCardWrapperClass:
        "bg-[#121016] rounded-xl overflow-hidden border border-amber-500/40 shadow-lg flex flex-col justify-between transition-all duration-200 hover:shadow-xl hover:border-amber-400 hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-[#050407] text-amber-400 py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-black uppercase tracking-widest shrink-0 border-b border-amber-500/30",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-[#0a080e] rounded-lg flex items-center justify-center overflow-hidden mb-2 p-1.5 border border-amber-500/30 relative shrink-0",
      sideCardTitleClass:
        "font-black text-xs text-amber-100 line-clamp-2 leading-tight mb-1 group-hover:text-amber-300 transition-colors block font-serif",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-amber-200/70 line-clamp-2 leading-tight mb-2 font-medium",
      sideCardVerifClass: "text-amber-400",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-gradient-to-r from-amber-400 to-amber-500 text-slate-950 font-black text-center rounded-lg shadow-md group-hover:brightness-110 transition-all text-xs uppercase tracking-widest flex items-center justify-center gap-1 border border-amber-300 font-serif",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-[#0d0b11] text-amber-200 rounded-2xl p-4 sm:p-5 shadow-2xl border border-amber-500/40 text-center space-y-2 font-serif",
    },
    "fresh-nature": {
      key: "fresh-nature",
      containerBg: "bg-[#F0FDF4] text-emerald-950",
      headerBgClass:
        "bg-emerald-900 text-white border-b border-emerald-700 shadow-sm",
      heroBgClass:
        "bg-gradient-to-r from-emerald-800 via-teal-700 to-emerald-900 border-b border-emerald-700 shadow-sm",
      heroTextClass:
        "text-white font-black text-lg sm:text-2xl uppercase tracking-tight drop-shadow-sm leading-tight",
      heroSubtextClass:
        "text-emerald-100 font-bold text-[10px] sm:text-xs uppercase tracking-wider flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "bg-white text-emerald-950 rounded-2xl overflow-hidden shadow-xl shadow-emerald-900/10 flex flex-col justify-between transition-all duration-300 hover:shadow-2xl transform hover:-translate-y-1 h-full w-full min-h-0 relative border-2 border-emerald-200",
      mainCardTopBarClass:
        "bg-emerald-950 text-emerald-300 py-1.5 px-3 flex items-center justify-center gap-1.5 text-xs font-black uppercase tracking-wider shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-emerald-50/60 rounded-xl flex items-center justify-center overflow-hidden mb-2.5 p-2 border border-emerald-100 relative shrink-0",
      mainCardTitleClass:
        "font-extrabold text-xs sm:text-sm text-emerald-950 line-clamp-2 leading-snug mb-1 block group-hover:text-emerald-700 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-emerald-800/80 line-clamp-2 leading-snug mb-2 font-medium",
      mainCardVerifClass: "text-emerald-600",
      mainCardButtonClass:
        "w-full py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-extrabold text-center rounded-xl shadow-lg shadow-emerald-600/30 uppercase tracking-wide flex items-center justify-center gap-1.5 text-xs sm:text-sm border border-emerald-500 transition-colors",
      sideCardWrapperClass:
        "bg-white rounded-xl overflow-hidden border border-emerald-200 shadow-sm flex flex-col justify-between transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-emerald-950 text-emerald-300 py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-black uppercase tracking-wider shrink-0",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-emerald-50/50 rounded-lg flex items-center justify-center overflow-hidden mb-2 p-1.5 border border-emerald-100 relative shrink-0",
      sideCardTitleClass:
        "font-extrabold text-xs text-emerald-950 line-clamp-2 leading-tight mb-1 group-hover:text-emerald-700 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-emerald-800/70 line-clamp-2 leading-tight mb-2 font-medium",
      sideCardVerifClass: "text-emerald-600",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-extrabold text-center rounded-lg shadow-sm transition-all text-xs uppercase tracking-wide flex items-center justify-center gap-1",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-emerald-950 text-emerald-100 rounded-2xl p-4 sm:p-5 shadow-xl border border-emerald-800 text-center space-y-2",
    },
    "retro-pop": {
      key: "retro-pop",
      containerBg:
        "bg-[#FEF9C3] text-slate-900 bg-[radial-gradient(#fde047_2px,transparent_2px)] bg-[size:16px_16px]",
      headerBgClass:
        "bg-purple-600 text-white border-b-4 border-black shadow-md",
      heroBgClass:
        "bg-gradient-to-r from-yellow-400 via-pink-500 to-cyan-400 text-black border-b-4 border-black",
      heroTextClass:
        "text-black font-black text-xl sm:text-3xl uppercase tracking-tighter drop-shadow-md leading-tight",
      heroSubtextClass:
        "text-black font-black text-[11px] sm:text-xs uppercase tracking-widest flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "bg-white text-slate-900 rounded-2xl overflow-hidden shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] flex flex-col justify-between transition-all duration-200 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] transform hover:-translate-y-0.5 h-full w-full min-h-0 relative border-3 border-black bg-pink-50",
      mainCardTopBarClass:
        "bg-cyan-400 text-black py-1.5 px-3 flex items-center justify-center gap-1.5 text-xs font-black uppercase tracking-widest border-b-3 border-black shrink-0",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-yellow-100 rounded-xl flex items-center justify-center overflow-hidden mb-2.5 p-2 border-2 border-black relative shrink-0",
      mainCardTitleClass:
        "font-black text-xs sm:text-sm text-black line-clamp-2 leading-tight mb-1 block group-hover:text-purple-600 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-slate-800 line-clamp-2 leading-tight mb-2 font-bold",
      mainCardVerifClass: "text-emerald-700 font-black",
      mainCardButtonClass:
        "w-full py-3 bg-purple-600 hover:bg-purple-700 text-yellow-300 font-black text-center rounded-xl shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] uppercase tracking-widest flex items-center justify-center gap-1.5 text-xs sm:text-sm border-2 border-black transition-all",
      sideCardWrapperClass:
        "bg-white rounded-2xl overflow-hidden border-3 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] flex flex-col justify-between transition-all duration-200 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-cyan-400 text-black py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-black uppercase tracking-widest shrink-0 border-b-2 border-black",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-yellow-100 rounded-lg flex items-center justify-center overflow-hidden mb-2 p-1.5 border-2 border-black relative shrink-0",
      sideCardTitleClass:
        "font-black text-xs text-black line-clamp-2 leading-tight mb-1 group-hover:text-purple-600 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-slate-800 line-clamp-2 leading-tight mb-2 font-bold",
      sideCardVerifClass: "text-emerald-700 font-black",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-purple-600 text-yellow-300 font-black text-center rounded-lg shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] group-hover:bg-purple-700 transition-all text-xs uppercase tracking-widest flex items-center justify-center gap-1 border-2 border-black",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-purple-600 text-white rounded-2xl p-4 sm:p-5 shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] border-3 border-black text-center space-y-2",
    },
    "ultra-corporate": {
      key: "ultra-corporate",
      containerBg: "bg-[#F1F5F9] text-slate-900",
      headerBgClass:
        "bg-[#0F172A] text-white border-b border-slate-700 shadow-sm",
      heroBgClass:
        "bg-gradient-to-r from-slate-900 via-blue-950 to-slate-900 border-b border-slate-700 shadow-md",
      heroTextClass:
        "text-white font-extrabold text-lg sm:text-2xl uppercase tracking-tight font-sans leading-tight",
      heroSubtextClass:
        "text-slate-300 font-semibold text-[10px] sm:text-xs uppercase tracking-wider flex items-center justify-center gap-1.5 pt-0.5",
      mainCardWrapperClass:
        "bg-white text-slate-900 rounded-lg overflow-hidden shadow-lg border border-slate-300 flex flex-col justify-between transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1 h-full w-full min-h-0 relative",
      mainCardTopBarClass:
        "bg-[#0F172A] text-white py-1 px-3 flex items-center justify-center gap-1.5 text-xs font-bold uppercase tracking-wider shrink-0 border-b border-slate-700",
      mainCardImageBgClass:
        "w-full h-32 sm:h-38 bg-slate-100 rounded-md flex items-center justify-center overflow-hidden mb-2.5 p-2 border border-slate-200 relative shrink-0",
      mainCardTitleClass:
        "font-bold text-xs sm:text-sm text-slate-900 line-clamp-2 leading-snug mb-1 block group-hover:text-blue-700 transition-colors",
      mainCardDescClass:
        "text-[11px] sm:text-xs text-slate-600 line-clamp-2 leading-snug mb-2 font-medium",
      mainCardVerifClass: "text-emerald-700",
      mainCardButtonClass:
        "w-full py-3 bg-[#0071CE] hover:bg-blue-700 text-white font-extrabold text-center rounded-md shadow-md uppercase tracking-wider flex items-center justify-center gap-1.5 text-xs sm:text-sm border border-blue-600 transition-colors",
      sideCardWrapperClass:
        "bg-white rounded-lg overflow-hidden border border-slate-300 shadow-xs flex flex-col justify-between transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 h-full w-full",
      sideCardTopBarClass:
        "bg-[#0F172A] text-white py-1 px-2.5 flex items-center justify-center gap-1 text-[10px] font-bold uppercase tracking-wider shrink-0 border-b border-slate-700",
      sideCardImageBgClass:
        "w-full h-24 sm:h-28 bg-slate-100 rounded-md flex items-center justify-center overflow-hidden mb-2 p-1.5 border border-slate-200 relative shrink-0",
      sideCardTitleClass:
        "font-bold text-xs text-slate-900 line-clamp-2 leading-tight mb-1 group-hover:text-blue-700 transition-colors block",
      sideCardDescClass:
        "text-[10px] sm:text-[11px] text-slate-500 line-clamp-2 leading-tight mb-2 font-medium",
      sideCardVerifClass: "text-emerald-700",
      sideCardButtonClass:
        "w-full py-2 sm:py-2.5 bg-[#0071CE] hover:bg-blue-700 text-white font-bold text-center rounded-md shadow-xs transition-all text-xs uppercase tracking-wide flex items-center justify-center gap-1",
      trustPanelClass:
        "max-w-4xl mx-auto mt-6 mb-3 bg-[#0F172A] text-white rounded-lg p-4 sm:p-5 shadow-lg border border-slate-700 text-center space-y-2",
    },
  },
  Fx = {
    walmart: {
      name: "Walmart",
      domain: "Walmart.com",
      partnerName: "Walmart.com Official Retail Partner",
      headerBg: "bg-[#0071CE]",
      accentColor: "#0071CE",
      buttonBg: "bg-[#0071CE]",
      badgeBg: "bg-[#0071CE]",
      heroBgGradient: "from-[#004F9A] via-[#0071CE] to-[#0284C7]",
      heroImg:
        "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=1200&q=80",
      logoComponent: l.jsxs("div", {
        className:
          "flex items-center gap-1.5 font-black text-current text-xl sm:text-2xl tracking-tight",
        children: [
          l.jsx("span", { children: "Walmart" }),
          l.jsx("svg", {
            className: "w-5 h-5 sm:w-6 sm:h-6 text-[#FFC220] shrink-0",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            children: l.jsx("path", {
              d: "M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83",
              stroke: "currentColor",
              strokeWidth: "3",
              strokeLinecap: "round",
            }),
          }),
        ],
      }),
    },
    amazon: {
      name: "Amazon",
      domain: "Amazon.com",
      partnerName: "Amazon.com Official Retail Partner",
      headerBg: "bg-[#131921]",
      accentColor: "#FF9900",
      buttonBg: "bg-[#0071CE]",
      badgeBg: "bg-[#131921]",
      heroBgGradient: "from-[#0F172A] via-[#1E293B] to-[#334155]",
      heroImg:
        "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80",
      logoComponent: l.jsxs("div", {
        className: "flex flex-col items-center leading-none text-current pt-1",
        children: [
          l.jsx("span", {
            className:
              "font-black text-xl sm:text-2xl text-current tracking-tight font-sans",
            children: "amazon",
          }),
          l.jsxs("svg", {
            className: "w-10 h-3 text-[#FF9900] -mt-0.5",
            viewBox: "0 0 36 10",
            fill: "none",
            children: [
              l.jsx("path", {
                d: "M 2 2 Q 18 10 30 3 Q 32 2 34 3.5 Q 28 11 16 9 Q 7 8 2 2 Z",
                fill: "currentColor",
              }),
              l.jsx("path", {
                d: "M 28 2 L 35 4.5 L 31 0.5 Z",
                fill: "currentColor",
              }),
            ],
          }),
        ],
      }),
    },
    aliexpress: {
      name: "AliExpress",
      domain: "AliExpress.com",
      partnerName: "AliExpress.com Official Retail Partner",
      headerBg: "bg-[#FF4747]",
      accentColor: "#FF4747",
      buttonBg: "bg-[#0071CE]",
      badgeBg: "bg-[#FF4747]",
      heroBgGradient: "from-[#990000] via-[#D97706] to-[#EF4444]",
      heroImg:
        "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&w=1200&q=80",
      logoComponent: l.jsx("div", {
        className:
          "flex items-center gap-1 font-black text-xl sm:text-2xl tracking-tight text-current",
        children: l.jsxs("span", {
          children: [
            "Ali",
            l.jsx("span", { className: "text-[#FFC220]", children: "Express" }),
          ],
        }),
      }),
    },
  },
  jt = {
    previewTitle: {
      en: "Link Preview & Redirect",
      ar: "معاينة الرابط وإعادة التوجيه",
    },
    previewSub: {
      en: "Verify the destination below before continuing",
      ar: "تأكد من الوجهة أدناه قبل المتابعة",
    },
    verifiedPreview: { en: "Verified Preview", ar: "معاينة مؤكدة" },
    continueBtn: {
      en: "Continue to Destination ➔",
      ar: "المتابعة إلى الوجهة ➔",
    },
    goHome: { en: "Go Back to Homepage", ar: "العودة إلى الصفحة الرئيسية" },
    configTitle: {
      en: "Firebase Not Connected",
      ar: "قاعدة البيانات غير متصلة",
    },
    configSub: {
      en: "To activate URL shortening and redirection, click the configuration settings button at the bottom-right and set a valid Firebase Realtime Database URL.",
      ar: "لتفعيل اختصار الروابط وإعادة التوجيه، انقر على زر الإعدادات أسفل اليمين لربط قاعدة البيانات.",
    },
  };
function pd({
  mode: f,
  code: V,
  dest: b,
  onGoHome: h,
  title: I,
  description: j,
  image: se,
  language: J = "en",
  theme: ee,
  palette: W,
  previewAccentColor: Ae,
  previewBgColor: R,
  showStoreLogo: de,
  store: Ge,
  storeLandingPage: $,
  storeLandingTheme: te,
  storeBackgroundImage: Ve,
  storeCardBg: st,
  multiDealsData: ot,
}) {
  const ue = J === "ar";
  lf(ee, W);
  const Me = Ae || "#F43F5E",
    ke =
      R ||
      (ee === "light-clean"
        ? "#f1f5f9"
        : ee === "warm-sunset"
          ? "#fff7ed"
          : ee === "minimal-pro"
            ? "#f8fafc"
            : ee === "neon-cyber"
              ? "#030712"
              : "#0f172a"),
    Ze = st || "#0071CE",
    it = f === "preview" && ot && ot.length > 0;
  bd.useEffect(() => {
    if (f === "notfound")
      try {
        window.location.replace(window.location.origin + "/");
      } catch {
        h();
      }
  }, [f, h]);
  const $e = (U, y, X) => {
      const O = `${U || ""} ${y || ""} ${X || ""}`.toLowerCase(),
        H =
          "px-2.5 py-1 sm:px-3 sm:py-1 rounded-tl-[12px] rounded-br-[10px] flex items-center justify-center border-r border-b border-black/40 shadow-md select-none pointer-events-none z-20";
      if (/amazon|amzn\.to|amzn\.com/i.test(O))
        return l.jsx("div", {
          className: `bg-[#0f1115] text-white ${H}`,
          children: l.jsxs("div", {
            className:
              "relative flex flex-col items-center leading-none pt-0.5 pb-0.5",
            children: [
              l.jsx("span", {
                className:
                  "font-black text-[12px] sm:text-[13px] text-white tracking-tight font-sans leading-none",
                children: "amazon",
              }),
              l.jsxs("svg", {
                className: "w-7 h-2 sm:w-8 sm:h-2.5 text-[#FF9900] -mt-0.5",
                viewBox: "0 0 36 10",
                fill: "none",
                children: [
                  l.jsx("path", {
                    d: "M 2 2 Q 18 10 30 3 Q 32 2 34 3.5 Q 28 11 16 9 Q 7 8 2 2 Z",
                    fill: "currentColor",
                  }),
                  l.jsx("path", {
                    d: "M 28 2 L 35 4.5 L 31 0.5 Z",
                    fill: "currentColor",
                  }),
                ],
              }),
            ],
          }),
        });
      if (/walmart|wmt\.co/i.test(O))
        return l.jsxs("div", {
          className: `bg-[#0071CE] text-white gap-1.5 ${H}`,
          children: [
            l.jsx("span", {
              className:
                "font-black text-xs sm:text-sm tracking-tight text-white leading-none",
              children: "Walmart",
            }),
            l.jsx("svg", {
              className: "w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#FFC220] shrink-0",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              children: l.jsx("path", {
                d: "M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round",
              }),
            }),
          ],
        });
      if (/target/i.test(O))
        return l.jsxs("div", {
          className: `bg-[#CC0000] text-white gap-1.5 ${H}`,
          children: [
            l.jsxs("svg", {
              className: "w-3.5 h-3.5 sm:w-4 sm:h-4 text-white shrink-0",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              children: [
                l.jsx("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "white",
                  strokeWidth: "3",
                  fill: "none",
                }),
                l.jsx("circle", { cx: "12", cy: "12", r: "4", fill: "white" }),
              ],
            }),
            l.jsx("span", {
              className:
                "font-black text-xs sm:text-sm uppercase tracking-wider text-white leading-none",
              children: "Target",
            }),
          ],
        });
      if (/ebay/i.test(O))
        return l.jsxs("div", {
          className: `bg-[#0f1115] text-white gap-0.5 ${H}`,
          children: [
            l.jsx("span", {
              className: "font-black text-xs sm:text-sm text-[#E53238]",
              children: "e",
            }),
            l.jsx("span", {
              className: "font-black text-xs sm:text-sm text-[#0064D2]",
              children: "b",
            }),
            l.jsx("span", {
              className: "font-black text-xs sm:text-sm text-[#F5AF02]",
              children: "a",
            }),
            l.jsx("span", {
              className: "font-black text-xs sm:text-sm text-[#86B817]",
              children: "y",
            }),
          ],
        });
      if (/bestbuy|best buy/i.test(O))
        return l.jsx("div", {
          className: `bg-[#003B64] text-white gap-1 ${H}`,
          children: l.jsx("span", {
            className:
              "font-black text-[11px] sm:text-xs text-[#FFF200] leading-none tracking-tight",
            children: "BEST BUY",
          }),
        });
      if (/etsy/i.test(O))
        return l.jsx("div", {
          className: `bg-[#F1641E] text-white gap-1 ${H}`,
          children: l.jsx("span", {
            className:
              "font-black text-xs sm:text-sm text-white leading-none font-serif",
            children: "Etsy",
          }),
        });
      if (/sephora/i.test(O))
        return l.jsx("div", {
          className: `bg-[#000000] text-white gap-1 ${H}`,
          children: l.jsx("span", {
            className:
              "font-black text-xs sm:text-sm text-white leading-none tracking-widest font-mono",
            children: "SEPHORA",
          }),
        });
      if (/nike/i.test(O))
        return l.jsxs("div", {
          className: `bg-[#000000] text-white gap-1.5 ${H}`,
          children: [
            l.jsx("svg", {
              className: "w-4 h-3 text-white fill-current",
              viewBox: "0 0 24 24",
              children: l.jsx("path", {
                d: "M21.707 5.293c-.391-.391-1.023-.391-1.414 0l-10.293 10.293-4.293-4.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l5 5c.391.391 1.023.391 1.414 0l11-11c.391-.391.391-1.023 0-1.414z",
              }),
            }),
            l.jsx("span", {
              className:
                "font-black text-xs sm:text-sm text-white leading-none tracking-wider",
              children: "NIKE",
            }),
          ],
        });
      if (/temu/i.test(O))
        return l.jsx("div", {
          className: `bg-[#FB7701] text-white gap-1 ${H}`,
          children: l.jsx("span", {
            className:
              "font-black text-xs sm:text-sm text-white leading-none tracking-tight",
            children: "TEMU",
          }),
        });
      if (/aliexpress/i.test(O))
        return l.jsx("div", {
          className: `bg-[#FF4747] text-white gap-1 ${H}`,
          children: l.jsx("span", {
            className: "font-black text-xs sm:text-sm text-white leading-none",
            children: "AliExpress",
          }),
        });
      let G = "Store";
      if (U && /^https?:\/\//i.test(U))
        try {
          const le = new URL(U).hostname.replace(/^www\./i, "").split(".");
          le.length >= 2 &&
            ((G = le[le.length - 2]),
            (G = G.charAt(0).toUpperCase() + G.slice(1)));
        } catch {}
      else X && X !== "auto" && (G = X.charAt(0).toUpperCase() + X.slice(1));
      return l.jsx("div", {
        className: `bg-[#0f1115] text-white gap-1.5 ${H}`,
        children: l.jsx("span", {
          className: "font-black text-xs sm:text-sm text-white leading-none",
          children: G,
        }),
      });
    },
    Nt = (U, y, X) => {
      const O = `${U || ""} ${y || ""} ${X?.previewDescription || ""}`;
      let H = X?.price || X?.currentPrice || null,
        G = X?.listPrice || X?.oldPrice || X?.wasPrice || null,
        F = X?.discountPercent || X?.discount || null;
      if (!H || !G) {
        const le = O.match(/\$\d+(?:\.\d{1,2})?/g);
        if (le && le.length >= 2) {
          const ie = le
            .map((pe) => parseFloat(pe.replace("$", "")))
            .filter((pe) => !isNaN(pe) && pe > 0)
            .sort((pe, Ie) => Ie - pe);
          ie.length >= 2 &&
            ie[0] > ie[1] &&
            (G ||
              (G = `$${ie[0] < 100 ? ie[0].toFixed(ie[0] % 1 === 0 ? 0 : 2) : Math.round(ie[0])}`),
            H ||
              (H = `$${ie[1] < 100 ? ie[1].toFixed(ie[1] % 1 === 0 ? 0 : 2) : Math.round(ie[1])}`),
            F || (F = Math.round(((ie[0] - ie[1]) / ie[0]) * 100)));
        } else if (le && le.length === 1) {
          const ie = parseFloat(le[0].replace("$", "")),
            pe = O.match(/(\d+)\s*%\s*off/i) || O.match(/save\s*(\d+)%/i);
          if (pe) {
            if (
              ((F = parseInt(pe[1], 10)),
              H ||
                (H = `$${ie < 100 ? ie.toFixed(ie % 1 === 0 ? 0 : 2) : Math.round(ie)}`),
              F > 0 && F < 100)
            ) {
              const Ie = ie / (1 - F / 100);
              G ||
                (G = `$${Ie < 100 ? Ie.toFixed(Ie % 1 === 0 ? 0 : 2) : Math.round(Ie)}`);
            }
          } else
            H ||
              (H = `$${ie < 100 ? ie.toFixed(ie % 1 === 0 ? 0 : 2) : Math.round(ie)}`);
        }
      }
      if (!F) {
        const le = O.match(/(\d+)\s*%\s*off/i) || O.match(/save\s*(\d+)%/i);
        le && (F = parseInt(le[1], 10));
      }
      return (
        !G &&
          !H &&
          !F &&
          (O.toLowerCase().includes("tomato") || O.includes("0.50")
            ? ((H = "$0.50"), (G = "$0.71"), (F = 30))
            : O.toLowerCase().includes("wire") ||
                O.toLowerCase().includes("audio") ||
                O.includes("30")
              ? ((H = "$30.00"), (G = "$31.00"), (F = 3))
              : (O.toLowerCase().includes("cottonelle") ||
                  O.toLowerCase().includes("tissue") ||
                  O.includes("11.67")) &&
                ((H = "$11.67"), (G = "$12.98"), (F = 10))),
        { newPrice: H, oldPrice: G, discountPercent: F ? `${F}% off` : null }
      );
    },
    oe = (U, y, X) => {
      const { newPrice: O, oldPrice: H, discountPercent: G } = Nt(U, y, X);
      return !H && !G && !O
        ? null
        : l.jsxs("div", {
            className:
              "absolute bottom-1.5 left-1.5 sm:bottom-2 sm:left-2 z-20 bg-[#E52E2E] text-white px-2.5 py-1 sm:px-3 sm:py-1 rounded-full shadow-md border border-white/20 flex items-center gap-1.5 pointer-events-none",
            children: [
              H &&
                l.jsx("span", {
                  className:
                    "font-extrabold text-[10px] sm:text-xs text-white/80 line-through leading-none drop-shadow-sm",
                  children: H,
                }),
              G
                ? l.jsx("span", {
                    className:
                      "font-black text-[10px] sm:text-xs text-white leading-none whitespace-nowrap drop-shadow-sm",
                    children: G,
                  })
                : O
                  ? l.jsx("span", {
                      className:
                        "font-black text-[10px] sm:text-xs text-white leading-none whitespace-nowrap drop-shadow-sm",
                      children: O,
                    })
                  : null,
            ],
          });
    },
    kt = (U, y = !1) => {
      const X = typeof window < "u" ? window.location.origin : "";
      if (U && U.code) {
        const H = String(U.code).trim().toLowerCase();
        return `${X}/?${H}&go=1`;
      }
      if ((y || !U?.code) && V) {
        const H = String(V).trim().toLowerCase();
        return `${X}/?${H}&go=1`;
      }
      const O = U?.url || U?.resolvedUrl || b || "#";
      if (O === "#") return "#";
      if (
        O.includes("go=1") ||
        O.includes("confirm=1") ||
        O.includes("direct=1")
      )
        return O;
      if (/^https?:\/\//i.test(O))
        try {
          const H = btoa(unescape(encodeURIComponent(O)))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
          return `${X}/?u=${H}&go=1`;
        } catch {}
      return O.includes("?") ? `${O}&go=1` : `${O}?go=1`;
    },
    Oe = (U, y, X) => {
      const O = kt(U, y),
        H =
          U.title ||
          (y ? "Special Limited Time Deal" : `Deal #${(X || 0) + 1}`),
        G = U.image || (y ? se : null),
        F =
          U.previewDescription ||
          U.description ||
          (y ? j : null) ||
          "🔥 Almost gone — tap Continue before it sells out.",
        { newPrice: le } = Nt(H, F, U);
      return y
        ? l.jsxs("div", {
            className:
              "bg-[#0b1329] border border-slate-700/80 rounded-[28px] p-6 sm:p-7 shadow-2xl flex flex-col justify-between text-left dir-auto relative w-full h-full min-h-[460px] sm:min-h-[520px] transition-all hover:border-slate-600",
            children: [
              l.jsxs("div", {
                children: [
                  l.jsxs("div", {
                    className:
                      "flex items-center gap-3 mb-4 border-b border-slate-800/80 pb-3",
                    children: [
                      l.jsx("div", {
                        className:
                          "w-9 h-9 rounded-xl flex items-center justify-center text-base font-bold shrink-0",
                        style: {
                          color: Me,
                          backgroundColor: Me.startsWith("#")
                            ? `${Me}25`
                            : "rgba(244,63,94,0.2)",
                        },
                        children: "🔗",
                      }),
                      l.jsxs("div", {
                        className: "overflow-hidden",
                        children: [
                          l.jsx("h2", {
                            className:
                              "text-sm font-black text-slate-100 truncate",
                            children: ue
                              ? jt.previewTitle.ar
                              : jt.previewTitle.en,
                          }),
                          l.jsx("p", {
                            className: "text-xs text-slate-400 truncate",
                            children: ue ? jt.previewSub.ar : jt.previewSub.en,
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("a", {
                    href: O,
                    rel: "nofollow noopener",
                    className:
                      "block w-full h-56 sm:h-64 bg-white rounded-2xl flex items-center justify-center overflow-hidden mb-5 p-3 shadow-inner border border-slate-200/20 cursor-pointer hover:scale-[1.015] transition-transform duration-200 relative",
                    children: [
                      de &&
                        l.jsx("div", {
                          className: "absolute top-0 left-0 z-20",
                          children: $e(
                            U.url || U.resolvedUrl || b || O,
                            H,
                            U.store || Ge,
                          ),
                        }),
                      oe(H, F, U),
                      G
                        ? l.jsx("img", {
                            src: G,
                            alt: H || "Product image",
                            className: "max-h-full max-w-full object-contain",
                            referrerPolicy: "no-referrer",
                            onError: (ie) => {
                              ie.target.style.display = "none";
                            },
                          })
                        : l.jsx("div", {
                            className: "text-slate-300 text-5xl font-black",
                            children: "📦",
                          }),
                    ],
                  }),
                  l.jsx("a", {
                    href: O,
                    rel: "nofollow noopener",
                    className:
                      "font-extrabold text-base sm:text-lg text-white line-clamp-2 leading-snug mb-2 hover:text-rose-400 transition-colors cursor-pointer block",
                    children: H,
                  }),
                  l.jsx("p", {
                    className:
                      "text-xs sm:text-sm text-slate-300 line-clamp-2 leading-relaxed mb-3 font-medium",
                    children: F,
                  }),
                  l.jsxs("div", {
                    className:
                      "text-[11px] uppercase font-bold text-emerald-400 tracking-wider mb-6 flex items-center gap-1.5",
                    children: [
                      l.jsx("span", {
                        className:
                          "inline-block w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse shrink-0",
                      }),
                      l.jsx("span", {
                        children: ue
                          ? jt.verifiedPreview.ar
                          : jt.verifiedPreview.en,
                      }),
                    ],
                  }),
                ],
              }),
              l.jsx("a", {
                href: O,
                rel: "nofollow noopener",
                className:
                  "block w-full py-4 text-white font-black text-center rounded-2xl shadow-xl hover:brightness-110 active:scale-[0.985] transition-all cursor-pointer text-sm sm:text-base uppercase tracking-wide mt-auto",
                style: {
                  background: Me,
                  boxShadow: `0 6px 20px ${Me.startsWith("#") ? `${Me}60` : "rgba(244,63,94,0.4)"}`,
                },
                children: le
                  ? ue
                    ? `احصل على العرض — ${le}`
                    : `See Deal — ${le}`
                  : ue
                    ? jt.continueBtn.ar
                    : jt.continueBtn.en,
              }),
            ],
          })
        : l.jsxs("div", {
            className:
              "bg-[#0b1329] border border-slate-800/90 rounded-2xl p-4 sm:p-4.5 shadow-lg flex flex-col justify-between text-left dir-auto relative w-full h-full min-h-[340px] transition-all hover:border-slate-700",
            children: [
              l.jsxs("div", {
                children: [
                  l.jsxs("div", {
                    className:
                      "flex items-center gap-2 mb-3 border-b border-slate-800/80 pb-2",
                    children: [
                      l.jsx("div", {
                        className:
                          "w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold shrink-0",
                        style: {
                          color: Me,
                          backgroundColor: Me.startsWith("#")
                            ? `${Me}20`
                            : "rgba(244,63,94,0.15)",
                        },
                        children: "🔗",
                      }),
                      l.jsxs("div", {
                        className: "overflow-hidden",
                        children: [
                          l.jsx("h2", {
                            className:
                              "text-[11px] font-bold text-slate-100 truncate",
                            children: ue
                              ? jt.previewTitle.ar
                              : jt.previewTitle.en,
                          }),
                          l.jsx("p", {
                            className: "text-[9px] text-slate-400 truncate",
                            children: ue ? jt.previewSub.ar : jt.previewSub.en,
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("a", {
                    href: O,
                    rel: "nofollow noopener",
                    className:
                      "block w-full h-32 sm:h-36 bg-white rounded-xl flex items-center justify-center overflow-hidden mb-3 p-2 shadow-inner border border-slate-200/20 cursor-pointer hover:scale-[1.015] transition-transform duration-200 relative",
                    children: [
                      de &&
                        l.jsx("div", {
                          className: "absolute top-0 left-0 z-20",
                          children: $e(
                            U.url || U.resolvedUrl || b || O,
                            H,
                            U.store || Ge,
                          ),
                        }),
                      oe(H, F, U),
                      G
                        ? l.jsx("img", {
                            src: G,
                            alt: H || "Product image",
                            className: "max-h-full max-w-full object-contain",
                            referrerPolicy: "no-referrer",
                            onError: (ie) => {
                              ie.target.style.display = "none";
                            },
                          })
                        : l.jsx("div", {
                            className: "text-slate-300 text-3xl font-black",
                            children: "📦",
                          }),
                    ],
                  }),
                  l.jsx("a", {
                    href: O,
                    rel: "nofollow noopener",
                    className:
                      "font-bold text-xs text-white line-clamp-2 leading-snug mb-1.5 hover:text-rose-400 transition-colors cursor-pointer block",
                    children: H,
                  }),
                  l.jsx("p", {
                    className:
                      "text-[10px] text-slate-300 line-clamp-2 leading-tight mb-2 font-medium",
                    children: F,
                  }),
                  l.jsxs("div", {
                    className:
                      "text-[9px] uppercase font-bold text-emerald-400 tracking-wider mb-4 flex items-center gap-1",
                    children: [
                      l.jsx("span", {
                        className:
                          "inline-block w-2 h-2 rounded-full bg-emerald-500 animate-pulse shrink-0",
                      }),
                      l.jsx("span", {
                        children: ue
                          ? jt.verifiedPreview.ar
                          : jt.verifiedPreview.en,
                      }),
                    ],
                  }),
                ],
              }),
              l.jsx("a", {
                href: O,
                rel: "nofollow noopener",
                className:
                  "block w-full py-2.5 text-white font-extrabold text-center rounded-xl shadow-md hover:brightness-110 active:scale-[0.985] transition-all cursor-pointer text-[11px] uppercase tracking-wide mt-auto",
                style: {
                  background: Me,
                  boxShadow: `0 4px 12px ${Me.startsWith("#") ? `${Me}40` : "rgba(244,63,94,0.25)"}`,
                },
                children: le
                  ? ue
                    ? `عرض — ${le}`
                    : `See Deal — ${le}`
                  : ue
                    ? jt.continueBtn.ar
                    : jt.continueBtn.en,
              }),
            ],
          });
    },
    Pe = {
      title:
        I ||
        "Cordless Robotic Pool Cleaner Wall Floor Waterline Cleaning 180W Powerful Suction...",
      description: j || "🔥 Almost gone — tap Continue before it sells out.",
      image: se || null,
      url: b || "#",
    },
    nt = ot ? ot.length : 0,
    Re = Math.ceil(nt / 2),
    C = ot ? ot.slice(0, Re) : [],
    D = ot ? ot.slice(Re) : [];
  if (f === "preview" && $ && Fx[$]) {
    const U = Fx[$],
      y = te && te in qx ? te : "classic-store",
      X = qx[y],
      O = (G, F = !1, le = 0) => {
        const ie =
            G.title || (ue ? "صفقة مميزة ومحققة" : "Featured Deal Preview"),
          pe =
            G.previewDescription ||
            G.description ||
            (ue
              ? "🔥 كمية محدودة — انقر للتأكيد قبل نفاذ المخزون."
              : "🔥 Almost gone — tap Confirm & Go To Retailer before it sells out.");
        let Ie = ie.trim();
        Ie.length > 55 && (Ie = Ie.substring(0, 52).trim() + " ....");
        let Ct = pe.trim();
        Ct.length > 60 && (Ct = Ct.substring(0, 56).trim() + " ...");
        const Ht = G.image || se,
          Xt = kt(G, F),
          St = () => {
            if (ue) return "رابط آمن ومؤكد";
            switch (y) {
              case "dark-premium":
                return "★ VIP SECURE DEAL";
              case "minimal-white":
                return "✦ MINIMAL VERIFIED DEAL";
              case "gradient-neon":
                return "> VERIFIED_LINK_OK";
              case "soft-pastel":
                return "✨ VERIFIED SAFE DEAL";
              case "bold-magazine":
                return "★ OFFICIAL DEAL ★";
              case "elegant-gold":
                return "👑 VIP EXCLUSIVE PREVIEW";
              case "fresh-nature":
                return "🌿 100% ECO VERIFIED LINK";
              case "retro-pop":
                return "⚡ POWER LINK OK!";
              case "ultra-corporate":
                return "🔒 SECURE ENTERPRISE ROUTE";
              default:
                return "VERIFIED SECURE LINK";
            }
          },
          ba = () => {
            if (ue) return "🛡 معاينة متجر آمن ومؤكد";
            switch (y) {
              case "dark-premium":
                return "👑 VIP ACCESS • VERIFIED DIRECT RETAIL PREVIEW";
              case "minimal-white":
                return "✦ Authentic Retail Link Verified";
              case "gradient-neon":
                return "[SYS_STATUS] 100% SECURE ENCRYPTED ROUTE";
              case "soft-pastel":
                return "🌸 Verified Safe & Fast Direct Link";
              case "bold-magazine":
                return "★ VERIFIED DIRECT FROM OFFICIAL RETAILER ★";
              case "elegant-gold":
                return "⚜ Authenticated Member Preview Route";
              case "fresh-nature":
                return "🌱 Guaranteed Safe & Verified Retailer Route";
              case "retro-pop":
                return "💥 100% VERIFIED POP DEAL ROUTE!";
              case "ultra-corporate":
                return "🔒 256-BIT ENCRYPTED RETAIL PREVIEW";
              default:
                return "🛡 SECURED & VERIFIED RETAIL PREVIEW";
            }
          },
          Vt = (Y) => {
            const re = Y.match(/#[0-9a-fA-F]{6}|#[0-9a-fA-F]{3}/g) || [];
            let ve = 89;
            if (re.length > 0) {
              let _e = 0;
              (re.forEach((ht) => {
                let ye = ht.replace("#", "");
                ye.length === 3 &&
                  (ye = ye
                    .split("")
                    .map((Qe) => Qe + Qe)
                    .join(""));
                const dl = parseInt(ye.slice(0, 2), 16) || 0,
                  we = parseInt(ye.slice(2, 4), 16) || 0,
                  Fa = parseInt(ye.slice(4, 6), 16) || 0;
                _e += (dl * 299 + we * 587 + Fa * 114) / 1e3;
              }),
                (ve = _e / re.length));
            }
            if (ve > 165)
              return {
                isLight: !0,
                titleColor: "#0f172a",
                descColor: "#334155",
                verifColor: "#047857",
                buttonBg: "#0f172a",
                buttonTextColor: "#ffffff",
              };
            {
              const _e = re[0] || "#0071CE";
              let ht = _e,
                ye = _e.replace("#", "");
              ye.length === 3 &&
                (ye = ye
                  .split("")
                  .map((da) => da + da)
                  .join(""));
              const dl = parseInt(ye.slice(0, 2), 16) || 0,
                we = parseInt(ye.slice(2, 4), 16) || 0,
                Fa = parseInt(ye.slice(4, 6), 16) || 0;
              return (
                (dl * 299 + we * 587 + Fa * 114) / 1e3 > 200 &&
                  (ht = "#0071CE"),
                {
                  isLight: !1,
                  titleColor: "#ffffff",
                  descColor: "rgba(255, 255, 255, 0.88)",
                  verifColor: "#6ee7b7",
                  buttonBg: "#ffffff",
                  buttonTextColor: ht,
                }
              );
            }
          };
        if (F) {
          const Y = Vt(Ze);
          return l.jsx(
            "a",
            {
              href: Xt,
              target: "_top",
              rel: "nofollow noopener",
              className:
                "block w-full h-full select-none cursor-pointer no-underline text-left group",
              children: l.jsxs("div", {
                className: X.mainCardWrapperClass,
                style: {
                  background: Ze,
                  borderColor: Ze.includes("gradient") ? "transparent" : Ze,
                },
                children: [
                  l.jsxs("div", {
                    className: X.mainCardTopBarClass,
                    children: [
                      l.jsx("span", {
                        className: "text-emerald-400 font-bold",
                        children: "✔",
                      }),
                      l.jsx("span", { children: St() }),
                    ],
                  }),
                  l.jsxs("div", {
                    className:
                      "p-3.5 sm:p-4 flex flex-col flex-1 justify-between",
                    children: [
                      l.jsxs("div", {
                        className:
                          "flex items-center justify-between mb-2 shrink-0",
                        children: [
                          de !== !1
                            ? l.jsx("div", {
                                className:
                                  "inline-block bg-white/95 px-2 py-1 rounded-md shadow-sm border border-white/20 origin-left scale-90",
                                children: $e(Xt, Ie, G.store || Ge || U.name),
                              })
                            : l.jsx("div", {}),
                          oe(Ie, Ct, G),
                        ],
                      }),
                      l.jsx("div", {
                        className: X.mainCardImageBgClass,
                        children: Ht
                          ? l.jsx("img", {
                              src: Ht,
                              alt: Ie,
                              className:
                                "max-h-full max-w-full object-contain group-hover:scale-[1.03] transition-transform duration-200",
                              referrerPolicy: "no-referrer",
                              onError: (re) => {
                                const ve = re.target;
                                !ve.dataset.proxyTried && Ht
                                  ? ((ve.dataset.proxyTried = "true"),
                                    (ve.src = `/api/amazon-image-proxy?url=${encodeURIComponent(Ht)}`))
                                  : (ve.style.display = "none");
                              },
                            })
                          : l.jsx("div", {
                              className: "text-slate-300 text-3xl font-black",
                              children: "📦",
                            }),
                      }),
                      l.jsx("span", {
                        className: X.mainCardTitleClass,
                        style: { color: Y.titleColor },
                        title: ie,
                        children: Ie,
                      }),
                      l.jsx("p", {
                        className: X.mainCardDescClass,
                        style: { color: Y.descColor },
                        children: Ct,
                      }),
                      l.jsxs("div", {
                        className: `text-[10px] sm:text-[11px] uppercase font-bold tracking-wide mb-2 flex items-center gap-1.5 shrink-0 mt-auto ${X.mainCardVerifClass}`,
                        style: { color: Y.verifColor },
                        children: [
                          l.jsx("span", {
                            className:
                              "inline-block w-2 h-2 rounded-full animate-pulse shrink-0",
                            style: { backgroundColor: Y.verifColor },
                          }),
                          l.jsx("span", { children: ba() }),
                        ],
                      }),
                    ],
                  }),
                  l.jsx("div", {
                    className: "p-3 pt-0 shrink-0",
                    children: l.jsxs("div", {
                      className: X.mainCardButtonClass,
                      style: {
                        background: Y.buttonBg,
                        color: Y.buttonTextColor,
                      },
                      children: [
                        l.jsx("span", {
                          children: ue
                            ? "تأكيد والانتقال للمتجر"
                            : "CONFIRM & GO TO RETAILER",
                        }),
                        l.jsx("span", {
                          className: "text-sm font-bold",
                          children: "➔",
                        }),
                      ],
                    }),
                  }),
                ],
              }),
            },
            le,
          );
        }
        const Yt = Vt(Ze);
        return l.jsx(
          "a",
          {
            href: Xt,
            target: "_top",
            rel: "nofollow noopener",
            className:
              "block w-full h-full select-none cursor-pointer no-underline text-left group",
            children: l.jsxs("div", {
              className: X.sideCardWrapperClass,
              children: [
                l.jsxs("div", {
                  className: X.sideCardTopBarClass,
                  children: [
                    l.jsx("span", {
                      className: "text-emerald-400 font-bold",
                      children: "✔",
                    }),
                    l.jsx("span", { children: St() }),
                  ],
                }),
                l.jsxs("div", {
                  className:
                    "p-2.5 sm:p-3 flex flex-col flex-1 justify-between",
                  children: [
                    l.jsxs("div", {
                      className:
                        "flex items-center justify-between mb-1.5 shrink-0",
                      children: [
                        de !== !1
                          ? l.jsx("div", {
                              className: "inline-block scale-80 origin-left",
                              children: $e(Xt, Ie, G.store || Ge || U.name),
                            })
                          : l.jsx("div", {}),
                        oe(Ie, Ct, G),
                      ],
                    }),
                    l.jsx("div", {
                      className: X.sideCardImageBgClass,
                      children: Ht
                        ? l.jsx("img", {
                            src: Ht,
                            alt: Ie,
                            className:
                              "max-h-full max-w-full object-contain group-hover:scale-[1.02] transition-transform duration-200",
                            referrerPolicy: "no-referrer",
                            onError: (Y) => {
                              const re = Y.target;
                              !re.dataset.proxyTried && Ht
                                ? ((re.dataset.proxyTried = "true"),
                                  (re.src = `/api/amazon-image-proxy?url=${encodeURIComponent(Ht)}`))
                                : (re.style.display = "none");
                            },
                          })
                        : l.jsx("div", {
                            className: "text-slate-300 text-2xl font-black",
                            children: "📦",
                          }),
                    }),
                    l.jsx("span", {
                      className: X.sideCardTitleClass,
                      title: ie,
                      children: Ie,
                    }),
                    l.jsx("p", {
                      className: X.sideCardDescClass,
                      children: Ct,
                    }),
                    l.jsxs("div", {
                      className: `text-[9px] sm:text-[10px] uppercase font-bold tracking-wide mb-1.5 flex items-center gap-1 shrink-0 mt-auto ${X.sideCardVerifClass}`,
                      children: [
                        l.jsx("span", {
                          className:
                            "inline-block w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse shrink-0",
                        }),
                        l.jsx("span", { children: ba() }),
                      ],
                    }),
                  ],
                }),
                l.jsx("div", {
                  className: "p-2.5 pt-0 shrink-0",
                  children: l.jsxs("div", {
                    className: X.sideCardButtonClass,
                    style: {
                      background: Yt.isLight ? "#0f172a" : Ze,
                      color: "#ffffff",
                    },
                    children: [
                      l.jsx("span", {
                        children: ue
                          ? "تأكيد والانتقال للمتجر"
                          : "CONFIRM & GO TO RETAILER",
                      }),
                      l.jsx("span", {
                        className: "text-xs font-bold",
                        children: "➔",
                      }),
                    ],
                  }),
                }),
              ],
            }),
          },
          le,
        );
      },
      H = Ve
        ? {
            backgroundImage: `linear-gradient(rgba(10, 25, 47, 0.4), rgba(10, 25, 47, 0.5)), url('${U.heroImg || "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=1920&q=80"}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
          }
        : void 0;
    return l.jsxs("div", {
      className: `min-h-screen w-full select-none overflow-y-auto ${Ve ? "relative" : X.containerBg}`,
      style: H,
      dir: ue ? "rtl" : "ltr",
      children: [
        l.jsx("header", {
          className: `w-full ${X.headerBgClass || `${U.headerBg} text-white`} px-4 sm:px-6 py-2.5 shadow-md`,
          children: l.jsxs("div", {
            className: "max-w-7xl mx-auto flex items-center justify-between",
            children: [
              l.jsx("div", {
                className: "scale-100 origin-left",
                children: U.logoComponent,
              }),
              l.jsx("div", {
                className:
                  "font-serif sm:font-sans font-bold text-xs sm:text-sm tracking-wide text-current opacity-90 drop-shadow-xs",
                children: ue
                  ? "أفضل صفقات اليوم الأكثر مبيعاً"
                  : "Today's Best-Selling Deals",
              }),
            ],
          }),
        }),
        l.jsxs("section", {
          className: `w-full relative overflow-hidden ${X.heroBgClass || `bg-gradient-to-r ${U.heroBgGradient}`} py-3 sm:py-4 px-4 text-white text-center shadow-md border-b border-white/10`,
          children: [
            l.jsx("img", {
              src: U.heroImg,
              alt: "Hero Retail",
              className:
                "absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-overlay pointer-events-none",
            }),
            l.jsxs("div", {
              className: "relative z-10 max-w-4xl mx-auto space-y-0.5",
              children: [
                l.jsx("h1", {
                  className: X.heroTextClass,
                  children: ue
                    ? "وجهتك الأولى للتوفير والتسوق"
                    : "YOUR ONE-STEP SHOP FOR SAVINGS",
                }),
                l.jsx("p", {
                  className: X.heroSubtextClass,
                  children: l.jsx("span", {
                    children: ue
                      ? "أسعار منخفضة • توصيل سريع • تشكيلة واسعة"
                      : "LOW PRICES • FAST DELIVERY • GREAT VARIETY",
                  }),
                }),
              ],
            }),
          ],
        }),
        l.jsxs("main", {
          className: "max-w-[1480px] mx-auto py-5 sm:py-7 px-3 sm:px-6",
          children: [
            it
              ? l.jsxs("div", {
                  className: "w-full",
                  children: [
                    nt <= 2 &&
                      l.jsxs("div", {
                        className:
                          "flex flex-col md:flex-row items-stretch justify-center gap-3.5 sm:gap-4 max-w-5xl mx-auto w-full px-1",
                        children: [
                          l.jsx("div", {
                            className:
                              "w-full md:w-[270px] lg:w-[300px] shrink-0 order-2 md:order-1 flex flex-col justify-center",
                            children: C[0] && O(C[0], !1, 0),
                          }),
                          l.jsx("div", {
                            className:
                              "w-full md:w-[310px] lg:w-[350px] shrink-0 z-10 order-1 md:order-2 flex flex-col justify-center",
                            children: O(Pe, !0),
                          }),
                          l.jsx("div", {
                            className:
                              "w-full md:w-[270px] lg:w-[300px] shrink-0 order-3 md:order-3 flex flex-col justify-center",
                            children: D[0] && O(D[0], !1, 1),
                          }),
                        ],
                      }),
                    nt > 2 &&
                      nt <= 4 &&
                      l.jsxs("div", {
                        className:
                          "flex flex-col lg:flex-row items-stretch justify-center gap-3.5 sm:gap-4 max-w-6xl mx-auto w-full px-1",
                        children: [
                          l.jsx("div", {
                            className:
                              "flex flex-col gap-3.5 w-full lg:w-[260px] xl:w-[290px] shrink-0 order-2 lg:order-1 justify-center",
                            children: C.map((G, F) =>
                              l.jsx(
                                "div",
                                {
                                  className: "w-full h-full",
                                  children: O(G, !1, F),
                                },
                                F,
                              ),
                            ),
                          }),
                          l.jsx("div", {
                            className:
                              "w-full lg:w-[300px] xl:w-[340px] shrink-0 z-10 order-1 lg:order-2 flex flex-col justify-center",
                            children: O(Pe, !0),
                          }),
                          l.jsx("div", {
                            className:
                              "flex flex-col gap-3.5 w-full lg:w-[260px] xl:w-[290px] shrink-0 order-3 lg:order-3 justify-center",
                            children: D.map((G, F) =>
                              l.jsx(
                                "div",
                                {
                                  className: "w-full h-full",
                                  children: O(G, !1, C.length + F),
                                },
                                F,
                              ),
                            ),
                          }),
                        ],
                      }),
                    nt > 4 &&
                      l.jsxs("div", {
                        className:
                          "flex flex-col xl:flex-row items-stretch justify-center gap-3.5 sm:gap-4 max-w-[1480px] mx-auto w-full px-1",
                        children: [
                          l.jsx("div", {
                            className:
                              "grid grid-cols-1 sm:grid-cols-2 gap-3.5 w-full xl:w-[520px] shrink-0 order-2 xl:order-1 content-center",
                            children: C.map((G, F) =>
                              l.jsx(
                                "div",
                                {
                                  className: "w-full h-full",
                                  children: O(G, !1, F),
                                },
                                F,
                              ),
                            ),
                          }),
                          l.jsx("div", {
                            className:
                              "w-full xl:w-[320px] shrink-0 z-10 order-1 xl:order-2 flex flex-col justify-center",
                            children: O(Pe, !0),
                          }),
                          l.jsx("div", {
                            className:
                              "grid grid-cols-1 sm:grid-cols-2 gap-3.5 w-full xl:w-[520px] shrink-0 order-3 xl:order-3 content-center",
                            children: D.map((G, F) =>
                              l.jsx(
                                "div",
                                {
                                  className: "w-full h-full",
                                  children: O(G, !1, C.length + F),
                                },
                                F,
                              ),
                            ),
                          }),
                        ],
                      }),
                  ],
                })
              : l.jsx("div", {
                  className: "max-w-[340px] mx-auto",
                  children: O(Pe, !0),
                }),
            l.jsxs("div", {
              className:
                "max-w-4xl mx-auto mt-6 mb-3 bg-[#081026] text-white rounded-2xl p-4 sm:p-5 shadow-xl border border-slate-800 text-center space-y-2",
              children: [
                l.jsx("div", {
                  className:
                    "text-[10px] sm:text-xs font-black uppercase tracking-widest text-slate-300 flex items-center justify-center gap-1.5",
                  children: l.jsx("span", {
                    children: "🛡 TRUST & SECURITY CENTER",
                  }),
                }),
                l.jsxs("div", {
                  className:
                    "grid grid-cols-1 sm:grid-cols-3 gap-3 py-2 border-t border-slate-800/80",
                  children: [
                    l.jsxs("div", {
                      className: "flex items-center justify-center gap-2",
                      children: [
                        l.jsx("div", {
                          className:
                            "w-7 h-7 rounded-full bg-blue-500/10 border border-blue-500/30 flex items-center justify-center text-blue-400 text-xs shrink-0",
                          children: "🛡️",
                        }),
                        l.jsxs("div", {
                          className: "text-left",
                          children: [
                            l.jsx("div", {
                              className:
                                "font-extrabold text-xs text-white leading-tight",
                              children: U.partnerName,
                            }),
                            l.jsx("p", {
                              className:
                                "text-[10px] text-slate-400 leading-tight",
                              children: "Verified retail catalog",
                            }),
                          ],
                        }),
                      ],
                    }),
                    l.jsxs("div", {
                      className: "flex items-center justify-center gap-2",
                      children: [
                        l.jsx("div", {
                          className:
                            "w-7 h-7 rounded-full bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center text-emerald-400 text-xs shrink-0",
                          children: "🔒",
                        }),
                        l.jsxs("div", {
                          className: "text-left",
                          children: [
                            l.jsx("div", {
                              className:
                                "font-extrabold text-xs text-white leading-tight",
                              children: "Secure Transaction",
                            }),
                            l.jsx("p", {
                              className:
                                "text-[10px] text-slate-400 leading-tight",
                              children: "256-bit SSL Encrypted",
                            }),
                          ],
                        }),
                      ],
                    }),
                    l.jsxs("div", {
                      className: "flex items-center justify-center gap-2",
                      children: [
                        l.jsx("div", {
                          className:
                            "w-7 h-7 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center text-amber-400 text-xs shrink-0",
                          children: "🚚",
                        }),
                        l.jsxs("div", {
                          className: "text-left",
                          children: [
                            l.jsx("div", {
                              className:
                                "font-extrabold text-xs text-white leading-tight",
                              children: "Fast & Reliable Shipping",
                            }),
                            l.jsx("p", {
                              className:
                                "text-[10px] text-slate-400 leading-tight",
                              children: "Direct to Store",
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      ],
    });
  }
  return l.jsx("div", {
    className:
      "min-h-screen w-full bg-[#0f172a] flex items-center justify-center p-4 sm:p-6 select-none overflow-y-auto",
    dir: ue ? "rtl" : "ltr",
    style: { background: ke },
    children: l.jsxs("div", {
      className:
        "w-full text-center animate-[revealUp_0.3s_cubic-bezier(0.16,1,0.3,1)_forwards] py-4 sm:py-8",
      children: [
        f === "resolving" &&
          l.jsx("div", {
            className: "space-y-3 max-w-md mx-auto py-12",
            children: l.jsx("div", {
              className:
                "w-8 h-8 mx-auto rounded-full border-3 border-white/20 border-t-white animate-spin",
            }),
          }),
        it
          ? l.jsxs("div", {
              className: "w-full",
              children: [
                nt <= 2 &&
                  l.jsxs("div", {
                    className:
                      "flex flex-col md:flex-row items-center justify-center gap-5 sm:gap-7 max-w-6xl mx-auto w-full px-2",
                    children: [
                      l.jsx("div", {
                        className:
                          "w-full md:w-[280px] lg:w-[320px] shrink-0 order-2 md:order-1",
                        children: C[0] && Oe(C[0], !1, 0),
                      }),
                      l.jsx("div", {
                        className:
                          "w-full md:w-[380px] lg:w-[440px] shrink-0 z-10 shadow-2xl order-1 md:order-2",
                        children: Oe(Pe, !0),
                      }),
                      l.jsx("div", {
                        className:
                          "w-full md:w-[280px] lg:w-[320px] shrink-0 order-3 md:order-3",
                        children: D[0] && Oe(D[0], !1, 1),
                      }),
                    ],
                  }),
                nt > 2 &&
                  nt <= 4 &&
                  l.jsxs("div", {
                    className:
                      "flex flex-col lg:flex-row items-center justify-center gap-5 sm:gap-7 max-w-7xl mx-auto w-full px-2",
                    children: [
                      l.jsx("div", {
                        className:
                          "flex flex-col gap-4.5 w-full lg:w-[280px] xl:w-[310px] shrink-0 order-2 lg:order-1",
                        children: C.map((U, y) =>
                          l.jsx(
                            "div",
                            { className: "w-full", children: Oe(U, !1, y) },
                            y,
                          ),
                        ),
                      }),
                      l.jsx("div", {
                        className:
                          "w-full lg:w-[400px] xl:w-[460px] shrink-0 z-10 shadow-2xl order-1 lg:order-2",
                        children: Oe(Pe, !0),
                      }),
                      l.jsx("div", {
                        className:
                          "flex flex-col gap-4.5 w-full lg:w-[280px] xl:w-[310px] shrink-0 order-3 lg:order-3",
                        children: D.map((U, y) =>
                          l.jsx(
                            "div",
                            {
                              className: "w-full",
                              children: Oe(U, !1, C.length + y),
                            },
                            y,
                          ),
                        ),
                      }),
                    ],
                  }),
                nt > 4 &&
                  l.jsxs("div", {
                    className:
                      "flex flex-col xl:flex-row items-center justify-center gap-5 sm:gap-7 max-w-[1600px] mx-auto w-full px-2",
                    children: [
                      l.jsx("div", {
                        className:
                          "grid grid-cols-1 sm:grid-cols-2 gap-4 w-full xl:w-[540px] shrink-0 order-2 xl:order-1",
                        children: C.map((U, y) =>
                          l.jsx(
                            "div",
                            { className: "w-full", children: Oe(U, !1, y) },
                            y,
                          ),
                        ),
                      }),
                      l.jsx("div", {
                        className:
                          "w-full xl:w-[420px] shrink-0 z-10 shadow-2xl order-1 xl:order-2",
                        children: Oe(Pe, !0),
                      }),
                      l.jsx("div", {
                        className:
                          "grid grid-cols-1 sm:grid-cols-2 gap-4 w-full xl:w-[540px] shrink-0 order-3 xl:order-3",
                        children: D.map((U, y) =>
                          l.jsx(
                            "div",
                            {
                              className: "w-full",
                              children: Oe(U, !1, C.length + y),
                            },
                            y,
                          ),
                        ),
                      }),
                    ],
                  }),
              ],
            })
          : f === "preview" &&
            b &&
            l.jsx("div", {
              className: "max-w-md mx-auto",
              children: Oe(Pe, !0),
            }),
        !1,
        f === "config" &&
          l.jsxs("div", {
            className:
              "max-w-md mx-auto bg-slate-900 border border-slate-800 rounded-[22px] p-8 shadow-2xl space-y-4 text-white",
            children: [
              l.jsx("div", { className: "text-4xl", children: "⚙️" }),
              l.jsx("h2", {
                className: "text-xl font-extrabold text-white",
                children: ue ? jt.configTitle.ar : jt.configTitle.en,
              }),
              l.jsx("p", {
                className: "text-sm text-slate-300 leading-relaxed",
                children: ue ? jt.configSub.ar : jt.configSub.en,
              }),
              l.jsx("button", {
                onClick: h,
                className:
                  "block w-full py-2.5 bg-rose-500 text-white font-extrabold text-center rounded-xl shadow cursor-pointer transition-all hover:brightness-105 text-xs",
                children: ue ? jt.goHome.ar : jt.goHome.en,
              }),
            ],
          }),
      ],
    }),
  });
}
const lm = `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE html>
<html b:version='2' class='v2' dir='ltr' lang='en' xmlns='http://www.w3.org/1999/xhtml' xmlns:b='http://www.google.com/2005/gml/b' xmlns:data='http://www.google.com/2005/gml/data' xmlns:expr='http://www.google.com/2005/gml/expr'>
<head>

<!--
  ===============================================================
  EVERYTHING YOU CAN CHANGE
  ===============================================================
-->

<meta charset='UTF-8'/>
<meta content='width=device-width, initial-scale=1, viewport-fit=cover' name='viewport'/>
<meta content='#1668e3' name='theme-color'/>

<!-- ================= SEO ================= -->
<title><data:blog.title/></title>
<b:if cond='data:blog.metaDescription'>
  <meta expr:content='data:blog.metaDescription' name='description'/>
  <meta expr:content='data:blog.metaDescription' property='og:description'/>
  <meta expr:content='data:blog.metaDescription' name='twitter:description'/>
<b:else/>
  <meta content='Free URL shortener for crypto marketing and affiliate campaigns. Clean, branded short links for Facebook, Instagram, TikTok, YouTube, X, Telegram and Discord.' name='description'/>
  <meta content='Free URL shortener for crypto marketing and affiliate campaigns.' property='og:description'/>
  <meta content='Free URL shortener for crypto marketing and affiliate campaigns.' name='twitter:description'/>
</b:if>
<meta content='url shortener, link shortener, short link, crypto marketing links, affiliate link shortener, branded short links' name='keywords'/>
<meta content='index, follow, max-snippet:-1, max-image-preview:large' name='robots'/>
<link expr:href='data:blog.homepageUrl' rel='canonical'/>
<link expr:href='data:blog.homepageUrl' hreflang='en' rel='alternate'/>
<link expr:href='data:blog.homepageUrl' hreflang='ar' rel='alternate'/>
<link expr:href='data:blog.homepageUrl' hreflang='x-default' rel='alternate'/>

<!-- ================= SITEMAP ================= -->
<link expr:href='data:blog.homepageUrl + &quot;sitemap.xml&quot;' rel='sitemap' type='application/xml'/>
<link expr:href='data:blog.homepageUrl + &quot;sitemap-pages.xml&quot;' rel='sitemap' type='application/xml'/>
<link expr:href='data:blog.homepageUrl + &quot;feeds/posts/default&quot;' expr:title='data:blog.title + &quot; - Atom&quot;' rel='alternate' type='application/atom+xml'/>

<!-- ================= VERIFICATION ================= -->
<b:if cond='"{VERIFY_GOOGLE}" != ""'><meta content='{VERIFY_GOOGLE}' name='google-site-verification'/></b:if>
<b:if cond='"{VERIFY_BING}" != ""'><meta content='{VERIFY_BING}' name='msvalidate.01'/></b:if>
<b:if cond='"{VERIFY_YANDEX}" != ""'><meta content='{VERIFY_YANDEX}' name='yandex-verification'/></b:if>

<!-- ================= SHARE CARD ================= -->
<meta expr:content='data:blog.title' property='og:title'/>
<meta expr:content='data:blog.title' name='twitter:title'/>
<meta content='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYAAjoklYEHgxoz8cyc4PGApG7lwIhVjoYWhFyipsmk6DlzB8YNLOrw5rp&s=10' id='ogImg' property='og:image'/>
<meta content='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYAAjoklYEHgxoz8cyc4PGApG7lwIhVjoYWhFyipsmk6DlzB8YNLOrw5rp&s=10' id='twImg' name='twitter:image'/>
<meta content='1200' property='og:image:width'/>
<meta content='630' property='og:image:height'/>
<meta content='website' property='og:type'/>
<meta expr:content='data:blog.title' property='og:site_name'/>
<meta content='en_US' property='og:locale'/>
<meta content='ar_AR' property='og:locale:alternate'/>
<meta expr:content='data:blog.url' property='og:url'/>
<meta content='summary_large_image' name='twitter:card'/>

<link href='https://pagead2.googlesyndication.com' rel='dns-prefetch'/>
<link href='https://yandex.ru' rel='dns-prefetch'/>

<script type='application/ld+json'>
{
  "@context": "https://schema.org",
  "@type": "WebApplication",
  "name": "Link Shortener",
  "applicationCategory": "UtilitiesApplication",
  "operatingSystem": "All",
  "description": "Free URL shortener that creates clean branded short links for crypto marketing, affiliate campaigns and social media platforms.",
  "inLanguage": ["en", "ar"],
  "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
}
<\/script>
<script type='application/ld+json'>
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Is this URL shortener free?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes. Creating short links is completely free and no account is required." }
    },
    {
      "@type": "Question",
      "name": "Do the short links work on Facebook and WhatsApp?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes. Turn on the preview page option to add a Continue screen, which is the safest way to share links on Facebook, WhatsApp and Telegram." }
    },
    {
      "@type": "Question",
      "name": "Can I use short links for affiliate and crypto campaigns?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes. The links work with affiliate and influencer networks such as Mavely, Collective Voice, Shopyoulikes, Amazon Associates, ShareASale, ClickBank, Impact and CJ Affiliate." }
    },
    {
      "@type": "Question",
      "name": "Do short links expire?",
      "acceptedAnswer": { "@type": "Answer", "text": "No. A short link stays active until it is removed. If a link ever stops working, use the alternative site listed on this page." }
    }
  ]
}
<\/script>

<b:skin><![CDATA[
/* ===================== TOKENS: blue + white ===================== */
:root{
  --blue:#1668e3; --blue-d:#0f4fb0; --blue-l:#3b8bff; --sky:#28b4f5;
  --ink:#0d1b2f; --slate:#4a5a70; --line:#e3ebf5;
  --bg:#ffffff; --bg-soft:#f3f8ff; --bg-tint:#eaf3ff;
  --card:#ffffff; --btn-ink:#ffffff; --nav-bg:rgba(255,255,255,.9);
  --hero1:#dcecff; --hero2:#eef5ff; --foot-bg:#0d1b2f; --foot-ink:#c9d6e6; --foot-dim:#9db0c7;
  --wa:#0f7d3f; --fb:#1461c9; --tg:#16708f; --yt:#c8001f;
  --r:16px; --r-lg:22px;
  --sh-sm:0 2px 8px rgba(13,27,47,.06);
  --sh:0 14px 34px -14px rgba(13,50,110,.28);
  --sh-lg:0 30px 60px -24px rgba(13,50,110,.38);
  --font:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Kufi Arabic","Segoe UI Arabic",sans-serif;
}
/* ===================== PALETTES ===================== */
body.p-emerald{
  --blue:#0a7a52; --blue-d:#05563a; --blue-l:#12a56f; --sky:#34d399;
  --ink:#0c2118; --slate:#456155; --line:#dcece5;
  --bg-soft:#f2fbf7; --bg-tint:#dff5ec;
  --hero1:#d7f5e7; --hero2:#eefaf4; --foot-bg:#08281c; --foot-ink:#c6e5d8; --foot-dim:#93bfab;
  --sh:0 14px 34px -14px rgba(5,86,58,.28);
  --sh-lg:0 30px 60px -24px rgba(5,86,58,.38);
}
body.p-violet{
  --blue:#6d28d9; --blue-d:#4c1d95; --blue-l:#8b5cf6; --sky:#a78bfa;
  --ink:#1b1230; --slate:#574a72; --line:#e6e0f7;
  --bg-soft:#f8f5ff; --bg-tint:#e9e1ff;
  --hero1:#e6dbff; --hero2:#f4efff; --foot-bg:#1a1033; --foot-ink:#d6cbf0; --foot-dim:#a99cc9;
  --sh:0 14px 34px -14px rgba(76,29,149,.28);
  --sh-lg:0 30px 60px -24px rgba(76,29,149,.38);
}
body.p-amber{
  --blue:#c2410c; --blue-d:#9a3412; --blue-l:#f97316; --sky:#fbbf24;
  --ink:#2a1608; --slate:#6b5140; --line:#f2e2d6;
  --bg-soft:#fff7f1; --bg-tint:#ffe4cf;
  --hero1:#ffe0c8; --hero2:#fff3e9; --foot-bg:#2b1607; --foot-ink:#f0dbc8; --foot-dim:#c2a48c;
  --sh:0 14px 34px -14px rgba(154,52,18,.28);
  --sh-lg:0 30px 60px -24px rgba(154,52,18,.38);
}
body.p-dark{
  --blue:#e0b23c; --blue-d:#c99b2c; --blue-l:#f2ca62; --sky:#f6d98a;
  --ink:#e9eff8; --slate:#a3b3c7; --line:#27374e;
  --bg:#0b1424; --bg-soft:#152238; --bg-tint:#1e3050;
  --card:#131f33; --btn-ink:#14213a; --nav-bg:rgba(11,20,36,.92);
  --hero1:#1a2b47; --hero2:#111d31; --foot-bg:#060d18; --foot-ink:#e9eff8; --foot-dim:#8fa1b8;
  --sh-sm:0 2px 8px rgba(0,0,0,.35);
  --sh:0 14px 34px -14px rgba(0,0,0,.6);
  --sh-lg:0 30px 60px -24px rgba(0,0,0,.7);
}
body.p-dark .copy{background:var(--blue);color:var(--btn-ink)}
body.p-dark .x{background:var(--bg-tint);color:var(--blue)}
body.p-dark .field::placeholder,body.p-dark .out input::placeholder{color:#8fa1b8}

*{box-sizing:border-box;margin:0;padding:0}
html{-webkit-text-size-adjust:100%;scroll-behavior:smooth}
body{
  font-family:var(--font);color:var(--ink);line-height:1.6;background:var(--bg);
  overflow-x:hidden;
}
img{max-width:100%;height:auto}
a{color:var(--blue-d)}
:focus-visible{outline:3px solid #ffcf3d;outline-offset:2px;border-radius:8px}
.wrap{max-width:1280px;margin:0 auto;padding:0 18px}

#shCfg{display:none}

/* ===================== NAV ===================== */
.nav{
  position:sticky;top:0;z-index:40;background:var(--nav-bg);
  backdrop-filter:blur(12px);border-bottom:1px solid var(--line);
}
.nav-in{display:flex;align-items:center;gap:14px;flex-wrap:wrap;padding:12px 18px;max-width:1280px;margin:0 auto}
.brand{display:flex;align-items:center;gap:9px;font-weight:800;font-size:18px;letter-spacing:-.01em;text-decoration:none;color:var(--ink)}
.brand i{
  width:32px;height:32px;border-radius:9px;display:grid;place-items:center;font-style:normal;
  background:linear-gradient(135deg,var(--blue-l),var(--blue-d));color:var(--btn-ink);font-size:15px;
}
.social{display:flex;gap:7px;flex-wrap:wrap;margin-inline-start:auto}
.social a{
  color:#fff;text-decoration:none;font-weight:700;font-size:13px;padding:8px 13px;border-radius:9px;
  transition:transform .15s ease,filter .15s ease;
}
.social a:hover{transform:translateY(-2px);filter:brightness(1.12)}
.s-wa{background:var(--wa)} .s-fb{background:var(--fb)} .s-tg{background:var(--tg)} .s-yt{background:var(--yt)}
.lang{display:flex;gap:6px}
.lang button{
  font-family:inherit;font-size:13px;font-weight:700;cursor:pointer;padding:8px 16px;border-radius:9px;
  border:1px solid var(--line);background:var(--card);color:var(--slate);transition:all .15s ease;
}
.lang button:hover{border-color:var(--blue-l);color:var(--blue-d)}
.lang button[aria-pressed="true"]{background:var(--blue);border-color:var(--blue);color:var(--btn-ink)}

/* ===================== HERO ===================== */
.hero{position:relative;padding:52px 0 60px;overflow:hidden}
.hero::before{
  content:"";position:absolute;inset:0;z-index:-1;
  background:
    radial-gradient(900px 380px at 82% 12%, var(--hero1) 0%, rgba(255,255,255,0) 65%),
    radial-gradient(700px 340px at 8% 0%, var(--hero2) 0%, rgba(255,255,255,0) 60%);
}
.hero-grid{display:grid;grid-template-columns:1.05fr .95fr;gap:44px;align-items:center}
.pill{
  display:inline-flex;align-items:center;gap:8px;background:var(--card);border:1px solid var(--line);
  border-radius:999px;padding:7px 15px;font-size:13px;font-weight:600;color:var(--slate);
  box-shadow:var(--sh-sm);margin-bottom:20px;
}
.pill b{color:var(--blue)}
.dot{width:7px;height:7px;border-radius:50%;background:#16a34a;box-shadow:0 0 0 3px rgba(22,163,74,.16)}
h1{font-size:clamp(30px,4.4vw,50px);line-height:1.1;font-weight:800;letter-spacing:-.025em;margin-bottom:16px}
.type{color:var(--blue);white-space:nowrap}
.caret{display:inline-block;width:3px;height:.92em;background:var(--blue);vertical-align:-.08em;margin-inline-start:4px;animation:blink 1s steps(2) infinite}
@keyframes blink{50%{opacity:0}}
.lead{font-size:17px;color:var(--slate);max-width:560px;margin-bottom:26px}

/* ---- the shortener form ---- */
.form{
  background:var(--card);border:1px solid var(--line);border-radius:var(--r-lg);
  padding:12px;box-shadow:var(--sh);max-width:600px;
}
.row{display:flex;gap:10px;align-items:center}
.field{
  flex:1;min-width:0;outline:none;font-family:inherit;font-size:16px;color:var(--ink);
  padding:14px 15px;border-radius:12px;
  border:2px solid var(--line);background:var(--bg-soft);
  transition:border-color .15s ease,background .15s ease,box-shadow .15s ease;
}
.field::placeholder{color:#7a8798;opacity:1}
.field:hover{border-color:#c9dcf5}
.field:focus{border-color:var(--blue);background:var(--card);box-shadow:0 0 0 4px rgba(127,127,127,.16)}
.cta{
  border:0;border-radius:12px;padding:14px 26px;color:var(--btn-ink);font-family:inherit;font-size:15px;font-weight:800;
  cursor:pointer;white-space:nowrap;background:linear-gradient(135deg,var(--blue-l),var(--blue-d));
  box-shadow:0 12px 22px -12px rgba(15,79,176,.95);transition:transform .12s ease,filter .12s ease;
}
.cta:hover{transform:translateY(-1px);filter:brightness(1.06)}
.cta:active{transform:scale(.985)}
.cta[disabled]{opacity:.7;cursor:progress}
.opt{display:flex;align-items:center;gap:9px;padding:8px 14px 4px;font-size:13.5px;color:var(--slate);cursor:pointer}
.opt input{width:17px;height:17px;accent-color:var(--blue);flex:0 0 auto}
.out{display:flex;gap:10px;padding:10px 4px 4px}
.out input{
  flex:1;min-width:0;border:2px solid var(--line);background:var(--bg-soft);border-radius:12px;
  padding:13px 14px;font-family:inherit;font-weight:700;font-size:15px;color:var(--blue-d);outline:none;
}
.out input::placeholder{color:#7a8798;font-weight:600;opacity:1}
.copy{
  border:0;border-radius:12px;padding:0 20px;font-family:inherit;font-weight:800;font-size:14px;
  color:var(--card);background:var(--ink);cursor:pointer;white-space:nowrap;
}
.copy:hover{filter:brightness(1.35)}
.msg{min-height:20px;padding:4px 6px 0;font-size:13.5px;font-weight:600;color:#c81e1e;text-align:center;word-break:break-word}
.msg.ok{color:#0b7a3f}
.ticks{list-style:none;display:flex;flex-wrap:wrap;gap:16px;margin-top:22px}
.ticks li{display:flex;align-items:center;gap:7px;font-size:14px;color:var(--slate);font-weight:600}
.ticks svg{flex:0 0 auto}

/* ---- hero art ---- */
.art{position:relative;min-height:380px}
.board{
  position:relative;border-radius:26px;padding:22px;
  background:linear-gradient(140deg,var(--sky),var(--blue));
  box-shadow:var(--sh-lg);
}
.mini{
  background:var(--card);border-radius:14px;padding:14px 16px;box-shadow:0 10px 24px -12px rgba(0,0,0,.35);
  display:flex;align-items:center;gap:12px;
}
.mini .ico{
  width:36px;height:36px;border-radius:10px;flex:0 0 auto;display:grid;place-items:center;
  background:var(--bg-tint);color:var(--blue-d);font-size:17px;
}
.mini .t{font-weight:800;font-size:14px}
.mini .u{font-size:12.5px;color:var(--slate);word-break:break-all}
.mini .n{margin-inline-start:auto;font-weight:800;color:#0b7a3f;font-size:13px;white-space:nowrap}
.panel{background:var(--card);border-radius:14px;padding:16px;margin-top:14px;box-shadow:0 10px 24px -12px rgba(0,0,0,.35)}
.panel-h{display:flex;align-items:baseline;gap:8px;margin-bottom:6px}
.panel-h .k{font-weight:800;font-size:14px}
.panel-h .up{color:#0b7a3f;font-weight:800;font-size:13px}
.panel-h .tot{margin-inline-start:auto;font-size:13px;color:var(--slate);font-weight:700}
.chip{
  position:absolute;background:var(--card);border-radius:12px;padding:10px 14px;font-weight:800;font-size:13px;
  box-shadow:var(--sh);display:flex;align-items:center;gap:8px;
}
.chip .b{width:26px;height:26px;border-radius:8px;background:var(--blue);color:var(--btn-ink);display:grid;place-items:center;font-size:13px}
.c1{top:-14px;inset-inline-start:-10px;animation:float 5s ease-in-out infinite}
.c2{bottom:-16px;inset-inline-end:-8px;animation:float 6s ease-in-out infinite .6s}
.c3{bottom:52px;inset-inline-start:-26px;animation:float 5.5s ease-in-out infinite 1.2s}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-9px)}}
.spark{stroke:var(--blue);stroke-width:2.5;fill:none;stroke-linecap:round;stroke-linejoin:round}
.spark-dot{fill:var(--blue)}
#g1 stop:first-child{stop-color:var(--blue)}
#g1 stop:last-child{stop-color:var(--card)}
.spark-fill{fill:url(#g1);opacity:.18}
.draw{stroke-dasharray:520;stroke-dashoffset:520;animation:draw 1.8s ease forwards .3s}
@keyframes draw{to{stroke-dashoffset:0}}

/* ===================== REVEAL ===================== */
.rv{opacity:0;transform:translateY(18px);transition:opacity .6s ease,transform .6s ease}
.rv.in{opacity:1;transform:none}

/* ===================== CONTENT + ADS ===================== */
.body-grid{
  display:grid;grid-template-columns:300px minmax(0,1fr) 300px;gap:22px;
  align-items:start;padding:38px 0 20px;
}
.rail{position:sticky;top:78px}
.ad{
  background:var(--bg-soft);border:1px solid var(--line);border-radius:var(--r);min-height:600px;
  display:flex;align-items:center;justify-content:center;overflow:hidden;
}
.ad span{font-size:11.5px;letter-spacing:.1em;text-transform:uppercase;color:var(--slate)}
.ad-mob{display:none;min-height:280px;margin:22px 0}

.card{
  background:var(--card);border:1px solid var(--line);border-radius:var(--r-lg);
  padding:24px;margin-bottom:20px;box-shadow:var(--sh-sm);
}
.eyebrow{font-size:11.5px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:var(--blue);margin-bottom:8px}
.card h2{font-size:20px;font-weight:800;letter-spacing:-.015em;margin-bottom:8px}
.card p{color:var(--slate);font-size:15px}

.notice{background:var(--bg-soft);border:1px solid var(--bg-tint);text-align:center}
.notice h2{color:var(--blue-d)}
.alt{
  display:block;text-align:center;text-decoration:none;color:var(--btn-ink);font-size:18px;font-weight:800;
  padding:18px;border-radius:var(--r);margin-bottom:20px;
  background:linear-gradient(135deg,var(--blue-l),var(--blue-d));
  box-shadow:0 18px 34px -18px rgba(15,79,176,.95);
  transition:transform .12s ease,filter .12s ease;
}
.alt:hover{transform:translateY(-2px);filter:brightness(1.08)}

.feats{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-top:14px}
.feat{border:1px solid var(--line);border-radius:14px;padding:16px;background:var(--bg-soft)}
.feat h3{font-size:15px;font-weight:800;margin-bottom:4px}
.feat p{font-size:13.5px}
.faq details{border-bottom:1px solid var(--line);padding:13px 0}
.faq details:last-child{border-bottom:0}
.faq summary{font-weight:700;font-size:15px;cursor:pointer;list-style:none}
.faq summary::-webkit-details-marker{display:none}
.faq summary::before{content:"+ ";color:var(--blue);font-weight:800}
.faq details[open] summary::before{content:"\\2212 "}
.faq p{margin-top:8px;font-size:14px}

/* ===================== FOOTER ===================== */
footer{background:var(--foot-bg);color:var(--foot-ink);margin-top:30px;padding:26px 0}
footer nav{display:flex;flex-wrap:wrap;justify-content:center;gap:4px}
footer button{
  font-family:inherit;font-size:13.5px;font-weight:700;color:#fff;background:none;border:0;
  padding:8px 12px;border-radius:8px;cursor:pointer;
}
footer button:hover{background:rgba(255,255,255,.12)}
footer a{color:#fff;font-size:13.5px;font-weight:700;padding:8px 12px;text-decoration:none}
footer a:hover{text-decoration:underline}
.legal{text-align:center;font-size:12.5px;margin-top:10px;color:var(--foot-dim)}

/* ===================== DOC MODAL ===================== */
.docs{display:none;position:fixed;inset:0;z-index:60;background:rgba(8,20,38,.6);padding:16px;overflow-y:auto}
.docs.on{display:block}
.docbox{
  background:var(--card);max-width:720px;margin:5vh auto 40px;border-radius:var(--r-lg);
  padding:26px 26px 30px;box-shadow:var(--sh-lg);position:relative;
}
.x{
  position:absolute;top:14px;inset-inline-end:14px;width:38px;height:38px;border:0;cursor:pointer;
  border-radius:10px;background:var(--bg-tint);color:var(--blue-d);font-size:18px;font-weight:800;font-family:inherit;
}
.x:hover{background:#d8e8ff}
.doc{display:none}
.doc.on{display:block}
.doc h2{font-size:21px;font-weight:800;margin-bottom:10px;padding-inline-end:44px}
.doc h3{font-size:15px;font-weight:800;margin:16px 0 4px}
.doc p{color:var(--slate);font-size:15px;margin-bottom:8px}
.doc ul{margin:6px 0 8px;padding-inline-start:20px;color:var(--slate);font-size:15px}
.doc li{margin-bottom:4px}

/* ===================== REDIRECT SCREENS ===================== */
.screen{display:none;max-width:520px;margin:14vh auto 0;padding:0 18px;text-align:center}
.screen.on{display:block}
body.go .page{display:none !important}
body.go{background:linear-gradient(160deg,var(--bg-tint),var(--bg))}
.spin{
  width:46px;height:46px;margin:0 auto 18px;border-radius:50%;
  border:5px solid var(--bg-tint);border-top-color:var(--blue);animation:sp .8s linear infinite;
}
@keyframes sp{to{transform:rotate(360deg)}}
.screen .lead2{font-size:17px;font-weight:700;color:var(--ink)}
.screen .lead2 small{display:block;margin-top:8px;font-weight:500;font-size:14px;color:var(--slate)}
.prev{background:var(--card);border:1px solid var(--line);border-radius:var(--r-lg);padding:34px 26px;box-shadow:var(--sh)}
.prev h2{font-size:21px;font-weight:800;margin-bottom:6px}
.prev p{color:var(--slate);font-size:15px}
.prev .dest{
  font-size:14px;color:var(--blue-d);font-weight:700;word-break:break-all;
  background:var(--bg-soft);padding:12px;border-radius:12px;margin:14px 0 18px;
}
.prev .go2{
  display:block;text-decoration:none;color:var(--btn-ink);font-weight:800;padding:15px;border-radius:12px;
  background:linear-gradient(135deg,var(--blue-l),var(--blue-d));
}

/* ===================== LANGUAGE ===================== */
.en-ar{display:none}
body.ar .en-only{display:none}
body.ar .en-ar{display:inline}
.bl-ar{display:none}
body.ar .bl-en{display:none}
body.ar .bl-ar{display:block}
body.ar{direction:rtl}
body.ar h1,body.ar .eyebrow{letter-spacing:0}
body.ar .type{white-space:normal}

/* ===================== RESPONSIVE ===================== */
@media (max-width:1100px){
  .body-grid{grid-template-columns:minmax(0,1fr)}
  .rail{display:none}
  .ad-mob{display:flex}
}
@media (max-width:900px){
  .hero{padding:34px 0 40px}
  .hero-grid{grid-template-columns:minmax(0,1fr);gap:38px}
  .art{min-height:0;margin-top:6px}
  .lead{max-width:none}
  .form{max-width:none}
}
@media (max-width:640px){
  .nav-in{gap:10px;padding:10px 14px}
  .brand{font-size:16px}
  .social{margin-inline-start:0;width:100%;order:3}
  .social a{flex:1 1 auto;text-align:center;padding:9px 6px;font-size:12.5px}
  .lang{margin-inline-start:auto}
  .lang button{padding:8px 12px}
  h1{font-size:29px}
  .lead{font-size:15.5px}
  .row{flex-direction:column;align-items:stretch}
  .cta{width:100%;padding:15px}
  .out{flex-direction:column}
  .copy{width:100%;padding:14px}
  .ticks{gap:10px 16px}
  .chip{font-size:12px;padding:8px 11px}
  .c3{inset-inline-start:-6px}
  .c1{inset-inline-start:-4px}
  .c2{inset-inline-end:-4px}
  .card{padding:18px 16px}
  .feats{grid-template-columns:1fr}
  .alt{font-size:16px}
  .docbox{padding:22px 18px 26px;margin:2vh auto 30px}
}
@media (prefers-reduced-motion:reduce){
  *{animation:none !important;transition:none !important}
  .rv{opacity:1;transform:none}
  .draw{stroke-dashoffset:0}
  html{scroll-behavior:auto}
}
]]></b:skin>

</head>
<body>

<!-- =====================================================================
     SETTINGS  -  Blogger > Layout > "Shortener Settings" > Edit
     ===================================================================== -->
<b:section id='ShortenerSettings' maxwidgets='1' showaddelement='yes'>
<b:widget id='HTML9' locked='false' title='Shortener Settings' type='HTML' version='2' visible='true'>
<b:widget-settings>
<b:widget-setting name='content'># One setting per line. Change what comes after the "=" sign.
FIREBASE_URL = {FIREBASE_URL}
ADSENSE_CLIENT = {ADSENSE_CLIENT}
ADSENSE_SLOT = {ADSENSE_SLOT}
YANDEX_BLOCK = {YANDEX_BLOCK}
ALT_SITE = {ALT_SITE}
SITE_BUTTON_EN = {SITE_BUTTON_EN}
SITE_BUTTON_AR = {SITE_BUTTON_AR}
OG_IMAGE = {OG_IMAGE}
CONTACT_EMAIL = {CONTACT_EMAIL}
BRAND = {BRAND}
WHATSAPP = {WHATSAPP}
FACEBOOK = {FACEBOOK}
TELEGRAM = {TELEGRAM}
YOUTUBE = {YOUTUBE}
YANDEX_MODE = {YANDEX_MODE}
YANDEX_IMAGE_URL = {YANDEX_IMAGE_URL}
YANDEX_CPA_CHECK = {YANDEX_CPA_CHECK}
YANDEX_CPA_URL = {YANDEX_CPA_URL}
ADSENSE_MODE = {ADSENSE_MODE}
ADSENSE_IMAGE_URL = {ADSENSE_IMAGE_URL}
ADSENSE_CPA_CHECK = {ADSENSE_CPA_CHECK}
ADSENSE_CPA_URL = {ADSENSE_CPA_URL}</b:widget-setting>
</b:widget-settings>
<b:includable id='main'><div id='shCfg' style='display:none'><data:content/></div></b:includable>
</b:widget>
</b:section>

<script type='text/javascript'>
//<![CDATA[
/* =====================================================================
   CONFIG  -  EDIT THESE VALUES BY HAND
   ===================================================================== */
var SH_CONFIG = {
  FIREBASE_URL:   "{FIREBASE_URL}",
  ADSENSE_CLIENT: "{ADSENSE_CLIENT}",
  ADSENSE_SLOT:   "{ADSENSE_SLOT}",
  YANDEX_BLOCK:   "{YANDEX_BLOCK}",
  ALT_SITE:       "{ALT_SITE}",
  SITE_BUTTON_EN: "{SITE_BUTTON_EN}",
  SITE_BUTTON_AR: "{SITE_BUTTON_AR_RAW}",
  OG_IMAGE:       "{OG_IMAGE}",
  PALETTE:        "{PALETTE}",
  CONTACT_EMAIL:  "{CONTACT_EMAIL}",
  BRAND:          "{BRAND}",
  WHATSAPP:       "{WHATSAPP}",
  FACEBOOK:       "{FACEBOOK}",
  TELEGRAM:       "{TELEGRAM}",
  YOUTUBE:        "{YOUTUBE}",
  YANDEX_MODE:    "{YANDEX_MODE}",
  YANDEX_IMAGE_URL: "{YANDEX_IMAGE_URL}",
  YANDEX_CPA_CHECK: "{YANDEX_CPA_CHECK}",
  YANDEX_CPA_URL:  "{YANDEX_CPA_URL}",
  ADSENSE_MODE:   "{ADSENSE_MODE}",
  ADSENSE_IMAGE_URL: "{ADSENSE_IMAGE_URL}",
  ADSENSE_CPA_CHECK: "{ADSENSE_CPA_CHECK}",
  ADSENSE_CPA_URL: "{ADSENSE_CPA_URL}"
};
/* ================= end of CONFIG, nothing to edit below ================= */

var CFG = (function () {
  var trim = /^(FIREBASE_URL|ALT_SITE|WHATSAPP|FACEBOOK|TELEGRAM|YOUTUBE)$/;
  var d = {}, k, v;

  function clean(k, v) {
    v = String(v || "").trim();
    if (trim.test(k)) { v = v.replace(/\\/+$/, ""); }
    return /XXXX/i.test(v) ? "" : v;
  }

  for (k in SH_CONFIG) {
    if (SH_CONFIG.hasOwnProperty(k)) { d[k] = clean(k, SH_CONFIG[k]); }
  }

  var el = document.getElementById("shCfg") || document.getElementById("ShortenerSettings");
  if (el) {
    var lines = (el.textContent || "").split(/[\\r\\n;]+/);
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i].trim();
      if (!ln || ln.charAt(0) === "#") { continue; }
      var p = ln.indexOf("=");
      if (p < 1) { continue; }
      k = ln.slice(0, p).trim().toUpperCase().replace(/[^A-Z_]/g, "");
      if (!d.hasOwnProperty(k)) { continue; }
      v = clean(k, ln.slice(p + 1));
      if (v) { d[k] = v; }
    }
  }
  return d;
})();

(function () {
  var sec = document.getElementById("ShortenerSettings");
  if (sec) { sec.style.display = "none"; }
  var pal = (CFG.PALETTE || "blue").toLowerCase();
  if (/^(blue|emerald|violet|amber|dark)$/.test(pal) && document.body) {
    document.body.className += " p-" + pal;
  }
})();

window.__SH = { mode: null, code: null, dest: null, cb: null };
(function () {
  var q = window.location.search;
  if (!q || q.length < 2) { return; }
  q = q.substring(1);

  var m = /(?:^|&)u=([^&]+)/.exec(q);
  if (m) {
    try {
      var b64 = m[1].replace(/-/g, "+").replace(/_/g, "/");
      while (b64.length % 4) { b64 += "="; }
      var dest = decodeURIComponent(escape(window.atob(b64)));
      if (/^https?:\\/\\//i.test(dest)) {
        if (/(?:^|&)p=1(?:&|$)/.test(q)) { window.__SH.mode = "preview"; window.__SH.dest = dest; }
        else { window.location.replace(dest); }
      }
    } catch (e) {}
    return;
  }

  var first = q.split("&")[0];
  if (first.indexOf("=") !== -1) { return; }
  var code = decodeURIComponent(first.replace(/\\/$/, "")).toLowerCase();
  if (!/^[a-z0-9_-]+$/.test(code)) { return; }

  window.__SH.mode = "resolving";
  window.__SH.code = code;
  if (document.body) { document.body.className += " go"; }
  if (!CFG.FIREBASE_URL) { window.__SH.mode = "config"; return; }

  var x = new XMLHttpRequest();
  x.open("GET", CFG.FIREBASE_URL + "/links/" + encodeURIComponent(code) + ".json", true);
  x.onload = function () {
    var d = null;
    try { d = JSON.parse(x.responseText); } catch (e) {}
    if (d && d.url && /^https?:\\/\\//i.test(d.url)) {
      if (d.preview) { window.__SH.mode = "preview"; window.__SH.dest = d.url; if (window.__SH.cb) { window.__SH.cb(); } }
      else { window.location.replace(d.url); }
    } else { window.__SH.mode = "notfound"; if (window.__SH.cb) { window.__SH.cb(); } }
  };
  x.onerror = function () { window.__SH.mode = "notfound"; if (window.__SH.cb) { window.__SH.cb(); } };
  x.send();
})();
//]]>
<\/script>

<header class='nav page'>
  <div class='nav-in'>
    <a class='brand' href='/'>
      <i aria-hidden='true'>&#128279;</i>
      <span id='brandName'>shortlinks</span>
    </a>
    <nav aria-label='Social media' class='social'>
      <a class='s-wa' href='https://wa.me/1234567890' id='soWa' rel='noopener nofollow' target='_blank'>WhatsApp</a>
      <a class='s-fb' href='https://facebook.com/yourpage' id='soFb' rel='noopener nofollow' target='_blank'>Facebook</a>
      <a class='s-tg' href='https://t.me/yourchannel' id='soTg' rel='noopener nofollow' target='_blank'>Telegram</a>
      <a class='s-yt' href='https://youtube.com/@yourchannel' id='soYt' rel='noopener nofollow' target='_blank'>Youtube</a>
    </nav>
    <div class='lang'>
      <button aria-pressed='true' id='langEn' type='button'>English</button>
      <button aria-pressed='false' id='langAr' lang='ar' type='button'>&#1575;&#1604;&#1593;&#1585;&#1576;&#1610;&#1577;</button>
    </div>
  </div>
</header>

<section class='hero page'>
  <div class='wrap hero-grid'>

    <div>
      <div class='pill'>
        <span aria-hidden='true' class='dot'></span>
        <span class='en-only'>Free forever &#183; <b>No signup</b> &#183; Unlimited links</span>
        <span class='en-ar' lang='ar'>مجاني دائمًا &#183; <b>بدون تسجيل</b> &#183; روابط غير محدودة</span>
      </div>

      <h1>
        <span class='en-only'>Smart link shortener for<br/><span class='type' id='typeEn'></span><span aria-hidden='true' class='caret'></span></span>
        <span class='en-ar' lang='ar'>مختصر روابط ذكي لأجل<br/><span class='type' id='typeAr'></span><span aria-hidden='true' class='caret'></span></span>
      </h1>

      <p class='lead'>
        <span class='en-only'>Turn long tracking URLs into clean, branded short links that work on Facebook, Instagram, TikTok, YouTube, X, Telegram and Discord. Built for crypto marketing and affiliate campaigns.</span>
        <span class='en-ar' lang='ar'>حوّل الروابط الطويلة إلى روابط قصيرة نظيفة تعمل على فيسبوك وإنستغرام وتيك توك ويوتيوب وإكس وتيليجرام وديسكورد. مصممة لتسويق العملات الرقمية والتسويق بالعمولة.</span>
      </p>

      <div class='form'>
        <div class='row'>
          <label class='field' for='shDest' style='position:absolute;left:-9999px'>Destination URL</label>
          <input class='field' data-ar='ألصق رابطًا طويلًا' data-en='Paste a long url' id='shDest' inputmode='url' placeholder='Paste a long url' type='url'/>
          <button class='cta' id='shSave' type='button'>
            <span class='en-only'>Shorten</span><span class='en-ar' lang='ar'>اختصار</span>
          </button>
        </div>
        <label class='opt' for='shPrev'>
          <input id='shPrev' type='checkbox'/>
          <span>
            <span class='en-only'>Add a preview &amp; Continue page (safer for Facebook)</span>
            <span class='en-ar' lang='ar'>إضافة صفحة معاينة ومتابعة (أكثر أمانًا لفيسبوك)</span>
          </span>
        </label>
        <div class='out'>
          <input aria-label='Your new short link' data-ar='رابطك القصير الجديد' data-en='Your new short link' id='shResult' placeholder='Your new short link' readonly='readonly' type='text'/>
          <button class='copy' id='shCopy' type='button'>
            <span class='en-only'>Copy link</span><span class='en-ar' lang='ar'>نسخ</span>
          </button>
        </div>
        <div aria-live='polite' class='msg' id='shMsg'></div>
      </div>

      <ul class='ticks'>
        <li>
          <svg aria-hidden='true' fill='none' height='17' stroke='#0b7a3f' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' viewBox='0 0 24 24' width='17'><polyline points='20 6 9 17 4 12'/></svg>
          <span class='en-only'>No account needed</span><span class='en-ar' lang='ar'>بدون حساب</span>
        </li>
        <li>
          <svg aria-hidden='true' fill='none' height='17' stroke='#0b7a3f' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' viewBox='0 0 24 24' width='17'><polyline points='20 6 9 17 4 12'/></svg>
          <span class='en-only'>Works on every platform</span><span class='en-ar' lang='ar'>يعمل على كل المنصات</span>
        </li>
        <li>
          <svg aria-hidden='true' fill='none' height='17' stroke='#0b7a3f' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' viewBox='0 0 24 24' width='17'><polyline points='20 6 9 17 4 12'/></svg>
          <span class='en-only'>Links never expire</span><span class='en-ar' lang='ar'>روابط لا تنتهي</span>
        </li>
      </ul>
    </div>

    <div aria-hidden='true' class='art'>
      <div class='board'>
        <div class='mini'>
          <span class='ico'>&#128279;</span>
          <span>
            <span class='t' id='boardBrand'>shortlinks</span><br/>
            <span class='u'>https://shortlinks.site/?a7x2k9</span>
          </span>
          <span class='n'><span data-count='143'>0</span>K clicks</span>
        </div>
        <div class='panel'>
          <div class='panel-h'>
            <span class='k'>Clicks</span>
            <span class='up'>+<span data-count='34'>0</span>%</span>
            <span class='tot'><span data-count='143'>0</span>K total</span>
          </div>
          <svg height='120' preserveAspectRatio='none' viewBox='0 0 300 110' width='100%'>
            <defs>
              <linearGradient id='g1' x1='0' x2='0' y1='0' y2='1'>
                <stop offset='0' stop-color='#1668e3'/>
                <stop offset='1' stop-color='#ffffff'/>
              </linearGradient>
            </defs>
            <path class='spark-fill' d='M0,86 C24,80 34,58 52,62 C70,66 78,88 96,84 C114,80 122,54 142,58 C162,62 168,80 186,72 C204,64 210,36 232,34 C252,32 262,20 300,8 L300,110 L0,110 Z'/>
            <path class='spark draw' d='M0,86 C24,80 34,58 52,62 C70,66 78,88 96,84 C114,80 122,54 142,58 C162,62 168,80 186,72 C204,64 210,36 232,34 C252,32 262,20 300,8'/>
            <circle class='spark-dot' cx='232' cy='34' r='4'/>
          </svg>
        </div>
        <div class='chip c1'><span class='b'>&#9635;</span> QR Codes</div>
        <div class='chip c2'><span class='b'>&#9679;</span> Preview Page</div>
        <div class='chip c3'><span class='b'>&#128279;</span> Smart Short Links</div>
      </div>
    </div>

  </div>
</section>

<div class='wrap body-grid page'>

  <aside class='rail'>
    <div class='ad' id='yandexAd'><span>Advertisement</span></div>
  </aside>

  <main>

    <section class='card rv'>
      <div class='eyebrow'><span class='en-only'>About this tool</span><span class='en-ar' lang='ar'>عن الأداة</span></div>
      <div class='bl-en'>
        <p>Unlock seamless crypto marketing with our powerful URL shortener. Create clean, branded short links optimized for global platforms including Facebook, Instagram, TikTok, YouTube, X (Twitter), Telegram, and Discord. Fully compatible with affiliate &amp; influencer networks like Mavely, Collective Voice, Shopyoulikes, Amazon Associates, ShareASale, ClickBank, Impact, CJ Affiliate, and more. Track clicks, conversions, and performance in real-time with advanced analytics, custom domains, and QR codes. Boost engagement, protect your links, and scale your cryptocurrency campaigns across all platforms effortlessly.</p>
      </div>
      <div class='bl-ar' lang='ar'>
        <p>اكتشف أداة تقصير الروابط القوية المصممة خصيصًا لتسويق العملات الرقمية. أنشئ روابط قصيرة نظيفة ومخصصة تعمل بكفاءة على جميع المنصات العالمية: فيسبوك، إنستغرام، تيك توك، يوتيوب، إكس (تويتر)، تيليجرام، وديسكورد. متوافقة تمامًا مع شبكات التسويق بالعمولة مثل Mavely، Collective Voice، Shopyoulikes، Amazon Associates، ShareASale، ClickBank، Impact، CJ Affiliate، وغيرها الكثير. تتبع النقرات والتحويلات فوريًا مع تحليلات متقدمة، نطاقات مخصصة، وأكواد QR. عزز التفاعل، احمِ روابطك، ووسّع حملاتك في العملات الرقمية بكل سهولة عبر كل المنصات.</p>
      </div>
    </section>

    <section class='card notice rv'>
      <h2><span class='en-only'>Important notice</span><span class='en-ar' lang='ar'>تنبيه هام</span></h2>
      <div class='bl-en'>
        <p>If any links on our site are no longer working or have expired, please use our alternative website. All content and services are fully available there.</p>
      </div>
      <div class='bl-ar' lang='ar'>
        <p>إذا كانت أي روابط على موقعنا غير فعالة أو قد انتهت صلاحيتها، يُرجى استخدام موقعنا البديل. جميع المحتويات والخدمات متوفرة بالكامل هناك.</p>
      </div>
    </section>

    <a class='alt rv' href='{ALT_SITE}' id='shAlt' rel='noopener' target='_blank'>
      <span class='en-only' id='altEn'>{SITE_BUTTON_EN}</span><span class='en-ar' id='altAr' lang='ar'>{SITE_BUTTON_AR}</span>
    </a>

    <div class='ad ad-mob' id='adsMobile'><span>Advertisement</span></div>

    <section class='card rv'>
      <div class='eyebrow'><span class='en-only'>Why use it</span><span class='en-ar' lang='ar'>لماذا تستخدمها؟</span></div>
      <h2><span class='en-only'>Built for marketers, not just for shortening</span><span class='en-ar' lang='ar'>مصممة للمسوّقين، وليس للتقصير فقط</span></h2>
      <div class='feats'>
        <div class='feat'>
          <h3><span class='en-only'>No account needed</span><span class='en-ar' lang='ar'>بدون حساب</span></h3>
          <p><span class='en-only'>Paste a destination and get a short link in one click. No signup, no email.</span><span class='en-ar' lang='ar'>الصق الوجهة واحصل على رابط قصير بنقرة واحدة. بدون تسجيل ولا بريد إلكتروني.</span></p>
        </div>
        <div class='feat'>
          <h3><span class='en-only'>Safe on social</span><span class='en-ar' lang='ar'>آمن على المنصات</span></h3>
          <p><span class='en-only'>The optional Continue page keeps links working on Facebook, WhatsApp and Telegram.</span><span class='en-ar' lang='ar'>صفحة المتابعة تحمي روابطك على فيسبوك وواتساب وتيليجرام.</span></p>
        </div>
        <div class='feat'>
          <h3><span class='en-only'>Affiliate ready</span><span class='en-ar' lang='ar'>جاهز للتسويق بالعمولة</span></h3>
          <p><span class='en-only'>Works with Mavely, ShareASale, ClickBank, Impact, CJ Affiliate and Amazon Associates.</span><span class='en-ar' lang='ar'>يعمل مع Mavely وShareASale وClickBank وImpact وCJ Affiliate وAmazon Associates.</span></p>
        </div>
        <div class='feat'>
          <h3><span class='en-only'>Fast and mobile first</span><span class='en-ar' lang='ar'>سريع ومهيأ للجوال</span></h3>
          <p><span class='en-only'>No frameworks, no web fonts. The page loads instantly, even on a slow connection.</span><span class='en-ar' lang='ar'>بدون مكتبات أو خطوط خارجية، فتفتح الصفحة فورًا.</span></p>
        </div>
      </div>
    </section>

    <section class='card faq rv'>
      <div class='eyebrow'><span class='en-only'>FAQ</span><span class='en-ar' lang='ar'>الأسئلة الشائعة</span></div>
      <details open='open'>
        <summary><span class='en-only'>Is this URL shortener free?</span><span class='en-ar' lang='ar'>هل الأداة مجانية؟</span></summary>
        <p><span class='en-only'>Yes. Creating short links is completely free and no account is required.</span><span class='en-ar' lang='ar'>نعم. إنشاء الروابط مجاني تمامًا ولا يتطلب إنشاء حساب.</span></p>
      </details>
      <details>
        <summary><span class='en-only'>Do the links work on Facebook and WhatsApp?</span><span class='en-ar' lang='ar'>هل تعمل الروابط على فيسبوك وواتساب؟</span></summary>
        <p><span class='en-only'>Yes. Turn on the preview page option to add a Continue screen, which is the safest way to share on Facebook, WhatsApp and Telegram.</span><span class='en-ar' lang='ar'>نعم. فعّل خيار صفحة المعاينة لإضافة زر متابعة، وهو الأسلوب الأكثر أمانًا للمشاركة.</span></p>
      </details>
      <details>
        <summary><span class='en-only'>Can I use short links for affiliate and crypto campaigns?</span><span class='en-ar' lang='ar'>هل يمكنني استخدامها في حملات العمولة والعملات الرقمية؟</span></summary>
        <p><span class='en-only'>Yes. The links work with affiliate and influencer networks such as Mavely, Collective Voice, Shopyoulikes, Amazon Associates, ShareASale, ClickBank, Impact and CJ Affiliate.</span><span class='en-ar' lang='ar'>نعم. تعمل الروابط مع شبكات التسويق بالعمولة مثل Mavely وCollective Voice وShopyoulikes وAmazon Associates وShareASale وClickBank وImpact وCJ Affiliate.</span></p>
      </details>
      <details>
        <summary><span class='en-only'>Do short links expire?</span><span class='en-ar' lang='ar'>هل تنتهي صلاحية الروابط؟</span></summary>
        <p><span class='en-only'>No. A short link stays active until it is removed. If a link ever stops working, use the alternative site listed above.</span><span class='en-ar' lang='ar'>لا. يظل الرابط القصير فعالًا حتى تتم إزالته. إذا توقف أي رابط فاستخدم الموقع البديل أعلاه.</span></p>
      </details>
    </section>

  </main>

  <aside class='rail'>
    <div class='ad' id='adsenseAd'><span>Advertisement</span></div>
  </aside>

</div>

<footer class='page'>
  <div class='wrap'>
    <nav aria-label='Site information'>
      <button data-doc='privacy' type='button'><span class='en-only'>Privacy Policy</span><span class='en-ar' lang='ar'>سياسة الخصوصية</span></button>
      <button data-doc='terms' type='button'><span class='en-only'>Terms</span><span class='en-ar' lang='ar'>الشروط</span></button>
      <button data-doc='contact' type='button'><span class='en-only'>Contact</span><span class='en-ar' lang='ar'>اتصل بنا</span></button>
      <button data-doc='about' type='button'><span class='en-only'>About</span><span class='en-ar' lang='ar'>من نحن</span></button>
      <a href='/sitemap.xml'><span class='en-only'>Sitemap</span><span class='en-ar' lang='ar'>خريطة الموقع</span></a>
    </nav>
    <p class='legal'>&#169; <span id='brandFoot'>shortlinks</span></p>
  </div>
</footer>

<div class='docs page' id='shDocs'>
  <div aria-modal='true' class='docbox' role='dialog' tabindex='-1'>
    <button aria-label='Close' class='x' id='docClose' type='button'>&#10005;</button>

    <article class='doc' id='doc-privacy'>
      <div class='bl-en'>
        <h2>Privacy Policy</h2>
        <p>This page explains what happens to your data when you use this link shortener. We do not ask you to register, and we do not collect your name, phone number or email address.</p>
        <h3>What we store</h3>
        <ul>
          <li>The destination URL you paste, together with the short code generated for it.</li>
          <li>Whether you asked for a preview page, and the time the link was created.</li>
          <li>A random key kept in your browser storage so your own device recognises links you made.</li>
        </ul>
        <h3>Your browser</h3>
        <p>We use local storage on your device to remember your language choice and your keys. Nothing in local storage is sent to us. Clearing your browser data removes it.</p>
        <h3>Advertising</h3>
        <p>This site shows ads from Google AdSense and the Yandex Advertising Network. Third-party vendors, including Google, use cookies to serve ads based on your previous visits to this and other websites. You can opt out of personalised advertising in <a href='https://www.google.com/settings/ads' rel='noopener nofollow' target='_blank'>Google Ads Settings</a>, or opt out of third-party vendors at <a href='https://www.aboutads.info' rel='noopener nofollow' target='_blank'>aboutads.info</a>.</p>
        <h3>Links to other sites</h3>
        <p>A short link sends visitors to a destination chosen by the person who created it. We do not control those destinations and are not responsible for their content or their privacy practices.</p>
        <h3>Removal requests</h3>
        <p>If a short link points to abusive, misleading or illegal content, contact us and we will remove it.</p>
      </div>
      <div class='bl-ar' lang='ar'>
        <h2>سياسة الخصوصية</h2>
        <p>توضح هذه الصفحة ما يحدث لبياناتك عند استخدام أداة تقصير الروابط. لا نطلب منك التسجيل، ولا نجمع اسمك أو رقم هاتفك أو بريدك الإلكتروني.</p>
        <h3>ما الذي نحفظه</h3>
        <ul>
          <li>رابط الوجهة الذي تلصقه، مع الرمز القصير الذي يتم توليده له.</li>
          <li>ما إذا طلبت صفحة معاينة، ووقت إنشاء الرابط.</li>
          <li>مفتاح عشوائي يُحفظ في متصفحك فقط ليتعرّف جهازك على الروابط التي أنشأتها.</li>
        </ul>
        <h3>متصفحك</h3>
        <p>نستخدم التخزين المحلي في جهازك لتذكر لغتك المفضلة ومفاتيحك. لا يُرسل أي من ذلك إلينا، ويمكن حذفه بمسح بيانات المتصفح.</p>
        <h3>الإعلانات</h3>
        <p>يعرض هذا الموقع إعلانات من Google AdSense وشبكة إعلانات Yandex. تستخدم جهات خارجية، ومنها Google، ملفات تعريف الارتباط لعرض إعلانات بناءً على زياراتك السابقة. يمكنك إيقاف الإعلانات المخصصة من <a href='https://www.google.com/settings/ads' rel='noopener nofollow' target='_blank'>إعدادات إعلانات Google</a>.</p>
        <h3>الروابط الخارجية</h3>
        <p>يوجّه الرابط القصير الزائر إلى وجهة يختارها منشئ الرابط. نحن لا نتحكم في تلك الوجهات ولسنا مسؤولين عن محتواها.</p>
        <h3>طلبات الحذف</h3>
        <p>إذا كان رابط قصير يشير إلى محتوى مسيء أو مضلل أو مخالف للقانون، فراسلنا وسنقوم بإزالته.</p>
      </div>
    </article>

    <article class='doc' id='doc-terms'>
      <div class='bl-en'>
        <h2>Terms of Use</h2>
        <p>By creating a short link on this site you agree to the terms below. If you do not agree with them, please do not use the service.</p>
        <h3>The service</h3>
        <p>The shortener is free and provided as it is, with no guarantee of availability or uptime. We may change, pause or end the service at any time.</p>
        <h3>What you may not shorten</h3>
        <ul>
          <li>Malware, phishing pages, or anything that harms a visitor's device or accounts.</li>
          <li>Spam, deceptive redirects, or links that hide their true destination to mislead people.</li>
          <li>Content that is illegal where you live, sexual content involving minors, or content that promotes violence or hatred.</li>
          <li>Anything that breaks the rules of the platform you share the link on.</li>
        </ul>
        <h3>Removal</h3>
        <p>We may remove any short link, at any time, without notice, if we believe it breaks these terms or the policies of our advertising partners.</p>
        <h3>Liability</h3>
        <p>You are responsible for the destination you point a link to and for how you share it. We are not liable for any loss that follows from using the service or from clicking a link created by someone else.</p>
      </div>
      <div class='bl-ar' lang='ar'>
        <h2>شروط الاستخدام</h2>
        <p>بإنشائك رابطًا قصيرًا على هذا موقع فإنك توافق على الشروط التالية. إن لم توافق عليها فيُرجى عدم استخدام الخدمة.</p>
        <h3>الخدمة</h3>
        <p>الخدمة مجانية وتُقدَّم كما هي، دون ضمان للتوفر أو الاستمرارية. ويحق لنا تعديلها أو إيقافها في أي وقت.</p>
        <h3>ما لا يجوز تقصيره</h3>
        <ul>
          <li>البرمجيات الخبيثة أو صفحات التصيّد أو أي شيء يضر بجهاز الزائر أو حساباته.</li>
          <li>الرسائل المزعجة أو التوجيه المخادع أو إخفاء الوجهة الحقيقية لتضليل الناس.</li>
          <li>أي محتوى مخالف للقانون، أو محتوى جنسي يخص القاصرين، أو محتوى يحض على العنف أو الكراهية.</li>
          <li>أي شيء يخالف قواعد المنصة التي تشارك الرابط عليها.</li>
        </ul>
        <h3>الإزالة</h3>
        <p>يحق لنا إزالة أي رابط قصير في أي وقت ودون إشعار إذا رأينا أنه يخالف هذه الشروط أو سياسات شركائنا الإعلانيين.</p>
        <h3>المسؤولية</h3>
        <p>أنت المسؤول عن الوجهة التي يشير إليها رابطك وعن طريقة مشاركته. ولا نتحمل أي خسارة تنتج عن استخدام الخدمة.</p>
      </div>
    </article>

    <article class='doc' id='doc-contact'>
      <div class='bl-en'>
        <h2>Contact</h2>
        <p>Questions, a broken link, a takedown request, or an advertising enquiry? Reach us and we will reply as soon as we can.</p>
        <h3>Email</h3>
        <p><a href='mailto:you@example.com' id='mailEn'>you@example.com</a></p>
        <h3>Social channels</h3>
        <p>You can also message us on WhatsApp, Facebook, Telegram or YouTube using the buttons at the top of the page.</p>
        <h3>Reporting a link</h3>
        <p>Send us the full short link and tell us what is wrong with it. Abusive links are removed quickly.</p>
      </div>
      <div class='bl-ar' lang='ar'>
        <h2>اتصل بنا</h2>
        <p>هل لديك سؤال، أو رابط لا يعمل، أو طلب حذف، أو استفسار إعلاني؟ راسلنا وسنرد في أقرب وقت.</p>
        <h3>البريد الإلكتروني</h3>
        <p><a href='mailto:you@example.com' id='mailAr'>you@example.com</a></p>
        <h3>قنوات التواصل</h3>
        <p>يمكنك أيضًا مراسلتنا عبر واتساب أو فيسبوك أو تيليجرام أو يوتيوب من الأزرار في أعلى الصفحة.</p>
        <h3>الإبلاغ عن رابط</h3>
        <p>أرسل لنا الرابط القصير كاملًا مع بيان المشكلة. تتم إزالة الروابط المسيئة بسرعة.</p>
      </div>
    </article>

    <article class='doc' id='doc-about'>
      <div class='bl-en'>
        <h2>About</h2>
        <p>This is a free link shortener made for people who share links for a living: crypto marketers, affiliate publishers, influencers and community managers.</p>
        <h3>What it does</h3>
        <p>You paste a destination, and the site gives you a short link you can share on Facebook, Instagram, TikTok, YouTube, X, Telegram, Discord or WhatsApp. An optional preview page adds a Continue screen, which keeps links working on platforms that are strict about redirects.</p>
        <h3>Who it is for</h3>
        <p>Anyone who needs clean links that fit in a bio, a caption or a short message, and that do not expose a long tracking string to the reader.</p>
        <h3>What it costs</h3>
        <p>Nothing. The site is paid for by the ads you see around this page.</p>
      </div>
      <div class='bl-ar' lang='ar'>
        <h2>من نحن</h2>
        <p>هذه أداة مجانية لتقصير الروابط، صُممت لمن يشاركون الروابط يوميًا: مسوّقو العملات الرقمية، وناشرو التسويق بالعمولة، وصنّاع المحتوى، ومديرو المجتمعات.</p>
        <h3>ماذا تفعل</h3>
        <p>تلصق الوجهة، فيمنحك الموقع رابطًا قصيرًا يمكن مشاركته على فيسبوك وإنستغرام وتيك توك ويوتيوب وإكس وتيليجرام وديسكورد وواتساب. وصفحة المعاينة الاختيارية تضيف زر متابعة يحافظ على عمل الروابط في المنصات الصارمة.</p>
        <h3>لمن هي</h3>
        <p>لكل من يحتاج روابط نظيفة تناسب النبذة أو التعليق أو الرسالة القصيرة.</p>
        <h3>التكلفة</h3>
        <p>مجانية بالكامل. تُموَّل الأداة من الإعلانات المعروضة حول هذه الصفحة.</p>
      </div>
    </article>

  </div>
</div>

<div class='screen' id='shScreen'></div>

<script type='text/javascript'>
//<![CDATA[
(function () {
  var base = window.location.origin + "/";
  var scr = document.getElementById("shScreen");
  var body = document.body;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function esc(s) { return (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

  if (window.__SH && window.__SH.mode) {
    if (body.className.indexOf("go") === -1) { body.className += " go"; }
    function paint() {
      var mo = window.__SH.mode;
      scr.className = "screen on";
      if (mo === "preview") {
        var d = window.__SH.dest;
        scr.innerHTML =
          '<div class="prev"><h2>\\uD83D\\uDD17 You are being redirected</h2>' +
          '<p>This link will take you to:</p><div class="dest">' + esc(d) + '</div>' +
          '<a class="go2" href="' + esc(d) + '" rel="nofollow noopener">Continue &#8594;</a></div>';
        return;
      }
      if (mo === "notfound") {
        scr.innerHTML = '<div class="lead2">&#10060; Link "<b>' + esc(window.__SH.code) + '</b>" was not found<small><a href="' + base + '">Go to homepage</a></small></div>';
        return;
      }
      if (mo === "config") {
        scr.innerHTML = '<div class="lead2">&#9881;&#65039; Not set up yet<small>Add FIREBASE_URL in Layout &#8594; Shortener Settings.</small></div>';
        return;
      }
      scr.innerHTML = '<div class="spin"></div><div class="lead2">Redirecting&#8230;</div>';
    }
    window.__SH.cb = paint;
    paint();
    return;
  }

  function setHref(id, url) { var el = document.getElementById(id); if (el && url) { el.href = url; } }
  function setText(id, t) { var el = document.getElementById(id); if (el && t) { el.textContent = t; } }
  setHref("shAlt", CFG.ALT_SITE);
  setHref("soWa", CFG.WHATSAPP);
  setHref("soFb", CFG.FACEBOOK);
  setHref("soTg", CFG.TELEGRAM);
  setHref("soYt", CFG.YOUTUBE);
  setText("altEn", CFG.SITE_BUTTON_EN);
  setText("altAr", CFG.SITE_BUTTON_AR);
  setText("brandName", CFG.BRAND);
  setText("brandFoot", CFG.BRAND);
  setText("boardBrand", CFG.BRAND);
  if (CFG.CONTACT_EMAIL) {
    var ids = ["mailEn", "mailAr"], a;
    for (var e = 0; e < ids.length; e++) {
      a = document.getElementById(ids[e]);
      if (a) { a.href = "mailto:" + CFG.CONTACT_EMAIL; a.textContent = CFG.CONTACT_EMAIL; }
    }
  }
  if (CFG.OG_IMAGE) {
    var og = document.getElementById("ogImg"), tw = document.getElementById("twImg");
    if (og) { og.setAttribute("content", CFG.OG_IMAGE); }
    if (tw) { tw.setAttribute("content", CFG.OG_IMAGE); }
  }

  var htmlEl = document.documentElement;
  var btnEn = document.getElementById("langEn"), btnAr = document.getElementById("langAr");
  var ph = document.querySelectorAll("[data-en][data-ar]");
  function setLang(l) {
    var ar = (l === "ar");
    body.classList[ar ? "add" : "remove"]("ar");
    htmlEl.setAttribute("dir", ar ? "rtl" : "ltr");
    htmlEl.setAttribute("lang", ar ? "ar" : "en");
    btnEn.setAttribute("aria-pressed", ar ? "false" : "true");
    btnAr.setAttribute("aria-pressed", ar ? "true" : "false");
    for (var i = 0; i < ph.length; i++) { ph[i].placeholder = ph[i].getAttribute(ar ? "data-ar" : "data-en"); }
    try { localStorage.setItem("sh_lang", ar ? "ar" : "en"); } catch (e) {}
  }
  btnEn.onclick = function () { setLang("en"); };
  btnAr.onclick = function () { setLang("ar"); };
  var saved = "";
  try { saved = localStorage.getItem("sh_lang") || ""; } catch (e) {}
  if (!saved && /^ar\\b/i.test(navigator.language || "")) { saved = "ar"; }
  if (saved === "ar") { setLang("ar"); }

  function typer(el, words) {
    if (!el) { return; }
    if (reduce) { el.textContent = words[0]; return; }
    var w = 0, c = 0, del = false;
    (function tick() {
      var word = words[w];
      c = del ? c - 1 : c + 1;
      el.textContent = word.slice(0, c);
      var wait = del ? 45 : 85;
      if (!del && c === word.length) { del = true; wait = 1500; }
      else if (del && c === 0) { del = false; w = (w + 1) % words.length; wait = 250; }
      setTimeout(tick, wait);
    })();
  }
  typer(document.getElementById("typeEn"), ["crypto campaigns.", "affiliate links.", "social media."]);
  typer(document.getElementById("typeAr"), ["\\u0627\\u0644\\u0639\\u0645\\u0644\\u0627\\u062A \\u0627\\u0644\\u0631قمية.", "\\u0627لتسويق \\u0628العمولة.", "\\u0645واقع \\u0627لتواصل."]);

  function countUp(el) {
    var target = parseInt(el.getAttribute("data-count"), 10) || 0;
    if (reduce) { el.textContent = target; return; }
    var start = null, dur = 1400;
    function step(t) {
      if (!start) { start = t; }
      var p = Math.min((t - start) / dur, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) { requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll("[data-count]");
  for (var i = 0; i < counters.length; i++) { countUp(counters[i]); }

  var revealed = document.querySelectorAll(".rv");
  if (window.IntersectionObserver && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        if (entries[j].isIntersecting) {
          entries[j].target.className += " in";
          io.unobserve(entries[j].target);
        }
      }
    }, { rootMargin: "0px 0px -60px 0px" });
    for (var k = 0; k < revealed.length; k++) { io.observe(revealed[k]); }
  } else {
    for (var n = 0; n < revealed.length; n++) { revealed[n].className += " in"; }
  }

  var docs = document.getElementById("shDocs");
  var docBox = docs.querySelector(".docbox");
  var opener = null;
  function openDoc(name) {
    var all = docs.querySelectorAll(".doc");
    for (var i2 = 0; i2 < all.length; i2++) { all[i2].className = "doc"; }
    var one = document.getElementById("doc-" + name);
    if (!one) { return; }
    one.className = "doc on";
    docs.className = "docs page on";
    docBox.scrollTop = 0;
    docBox.focus();
  }
  function closeDoc() {
    docs.className = "docs page";
    if (opener) { opener.focus(); }
  }
  var fb = document.querySelectorAll("[data-doc]");
  for (var f = 0; f < fb.length; f++) {
    (function (b2) { b2.onclick = function () { opener = b2; openDoc(b2.getAttribute("data-doc")); }; })(fb[f]);
  }
  document.getElementById("docClose").onclick = closeDoc;
  docs.onclick = function (ev) { if (ev.target === docs) { closeDoc(); } };
  document.addEventListener("keydown", function (ev) {
    if (ev.key === "Escape" && docs.className.indexOf("on") !== -1) { closeDoc(); }
  });

  var destEl = document.getElementById("shDest"),
      prevEl = document.getElementById("shPrev"),
      saveEl = document.getElementById("shSave"),
      resEl  = document.getElementById("shResult"),
      msgEl  = document.getElementById("shMsg");

  var T = {
    bad:   { en: "Enter a destination starting with http:// or https://", ar: "\\u0623\\u062F\\u062E\\u0644 \\u0631\\u0627بطًا \\u064Aبدأ \\u0628ـ http:// \\u0623و https://" },
    saving:{ en: "Creating your link\\u2026", ar: "\\u062Cارٍ \\u0625نشاء \\u0627لرابط…" },
    done:  { en: "Short link ready. Copy it and share it.", ar: "\\u0627لرابط \\u062Cاهز. \\u0627نسخه \\u0648شاركه." },
    copied:{ en: "Copied!", ar: "\\u062Aم \\u0627لنسخ!" },
    net:   { en: "Could not reach the database. Check FIREBASE_URL in Layout and the database rules.", ar: "\\u062Aعذر \\u0627لاتصال \\u0628قاسدة \\u0627لبيانات." },
    cfg:   { en: "Add FIREBASE_URL in Layout > Shortener Settings.", ar: "\\u0623ضف FIREBASE_URL \\u0641ي \\u0625عدادات \\u0627لخطيط." },
    empty: { en: "Nothing to copy yet.", ar: "\\u0644ا \\u064Aوجد \\u0631ابط \\u0644لنسخ \\u0628عح." }
  };
  function say(k, ok) {
    var l = body.classList.contains("ar") ? "ar" : "en";
    msgEl.className = "msg" + (ok ? " ok" : "");
    msgEl.textContent = T[k][l];
  }
  function code6() { return Math.random().toString(36).slice(2, 8); }
  function read(c, cb) {
    var x = new XMLHttpRequest();
    x.open("GET", CFG.FIREBASE_URL + "/links/" + c + ".json", true);
    x.onload = function () { var d = null; try { d = JSON.parse(x.responseText); } catch (e) {} cb(true, d); };
    x.onerror = function () { cb(false, null); };
    x.send();
  }
  function write(c, payload, cb) {
    var x = new XMLHttpRequest();
    x.open("PUT", CFG.FIREBASE_URL + "/links/" + c + ".json", true);
    x.setRequestHeader("Content-Type", "application/json");
    x.onload = function () { cb(x.status >= 200 && x.status < 300); };
    x.onerror = function () { cb(false); };
    x.send(JSON.stringify(payload));
  }

  saveEl.onclick = function () {
    if (!CFG.FIREBASE_URL) { say("cfg"); return; }
    var dest = (destEl.value || "").trim();
    if (!/^https?:\\/\\//i.test(dest)) { say("bad"); destEl.focus(); return; }
    saveEl.disabled = true;
    say("saving", true);
    var tries = 0;
    (function attempt() {
      tries++;
      var c = code6();
      read(c, function (online, existing) {
        if (!online) { saveEl.disabled = false; say("net"); return; }
        if (existing && existing.url && tries < 6) { attempt(); return; }
        var key = Math.random().toString(36).slice(2, 10);
        write(c, { url: dest, preview: !!prevEl.checked, key: key, created: Date.now() }, function (ok) {
          saveEl.disabled = false;
          if (!ok) { say("net"); return; }
          try { localStorage.setItem("shk_" + c, key); } catch (e) {}
          resEl.value = base + "?" + c;
          say("done", true);
          resEl.focus();
          resEl.select();
        });
      });
    })();
  };
  destEl.onkeydown = function (ev) { if (ev.key === "Enter") { saveEl.click(); } };

  document.getElementById("shCopy").onclick = function () {
    if (!resEl.value) { say("empty"); return; }
    resEl.select(); resEl.setSelectionRange(0, 99999);
    try { document.execCommand("copy"); } catch (e) {}
    if (navigator.clipboard) { navigator.clipboard.writeText(resEl.value); }
    say("copied", true);
  };

  function loadAds() {
    // 1. Google AdSense slot
    if (CFG.ADSENSE_MODE === "custom_image") {
      var imgUrl = CFG.ADSENSE_IMAGE_URL || "https://iili.io/CSegoOP.png";
      var boxes = [document.getElementById("adsenseAd"), document.getElementById("adsMobile")];
      for (var i3 = 0; i3 < boxes.length; i3++) {
        if (!boxes[i3]) { continue; }
        boxes[i3].style.padding = "0";
        boxes[i3].style.overflow = "hidden";
        boxes[i3].style.display = "flex";
        boxes[i3].style.alignItems = "center";
        boxes[i3].style.justifyContent = "center";
        boxes[i3].style.height = boxes[i3].id === "adsenseAd" ? "100%" : "auto";
        
        var imgHtml = '<img src="' + imgUrl + '" style="width:100%;height:100%;max-height:600px;object-fit:cover;border-radius:12px;border:1px solid #e2e8f0" referrerPolicy="no-referrer" />';
        if (CFG.ADSENSE_CPA_CHECK === "true" && CFG.ADSENSE_CPA_URL) {
          boxes[i3].innerHTML = '<a href="' + CFG.ADSENSE_CPA_URL + '" target="_blank" rel="noopener noreferrer" style="width:100%;height:100%;display:block">' + imgHtml + '</a>';
        } else {
          boxes[i3].innerHTML = imgHtml;
        }
      }
    } else if (CFG.ADSENSE_CLIENT && CFG.ADSENSE_SLOT) {
      if (!document.querySelector('script[src*="adsbygoogle.js"]')) {
        var s = document.createElement("script");
        s.async = true;
        s.crossOrigin = "anonymous";
        s.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=" + CFG.ADSENSE_CLIENT;
        document.head.appendChild(s);
      }
      var boxes = [document.getElementById("adsenseAd"), document.getElementById("adsMobile")];
      for (var i3 = 0; i3 < boxes.length; i3++) {
        if (!boxes[i3]) { continue; }
        var ins = document.createElement("ins");
        ins.className = "adsbygoogle";
        ins.style.display = "block";
        ins.style.width = "100%";
        ins.setAttribute("data-ad-client", CFG.ADSENSE_CLIENT);
        ins.setAttribute("data-ad-slot", CFG.ADSENSE_SLOT);
        ins.setAttribute("data-ad-format", "auto");
        ins.setAttribute("data-full-width-responsive", "true");
        boxes[i3].innerHTML = "";
        boxes[i3].appendChild(ins);
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    }

    // 2. Yandex Block
    if (CFG.YANDEX_MODE === "custom_image") {
      var yImgUrl = CFG.YANDEX_IMAGE_URL || "https://iili.io/CSegoOP.png";
      var host = document.getElementById("yandexAd");
      if (host) {
        host.style.padding = "0";
        host.style.overflow = "hidden";
        host.style.display = "flex";
        host.style.alignItems = "center";
        host.style.justifyContent = "center";
        host.style.height = "100%";
        
        var imgHtml = '<img src="' + yImgUrl + '" style="width:100%;height:100%;max-height:600px;object-fit:cover;border-radius:12px;border:1px solid #e2e8f0" referrerPolicy="no-referrer" />';
        if (CFG.YANDEX_CPA_CHECK === "true" && CFG.YANDEX_CPA_URL) {
          host.innerHTML = '<a href="' + CFG.YANDEX_CPA_URL + '" target="_blank" rel="noopener noreferrer" style="width:100%;height:100%;display:block">' + imgHtml + '</a>';
        } else {
          host.innerHTML = imgHtml;
        }
      }
    } else if (CFG.YANDEX_BLOCK) {
      window.yaContextCb = window.yaContextCb || [];
      var y = document.createElement("script");
      y.async = true;
      y.src = "https://yandex.ru/ads/system/context.js";
      document.head.appendChild(y);
      var host = document.getElementById("yandexAd");
      if (host) {
        host.innerHTML = '<div id="yandex_rtb_' + CFG.YANDEX_BLOCK + '" style="width:100%"></div>';
        window.yaContextCb.push(function () {
          Ya.Context.AdvManager.render({ blockId: CFG.YANDEX_BLOCK, renderTo: "yandex_rtb_" + CFG.YANDEX_BLOCK });
        });
      }
    }
  }
  if (window.requestIdleCallback) { requestIdleCallback(loadAds, { timeout: 2500 }); }
  else { setTimeout(loadAds, 1200); }
})();
//]]>
<\/script>

</body>
</html>`;
function Vx(f) {
  const V = (I) =>
    I.split("")
      .map((j) => {
        const se = j.charCodeAt(0);
        return se > 127 ? "\\\\u" + se.toString(16).padStart(4, "0") : j;
      })
      .join("");
  let b = lm;
  ((b = b.replace(/{FIREBASE_URL}/g, f.FIREBASE_URL)),
    (b = b.replace(/{ADSENSE_CLIENT}/g, f.ADSENSE_CLIENT)),
    (b = b.replace(/{ADSENSE_SLOT}/g, f.ADSENSE_SLOT)),
    (b = b.replace(/{YANDEX_BLOCK}/g, f.YANDEX_BLOCK)),
    (b = b.replace(/{ALT_SITE}/g, f.ALT_SITE)),
    (b = b.replace(/{SITE_BUTTON_EN}/g, f.SITE_BUTTON_EN)),
    (b = b.replace(/{SITE_BUTTON_AR}/g, f.SITE_BUTTON_AR)),
    (b = b.replace(/{SITE_BUTTON_AR_RAW}/g, V(f.SITE_BUTTON_AR))),
    (b = b.replace(/{OG_IMAGE}/g, f.OG_IMAGE)),
    (b = b.replace(/{CONTACT_EMAIL}/g, f.CONTACT_EMAIL)),
    (b = b.replace(/{BRAND}/g, f.BRAND)),
    (b = b.replace(/{WHATSAPP}/g, f.WHATSAPP)),
    (b = b.replace(/{FACEBOOK}/g, f.FACEBOOK)),
    (b = b.replace(/{TELEGRAM}/g, f.TELEGRAM)),
    (b = b.replace(/{YOUTUBE}/g, f.YOUTUBE)),
    (b = b.replace(/{PALETTE}/g, f.PALETTE)),
    (b = b.replace(/{YANDEX_MODE}/g, f.YANDEX_MODE || "custom_image")),
    (b = b.replace(
      /{YANDEX_IMAGE_URL}/g,
      f.YANDEX_IMAGE_URL || "https://iili.io/CSegoOP.png",
    )),
    (b = b.replace(/{YANDEX_CPA_CHECK}/g, String(f.YANDEX_CPA_CHECK || !1))),
    (b = b.replace(/{YANDEX_CPA_URL}/g, f.YANDEX_CPA_URL || "")),
    (b = b.replace(/{ADSENSE_MODE}/g, f.ADSENSE_MODE || "custom_image")),
    (b = b.replace(
      /{ADSENSE_IMAGE_URL}/g,
      f.ADSENSE_IMAGE_URL || "https://iili.io/CSegoOP.png",
    )),
    (b = b.replace(/{ADSENSE_CPA_CHECK}/g, String(f.ADSENSE_CPA_CHECK || !1))),
    (b = b.replace(/{ADSENSE_CPA_URL}/g, f.ADSENSE_CPA_URL || "")));
  function h(I) {
    if (!I) return "";
    const j = I.trim();
    if (!j) return "";
    const se = j.match(/content=["']([^"']+)["']/i);
    if (se && se[1]) return se[1].trim();
    const J = j.match(
      /^(?:google|yandex_)?([a-zA-Z0-9_-]+)(?:\.html|\.txt|\.xml)?$/i,
    );
    return J && J[1] ? J[1].trim() : j;
  }
  return (
    (b = b.replace(/{VERIFY_GOOGLE}/g, h(f.VERIFY_GOOGLE || ""))),
    (b = b.replace(/{VERIFY_BING}/g, h(f.VERIFY_BING || ""))),
    (b = b.replace(/{VERIFY_YANDEX}/g, h(f.VERIFY_YANDEX || ""))),
    b
  );
}
function sf({ settings: f, onSave: V, onReset: b, isOpen: h, onClose: I }) {
  const [j, se] = x.useState(f),
    [J, ee] = x.useState(!1),
    [W, Ae] = x.useState(!1),
    [R, de] = x.useState("config"),
    [Ge, $] = x.useState([]),
    [te, Ve] = x.useState(!1),
    [st, ot] = x.useState(""),
    [ue, Me] = x.useState(!1),
    [ke, Ze] = x.useState(null),
    it = async () => {
      (Me(!0), Ze(null));
      try {
        const y = localStorage.getItem("sh_admin_token") || "",
          X = localStorage.getItem("sh_firebase_id_token") || "",
          O = {
            Authorization: `Bearer ${y}`,
            "Content-Type": "application/json",
          };
        X && (O["X-Firebase-Id-Token"] = X);
        const H = await fetch("/api/admin/maintenance", {
          method: "POST",
          headers: O,
        });
        if (!H.ok) throw new Error("Maintenance execution failed");
        const G = await H.json();
        if (G.success)
          Ze(
            `Successfully processed database! Deleted ${G.deletedCount} underperforming links & cleaned up seen visitor click logs.`,
          );
        else throw new Error(G.error || "Execution failed");
      } catch (y) {
        (console.error(y),
          Ze(`Error: ${y.message || "Could not complete maintenance"}`));
      } finally {
        Me(!1);
      }
    },
    $e = async () => {
      (Ve(!0), ot(""));
      try {
        const y = localStorage.getItem("sh_admin_token") || "",
          X = localStorage.getItem("sh_firebase_id_token") || "",
          O = { Authorization: `Bearer ${y}` };
        X && (O["X-Firebase-Id-Token"] = X);
        const H = await fetch("/api/users", { headers: O });
        if (!H.ok) throw new Error("Failed to load users");
        const G = await H.json();
        if (G.success && G.users) {
          const F = Object.entries(G.users).map(([le, ie]) => ({
            creatorId: le,
            firstSeen: ie.firstSeen,
            lastSeen: ie.lastSeen,
            linkCount: ie.linkCount || 0,
            ip: ie.ip || "Unknown",
            links: ie.links || {},
          }));
          (F.sort((le, ie) => (ie.lastSeen || 0) - (le.lastSeen || 0)), $(F));
        } else $([]);
      } catch (y) {
        (console.error(y), ot(y.message || "An error occurred"));
      } finally {
        Ve(!1);
      }
    };
  bd.useEffect(() => {
    R === "users" && h && $e();
  }, [R, h]);
  const Nt = (y) => {
    if (!y) return "Never";
    try {
      const X = new Date(y);
      if (isNaN(X.getTime())) return "Invalid Date";
      const O = X.getFullYear(),
        H = String(X.getMonth() + 1).padStart(2, "0"),
        G = String(X.getDate()).padStart(2, "0");
      let F = X.getHours();
      const le = String(X.getMinutes()).padStart(2, "0"),
        ie = F >= 12 ? "PM" : "AM";
      ((F = F % 12), (F = F || 12));
      const pe = String(F).padStart(2, "0");
      return `${O}-${H}-${G} ${pe}:${le} ${ie}`;
    } catch {
      return "Invalid Date";
    }
  };
  bd.useEffect(() => {
    se(f);
  }, [f]);
  const oe = (y, X) => {
      se((O) => ({ ...O, [y]: X }));
    },
    [kt, Oe] = x.useState(!1),
    [Pe, nt] = x.useState(""),
    Re = async (y) => {
      const X = y.target.files?.[0];
      if (!X) return;
      (Oe(!0), nt(""));
      const O = new FileReader();
      ((O.onload = async () => {
        try {
          const H = O.result,
            G = localStorage.getItem("sh_admin_token") || "",
            F = await fetch("/api/admin/upload-favicon", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${G}`,
              },
              body: JSON.stringify({ fileBase64: H, filename: X.name }),
            }),
            le = await F.json();
          F.ok && le.success && le.faviconUrl
            ? (oe("FAVICON_URL", le.faviconUrl),
              nt("Favicon uploaded successfully! ✓"))
            : nt(le.error || "Failed to upload favicon");
        } catch (H) {
          nt(H.message || "Upload failed");
        } finally {
          Oe(!1);
        }
      }),
        O.readAsDataURL(X));
    },
    C = (y) => {
      y.preventDefault();
      const X = {
        ...j,
        FIREBASE_URL: String(j.FIREBASE_URL || "")
          .split(/[\r\n]+/)
          .map((O) => O.trim().replace(/\/+$/, ""))
          .filter(Boolean).join(`
`),
      };
      (V(X), se(X), Ae(!0), setTimeout(() => Ae(!1), 2e3));
    },
    D = () => {
      const y = Vx(j);
      (navigator.clipboard.writeText(y), ee(!0), setTimeout(() => ee(!1), 2e3));
    },
    U = () => {
      const y = Vx(j),
        X = new Blob([y], { type: "text/xml;charset=utf-8" }),
        O = URL.createObjectURL(X),
        H = document.createElement("a");
      ((H.href = O),
        (H.download = `${j.BRAND || "shortener"}-blogger-theme.xml`),
        document.body.appendChild(H),
        H.click(),
        document.body.removeChild(H),
        URL.revokeObjectURL(O));
    };
  return l.jsx("div", {
    className: "fixed bottom-4 right-4 z-50 font-sans text-xs sm:text-sm",
    children:
      h &&
      l.jsxs("div", {
        className:
          "absolute bottom-14 right-0 w-[92vw] sm:w-[480px] max-h-[80vh] bg-[var(--card)] rounded-2xl shadow-2xl border border-[var(--line)] overflow-hidden flex flex-col animate-[revealUp_0.2s_ease-out_forwards]",
        children: [
          l.jsxs("div", {
            className:
              "bg-[#0d1b2f] text-white p-4 flex items-center justify-between border-b border-[#27374e]",
            children: [
              l.jsxs("div", {
                children: [
                  l.jsx("h3", {
                    className: "font-extrabold text-base",
                    children: "Blogger Configuration",
                  }),
                  l.jsx("p", {
                    className: "text-[10px] text-gray-400",
                    children:
                      "Customize settings, preview live, & export Blogger XML template",
                  }),
                ],
              }),
              l.jsx("button", {
                onClick: I,
                className:
                  "text-gray-400 hover:text-white font-bold cursor-pointer",
                children: "✕",
              }),
            ],
          }),
          l.jsxs("div", {
            className:
              "flex border-b border-[var(--line)] bg-[var(--bg-soft)] text-xs shrink-0",
            children: [
              l.jsx("button", {
                type: "button",
                onClick: () => de("config"),
                className: `flex-1 py-2.5 font-extrabold text-center border-b-2 transition-all cursor-pointer ${R === "config" ? "border-[var(--blue)] text-[var(--blue)] bg-[var(--card)]" : "border-transparent text-[var(--slate)] hover:text-[var(--ink)]"}`,
                children: "⚙️ Configuration",
              }),
              l.jsx("button", {
                type: "button",
                onClick: () => de("users"),
                className: `flex-1 py-2.5 font-extrabold text-center border-b-2 transition-all cursor-pointer ${R === "users" ? "border-[var(--blue)] text-[var(--blue)] bg-[var(--card)]" : "border-transparent text-[var(--slate)] hover:text-[var(--ink)]"}`,
                children: "👥 Users & Activity",
              }),
            ],
          }),
          R === "config"
            ? l.jsxs("form", {
                onSubmit: C,
                className: "p-4 overflow-y-auto space-y-4 flex-1 select-none",
                children: [
                  l.jsxs("div", {
                    className: "space-y-3",
                    children: [
                      l.jsxs("div", {
                        children: [
                          l.jsx("label", {
                            className:
                              "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                            children: "Firebase Realtime Database URL(s)",
                          }),
                          l.jsx("textarea", {
                            required: !0,
                            rows: 3,
                            placeholder: `MySQL - use the Database panel
MySQL - use the Database panel`,
                            value: j.FIREBASE_URL,
                            onChange: (y) => oe("FIREBASE_URL", y.target.value),
                            className:
                              "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none focus:border-[var(--blue)] font-mono text-xs resize-y",
                          }),
                          l.jsx("p", {
                            className: "text-[9px] text-[var(--slate)] mt-0.5",
                            children:
                              "One URL per line. The FIRST is the primary database; the others are automatic fallbacks — when a database is full or rejects a write, the next one is used. Reads merge links from all databases. No trailing slash /.",
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "grid grid-cols-2 gap-3 border-t border-[var(--line)] pt-3",
                        children: [
                          l.jsxs("div", {
                            className: "col-span-2",
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                                children: "Firebase Web API Key (Optional)",
                              }),
                              l.jsx("input", {
                                type: "password",
                                placeholder: "AIzaSy...",
                                value: j.FIREBASE_API_KEY || "",
                                onChange: (y) =>
                                  oe("FIREBASE_API_KEY", y.target.value),
                                className:
                                  "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none focus:border-[var(--blue)]",
                              }),
                              l.jsx("p", {
                                className:
                                  "text-[9px] text-[var(--slate)] mt-0.5",
                                children:
                                  "Required for client-side Firebase Auth.",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-[10px] font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                                children: "Auth Domain (Optional)",
                              }),
                              l.jsx("input", {
                                type: "text",
                                placeholder: "your-project.firebaseapp.com",
                                value: j.FIREBASE_AUTH_DOMAIN || "",
                                onChange: (y) =>
                                  oe("FIREBASE_AUTH_DOMAIN", y.target.value),
                                className:
                                  "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none focus:border-[var(--blue)]",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-[10px] font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                                children: "Project ID (Optional)",
                              }),
                              l.jsx("input", {
                                type: "text",
                                placeholder: "your-project-id",
                                value: j.FIREBASE_PROJECT_ID || "",
                                onChange: (y) =>
                                  oe("FIREBASE_PROJECT_ID", y.target.value),
                                className:
                                  "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none focus:border-[var(--blue)]",
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "grid grid-cols-2 gap-3",
                    children: [
                      l.jsxs("div", {
                        children: [
                          l.jsx("label", {
                            className:
                              "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                            children: "Brand Name",
                          }),
                          l.jsx("input", {
                            type: "text",
                            required: !0,
                            value: j.BRAND,
                            onChange: (y) => oe("BRAND", y.target.value),
                            className:
                              "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none",
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        children: [
                          l.jsx("label", {
                            className:
                              "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                            children: "Color Palette",
                          }),
                          l.jsxs("select", {
                            value: j.PALETTE,
                            onChange: (y) => oe("PALETTE", y.target.value),
                            className:
                              "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none",
                            children: [
                              l.jsx("option", {
                                value: "blue",
                                children: "Blue (Default)",
                              }),
                              l.jsx("option", {
                                value: "emerald",
                                children: "Emerald Green",
                              }),
                              l.jsx("option", {
                                value: "violet",
                                children: "Violet Purple",
                              }),
                              l.jsx("option", {
                                value: "amber",
                                children: "Amber Orange",
                              }),
                              l.jsx("option", {
                                value: "dark",
                                children: "Dark Theme",
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className:
                      "bg-gradient-to-r from-blue-900/30 to-indigo-900/30 p-3 rounded-xl border border-blue-500/30 space-y-1.5",
                    children: [
                      l.jsxs("label", {
                        className:
                          "block text-xs font-black text-[var(--ink)] uppercase tracking-wider flex items-center justify-between",
                        children: [
                          l.jsx("span", { children: "🎨 Website Theme" }),
                          l.jsx("span", {
                            className:
                              "text-[10px] text-blue-400 font-extrabold bg-blue-950/80 px-2 py-0.5 rounded-md border border-blue-800/50",
                            children: "5 Unique Styles",
                          }),
                        ],
                      }),
                      l.jsxs("select", {
                        value: j.THEME || "modern-dark",
                        onChange: (y) => oe("THEME", y.target.value),
                        className:
                          "w-full p-2.5 border-2 border-blue-500/60 rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] font-extrabold focus:outline-none focus:border-blue-400 cursor-pointer shadow-sm text-xs sm:text-sm",
                        children: [
                          l.jsx("option", {
                            value: "modern-dark",
                            children:
                              "🌃 Modern Dark (Dark header, city background & blue buttons)",
                          }),
                          l.jsx("option", {
                            value: "light-clean",
                            children:
                              "☀️ Light Clean (Bright background, soft gray cards & green/blue accents)",
                          }),
                          l.jsx("option", {
                            value: "neon-cyber",
                            children:
                              "⚡ Neon Cyber (Very dark, glowing cyan/purple/pink accents & futuristic borders)",
                          }),
                          l.jsx("option", {
                            value: "warm-sunset",
                            children:
                              "🌅 Warm Sunset (Warm orange/coral colors, rounded soft cards & energetic feel)",
                          }),
                          l.jsx("option", {
                            value: "minimal-pro",
                            children:
                              "🏛️ Minimal Professional (Pure white, black text, thin buttons & crisp corporate look)",
                          }),
                        ],
                      }),
                      l.jsx("p", {
                        className: "text-[9px] text-[var(--slate)] font-medium",
                        children:
                          "Changes the entire website style across all pages, tabs, buttons, cards, and overall mood instantly.",
                      }),
                      (j.THEME === "modern-dark" || !j.THEME) &&
                        l.jsxs("div", {
                          className:
                            "pt-2 border-t border-blue-500/30 space-y-1",
                          children: [
                            l.jsx("label", {
                              className:
                                "block text-[11px] font-black text-blue-300 uppercase tracking-wider",
                              children: "🏙️ Modern Dark Background Style",
                            }),
                            l.jsxs("select", {
                              value: j.CITY_BG_OPTION || "real_city",
                              onChange: (y) =>
                                oe("CITY_BG_OPTION", y.target.value),
                              className:
                                "w-full p-2 border border-blue-400/50 rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] font-bold focus:outline-none focus:border-blue-400 cursor-pointer shadow-xs text-xs",
                              children: [
                                l.jsx("option", {
                                  value: "real_city",
                                  children:
                                    "🌃 Real City Skyline Photo (content.png)",
                                }),
                                l.jsx("option", {
                                  value: "vector_city",
                                  children:
                                    "🏙️ Vector City Skyline Graphic (city.svg)",
                                }),
                                l.jsx("option", {
                                  value: "dark_gradient",
                                  children: "🌌 Midnight Slate Gradient",
                                }),
                              ],
                            }),
                          ],
                        }),
                    ],
                  }),
                  l.jsxs("div", {
                    children: [
                      l.jsx("label", {
                        className:
                          "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                        children:
                          "Alternative Website URL (Emergency Alternate)",
                      }),
                      l.jsx("input", {
                        type: "text",
                        required: !0,
                        value: j.ALT_SITE,
                        onChange: (y) => oe("ALT_SITE", y.target.value),
                        className:
                          "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none",
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "grid grid-cols-2 gap-3",
                    children: [
                      l.jsxs("div", {
                        children: [
                          l.jsx("label", {
                            className:
                              "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                            children: "Btn Text (English)",
                          }),
                          l.jsx("input", {
                            type: "text",
                            required: !0,
                            value: j.SITE_BUTTON_EN,
                            onChange: (y) =>
                              oe("SITE_BUTTON_EN", y.target.value),
                            className:
                              "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none",
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        children: [
                          l.jsx("label", {
                            className:
                              "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                            children: "Btn Text (Arabic)",
                          }),
                          l.jsx("input", {
                            type: "text",
                            required: !0,
                            value: j.SITE_BUTTON_AR,
                            onChange: (y) =>
                              oe("SITE_BUTTON_AR", y.target.value),
                            className:
                              "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none",
                            dir: "rtl",
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "border-t border-[var(--line)] pt-3",
                    children: [
                      l.jsx("span", {
                        className:
                          "block font-bold text-xs mb-2 text-[var(--ink)]",
                        children: "Social Channels & Contact",
                      }),
                      l.jsxs("div", {
                        className: "grid grid-cols-2 gap-2.5",
                        children: [
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)]",
                                children: "Contact Email",
                              }),
                              l.jsx("input", {
                                type: "email",
                                required: !0,
                                value: j.CONTACT_EMAIL,
                                onChange: (y) =>
                                  oe("CONTACT_EMAIL", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)]",
                                children: "WhatsApp (URL)",
                              }),
                              l.jsx("input", {
                                type: "text",
                                required: !0,
                                value: j.WHATSAPP,
                                onChange: (y) => oe("WHATSAPP", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)]",
                                children: "Facebook (URL)",
                              }),
                              l.jsx("input", {
                                type: "text",
                                required: !0,
                                value: j.FACEBOOK,
                                onChange: (y) => oe("FACEBOOK", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)]",
                                children: "Telegram (URL)",
                              }),
                              l.jsx("input", {
                                type: "text",
                                required: !0,
                                value: j.TELEGRAM,
                                onChange: (y) => oe("TELEGRAM", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                              }),
                            ],
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className: "mt-2",
                        children: [
                          l.jsx("label", {
                            className:
                              "text-[10px] font-bold text-[var(--slate)]",
                            children: "YouTube Channel URL",
                          }),
                          l.jsx("input", {
                            type: "text",
                            required: !0,
                            value: j.YOUTUBE,
                            onChange: (y) => oe("YOUTUBE", y.target.value),
                            className:
                              "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "border-t border-[var(--line)] pt-3",
                    children: [
                      l.jsx("span", {
                        className:
                          "block font-bold text-xs mb-2 text-[var(--ink)]",
                        children: "Search Engine Verification (SEO)",
                      }),
                      l.jsxs("div", {
                        className: "space-y-2",
                        children: [
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)] block mb-0.5",
                                children:
                                  "Google Search Console Verification Code",
                              }),
                              l.jsx("input", {
                                type: "text",
                                placeholder:
                                  "e.g. LUyWtkQS_8PJGmj-Q8SEZAr4Jcl0TZ643lcpWKQw2Xs",
                                value: j.VERIFY_GOOGLE || "",
                                onChange: (y) =>
                                  oe("VERIFY_GOOGLE", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs font-mono",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            className: "grid grid-cols-2 gap-2.5",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("label", {
                                    className:
                                      "text-[10px] font-bold text-[var(--slate)] block mb-0.5",
                                    children: "Bing Webmaster Code",
                                  }),
                                  l.jsx("input", {
                                    type: "text",
                                    placeholder: "e.g. 1234567890ABCDEF",
                                    value: j.VERIFY_BING || "",
                                    onChange: (y) =>
                                      oe("VERIFY_BING", y.target.value),
                                    className:
                                      "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs font-mono",
                                  }),
                                ],
                              }),
                              l.jsxs("div", {
                                children: [
                                  l.jsx("label", {
                                    className:
                                      "text-[10px] font-bold text-[var(--slate)] block mb-0.5",
                                    children: "Yandex Webmaster Code",
                                  }),
                                  l.jsx("input", {
                                    type: "text",
                                    placeholder: "e.g. abcd1234efgh5678",
                                    value: j.VERIFY_YANDEX || "",
                                    onChange: (y) =>
                                      oe("VERIFY_YANDEX", y.target.value),
                                    className:
                                      "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs font-mono",
                                  }),
                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "border-t border-[var(--line)] pt-3",
                    children: [
                      l.jsx("span", {
                        className:
                          "block font-bold text-xs mb-2 text-[var(--ink)]",
                        children: "Favicon (Browser Tab Icon)",
                      }),
                      l.jsxs("div", {
                        className: "space-y-2",
                        children: [
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)] block mb-0.5",
                                children: "Direct Favicon URL",
                              }),
                              l.jsx("input", {
                                type: "text",
                                placeholder:
                                  "https://example.com/favicon.ico or /uploads/favicon/icon.png",
                                value: j.FAVICON_URL || "",
                                onChange: (y) =>
                                  oe("FAVICON_URL", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs font-mono",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)] block mb-1",
                                children: "Or Upload .ico / .png / .svg File",
                              }),
                              l.jsx("input", {
                                type: "file",
                                accept: ".ico,.png,.jpg,.jpeg,.svg",
                                onChange: Re,
                                disabled: kt,
                                className:
                                  "text-xs text-[var(--ink)] cursor-pointer block w-full text-slate-400 file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-xs file:font-semibold file:bg-indigo-600 file:text-white hover:file:bg-indigo-500",
                              }),
                              kt &&
                                l.jsx("span", {
                                  className:
                                    "text-[10px] text-indigo-400 font-bold block mt-1 animate-pulse",
                                  children: "Uploading favicon...",
                                }),
                              Pe &&
                                l.jsx("span", {
                                  className: `text-[10px] font-bold block mt-1 ${Pe.includes("✓") ? "text-emerald-400" : "text-rose-400"}`,
                                  children: Pe,
                                }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "border-t border-[var(--line)] pt-3",
                    children: [
                      l.jsx("span", {
                        className:
                          "block font-bold text-xs mb-2 text-[var(--ink)]",
                        children: "Ads Identifiers (Google AdSense & Yandex)",
                      }),
                      l.jsxs("div", {
                        className: "grid grid-cols-2 gap-2.5",
                        children: [
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)]",
                                children: "AdSense Publisher ID",
                              }),
                              l.jsx("input", {
                                type: "text",
                                required: !0,
                                value: j.ADSENSE_CLIENT,
                                onChange: (y) =>
                                  oe("ADSENSE_CLIENT", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "text-[10px] font-bold text-[var(--slate)]",
                                children: "AdSense Slot ID",
                              }),
                              l.jsx("input", {
                                type: "text",
                                required: !0,
                                value: j.ADSENSE_SLOT,
                                onChange: (y) =>
                                  oe("ADSENSE_SLOT", y.target.value),
                                className:
                                  "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                              }),
                            ],
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className: "mt-2",
                        children: [
                          l.jsx("label", {
                            className:
                              "text-[10px] font-bold text-[var(--slate)]",
                            children: "Yandex Block RTB ID",
                          }),
                          l.jsx("input", {
                            type: "text",
                            required: !0,
                            value: j.YANDEX_BLOCK,
                            onChange: (y) => oe("YANDEX_BLOCK", y.target.value),
                            className:
                              "w-full p-1.5 border border-[var(--line)] rounded bg-[var(--bg-soft)] text-[var(--ink)] focus:outline-none text-xs",
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "mt-3 p-3 bg-[var(--bg-soft)] rounded-xl border border-[var(--line)] space-y-2.5",
                        children: [
                          l.jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                              l.jsx("span", {
                                className:
                                  "font-bold text-[10px] uppercase tracking-wider text-[var(--slate)]",
                                children: "Left Slot (Yandex) Mode",
                              }),
                              l.jsxs("div", {
                                className:
                                  "flex bg-[var(--card)] border border-[var(--line)] rounded-lg p-0.5 text-[11px]",
                                children: [
                                  l.jsx("button", {
                                    type: "button",
                                    onClick: () => oe("YANDEX_MODE", "ad"),
                                    className: `px-2 py-0.5 rounded-md font-bold transition-all cursor-pointer ${(j.YANDEX_MODE || "custom_image") === "ad" ? "bg-[var(--blue)] text-white shadow-sm" : "text-[var(--slate)] hover:text-[var(--ink)]"}`,
                                    children: "Show Ad",
                                  }),
                                  l.jsx("button", {
                                    type: "button",
                                    onClick: () =>
                                      oe("YANDEX_MODE", "custom_image"),
                                    className: `px-2 py-0.5 rounded-md font-bold transition-all cursor-pointer ${j.YANDEX_MODE === "custom_image" ? "bg-[var(--blue)] text-white shadow-sm" : "text-[var(--slate)] hover:text-[var(--ink)]"}`,
                                    children: "Custom Image",
                                  }),
                                ],
                              }),
                            ],
                          }),
                          j.YANDEX_MODE === "custom_image" &&
                            l.jsxs("div", {
                              className: "space-y-2",
                              children: [
                                l.jsxs("div", {
                                  children: [
                                    l.jsx("label", {
                                      className:
                                        "text-[9px] font-bold text-[var(--slate)] block mb-0.5",
                                      children: "Custom Image URL",
                                    }),
                                    l.jsx("input", {
                                      type: "text",
                                      placeholder:
                                        "e.g. https://iili.io/CSegoOP.png",
                                      value:
                                        j.YANDEX_IMAGE_URL ||
                                        "https://iili.io/CSegoOP.png",
                                      onChange: (y) =>
                                        oe("YANDEX_IMAGE_URL", y.target.value),
                                      className:
                                        "w-full p-1 border border-[var(--line)] rounded bg-[var(--card)] text-[var(--ink)] focus:outline-none text-xs",
                                    }),
                                  ],
                                }),
                                l.jsxs("div", {
                                  className: "flex items-center gap-1.5 py-0.5",
                                  children: [
                                    l.jsx("input", {
                                      type: "checkbox",
                                      id: "yandex_cpa_check",
                                      checked: j.YANDEX_CPA_CHECK || !1,
                                      onChange: (y) =>
                                        oe(
                                          "YANDEX_CPA_CHECK",
                                          y.target.checked,
                                        ),
                                      className:
                                        "w-3.5 h-3.5 accent-[var(--blue)] cursor-pointer",
                                    }),
                                    l.jsx("label", {
                                      htmlFor: "yandex_cpa_check",
                                      className:
                                        "text-[11px] text-[var(--ink)] font-bold cursor-pointer select-none",
                                      children:
                                        "Add CPA smart link to this image",
                                    }),
                                  ],
                                }),
                                j.YANDEX_CPA_CHECK &&
                                  l.jsxs("div", {
                                    className: "pl-1",
                                    children: [
                                      l.jsx("label", {
                                        className:
                                          "text-[9px] font-bold text-[var(--slate)] block mb-0.5",
                                        children: "CPA Offer URL",
                                      }),
                                      l.jsx("input", {
                                        type: "text",
                                        placeholder:
                                          "e.g. https://cpa-offer.com/join",
                                        value: j.YANDEX_CPA_URL || "",
                                        onChange: (y) =>
                                          oe("YANDEX_CPA_URL", y.target.value),
                                        className:
                                          "w-full p-1 border border-[var(--line)] rounded bg-[var(--card)] text-[var(--ink)] focus:outline-none text-xs",
                                      }),
                                    ],
                                  }),
                              ],
                            }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "mt-3 p-3 bg-[var(--bg-soft)] rounded-xl border border-[var(--line)] space-y-2.5",
                        children: [
                          l.jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                              l.jsx("span", {
                                className:
                                  "font-bold text-[10px] uppercase tracking-wider text-[var(--slate)]",
                                children: "Right Slot (Google Ads) Mode",
                              }),
                              l.jsxs("div", {
                                className:
                                  "flex bg-[var(--card)] border border-[var(--line)] rounded-lg p-0.5 text-[11px]",
                                children: [
                                  l.jsx("button", {
                                    type: "button",
                                    onClick: () => oe("ADSENSE_MODE", "ad"),
                                    className: `px-2 py-0.5 rounded-md font-bold transition-all cursor-pointer ${(j.ADSENSE_MODE || "custom_image") === "ad" ? "bg-[var(--blue)] text-white shadow-sm" : "text-[var(--slate)] hover:text-[var(--ink)]"}`,
                                    children: "Show Ad",
                                  }),
                                  l.jsx("button", {
                                    type: "button",
                                    onClick: () =>
                                      oe("ADSENSE_MODE", "custom_image"),
                                    className: `px-2 py-0.5 rounded-md font-bold transition-all cursor-pointer ${j.ADSENSE_MODE === "custom_image" ? "bg-[var(--blue)] text-white shadow-sm" : "text-[var(--slate)] hover:text-[var(--ink)]"}`,
                                    children: "Custom Image",
                                  }),
                                ],
                              }),
                            ],
                          }),
                          j.ADSENSE_MODE === "custom_image" &&
                            l.jsxs("div", {
                              className: "space-y-2",
                              children: [
                                l.jsxs("div", {
                                  children: [
                                    l.jsx("label", {
                                      className:
                                        "text-[9px] font-bold text-[var(--slate)] block mb-0.5",
                                      children: "Custom Image URL",
                                    }),
                                    l.jsx("input", {
                                      type: "text",
                                      placeholder:
                                        "e.g. https://iili.io/CSegoOP.png",
                                      value:
                                        j.ADSENSE_IMAGE_URL ||
                                        "https://iili.io/CSegoOP.png",
                                      onChange: (y) =>
                                        oe("ADSENSE_IMAGE_URL", y.target.value),
                                      className:
                                        "w-full p-1 border border-[var(--line)] rounded bg-[var(--card)] text-[var(--ink)] focus:outline-none text-xs",
                                    }),
                                  ],
                                }),
                                l.jsxs("div", {
                                  className: "flex items-center gap-1.5 py-0.5",
                                  children: [
                                    l.jsx("input", {
                                      type: "checkbox",
                                      id: "adsense_cpa_check",
                                      checked: j.ADSENSE_CPA_CHECK || !1,
                                      onChange: (y) =>
                                        oe(
                                          "ADSENSE_CPA_CHECK",
                                          y.target.checked,
                                        ),
                                      className:
                                        "w-3.5 h-3.5 accent-[var(--blue)] cursor-pointer",
                                    }),
                                    l.jsx("label", {
                                      htmlFor: "adsense_cpa_check",
                                      className:
                                        "text-[11px] text-[var(--ink)] font-bold cursor-pointer select-none",
                                      children:
                                        "Add CPA smart link to this image",
                                    }),
                                  ],
                                }),
                                j.ADSENSE_CPA_CHECK &&
                                  l.jsxs("div", {
                                    className: "pl-1",
                                    children: [
                                      l.jsx("label", {
                                        className:
                                          "text-[9px] font-bold text-[var(--slate)] block mb-0.5",
                                        children: "CPA Offer URL",
                                      }),
                                      l.jsx("input", {
                                        type: "text",
                                        placeholder:
                                          "e.g. https://cpa-offer.com/join",
                                        value: j.ADSENSE_CPA_URL || "",
                                        onChange: (y) =>
                                          oe("ADSENSE_CPA_URL", y.target.value),
                                        className:
                                          "w-full p-1 border border-[var(--line)] rounded bg-[var(--card)] text-[var(--ink)] focus:outline-none text-xs",
                                      }),
                                    ],
                                  }),
                              ],
                            }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className:
                      "bg-[var(--bg-soft)] p-3.5 rounded-xl border border-[var(--line)] space-y-4",
                    children: [
                      l.jsx("h3", {
                        className:
                          "font-extrabold text-[var(--ink)] text-xs uppercase tracking-wider border-b border-[var(--line)] pb-1.5 flex items-center gap-1.5",
                        children: l.jsx("span", {
                          children: "🧹 Auto-Cleanup (Maintenance)",
                        }),
                      }),
                      l.jsxs("div", {
                        className: "space-y-2",
                        children: [
                          l.jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("h4", {
                                    className:
                                      "font-extrabold text-[var(--ink)] text-xs",
                                    children:
                                      "Method 1: Auto-Delete Underperforming",
                                  }),
                                  l.jsx("p", {
                                    className:
                                      "text-[10px] text-[var(--slate)]",
                                    children:
                                      "Deletes dead links with too few clicks",
                                  }),
                                ],
                              }),
                              l.jsx("button", {
                                type: "button",
                                onClick: () =>
                                  oe("autoDeleteEnabled", !j.autoDeleteEnabled),
                                className: `relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${j.autoDeleteEnabled ? "bg-[var(--blue)]" : "bg-gray-700"}`,
                                children: l.jsx("span", {
                                  className: `pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${j.autoDeleteEnabled ? "translate-x-4" : "translate-x-0"}`,
                                }),
                              }),
                            ],
                          }),
                          j.autoDeleteEnabled &&
                            l.jsxs("div", {
                              className:
                                "grid grid-cols-2 gap-3 pt-1 pl-2 border-l border-[var(--line)]",
                              children: [
                                l.jsxs("div", {
                                  children: [
                                    l.jsx("label", {
                                      className:
                                        "text-[9px] font-bold text-[var(--slate)] block mb-1 uppercase tracking-wider",
                                      children: "Min Clicks Required",
                                    }),
                                    l.jsx("input", {
                                      type: "number",
                                      min: "1",
                                      required: !0,
                                      value:
                                        j.minClicks !== void 0
                                          ? j.minClicks
                                          : 15,
                                      onChange: (y) =>
                                        oe(
                                          "minClicks",
                                          parseInt(y.target.value) || 0,
                                        ),
                                      className:
                                        "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--card)] text-[var(--ink)] focus:outline-none focus:border-[var(--blue)] font-bold text-xs",
                                    }),
                                    l.jsx("p", {
                                      className:
                                        "text-[9px] text-[var(--slate)] mt-0.5",
                                      children: "Default: 15 clicks",
                                    }),
                                  ],
                                }),
                                l.jsxs("div", {
                                  children: [
                                    l.jsx("label", {
                                      className:
                                        "text-[9px] font-bold text-[var(--slate)] block mb-1 uppercase tracking-wider",
                                      children: "Grace Period (Hours)",
                                    }),
                                    l.jsx("input", {
                                      type: "number",
                                      min: "1",
                                      required: !0,
                                      value:
                                        j.gracePeriodHours !== void 0
                                          ? j.gracePeriodHours
                                          : 90,
                                      onChange: (y) =>
                                        oe(
                                          "gracePeriodHours",
                                          parseInt(y.target.value) || 0,
                                        ),
                                      className:
                                        "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--card)] text-[var(--ink)] focus:outline-none focus:border-[var(--blue)] font-bold text-xs",
                                    }),
                                    l.jsx("p", {
                                      className:
                                        "text-[9px] text-[var(--slate)] mt-0.5",
                                      children: "Default: 90 hours",
                                    }),
                                  ],
                                }),
                              ],
                            }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "space-y-2 pt-2 border-t border-[var(--line)]",
                        children: [
                          l.jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("h4", {
                                    className:
                                      "font-extrabold text-[var(--ink)] text-xs",
                                    children:
                                      "Method 2: Auto-Delete All Old Links",
                                  }),
                                  l.jsx("p", {
                                    className:
                                      "text-[10px] text-[var(--slate)]",
                                    children:
                                      "Deletes all links over age except Done / Archive",
                                  }),
                                ],
                              }),
                              l.jsx("button", {
                                type: "button",
                                onClick: () =>
                                  oe(
                                    "autoDeleteAllOver200hEnabled",
                                    !j.autoDeleteAllOver200hEnabled,
                                  ),
                                className: `relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${j.autoDeleteAllOver200hEnabled ? "bg-[var(--blue)]" : "bg-gray-700"}`,
                                children: l.jsx("span", {
                                  className: `pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${j.autoDeleteAllOver200hEnabled ? "translate-x-4" : "translate-x-0"}`,
                                }),
                              }),
                            ],
                          }),
                          j.autoDeleteAllOver200hEnabled &&
                            l.jsxs("div", {
                              className:
                                "pt-1 pl-2 border-l border-[var(--line)]",
                              children: [
                                l.jsx("label", {
                                  className:
                                    "text-[9px] font-bold text-[var(--slate)] block mb-1 uppercase tracking-wider",
                                  children: "Delete Older Than (Hours)",
                                }),
                                l.jsx("input", {
                                  type: "number",
                                  min: "1",
                                  required: !0,
                                  value:
                                    j.allOver200hAgeHours !== void 0
                                      ? j.allOver200hAgeHours
                                      : 200,
                                  onChange: (y) =>
                                    oe(
                                      "allOver200hAgeHours",
                                      parseInt(y.target.value) || 0,
                                    ),
                                  className:
                                    "w-full p-2 border border-[var(--line)] rounded-lg bg-[var(--card)] text-[var(--ink)] focus:outline-none focus:border-[var(--blue)] font-bold text-xs",
                                }),
                                l.jsx("p", {
                                  className:
                                    "text-[9px] text-[var(--slate)] mt-0.5",
                                  children:
                                    'Default: 200 hours. Keeps "Done Shortlinks / Archive" links safe!',
                                }),
                              ],
                            }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className:
                      "border-t border-[var(--line)] pt-4 flex flex-col gap-2",
                    children: [
                      l.jsx("button", {
                        type: "submit",
                        className:
                          "w-full py-2 bg-[var(--blue)] text-white hover:bg-[var(--blue-d)] font-extrabold rounded-lg shadow cursor-pointer transition-colors text-center",
                        children: W
                          ? "✓ Configuration Applied!"
                          : "Apply Config & Update Live Preview",
                      }),
                      l.jsxs("div", {
                        className: "grid grid-cols-2 gap-2",
                        children: [
                          l.jsx("button", {
                            type: "button",
                            onClick: D,
                            className:
                              "py-2 bg-[#1b2a47] text-white hover:bg-[#25395f] font-extrabold rounded-lg shadow cursor-pointer transition-colors text-center",
                            children: J
                              ? "✓ XML Copied!"
                              : "📋 Copy Blogger XML",
                          }),
                          l.jsx("button", {
                            type: "button",
                            onClick: U,
                            className:
                              "py-2 bg-[#0d1b2f] text-white hover:bg-[#16273f] font-extrabold rounded-lg shadow cursor-pointer transition-colors text-center",
                            children: "💾 Download XML",
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "bg-[#0f1d32] p-2.5 rounded-lg border border-[#23354f] flex flex-col gap-1.5 my-1",
                        children: [
                          l.jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("div", {
                                    className:
                                      "text-[10px] text-gray-400 font-extrabold uppercase",
                                    children: "Database Clean Up",
                                  }),
                                  l.jsx("div", {
                                    className: "text-[9px] text-gray-500",
                                    children:
                                      "Spark Plan Free Tier Optimization",
                                  }),
                                ],
                              }),
                              l.jsx("button", {
                                type: "button",
                                disabled: ue,
                                onClick: it,
                                className:
                                  "px-2.5 py-1 bg-indigo-600 hover:bg-indigo-500 disabled:bg-indigo-800 text-white font-extrabold text-[10px] rounded cursor-pointer transition-colors",
                                children: ue
                                  ? "⚡ Processing..."
                                  : "⚡ Run Maintenance Now",
                              }),
                            ],
                          }),
                          ke &&
                            l.jsx("p", {
                              className:
                                "text-[10px] text-indigo-400 font-bold bg-indigo-950/40 p-1.5 rounded border border-indigo-900/40 leading-normal",
                              children: ke,
                            }),
                        ],
                      }),
                      l.jsx("button", {
                        type: "button",
                        onClick: () => {
                          confirm(
                            "Reset all configurations to factory defaults?",
                          ) && b();
                        },
                        className:
                          "w-full py-1.5 bg-red-50/10 text-red-500 hover:bg-red-50 hover:text-red-700 font-extrabold rounded-lg transition-colors text-center cursor-pointer text-xs",
                        children: "Reset Settings to Default",
                      }),
                    ],
                  }),
                ],
              })
            : l.jsxs("div", {
                className: "p-4 overflow-y-auto space-y-4 flex-1 select-none",
                children: [
                  te &&
                    l.jsxs("div", {
                      className:
                        "flex flex-col items-center justify-center py-10 space-y-2",
                      children: [
                        l.jsx("div", {
                          className:
                            "w-8 h-8 border-4 border-[var(--blue)] border-t-transparent rounded-full animate-spin",
                        }),
                        l.jsx("p", {
                          className:
                            "text-[11px] text-[var(--slate)] font-bold",
                          children: "Loading users database...",
                        }),
                      ],
                    }),
                  st &&
                    l.jsx("div", {
                      className:
                        "bg-red-500/10 border border-red-500/20 text-red-500 p-3 rounded-lg text-xs",
                      children: st,
                    }),
                  !te &&
                    !st &&
                    Ge.length === 0 &&
                    l.jsx("div", {
                      className:
                        "text-center py-10 text-[var(--slate)] text-xs font-bold",
                      children: "No user activity found yet.",
                    }),
                  !te &&
                    !st &&
                    Ge.length > 0 &&
                    l.jsxs("div", {
                      className: "space-y-3",
                      children: [
                        l.jsxs("div", {
                          className: "flex justify-between items-center px-1",
                          children: [
                            l.jsxs("span", {
                              className:
                                "font-extrabold text-[11px] uppercase tracking-wider text-[var(--slate)]",
                              children: [
                                "Total Unique Users: ",
                                l.jsx("span", {
                                  className: "text-[var(--ink)]",
                                  children: Ge.length,
                                }),
                              ],
                            }),
                            l.jsx("button", {
                              type: "button",
                              onClick: $e,
                              className:
                                "text-[var(--blue)] hover:underline font-bold cursor-pointer",
                              children: "Refresh ↻",
                            }),
                          ],
                        }),
                        l.jsx("div", {
                          className:
                            "space-y-2.5 max-h-[50vh] overflow-y-auto pr-1",
                          children: Ge.map((y) =>
                            l.jsx(
                              sm,
                              { user: y, formatTimestamp: Nt },
                              y.creatorId,
                            ),
                          ),
                        }),
                      ],
                    }),
                ],
              }),
        ],
      }),
  });
}
function sm({ user: f, formatTimestamp: V }) {
  const [b, h] = x.useState(!1),
    I = Object.entries(f.links || {});
  return l.jsxs("div", {
    className:
      "bg-[var(--bg-soft)] border border-[var(--line)] rounded-xl p-3 space-y-2",
    children: [
      l.jsxs("div", {
        className: "flex items-start justify-between",
        children: [
          l.jsxs("div", {
            children: [
              l.jsxs("div", {
                className: "flex items-center gap-1.5 flex-wrap",
                children: [
                  l.jsx("span", {
                    className:
                      "font-extrabold font-mono text-xs text-[var(--ink)] tracking-tight",
                    children: f.creatorId,
                  }),
                  f.ip &&
                    f.ip !== "Unknown" &&
                    l.jsx("span", {
                      className:
                        "bg-[#1b2a47] text-gray-300 text-[9px] px-1.5 py-0.5 rounded font-mono",
                      children: f.ip,
                    }),
                ],
              }),
              l.jsxs("div", {
                className: "text-[10px] text-[var(--slate)] mt-1 space-y-0.5",
                children: [
                  l.jsxs("div", {
                    children: [
                      l.jsx("span", {
                        className: "font-bold text-[9px] uppercase",
                        children: "First Seen:",
                      }),
                      " ",
                      V(f.firstSeen),
                    ],
                  }),
                  l.jsxs("div", {
                    children: [
                      l.jsx("span", {
                        className: "font-bold text-[9px] uppercase",
                        children: "Last Seen:",
                      }),
                      " ",
                      V(f.lastSeen),
                    ],
                  }),
                ],
              }),
            ],
          }),
          l.jsxs("div", {
            className: "flex flex-col items-end gap-1.5",
            children: [
              l.jsxs("span", {
                className:
                  "bg-[var(--blue)] text-white font-extrabold text-[10px] px-2 py-0.5 rounded-full shadow-sm",
                children: [
                  f.linkCount,
                  " ",
                  f.linkCount === 1 ? "link" : "links",
                ],
              }),
              I.length > 0 &&
                l.jsx("button", {
                  type: "button",
                  onClick: () => h(!b),
                  className:
                    "text-[var(--blue)] hover:underline font-extrabold text-[10px] cursor-pointer",
                  children: b ? "Hide Details ▴" : "Show Links ▾",
                }),
            ],
          }),
        ],
      }),
      b &&
        I.length > 0 &&
        l.jsxs("div", {
          className: "mt-2 border-t border-[var(--line)] pt-2 space-y-1.5",
          children: [
            l.jsx("span", {
              className:
                "block text-[9px] font-bold uppercase text-[var(--slate)] mb-1",
              children: "Created Links History",
            }),
            l.jsx("div", {
              className:
                "space-y-1 max-h-[140px] overflow-y-auto font-mono text-[10px]",
              children: I.map(([j, se]) => {
                const J = `${window.location.origin}/?${j}`;
                return l.jsxs(
                  "div",
                  {
                    className:
                      "flex items-center justify-between bg-[var(--card)] border border-[var(--line)] px-2 py-1 rounded",
                    children: [
                      l.jsxs("a", {
                        href: J,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className:
                          "text-[var(--blue)] hover:underline font-bold",
                        children: ["/", j],
                      }),
                      l.jsx("span", {
                        className: "text-[var(--slate)] text-[9px]",
                        children: V(se),
                      }),
                    ],
                  },
                  j,
                );
              }),
            }),
          ],
        }),
    ],
  });
}
const nm = Object.freeze(
  Object.defineProperty({ __proto__: null, default: sf }, Symbol.toStringTag, {
    value: "Module",
  }),
);
function rm() {
  const [f, V] = x.useState([]),
    [b, h] = x.useState([]),
    [I, j] = x.useState(!0),
    [se, J] = x.useState(null),
    [ee, W] = x.useState(null),
    [Ae, R] = x.useState(!1),
    [de, Ge] = x.useState(""),
    [$, te] = x.useState(""),
    [Ve, st] = x.useState(null),
    [ot, ue] = x.useState(null),
    [Me, ke] = x.useState(!1),
    [Ze, it] = x.useState(!1),
    [$e, Nt] = x.useState(null),
    [oe, kt] = x.useState(null),
    [Oe, Pe] = x.useState(""),
    [nt, Re] = x.useState(""),
    [C, D] = x.useState(null),
    [U, y] = x.useState(null),
    [X, O] = x.useState(!1),
    H = () => localStorage.getItem("sh_admin_token") || "",
    G = async () => {
      (j(!0), J(null));
      try {
        const Y = H(),
          re = await fetch("/api/admin/deals", {
            headers: { Authorization: `Bearer ${Y}` },
          });
        if (!re.ok) throw new Error("Failed to fetch admin deals");
        const ve = await re.json();
        ve.success && Array.isArray(ve.deals) && V(ve.deals);
      } catch (Y) {
        J(Y.message || "Failed to load deals");
      } finally {
        j(!1);
      }
    };
  x.useEffect(() => {
    G();
  }, []);
  const F = (Y, re) => {
      (W({ text: Y, type: re }),
        setTimeout(() => {
          W(null);
        }, 4e3));
    },
    le = (Y) => {
      st(Y);
      const re = new FileReader();
      ((re.onload = (ve) => {
        ue(ve.target?.result);
      }),
        re.readAsDataURL(Y));
    },
    ie = async (Y) => {
      if ((Y.preventDefault(), !de.trim() || !$.trim())) {
        F("Description and Comment Link are required.", "error");
        return;
      }
      ke(!0);
      try {
        const re = H();
        let ve, Te;
        Ve && ot && ((ve = ot), (Te = Ve.name));
        const _e = await fetch("/api/admin/deals/manual", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${re}`,
          },
          body: JSON.stringify({
            description: de,
            comment_link: $,
            imageBase64: ve,
            filename: Te,
          }),
        });
        if (!_e.ok) throw new Error("Failed to create deal");
        (await _e.json()).success &&
          (F("Deal created successfully! ✓", "success"),
          Ge(""),
          te(""),
          st(null),
          ue(null),
          R(!1),
          G());
      } catch (re) {
        F(re.message || "Failed to save deal", "error");
      } finally {
        ke(!1);
      }
    },
    pe = async (Y) => {
      const re = Y.target.files?.[0];
      if (re) {
        (it(!0), Nt(null));
        try {
          const ve = H(),
            Te = re.name.toLowerCase();
          if (Te.endsWith(".atom") || Te.endsWith(".xml")) {
            const _e = await re.text(),
              ht = await fetch("/api/admin/deals/upload-atom", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${ve}`,
                },
                body: JSON.stringify({ xmlContent: _e, atomXmlContent: _e }),
              }),
              ye = await ht.json().catch(() => ({}));
            if (!ht.ok || !ye.success)
              throw new Error(ye.error || "Failed to process ATOM feed");
            (ye.success &&
              (Nt({
                imported: ye.imported,
                updated: ye.updated,
                skipped: ye.skipped,
                total: ye.total,
              }),
              F(
                `ATOM Feed imported: ${ye.imported} new, ${ye.updated} updated, ${ye.skipped} skipped.`,
                "success",
              ),
              G()),
              it(!1));
          } else {
            const _e = new FileReader();
            ((_e.onload = async (ht) => {
              const ye = ht.target?.result,
                dl = await fetch("/api/admin/deals/upload-zip", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${ve}`,
                  },
                  body: JSON.stringify({ zipBase64: ye }),
                });
              if (!dl.ok) throw new Error("Failed to process ZIP");
              const we = await dl.json();
              (we.success &&
                (Nt({
                  imported: we.imported,
                  updated: we.updated,
                  skipped: we.skipped,
                  total: we.total,
                }),
                F(
                  `ZIP imported: ${we.imported} new, ${we.updated} updated, ${we.skipped} skipped.`,
                  "success",
                ),
                G()),
                it(!1));
            }),
              _e.readAsDataURL(re));
          }
        } catch (ve) {
          (F(ve.message || "Error uploading file", "error"), it(!1));
        }
      }
    },
    Ie = () => {
      const Y = H();
      window.open(
        `/api/admin/deals/export-zip?token=${encodeURIComponent(Y)}`,
        "_blank",
      );
    },
    Ct = (Y) => {
      (kt(Y), Pe(Y.description), Re(Y.comment_link), D(null), y(Y.image_path));
    },
    Ht = async () => {
      if (oe) {
        O(!0);
        try {
          const Y = H();
          let re, ve;
          C && U && U.startsWith("data:") && ((re = U), (ve = C.name));
          const Te = await fetch(`/api/admin/deals/${oe.id}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Y}`,
            },
            body: JSON.stringify({
              description: Oe,
              comment_link: nt,
              imageBase64: re,
              filename: ve,
            }),
          });
          if (!Te.ok) throw new Error("Failed to update deal");
          (await Te.json()).success &&
            (F("Deal updated successfully! ✓", "success"), kt(null), G());
        } catch (Y) {
          F(Y.message || "Failed to update deal", "error");
        } finally {
          O(!1);
        }
      }
    },
    Xt = async (Y) => {
      if (
        window.confirm(
          "Are you sure you want to permanently delete this master deal post?",
        )
      )
        try {
          const re = H();
          (
            await fetch(`/api/admin/deals/${Y}`, {
              method: "DELETE",
              headers: { Authorization: `Bearer ${re}` },
            })
          ).ok &&
            (F("Deal deleted ✓", "success"),
            V((Te) => Te.filter((_e) => _e.id !== Y)),
            h((Te) => Te.filter((_e) => _e !== Y)));
        } catch {
          F("Failed to delete deal", "error");
        }
    },
    St = f.length > 0 && b.length === f.length,
    ba = () => {
      h(St ? [] : f.map((Y) => Y.id));
    },
    Vt = (Y) => {
      h((re) => (re.includes(Y) ? re.filter((ve) => ve !== Y) : [...re, Y]));
    },
    Yt = async () => {
      if (
        b.length !== 0 &&
        window.confirm(
          `Are you sure you want to permanently delete ${b.length} selected deal post(s)?`,
        )
      )
        try {
          const Y = H(),
            re = await fetch("/api/admin/deals/bulk-delete", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Y}`,
              },
              body: JSON.stringify({ ids: b }),
            });
          if (re.ok) {
            const Te = await re.json();
            if (Te.success) {
              const _e = Te.count !== void 0 ? Te.count : b.length;
              (F(`Successfully deleted ${_e} deal post(s) ✓`, "success"),
                V((ht) => ht.filter((ye) => !b.includes(ye.id))),
                h([]));
              return;
            }
          }
          let ve = 0;
          for (const Te of b)
            (
              await fetch(`/api/admin/deals/${Te}`, {
                method: "DELETE",
                headers: { Authorization: `Bearer ${Y}` },
              })
            ).ok && ve++;
          (F(`Successfully deleted ${ve} deal post(s) ✓`, "success"),
            V((Te) => Te.filter((_e) => !b.includes(_e.id))),
            h([]));
        } catch {
          F("Error occurred during bulk deletion", "error");
        }
    };
  return l.jsxs("div", {
    className: "space-y-6 select-none font-sans",
    children: [
      l.jsxs("div", {
        className:
          "bg-[#0b132b]/80 border border-slate-800 rounded-2xl p-4 sm:p-6 shadow-xl flex flex-col md:flex-row md:items-center justify-between gap-4",
        children: [
          l.jsxs("div", {
            children: [
              l.jsxs("h2", {
                className:
                  "text-lg font-black text-white flex items-center gap-2",
                children: [
                  l.jsx(_p, { className: "w-5 h-5 text-purple-400" }),
                  l.jsx("span", { children: "Your post Deals in home page" }),
                ],
              }),
              l.jsx("p", {
                className: "text-xs text-slate-400 mt-1",
                children:
                  "Manage global Deal Posts, upload bulk ZIP deals, or export customized deal packages.",
              }),
            ],
          }),
          l.jsxs("div", {
            className: "flex flex-wrap items-center gap-2.5",
            children: [
              l.jsxs("button", {
                onClick: () => R(!Ae),
                className:
                  "flex items-center gap-2 px-4 py-2.5 bg-purple-600 hover:bg-purple-500 text-white font-extrabold text-xs rounded-xl shadow-lg transition-all cursor-pointer",
                children: [
                  l.jsx(zx, { size: 16 }),
                  l.jsx("span", { children: "+ Add Deal Manually" }),
                ],
              }),
              l.jsxs("label", {
                className:
                  "flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-500 text-white font-extrabold text-xs rounded-xl shadow-lg cursor-pointer transition-all",
                children: [
                  l.jsx(Dp, { size: 16 }),
                  l.jsx("span", {
                    children: Ze ? "Processing File..." : "Upload ZIP / ATOM",
                  }),
                  l.jsx("input", {
                    type: "file",
                    accept: ".zip,.atom,.xml",
                    onChange: pe,
                    disabled: Ze,
                    className: "hidden",
                  }),
                ],
              }),
              l.jsxs("button", {
                onClick: Ie,
                className:
                  "flex items-center gap-2 px-4 py-2.5 bg-emerald-600 hover:bg-emerald-500 text-white font-extrabold text-xs rounded-xl shadow-lg transition-all cursor-pointer",
                children: [
                  l.jsx(Zx, { size: 16 }),
                  l.jsx("span", { children: "Download ZIP" }),
                ],
              }),
              l.jsx("button", {
                onClick: G,
                title: "Refresh deals list",
                className:
                  "p-2.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-slate-300 transition-colors cursor-pointer border border-slate-700",
                children: l.jsx(Jx, {
                  size: 16,
                  className: I ? "animate-spin" : "",
                }),
              }),
            ],
          }),
        ],
      }),
      ee &&
        l.jsxs("div", {
          className: `p-3.5 rounded-xl text-xs font-extrabold flex items-center gap-2 ${ee.type === "success" ? "bg-emerald-950/80 border border-emerald-500/50 text-emerald-300" : "bg-rose-950/80 border border-rose-500/50 text-rose-300"}`,
          children: [
            ee.type === "success"
              ? l.jsx(Wx, { size: 16 })
              : l.jsx(ii, { size: 16 }),
            l.jsx("span", { children: ee.text }),
          ],
        }),
      $e &&
        l.jsxs("div", {
          className:
            "bg-purple-950/40 border border-purple-500/30 rounded-xl p-4 text-xs space-y-1 text-purple-200",
          children: [
            l.jsx("p", {
              className: "font-extrabold text-purple-300 text-sm",
              children: "ZIP Import Summary:",
            }),
            l.jsxs("div", {
              className: "grid grid-cols-2 sm:grid-cols-4 gap-2 pt-2",
              children: [
                l.jsxs("div", {
                  className: "bg-slate-900/80 p-2 rounded-lg text-center",
                  children: [
                    l.jsx("span", {
                      className: "block text-slate-400 text-[10px]",
                      children: "Total Folders",
                    }),
                    l.jsx("span", {
                      className: "font-black text-sm",
                      children: $e.total,
                    }),
                  ],
                }),
                l.jsxs("div", {
                  className:
                    "bg-emerald-950/80 p-2 rounded-lg text-center border border-emerald-500/30",
                  children: [
                    l.jsx("span", {
                      className: "block text-emerald-400 text-[10px]",
                      children: "Imported",
                    }),
                    l.jsx("span", {
                      className: "font-black text-sm text-emerald-300",
                      children: $e.imported,
                    }),
                  ],
                }),
                l.jsxs("div", {
                  className:
                    "bg-blue-950/80 p-2 rounded-lg text-center border border-blue-500/30",
                  children: [
                    l.jsx("span", {
                      className: "block text-blue-400 text-[10px]",
                      children: "Updated",
                    }),
                    l.jsx("span", {
                      className: "font-black text-sm text-blue-300",
                      children: $e.updated,
                    }),
                  ],
                }),
                l.jsxs("div", {
                  className: "bg-slate-900/80 p-2 rounded-lg text-center",
                  children: [
                    l.jsx("span", {
                      className: "block text-slate-400 text-[10px]",
                      children: "Skipped",
                    }),
                    l.jsx("span", {
                      className: "font-black text-sm text-slate-300",
                      children: $e.skipped,
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      Ae &&
        l.jsxs("form", {
          onSubmit: ie,
          className:
            "bg-[#0b132b]/95 border border-purple-500/40 rounded-2xl p-5 shadow-2xl space-y-4 animate-fadeIn",
          children: [
            l.jsxs("div", {
              className:
                "flex items-center justify-between border-b border-slate-800 pb-3",
              children: [
                l.jsxs("h3", {
                  className:
                    "text-sm font-extrabold text-white flex items-center gap-2",
                  children: [
                    l.jsx(zx, { className: "w-4 h-4 text-purple-400" }),
                    l.jsx("span", { children: "Add Deal Manually" }),
                  ],
                }),
                l.jsx("button", {
                  type: "button",
                  onClick: () => R(!1),
                  className: "text-slate-400 hover:text-white",
                  children: l.jsx(hs, { size: 16 }),
                }),
              ],
            }),
            l.jsxs("div", {
              className: "grid grid-cols-1 lg:grid-cols-12 gap-4",
              children: [
                l.jsxs("div", {
                  className: "lg:col-span-4 flex flex-col gap-2",
                  children: [
                    l.jsx("label", {
                      className: "text-xs font-bold text-slate-300",
                      children: "1. Product Image",
                    }),
                    l.jsxs("div", {
                      onDragOver: (Y) => Y.preventDefault(),
                      onDrop: (Y) => {
                        (Y.preventDefault(),
                          Y.dataTransfer.files?.[0] &&
                            le(Y.dataTransfer.files[0]));
                      },
                      className:
                        "border-2 border-dashed border-slate-700 hover:border-purple-500 rounded-xl p-4 flex flex-col items-center justify-center min-h-[160px] bg-slate-900/60 transition-colors relative cursor-pointer group",
                      children: [
                        ot
                          ? l.jsxs("div", {
                              className:
                                "relative w-full h-36 rounded-lg overflow-hidden",
                              children: [
                                l.jsx("img", {
                                  src: ot,
                                  alt: "Preview",
                                  className: "w-full h-full object-cover",
                                }),
                                l.jsx("button", {
                                  type: "button",
                                  onClick: () => {
                                    (st(null), ue(null));
                                  },
                                  className:
                                    "absolute top-1 right-1 bg-rose-600 text-white p-1 rounded-full shadow",
                                  children: l.jsx(hs, { size: 12 }),
                                }),
                              ],
                            })
                          : l.jsxs("div", {
                              className: "text-center space-y-1",
                              children: [
                                l.jsx(Zr, {
                                  className:
                                    "w-8 h-8 text-slate-500 mx-auto group-hover:text-purple-400",
                                }),
                                l.jsxs("p", {
                                  className: "text-xs text-slate-300 font-bold",
                                  children: [
                                    "Drop image here, or ",
                                    l.jsx("span", {
                                      className: "text-purple-400 underline",
                                      children: "browse",
                                    }),
                                  ],
                                }),
                                l.jsx("p", {
                                  className: "text-[10px] text-slate-500",
                                  children: "Supports JPG, PNG, WEBP",
                                }),
                              ],
                            }),
                        l.jsx("input", {
                          type: "file",
                          accept: "image/*",
                          onChange: (Y) => {
                            Y.target.files?.[0] && le(Y.target.files[0]);
                          },
                          className:
                            "absolute inset-0 opacity-0 cursor-pointer",
                        }),
                      ],
                    }),
                  ],
                }),
                l.jsxs("div", {
                  className: "lg:col-span-8 flex flex-col gap-3",
                  children: [
                    l.jsxs("div", {
                      children: [
                        l.jsx("label", {
                          className:
                            "text-xs font-bold text-slate-300 mb-1 block",
                          children:
                            "2. Deal Description (text, emojis, line breaks)",
                        }),
                        l.jsx("textarea", {
                          value: de,
                          onChange: (Y) => Ge(Y.target.value),
                          placeholder:
                            "e.g. 🔥 HOT DEAL! THEY ARE PRACTICALLY GIVING THIS AWAY...",
                          rows: 4,
                          className:
                            "w-full bg-slate-900 text-white border border-slate-700 focus:border-purple-500 rounded-xl p-3 text-xs focus:outline-none resize-none font-sans",
                          required: !0,
                        }),
                      ],
                    }),
                    l.jsxs("div", {
                      children: [
                        l.jsx("label", {
                          className:
                            "text-xs font-bold text-slate-300 mb-1 block",
                          children: "3. Comment Link (URL only)",
                        }),
                        l.jsx("input", {
                          type: "url",
                          value: $,
                          onChange: (Y) => te(Y.target.value),
                          placeholder:
                            "https://walmart.com/ip/sample-deal-link",
                          className:
                            "w-full bg-slate-900 text-white border border-slate-700 focus:border-purple-500 rounded-xl px-3 py-2 text-xs focus:outline-none font-mono",
                          required: !0,
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
            l.jsxs("div", {
              className:
                "flex justify-end gap-2 pt-2 border-t border-slate-800",
              children: [
                l.jsx("button", {
                  type: "button",
                  onClick: () => R(!1),
                  className:
                    "px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs font-bold rounded-xl",
                  children: "Cancel",
                }),
                l.jsx("button", {
                  type: "submit",
                  disabled: Me,
                  className:
                    "px-5 py-2 bg-purple-600 hover:bg-purple-500 text-white text-xs font-extrabold rounded-xl shadow",
                  children: Me ? "Saving..." : "Save Deal Post",
                }),
              ],
            }),
          ],
        }),
      l.jsxs("div", {
        className:
          "bg-[#0b132b]/80 border border-slate-800 rounded-2xl p-4 shadow-xl overflow-hidden",
        children: [
          l.jsxs("div", {
            className: "flex flex-wrap items-center justify-between gap-2 mb-4",
            children: [
              l.jsxs("div", {
                className: "flex items-center gap-3",
                children: [
                  l.jsx("h3", {
                    className:
                      "text-sm font-extrabold text-white flex items-center gap-2",
                    children: l.jsxs("span", {
                      children: ["Published Master Deals (", f.length, ")"],
                    }),
                  }),
                  f.length > 0 &&
                    l.jsx("button", {
                      type: "button",
                      onClick: ba,
                      className:
                        "px-2.5 py-1 bg-slate-800 hover:bg-slate-700 text-purple-300 font-extrabold text-xs rounded-lg transition-colors cursor-pointer border border-purple-500/30 flex items-center gap-1",
                      children: l.jsx("span", {
                        children: St ? "Deselect All" : "Select All",
                      }),
                    }),
                  b.length > 0 &&
                    l.jsxs("span", {
                      className:
                        "text-xs text-purple-300 font-bold bg-purple-950/80 border border-purple-500/40 px-2.5 py-1 rounded-lg",
                      children: [b.length, " Selected"],
                    }),
                ],
              }),
              b.length > 0 &&
                l.jsxs("button", {
                  onClick: Yt,
                  className:
                    "flex items-center gap-2 px-3.5 py-1.5 bg-rose-600 hover:bg-rose-500 text-white font-extrabold text-xs rounded-xl shadow-lg transition-all cursor-pointer animate-fadeIn",
                  children: [
                    l.jsx(qa, { size: 14 }),
                    l.jsxs("span", {
                      children: ["Delete Selected (", b.length, ")"],
                    }),
                  ],
                }),
            ],
          }),
          I
            ? l.jsx("div", {
                className: "py-12 text-center text-slate-400",
                children: "Loading master deals...",
              })
            : f.length === 0
              ? l.jsx("div", {
                  className:
                    "py-12 text-center text-slate-500 text-xs font-bold",
                  children:
                    "No deal posts found. Upload a ZIP or create deals manually above.",
                })
              : l.jsx("div", {
                  className: "overflow-x-auto",
                  children: l.jsxs("table", {
                    className:
                      "w-full text-left border-collapse text-xs text-slate-300",
                    children: [
                      l.jsx("thead", {
                        children: l.jsxs("tr", {
                          className:
                            "border-b border-slate-800 text-slate-400 uppercase text-[10px] tracking-wider bg-slate-900/60",
                          children: [
                            l.jsx("th", {
                              className: "py-3 px-3 w-10 text-center",
                              children: l.jsx("input", {
                                type: "checkbox",
                                checked: St,
                                onChange: ba,
                                title: "Select All",
                                className:
                                  "w-4 h-4 rounded border-slate-700 bg-slate-900 text-purple-600 focus:ring-purple-500 cursor-pointer",
                              }),
                            }),
                            l.jsx("th", {
                              className: "py-3 px-3",
                              children: "Image",
                            }),
                            l.jsx("th", {
                              className: "py-3 px-3",
                              children: "Folder / Source",
                            }),
                            l.jsx("th", {
                              className: "py-3 px-3",
                              children: "Description",
                            }),
                            l.jsx("th", {
                              className: "py-3 px-3",
                              children: "Comment Link",
                            }),
                            l.jsx("th", {
                              className: "py-3 px-3",
                              children: "Store",
                            }),
                            l.jsx("th", {
                              className: "py-3 px-3 text-center",
                              children: "Copies",
                            }),
                            l.jsx("th", {
                              className: "py-3 px-3 text-right",
                              children: "Actions",
                            }),
                          ],
                        }),
                      }),
                      l.jsx("tbody", {
                        className: "divide-y divide-slate-800/60",
                        children: f.map((Y) => {
                          const re = b.includes(Y.id);
                          return l.jsxs(
                            "tr",
                            {
                              className: `transition-colors ${re ? "bg-purple-950/30" : "hover:bg-slate-900/40"}`,
                              children: [
                                l.jsx("td", {
                                  className: "py-3 px-3 text-center",
                                  children: l.jsx("input", {
                                    type: "checkbox",
                                    checked: re,
                                    onChange: () => Vt(Y.id),
                                    className:
                                      "w-4 h-4 rounded border-slate-700 bg-slate-900 text-purple-600 focus:ring-purple-500 cursor-pointer",
                                  }),
                                }),
                                l.jsx("td", {
                                  className: "py-3 px-3",
                                  children: l.jsx("div", {
                                    className:
                                      "w-12 h-12 rounded-lg bg-black overflow-hidden border border-slate-700 shrink-0",
                                    children: l.jsx("img", {
                                      src: Y.image_path,
                                      alt: "Thumbnail",
                                      className: "w-full h-full object-cover",
                                      onError: (ve) => {
                                        (V((Te) =>
                                          Te.filter((_e) => _e.id !== Y.id),
                                        ),
                                          fetch(`/api/admin/deals/${Y.id}`, {
                                            method: "DELETE",
                                          }).catch(() => {}));
                                      },
                                    }),
                                  }),
                                }),
                                l.jsxs("td", {
                                  className: "py-3 px-3",
                                  children: [
                                    l.jsx("span", {
                                      className:
                                        "font-mono text-[11px] font-bold text-white block max-w-[140px] truncate",
                                      children: Y.folder_name,
                                    }),
                                    l.jsx("span", {
                                      className:
                                        "text-[10px] text-purple-400 uppercase font-black",
                                      children: Y.source,
                                    }),
                                  ],
                                }),
                                l.jsx("td", {
                                  className: "py-3 px-3 max-w-[260px]",
                                  children: l.jsx("p", {
                                    className:
                                      "line-clamp-2 text-slate-200 text-[11px]",
                                    children: Y.description,
                                  }),
                                }),
                                l.jsx("td", {
                                  className: "py-3 px-3 max-w-[200px]",
                                  children: l.jsx("span", {
                                    className:
                                      "font-mono text-[11px] text-blue-400 truncate block",
                                    children: Y.comment_link || "-",
                                  }),
                                }),
                                l.jsx("td", {
                                  className: "py-3 px-3",
                                  children: l.jsx("span", {
                                    className:
                                      "px-2 py-0.5 rounded text-[10px] font-black uppercase tracking-wider bg-slate-800 text-slate-200",
                                    children: Y.store,
                                  }),
                                }),
                                l.jsx("td", {
                                  className: "py-3 px-3 text-center",
                                  children: l.jsx("span", {
                                    className:
                                      "font-mono font-bold text-purple-300",
                                    children: Y.copy_count || 0,
                                  }),
                                }),
                                l.jsx("td", {
                                  className: "py-3 px-3 text-right",
                                  children: l.jsxs("div", {
                                    className:
                                      "flex items-center justify-end gap-1",
                                    children: [
                                      l.jsx("button", {
                                        onClick: () => Ct(Y),
                                        title: "Edit Master Deal",
                                        className:
                                          "p-1.5 rounded-lg bg-slate-800 hover:bg-purple-900/60 text-slate-300 hover:text-white transition-colors",
                                        children: l.jsx(ci, { size: 14 }),
                                      }),
                                      l.jsx("button", {
                                        onClick: () => Xt(Y.id),
                                        title: "Delete Master Deal",
                                        className:
                                          "p-1.5 rounded-lg bg-slate-800 hover:bg-rose-950 text-rose-400 transition-colors",
                                        children: l.jsx(qa, { size: 14 }),
                                      }),
                                    ],
                                  }),
                                }),
                              ],
                            },
                            Y.id,
                          );
                        }),
                      }),
                    ],
                  }),
                }),
        ],
      }),
      oe &&
        l.jsx("div", {
          className:
            "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4",
          children: l.jsxs("div", {
            className:
              "bg-[#0b132b] border border-purple-500/40 rounded-2xl p-6 w-full max-w-xl space-y-4 shadow-2xl",
            children: [
              l.jsxs("div", {
                className:
                  "flex items-center justify-between border-b border-slate-800 pb-3",
                children: [
                  l.jsx("h3", {
                    className: "font-bold text-sm text-white",
                    children: "Edit Master Deal Post",
                  }),
                  l.jsx("button", {
                    onClick: () => kt(null),
                    className: "text-slate-400 hover:text-white",
                    children: l.jsx(hs, { size: 16 }),
                  }),
                ],
              }),
              l.jsxs("div", {
                className: "space-y-3",
                children: [
                  l.jsxs("div", {
                    children: [
                      l.jsx("label", {
                        className:
                          "text-xs font-bold text-slate-300 block mb-1",
                        children: "Description",
                      }),
                      l.jsx("textarea", {
                        value: Oe,
                        onChange: (Y) => Pe(Y.target.value),
                        rows: 4,
                        className:
                          "w-full bg-slate-900 text-white border border-slate-700 rounded-xl p-3 text-xs focus:outline-none font-sans",
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    children: [
                      l.jsx("label", {
                        className:
                          "text-xs font-bold text-slate-300 block mb-1",
                        children: "Comment Link (URL)",
                      }),
                      l.jsx("input", {
                        type: "text",
                        value: nt,
                        onChange: (Y) => Re(Y.target.value),
                        className:
                          "w-full bg-slate-900 text-white border border-slate-700 rounded-xl px-3 py-2 text-xs focus:outline-none font-mono",
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    children: [
                      l.jsx("label", {
                        className:
                          "text-xs font-bold text-slate-300 block mb-1",
                        children: "Replace Image (Optional)",
                      }),
                      l.jsx("input", {
                        type: "file",
                        accept: "image/*",
                        onChange: (Y) => {
                          const re = Y.target.files?.[0];
                          if (re) {
                            D(re);
                            const ve = new FileReader();
                            ((ve.onload = (Te) => y(Te.target?.result)),
                              ve.readAsDataURL(re));
                          }
                        },
                        className: "text-xs text-slate-400",
                      }),
                    ],
                  }),
                ],
              }),
              l.jsxs("div", {
                className:
                  "flex justify-end gap-2 pt-3 border-t border-slate-800",
                children: [
                  l.jsx("button", {
                    onClick: () => kt(null),
                    className:
                      "px-4 py-2 bg-slate-800 text-slate-300 text-xs font-bold rounded-xl",
                    children: "Cancel",
                  }),
                  l.jsx("button", {
                    onClick: Ht,
                    disabled: X,
                    className:
                      "px-5 py-2 bg-purple-600 text-white text-xs font-extrabold rounded-xl",
                    children: X ? "Saving..." : "Save Changes",
                  }),
                ],
              }),
            ],
          }),
        }),
    ],
  });
}
function om({
  settings: f,
  onGoHome: V,
  onLogout: b,
  onSaveSettings: h,
  onResetSettings: I,
}) {
  const [j, se] = x.useState(!1),
    [J, ee] = x.useState({}),
    [W, Ae] = x.useState({}),
    [R, de] = x.useState(!0),
    [Ge, $] = x.useState(!1),
    [te, Ve] = x.useState(""),
    [st, ot] = x.useState(""),
    [ue, Me] = x.useState("lastSeenDesc"),
    [ke, Ze] = x.useState("all"),
    [it, $e] = x.useState("grid"),
    [Nt, oe] = x.useState("newest"),
    [kt, Oe] = x.useState({}),
    [Pe, nt] = x.useState(() => {
      try {
        const d = localStorage.getItem("sh_grid_cols"),
          S = d ? parseInt(d, 10) : 3;
        return [2, 3, 4, 5, 6].includes(S) ? S : 3;
      } catch {
        return 3;
      }
    }),
    [Re, C] = x.useState("grouped"),
    [D, U] = x.useState("active"),
    [y, X] = x.useState("all"),
    O = [
      { id: "all", label: "All", test: () => !0 },
      { id: "lt5", label: "Less than 5", test: (d) => d < 5 },
      { id: "lt15", label: "Less than 15", test: (d) => d < 15 },
      { id: "gt20", label: "Over 20", test: (d) => d > 20 },
      { id: "gt50", label: "Over 50", test: (d) => d > 50 },
      { id: "gt100", label: "Over 100", test: (d) => d > 100 },
      { id: "gt200", label: "Over 200", test: (d) => d > 200 },
      { id: "gt400", label: "Over 400", test: (d) => d > 400 },
    ],
    [H, G] = x.useState("all"),
    F = (O.find((d) => d.id === H) || O[0]).test,
    [le, ie] = x.useState({}),
    [pe, Ie] = x.useState(!1),
    [Ct, Ht] = x.useState(!1),
    Xt = (d) => D === "archive" && !!(d.atomEdited || le[d.code]),
    [St, ba] = x.useState(null),
    [Vt, Yt] = x.useState(!1),
    [Y, re] = x.useState(!1),
    [ve, Te] = x.useState(null),
    _e = (d, S, p) => {
      if (!d) return "other";
      try {
        const M = new URL(d).hostname.toLowerCase();
        if (
          M.includes("amazon.") ||
          M === "amzn.to" ||
          M === "a.co" ||
          M.endsWith(".amazon.com")
        )
          return "amazon";
        if (
          M.includes("walmart.") ||
          M.includes("mavely") ||
          M.includes("mavlink.to")
        )
          return "walmart";
        if (M.includes("ebay.") || M === "ebay.to" || M.endsWith(".ebay.com"))
          return "ebay";
        if (M.includes("etsy.")) return "etsy";
      } catch {
        const M = d.toLowerCase();
        if (
          M.includes("amazon.") ||
          M.includes("amzn.to") ||
          M.includes("a.co")
        )
          return "amazon";
        if (
          M.includes("walmart.") ||
          M.includes("mavely") ||
          M.includes("mavlink.to")
        )
          return "walmart";
        if (M.includes("ebay.") || M.includes("ebay.to")) return "ebay";
        if (M.includes("etsy.")) return "etsy";
      }
      const Q = (S || "").toLowerCase(),
        E = (p || "").toLowerCase();
      return Q.includes("walmart") || E.includes("walmart")
        ? "walmart"
        : Q.includes("amazon") || E.includes("amazon")
          ? "amazon"
          : Q.includes("ebay") || E.includes("ebay")
            ? "ebay"
            : Q.includes("etsy") || E.includes("etsy")
              ? "etsy"
              : "other";
    },
    ht = (d, S, p, Q) => {
      const E = d || _e(S || "", p, Q);
      return E === "amazon"
        ? l.jsxs("span", {
            className:
              "inline-flex items-center gap-1 bg-amber-500/10 border border-amber-500/30 text-amber-500 text-[10px] font-extrabold px-2 py-0.5 rounded-lg uppercase tracking-wider select-none shrink-0",
            children: [
              l.jsx("span", {
                className: "w-1.5 h-1.5 rounded-full bg-amber-500",
              }),
              "Amazon",
            ],
          })
        : E === "walmart"
          ? l.jsxs("span", {
              className:
                "inline-flex items-center gap-1 bg-sky-500/10 border border-sky-500/30 text-sky-400 text-[10px] font-extrabold px-2 py-0.5 rounded-lg uppercase tracking-wider select-none shrink-0",
              children: [
                l.jsx("span", {
                  className: "w-1.5 h-1.5 rounded-full bg-sky-400",
                }),
                "Walmart",
              ],
            })
          : E === "ebay"
            ? l.jsxs("span", {
                className:
                  "inline-flex items-center gap-1 bg-yellow-500/10 border border-yellow-500/30 text-yellow-500 text-[10px] font-extrabold px-2 py-0.5 rounded-lg uppercase tracking-wider select-none shrink-0",
                children: [
                  l.jsx("span", {
                    className: "w-1.5 h-1.5 rounded-full bg-yellow-500",
                  }),
                  "eBay",
                ],
              })
            : E === "etsy"
              ? l.jsxs("span", {
                  className:
                    "inline-flex items-center gap-1 bg-orange-600/10 border border-orange-600/30 text-orange-500 text-[10px] font-extrabold px-2 py-0.5 rounded-lg uppercase tracking-wider select-none shrink-0",
                  children: [
                    l.jsx("span", {
                      className: "w-1.5 h-1.5 rounded-full bg-orange-500",
                    }),
                    "Etsy",
                  ],
                })
              : l.jsxs("span", {
                  className:
                    "inline-flex items-center gap-1 bg-slate-800 border border-slate-700/60 text-slate-400 text-[10px] font-extrabold px-2 py-0.5 rounded-lg uppercase tracking-wider select-none shrink-0",
                  children: [
                    l.jsx("span", {
                      className: "w-1.5 h-1.5 rounded-full bg-slate-500",
                    }),
                    "Other",
                  ],
                });
    },
    [ye, dl] = x.useState(
      () => localStorage.getItem("sh_hide_reviewed") === "true",
    ),
    [we, Fa] = x.useState(() => {
      try {
        const d = localStorage.getItem("sh_reviewed_links");
        return d ? JSON.parse(d) : {};
      } catch {
        return {};
      }
    }),
    [Qe, da] = x.useState(() => {
      try {
        const d = localStorage.getItem("sh_ip_countries");
        return d ? JSON.parse(d) : {};
      } catch {
        return {};
      }
    }),
    Aa = x.useRef(new Set()),
    Va = (
      d,
      S,
      p = "w-[18px] h-[12px] object-cover shadow-sm border border-slate-800/40 rounded-sm inline-block select-none align-middle",
    ) => {
      if (!d || d === "Unknown" || d.length !== 2)
        return l.jsx("span", {
          className: "text-[10px] select-none",
          children: "🏳️",
        });
      const Q = d.toLowerCase();
      return l.jsx("img", {
        src: `https://flagcdn.com/w40/${Q}.png`,
        alt: S || d,
        title: S || d,
        className: p,
        referrerPolicy: "no-referrer",
        onError: (E) => {
          E.currentTarget.style.display = "none";
        },
      });
    };
  (x.useEffect(() => {
    localStorage.setItem("sh_grid_cols", String(Pe));
  }, [Pe]),
    x.useEffect(() => {
      localStorage.setItem("sh_hide_reviewed", ye ? "true" : "false");
    }, [ye]),
    x.useEffect(() => {
      localStorage.setItem("sh_reviewed_links", JSON.stringify(we));
    }, [we]),
    x.useEffect(() => {
      if (R) return;
      const d = new Set();
      (Object.values(W).forEach((S) => {
        S.ip && S.ip !== "Unknown" && S.ip !== "" && d.add(S.ip);
      }),
        Object.values(J).forEach((S) => {
          const p = S.creatorIp || S.ip;
          p && p !== "Unknown" && p !== "" && d.add(p);
        }),
        d.forEach(async (S) => {
          if (!(Qe[S] || Aa.current.has(S))) {
            Aa.current.add(S);
            try {
              const p = await fetch(
                `/api/ip-lookup?ip=${encodeURIComponent(S)}`,
              );
              if (p.ok) {
                const Q = await p.json();
                Q &&
                  Q.countryCode &&
                  da((E) => {
                    const Z = {
                      ...E,
                      [S]: {
                        countryCode: Q.countryCode,
                        countryName: Q.country || "Unknown",
                      },
                    };
                    return (
                      localStorage.setItem(
                        "sh_ip_countries",
                        JSON.stringify(Z),
                      ),
                      Z
                    );
                  });
              }
            } catch (p) {
              console.error(`[IP Lookup] Error looking up ${S}:`, p);
            } finally {
              Aa.current.delete(S);
            }
          }
        }));
    }, [J, W, R, Qe]));
  const bs = (d) => {
      switch (d) {
        case 2:
          return "grid grid-cols-1 sm:grid-cols-2 gap-4";
        case 3:
          return "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4";
        case 4:
          return "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4";
        case 5:
          return "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4";
        case 6:
          return "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4";
        default:
          return "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4";
      }
    },
    [$a, gs] = x.useState(null),
    [ul, $t] = x.useState(""),
    [bt, zt] = x.useState(""),
    [vs, Qa] = x.useState(""),
    [Il, Ka] = x.useState(""),
    [Wt, Za] = x.useState(!1),
    [ga, Ja] = x.useState(!1),
    [Wa, Pa] = x.useState(""),
    [xl, fl] = x.useState(""),
    [pl, ql] = x.useState("other"),
    [Vs, ml] = x.useState(!1),
    [hl, Ke] = x.useState(""),
    [Fl, xt] = x.useState(""),
    [ys, Lt] = x.useState(null),
    [ft, Bt] = x.useState(!1),
    [Pt, bl] = x.useState({}),
    [el, bn] = x.useState(!1),
    [gn, gl] = x.useState(!1),
    [qe, ea] = x.useState(null),
    [Vl, ua] = x.useState(!1),
    Et = async () => {
      const d = f?.FIREBASE_API_KEY;
      if (!d) return null;
      const S = localStorage.getItem("sh_firebase_id_token"),
        p = localStorage.getItem("sh_firebase_id_token_expires_at");
      if (S && p && parseInt(p, 10) > Date.now() + 300 * 1e3) return S;
      try {
        const Q = await fetch(
          `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${d}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ returnSecureToken: !0 }),
          },
        );
        if (Q.ok) {
          const E = await Q.json(),
            Z = E.idToken,
            M = parseInt(E.expiresIn || "3600", 10),
            K = Date.now() + M * 1e3;
          return (
            localStorage.setItem("sh_firebase_id_token", Z),
            localStorage.setItem(
              "sh_firebase_id_token_expires_at",
              K.toString(),
            ),
            Z
          );
        } else {
          const E = await Q.json();
          console.error("[Firebase Auth] Authentication failed:", E);
        }
      } catch (Q) {
        console.error(
          "[Firebase Auth] Network error during authentication:",
          Q,
        );
      }
      return null;
    },
    et = async (d = !1) => {
      d ? $(!0) : (de(!0), Ve(""));
      try {
        const S = localStorage.getItem("sh_admin_token") || "",
          p = await Et(),
          Q = { Authorization: `Bearer ${S}` };
        p && (Q["X-Firebase-Id-Token"] = p);
        const E = await fetch("/api/admin/dashboard-data", { headers: Q });
        if (!E.ok)
          throw E.status === 401
            ? new Error("Unauthorized: Please log in again.")
            : new Error("Failed to fetch dashboard data.");
        const Z = await E.json();
        if (Z.success) (ee(Z.links || {}), Ae(Z.users || {}));
        else throw new Error(Z.error || "Failed to load database.");
      } catch (S) {
        (console.error(S),
          d || Ve(S.message || "An error occurred while loading data."));
      } finally {
        (de(!1), $(!1));
      }
    },
    tl = async () => {
      (re(!0), Te(null));
      try {
        const d = localStorage.getItem("sh_admin_token") || "",
          S = await Et(),
          p = {
            Authorization: `Bearer ${d}`,
            "Content-Type": "application/json",
          };
        S && (p["X-Firebase-Id-Token"] = S);
        const Q = await fetch("/api/admin/maintenance", {
            method: "POST",
            headers: p,
          }),
          E = await Q.json();
        if (!Q.ok) throw new Error(E.error || "Maintenance execution failed");
        if (E.success)
          (Te({
            text: `Successfully processed database! Deleted ${E.deletedCount} links & cleaned up visitor click logs.`,
            type: "success",
          }),
            et(!0));
        else throw new Error(E.error || "Execution failed");
      } catch (d) {
        (console.error(d),
          Te({
            text: `Error: ${d.message || "Could not complete maintenance"}`,
            type: "error",
          }));
      } finally {
        re(!1);
      }
    };
  x.useEffect(() => {
    et();
    const d = setInterval(() => {
      et(!0);
    }, 5e3);
    return () => clearInterval(d);
  }, []);
  const vl = (d) => {
      if (!d) return "Never";
      try {
        const S = new Date(d);
        if (isNaN(S.getTime())) return "Invalid Date";
        const p = String(S.getDate()).padStart(2, "0"),
          Q = String(S.getMonth() + 1).padStart(2, "0"),
          E = S.getFullYear();
        let Z = S.getHours();
        const M = String(S.getMinutes()).padStart(2, "0"),
          K = Z >= 12 ? "PM" : "AM";
        ((Z = Z % 12), (Z = Z || 12));
        const ne = String(Z).padStart(2, "0");
        return `${p}/${Q}/${E} ${ne}:${M} ${K}`;
      } catch {
        return "Invalid Date";
      }
    },
    It = (d) => {
      if (!d) return null;
      const p = (Date.now() - d) / (1e3 * 60 * 60);
      return p < 1
        ? l.jsxs("span", {
            className:
              "inline-flex items-center gap-1 bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[9px] font-bold px-1.5 py-0.5 rounded-md select-none shrink-0",
            children: [
              l.jsx("span", {
                className: "w-1 h-1 rounded-full bg-emerald-400 animate-pulse",
              }),
              "<1h Old",
            ],
          })
        : p < 24
          ? l.jsxs("span", {
              className:
                "inline-flex items-center gap-1 bg-blue-500/10 border border-blue-500/20 text-blue-400 text-[9px] font-bold px-1.5 py-0.5 rounded-md select-none shrink-0",
              children: [
                l.jsx("span", {
                  className: "w-1 h-1 rounded-full bg-blue-400",
                }),
                "<24h Old",
              ],
            })
          : l.jsxs("span", {
              className:
                "inline-flex items-center gap-1 bg-slate-800 border border-slate-700/60 text-slate-400 text-[9px] font-bold px-1.5 py-0.5 rounded-md select-none shrink-0",
              children: [
                l.jsx("span", {
                  className: "w-1 h-1 rounded-full bg-slate-500",
                }),
                "Older",
              ],
            });
    },
    xa = () => {
      const d = {},
        S = Date.now();
      let p = 0;
      (ke === "1h"
        ? (p = 3600 * 1e3)
        : ke === "5h"
          ? (p = 300 * 60 * 1e3)
          : ke === "12h"
            ? (p = 720 * 60 * 1e3)
            : ke === "24h"
              ? (p = 1440 * 60 * 1e3)
              : ke === "48h"
                ? (p = 2880 * 60 * 1e3)
                : ke === "72h" && (p = 4320 * 60 * 1e3),
        Object.entries(J).forEach(([M, K]) => {
          const ne = K.creatorId || "anonymous";
          if (
            (p > 0 && (!K.created || S - K.created > p)) ||
            !F(Number(K.clicks ?? K.clickCount) || 0) ||
            (pe && (K.atomEdited || le[M])) ||
            (ye && we[M])
          )
            return;
          const ce = !!K.trashed,
            he = !!K.done;
          if (D === "trash") {
            if (!ce) return;
          } else if (D === "archive") {
            if (ce || !he) return;
          } else if (ce || he) return;
          if (D === "active" && y !== "all") {
            let pt = K.store;
            if (
              ((!pt || pt === "other") &&
                (pt = _e(K.resolvedUrl || K.url, K.title, K.description)),
              pt !== y)
            )
              return;
          }
          (d[ne] || (d[ne] = []), d[ne].push({ ...K, code: M }));
        }));
      const Q = [],
        E = new Set();
      (Object.entries(W).forEach(([M, K]) => {
        E.add(M);
        const ne = d[M] || [];
        if (
          (D === "archive" ||
            D === "trash" ||
            ke !== "all" ||
            ye ||
            y !== "all") &&
          ne.length === 0
        )
          return;
        const ce = Object.keys(K.links || {}),
          he = new Map();
        (ne.forEach((Ee) => he.set(Ee.code, Ee)),
          D === "active" &&
            ke === "all" &&
            !ye &&
            y === "all" &&
            ce.forEach((Ee) => {
              !J[Ee] &&
                !he.has(Ee) &&
                he.set(Ee, {
                  code: Ee,
                  url: "Unknown/Missing",
                  title: "Deleted or Missing link",
                  description: "",
                  image: "",
                });
            }));
        const pt = Array.from(he.values()),
          pa = [...pt].sort((Ee, He) =>
            ue === "clicksDesc"
              ? (He.clicks || 0) - (Ee.clicks || 0)
              : (He.created || 0) - (Ee.created || 0),
          ),
          Tt = pa[0]?.created || K.lastSeen || 0,
          wa = [...pa].reverse()[0]?.created || K.firstSeen || 0;
        Q.push({
          creatorId: M,
          label: K.label || `USER ${Q.length + 1}`,
          firstSeen: wa,
          lastSeen: Tt,
          linkCount: K.linkCount !== void 0 ? K.linkCount : pt.length,
          ip: K.ip || "Unknown",
          links: pa,
        });
      }),
        Object.entries(d).forEach(([M, K]) => {
          if (E.has(M)) return;
          const ne = [...K].sort((pt, pa) =>
              ue === "clicksDesc"
                ? (pa.clicks || 0) - (pt.clicks || 0)
                : (pa.created || 0) - (pt.created || 0),
            ),
            ce = ne.find((pt) => pt.ip)?.ip || "Unknown";
          let he = "";
          (M === "anonymous"
            ? (he =
                ce && ce !== "Unknown"
                  ? `Anonymous Guest (${ce})`
                  : "Anonymous Guest")
            : (he =
                ce && ce !== "Unknown"
                  ? `Guest (${ce})`
                  : `Guest (${M.substring(0, 8)})`),
            Q.push({
              creatorId: M,
              label: he,
              firstSeen: ne[ne.length - 1]?.created || 0,
              lastSeen: ne[0]?.created || 0,
              linkCount: K.length,
              ip: ce,
              links: ne,
            }));
        }));
      let Z = Q;
      if (st.trim()) {
        const M = st.toLowerCase().trim();
        Z = Q.map((K) => {
          if (
            K.label.toLowerCase().includes(M) ||
            K.creatorId.toLowerCase().includes(M) ||
            K.ip.toLowerCase().includes(M)
          )
            return K;
          const ce = K.links.filter(
            (he) =>
              he.code.toLowerCase().includes(M) ||
              (he.title || "").toLowerCase().includes(M) ||
              he.url.toLowerCase().includes(M) ||
              (he.description || "").toLowerCase().includes(M) ||
              (he.creatorIp || "").toLowerCase().includes(M),
          );
          return ce.length > 0 ? { ...K, links: ce } : null;
        }).filter(Boolean);
      }
      return (
        Z.sort((M, K) => {
          if (ue === "clicksDesc") {
            const ne = (ce) =>
              ce.links.reduce((he, pt) => he + (pt.clicks || 0), 0);
            return ne(K) - ne(M);
          }
          return ue === "lastSeenDesc"
            ? (K.lastSeen || 0) - (M.lastSeen || 0)
            : ue === "firstSeenDesc"
              ? (K.firstSeen || 0) - (M.firstSeen || 0)
              : ue === "firstSeenAsc"
                ? (M.firstSeen || 0) - (K.firstSeen || 0)
                : ue === "linksDesc"
                  ? (K.linkCount || 0) - (M.linkCount || 0)
                  : ue === "label"
                    ? M.label.localeCompare(K.label, void 0, {
                        numeric: !0,
                        sensitivity: "base",
                      })
                    : 0;
        }),
        Z
      );
    },
    vn = () => {
      const d = [],
        S = Date.now();
      let p = 0;
      return (
        ke === "1h"
          ? (p = 3600 * 1e3)
          : ke === "5h"
            ? (p = 300 * 60 * 1e3)
            : ke === "12h"
              ? (p = 720 * 60 * 1e3)
              : ke === "24h"
                ? (p = 1440 * 60 * 1e3)
                : ke === "48h"
                  ? (p = 2880 * 60 * 1e3)
                  : ke === "72h" && (p = 4320 * 60 * 1e3),
        Object.entries(J).forEach(([Q, E]) => {
          if (
            (p > 0 && (!E.created || S - E.created > p)) ||
            !F(Number(E.clicks ?? E.clickCount) || 0) ||
            (pe && (E.atomEdited || le[Q])) ||
            (ye && we[Q])
          )
            return;
          const Z = !!E.trashed,
            M = !!E.done;
          if (D === "trash") {
            if (!Z) return;
          } else if (D === "archive") {
            if (Z || !M) return;
          } else if (Z || M) return;
          if (D === "active" && y !== "all") {
            let ce = E.store;
            if (
              ((!ce || ce === "other") &&
                (ce = _e(E.resolvedUrl || E.url, E.title, E.description)),
              ce !== y)
            )
              return;
          }
          if (st.trim()) {
            const ce = st.toLowerCase().trim();
            if (!(
              Q.toLowerCase().includes(ce) ||
              E.url.toLowerCase().includes(ce) ||
              (E.title || "").toLowerCase().includes(ce) ||
              (E.description || "").toLowerCase().includes(ce) ||
              (E.creatorId || "").toLowerCase().includes(ce) ||
              (E.ip || "").toLowerCase().includes(ce) ||
              (E.creatorIp || "").toLowerCase().includes(ce)
            ))
              return;
          }
          let K = "Guest User";
          const ne = E.creatorId || "anonymous";
          (W[ne]
            ? (K = W[ne].label || `User ${ne.substring(0, 8)}`)
            : E.ip && (K = `Guest (${E.ip})`),
            d.push({ ...E, code: Q, groupLabel: K }));
        }),
        d.sort((Q, E) =>
          Nt === "clicksDesc"
            ? (E.clicks || 0) - (Q.clicks || 0)
            : Nt === "oldest"
              ? (Q.created || 0) - (E.created || 0)
              : (E.created || 0) - (Q.created || 0),
        )
      );
    },
    At = xa(),
    yl = vn(),
    Bl = (() => {
      const d = { all: 0, amazon: 0, walmart: 0, ebay: 0, etsy: 0, other: 0 },
        S = Date.now();
      let p = 0;
      return (
        ke === "1h"
          ? (p = 3600 * 1e3)
          : ke === "5h"
            ? (p = 300 * 60 * 1e3)
            : ke === "12h"
              ? (p = 720 * 60 * 1e3)
              : ke === "24h"
                ? (p = 1440 * 60 * 1e3)
                : ke === "48h"
                  ? (p = 2880 * 60 * 1e3)
                  : ke === "72h" && (p = 4320 * 60 * 1e3),
        Object.entries(J).forEach(([Q, E]) => {
          if (
            E.trashed ||
            E.done ||
            (p > 0 && (!E.created || S - E.created > p)) ||
            (ye && we[Q])
          )
            return;
          if (st.trim()) {
            const M = st.toLowerCase().trim();
            if (!(
              Q.toLowerCase().includes(M) ||
              E.url.toLowerCase().includes(M) ||
              (E.title || "").toLowerCase().includes(M) ||
              (E.description || "").toLowerCase().includes(M) ||
              (E.creatorId || "").toLowerCase().includes(M) ||
              (E.ip || "").toLowerCase().includes(M) ||
              (E.creatorIp || "").toLowerCase().includes(M)
            ))
              return;
          }
          let Z = E.store;
          ((!Z || Z === "other") &&
            (Z = _e(E.resolvedUrl || E.url, E.title, E.description)),
            d.all++,
            Z === "amazon"
              ? d.amazon++
              : Z === "walmart"
                ? d.walmart++
                : Z === "ebay"
                  ? d.ebay++
                  : Z === "etsy"
                    ? d.etsy++
                    : d.other++);
        }),
        d
      );
    })(),
    Qt = Object.values(J),
    $l = Qt.filter((d) => !d.done && !d.trashed).length,
    fa = Qt.filter((d) => !!d.done && !d.trashed).length,
    je = Qt.filter((d) => !!d.trashed).length;
  Qt.length;
  const ws = Qt.filter(
      (d) =>
        !d.done &&
        !d.trashed &&
        d.created &&
        d.created > Date.now() - 1440 * 60 * 1e3,
    ).length,
    gt = Qt.filter(
      (d) =>
        !d.done &&
        !d.trashed &&
        d.created &&
        d.created > Date.now() - 720 * 60 * 1e3,
    ).length,
    js = Qt.filter((d) => !d.done && !d.trashed),
    va = new Set(js.map((d) => d.creatorId || "anonymous")).size,
    wl = (() => {
      const d = new Set();
      return (
        Object.values(W).forEach((S) => {
          S.ip && S.ip !== "Unknown" && S.ip !== "" && d.add(S.ip);
        }),
        Qt.forEach((S) => {
          const p = S.creatorIp || S.ip;
          p && p !== "Unknown" && p !== "" && d.add(p);
        }),
        d.size
      );
    })(),
    Ta = Qt.filter(
      (d) => !d.done && !d.trashed && (!d.image || d.image.trim() === ""),
    ).length,
    qt = Qt.filter((d) => !d.trashed).reduce((d, S) => d + (S.clicks || 0), 0),
    ta = (d) => {
      Oe((S) => ({ ...S, [d]: !S[d] }));
    },
    yn = () => {
      const d = {};
      (At.forEach((S) => {
        d[S.creatorId] = !0;
      }),
        Oe(d));
    },
    jl = () => {
      Oe({});
    },
    aa = Object.values(Pt).filter(Boolean).length,
    ya = (d) => {
      bl((S) => ({ ...S, [d]: !S[d] }));
    },
    Ql = (d) => {
      Fa((S) => ({ ...S, [d]: !S[d] }));
    },
    Nl = () => {
      const d = { ...Pt };
      (Re === "flat"
        ? yl.forEach((S) => {
            d[S.code] = !0;
          })
        : At.forEach((S) => {
            S.links.forEach((p) => {
              d[p.code] = !0;
            });
          }),
        bl(d));
    },
    Ol = () => {
      bl({});
    },
    $s = async () => {
      const d = Object.entries(Pt)
        .filter(([, S]) => S)
        .map(([S]) => S);
      if (d.length !== 0) {
        Ht(!0);
        try {
          const S = localStorage.getItem("sh_admin_token") || "",
            p = await Et(),
            Q = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${S}`,
            };
          (p && (Q["X-Firebase-Id-Token"] = p),
            await Promise.all(
              d.map((E) => {
                const Z = J[E];
                return !Z || !Z.url
                  ? Promise.resolve()
                  : fetch(`/api/admin/links/${E}`, {
                      method: "PATCH",
                      headers: Q,
                      body: JSON.stringify({
                        title: Z.title || "",
                        url: Z.url,
                        image: Z.image || "",
                        description: Z.description || "",
                        preview: !!Z.preview,
                        done: !1,
                        trashed: !0,
                      }),
                    }).catch(() => {});
              }),
            ),
            ee((E) => {
              const Z = { ...E };
              return (
                d.forEach((M) => {
                  Z[M] && (Z[M] = { ...Z[M], trashed: !0, done: !1 });
                }),
                Z
              );
            }),
            bl({}));
        } catch (S) {
          alert(S?.message || "Could not move links to trash.");
        } finally {
          Ht(!1);
        }
      }
    },
    wn = () => {
      const d = (K) =>
          String(K ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;"),
        S = (K, ne) => !!(ne.atomEdited || le[K]),
        p = Object.entries(J).filter(
          ([K, ne]) => ne.done && !ne.trashed && (!pe || !S(K, ne)),
        ),
        Q = new Date().toISOString();
      let E = `<?xml version="1.0" encoding="UTF-8"?>
`;
      ((E += `<feed xmlns="http://www.w3.org/2005/Atom">
`),
        (E += `  <title>Done Shortlinks / Archive Export</title>
`),
        (E += `  <updated>${Q}</updated>
`),
        (E += `  <id>urn:mavelylink:archive-export</id>
`),
        p.forEach(([K, ne]) => {
          ((E += `  <entry>
`),
            (E += `    <id>urn:mavelylink:link:${d(K)}</id>
`),
            (E += `    <title>${d(ne.title || ne.description || K)}</title>
`),
            (E += `    <link rel="alternate" href="${d(ne.resolvedUrl || ne.finalUrl || ne.url || "")}"/>
`),
            ne.image &&
              (E += `    <link rel="enclosure" type="image/jpeg" href="${d(ne.image)}"/>
`),
            (E += `    <summary>${d(ne.description || ne.title || "")}</summary>
`),
            (E += `    <category term="code" label="${d(K)}"/>
`),
            (E += `  </entry>
`));
        }),
        (E += `</feed>
`));
      const Z = new Blob([E], { type: "application/atom+xml" }),
        M = document.createElement("a");
      ((M.href = URL.createObjectURL(Z)),
        (M.download = pe
          ? "archive_clean_export.atom"
          : "archive_done_export.atom"),
        M.click(),
        setTimeout(() => URL.revokeObjectURL(M.href), 2e3));
    },
    Qs = async (d) => {
      const S = d.target.files?.[0];
      if (S)
        try {
          const p = await S.text(),
            Q = new DOMParser().parseFromString(p, "application/xml");
          if (Q.getElementsByTagName("parsererror").length > 0) {
            (alert(
              "This file could not be read as ATOM/XML. Please export a fresh ATOM and edit that.",
            ),
              (d.target.value = ""));
            return;
          }
          const E = Array.from(Q.getElementsByTagName("entry"));
          if (E.length === 0) {
            (alert("No <entry> items were found in this ATOM file."),
              (d.target.value = ""));
            return;
          }
          const Z = {},
            M = [];
          let K = 0,
            ne = 0;
          const ce = { ...J };
          (E.forEach((Ee) => {
            let He = "";
            const ia = Array.from(Ee.getElementsByTagName("category")).find(
              (El) => El.getAttribute("term") === "code",
            );
            if ((ia && (He = ia.getAttribute("label") || ""), !He)) {
              const Al = (
                Ee.getElementsByTagName("id")[0]?.textContent || ""
              ).match(/link:([A-Za-z0-9_-]+)/);
              Al && (He = Al[1]);
            }
            He || (He = "atom_" + Math.random().toString(36).slice(2, 9));
            const Cl = (
                Ee.getElementsByTagName("title")[0]?.textContent || ""
              ).trim(),
              La = (
                Ee.getElementsByTagName("summary")[0]?.textContent || ""
              ).trim();
            let Sl = "",
              Ba = "";
            Array.from(Ee.getElementsByTagName("link")).forEach((El) => {
              const Al = El.getAttribute("rel");
              ((Al === "alternate" || !Al) &&
                (Sl = El.getAttribute("href") || Sl),
                Al === "enclosure" && (Ba = El.getAttribute("href") || Ba));
            });
            const vt = ce[He],
              Oa = !vt,
              Zl =
                Oa ||
                (!!Cl && Cl !== (vt.title || "")) ||
                (!!La && La !== (vt.description || "")) ||
                (!!Sl && Sl !== (vt.resolvedUrl || vt.url || "")) ||
                (!!Ba && Ba !== (vt.image || "")),
              Ks = {
                ...(vt || {}),
                code: He,
                url: Sl || vt?.url || "",
                resolvedUrl: Sl || vt?.resolvedUrl || vt?.url || "",
                title: Cl || vt?.title || He,
                description: La || vt?.description || "",
                image: Ba || vt?.image || "",
                created: vt?.created || Date.now(),
                done: !0,
                trashed: !1,
                atomEdited: Zl ? !0 : vt?.atomEdited || !1,
              };
            ((ce[He] = Ks),
              Zl &&
                ((Z[He] = !0), M.push({ ...Ks, code: He }), Oa ? K++ : ne++));
          }),
            ee(ce),
            ie((Ee) => ({ ...Ee, ...Z })));
          const he = localStorage.getItem("sh_admin_token") || "",
            pt = await Et(),
            pa = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${he}`,
            };
          pt && (pa["X-Firebase-Id-Token"] = pt);
          let Tt = 0,
            wa = 0;
          (await Promise.all(
            M.map(async (Ee) => {
              if (!Ee.url || !/^https?:\/\//i.test(Ee.url)) {
                wa++;
                return;
              }
              try {
                (
                  await fetch(`/api/admin/links/${Ee.code}`, {
                    method: "PATCH",
                    headers: pa,
                    body: JSON.stringify({
                      title: Ee.title || "",
                      url: Ee.url,
                      image: Ee.image || "",
                      description: Ee.description || "",
                      preview: !!Ee.preview,
                      done: !0,
                      trashed: !1,
                      atomEdited: !0,
                    }),
                  })
                ).ok
                  ? Tt++
                  : wa++;
              } catch {
                wa++;
              }
            }),
          ),
            alert(
              `ATOM applied: ${K} added, ${ne} updated. Saved to server: ${Tt}` +
                (wa ? `, ${wa} could not be saved (missing/invalid URL)` : "") +
                ".",
            ));
        } catch {
          alert("Failed to read the ATOM file.");
        } finally {
          d.target.value = "";
        }
    },
    _a = async () => {
      const d = Object.entries(Pt)
        .filter(([S, p]) => p)
        .map(([S]) => S);
      if (d.length !== 0) {
        bn(!0);
        try {
          const S = localStorage.getItem("sh_admin_token") || "",
            p = await Et(),
            Q = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${S}`,
            };
          p && (Q["X-Firebase-Id-Token"] = p);
          const E = await fetch("/api/admin/links/bulk-delete", {
              method: "POST",
              headers: Q,
              body: JSON.stringify({ codes: d }),
            }),
            Z = await E.json();
          if (!E.ok) throw new Error(Z.error || "Failed to bulk delete links");
          const M = { ...J };
          (d.forEach((K) => {
            const ne = M[K];
            if (ne && ne.creatorId) {
              const ce = ne.creatorId;
              if (W[ce]) {
                const he = {
                  ...W[ce],
                  linkCount: Math.max(0, (W[ce].linkCount || 1) - 1),
                };
                (he.links && delete he.links[K], (W[ce] = he));
              }
            }
            delete M[K];
          }),
            ee(M),
            Ae({ ...W }),
            bl({}),
            gl(!1));
        } catch (S) {
          alert(S.message || "Could not delete links.");
        } finally {
          bn(!1);
        }
      }
    },
    Kl = async () => {
      if (St) {
        Yt(!0);
        try {
          const d = localStorage.getItem("sh_admin_token") || "",
            S = await Et(),
            p = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${d}`,
            };
          S && (p["X-Firebase-Id-Token"] = S);
          const Q = await fetch("/api/admin/users/delete", {
              method: "POST",
              headers: p,
              body: JSON.stringify({ creatorId: St.creatorId }),
            }),
            E = await Q.json();
          if (!Q.ok) throw new Error(E.error || "Failed to delete user");
          (et(), ba(null));
        } catch (d) {
          alert("Error deleting user: " + d.message);
        } finally {
          Yt(!1);
        }
      }
    },
    kl = (d) => {
      (gs(d),
        $t(d.title || ""),
        zt(d.url || ""),
        Qa(d.image || ""),
        Ka(d.description || ""),
        Za(!!d.preview),
        Ja(!!d.done),
        Pa(d.previewDescription || ""),
        fl(d.previewAccentColor || "#1668e3"),
        ql(d.store || "other"),
        xt(""),
        Ke(""));
    },
    Da = async (d) => {
      if ((d.preventDefault(), !!$a)) {
        if (!bt.trim() || !/^https?:\/\//i.test(bt)) {
          xt("Destination URL must start with http:// or https://");
          return;
        }
        (ml(!0), xt(""), Ke(""));
        try {
          const S = localStorage.getItem("sh_admin_token") || "",
            p = await Et(),
            Q = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${S}`,
            };
          p && (Q["X-Firebase-Id-Token"] = p);
          const E = await fetch(`/api/admin/links/${$a.code}`, {
              method: "PATCH",
              headers: Q,
              body: JSON.stringify({
                title: ul.trim(),
                url: bt.trim(),
                image: vs.trim(),
                description: Il.trim(),
                preview: Wt,
                done: ga,
                previewDescription: Wt ? Wa.trim() : null,
                previewAccentColor: Wt ? xl.trim() : null,
                store: pl,
              }),
            }),
            Z = await E.json();
          if (!E.ok) throw new Error(Z.error || "Failed to update link");
          (Ke("Link updated successfully!"),
            ee((M) => ({
              ...M,
              [$a.code]: {
                ...M[$a.code],
                title: ul.trim(),
                url: bt.trim(),
                resolvedUrl: bt.trim(),
                finalUrl: bt.trim(),
                image: vs.trim(),
                description: Il.trim(),
                preview: Wt,
                done: ga,
                previewDescription: Wt ? Wa.trim() : null,
                previewAccentColor: Wt ? xl.trim() : null,
                store: pl,
              },
            })),
            setTimeout(() => {
              gs(null);
            }, 1e3));
        } catch (S) {
          xt(S.message || "An error occurred while saving.");
        } finally {
          ml(!1);
        }
      }
    },
    Ul = async (d) => {
      Bt(!0);
      try {
        const S = localStorage.getItem("sh_admin_token") || "",
          p = await Et(),
          Q = { Authorization: `Bearer ${S}` };
        p && (Q["X-Firebase-Id-Token"] = p);
        const E = await fetch(`/api/admin/links/${d}`, {
            method: "DELETE",
            headers: Q,
          }),
          Z = await E.json();
        if (!E.ok) throw new Error(Z.error || "Failed to delete link");
        const M = { ...J },
          K = M[d];
        if ((delete M[d], ee(M), K && K.creatorId)) {
          const ne = K.creatorId;
          if (W[ne]) {
            const ce = {
              ...W[ne],
              linkCount: Math.max(0, (W[ne].linkCount || 1) - 1),
            };
            (ce.links && delete ce.links[d], Ae((he) => ({ ...he, [ne]: ce })));
          }
        }
        Lt(null);
      } catch (S) {
        alert(S.message || "Could not delete link.");
      } finally {
        Bt(!1);
      }
    },
    za = async (d, S) => {
      try {
        const p = localStorage.getItem("sh_admin_token") || "",
          Q = await Et(),
          E = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${p}`,
          };
        Q && (E["X-Firebase-Id-Token"] = Q);
        const Z = await fetch(`/api/admin/links/${d.code}`, {
            method: "PATCH",
            headers: E,
            body: JSON.stringify({
              title: d.title || "",
              url: d.url,
              image: d.image || "",
              description: d.description || "",
              preview: !!d.preview,
              done: !!d.done,
              trashed: S,
            }),
          }),
          M = await Z.json();
        if (!Z.ok) throw new Error(M.error || "Failed to update link");
        ee((K) => ({ ...K, [d.code]: { ...K[d.code], trashed: S } }));
      } catch (p) {
        alert(p.message || "An error occurred.");
      }
    };
  return l.jsxs("div", {
    className:
      "min-h-screen bg-[#070e1b] text-slate-100 antialiased p-4 sm:p-6 md:p-8 font-sans",
    children: [
      l.jsxs("header", {
        className:
          "max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8 pb-6 border-b border-slate-800",
        children: [
          l.jsxs("div", {
            className: "flex items-center gap-3",
            children: [
              l.jsx("div", {
                className:
                  "w-10 h-10 rounded-xl bg-gradient-to-tr from-blue-500 to-indigo-600 text-white flex items-center justify-center text-xl font-bold shadow-md",
                children: "📈",
              }),
              l.jsxs("div", {
                children: [
                  l.jsxs("h1", {
                    className:
                      "text-xl sm:text-2xl font-black tracking-tight text-white flex items-center gap-2",
                    children: [
                      "Link Ledger Dashboard",
                      l.jsx("span", {
                        className:
                          "bg-blue-500/10 border border-blue-500/20 text-blue-400 text-xs px-2.5 py-0.5 rounded-full",
                        children: "Admin",
                      }),
                    ],
                  }),
                  l.jsx("p", {
                    className: "text-xs text-slate-400 mt-0.5",
                    children:
                      "Secure in-site management of all shortlinks and user activity.",
                  }),
                ],
              }),
            ],
          }),
          l.jsxs("div", {
            className: "flex items-center gap-2 self-stretch md:self-auto",
            children: [
              l.jsxs("button", {
                onClick: () => se(!0),
                title:
                  "Configure Blogger shortener settings, templates, and autodelete rules",
                className:
                  "flex-1 md:flex-none px-4 py-2 rounded-xl bg-slate-900 border border-slate-850 hover:bg-slate-800 text-slate-200 text-xs font-extrabold flex items-center justify-center gap-1.5 transition-all cursor-pointer shadow-sm",
                children: [
                  l.jsx(zp, { className: "w-4 h-4 text-blue-400" }),
                  "⚙️ Settings",
                ],
              }),
              l.jsx("button", {
                onClick: tl,
                disabled: Y,
                title:
                  "Run Database Maintenance (Optimize and delete underperforming links)",
                className:
                  "flex-1 md:flex-none px-4 py-2 rounded-xl bg-indigo-950/60 border border-indigo-500/20 hover:bg-indigo-900/60 text-indigo-400 text-xs font-extrabold flex items-center justify-center gap-1.5 transition-all cursor-pointer disabled:opacity-55 shadow-sm",
                children: Y ? "⚡ Processing..." : "⚡ Run Maintenance",
              }),
              l.jsx("button", {
                onClick: () => et(),
                title: "Refresh database",
                className:
                  "p-2.5 rounded-xl bg-slate-900 border border-slate-800 hover:bg-slate-800 text-slate-300 transition-all cursor-pointer shadow-sm",
                children: l.jsx(Jx, {
                  className: `w-4 h-4 ${R || Ge ? "animate-spin" : ""}`,
                }),
              }),
              l.jsxs("button", {
                onClick: V,
                className:
                  "flex-1 md:flex-none px-4 py-2 rounded-xl bg-slate-900 border border-slate-800 hover:bg-slate-800 text-slate-200 text-xs font-extrabold flex items-center justify-center gap-1.5 transition-all cursor-pointer",
                children: [l.jsx(Lp, { className: "w-4 h-4" }), "Home"],
              }),
              l.jsxs("button", {
                onClick: b,
                className:
                  "flex-1 md:flex-none px-4 py-2 rounded-xl bg-red-950/40 border border-red-500/20 hover:bg-red-900/40 text-red-400 text-xs font-extrabold flex items-center justify-center gap-1.5 transition-all cursor-pointer",
                children: [l.jsx(Bp, { className: "w-4 h-4" }), "Logout"],
              }),
            ],
          }),
        ],
      }),
      ve &&
        l.jsxs("div", {
          className: `max-w-7xl mx-auto mb-6 p-4 rounded-xl border flex items-center justify-between gap-3 text-xs font-bold ${ve.type === "success" ? "bg-emerald-950/40 border-emerald-500/20 text-emerald-400" : "bg-red-950/40 border-red-500/20 text-red-400"}`,
          children: [
            l.jsxs("div", {
              className: "flex items-center gap-2",
              children: [
                ve.type === "success"
                  ? l.jsx(Wx, { className: "w-4 h-4 shrink-0" })
                  : l.jsx(ii, { className: "w-4 h-4 shrink-0" }),
                l.jsx("span", { children: ve.text }),
              ],
            }),
            l.jsx("button", {
              onClick: () => Te(null),
              className:
                "p-1 hover:bg-slate-800/60 rounded text-slate-400 hover:text-slate-200 transition-colors cursor-pointer",
              children: l.jsx(hs, { className: "w-3.5 h-3.5" }),
            }),
          ],
        }),
      l.jsxs("section", {
        className:
          "max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8",
        children: [
          l.jsxs("div", {
            className:
              "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 flex flex-col justify-between shadow-sm",
            children: [
              l.jsx("span", {
                className:
                  "text-[10px] sm:text-xs font-extrabold text-slate-400 uppercase tracking-wider",
                children: "Total Shortlinks",
              }),
              l.jsxs("div", {
                className: "mt-2 flex items-baseline gap-1.5 flex-wrap",
                children: [
                  l.jsx("span", {
                    className: "text-2xl sm:text-3xl font-black text-white",
                    children: R ? "..." : $l + fa,
                  }),
                  l.jsxs("span", {
                    className:
                      "text-[10px] text-emerald-400 font-bold uppercase tracking-wider",
                    children: [$l, " active"],
                  }),
                  fa > 0 &&
                    l.jsxs("span", {
                      className:
                        "text-[10px] text-violet-400 font-extrabold bg-violet-500/10 border border-violet-500/20 px-1.5 py-0.5 rounded",
                      children: [fa, " archived"],
                    }),
                ],
              }),
            ],
          }),
          l.jsxs("div", {
            className:
              "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 flex flex-col justify-between shadow-sm",
            children: [
              l.jsx("span", {
                className:
                  "text-[10px] sm:text-xs font-extrabold text-slate-400 uppercase tracking-wider",
                children: "Created Last 24h",
              }),
              l.jsxs("div", {
                className: "mt-2 flex items-baseline gap-2",
                children: [
                  l.jsx("span", {
                    className: "text-2xl sm:text-3xl font-black text-blue-400",
                    children: R ? "..." : ws,
                  }),
                  l.jsx("span", {
                    className: "text-[10px] text-blue-400/80 font-bold",
                    children: "links",
                  }),
                ],
              }),
            ],
          }),
          l.jsxs("div", {
            className:
              "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 flex flex-col justify-between shadow-sm",
            children: [
              l.jsx("span", {
                className:
                  "text-[10px] sm:text-xs font-extrabold text-slate-400 uppercase tracking-wider",
                children: "GUEST IPs",
              }),
              l.jsxs("div", {
                className: "mt-2 flex items-baseline gap-2",
                children: [
                  l.jsx("span", {
                    className:
                      "text-2xl sm:text-3xl font-black text-indigo-400",
                    children: R ? "..." : wl,
                  }),
                  l.jsx("span", {
                    className: "text-[10px] text-indigo-400/80 font-bold",
                    children: "unique visitors",
                  }),
                ],
              }),
            ],
          }),
          l.jsxs("div", {
            className:
              "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 flex flex-col justify-between shadow-sm",
            children: [
              l.jsx("span", {
                className:
                  "text-[10px] sm:text-xs font-extrabold text-slate-400 uppercase tracking-wider",
                children: "Unique Users",
              }),
              l.jsxs("div", {
                className: "mt-2 flex items-baseline gap-2",
                children: [
                  l.jsx("span", {
                    className:
                      "text-2xl sm:text-3xl font-black text-violet-400",
                    children: R ? "..." : va,
                  }),
                  l.jsx("span", {
                    className: "text-[10px] text-violet-400/80 font-bold",
                    children: "creators",
                  }),
                ],
              }),
            ],
          }),
          l.jsxs("div", {
            className:
              "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 flex flex-col justify-between shadow-sm",
            children: [
              l.jsx("span", {
                className:
                  "text-[10px] sm:text-xs font-extrabold text-slate-400 uppercase tracking-wider",
                children: "Missing Image Count",
              }),
              l.jsxs("div", {
                className: "mt-2 flex items-baseline gap-2",
                children: [
                  l.jsx("span", {
                    className: "text-2xl sm:text-3xl font-black text-amber-500",
                    children: R ? "..." : Ta,
                  }),
                  l.jsx("span", {
                    className: "text-[10px] text-amber-500/80 font-bold",
                    children: "no-thumbnail",
                  }),
                ],
              }),
            ],
          }),
          l.jsxs("div", {
            className:
              "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 flex flex-col justify-between shadow-sm",
            children: [
              l.jsx("span", {
                className:
                  "text-[10px] sm:text-xs font-extrabold text-slate-400 uppercase tracking-wider",
                children: "TOTAL CLICKS",
              }),
              l.jsxs("div", {
                className: "mt-2 flex items-baseline gap-2",
                children: [
                  l.jsx("span", {
                    className:
                      "text-2xl sm:text-3xl font-black text-emerald-400",
                    children: R ? "..." : qt,
                  }),
                  l.jsx("span", {
                    className: "text-[10px] text-emerald-400/80 font-bold",
                    children: "clicks",
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
      !R &&
        !te &&
        l.jsxs("section", {
          className:
            "max-w-7xl mx-auto mb-8 bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 shadow-sm",
          children: [
            l.jsxs("div", {
              className:
                "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-b border-slate-800/60 pb-3 mb-3",
              children: [
                l.jsxs("div", {
                  children: [
                    l.jsx("h3", {
                      className:
                        "text-xs sm:text-sm font-black text-white uppercase tracking-wider flex items-center gap-2",
                      children: "🛍️ Store Distribution Breakdown",
                    }),
                    l.jsx("p", {
                      className: "text-[10px] sm:text-xs text-slate-400 mt-0.5",
                      children:
                        "Real-time classification based on true final redirect destination domains",
                    }),
                  ],
                }),
                l.jsxs("div", {
                  className:
                    "text-[10px] font-bold text-slate-400 bg-slate-950 px-2 py-1 rounded border border-slate-800",
                  children: [
                    "Active Links Scanned: ",
                    l.jsx("span", {
                      className: "text-white font-black",
                      children: Bl.all,
                    }),
                  ],
                }),
              ],
            }),
            l.jsx("div", {
              className: "grid grid-cols-2 sm:grid-cols-5 gap-3",
              children: [
                {
                  id: "amazon",
                  label: "Amazon",
                  color: "text-amber-500",
                  bg: "bg-amber-500/10",
                  border: "border-amber-500/30",
                },
                {
                  id: "walmart",
                  label: "Walmart",
                  color: "text-sky-400",
                  bg: "bg-sky-400/10",
                  border: "border-sky-400/30",
                },
                {
                  id: "ebay",
                  label: "eBay",
                  color: "text-yellow-500",
                  bg: "bg-yellow-500/10",
                  border: "border-yellow-500/30",
                },
                {
                  id: "etsy",
                  label: "Etsy",
                  color: "text-orange-500",
                  bg: "bg-orange-600/10",
                  border: "border-orange-600/30",
                },
                {
                  id: "other",
                  label: "Other Sites",
                  color: "text-slate-400",
                  bg: "bg-slate-800/40",
                  border: "border-slate-700/60",
                },
              ].map((d) => {
                const S = Bl[d.id] || 0,
                  p = Bl.all > 0 ? Math.round((S / Bl.all) * 100) : 0;
                return l.jsxs(
                  "div",
                  {
                    className: `${d.bg} ${d.border} border p-3 rounded-xl flex flex-col justify-between`,
                    children: [
                      l.jsx("span", {
                        className: `text-[10px] font-black uppercase tracking-wider ${d.color}`,
                        children: d.label,
                      }),
                      l.jsxs("div", {
                        className: "mt-1 flex items-baseline justify-between",
                        children: [
                          l.jsx("span", {
                            className: "text-xl font-black text-white",
                            children: S,
                          }),
                          l.jsxs("span", {
                            className: "text-[10px] font-mono text-slate-500",
                            children: [p, "%"],
                          }),
                        ],
                      }),
                      l.jsx("div", {
                        className:
                          "w-full bg-slate-950 h-1.5 rounded-full mt-2 overflow-hidden",
                        children: l.jsx("div", {
                          className: `h-full rounded-full ${d.id === "amazon" ? "bg-amber-500" : d.id === "walmart" ? "bg-sky-400" : d.id === "ebay" ? "bg-yellow-500" : d.id === "etsy" ? "bg-orange-500" : "bg-slate-500"}`,
                          style: { width: `${p}%` },
                        }),
                      }),
                    ],
                  },
                  d.id,
                );
              }),
            }),
          ],
        }),
      aa > 0 &&
        l.jsxs("section", {
          className:
            "max-w-7xl mx-auto bg-blue-950/20 border border-blue-500/20 rounded-2xl p-3.5 px-5 mb-4 flex flex-col sm:flex-row items-center gap-3 justify-between shadow-sm",
          children: [
            l.jsxs("div", {
              className: "flex items-center gap-2",
              children: [
                l.jsx("span", {
                  className:
                    "w-2.5 h-2.5 bg-blue-500 rounded-full animate-ping shrink-0",
                }),
                l.jsxs("span", {
                  className:
                    "text-xs font-extrabold text-blue-400 font-sans tracking-wide",
                  children: [
                    "Selected ",
                    aa,
                    " shortlink",
                    aa === 1 ? "" : "s",
                    " for bulk action",
                  ],
                }),
              ],
            }),
            l.jsxs("div", {
              className: "flex gap-2 w-full sm:w-auto",
              children: [
                l.jsx("button", {
                  onClick: Ol,
                  className:
                    "flex-1 sm:flex-none px-4 py-2 bg-slate-900 border border-slate-800 hover:bg-slate-800 text-slate-300 text-xs font-extrabold rounded-xl transition-all cursor-pointer",
                  children: "Clear Selection",
                }),
                l.jsxs("button", {
                  onClick: () => gl(!0),
                  className:
                    "flex-1 sm:flex-none px-4 py-2 bg-gradient-to-tr from-red-600 to-rose-700 hover:brightness-110 text-white text-xs font-extrabold rounded-xl transition-all cursor-pointer flex items-center justify-center gap-2 shadow",
                  children: [
                    l.jsx(qa, { className: "w-3.5 h-3.5" }),
                    D === "trash"
                      ? `Delete Selected Permanently (${aa})`
                      : `Delete Selected (${aa})`,
                  ],
                }),
                (D === "active" || D === "archive") &&
                  l.jsxs("button", {
                    onClick: $s,
                    disabled: Ct,
                    className:
                      "flex-1 sm:flex-none px-4 py-2 bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-white text-xs font-extrabold rounded-xl transition-all cursor-pointer flex items-center justify-center gap-2 shadow",
                    children: [
                      l.jsx(qa, { className: "w-3.5 h-3.5" }),
                      Ct ? "Moving..." : `Trash Selected (${aa})`,
                    ],
                  }),
              ],
            }),
          ],
        }),
      l.jsx("section", {
        className: "max-w-7xl mx-auto mb-6",
        children: l.jsxs("div", {
          className:
            "flex border-b border-slate-800 bg-[#070d19]/40 rounded-t-xl overflow-hidden",
          children: [
            l.jsxs("button", {
              onClick: () => {
                (U("active"), Ol());
              },
              className: `flex-1 sm:flex-none px-6 py-3 text-xs font-black tracking-wide uppercase transition-all cursor-pointer border-b-2 -mb-[2px] text-center ${D === "active" ? "border-blue-500 text-blue-400 font-black bg-blue-950/10" : "border-transparent text-slate-400 hover:text-slate-200 hover:bg-slate-900/10"}`,
              children: ["📂 Link Ledger (", $l, ")"],
            }),
            l.jsxs("button", {
              onClick: () => {
                (U("archive"), Ol());
              },
              className: `flex-1 sm:flex-none px-6 py-3 text-xs font-black tracking-wide uppercase transition-all cursor-pointer border-b-2 -mb-[2px] text-center ${D === "archive" ? "border-violet-500 text-violet-400 font-black bg-violet-950/10" : "border-transparent text-slate-400 hover:text-slate-200 hover:bg-slate-900/10"}`,
              children: ["📥 Done Shortlinks / Archive (", fa, ")"],
            }),
            l.jsxs("button", {
              onClick: () => {
                (U("trash"), Ol());
              },
              className: `flex-1 sm:flex-none px-6 py-3 text-xs font-black tracking-wide uppercase transition-all cursor-pointer border-b-2 -mb-[2px] text-center ${D === "trash" ? "border-rose-500 text-rose-400 font-black bg-rose-950/10" : "border-transparent text-slate-400 hover:text-slate-200 hover:bg-slate-900/10"}`,
              children: ["🗑️ Trash (", je, ")"],
            }),
            l.jsx("button", {
              onClick: () => {
                (U("deals"), Ol());
              },
              className: `flex-1 sm:flex-none px-6 py-3 text-xs font-black tracking-wide uppercase transition-all cursor-pointer border-b-2 -mb-[2px] text-center ${D === "deals" ? "border-purple-500 text-purple-400 font-black bg-purple-950/10" : "border-transparent text-slate-400 hover:text-slate-200 hover:bg-slate-900/10"}`,
              children: "🏷️ Your post Deals in home page",
            }),
          ],
        }),
      }),
      D === "deals"
        ? l.jsx("section", {
            className: "max-w-7xl mx-auto mb-6",
            children: l.jsx(rm, {}),
          })
        : l.jsxs(l.Fragment, {
            children: [
              D === "active" &&
                l.jsx("section", {
                  className: "max-w-7xl mx-auto mb-6",
                  children: l.jsxs("div", {
                    className:
                      "flex flex-wrap gap-2 items-center bg-[#070d19]/60 border border-slate-800/80 p-2.5 rounded-2xl",
                    children: [
                      l.jsx("span", {
                        className:
                          "text-[10px] font-extrabold text-slate-500 uppercase tracking-wider pl-1.5 pr-2 select-none",
                        children: "Store Filters:",
                      }),
                      [
                        { id: "all", label: "All Stores" },
                        { id: "amazon", label: "Amazon" },
                        { id: "walmart", label: "Walmart" },
                        { id: "ebay", label: "eBay" },
                        { id: "etsy", label: "Etsy" },
                        { id: "other", label: "Other" },
                      ].map((d) => {
                        const S = Bl[d.id] || 0;
                        if (d.id !== "all" && S === 0) return null;
                        const p = y === d.id;
                        return l.jsxs(
                          "button",
                          {
                            onClick: () => X(d.id),
                            className: `px-3.5 py-1.5 rounded-xl text-xs font-extrabold transition-all duration-150 cursor-pointer flex items-center gap-1.5 border ${p ? "bg-blue-600/20 border-blue-500 text-blue-400 font-bold shadow-lg shadow-blue-500/5" : "bg-slate-950 border-slate-800/80 hover:border-slate-700 text-slate-400 hover:text-slate-200"}`,
                            children: [
                              l.jsxs("span", {
                                className: "flex items-center gap-1",
                                children: [
                                  d.id === "amazon" && "🔸",
                                  d.id === "walmart" && "🔹",
                                  d.id === "ebay" && "🟡",
                                  d.id === "etsy" && "🔸",
                                  d.label,
                                ],
                              }),
                              l.jsx("span", {
                                className: `text-[10px] px-1.5 py-0.5 rounded-md font-mono font-bold ${p ? "bg-blue-500/30 text-blue-300" : "bg-slate-900 text-slate-500"}`,
                                children: S,
                              }),
                            ],
                          },
                          d.id,
                        );
                      }),
                    ],
                  }),
                }),
              l.jsxs("section", {
                className:
                  "max-w-7xl mx-auto bg-[#0b1528] border border-slate-800/80 rounded-2xl p-4 mb-6 space-y-4",
                children: [
                  l.jsxs("div", {
                    className:
                      "flex flex-col lg:flex-row items-center gap-4 justify-between",
                    children: [
                      l.jsxs("div", {
                        className: "relative w-full lg:max-w-xs",
                        children: [
                          l.jsx(di, {
                            className:
                              "absolute left-3 top-2.5 w-4 h-4 text-slate-400",
                          }),
                          l.jsx("input", {
                            type: "text",
                            placeholder:
                              "Search code, title, URL, IP or User...",
                            value: st,
                            onChange: (d) => ot(d.target.value),
                            className:
                              "w-full bg-slate-950 border border-slate-800 hover:border-slate-700 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 rounded-xl pl-9 pr-4 py-2 text-xs text-white placeholder-slate-500 outline-none transition-all",
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "flex flex-wrap items-center gap-2 w-full lg:w-auto justify-start lg:justify-center",
                        children: [
                          l.jsxs("div", {
                            className:
                              "flex items-center bg-slate-950 p-1 rounded-xl border border-slate-800",
                            children: [
                              l.jsx("button", {
                                onClick: () => C("grouped"),
                                className: `px-3 py-1.5 text-xs font-extrabold rounded-lg transition-all cursor-pointer ${Re === "grouped" ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white"}`,
                                children: "Grouped By User",
                              }),
                              l.jsx("button", {
                                onClick: () => C("flat"),
                                className: `px-3 py-1.5 text-xs font-extrabold rounded-lg transition-all cursor-pointer ${Re === "flat" ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white"}`,
                                children: "All Links (Flat List)",
                              }),
                            ],
                          }),
                          l.jsxs("button", {
                            onClick: () => Ze(ke === "12h" ? "all" : "12h"),
                            className: `px-3 py-1.5 rounded-xl border text-xs font-extrabold transition-all flex items-center gap-1.5 cursor-pointer ${ke === "12h" ? "bg-amber-500/20 border-amber-500 text-amber-400" : "bg-slate-950 border-slate-800 hover:border-slate-700 text-slate-400"}`,
                            children: [
                              l.jsx("span", { children: "🔥 Last 12h" }),
                              l.jsx("span", {
                                className:
                                  "bg-slate-900 text-[10px] text-white px-1.5 py-0.5 rounded font-mono",
                                children: R ? "..." : gt,
                              }),
                            ],
                          }),
                          l.jsxs("button", {
                            onClick: () => dl(!ye),
                            className: `px-3 py-1.5 rounded-xl border text-xs font-extrabold transition-all flex items-center gap-1.5 cursor-pointer ${ye ? "bg-violet-500/20 border-violet-500 text-violet-400" : "bg-slate-950 border-slate-800 hover:border-slate-700 text-slate-400"}`,
                            children: [
                              l.jsx("span", { children: "👁️ Hide Reviewed" }),
                              l.jsx("span", {
                                className:
                                  "bg-slate-900 text-[10px] text-white px-1.5 py-0.5 rounded font-mono",
                                children: R
                                  ? "..."
                                  : Object.values(we).filter(Boolean).length,
                              }),
                            ],
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "flex flex-wrap items-center gap-3 w-full lg:w-auto justify-end",
                        children: [
                          l.jsxs("div", {
                            className:
                              "flex items-center gap-1.5 bg-slate-950 p-1 rounded-xl border border-slate-800 text-xs",
                            children: [
                              l.jsx("span", {
                                className:
                                  "px-2 text-[10px] font-bold text-slate-500 uppercase tracking-wider",
                                children: "Time",
                              }),
                              l.jsxs("select", {
                                value: ke,
                                onChange: (d) => Ze(d.target.value),
                                className:
                                  "bg-transparent text-slate-200 py-1 px-2 font-extrabold outline-none cursor-pointer border-0 rounded-lg text-xs",
                                children: [
                                  l.jsx("option", {
                                    value: "all",
                                    className: "bg-slate-950",
                                    children: "All Time",
                                  }),
                                  l.jsx("option", {
                                    value: "1h",
                                    className: "bg-slate-950",
                                    children: "Last 1h",
                                  }),
                                  l.jsx("option", {
                                    value: "5h",
                                    className: "bg-slate-950",
                                    children: "Last 5h",
                                  }),
                                  l.jsx("option", {
                                    value: "12h",
                                    className: "bg-slate-950",
                                    children: "Last 12h",
                                  }),
                                  l.jsx("option", {
                                    value: "24h",
                                    className: "bg-slate-950",
                                    children: "Last 24h",
                                  }),
                                  l.jsx("option", {
                                    value: "48h",
                                    className: "bg-slate-950",
                                    children: "Last 48h",
                                  }),
                                  l.jsx("option", {
                                    value: "72h",
                                    className: "bg-slate-950",
                                    children: "Last 72h",
                                  }),
                                ],
                              }),
                            ],
                          }),
                          Re === "grouped" &&
                            l.jsxs("div", {
                              className:
                                "flex items-center bg-slate-950 p-1 rounded-xl border border-slate-800",
                              children: [
                                l.jsx("button", {
                                  onClick: () => $e("grid"),
                                  title: "Grid View",
                                  className: `p-1.5 rounded-lg transition-all cursor-pointer ${it === "grid" ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white"}`,
                                  children: l.jsx(Op, {
                                    className: "w-3.5 h-3.5",
                                  }),
                                }),
                                l.jsx("button", {
                                  onClick: () => $e("list"),
                                  title: "Compact List View",
                                  className: `p-1.5 rounded-lg transition-all cursor-pointer ${it === "list" ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white"}`,
                                  children: l.jsx(Up, {
                                    className: "w-3.5 h-3.5",
                                  }),
                                }),
                              ],
                            }),
                          (Re === "flat" ||
                            (Re === "grouped" && it === "grid")) &&
                            l.jsxs("div", {
                              className:
                                "flex items-center gap-1.5 bg-slate-950 p-1 rounded-xl border border-slate-800 text-xs",
                              children: [
                                l.jsx("span", {
                                  className:
                                    "px-2 text-[10px] font-bold text-slate-500 uppercase tracking-wider",
                                  children: "Columns",
                                }),
                                l.jsxs("select", {
                                  value: Pe,
                                  onChange: (d) => nt(Number(d.target.value)),
                                  className:
                                    "bg-transparent text-slate-200 py-1 px-2 font-extrabold outline-none cursor-pointer border-0 rounded-lg text-xs",
                                  children: [
                                    l.jsx("option", {
                                      value: 2,
                                      className: "bg-slate-950",
                                      children: "2 Cols",
                                    }),
                                    l.jsx("option", {
                                      value: 3,
                                      className: "bg-slate-950",
                                      children: "3 Cols",
                                    }),
                                    l.jsx("option", {
                                      value: 4,
                                      className: "bg-slate-950",
                                      children: "4 Cols",
                                    }),
                                    l.jsx("option", {
                                      value: 5,
                                      className: "bg-slate-950",
                                      children: "5 Cols",
                                    }),
                                    l.jsx("option", {
                                      value: 6,
                                      className: "bg-slate-950",
                                      children: "6 Cols",
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          l.jsxs("div", {
                            className:
                              "flex items-center gap-1.5 bg-slate-950 p-1 rounded-xl border border-slate-800 text-xs",
                            children: [
                              l.jsx("span", {
                                className:
                                  "px-2 text-[10px] font-bold text-slate-500 uppercase tracking-wider",
                                children: "Sort",
                              }),
                              Re === "flat"
                                ? l.jsxs("select", {
                                    value: Nt,
                                    onChange: (d) => oe(d.target.value),
                                    className:
                                      "bg-transparent text-slate-200 py-1 px-2.5 font-extrabold outline-none cursor-pointer border-0 rounded-lg text-xs",
                                    children: [
                                      l.jsx("option", {
                                        value: "newest",
                                        className: "bg-slate-950",
                                        children: "Newest Created",
                                      }),
                                      l.jsx("option", {
                                        value: "oldest",
                                        className: "bg-slate-950",
                                        children: "Oldest Created",
                                      }),
                                      l.jsx("option", {
                                        value: "clicksDesc",
                                        className: "bg-slate-950",
                                        children: "🔥 Most Clicked",
                                      }),
                                    ],
                                  })
                                : l.jsxs("select", {
                                    value: ue,
                                    onChange: (d) => Me(d.target.value),
                                    className:
                                      "bg-transparent text-slate-200 py-1 px-2.5 font-extrabold outline-none cursor-pointer border-0 rounded-lg text-xs",
                                    children: [
                                      l.jsx("option", {
                                        value: "lastSeenDesc",
                                        className: "bg-slate-950",
                                        children: "Newest Activity",
                                      }),
                                      l.jsx("option", {
                                        value: "firstSeenDesc",
                                        className: "bg-slate-950",
                                        children: "First Seen (Newest)",
                                      }),
                                      l.jsx("option", {
                                        value: "firstSeenAsc",
                                        className: "bg-slate-950",
                                        children: "First Seen (Oldest)",
                                      }),
                                      l.jsx("option", {
                                        value: "linksDesc",
                                        className: "bg-slate-950",
                                        children: "Most Links",
                                      }),
                                      l.jsx("option", {
                                        value: "clicksDesc",
                                        className: "bg-slate-950",
                                        children: "🔥 Most Clicked",
                                      }),
                                      l.jsx("option", {
                                        value: "label",
                                        className: "bg-slate-950",
                                        children: "User Label",
                                      }),
                                    ],
                                  }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className:
                      "flex flex-wrap items-center gap-2 pt-3 mt-1 border-t border-slate-800/60",
                    children: [
                      l.jsx("span", {
                        className:
                          "text-[10px] font-black uppercase tracking-wider text-slate-500 mr-1",
                        children: "Clicks:",
                      }),
                      O.map((d) =>
                        l.jsx(
                          "button",
                          {
                            onClick: () => G(d.id),
                            className: `px-2.5 py-1 text-[11px] font-extrabold rounded-lg transition-all cursor-pointer border ${H === d.id ? "bg-blue-600 border-blue-500 text-white shadow" : "bg-slate-950 border-slate-800 text-slate-400 hover:text-white hover:border-slate-700"}`,
                            children: d.label,
                          },
                          d.id,
                        ),
                      ),
                    ],
                  }),
                  l.jsxs("div", {
                    className:
                      "flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-slate-800/60",
                    children: [
                      l.jsxs("div", {
                        className: "text-xs text-slate-400 font-sans",
                        children: [
                          "Showing ",
                          l.jsx("span", {
                            className: "text-white font-bold",
                            children: Re === "flat" ? yl.length : At.length,
                          }),
                          " entries",
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "flex flex-wrap gap-1 bg-slate-950 p-1 rounded-xl border border-slate-800",
                        children: [
                          l.jsx("button", {
                            onClick: Nl,
                            className:
                              "px-2.5 py-1 text-[10px] font-extrabold rounded-lg text-slate-300 hover:text-white transition-all cursor-pointer",
                            children: "Select All Shown",
                          }),
                          Re === "grouped" &&
                            l.jsxs(l.Fragment, {
                              children: [
                                l.jsx("button", {
                                  onClick: yn,
                                  className:
                                    "px-2.5 py-1 text-[10px] font-extrabold rounded-lg text-slate-300 hover:text-white transition-all cursor-pointer",
                                  children: "Expand All",
                                }),
                                l.jsx("button", {
                                  onClick: jl,
                                  className:
                                    "px-2.5 py-1 text-[10px] font-extrabold rounded-lg text-slate-300 hover:text-white transition-all cursor-pointer",
                                  children: "Collapse All",
                                }),
                              ],
                            }),
                        ],
                      }),
                    ],
                  }),
                  D === "archive" &&
                    l.jsxs("div", {
                      className:
                        "flex flex-wrap items-center gap-2 pt-3 mt-1 border-t border-slate-800/60",
                      children: [
                        l.jsx("span", {
                          className:
                            "text-[10px] font-black uppercase tracking-wider text-slate-500 mr-1",
                          children: "Archive ATOM:",
                        }),
                        l.jsx("button", {
                          onClick: wn,
                          className:
                            "flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 hover:bg-purple-500 text-white font-extrabold text-[11px] rounded-lg transition-colors cursor-pointer",
                          children: "Export ATOM",
                        }),
                        l.jsxs("label", {
                          className:
                            "flex items-center gap-1.5 px-3 py-1.5 bg-sky-600 hover:bg-sky-500 text-white font-extrabold text-[11px] rounded-lg transition-colors cursor-pointer",
                          children: [
                            "Upload / Re-upload ATOM",
                            l.jsx("input", {
                              type: "file",
                              accept:
                                ".atom,.xml,application/atom+xml,text/xml",
                              className: "hidden",
                              onChange: Qs,
                            }),
                          ],
                        }),
                        l.jsxs("label", {
                          className:
                            "flex items-center gap-1.5 px-3 py-1.5 bg-slate-800 border border-slate-700 text-slate-200 font-extrabold text-[11px] rounded-lg cursor-pointer select-none",
                          children: [
                            l.jsx("input", {
                              type: "checkbox",
                              checked: pe,
                              onChange: (d) => Ie(d.target.checked),
                              className:
                                "w-3.5 h-3.5 rounded border-slate-600 bg-slate-900 text-emerald-500 cursor-pointer",
                            }),
                            "Hide green-edited posts",
                          ],
                        }),
                        Object.keys(le).length > 0 &&
                          l.jsxs("span", {
                            className:
                              "text-[11px] font-bold text-emerald-400 bg-emerald-950/50 border border-emerald-600/40 px-2.5 py-1 rounded-lg",
                            children: [
                              Object.keys(le).length,
                              " edited (green)",
                            ],
                          }),
                      ],
                    }),
                ],
              }),
              l.jsxs("main", {
                className: "max-w-7xl mx-auto space-y-4",
                children: [
                  R &&
                    l.jsxs("div", {
                      className:
                        "flex flex-col items-center justify-center py-20 space-y-3",
                      children: [
                        l.jsx("div", {
                          className:
                            "w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin",
                        }),
                        l.jsx("p", {
                          className: "text-sm text-slate-400 font-bold",
                          children: "Synchronizing ledger database...",
                        }),
                      ],
                    }),
                  te &&
                    l.jsxs("div", {
                      className:
                        "bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-2xl flex items-start gap-3",
                      children: [
                        l.jsx(ii, { className: "w-5 h-5 shrink-0 mt-0.5" }),
                        l.jsxs("div", {
                          children: [
                            l.jsx("h3", {
                              className: "font-bold text-sm text-white",
                              children: "Database Sync Error",
                            }),
                            l.jsx("p", {
                              className: "text-xs mt-1 text-slate-400",
                              children: te,
                            }),
                            l.jsx("button", {
                              onClick: () => et(),
                              className:
                                "mt-3 text-xs text-blue-400 hover:underline font-bold",
                              children: "Retry Connection",
                            }),
                          ],
                        }),
                      ],
                    }),
                  !R &&
                    !te &&
                    Re === "grouped" &&
                    At.length === 0 &&
                    l.jsxs("div", {
                      className:
                        "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-12 text-center text-slate-400",
                      children: [
                        l.jsx(di, {
                          className: "w-8 h-8 mx-auto text-slate-600 mb-3",
                        }),
                        l.jsx("p", {
                          className: "text-sm font-bold",
                          children: "No entries found matching your query.",
                        }),
                      ],
                    }),
                  !R &&
                    !te &&
                    Re === "flat" &&
                    yl.length === 0 &&
                    l.jsxs("div", {
                      className:
                        "bg-[#0b1528] border border-slate-800/80 rounded-2xl p-12 text-center text-slate-400",
                      children: [
                        l.jsx(di, {
                          className: "w-8 h-8 mx-auto text-slate-600 mb-3",
                        }),
                        l.jsx("p", {
                          className: "text-sm font-bold",
                          children: "No links found matching your query.",
                        }),
                      ],
                    }),
                  !R &&
                    !te &&
                    Re === "flat" &&
                    yl.length > 0 &&
                    l.jsx("div", {
                      className: bs(Pe),
                      children: yl.map((d) => {
                        const S = `${window.location.origin}/?${d.code}`;
                        return l.jsxs(
                          "div",
                          {
                            className: `rounded-2xl p-4 flex gap-4 transition-all relative group shadow-sm flex-col justify-between border-2 ${Xt(d) ? "bg-emerald-800/60 border-emerald-400 hover:border-emerald-300" : "bg-[#0b1528] border-slate-800/80 hover:border-slate-700"}`,
                            children: [
                              l.jsxs("div", {
                                className: "flex gap-4",
                                children: [
                                  l.jsxs("div", {
                                    className:
                                      "w-16 h-16 sm:w-20 sm:h-20 bg-slate-900 border border-slate-800 rounded-lg shrink-0 overflow-hidden flex items-center justify-center relative",
                                    children: [
                                      l.jsx("div", {
                                        className:
                                          "absolute top-1 left-1 z-20 bg-slate-950/80 p-1 rounded border border-slate-800/40",
                                        children: l.jsx("input", {
                                          type: "checkbox",
                                          checked: !!Pt[d.code],
                                          onChange: () => ya(d.code),
                                          className:
                                            "w-3.5 h-3.5 accent-blue-500 cursor-pointer rounded",
                                        }),
                                      }),
                                      d.image
                                        ? l.jsx("img", {
                                            src: d.image,
                                            alt: d.title || "Link preview",
                                            referrerPolicy: "no-referrer",
                                            className:
                                              "w-full h-full object-cover",
                                            onError: (p) => {
                                              p.target.src = "";
                                            },
                                          })
                                        : l.jsx(Zr, {
                                            className: "w-6 h-6 text-slate-600",
                                          }),
                                      !d.image &&
                                        l.jsx("div", {
                                          className:
                                            "absolute inset-0 bg-amber-500/5 flex items-center justify-center",
                                          title: "Missing Image",
                                        }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className: "flex-1 min-w-0",
                                    children: [
                                      l.jsxs("div", {
                                        className:
                                          "flex items-center gap-1.5 flex-wrap",
                                        children: [
                                          l.jsxs("a", {
                                            href: S,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className:
                                              "text-xs font-black text-blue-400 hover:underline font-mono tracking-tight flex items-center gap-1 shrink-0",
                                            children: [
                                              "/",
                                              d.code,
                                              l.jsx(tr, {
                                                className: "w-3 h-3",
                                              }),
                                            ],
                                          }),
                                          ht(
                                            d.store,
                                            d.resolvedUrl || d.url,
                                            d.title,
                                            d.description,
                                          ),
                                          d.preview &&
                                            l.jsx("span", {
                                              className:
                                                "bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[9px] px-1.5 py-0.2 rounded font-bold uppercase shrink-0",
                                              children: "Preview",
                                            }),
                                          It(d.created),
                                        ],
                                      }),
                                      l.jsx("h4", {
                                        className:
                                          "text-xs font-black text-white truncate mt-1",
                                        children: d.title || "Untitled Link",
                                      }),
                                      l.jsx("p", {
                                        className:
                                          "text-[11px] text-slate-400 line-clamp-1 mt-0.5",
                                        children:
                                          d.description ||
                                          "No description provided.",
                                      }),
                                      l.jsx("div", {
                                        className:
                                          "flex flex-wrap gap-1.5 items-center mt-1",
                                        children: l.jsxs("span", {
                                          className:
                                            "inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded bg-slate-950 text-[10px] text-slate-400 border border-slate-800/60 font-mono font-bold truncate max-w-full",
                                          children: [
                                            "👤 ",
                                            d.groupLabel,
                                            (() => {
                                              const p =
                                                d.creatorIp ||
                                                (d.creatorId
                                                  ? W[d.creatorId]?.ip
                                                  : null) ||
                                                d.ip;
                                              return p && Qe[p]
                                                ? Va(
                                                    Qe[p].countryCode,
                                                    Qe[p].countryName,
                                                  )
                                                : null;
                                            })(),
                                          ],
                                        }),
                                      }),
                                      (D === "archive" ||
                                        D === "trash" ||
                                        d.done ||
                                        d.trashed) &&
                                        l.jsxs("div", {
                                          className:
                                            "mt-2.5 pt-2 flex flex-wrap items-center gap-1.5 border-t border-slate-800/60",
                                          children: [
                                            l.jsxs("span", {
                                              className:
                                                "text-[9px] font-extrabold text-slate-400 bg-slate-900 border border-slate-800 px-1 py-0.5 rounded shrink-0 font-mono",
                                              children: [
                                                "ID: ",
                                                l.jsx("span", {
                                                  className:
                                                    "text-indigo-400 font-bold",
                                                  children:
                                                    d.creatorId || "anonymous",
                                                }),
                                              ],
                                            }),
                                            l.jsxs("span", {
                                              className:
                                                "text-[9px] font-extrabold text-slate-400 bg-slate-900 border border-slate-800 px-1 py-0.5 rounded shrink-0 font-mono flex items-center gap-1",
                                              children: [
                                                "IP: ",
                                                l.jsx("span", {
                                                  className:
                                                    "text-emerald-400 font-bold",
                                                  children:
                                                    d.creatorIp ||
                                                    (d.creatorId
                                                      ? W[d.creatorId]?.ip
                                                      : null) ||
                                                    d.ip ||
                                                    "Unknown",
                                                }),
                                                (() => {
                                                  const p =
                                                    d.creatorIp ||
                                                    (d.creatorId
                                                      ? W[d.creatorId]?.ip
                                                      : null) ||
                                                    d.ip;
                                                  return p && Qe[p]
                                                    ? Va(
                                                        Qe[p].countryCode,
                                                        Qe[p].countryName,
                                                      )
                                                    : null;
                                                })(),
                                              ],
                                            }),
                                          ],
                                        }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className:
                                      "flex flex-col items-center justify-center px-3.5 py-2.5 rounded-xl bg-blue-950/40 border border-blue-800/40 text-blue-400 shrink-0 min-w-[72px] h-[72px] text-center self-center shadow-lg shadow-blue-950/20",
                                    children: [
                                      l.jsx("span", {
                                        className:
                                          "text-2xl font-black tracking-tight leading-none text-blue-300",
                                        children: d.clicks || 0,
                                      }),
                                      l.jsx("span", {
                                        className:
                                          "text-[9px] font-black text-blue-400 uppercase tracking-widest mt-1",
                                        children: "CLICKS",
                                      }),
                                    ],
                                  }),
                                ],
                              }),
                              l.jsxs("div", {
                                children: [
                                  l.jsxs("div", {
                                    className:
                                      "text-[10px] text-slate-500 truncate mt-2 font-mono hover:text-slate-300",
                                    children: ["→ ", d.url],
                                  }),
                                  l.jsxs("div", {
                                    className:
                                      "flex items-center justify-between border-t border-slate-800/40 pt-2.5 mt-2.5",
                                    children: [
                                      l.jsx("span", {
                                        className:
                                          "text-[9px] font-semibold text-sky-300/90 font-mono",
                                        children: d.created
                                          ? vl(d.created)
                                          : "Fallback Time",
                                      }),
                                      l.jsx("div", {
                                        className: "flex gap-1.5 flex-wrap",
                                        children:
                                          D === "trash"
                                            ? l.jsxs(l.Fragment, {
                                                children: [
                                                  l.jsx("button", {
                                                    onClick: () => za(d, !1),
                                                    className:
                                                      "p-1 px-2 text-[10px] font-extrabold rounded bg-emerald-950/20 border border-emerald-500/10 text-emerald-400 hover:bg-emerald-950/50 hover:border-emerald-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                    title: "Restore Link",
                                                    children: "Restore",
                                                  }),
                                                  l.jsx("button", {
                                                    onClick: () => ea(d),
                                                    className:
                                                      "p-1 px-1.5 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                    title: "View Details",
                                                    children: l.jsx(er, {
                                                      className: "w-3 h-3",
                                                    }),
                                                  }),
                                                  l.jsxs("button", {
                                                    onClick: () => Lt(d.code),
                                                    className:
                                                      "p-1 px-2 text-[10px] font-extrabold rounded bg-red-950/20 border border-red-500/10 text-red-400 hover:bg-red-950/50 hover:border-red-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                    title: "Delete Permanently",
                                                    children: [
                                                      l.jsx(qa, {
                                                        className: "w-3 h-3",
                                                      }),
                                                      "Delete",
                                                    ],
                                                  }),
                                                ],
                                              })
                                            : l.jsxs(l.Fragment, {
                                                children: [
                                                  l.jsxs("button", {
                                                    onClick: () => Ql(d.code),
                                                    className: `p-1 px-2 text-[10px] font-extrabold rounded border transition-all cursor-pointer flex items-center gap-1 ${we[d.code] ? "bg-violet-950/40 border-violet-500/20 text-violet-400 hover:bg-violet-900/40" : "bg-slate-900 border-slate-800 text-slate-400 hover:text-white hover:bg-slate-800"}`,
                                                    title: we[d.code]
                                                      ? "Mark as Unreviewed"
                                                      : "Mark as Reviewed",
                                                    children: [
                                                      l.jsx(ms, {
                                                        className:
                                                          "w-2.5 h-2.5",
                                                      }),
                                                      we[d.code]
                                                        ? "Reviewed"
                                                        : "Review",
                                                    ],
                                                  }),
                                                  l.jsx("button", {
                                                    onClick: () => ea(d),
                                                    className:
                                                      "p-1 px-1.5 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                    title: "View Details",
                                                    children: l.jsx(er, {
                                                      className: "w-3 h-3",
                                                    }),
                                                  }),
                                                  l.jsx("button", {
                                                    onClick: () => kl(d),
                                                    className:
                                                      "p-1 px-1.5 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                    title: "Edit Link",
                                                    children: l.jsx(ci, {
                                                      className: "w-3 h-3",
                                                    }),
                                                  }),
                                                  l.jsx("button", {
                                                    onClick: () => za(d, !0),
                                                    className:
                                                      "p-1 px-2 text-[10px] font-extrabold rounded bg-amber-950/20 border border-amber-500/10 text-amber-400 hover:bg-amber-950/50 hover:border-amber-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                    title: "Move to Trash",
                                                    children: "Trash",
                                                  }),
                                                  l.jsx("button", {
                                                    onClick: () => Lt(d.code),
                                                    className:
                                                      "p-1 px-1.5 text-[10px] font-extrabold rounded bg-red-950/20 border border-red-500/10 text-red-400 hover:bg-red-950/50 hover:border-red-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                    title: "Delete Link",
                                                    children: l.jsx(qa, {
                                                      className: "w-3 h-3",
                                                    }),
                                                  }),
                                                ],
                                              }),
                                      }),
                                    ],
                                  }),
                                ],
                              }),
                            ],
                          },
                          d.code,
                        );
                      }),
                    }),
                  !R &&
                    !te &&
                    Re === "grouped" &&
                    At.length > 0 &&
                    l.jsx("div", {
                      className: "space-y-4",
                      children: At.map((d) => {
                        const S = !!kt[d.creatorId];
                        return l.jsxs(
                          "div",
                          {
                            className:
                              "bg-[#0b1528] border border-slate-800/80 rounded-2xl overflow-hidden shadow-sm hover:border-slate-700/60 transition-all",
                            children: [
                              l.jsxs("div", {
                                onClick: () => ta(d.creatorId),
                                className:
                                  "p-4 sm:px-6 flex flex-wrap items-center justify-between gap-4 cursor-pointer hover:bg-slate-800/20 transition-all select-none",
                                children: [
                                  l.jsxs("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                      l.jsx("div", {
                                        className:
                                          "w-8 h-8 rounded-lg bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 flex items-center justify-center text-sm",
                                        children: "👤",
                                      }),
                                      l.jsxs("div", {
                                        children: [
                                          l.jsxs("div", {
                                            className:
                                              "flex items-center gap-2 flex-wrap",
                                            children: [
                                              l.jsxs("span", {
                                                className:
                                                  "font-black text-sm text-white flex items-center gap-1.5",
                                                children: [
                                                  d.label,
                                                  d.ip &&
                                                    Qe[d.ip] &&
                                                    Va(
                                                      Qe[d.ip]?.countryCode ||
                                                        "",
                                                      Qe[d.ip].countryName,
                                                    ),
                                                ],
                                              }),
                                              l.jsxs("span", {
                                                className:
                                                  "font-mono text-[10px] text-indigo-400 font-extrabold bg-indigo-950/60 border border-indigo-900/40 px-1.5 py-0.5 rounded shadow-sm",
                                                children: ["ID: ", d.creatorId],
                                              }),
                                              d.ip &&
                                                l.jsxs("span", {
                                                  className:
                                                    "bg-slate-900 border border-slate-800 text-slate-400 text-[9px] px-1.5 py-0.5 rounded font-mono flex items-center gap-1",
                                                  children: [
                                                    "IP: ",
                                                    d.ip,
                                                    Qe[d.ip] &&
                                                      Va(
                                                        Qe[d.ip].countryCode,
                                                        Qe[d.ip].countryName,
                                                      ),
                                                  ],
                                                }),
                                            ],
                                          }),
                                          l.jsxs("div", {
                                            className:
                                              "text-[10px] text-slate-400 mt-1 flex flex-wrap gap-x-3 gap-y-0.5",
                                            children: [
                                              l.jsxs("span", {
                                                children: [
                                                  l.jsx("span", {
                                                    className:
                                                      "font-bold text-slate-500",
                                                    children: "First Link:",
                                                  }),
                                                  " ",
                                                  vl(d.firstSeen),
                                                ],
                                              }),
                                              d.lastSeen > d.firstSeen &&
                                                l.jsxs("span", {
                                                  children: [
                                                    l.jsx("span", {
                                                      className:
                                                        "font-bold text-slate-500",
                                                      children: "Last Active:",
                                                    }),
                                                    " ",
                                                    vl(d.lastSeen),
                                                  ],
                                                }),
                                            ],
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className: "flex items-center gap-2.5",
                                    children: [
                                      l.jsxs("button", {
                                        type: "button",
                                        onClick: (p) => {
                                          (p.stopPropagation(), ba(d));
                                        },
                                        className:
                                          "px-2.5 py-1 text-[11px] font-black rounded-lg bg-red-950/50 border border-red-500/40 text-red-400 hover:bg-red-900/80 hover:border-red-500/70 transition-all cursor-pointer flex items-center gap-1 shadow-sm shrink-0",
                                        title:
                                          "Delete user and all associated links",
                                        children: [
                                          l.jsx(qa, { className: "w-3 h-3" }),
                                          l.jsx("span", {
                                            children: "Delete User",
                                          }),
                                        ],
                                      }),
                                      l.jsxs("span", {
                                        className:
                                          "bg-blue-500/10 border border-blue-500/20 text-blue-400 font-extrabold text-[11px] px-2.5 py-1 rounded-full",
                                        children: [
                                          d.links.length,
                                          " ",
                                          d.links.length === 1
                                            ? "link"
                                            : "links",
                                        ],
                                      }),
                                      S
                                        ? l.jsx(Px, {
                                            className: "w-4 h-4 text-slate-400",
                                          })
                                        : l.jsx(ar, {
                                            className: "w-4 h-4 text-slate-400",
                                          }),
                                    ],
                                  }),
                                ],
                              }),
                              S &&
                                l.jsx("div", {
                                  className:
                                    "border-t border-slate-800 bg-slate-950/40 p-4 sm:p-6 space-y-4",
                                  children:
                                    d.links.length === 0
                                      ? l.jsx("div", {
                                          className:
                                            "text-center py-4 text-xs text-slate-500 font-bold",
                                          children: "No links recorded.",
                                        })
                                      : it === "grid"
                                        ? l.jsx("div", {
                                            className: bs(Pe),
                                            children: d.links.map((p) => {
                                              const Q = `${window.location.origin}/?${p.code}`;
                                              return l.jsxs(
                                                "div",
                                                {
                                                  className: `rounded-xl p-4 flex gap-4 transition-all relative group border-2 ${Xt(p) ? "bg-emerald-800/60 border-emerald-400 hover:border-emerald-300" : "bg-[#0b1528]/80 border-slate-800/80 hover:border-slate-700"}`,
                                                  children: [
                                                    l.jsxs("div", {
                                                      className:
                                                        "w-16 h-16 sm:w-20 sm:h-20 bg-slate-900 border border-slate-800 rounded-lg shrink-0 overflow-hidden flex items-center justify-center relative",
                                                      children: [
                                                        l.jsx("div", {
                                                          className:
                                                            "absolute top-1 left-1 z-20 bg-slate-950/80 p-1 rounded border border-slate-800/40",
                                                          children: l.jsx(
                                                            "input",
                                                            {
                                                              type: "checkbox",
                                                              checked:
                                                                !!Pt[p.code],
                                                              onChange: () =>
                                                                ya(p.code),
                                                              className:
                                                                "w-3.5 h-3.5 accent-blue-500 cursor-pointer rounded",
                                                            },
                                                          ),
                                                        }),
                                                        p.image
                                                          ? l.jsx("img", {
                                                              src: p.image,
                                                              alt:
                                                                p.title ||
                                                                "Link preview",
                                                              referrerPolicy:
                                                                "no-referrer",
                                                              className:
                                                                "w-full h-full object-cover",
                                                              onError: (E) => {
                                                                E.target.src =
                                                                  "";
                                                              },
                                                            })
                                                          : l.jsx(Zr, {
                                                              className:
                                                                "w-6 h-6 text-slate-600",
                                                            }),
                                                        !p.image &&
                                                          l.jsx("div", {
                                                            className:
                                                              "absolute inset-0 bg-amber-500/5 flex items-center justify-center",
                                                            title:
                                                              "Missing Image",
                                                          }),
                                                      ],
                                                    }),
                                                    l.jsxs("div", {
                                                      className:
                                                        "flex-1 min-w-0 flex flex-col justify-between",
                                                      children: [
                                                        l.jsxs("div", {
                                                          children: [
                                                            l.jsxs("div", {
                                                              className:
                                                                "flex items-center gap-1.5 flex-wrap",
                                                              children: [
                                                                l.jsxs("a", {
                                                                  href: Q,
                                                                  target:
                                                                    "_blank",
                                                                  rel: "noopener noreferrer",
                                                                  className:
                                                                    "text-xs font-black text-blue-400 hover:underline font-mono tracking-tight flex items-center gap-1 shrink-0",
                                                                  children: [
                                                                    "/",
                                                                    p.code,
                                                                    l.jsx(tr, {
                                                                      className:
                                                                        "w-3 h-3",
                                                                    }),
                                                                  ],
                                                                }),
                                                                ht(
                                                                  p.store,
                                                                  p.resolvedUrl ||
                                                                    p.url,
                                                                  p.title,
                                                                  p.description,
                                                                ),
                                                                p.preview &&
                                                                  l.jsx(
                                                                    "span",
                                                                    {
                                                                      className:
                                                                        "bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[9px] px-1.5 py-0.2 rounded font-bold uppercase shrink-0",
                                                                      children:
                                                                        "Preview Mode",
                                                                    },
                                                                  ),
                                                                It(p.created),
                                                              ],
                                                            }),
                                                            l.jsx("h4", {
                                                              className:
                                                                "text-xs font-black text-white truncate mt-1",
                                                              children:
                                                                p.title ||
                                                                "Untitled Link",
                                                            }),
                                                            l.jsx("p", {
                                                              className:
                                                                "text-[11px] text-slate-400 line-clamp-1 mt-0.5",
                                                              children:
                                                                p.description ||
                                                                "No description provided.",
                                                            }),
                                                            l.jsxs("p", {
                                                              className:
                                                                "text-[10px] text-slate-500 truncate mt-1 font-mono hover:text-slate-300",
                                                              children: [
                                                                "→ ",
                                                                p.url,
                                                              ],
                                                            }),
                                                            (D === "archive" ||
                                                              D === "trash" ||
                                                              p.done ||
                                                              p.trashed) &&
                                                              l.jsxs("div", {
                                                                className:
                                                                  "mt-2 pt-1.5 flex flex-wrap items-center gap-1.5",
                                                                children: [
                                                                  l.jsxs(
                                                                    "span",
                                                                    {
                                                                      className:
                                                                        "text-[9px] font-extrabold text-slate-400 bg-slate-900 border border-slate-800 px-1 py-0.5 rounded shrink-0 font-mono",
                                                                      children:
                                                                        [
                                                                          "ID: ",
                                                                          l.jsx(
                                                                            "span",
                                                                            {
                                                                              className:
                                                                                "text-indigo-400 font-bold",
                                                                              children:
                                                                                p.creatorId ||
                                                                                "anonymous",
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  ),
                                                                  l.jsxs(
                                                                    "span",
                                                                    {
                                                                      className:
                                                                        "text-[9px] font-extrabold text-slate-400 bg-slate-900 border border-slate-800 px-1 py-0.5 rounded shrink-0 font-mono flex items-center gap-1",
                                                                      children:
                                                                        [
                                                                          "IP: ",
                                                                          l.jsx(
                                                                            "span",
                                                                            {
                                                                              className:
                                                                                "text-emerald-400 font-bold",
                                                                              children:
                                                                                p.creatorIp ||
                                                                                (p.creatorId
                                                                                  ? W[
                                                                                      p
                                                                                        .creatorId
                                                                                    ]
                                                                                      ?.ip
                                                                                  : null) ||
                                                                                p.ip ||
                                                                                "Unknown",
                                                                            },
                                                                          ),
                                                                          (() => {
                                                                            const E =
                                                                              p.creatorIp ||
                                                                              (p.creatorId
                                                                                ? W[
                                                                                    p
                                                                                      .creatorId
                                                                                  ]
                                                                                    ?.ip
                                                                                : null) ||
                                                                              p.ip;
                                                                            return E &&
                                                                              Qe[
                                                                                E
                                                                              ]
                                                                              ? Va(
                                                                                  Qe[
                                                                                    E
                                                                                  ]
                                                                                    .countryCode,
                                                                                  Qe[
                                                                                    E
                                                                                  ]
                                                                                    .countryName,
                                                                                )
                                                                              : null;
                                                                          })(),
                                                                        ],
                                                                    },
                                                                  ),
                                                                ],
                                                              }),
                                                          ],
                                                        }),
                                                        l.jsxs("div", {
                                                          className:
                                                            "flex items-center justify-between border-t border-slate-800/40 pt-2.5 mt-2.5",
                                                          children: [
                                                            l.jsx("span", {
                                                              className:
                                                                "text-[9px] font-semibold text-sky-300/90 font-mono",
                                                              children:
                                                                p.created
                                                                  ? vl(
                                                                      p.created,
                                                                    )
                                                                  : "Fallback Time",
                                                            }),
                                                            l.jsx("div", {
                                                              className:
                                                                "flex gap-2 flex-wrap",
                                                              children:
                                                                D === "trash"
                                                                  ? l.jsxs(
                                                                      l.Fragment,
                                                                      {
                                                                        children:
                                                                          [
                                                                            l.jsx(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    za(
                                                                                      p,
                                                                                      !1,
                                                                                    ),
                                                                                className:
                                                                                  "p-1 px-2 text-[10px] font-extrabold rounded bg-emerald-950/20 border border-emerald-500/10 text-emerald-400 hover:bg-emerald-950/50 hover:border-emerald-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                                title:
                                                                                  "Restore Link",
                                                                                children:
                                                                                  "Restore",
                                                                              },
                                                                            ),
                                                                            l.jsxs(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    ea(
                                                                                      p,
                                                                                    ),
                                                                                className:
                                                                                  "p-1 px-2 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                                                children:
                                                                                  [
                                                                                    l.jsx(
                                                                                      er,
                                                                                      {
                                                                                        className:
                                                                                          "w-2.5 h-2.5",
                                                                                      },
                                                                                    ),
                                                                                    "View",
                                                                                  ],
                                                                              },
                                                                            ),
                                                                            l.jsxs(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    Lt(
                                                                                      p.code,
                                                                                    ),
                                                                                className:
                                                                                  "p-1 px-2 text-[10px] font-extrabold rounded bg-red-950/20 border border-red-500/10 text-red-400 hover:bg-red-950/50 hover:border-red-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                                title:
                                                                                  "Delete Permanently",
                                                                                children:
                                                                                  [
                                                                                    l.jsx(
                                                                                      qa,
                                                                                      {
                                                                                        className:
                                                                                          "w-2.5 h-2.5",
                                                                                      },
                                                                                    ),
                                                                                    "Delete",
                                                                                  ],
                                                                              },
                                                                            ),
                                                                          ],
                                                                      },
                                                                    )
                                                                  : l.jsxs(
                                                                      l.Fragment,
                                                                      {
                                                                        children:
                                                                          [
                                                                            l.jsxs(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    Ql(
                                                                                      p.code,
                                                                                    ),
                                                                                className: `p-1 px-2 text-[10px] font-extrabold rounded border transition-all cursor-pointer flex items-center gap-1 ${we[p.code] ? "bg-violet-950/40 border-violet-500/20 text-violet-400 hover:bg-violet-900/40" : "bg-slate-900 border-slate-800 text-slate-400 hover:text-white hover:bg-slate-800"}`,
                                                                                title:
                                                                                  we[
                                                                                    p
                                                                                      .code
                                                                                  ]
                                                                                    ? "Mark as Unreviewed"
                                                                                    : "Mark as Reviewed",
                                                                                children:
                                                                                  [
                                                                                    l.jsx(
                                                                                      ms,
                                                                                      {
                                                                                        className:
                                                                                          "w-2.5 h-2.5",
                                                                                      },
                                                                                    ),
                                                                                    we[
                                                                                      p
                                                                                        .code
                                                                                    ]
                                                                                      ? "Reviewed"
                                                                                      : "Review",
                                                                                  ],
                                                                              },
                                                                            ),
                                                                            l.jsxs(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    ea(
                                                                                      p,
                                                                                    ),
                                                                                className:
                                                                                  "p-1 px-2 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                                                children:
                                                                                  [
                                                                                    l.jsx(
                                                                                      er,
                                                                                      {
                                                                                        className:
                                                                                          "w-2.5 h-2.5",
                                                                                      },
                                                                                    ),
                                                                                    "View",
                                                                                  ],
                                                                              },
                                                                            ),
                                                                            l.jsxs(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    kl(
                                                                                      p,
                                                                                    ),
                                                                                className:
                                                                                  "p-1 px-2 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                                                children:
                                                                                  [
                                                                                    l.jsx(
                                                                                      ci,
                                                                                      {
                                                                                        className:
                                                                                          "w-2.5 h-2.5",
                                                                                      },
                                                                                    ),
                                                                                    "Edit",
                                                                                  ],
                                                                              },
                                                                            ),
                                                                            l.jsx(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    za(
                                                                                      p,
                                                                                      !0,
                                                                                    ),
                                                                                className:
                                                                                  "p-1 px-2 text-[10px] font-extrabold rounded bg-amber-950/20 border border-amber-500/10 text-amber-400 hover:bg-amber-950/50 hover:border-amber-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                                title:
                                                                                  "Move to Trash",
                                                                                children:
                                                                                  "Trash",
                                                                              },
                                                                            ),
                                                                            l.jsxs(
                                                                              "button",
                                                                              {
                                                                                onClick:
                                                                                  () =>
                                                                                    Lt(
                                                                                      p.code,
                                                                                    ),
                                                                                className:
                                                                                  "p-1 px-2 text-[10px] font-extrabold rounded bg-red-950/20 border border-red-500/10 text-red-400 hover:bg-red-950/50 hover:border-red-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                                children:
                                                                                  [
                                                                                    l.jsx(
                                                                                      qa,
                                                                                      {
                                                                                        className:
                                                                                          "w-2.5 h-2.5",
                                                                                      },
                                                                                    ),
                                                                                    "Delete",
                                                                                  ],
                                                                              },
                                                                            ),
                                                                          ],
                                                                      },
                                                                    ),
                                                            }),
                                                          ],
                                                        }),
                                                      ],
                                                    }),
                                                    l.jsxs("div", {
                                                      className:
                                                        "flex flex-col items-center justify-center px-3.5 py-2.5 rounded-xl bg-blue-950/40 border border-blue-800/40 text-blue-400 shrink-0 min-w-[72px] h-[72px] text-center self-center shadow-lg shadow-blue-950/20",
                                                      children: [
                                                        l.jsx("span", {
                                                          className:
                                                            "text-2xl font-black tracking-tight leading-none text-blue-300",
                                                          children:
                                                            p.clicks || 0,
                                                        }),
                                                        l.jsx("span", {
                                                          className:
                                                            "text-[9px] font-black text-blue-400 uppercase tracking-widest mt-1",
                                                          children: "CLICKS",
                                                        }),
                                                      ],
                                                    }),
                                                  ],
                                                },
                                                p.code,
                                              );
                                            }),
                                          })
                                        : l.jsx("div", {
                                            className: "space-y-2",
                                            children: d.links.map((p) => {
                                              const Q = `${window.location.origin}/?${p.code}`;
                                              return l.jsxs(
                                                "div",
                                                {
                                                  className:
                                                    "bg-[#0b1528]/50 border border-slate-800/60 rounded-xl p-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 hover:border-slate-700 transition-all group relative",
                                                  children: [
                                                    l.jsxs("div", {
                                                      className:
                                                        "flex items-center gap-3 min-w-0 flex-1",
                                                      children: [
                                                        l.jsx("input", {
                                                          type: "checkbox",
                                                          checked: !!Pt[p.code],
                                                          onChange: () =>
                                                            ya(p.code),
                                                          className:
                                                            "w-3.5 h-3.5 accent-blue-500 cursor-pointer rounded shrink-0",
                                                        }),
                                                        l.jsx("div", {
                                                          className:
                                                            "w-9 h-9 bg-slate-900 border border-slate-800 rounded-lg overflow-hidden shrink-0 flex items-center justify-center relative",
                                                          children: p.image
                                                            ? l.jsx("img", {
                                                                src: p.image,
                                                                alt: "",
                                                                referrerPolicy:
                                                                  "no-referrer",
                                                                className:
                                                                  "w-full h-full object-cover",
                                                                onError: (
                                                                  E,
                                                                ) => {
                                                                  E.target.src =
                                                                    "";
                                                                },
                                                              })
                                                            : l.jsx(Zr, {
                                                                className:
                                                                  "w-4 h-4 text-slate-600",
                                                              }),
                                                        }),
                                                        l.jsxs("div", {
                                                          className:
                                                            "min-w-0 flex-1",
                                                          children: [
                                                            l.jsxs("div", {
                                                              className:
                                                                "flex items-center gap-1.5 flex-wrap",
                                                              children: [
                                                                l.jsxs("a", {
                                                                  href: Q,
                                                                  target:
                                                                    "_blank",
                                                                  rel: "noopener noreferrer",
                                                                  className:
                                                                    "text-xs font-black text-blue-400 hover:underline font-mono tracking-tight flex items-center gap-1",
                                                                  children: [
                                                                    "/",
                                                                    p.code,
                                                                    l.jsx(tr, {
                                                                      className:
                                                                        "w-2.5 h-2.5",
                                                                    }),
                                                                  ],
                                                                }),
                                                                ht(
                                                                  p.store,
                                                                  p.resolvedUrl ||
                                                                    p.url,
                                                                  p.title,
                                                                  p.description,
                                                                ),
                                                                p.preview &&
                                                                  l.jsx(
                                                                    "span",
                                                                    {
                                                                      className:
                                                                        "bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[8px] px-1 rounded font-bold uppercase shrink-0",
                                                                      children:
                                                                        "Preview Mode",
                                                                    },
                                                                  ),
                                                                It(p.created),
                                                              ],
                                                            }),
                                                            l.jsxs("div", {
                                                              className:
                                                                "flex items-center gap-2 mt-0.5 min-w-0",
                                                              children: [
                                                                l.jsx("h4", {
                                                                  className:
                                                                    "text-xs font-bold text-white truncate max-w-[200px] sm:max-w-[350px]",
                                                                  children:
                                                                    p.title ||
                                                                    "Untitled",
                                                                }),
                                                                l.jsxs("span", {
                                                                  className:
                                                                    "text-[10px] text-slate-500 truncate hidden md:inline",
                                                                  children: [
                                                                    "→ ",
                                                                    p.url,
                                                                  ],
                                                                }),
                                                              ],
                                                            }),
                                                            (D === "archive" ||
                                                              D === "trash" ||
                                                              p.done ||
                                                              p.trashed) &&
                                                              l.jsxs("div", {
                                                                className:
                                                                  "mt-1 flex flex-wrap items-center gap-1.5",
                                                                children: [
                                                                  l.jsxs(
                                                                    "span",
                                                                    {
                                                                      className:
                                                                        "text-[9px] font-extrabold text-slate-400 bg-slate-900 border border-slate-800 px-1 py-0.5 rounded shrink-0 font-mono",
                                                                      children:
                                                                        [
                                                                          "ID: ",
                                                                          l.jsx(
                                                                            "span",
                                                                            {
                                                                              className:
                                                                                "text-indigo-400 font-bold",
                                                                              children:
                                                                                p.creatorId ||
                                                                                "anonymous",
                                                                            },
                                                                          ),
                                                                        ],
                                                                    },
                                                                  ),
                                                                  l.jsxs(
                                                                    "span",
                                                                    {
                                                                      className:
                                                                        "text-[9px] font-extrabold text-slate-400 bg-slate-900 border border-slate-800 px-1 py-0.5 rounded shrink-0 font-mono flex items-center gap-1",
                                                                      children:
                                                                        [
                                                                          "IP: ",
                                                                          l.jsx(
                                                                            "span",
                                                                            {
                                                                              className:
                                                                                "text-emerald-400 font-bold",
                                                                              children:
                                                                                p.creatorIp ||
                                                                                (p.creatorId
                                                                                  ? W[
                                                                                      p
                                                                                        .creatorId
                                                                                    ]
                                                                                      ?.ip
                                                                                  : null) ||
                                                                                p.ip ||
                                                                                "Unknown",
                                                                            },
                                                                          ),
                                                                          (() => {
                                                                            const E =
                                                                              p.creatorIp ||
                                                                              (p.creatorId
                                                                                ? W[
                                                                                    p
                                                                                      .creatorId
                                                                                  ]
                                                                                    ?.ip
                                                                                : null) ||
                                                                              p.ip;
                                                                            return E &&
                                                                              Qe[
                                                                                E
                                                                              ]
                                                                              ? Va(
                                                                                  Qe[
                                                                                    E
                                                                                  ]
                                                                                    .countryCode,
                                                                                  Qe[
                                                                                    E
                                                                                  ]
                                                                                    .countryName,
                                                                                )
                                                                              : null;
                                                                          })(),
                                                                        ],
                                                                    },
                                                                  ),
                                                                ],
                                                              }),
                                                          ],
                                                        }),
                                                      ],
                                                    }),
                                                    l.jsxs("div", {
                                                      className:
                                                        "flex flex-col items-center justify-center px-2.5 py-1 rounded-xl bg-blue-950/40 border border-blue-800/40 text-blue-400 shrink-0 min-w-[64px] h-[44px] text-center self-center shadow-md",
                                                      children: [
                                                        l.jsx("span", {
                                                          className:
                                                            "text-base font-black tracking-tight leading-none text-blue-300",
                                                          children:
                                                            p.clicks || 0,
                                                        }),
                                                        l.jsx("span", {
                                                          className:
                                                            "text-[7.5px] font-black text-blue-400 uppercase tracking-widest mt-0.5",
                                                          children: "CLICKS",
                                                        }),
                                                      ],
                                                    }),
                                                    l.jsxs("div", {
                                                      className:
                                                        "flex items-center gap-4 shrink-0 w-full sm:w-auto justify-between sm:justify-end border-t border-slate-800/40 sm:border-t-0 pt-2 sm:pt-0",
                                                      children: [
                                                        l.jsx("span", {
                                                          className:
                                                            "text-[10px] font-semibold text-sky-300/90 font-mono",
                                                          children: p.created
                                                            ? vl(p.created)
                                                            : "Fallback Time",
                                                        }),
                                                        l.jsx("div", {
                                                          className:
                                                            "flex gap-1.5 flex-wrap",
                                                          children:
                                                            D === "trash"
                                                              ? l.jsxs(
                                                                  l.Fragment,
                                                                  {
                                                                    children: [
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              za(
                                                                                p,
                                                                                !1,
                                                                              ),
                                                                          className:
                                                                            "p-1 px-1.5 text-[10px] font-extrabold rounded bg-emerald-950/20 border border-emerald-500/10 text-emerald-400 hover:bg-emerald-950/50 hover:border-emerald-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                          title:
                                                                            "Restore Link",
                                                                          children:
                                                                            "Restore",
                                                                        },
                                                                      ),
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              ea(
                                                                                p,
                                                                              ),
                                                                          className:
                                                                            "p-1 px-1.5 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                                          title:
                                                                            "View Details",
                                                                          children:
                                                                            l.jsx(
                                                                              er,
                                                                              {
                                                                                className:
                                                                                  "w-3 h-3",
                                                                              },
                                                                            ),
                                                                        },
                                                                      ),
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              Lt(
                                                                                p.code,
                                                                              ),
                                                                          className:
                                                                            "p-1 px-1.5 text-[10px] font-extrabold rounded bg-red-950/20 border border-red-500/10 text-red-400 hover:bg-red-950/50 hover:border-red-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                          title:
                                                                            "Delete Permanently",
                                                                          children:
                                                                            l.jsx(
                                                                              qa,
                                                                              {
                                                                                className:
                                                                                  "w-3 h-3",
                                                                              },
                                                                            ),
                                                                        },
                                                                      ),
                                                                    ],
                                                                  },
                                                                )
                                                              : l.jsxs(
                                                                  l.Fragment,
                                                                  {
                                                                    children: [
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              Ql(
                                                                                p.code,
                                                                              ),
                                                                          className: `p-1 px-1.5 text-[10px] font-extrabold rounded border transition-all cursor-pointer flex items-center gap-1 ${we[p.code] ? "bg-violet-950/40 border-violet-500/20 text-violet-400 hover:bg-violet-900/40" : "bg-slate-900 border-slate-800 text-slate-400 hover:text-white hover:bg-slate-800"}`,
                                                                          title:
                                                                            we[
                                                                              p
                                                                                .code
                                                                            ]
                                                                              ? "Mark as Unreviewed"
                                                                              : "Mark as Reviewed",
                                                                          children:
                                                                            l.jsx(
                                                                              ms,
                                                                              {
                                                                                className:
                                                                                  "w-3 h-3",
                                                                              },
                                                                            ),
                                                                        },
                                                                      ),
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              ea(
                                                                                p,
                                                                              ),
                                                                          className:
                                                                            "p-1 px-1.5 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                                          title:
                                                                            "View Details",
                                                                          children:
                                                                            l.jsx(
                                                                              er,
                                                                              {
                                                                                className:
                                                                                  "w-3 h-3",
                                                                              },
                                                                            ),
                                                                        },
                                                                      ),
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              kl(
                                                                                p,
                                                                              ),
                                                                          className:
                                                                            "p-1 px-1.5 text-[10px] font-extrabold rounded bg-slate-900 border border-slate-800 text-slate-300 hover:text-white hover:bg-slate-800 transition-all cursor-pointer flex items-center gap-1",
                                                                          title:
                                                                            "Edit Link",
                                                                          children:
                                                                            l.jsx(
                                                                              ci,
                                                                              {
                                                                                className:
                                                                                  "w-3 h-3",
                                                                              },
                                                                            ),
                                                                        },
                                                                      ),
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              za(
                                                                                p,
                                                                                !0,
                                                                              ),
                                                                          className:
                                                                            "p-1 px-1.5 text-[10px] font-extrabold rounded bg-amber-950/20 border border-amber-500/10 text-amber-400 hover:bg-amber-950/50 hover:border-amber-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                          title:
                                                                            "Move to Trash",
                                                                          children:
                                                                            "Trash",
                                                                        },
                                                                      ),
                                                                      l.jsx(
                                                                        "button",
                                                                        {
                                                                          onClick:
                                                                            () =>
                                                                              Lt(
                                                                                p.code,
                                                                              ),
                                                                          className:
                                                                            "p-1 px-1.5 text-[10px] font-extrabold rounded bg-red-950/20 border border-red-500/10 text-red-400 hover:bg-red-950/50 hover:border-red-500/30 transition-all cursor-pointer flex items-center gap-1",
                                                                          title:
                                                                            "Delete Link",
                                                                          children:
                                                                            l.jsx(
                                                                              qa,
                                                                              {
                                                                                className:
                                                                                  "w-3 h-3",
                                                                              },
                                                                            ),
                                                                        },
                                                                      ),
                                                                    ],
                                                                  },
                                                                ),
                                                        }),
                                                      ],
                                                    }),
                                                  ],
                                                },
                                                p.code,
                                              );
                                            }),
                                          }),
                                }),
                            ],
                          },
                          d.creatorId,
                        );
                      }),
                    }),
                ],
              }),
              $a &&
                l.jsx("div", {
                  className:
                    "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4",
                  children: l.jsxs("div", {
                    className:
                      "bg-[#0b1528] border border-slate-800 rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden",
                    children: [
                      l.jsxs("div", {
                        className:
                          "px-6 py-4 border-b border-slate-800 flex justify-between items-center bg-[#070e1b]",
                        children: [
                          l.jsxs("h3", {
                            className:
                              "font-extrabold text-sm text-white flex items-center gap-2",
                            children: [
                              "✏️ Edit Shortlink ",
                              l.jsxs("span", {
                                className: "font-mono text-blue-400",
                                children: ["/", $a.code],
                              }),
                            ],
                          }),
                          l.jsx("button", {
                            onClick: () => gs(null),
                            className:
                              "text-slate-400 hover:text-white transition-all cursor-pointer p-1.5 rounded-lg hover:bg-slate-800",
                            children: l.jsx(hs, { className: "w-4 h-4" }),
                          }),
                        ],
                      }),
                      l.jsxs("form", {
                        onSubmit: Da,
                        className: "p-6 space-y-4",
                        children: [
                          hl &&
                            l.jsxs("div", {
                              className:
                                "bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 p-3 rounded-lg text-xs font-bold flex items-center gap-2",
                              children: [
                                l.jsx(ms, { className: "w-4 h-4 shrink-0" }),
                                hl,
                              ],
                            }),
                          Fl &&
                            l.jsxs("div", {
                              className:
                                "bg-red-500/10 border border-red-500/20 text-red-400 p-3 rounded-lg text-xs font-bold flex items-center gap-2",
                              children: [
                                l.jsx(ii, { className: "w-4 h-4 shrink-0" }),
                                Fl,
                              ],
                            }),
                          l.jsxs("div", {
                            onClick: () => Ja(!ga),
                            className:
                              "flex items-center gap-3 bg-violet-950/20 border border-violet-500/20 p-3.5 rounded-xl select-none mb-4 cursor-pointer hover:bg-violet-950/30 transition-all",
                            children: [
                              l.jsx("input", {
                                type: "checkbox",
                                id: "doneCheckbox",
                                checked: ga,
                                onChange: (d) => Ja(d.target.checked),
                                onClick: (d) => d.stopPropagation(),
                                className:
                                  "w-4 h-4 accent-violet-500 cursor-pointer rounded",
                              }),
                              l.jsxs("label", {
                                htmlFor: "doneCheckbox",
                                className:
                                  "text-xs font-extrabold text-white cursor-pointer flex-1",
                                children: [
                                  "DONE (Archive / Mark as Finished)",
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] font-normal text-slate-400 mt-0.5",
                                    children:
                                      "Ticking this hides the link from the main ledger and moves it to the archive",
                                  }),
                                ],
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-1",
                                children: "Link Title",
                              }),
                              l.jsx("input", {
                                type: "text",
                                value: ul,
                                onChange: (d) => $t(d.target.value),
                                placeholder: "e.g. Awesome Crypto Deal",
                                className:
                                  "w-full bg-slate-950 border border-slate-800 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 rounded-xl px-4 py-2 text-xs text-white placeholder-slate-600 outline-none transition-all",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-1",
                                children: "Destination URL *",
                              }),
                              l.jsx("input", {
                                type: "url",
                                value: bt,
                                onChange: (d) => zt(d.target.value),
                                required: !0,
                                placeholder:
                                  "https://example.com/long-tracking-url",
                                className:
                                  "w-full bg-slate-950 border border-slate-800 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 rounded-xl px-4 py-2 text-xs text-white placeholder-slate-600 outline-none transition-all font-mono",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-1",
                                children: "Thumbnail Image URL (or blank)",
                              }),
                              l.jsx("input", {
                                type: "text",
                                value: vs,
                                onChange: (d) => Qa(d.target.value),
                                placeholder: "https://example.com/image.png",
                                className:
                                  "w-full bg-slate-950 border border-slate-800 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 rounded-xl px-4 py-2 text-xs text-white placeholder-slate-600 outline-none transition-all font-mono",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-1",
                                children: "Description Text",
                              }),
                              l.jsx("textarea", {
                                value: Il,
                                onChange: (d) => Ka(d.target.value),
                                rows: 2,
                                placeholder:
                                  "Description showing on social preview card...",
                                className:
                                  "w-full bg-slate-950 border border-slate-800 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 rounded-xl px-4 py-2 text-xs text-white placeholder-slate-600 outline-none transition-all",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("label", {
                                className:
                                  "block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-1",
                                children: "Target Store Badge / Brand",
                              }),
                              l.jsxs("select", {
                                value: pl,
                                onChange: (d) => ql(d.target.value),
                                className:
                                  "w-full bg-slate-950 border border-slate-800 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 rounded-xl px-4 py-2 text-xs text-white outline-none transition-all cursor-pointer",
                                children: [
                                  l.jsx("option", {
                                    value: "other",
                                    children: "Other / General",
                                  }),
                                  l.jsx("option", {
                                    value: "walmart",
                                    children: "Walmart",
                                  }),
                                  l.jsx("option", {
                                    value: "amazon",
                                    children: "Amazon",
                                  }),
                                  l.jsx("option", {
                                    value: "ebay",
                                    children: "eBay",
                                  }),
                                  l.jsx("option", {
                                    value: "etsy",
                                    children: "Etsy",
                                  }),
                                ],
                              }),
                              l.jsx("span", {
                                className:
                                  "block text-[10px] text-slate-500 mt-1",
                                children:
                                  "If auto-detection fails (e.g. for shortlinks), you can override the store logo badge here",
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            className:
                              "flex items-center justify-between bg-slate-950 border border-slate-800 p-3 rounded-xl select-none",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "block text-xs font-extrabold text-white",
                                    children:
                                      "Social Preview Interstitial Mode",
                                  }),
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] text-slate-500 mt-0.5",
                                    children:
                                      "Force a clean visual preview page before final redirect",
                                  }),
                                ],
                              }),
                              l.jsx("button", {
                                type: "button",
                                onClick: () => Za(!Wt),
                                className: `relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${Wt ? "bg-blue-500" : "bg-slate-800"}`,
                                children: l.jsx("span", {
                                  className: `pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${Wt ? "translate-x-5" : "translate-x-0"}`,
                                }),
                              }),
                            ],
                          }),
                          Wt &&
                            l.jsxs("div", {
                              className:
                                "bg-slate-950/60 border border-slate-800/85 p-3.5 rounded-xl space-y-3 animate-[revealUp_0.15s_ease-out] text-left",
                              children: [
                                l.jsxs("div", {
                                  children: [
                                    l.jsx("label", {
                                      className:
                                        "block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-1",
                                      children:
                                        "Redirect Page Custom Description",
                                    }),
                                    l.jsx("textarea", {
                                      value: Wa,
                                      onChange: (d) => Pa(d.target.value),
                                      rows: 2,
                                      placeholder:
                                        "e.g. 🔥 Almost gone — tap Continue before it sells out.",
                                      className:
                                        "w-full bg-slate-950 border border-slate-800 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 rounded-xl px-4 py-2 text-xs text-white placeholder-slate-600 outline-none transition-all",
                                    }),
                                  ],
                                }),
                                l.jsxs("div", {
                                  children: [
                                    l.jsx("label", {
                                      className:
                                        "block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-1",
                                      children: "Redirect Page Accent Color",
                                    }),
                                    l.jsxs("div", {
                                      className: "flex items-center gap-2",
                                      children: [
                                        l.jsx("input", {
                                          type: "color",
                                          value: xl,
                                          onChange: (d) => fl(d.target.value),
                                          className:
                                            "w-8 h-8 rounded border border-slate-800 bg-transparent cursor-pointer overflow-hidden p-0",
                                        }),
                                        l.jsx("span", {
                                          className:
                                            "font-mono text-xs text-slate-300 uppercase",
                                          children: xl,
                                        }),
                                      ],
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          l.jsxs("div", {
                            className: "flex gap-3 pt-2",
                            children: [
                              l.jsx("button", {
                                type: "button",
                                onClick: () => gs(null),
                                className:
                                  "flex-1 py-2.5 rounded-xl border border-slate-850 hover:bg-slate-900 text-slate-300 text-xs font-extrabold cursor-pointer transition-all",
                                children: "Cancel",
                              }),
                              l.jsx("button", {
                                type: "submit",
                                disabled: Vs,
                                className:
                                  "flex-1 py-2.5 rounded-xl bg-gradient-to-tr from-blue-500 to-indigo-600 hover:brightness-110 text-white text-xs font-extrabold disabled:opacity-50 cursor-pointer transition-all shadow-md flex items-center justify-center gap-1.5",
                                children: Vs ? "Saving..." : "Save Changes",
                              }),
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                }),
              ys &&
                l.jsx("div", {
                  className:
                    "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4",
                  children: l.jsxs("div", {
                    className:
                      "bg-[#0b1528] border border-red-500/20 rounded-2xl w-full max-w-sm shadow-2xl overflow-hidden p-6 text-center space-y-4",
                    children: [
                      l.jsx("div", {
                        className:
                          "w-12 h-12 bg-red-500/10 border border-red-500/20 text-red-500 rounded-full flex items-center justify-center text-lg mx-auto",
                        children: "⚠️",
                      }),
                      l.jsxs("div", {
                        children: [
                          l.jsx("h3", {
                            className: "font-extrabold text-sm text-white",
                            children: "Delete Shortlink?",
                          }),
                          l.jsxs("p", {
                            className: "text-xs text-slate-400 mt-1.5",
                            children: [
                              "Are you sure you want to permanently delete ",
                              l.jsxs("span", {
                                className: "font-mono font-bold text-red-400",
                                children: ["/", ys],
                              }),
                              "? This action is irreversible and will also decrement the user's active link count.",
                            ],
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className: "flex gap-3 pt-2",
                        children: [
                          l.jsx("button", {
                            disabled: ft,
                            onClick: () => Lt(null),
                            className:
                              "flex-1 py-2 rounded-xl border border-slate-800 hover:bg-slate-900 text-slate-300 text-xs font-bold cursor-pointer transition-all",
                            children: "Cancel",
                          }),
                          l.jsx("button", {
                            disabled: ft,
                            onClick: () => Ul(ys),
                            className:
                              "flex-1 py-2 rounded-xl bg-red-600 hover:bg-red-500 text-white text-xs font-bold disabled:opacity-50 cursor-pointer transition-all shadow-md",
                            children: ft ? "Deleting..." : "Delete Permanently",
                          }),
                        ],
                      }),
                    ],
                  }),
                }),
              gn &&
                l.jsx("div", {
                  className:
                    "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4",
                  children: l.jsxs("div", {
                    className:
                      "bg-[#0b1528] border border-red-500/20 rounded-2xl w-full max-w-sm shadow-2xl overflow-hidden p-6 text-center space-y-4",
                    children: [
                      l.jsx("div", {
                        className:
                          "w-12 h-12 bg-red-500/10 border border-red-500/20 text-red-500 rounded-full flex items-center justify-center text-lg mx-auto",
                        children: "⚠️",
                      }),
                      l.jsxs("div", {
                        children: [
                          l.jsx("h3", {
                            className: "font-extrabold text-sm text-white",
                            children: "Delete Selected Links?",
                          }),
                          l.jsxs("p", {
                            className: "text-xs text-slate-400 mt-1.5",
                            children: [
                              "Are you sure you want to permanently delete the ",
                              l.jsx("span", {
                                className: "font-mono font-bold text-red-400",
                                children: aa,
                              }),
                              " selected links? This action is irreversible and will also decrement their creators' active link counts.",
                            ],
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className: "flex gap-3 pt-2",
                        children: [
                          l.jsx("button", {
                            disabled: el,
                            onClick: () => gl(!1),
                            className:
                              "flex-1 py-2 rounded-xl border border-slate-800 hover:bg-slate-900 text-slate-300 text-xs font-bold cursor-pointer transition-all",
                            children: "Cancel",
                          }),
                          l.jsx("button", {
                            disabled: el,
                            onClick: _a,
                            className:
                              "flex-1 py-2 rounded-xl bg-red-600 hover:bg-red-500 text-white text-xs font-bold disabled:opacity-50 cursor-pointer transition-all shadow-md",
                            children: el ? "Deleting..." : "Delete Selected",
                          }),
                        ],
                      }),
                    ],
                  }),
                }),
              qe &&
                l.jsx("div", {
                  className:
                    "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4",
                  children: l.jsxs("div", {
                    className:
                      "bg-[#0b1528] border border-slate-800 rounded-2xl w-full max-w-xl shadow-2xl overflow-hidden",
                    children: [
                      l.jsxs("div", {
                        className:
                          "px-6 py-4 border-b border-slate-800 flex justify-between items-center bg-[#070e1b]",
                        children: [
                          l.jsxs("h3", {
                            className:
                              "font-extrabold text-sm text-white flex items-center gap-2",
                            children: [
                              "🔍 Shortlink Details ",
                              l.jsxs("span", {
                                className: "font-mono text-blue-400",
                                children: ["/", qe.code],
                              }),
                            ],
                          }),
                          l.jsx("button", {
                            onClick: () => {
                              (ea(null), ua(!1));
                            },
                            className:
                              "text-slate-400 hover:text-white transition-all cursor-pointer p-1.5 rounded-lg hover:bg-slate-800",
                            children: l.jsx(hs, { className: "w-4 h-4" }),
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className: "p-6 space-y-6 max-h-[80vh] overflow-y-auto",
                        children: [
                          l.jsxs("div", {
                            className:
                              "bg-slate-950 p-4 rounded-xl border border-slate-800 flex flex-col sm:flex-row sm:items-center justify-between gap-3",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-0.5",
                                    children: "Short URL",
                                  }),
                                  l.jsx("span", {
                                    className:
                                      "font-mono text-xs text-blue-400 font-extrabold break-all",
                                    children: `${window.location.origin}/?${qe.code}`,
                                  }),
                                ],
                              }),
                              l.jsx("button", {
                                type: "button",
                                onClick: async () => {
                                  try {
                                    (await navigator.clipboard.writeText(
                                      `${window.location.origin}/?${qe.code}`,
                                    ),
                                      ua(!0),
                                      setTimeout(() => ua(!1), 2e3));
                                  } catch (d) {
                                    console.error("Copy failed", d);
                                  }
                                },
                                className:
                                  "px-4 py-2 bg-gradient-to-tr from-blue-500 to-indigo-600 hover:brightness-110 text-white text-xs font-extrabold rounded-lg transition-all flex items-center justify-center gap-1.5 shadow",
                                children: Vl
                                  ? l.jsxs(l.Fragment, {
                                      children: [
                                        l.jsx(ms, { className: "w-3.5 h-3.5" }),
                                        "Copied!",
                                      ],
                                    })
                                  : l.jsxs(l.Fragment, {
                                      children: [
                                        l.jsx(ui, { className: "w-3.5 h-3.5" }),
                                        "Copy Short Link",
                                      ],
                                    }),
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                    children: "Link Title",
                                  }),
                                  l.jsx("span", {
                                    className:
                                      "text-xs text-white font-extrabold block bg-slate-950/40 p-2.5 rounded-lg border border-slate-900 truncate",
                                    children: qe.title || "Untitled Link",
                                  }),
                                ],
                              }),
                              l.jsxs("div", {
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                    children: "Creator ID",
                                  }),
                                  l.jsx("span", {
                                    className:
                                      "text-xs text-slate-300 font-mono block bg-slate-950/40 p-2.5 rounded-lg border border-slate-900 truncate",
                                    title: qe.creatorId,
                                    children: qe.creatorId || "Anonymous",
                                  }),
                                ],
                              }),
                              l.jsxs("div", {
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                    children: "Created Time",
                                  }),
                                  l.jsx("span", {
                                    className:
                                      "text-xs text-slate-300 block bg-slate-950/40 p-2.5 rounded-lg border border-slate-900 font-mono",
                                    children: qe.created
                                      ? vl(qe.created)
                                      : "Unknown",
                                  }),
                                ],
                              }),
                              l.jsxs("div", {
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                    children: "Social Preview Flag",
                                  }),
                                  l.jsxs("span", {
                                    className: `text-xs font-bold inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg ${qe.preview ? "bg-emerald-500/10 border border-emerald-500/20 text-emerald-400" : "bg-slate-900 border border-slate-800 text-slate-400"}`,
                                    children: [
                                      l.jsx("span", {
                                        className: `w-1.5 h-1.5 rounded-full ${qe.preview ? "bg-emerald-400 animate-pulse" : "bg-slate-500"}`,
                                      }),
                                      qe.preview
                                        ? "Interstitial Enabled"
                                        : "Instant Redirect",
                                    ],
                                  }),
                                ],
                              }),
                            ],
                          }),
                          l.jsxs("div", {
                            children: [
                              l.jsx("span", {
                                className:
                                  "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                children: "Destination URL",
                              }),
                              l.jsxs("div", {
                                className:
                                  "bg-slate-950/40 p-3 rounded-lg border border-slate-900 flex items-center justify-between gap-3",
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "text-xs text-slate-300 font-mono break-all line-clamp-2",
                                    children: qe.url,
                                  }),
                                  l.jsx("a", {
                                    href: qe.url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className:
                                      "p-1.5 hover:bg-slate-850 rounded text-blue-400 hover:text-blue-300 shrink-0",
                                    title: "Open Destination",
                                    children: l.jsx(tr, {
                                      className: "w-4 h-4",
                                    }),
                                  }),
                                ],
                              }),
                            ],
                          }),
                          qe.resolvedUrl &&
                            qe.resolvedUrl !== qe.url &&
                            l.jsxs("div", {
                              children: [
                                l.jsx("span", {
                                  className:
                                    "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                  children: "Resolved Destination URL",
                                }),
                                l.jsxs("div", {
                                  className:
                                    "bg-slate-950/40 p-3 rounded-lg border border-slate-900 flex items-center justify-between gap-3",
                                  children: [
                                    l.jsx("span", {
                                      className:
                                        "text-xs text-slate-300 font-mono break-all line-clamp-2",
                                      children: qe.resolvedUrl,
                                    }),
                                    l.jsx("a", {
                                      href: qe.resolvedUrl,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      className:
                                        "p-1.5 hover:bg-slate-850 rounded text-blue-400 hover:text-blue-300 shrink-0",
                                      title: "Open Resolved Destination",
                                      children: l.jsx(tr, {
                                        className: "w-4 h-4",
                                      }),
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          l.jsxs("div", {
                            className:
                              "border-t border-slate-800/60 pt-4 grid grid-cols-1 sm:grid-cols-[140px_1fr] gap-4",
                            children: [
                              l.jsxs("div", {
                                children: [
                                  l.jsx("span", {
                                    className:
                                      "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                    children: "Thumbnail Image",
                                  }),
                                  l.jsx("div", {
                                    className:
                                      "w-full h-28 bg-slate-950 border border-slate-850 rounded-xl overflow-hidden flex items-center justify-center relative",
                                    children: qe.image
                                      ? l.jsx("img", {
                                          src: qe.image,
                                          alt: "Scraped Preview",
                                          referrerPolicy: "no-referrer",
                                          className:
                                            "w-full h-full object-cover",
                                        })
                                      : l.jsx(Zr, {
                                          className: "w-8 h-8 text-slate-700",
                                        }),
                                  }),
                                ],
                              }),
                              l.jsxs("div", {
                                className: "space-y-3",
                                children: [
                                  l.jsxs("div", {
                                    children: [
                                      l.jsx("span", {
                                        className:
                                          "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                        children: "Scraped Description",
                                      }),
                                      l.jsx("p", {
                                        className:
                                          "text-xs text-slate-300 bg-slate-950/40 p-2.5 rounded-lg border border-slate-900 line-clamp-3",
                                        children:
                                          qe.description ||
                                          "No description scraped or provided.",
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    children: [
                                      l.jsx("span", {
                                        className:
                                          "block text-[10px] font-extrabold text-slate-500 uppercase tracking-wider mb-1",
                                        children: "Thumbnail URL",
                                      }),
                                      l.jsx("span", {
                                        className:
                                          "text-[10px] text-slate-400 font-mono bg-slate-950/40 p-2.5 rounded-lg border border-slate-900 truncate block",
                                        children: qe.image || "None",
                                      }),
                                    ],
                                  }),
                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                      l.jsx("div", {
                        className:
                          "px-6 py-4 border-t border-slate-800 bg-[#070e1b] flex justify-end",
                        children: l.jsx("button", {
                          onClick: () => {
                            (ea(null), ua(!1));
                          },
                          className:
                            "px-5 py-2 rounded-xl bg-slate-900 border border-slate-800 hover:bg-slate-800 text-slate-200 text-xs font-extrabold transition-all cursor-pointer",
                          children: "Close details",
                        }),
                      }),
                    ],
                  }),
                }),
              St &&
                l.jsx("div", {
                  className:
                    "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4",
                  children: l.jsxs("div", {
                    className:
                      "bg-[#0b1528] border border-red-500/30 rounded-2xl w-full max-w-md p-6 shadow-2xl",
                    children: [
                      l.jsxs("h3", {
                        className:
                          "text-base font-black text-red-400 mb-2 flex items-center gap-2",
                        children: [
                          l.jsx(qa, { className: "w-5 h-5" }),
                          l.jsx("span", { children: "Confirm User Deletion" }),
                        ],
                      }),
                      l.jsxs("p", {
                        className:
                          "text-xs text-slate-300 leading-relaxed mb-4",
                        children: [
                          "Are you sure you want to completely delete user ",
                          l.jsx("span", {
                            className: "font-bold text-white",
                            children: St.label,
                          }),
                          " (",
                          l.jsx("span", {
                            className: "font-mono text-indigo-400",
                            children: St.creatorId,
                          }),
                          ") and all their ",
                          l.jsxs("span", {
                            className: "font-bold text-white",
                            children: [
                              St.links.length,
                              " link",
                              St.links.length === 1 ? "" : "s",
                            ],
                          }),
                          "?",
                        ],
                      }),
                      l.jsx("p", {
                        className:
                          "text-[11px] text-amber-400/90 bg-amber-950/40 border border-amber-500/20 p-2.5 rounded-lg mb-6",
                        children:
                          "⚠️ This will delete the user record from Firebase so they do not reappear as empty.",
                      }),
                      l.jsxs("div", {
                        className: "flex gap-3",
                        children: [
                          l.jsx("button", {
                            disabled: Vt,
                            onClick: () => ba(null),
                            className:
                              "flex-1 py-2.5 rounded-xl bg-slate-900 border border-slate-800 hover:bg-slate-800 text-slate-300 text-xs font-bold transition-all cursor-pointer",
                            children: "Cancel",
                          }),
                          l.jsx("button", {
                            disabled: Vt,
                            onClick: Kl,
                            className:
                              "flex-1 py-2.5 rounded-xl bg-red-600 hover:bg-red-500 text-white text-xs font-bold disabled:opacity-50 transition-all cursor-pointer shadow-lg shadow-red-950/50 flex items-center justify-center gap-2",
                            children: Vt
                              ? "Deleting User..."
                              : "Delete User & All Links",
                          }),
                        ],
                      }),
                    ],
                  }),
                }),
            ],
          }),
      f &&
        l.jsx(sf, {
          settings: f,
          onSave: h || (() => {}),
          onReset: I || (() => {}),
          isOpen: j,
          onClose: () => se(!1),
        }),
    ],
  });
}
const $x = [
    {
      id: "mavely",
      name: "Mavely",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-blue-600 text-white",
      descriptionEn:
        "Monetize & shorten affiliate links with real-time conversion and commission tracking.",
      descriptionAr:
        "اختصار وتحويل روابط عمولة Mavely مع تتبع المبيعات والأرباح بدقة.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z",
          }),
        }),
    },
    {
      id: "shopyoulikes",
      name: "ShopYouLikes",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-gradient-to-tr from-emerald-600 to-teal-500 text-white",
      descriptionEn:
        "Create clean short links for fashion, lifestyle, and retail affiliate campaigns.",
      descriptionAr:
        "إنشاء روابط قصيرة أنيقة لحملات التسويق بالعمولة والأزياء.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12 2l2.4 7.4h7.8l-6.3 4.6 2.4 7.4-6.3-4.6-6.3 4.6 2.4-7.4-6.3-4.6h7.8z",
          }),
        }),
    },
    {
      id: "collectivevoice",
      name: "Collective Voice",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-purple-600 text-white",
      descriptionEn:
        "Shorten ShopStyle / Collective Voice product links for content creators.",
      descriptionAr: "اختصار روابط المنتجات لصناع المحتوى والإنفلونسرز بسهولة.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none",
          }),
        }),
    },
    {
      id: "amazon",
      name: "Amazon Associates",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-[#232F3E] text-[#FF9900]",
      descriptionEn:
        "Seamless short link redirection for Amazon store products and deals.",
      descriptionAr: "توجيه واختصار روابط أمازون للمنتجات والعروض بضغط واحدة.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M13.25 15.65c-2.31 1.7-5.58 2.05-8.38 1.05-.39-.14-.84.15-.71.55.76 2.37 3.52 3.63 5.92 3.63 2.91 0 5.62-1.31 7.47-3.41.31-.35 0-.82-.44-.65-.77.29-2.61.34-3.86-1.17zm8.13-1.68c-.37-.48-2.42-.23-3.32-.12-.27.03-.31-.22-.07-.38 1.55-1.07 4.09-.76 4.38-.39.29.38-.11 2.95-1.58 4.14-.23.19-.44.08-.34-.17.33-.82.93-2.6.93-3.08zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.87 11.23c-.76.67-1.74.88-2.68.88-1.52 0-2.8-.75-2.8-2.22 0-1.89 1.78-2.58 3.51-2.58.55 0 1.25.06 1.77.17v-.31c0-.75-.48-1.2-1.42-1.2-.84 0-1.65.23-2.19.53-.16.09-.34-.04-.3-.22l.27-1.13c.04-.16.2-.26.36-.18.73.34 1.83.56 2.89.56 2.08 0 3.25.96 3.25 3.06v3.78c0 .87.35 1.26.7 1.7.12.15.01.37-.18.37h-1.28c-.28 0-.46-.18-.58-.39l-.3-.52z",
          }),
        }),
    },
    {
      id: "walmart",
      name: "Walmart Affiliate",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-[#0071CE] text-[#FFC220]",
      descriptionEn:
        "High-conversion link optimization for Walmart creator networks.",
      descriptionAr: "تحسين وروابط سريعة لحملات التسويق لمنتجات وول مارت.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12 2l1.8 4.6L18.4 5l-2.2 4.4 4.8 1.2-4.4 2.2 2.2 4.4-4.6-1.8L12 22l-1.8-4.6L5.6 19l2.2-4.4-4.8-1.2 4.4-2.2-2.2-4.4 4.6 1.8z",
          }),
        }),
    },
    {
      id: "ltk",
      name: "LTK (RewardStyle)",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-rose-600 text-white",
      descriptionEn:
        "Creator-first short links for LTK feeds and shopping lookbooks.",
      descriptionAr: "روابط قصيرة موجهة لكتالوجات LTK وإطلالات الموضة.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z",
          }),
        }),
    },
    {
      id: "impact",
      name: "Impact Radius",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-indigo-600 text-white",
      descriptionEn:
        "Direct link tracking with deep attribution for Impact brand partnerships.",
      descriptionAr: "تتبع مباشر للروابط المباشرة لشراكات ماركات Impact.",
      renderIcon: () =>
        l.jsxs("svg", {
          className: "w-6 h-6 fill-none stroke-current",
          strokeWidth: "2.5",
          viewBox: "0 0 24 24",
          children: [
            l.jsx("circle", { cx: "12", cy: "12", r: "9" }),
            l.jsx("circle", { cx: "12", cy: "12", r: "5" }),
            l.jsx("circle", {
              cx: "12",
              cy: "12",
              r: "1",
              fill: "currentColor",
            }),
          ],
        }),
    },
    {
      id: "cj",
      name: "CJ Affiliate",
      category: "affiliate",
      badgeEn: "Affiliate & CPA",
      badgeAr: "أفلييت وعمولة",
      iconBg: "bg-teal-600 text-white",
      descriptionEn:
        "Smart shortener for CJ affiliate links with custom geo-redirection.",
      descriptionAr: "رابط قصير ذكي لشبكة CJ مع خاصية التوجيه الجغرافي.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z",
          }),
        }),
    },
    {
      id: "facebook",
      name: "Facebook & Reels",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg: "bg-[#1877F2] text-white",
      descriptionEn:
        "Clean, block-safe short links optimized for Facebook posts and group comments.",
      descriptionAr:
        "روابط آمنة وغير محظورة للنشر في مجموعات ومنشورات الفيسبوك.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
          }),
        }),
    },
    {
      id: "whatsapp",
      name: "WhatsApp & Status",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg: "bg-[#25D366] text-white",
      descriptionEn:
        "Fast-loading short links with rich preview thumbnails for WhatsApp chats.",
      descriptionAr: "روابط خفيفة مع معاينة ممتازة لمجموعات وقنوات الواتساب.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12.031 2c-5.523 0-10 4.477-10 10 0 1.77.461 3.431 1.265 4.875L2 22l5.242-1.375C8.633 21.411 10.273 22 12.031 22c5.523 0 10-4.477 10-10s-4.477-10-10-10zm5.832 14.125c-.246.691-1.223 1.266-1.988 1.434-.523.113-1.203.203-3.492-.746-2.926-1.215-4.812-4.195-4.961-4.391-.145-.195-1.203-1.602-1.203-3.055 0-1.453.758-2.164 1.031-2.453.273-.289.598-.363.797-.363.199 0 .398.004.57.012.18.008.422-.066.66.508.246.598.836 2.039.91 2.188.074.148.121.324.023.516-.098.195-.148.316-.293.488-.145.172-.305.383-.438.516-.148.148-.305.313-.133.609.172.297.766 1.266 1.645 2.051 1.129 1.008 2.082 1.32 2.379 1.469.297.148.473.125.648-.074.176-.199.75-0.875.953-1.176.203-.297.402-.246.676-.145.273.098 1.734.82 2.035.973.297.148.496.223.57.348.074.125.074.723-.172 1.414z",
          }),
        }),
    },
    {
      id: "instagram",
      name: "Instagram & Bio",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg:
        "bg-gradient-to-tr from-amber-500 via-rose-500 to-purple-600 text-white",
      descriptionEn:
        "Perfect link-in-bio and story links with attractive custom target domains.",
      descriptionAr:
        "مثالية للبايو والستوري في إنستغرام مع نطاقات قصيرة جذابة.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
          }),
        }),
    },
    {
      id: "tiktok",
      name: "TikTok & Bio",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg: "bg-black text-white",
      descriptionEn:
        "Compact links designed for TikTok bio sections and viral video descriptions.",
      descriptionAr: "روابط مدمجة للبايو ووصف مقاطع التيك توك الفيروسية.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.82.56-1.31 1.56-1.26 2.55.02.83.43 1.62 1.1 2.12.82.63 1.95.82 2.93.53 1.03-.28 1.88-1.07 2.19-2.09.11-.42.17-.86.16-1.3-.02-4.43-.01-8.86-.02-13.29z",
          }),
        }),
    },
    {
      id: "x-twitter",
      name: "X (Twitter)",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg: "bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900",
      descriptionEn:
        "Ultra-short URL format saving precious character limits on X posts.",
      descriptionAr:
        "روابط فائقة القصر لتوفير مساحة الأحرف في تغريدات منشورات X.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-5 h-5 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
          }),
        }),
    },
    {
      id: "youtube",
      name: "YouTube & Shorts",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg: "bg-[#FF0000] text-white",
      descriptionEn:
        "Short URLs formatted for YouTube video descriptions and pinned comments.",
      descriptionAr: "روابط مثالية لوصف فيديوهات اليوتيوب والتعليقات المثبتة.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
          }),
        }),
    },
    {
      id: "reddit",
      name: "Reddit & Telegram",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg: "bg-[#FF4500] text-white",
      descriptionEn:
        "High-trust short URLs tailored for Reddit communities and Telegram channels.",
      descriptionAr: "روابط موثوقة لمجتمعات ريديت وقنوات التيليجرام.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12 0C5.373 0 0 5.373 0 12c0 3.314 1.343 6.314 3.515 8.485l-2.286 2.286C.775 23.225 1.166 24 1.802 24H12c6.627 0 12-5.373 12-12S18.627 0 12 0zm5.894 8.221c.214 0 .388.174.388.388 0 .032-.004.062-.012.092l-1.397 5.176c-.052.193-.227.329-.427.329h-8.91c-.2 0-.375-.136-.427-.329L5.73 8.701c-.008-.03-.012-.06-.012-.092 0-.214.174-.388.388-.388h11.788z",
          }),
        }),
    },
    {
      id: "pinterest",
      name: "Pinterest Pins",
      category: "social",
      badgeEn: "Social Media",
      badgeAr: "تواصل اجتماعي",
      iconBg: "bg-[#BD081C] text-white",
      descriptionEn:
        "Rich destination links optimized for Pinterest shopping pins and boards.",
      descriptionAr: "روابط وجهة محسّنة لدبابيس وبوردات بينتريست.",
      renderIcon: () =>
        l.jsx("svg", {
          className: "w-6 h-6 fill-current",
          viewBox: "0 0 24 24",
          children: l.jsx("path", {
            d: "M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026h.032z",
          }),
        }),
    },
  ],
  im = ({ language: f = "en" }) => {
    const V = f === "ar",
      [b, h] = x.useState("all"),
      I = x.useRef(null),
      j = b === "all" ? $x : $x.filter((R) => R.category === b),
      se = [...j, ...j, ...j],
      J = (R) => {
        (h(R),
          I.current && I.current.scrollTo({ left: 0, behavior: "instant" }));
      },
      [ee, W] = x.useState(!1);
    x.useEffect(() => {
      if (ee) return;
      return MvMarq(I);
    }, [ee, b]);
    const Ae = (R) => {
      if (!I.current) return;
      const de = 320;
      I.current.scrollBy({ left: R === "left" ? -de : de, behavior: "smooth" });
    };
    return l.jsx("section", {
      className:
        "w-full my-6 glass-header border-y border-white/10 py-6 px-4 sm:px-6 relative overflow-hidden select-none mv-rd-nets",
      children: l.jsxs("div", {
        className: "max-w-7xl mx-auto space-y-5 relative z-10",
        children: [
          l.jsxs("div", {
            className:
              "flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-white/15 pb-4",
            children: [
              l.jsxs("div", {
                className: "space-y-1 text-start",
                children: [
                  l.jsxs("div", {
                    className:
                      "inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-blue-500/20 border border-blue-400/30 text-sky-300 font-black text-[11px] uppercase tracking-wider",
                    children: [
                      l.jsx(ef, {
                        size: 13,
                        className: "animate-pulse text-sky-400",
                      }),
                      l.jsx("span", {
                        children: V
                          ? "المنصات المدعومة"
                          : "Universal Compatibility",
                      }),
                    ],
                  }),
                  l.jsx("h3", {
                    className:
                      "text-lg sm:text-xl md:text-2xl font-black text-white tracking-tight drop-shadow-md",
                    children: V
                      ? "المنصات وشبكات التسويق بالعمولة"
                      : "Supported Networks & Social Platforms",
                  }),
                  l.jsx("p", {
                    className:
                      "text-xs sm:text-sm font-medium text-slate-200 max-w-2xl leading-relaxed drop-shadow-sm",
                    children: V
                      ? "روابطنا القصيرة مجهزة للعمل بسلاسة عبر جميع شبكات الأفلييت ومنصات التواصل الاجتماعي مع معاينة واضحة وتتبع دقيق."
                      : "Optimized short links designed to bypass blocks, maximize CTR, and track clicks seamlessly across all affiliate networks & social media.",
                  }),
                ],
              }),
              l.jsxs("div", {
                className: "flex flex-wrap items-center gap-2 shrink-0",
                children: [
                  l.jsxs("div", {
                    className:
                      "bg-slate-900/70 p-1 rounded-xl border border-white/10 flex items-center gap-1 backdrop-blur-md",
                    children: [
                      l.jsx("button", {
                        onClick: () => J("all"),
                        className: `px-3 py-1.5 rounded-lg text-xs font-black transition-all cursor-pointer ${b === "all" ? "bg-blue-600 text-white shadow-md" : "text-slate-300 hover:text-white"}`,
                        children: V ? "الكل" : "All Platforms",
                      }),
                      l.jsx("button", {
                        onClick: () => J("affiliate"),
                        className: `px-3 py-1.5 rounded-lg text-xs font-black transition-all cursor-pointer ${b === "affiliate" ? "bg-blue-600 text-white shadow-md" : "text-slate-300 hover:text-white"}`,
                        children: V
                          ? "شبكات الأفلييت & CPA"
                          : "Affiliate & CPA",
                      }),
                      l.jsx("button", {
                        onClick: () => J("social"),
                        className: `px-3 py-1.5 rounded-lg text-xs font-black transition-all cursor-pointer ${b === "social" ? "bg-blue-600 text-white shadow-md" : "text-slate-300 hover:text-white"}`,
                        children: V ? "التواصل الاجتماعي" : "Social Media",
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "flex items-center gap-1",
                    children: [
                      l.jsx("button", {
                        onClick: () => Ae("left"),
                        className:
                          "p-2 bg-slate-900/60 hover:bg-slate-800 text-white rounded-xl border border-white/10 transition-all cursor-pointer active:scale-95 shadow-md",
                        title: V ? "السابق" : "Scroll Left",
                        children: l.jsx(Mp, { size: 16 }),
                      }),
                      l.jsx("button", {
                        onClick: () => Ae("right"),
                        className:
                          "p-2 bg-slate-900/60 hover:bg-slate-800 text-white rounded-xl border border-white/10 transition-all cursor-pointer active:scale-95 shadow-md",
                        title: V ? "التالي" : "Scroll Right",
                        children: l.jsx(Rp, { size: 16 }),
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          l.jsx("div", {
            className: "relative w-full overflow-hidden",
            onMouseEnter: () => W(!0),
            onMouseLeave: () => W(!1),
            onTouchStart: () => W(!0),
            onTouchEnd: () => W(!1),
            children: l.jsx("div", {
              ref: I,
              className: "flex gap-4 overflow-x-auto scrollbar-none py-2 px-1",
              children: se.map((R, de) =>
                l.jsxs(
                  "div",
                  {
                    className:
                      "w-64 sm:w-72 shrink-0 glass-card rounded-2xl p-4 shadow-xl hover:shadow-2xl transition-all duration-200 transform hover:-translate-y-1 flex flex-col justify-between space-y-3 cursor-pointer group text-start text-slate-900",
                    children: [
                      l.jsxs("div", {
                        className: "flex items-center justify-between gap-2",
                        children: [
                          l.jsx("div", {
                            className: `w-11 h-11 rounded-xl ${R.iconBg} flex items-center justify-center shadow-md group-hover:scale-105 transition-transform shrink-0`,
                            children: R.renderIcon(),
                          }),
                          l.jsx("span", {
                            className: `text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full border ${R.category === "affiliate" ? "bg-blue-50 text-blue-700 border-blue-200" : "bg-purple-50 text-purple-700 border-purple-200"}`,
                            children: V ? R.badgeAr : R.badgeEn,
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className: "space-y-1 flex-1",
                        children: [
                          l.jsxs("h4", {
                            className:
                              "font-extrabold text-sm sm:text-base text-slate-900 group-hover:text-blue-600 transition-colors flex items-center justify-between",
                            children: [
                              l.jsx("span", { children: R.name }),
                              l.jsx(tr, {
                                size: 12,
                                className:
                                  "opacity-0 group-hover:opacity-100 transition-opacity text-blue-600",
                              }),
                            ],
                          }),
                          l.jsx("p", {
                            className:
                              "text-xs font-medium text-slate-600 leading-relaxed line-clamp-2",
                            children: V ? R.descriptionAr : R.descriptionEn,
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className:
                          "pt-2 border-t border-slate-200 flex items-center justify-between text-[11px] font-bold text-blue-600",
                        children: [
                          l.jsxs("span", {
                            className: "flex items-center gap-1",
                            children: [
                              l.jsx(Gp, {
                                size: 13,
                                className: "text-emerald-500",
                              }),
                              l.jsx("span", {
                                className:
                                  "text-[11px] text-slate-800 font-extrabold",
                                children: V
                                  ? "توافق كامل 100%"
                                  : "100% Compatible",
                              }),
                            ],
                          }),
                          l.jsx("span", {
                            className:
                              "text-[10px] text-emerald-700 font-mono font-bold bg-emerald-100 px-1.5 py-0.5 rounded",
                            children: "OK",
                          }),
                        ],
                      }),
                    ],
                  },
                  `${R.id}-${de}`,
                ),
              ),
            }),
          }),
        ],
      }),
    });
  },
  md = [
    { code: "AF", name: "Afghanistan", nameAr: "أفغانستان", flag: "🇦🇫" },
    { code: "AL", name: "Albania", nameAr: "ألبانيا", flag: "🇦🇱" },
    { code: "DZ", name: "Algeria", nameAr: "الجزائر", flag: "🇩🇿" },
    { code: "AR", name: "Argentina", nameAr: "الأرجنتين", flag: "🇦🇷" },
    { code: "AM", name: "Armenia", nameAr: "أرمينيا", flag: "🇦🇲" },
    { code: "AU", name: "Australia", nameAr: "أستراليا", flag: "🇦🇺" },
    { code: "AT", name: "Austria", nameAr: "النمسا", flag: "🇦🇹" },
    { code: "AZ", name: "Azerbaijan", nameAr: "أذربيجان", flag: "🇦🇿" },
    { code: "BH", name: "Bahrain", nameAr: "البحرين", flag: "🇧🇭" },
    { code: "BD", name: "Bangladesh", nameAr: "بنجلاديش", flag: "🇧🇩" },
    { code: "BY", name: "Belarus", nameAr: "بيلاروسيا", flag: "🇧🇾" },
    { code: "BE", name: "Belgium", nameAr: "بلجيكا", flag: "🇧🇪" },
    { code: "BO", name: "Bolivia", nameAr: "بوليفيا", flag: "🇧🇴" },
    {
      code: "BA",
      name: "Bosnia & Herzegovina",
      nameAr: "البوسنة والهرسك",
      flag: "🇧🇦",
    },
    { code: "BR", name: "Brazil", nameAr: "البرازيل", flag: "🇧🇷" },
    { code: "BG", name: "Bulgaria", nameAr: "بلغاريا", flag: "🇧🇬" },
    { code: "CA", name: "Canada", nameAr: "كندا", flag: "🇨🇦" },
    { code: "CL", name: "Chile", nameAr: "تشيلي", flag: "🇨🇱" },
    { code: "CN", name: "China", nameAr: "الصين", flag: "🇨🇳" },
    { code: "CO", name: "Colombia", nameAr: "كولومبيا", flag: "🇨🇴" },
    { code: "CR", name: "Costa Rica", nameAr: "كوستاريكا", flag: "🇨🇷" },
    { code: "HR", name: "Croatia", nameAr: "كرواتيا", flag: "🇭🇷" },
    { code: "CY", name: "Cyprus", nameAr: "قبرص", flag: "🇨🇾" },
    { code: "CZ", name: "Czechia", nameAr: "التشيك", flag: "🇨🇿" },
    { code: "DK", name: "Denmark", nameAr: "الدنمارك", flag: "🇩🇰" },
    {
      code: "DO",
      name: "Dominican Republic",
      nameAr: "جمهورية الدومينيكان",
      flag: "🇩🇴",
    },
    { code: "EC", name: "Ecuador", nameAr: "الإكوادور", flag: "🇪🇨" },
    { code: "EG", name: "Egypt", nameAr: "مصر", flag: "🇪🇬" },
    { code: "SV", name: "El Salvador", nameAr: "السلفادور", flag: "🇸🇻" },
    { code: "EE", name: "Estonia", nameAr: "إستونيا", flag: "🇪🇪" },
    { code: "FI", name: "Finland", nameAr: "فنلندا", flag: "🇫🇮" },
    { code: "FR", name: "France", nameAr: "فرنسا", flag: "🇫🇷" },
    { code: "GE", name: "Georgia", nameAr: "جورجيا", flag: "🇬🇪" },
    { code: "DE", name: "Germany", nameAr: "ألمانيا", flag: "🇩🇪" },
    { code: "GH", name: "Ghana", nameAr: "غانا", flag: "🇬🇭" },
    { code: "GR", name: "Greece", nameAr: "اليونان", flag: "🇬🇷" },
    { code: "GT", name: "Guatemala", nameAr: "غواتيمالا", flag: "🇬🇹" },
    { code: "HK", name: "Hong Kong", nameAr: "هونغ كونغ", flag: "🇭🇰" },
    { code: "HU", name: "Hungary", nameAr: "المجر", flag: "🇭🇺" },
    { code: "IS", name: "Iceland", nameAr: "آيسلندا", flag: "🇮🇸" },
    { code: "IN", name: "India", nameAr: "الهند", flag: "🇮🇳" },
    { code: "ID", name: "Indonesia", nameAr: "إندونيسيا", flag: "🇮🇩" },
    { code: "IQ", name: "Iraq", nameAr: "العراق", flag: "🇮🇶" },
    { code: "IE", name: "Ireland", nameAr: "أيرلندا", flag: "🇮🇪" },
    { code: "IL", name: "Israel", nameAr: "إسرائيل", flag: "🇮🇱" },
    { code: "IT", name: "Italy", nameAr: "إيطاليا", flag: "🇮🇹" },
    { code: "JM", name: "Jamaica", nameAr: "جامايكا", flag: "🇯🇲" },
    { code: "JP", name: "Japan", nameAr: "اليابان", flag: "🇯🇵" },
    { code: "JO", name: "Jordan", nameAr: "الأردن", flag: "🇯🇴" },
    { code: "KZ", name: "Kazakhstan", nameAr: "كازاخستان", flag: "🇰🇿" },
    { code: "KE", name: "Kenya", nameAr: "كينيا", flag: "🇰🇪" },
    { code: "KW", name: "Kuwait", nameAr: "الكويت", flag: "🇰🇼" },
    { code: "LV", name: "Latvia", nameAr: "لاتفيا", flag: "🇱🇻" },
    { code: "LB", name: "Lebanon", nameAr: "لبنان", flag: "🇱🇧" },
    { code: "LT", name: "Lithuania", nameAr: "ليتوانيا", flag: "🇱🇹" },
    { code: "LU", name: "Luxembourg", nameAr: "لوكسمبورغ", flag: "🇱🇺" },
    { code: "MY", name: "Malaysia", nameAr: "ماليزيا", flag: "🇲🇾" },
    { code: "MX", name: "Mexico", nameAr: "المكسيك", flag: "🇲🇽" },
    { code: "MA", name: "Morocco", nameAr: "المغرب", flag: "🇲🇦" },
    { code: "NL", name: "Netherlands", nameAr: "هولندا", flag: "🇳🇱" },
    { code: "NZ", name: "New Zealand", nameAr: "نيوزيلندا", flag: "🇳🇿" },
    { code: "NG", name: "Nigeria", nameAr: "نيجيريا", flag: "🇳🇬" },
    { code: "NO", name: "Norway", nameAr: "النرويج", flag: "🇳🇴" },
    { code: "OM", name: "Oman", nameAr: "عُمان", flag: "🇴🇲" },
    { code: "PK", name: "Pakistan", nameAr: "باكستان", flag: "🇵🇰" },
    { code: "PA", name: "Panama", nameAr: "بنما", flag: "🇵🇦" },
    { code: "PY", name: "Paraguay", nameAr: "باراغواي", flag: "🇵🇾" },
    { code: "PE", name: "Peru", nameAr: "بيرو", flag: "🇵🇪" },
    { code: "PH", name: "Philippines", nameAr: "الفلبين", flag: "🇵🇭" },
    { code: "PL", name: "Poland", nameAr: "بولندا", flag: "🇵🇱" },
    { code: "PT", name: "Portugal", nameAr: "البرتغال", flag: "🇵🇹" },
    { code: "QA", name: "Qatar", nameAr: "قطر", flag: "🇶🇦" },
    { code: "RO", name: "Romania", nameAr: "رومانيا", flag: "🇷🇴" },
    { code: "SA", name: "Saudi Arabia", nameAr: "السعودية", flag: "🇸🇦" },
    { code: "RS", name: "Serbia", nameAr: "صربيا", flag: "🇷🇸" },
    { code: "SG", name: "Singapore", nameAr: "سنغافورة", flag: "🇸🇬" },
    { code: "SK", name: "Slovakia", nameAr: "سلوفاكيا", flag: "🇸🇰" },
    { code: "ZA", name: "South Africa", nameAr: "جنوب أفريقيا", flag: "🇿🇦" },
    { code: "KR", name: "South Korea", nameAr: "كوريا الجنوبية", flag: "🇰🇷" },
    { code: "ES", name: "Spain", nameAr: "إسبانيا", flag: "🇪🇸" },
    { code: "SE", name: "Sweden", nameAr: "السويد", flag: "🇸🇪" },
    { code: "CH", name: "Switzerland", nameAr: "سويسرا", flag: "🇨🇭" },
    { code: "TW", name: "Taiwan", nameAr: "تايوان", flag: "🇹🇼" },
    { code: "TH", name: "Thailand", nameAr: "تايلاند", flag: "🇹🇭" },
    { code: "TN", name: "Tunisia", nameAr: "تونس", flag: "🇹🇳" },
    { code: "TR", name: "Turkey", nameAr: "تركيا", flag: "🇹🇷" },
    { code: "UA", name: "Ukraine", nameAr: "أوكرانيا", flag: "🇺🇦" },
    {
      code: "AE",
      name: "United Arab Emirates",
      nameAr: "الإمارات",
      flag: "🇦🇪",
    },
    {
      code: "GB",
      name: "United Kingdom",
      nameAr: "المملكة المتحدة",
      flag: "🇬🇧",
    },
    {
      code: "US",
      name: "United States",
      nameAr: "الولايات المتحدة",
      flag: "🇺🇸",
    },
    { code: "UY", name: "Uruguay", nameAr: "أوروغواي", flag: "🇺🇾" },
    { code: "UZ", name: "Uzbekistan", nameAr: "أوزبكستان", flag: "🇺🇿" },
    { code: "VE", name: "Venezuela", nameAr: "فنزويلا", flag: "🇻🇪" },
    { code: "VN", name: "Vietnam", nameAr: "فيتنام", flag: "🇻🇳" },
  ],
  cm = ({
    selectedCountries: f,
    onChange: V,
    onInfoClick: b,
    isDarkCard: h = !1,
    isAr: I = !1,
  }) => {
    const [j, se] = x.useState(!1),
      [J, ee] = x.useState(""),
      W = x.useMemo(() => {
        const $ = J.trim().toLowerCase();
        return $
          ? md.filter(
              (te) =>
                te.name.toLowerCase().includes($) ||
                te.code.toLowerCase().includes($) ||
                (te.nameAr && te.nameAr.toLowerCase().includes($)),
            )
          : md;
      }, [J]),
      Ae = ($) => {
        const te = $.toUpperCase();
        f.includes(te) ? V(f.filter((Ve) => Ve !== te)) : V([...f, te]);
      },
      R = () => {
        const $ = W.map((Ve) => Ve.code.toUpperCase()),
          te = new Set([...f, ...$]);
        V(Array.from(te));
      },
      de = () => {
        V([]);
      },
      Ge = f.length;
    return l.jsxs("div", {
      className: "relative inline-block text-start",
      children: [
        j &&
          l.jsx("div", {
            className: "fixed inset-0 z-40 bg-transparent",
            onClick: () => se(!1),
          }),
        l.jsxs("div", {
          className: `relative z-30 flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-xs font-extrabold transition-all shadow-2xs cursor-pointer select-none ${h ? "bg-[#081023] border-cyan-500/40 text-cyan-100 hover:bg-[#0c1836]" : "bg-white border-slate-300 text-slate-800 hover:bg-slate-50"}`,
          onClick: () => {
            (se(!j), b && b());
          },
          children: [
            l.jsx(tf, {
              className: `w-3.5 h-3.5 shrink-0 ${h ? "text-cyan-400" : "text-blue-600"}`,
            }),
            l.jsx("span", {
              className: "whitespace-nowrap",
              children: I ? "دول أخرى" : "Other Countries",
            }),
            Ge > 0 &&
              l.jsx("span", {
                className: `px-1.5 py-0.2 rounded-full text-[9px] font-black shrink-0 ${h ? "bg-cyan-500/30 text-cyan-200 border border-cyan-400/40" : "bg-blue-600 text-white"}`,
                children: Ge,
              }),
            b &&
              l.jsx("button", {
                type: "button",
                onClick: ($) => {
                  ($.preventDefault(), $.stopPropagation(), b());
                },
                title: I ? "معلومات تقييد الدول" : "Country restriction info",
                className: `p-0.5 rounded-full transition-colors cursor-pointer shrink-0 ${h ? "text-cyan-400 hover:bg-cyan-950/80 hover:text-cyan-200" : "text-blue-600 hover:bg-blue-50 hover:text-blue-800"}`,
                children: l.jsx(af, { size: 13 }),
              }),
            l.jsxs("div", {
              className:
                "flex items-center gap-0.5 text-[10px] opacity-75 shrink-0 ml-1",
              children: [
                l.jsx("span", { children: I ? "اختيار" : "Select" }),
                j ? l.jsx(Px, { size: 13 }) : l.jsx(ar, { size: 13 }),
              ],
            }),
          ],
        }),
        j &&
          l.jsxs("div", {
            className: `absolute right-0 top-full mt-1 z-50 w-72 sm:w-80 p-2.5 rounded-xl border-2 space-y-2 shadow-2xl animate-in fade-in zoom-in-95 duration-150 ${h ? "bg-[#060a17] border-cyan-500/60 text-cyan-100 shadow-cyan-950/80" : "bg-white border-slate-300 text-slate-900 shadow-xl"}`,
            children: [
              l.jsxs("div", {
                className: "relative",
                children: [
                  l.jsx("input", {
                    type: "text",
                    value: J,
                    onChange: ($) => ee($.target.value),
                    placeholder: I
                      ? "بحث بالاسم أو الكود..."
                      : "Search list...",
                    className: `w-full pl-7 pr-7 py-1 border rounded-md text-xs font-semibold transition-colors shadow-inner focus:outline-none ${h ? "bg-[#02050e] border-cyan-500/60 text-cyan-100 placeholder:text-cyan-600/70 focus:border-cyan-400" : "bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 focus:border-blue-600"}`,
                  }),
                  l.jsx(di, {
                    className: `w-3.5 h-3.5 absolute left-2 top-2 ${h ? "text-cyan-500" : "text-slate-400"}`,
                  }),
                  J &&
                    l.jsx("button", {
                      type: "button",
                      onClick: () => ee(""),
                      className:
                        "absolute right-2 top-1.5 text-slate-400 hover:text-slate-600 cursor-pointer",
                      children: l.jsx(hs, { size: 12 }),
                    }),
                ],
              }),
              l.jsxs("div", {
                className:
                  "flex items-center justify-between text-[10px] font-bold px-0.5",
                children: [
                  l.jsxs("span", {
                    className: h ? "text-cyan-400" : "text-slate-600",
                    children: [W.length, " ", I ? "دولة" : "countries"],
                  }),
                  l.jsxs("div", {
                    className: "flex items-center gap-1.5",
                    children: [
                      l.jsx("button", {
                        type: "button",
                        onClick: R,
                        className: `underline cursor-pointer hover:opacity-80 text-[10px] uppercase font-extrabold ${h ? "text-cyan-300" : "text-blue-700"}`,
                        children: I ? "تحديد الكل" : "Select All",
                      }),
                      l.jsx("span", { children: "•" }),
                      l.jsx("button", {
                        type: "button",
                        onClick: de,
                        className:
                          "underline cursor-pointer hover:opacity-80 text-[10px] uppercase font-extrabold text-rose-500",
                        children: I ? "مسح" : "Clear",
                      }),
                    ],
                  }),
                ],
              }),
              l.jsx("div", {
                className: `max-h-40 overflow-y-auto rounded-md border shadow-inner transition-colors ${h ? "border-cyan-500/40 bg-[#030611]" : "border-slate-300 bg-white"}`,
                children:
                  W.length === 0
                    ? l.jsx("div", {
                        className:
                          "p-3 text-center text-xs text-slate-400 font-semibold",
                        children: I ? "لا توجد نتائج" : "No match found.",
                      })
                    : W.map(($) => {
                        const te = f.includes($.code.toUpperCase());
                        return l.jsxs(
                          "label",
                          {
                            className: `flex items-center justify-between px-2.5 py-1 border-b text-[11px] cursor-pointer select-none transition-colors ${te ? (h ? "bg-amber-400/20 text-amber-200 font-bold italic border-cyan-900/40" : "bg-[#fffeb3] text-slate-900 font-bold italic border-slate-200") : h ? "hover:bg-cyan-950/60 text-slate-300 border-cyan-950/30" : "hover:bg-slate-100/80 text-slate-800 border-slate-100"}`,
                            children: [
                              l.jsxs("div", {
                                className: "flex items-center gap-2 min-w-0",
                                children: [
                                  l.jsx("input", {
                                    type: "checkbox",
                                    checked: te,
                                    onChange: () => Ae($.code),
                                    className:
                                      "w-3.5 h-3.5 accent-indigo-600 cursor-pointer rounded shrink-0",
                                  }),
                                  l.jsx("span", {
                                    className: "text-sm leading-none shrink-0",
                                    children: $.flag,
                                  }),
                                  l.jsx("span", {
                                    className: "truncate font-semibold",
                                    children: I && $.nameAr ? $.nameAr : $.name,
                                  }),
                                ],
                              }),
                              l.jsx("span", {
                                className: `text-[9px] font-mono uppercase px-1 py-0.2 rounded shrink-0 ${te ? (h ? "bg-amber-400/30 text-amber-100 font-bold" : "bg-amber-200 text-amber-950 font-bold") : h ? "text-cyan-500/70" : "text-slate-400"}`,
                                children: $.code,
                              }),
                            ],
                          },
                          $.code,
                        );
                      }),
              }),
              f.length > 0 &&
                l.jsxs("div", {
                  className:
                    "pt-1 border-t border-slate-200 dark:border-cyan-500/30 flex flex-wrap gap-1 max-h-16 overflow-y-auto",
                  children: [
                    l.jsx("span", {
                      className: `text-[9px] font-bold block w-full ${h ? "text-cyan-300" : "text-slate-600"}`,
                      children: I ? "الدول المختارة:" : "Selected:",
                    }),
                    f.map(($) => {
                      const te = md.find((Ve) => Ve.code.toUpperCase() === $);
                      return l.jsxs(
                        "span",
                        {
                          className: `inline-flex items-center gap-1 px-1.5 py-0.3 rounded text-[10px] font-bold border ${h ? "bg-amber-400/20 text-amber-200 border-amber-400/40" : "bg-amber-100 text-slate-900 border-amber-300"}`,
                          children: [
                            l.jsx("span", { children: te?.flag || "🌍" }),
                            l.jsx("span", {
                              children: te
                                ? I && te.nameAr
                                  ? te.nameAr
                                  : te.name
                                : $,
                            }),
                            l.jsx("button", {
                              type: "button",
                              onClick: () => Ae($),
                              className:
                                "ml-0.5 hover:text-rose-500 cursor-pointer",
                              children: l.jsx(hs, { size: 10 }),
                            }),
                          ],
                        },
                        $,
                      );
                    }),
                  ],
                }),
            ],
          }),
      ],
    });
  };
var dm = Vp();
const um = Hp(dm),
  ni = {
    FIREBASE_URL: "",
    ADSENSE_CLIENT: "ca-pub-XXXXXXXXXXXXXXXX",
    ADSENSE_SLOT: "XXXXXXXXXX",
    YANDEX_BLOCK: "R-A-XXXXXXX-1",
    ALT_SITE: "https://mavely.ai.studio/",
    SITE_BUTTON_EN: "Site Link Here",
    SITE_BUTTON_AR: "رابط الموقع البديل",
    OG_IMAGE: "https://iili.io/CSegoOP.png",
    PALETTE: "dark",
    THEME: "modern-dark",
    CITY_BG_OPTION: "real_city",
    CONTACT_EMAIL: "mavelylink@gmail.com",
    BRAND: "Mavely Link",
    WHATSAPP: "https://wa.me/1234567890",
    FACEBOOK: "https://www.facebook.com/profile.php?id=61592084252311",
    TELEGRAM: "https://www.facebook.com/profile.php?id=61592084252311",
    YOUTUBE: "https://www.youtube.com/channel/UCsH5MO1MFM1UZeK5peX7kUA",
    YANDEX_MODE: "ad",
    YANDEX_IMAGE_URL: "https://iili.io/CSegoOP.png",
    YANDEX_CPA_CHECK: !1,
    YANDEX_CPA_URL: "",
    ADSENSE_MODE: "ad",
    ADSENSE_IMAGE_URL: "https://iili.io/CSegoOP.png",
    ADSENSE_CPA_CHECK: !1,
    ADSENSE_CPA_URL: "",
    VERIFY_GOOGLE: "",
    VERIFY_BING: "",
    VERIFY_YANDEX: "",
    minClicks: 15,
    gracePeriodHours: 90,
    autoDeleteEnabled: !1,
    autoDeleteAllOver200hEnabled: !1,
    allOver200hAgeHours: 200,
  },
  hd = [
    "api",
    "uploads",
    "src",
    "node_modules",
    "admin",
    "dashboard",
    "deals",
    "settings",
    "login",
    "timer-usa",
    "timer",
    "manual-deals",
    "network-leads",
    "shorten",
    "qr",
    "qr-code",
    "ip",
    "ip-detective",
    "download",
    "fb-downloader",
    "configure",
    "privacy-policy",
    "privacy",
    "terms-of-service",
    "terms",
    "contact-us",
    "contact",
    "about-us",
    "about",
    "cookie-policy",
    "cookie",
    "index.html",
    "favicon.ico",
    "robots.txt",
    "sitemap.xml",
    "landing",
    "landing-admin",
    "go",
  ];
async function xm(f, V) {
  if (!(typeof window > "u"))
    try {
      let b = "";
      try {
        ((b = localStorage.getItem("sh_my_uid") || ""),
          b ||
            ((b = "u_" + Math.random().toString(36).slice(2, 12)),
            localStorage.setItem("sh_my_uid", b)));
      } catch {
        b = "u_" + Math.random().toString(36).slice(2, 12);
      }
      let h = "other";
      const I = String(f || "").toLowerCase();
      if (I === "walmart" || I === "amazon" || I === "aliexpress") h = I;
      else {
        const J = String(V || "").toLowerCase();
        J.includes("walmart")
          ? (h = "walmart")
          : J.includes("amazon") || J.includes("amzn")
            ? (h = "amazon")
            : (J.includes("aliexpress") || J.includes("ali")) &&
              (h = "aliexpress");
      }
      let j = "";
      try {
        const J = localStorage.getItem("sh_real_guest_v1");
        if (J) {
          const ee = JSON.parse(J);
          ee &&
            ee.country &&
            ee.country !== "XX" &&
            !ee.realCountryPending &&
            (j = String(ee.country).toUpperCase());
        }
      } catch {}
      if (!/^[A-Z]{2}$/.test(j))
        try {
          const ee = await (await fetch("/api/ip-lookup")).json(),
            W = String((ee && ee.countryCode) || "").toUpperCase();
          if (/^[A-Z]{2}$/.test(W)) {
            j = W;
            try {
              const Ae = localStorage.getItem("sh_real_guest_v1"),
                R = Ae ? JSON.parse(Ae) : {};
              ((R.country = W),
                delete R.realCountryPending,
                localStorage.setItem("sh_real_guest_v1", JSON.stringify(R)));
            } catch {}
          }
        } catch {}
      /^[A-Z]{2}$/.test(j) || (j = "US");
      const se = async (J) => {
        try {
          const ee = await fetch(J, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ network: h, country: j, uid: b }),
            }),
            W = ee.headers.get("content-type") || "";
          if (ee.ok && W.indexOf("application/json") !== -1) {
            const Ae = await ee.json();
            return !!(Ae && Ae.success);
          }
        } catch {}
        return !1;
      };
      ((await se("/api/network-leads")) || (await se("/api/network-leads.php")),
        window.dispatchEvent(
          new CustomEvent("mavely:shortlink-created", {
            detail: { store: h, destHost: String(V || "") },
          }),
        ));
    } catch {}
}
function nf(f) {
  const V = [];
  for (let b of String(f || "").split(/[\r\n,]+/))
    ((b = b.trim().replace(/\/+$/, "")),
      b &&
        (/XXXX|your-app-default/i.test(b) ||
          (/^https?:\/\//i.test(b) && V.indexOf(b) === -1 && V.push(b))));
  return V;
}
function ri(f) {
  return nf(f)[0] || "";
}
function Qx(f) {
  return String(f || "")
    .split(/[\r\n]+/)
    .map((V) => V.trim().replace(/\/+$/, ""))
    .filter(Boolean).join(`
`);
}
function oi() {
  if (!(typeof window > "u"))
    try {
      window.location.replace(window.location.origin + "/");
    } catch {
      window.location.href = "/";
    }
}
const fm = x.lazy(() =>
    lr(() => import("./TimerUsa-MV41g.js"), __vite__mapDeps([0, 1, 2])),
  ),
  pm = x.lazy(() =>
    lr(() => import("./DealsList-MV41g.js"), __vite__mapDeps([3, 1, 2])),
  ),
  mm = x.lazy(() =>
    lr(() => import("./ManualDealsTab-MV41g.js"), __vite__mapDeps([4, 1, 2])),
  ),
  hm = x.lazy(() =>
    lr(() => import("./NetworkLeadsTab-MV41g.js"), __vite__mapDeps([5, 1, 2])),
  ),
  bm = x.lazy(() =>
    lr(() => import("./DocModal-MV41g.js"), __vite__mapDeps([6, 1, 2])),
  ),
  gm = x.lazy(() => lr(() => Promise.resolve().then(() => nm), void 0)),
  Kx = (f) => {
    f = MvFbUn(f);
    if (!f || !f.trim()) return !0;
    const V = f.trim();
    if (/^(\/?\?|\/r\/)?[a-z0-9_-]{4,12}$/i.test(V)) return !0;
    try {
      const h = new URL(V).hostname.toLowerCase(),
        I = typeof window < "u" ? window.location.hostname.toLowerCase() : "";
      return !!(
        h === "mavelylink.ai.studio" ||
        h === I ||
        h.endsWith(".ai.studio") ||
        h === "localhost" ||
        h === "127.0.0.1"
      );
    } catch {
      return !!(V.startsWith("?") || V.startsWith("/"));
    }
  };
function vm() {
  const [f, V] = x.useState(() => {
    try {
      const i = localStorage.getItem("sh_theme");
      if (i) return { ...ni, THEME: i };
    } catch {}
    return ni;
  });
  x.useEffect(() => {
    if (f.THEME)
      try {
        localStorage.setItem("sh_theme", f.THEME);
      } catch {}
  }, [f.THEME]);
  const [b, h] = x.useState(() => {
      try {
        const i = localStorage.getItem("sh_lang");
        if (i === "ar" || i === "en") return i;
      } catch {}
      return typeof navigator < "u" && /^ar\b/i.test(navigator.language || "")
        ? "ar"
        : "en";
    }),
    [I] = x.useState(() => {
      try {
        let i = localStorage.getItem("sh_creator_id");
        if (!i) {
          const B = document.cookie.match(/(?:^|; )sh_creator_id=([^;]*)/);
          B && B[1] && (i = decodeURIComponent(B[1]));
        }
        (i ||
          (i = `user_${Math.random().toString(36).slice(2, 11)}_${Date.now().toString(36)}`),
          localStorage.setItem("sh_creator_id", i));
        try {
          document.cookie = `sh_creator_id=${i}; path=/; max-age=31536000; SameSite=Lax`;
        } catch {}
        return i;
      } catch {
        const i = `user_fallback_${Math.random().toString(36).slice(2, 10)}`;
        try {
          document.cookie = `sh_creator_id=${i}; path=/; max-age=31536000; SameSite=Lax`;
        } catch {}
        return i;
      }
    });
  x.useEffect(() => {
    try {
      document.cookie = `sh_creator_id=${I}; path=/; max-age=31536000; SameSite=Lax`;
    } catch {}
  }, [I]);
  const [j, se] = x.useState(() => {
      if (typeof window > "u") return "deals";
      const i = window.location.pathname.toLowerCase();
      return i === "/timer-usa" || i === "/timer"
        ? "timer"
        : i === "/manual-deals"
          ? "manual_deals"
          : i === "/network-leads"
            ? "network_leads"
            : "deals";
    }),
    [J, ee] = x.useState(!1),
    [W, Ae] = x.useState(0),
    R = () => {
      (ee(!0),
        setTimeout(() => {
          ee(!1);
        }, 3e4));
    };
  x.useEffect(() => {
    fetch("/api/settings")
      .then((i) => {
        if (!i.ok) throw new Error("Failed to load settings");
        return i.json();
      })
      .then((i) => {
        if (i && typeof i == "object") {
          const B = { ...ni, ...i };
          (B.FIREBASE_URL && (B.FIREBASE_URL = Qx(B.FIREBASE_URL)), V(B));
        }
      })
      .catch((i) => console.error("Failed to load settings from server:", i));
  }, []);
  const de = () =>
      (typeof window < "u" && window.__INITIAL_LINK_DATA__) || null,
    Ge = () => {
      if (typeof window < "u") {
        if (window.__INITIAL_REDIRECT_MODE__)
          return window.__INITIAL_REDIRECT_MODE__;
        const i = window.location.search,
          B = window.location.pathname;
        if (i && i.length > 1) {
          if (i.includes("u=")) return "resolving";
          const q = i.substring(1).split("&")[0],
            me = [
              "p",
              "u",
              "code",
              "go",
              "confirm",
              "ref",
              "fbclid",
              "gclid",
              "utm_source",
              "utm_medium",
            ];
          if (q && q.indexOf("=") === -1 && !me.includes(q.toLowerCase()))
            return "resolving";
        }
        if (B && B !== "/" && B !== "/index.html") {
          const q = B.replace(/^\/+|\/+$/g, ""),
            me = hd;
          if (q && /^[a-z0-9_-]+$/i.test(q) && !me.includes(q.toLowerCase()))
            return "resolving";
        }
      }
      return null;
    },
    $ = de(),
    [te, Ve] = x.useState(() => Ge()),
    [st, ot] = x.useState(() => {
      if ($ && $.key) return $.key;
      if (typeof window < "u") {
        const i = window.location.search;
        if (i && i.length > 1) {
          const q = i.substring(1).split("&")[0],
            me = [
              "p",
              "u",
              "code",
              "go",
              "confirm",
              "ref",
              "fbclid",
              "gclid",
              "utm_source",
              "utm_medium",
            ];
          if (q && q.indexOf("=") === -1 && !me.includes(q.toLowerCase()))
            return decodeURIComponent(q.replace(/\/$/, "")).toLowerCase();
        }
        const B = window.location.pathname;
        if (B && B !== "/" && B !== "/index.html") {
          const q = B.replace(/^\/+|\/+$/g, ""),
            me = hd;
          if (q && /^[a-z0-9_-]+$/i.test(q) && !me.includes(q.toLowerCase()))
            return q.toLowerCase();
        }
      }
      return null;
    }),
    [ue, Me] = x.useState(() => ($ && $.url) || null),
    [ke, Ze] = x.useState(() => ($ && $.title) || null),
    [it, $e] = x.useState(
      () => ($ && ($.previewDescription || $.description)) || null,
    ),
    [Nt, oe] = x.useState(() => ($ && $.image) || null),
    [kt, Oe] = x.useState(() => ($ && $.previewAccentColor) || null),
    [Pe, nt] = x.useState(() => ($ && $.previewBgColor) || null),
    [Re, C] = x.useState(() => ($ && $.multiDealsData) || null),
    [D, U] = x.useState(!0),
    [y, X] = x.useState(() => ($ ? !!($.showStoreLogo || $.storeLogo) : !0)),
    [O, H] = x.useState(!1),
    [G, F] = x.useState(2),
    [le, ie] = x.useState(["", "", "", "", "", "", "", ""]),
    [pe, Ie] = x.useState(null),
    [Ct, Ht] = x.useState(() => ($ && $.storeLandingPage) || null),
    [Xt, St] = x.useState("classic-store"),
    [ba, Vt] = x.useState(() => ($ && $.storeLandingTheme) || "classic-store"),
    [Yt, Y] = x.useState(null),
    [re, ve] = x.useState("desktop"),
    [Te, _e] = x.useState(!1),
    [ht, ye] = x.useState(() => ($ ? !!$.storeBackgroundImage : !1));
  x.useEffect(() => {
    const i = (B) => {
      B.key === "Escape" && Yt && Y(null);
    };
    return (
      window.addEventListener("keydown", i),
      () => window.removeEventListener("keydown", i)
    );
  }, [Yt]);
  const [dl, we] = x.useState(!1),
    [Fa, Qe] = x.useState("solid"),
    [da, Aa] = x.useState("#0071CE"),
    [Va, bs] = x.useState("#004B8D"),
    [$a, gs] = x.useState("135deg"),
    [ul, $t] = x.useState(null),
    bt = () =>
      Fa === "solid"
        ? da
        : $a === "circle"
          ? `radial-gradient(circle, ${da}, ${Va})`
          : `linear-gradient(${$a}, ${da}, ${Va})`,
    [zt, vs] = x.useState("solid"),
    [Qa, Il] = x.useState("#F43F5E"),
    [Ka, Wt] = x.useState("#F59E0B"),
    [Za, ga] = x.useState("135deg"),
    [Ja, Wa] = x.useState("solid"),
    [Pa, xl] = x.useState("#F3F722"),
    [fl, pl] = x.useState("#FF9900"),
    [ql, Vs] = x.useState("135deg"),
    ml = (i, B, q) => {
      (Il(i), Wt(B), ga(q));
      const me =
        q === "circle"
          ? `radial-gradient(circle, ${i}, ${B})`
          : `linear-gradient(${q}, ${i}, ${B})`;
      wl(me);
    },
    hl = (i, B, q) => {
      (xl(i), pl(B), Vs(q));
      const me =
        q === "circle"
          ? `radial-gradient(circle, ${i}, ${B})`
          : `linear-gradient(${q}, ${i}, ${B})`;
      qt(me);
    },
    [Ke, Fl] = x.useState(""),
    [xt, ys] = x.useState(!1),
    [Lt, ft] = x.useState(!1),
    [Bt, Pt] = x.useState([]),
    [bl, el] = x.useState(!1),
    [bn, gn] = x.useState(() => {
      try {
        return localStorage.getItem("country_info_agreed") === "true";
      } catch {
        return !1;
      }
    }),
    gl = () => {
      (gn(!0), el(!1));
      try {
        localStorage.setItem("country_info_agreed", "true");
      } catch (i) {
        console.error(i);
      }
    },
    qe = () => {
      (el(!1), bn || (ft(!1), Pt([])));
    },
    [ea, Vl] = x.useState("auto"),
    [ua, Et] = x.useState(""),
    [et, tl] = x.useState(""),
    [vl, It] = x.useState(!1),
    [xa, vn] = x.useState(!1),
    [At, yl] = x.useState(""),
    [Bl, Qt] = x.useState(!1),
    [$l, fa] = x.useState(!1),
    [je, ws] = x.useState(() => {
      try {
        const i = localStorage.getItem("sh_custom_desc");
        return i !== null
          ? i
          : 'type "SEEN" when you see this!! ❤️ Grab it here 👉🏻 :';
      } catch {
        return 'type "SEEN" when you see this!! ❤️ Grab it here 👉🏻 :';
      }
    }),
    [gt, js] = x.useState(() => {
      try {
        const i = localStorage.getItem("sh_preview_desc");
        return i !== null
          ? i
          : "🔥 Almost gone — tap Continue before it sells out.";
      } catch {
        return "🔥 Almost gone — tap Continue before it sells out.";
      }
    }),
    [va, wl] = x.useState(() => {
      try {
        const i = localStorage.getItem("sh_preview_color");
        return i !== null ? i : "#F43F5E";
      } catch {
        return "#F43F5E";
      }
    }),
    [Ta, qt] = x.useState(() => {
      try {
        const i = localStorage.getItem("sh_preview_bgcolor");
        return i !== null ? i : "#F3F722";
      } catch {
        return "#F3F722";
      }
    }),
    [ta, yn] = x.useState(() => {
      try {
        return localStorage.getItem("sh_use_desc") === "true";
      } catch {
        return !1;
      }
    }),
    [jl, aa] = x.useState(() => {
      try {
        return localStorage.getItem("sh_make_qr") === "true";
      } catch {
        return !1;
      }
    }),
    [MvFb, MvSetFb] = x.useState(() => {
      try {
        return localStorage.getItem("sh_fb_link") === "true";
      } catch {
        return !1;
      }
    }),
    [ya, Ql] = x.useState(""),
    [Nl, Ol] = x.useState(!1);
  (x.useEffect(() => {
    try {
      localStorage.setItem("sh_make_qr", String(jl));
    } catch {}
  }, [jl]),
    x.useEffect(() => {
      try {
        localStorage.setItem("sh_fb_link", String(MvFb));
      } catch {}
    }, [MvFb]),
    x.useEffect(() => {
      jl && At
        ? um
            .toDataURL(At, {
              width: 320,
              margin: 2,
              color: { dark: "#0b132b", light: "#ffffff" },
            })
            .then((i) => Ql(i))
            .catch((i) => console.error("Error generating QR code:", i))
        : Ql("");
    }, [jl, At]));
  const $s = async () => {
      if (ya)
        try {
          const B = await (await fetch(ya)).blob();
          if (navigator.clipboard && window.ClipboardItem)
            (await navigator.clipboard.write([
              new ClipboardItem({ [B.type]: B }),
            ]),
              Ol(!0),
              setTimeout(() => Ol(!1), 2500));
          else {
            const q = document.createElement("a");
            ((q.href = ya),
              (q.download = `qr-code-${Date.now()}.png`),
              q.click());
          }
        } catch (i) {
          console.error("Failed to copy QR code image:", i);
        }
    },
    wn = () => {
      if (!ya) return;
      const i = document.createElement("a");
      ((i.href = ya),
        (i.download = `qr-code-${Date.now()}.png`),
        document.body.appendChild(i),
        i.click(),
        document.body.removeChild(i));
    };
  (x.useEffect(() => {
    try {
      localStorage.setItem("sh_custom_desc", je);
    } catch {}
  }, [je]),
    x.useEffect(() => {
      try {
        localStorage.setItem("sh_preview_desc", gt);
      } catch {}
    }, [gt]),
    x.useEffect(() => {
      try {
        localStorage.setItem("sh_preview_color", va);
      } catch {}
    }, [va]),
    x.useEffect(() => {
      try {
        localStorage.setItem("sh_preview_bgcolor", Ta);
      } catch {}
    }, [Ta]),
    x.useEffect(() => {
      try {
        localStorage.setItem("sh_use_desc", String(ta));
      } catch {}
    }, [ta]),
    x.useEffect(() => {
      Et(
        xa
          ? b === "ar"
            ? "جارٍ إنشاء الرابط..."
            : "Creating your link..."
          : At
            ? ta
              ? `${je}
${At}`
              : At
            : "",
      );
    }, [At, ta, je, xa, b]));
  const Qs = (i) => {
      const B = document.getElementById("customDescriptionInput");
      if (!B) {
        ws((ca) => ca + i);
        return;
      }
      const q = B.selectionStart,
        me = B.selectionEnd,
        ge = B.value,
        xe = ge.substring(0, q),
        Ce = ge.substring(me, ge.length),
        Zt = xe + i + Ce;
      (ws(Zt),
        setTimeout(() => {
          (B.focus(), B.setSelectionRange(q + i.length, q + i.length));
        }, 0));
    },
    [_a, Kl] = x.useState("shorten"),
    [kl, Da] = x.useState(""),
    [Ul, za] = x.useState(!1),
    [d, S] = x.useState(""),
    [p, Q] = x.useState(null),
    [E, Z] = x.useState(""),
    [M, K] = x.useState(!1),
    [ne, ce] = x.useState(""),
    [he, pt] = x.useState(null),
    [pa, Tt] = x.useState(null),
    [wa, Ee] = x.useState(!1),
    [He, ia] = x.useState(!1),
    [Cl, La] = x.useState(""),
    [Sl, Ba] = x.useState(""),
    [vt, Oa] = x.useState(""),
    [Zl, Ks] = x.useState("Verify"),
    [El, Al] = x.useState(""),
    [xi, sr] = x.useState("settings");
  x.useEffect(() => {
    if (f.FAVICON_URL) {
      let i = document.querySelector("link[rel~='icon']");
      (i ||
        ((i = document.createElement("link")),
        (i.rel = "icon"),
        document.head.appendChild(i)),
        (i.href = f.FAVICON_URL));
    }
  }, [f.FAVICON_URL]);
  const Jr = () => {
      const i = Number(localStorage.getItem("sh_auth_lock_until") || 0);
      return Date.now() < i
        ? !0
        : (i > 0 && localStorage.removeItem("sh_auth_lock_until"), !1);
    },
    Wr = (i) => {
      if (Jr()) {
        alert(
          b === "ar"
            ? "الوصول محظور لمدة 100 ساعة بسبب محاولات تسجيل دخول غير صالحة."
            : "Access is locked for 100 hours due to invalid login attempts.",
        );
        return;
      }
      sr(i);
      const B = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
      let q = "";
      for (let me = 0; me < 6; me++)
        q += B.charAt(Math.floor(Math.random() * B.length));
      (Ks(q), Oa(""), Al(""), ia(!0));
    },
    [nr, Jl] = x.useState(
      () =>
        window.location.pathname === "/admin" ||
        window.location.pathname === "/dashboard",
    ),
    [gd, Ns] = x.useState(() => {
      try {
        return !!(localStorage.getItem("sh_admin_token") || "");
      } catch {
        return !1;
      }
    }),
    [la, jn] = x.useState(() => {
      try {
        const i = localStorage.getItem("sh_cookie_consent");
        if (i) return JSON.parse(i);
      } catch {}
      return null;
    }),
    [fi, Ml] = x.useState(!1),
    [rr, Wl] = x.useState(!1),
    [Pr, Zs] = x.useState(la ? la.analytics : !1),
    [or, Js] = x.useState(la ? la.marketing : !1),
    [Ua, eo] = x.useState(!1),
    Ws = (i) => {
      (Tt(i),
        Ll(
          {
            privacy: "/privacy-policy",
            terms: "/terms-of-service",
            contact: "/contact-us",
            about: "/about-us",
            cookie: "/cookie-policy",
          }[i] || `/${i}`,
        ));
    },
    pi = () => {
      (Tt(null), Ll(j === "timer" ? "/timer-usa" : "/deals"));
    },
    mi = () => {
      (Ee(!0), Ll("/settings"));
    },
    hi = () => {
      (Ee(!1), Ll("/timer-usa"));
    },
    ja = (i = "timer") => {
      (se(i),
        Ll(
          {
            timer: "/timer-usa",
            deals: "/deals",
            manual_deals: "/manual-deals",
            network_leads: "/network-leads",
          }[i] || "/",
        ));
    },
    ir = (i) => {
      (Kl(i), Ll(i === "download" ? "/download" : i === "ip" ? "/ip" : "/"));
    },
    Nn = () => {
      const i = window.location.pathname.toLowerCase();
      (i === "/privacy-policy" || i === "/privacy"
        ? (Tt("privacy"), Ee(!1))
        : i === "/terms-of-service" || i === "/terms"
          ? (Tt("terms"), Ee(!1))
          : i === "/contact-us" || i === "/contact"
            ? (Tt("contact"), Ee(!1))
            : i === "/about-us" || i === "/about"
              ? (Tt("about"), Ee(!1))
              : i === "/cookie-policy" || i === "/cookie"
                ? (Tt("cookie"), Ee(!1))
                : i === "/settings" || i === "/configure"
                  ? (Ee(!0), Tt(null))
                  : (Tt(null), Ee(!1)),
        i === "/admin" || i === "/dashboard"
          ? !!(localStorage.getItem("sh_admin_token") || "")
            ? (Jl(!0), Ns(!0))
            : (Jl(!1), Ns(!1), Ll("/"))
          : (Jl(!1),
            se(
              i === "/deals"
                ? "deals"
                : i === "/manual-deals"
                  ? "manual_deals"
                  : i === "/network-leads"
                    ? "network_leads"
                    : i === "/timer-usa" || i === "/timer"
                      ? "timer"
                      : "deals",
            ),
            i === "/download" || i === "/fb-downloader"
              ? Kl("download")
              : i === "/ip" || i === "/ip-detective"
                ? Kl("ip")
                : i === "/qr" || i === "/qr-code"
                  ? (Kl("shorten"), aa(!0))
                  : (i === "/shorten" || i === "/") && Kl("shorten")));
    };
  (x.useEffect(() => {
    Nn();
    const i = () => {
      Nn();
    };
    return (
      window.addEventListener("popstate", i),
      () => window.removeEventListener("popstate", i)
    );
  }, []),
    x.useEffect(() => {
      nr &&
        !(localStorage.getItem("sh_admin_token") || "") &&
        (Jl(!1), Ns(!1), Ll("/"));
    }, [nr]));
  const mvSrvAuth = (u, p) => {
      window.__mvAuthErr = "";
      try {
        const r = new XMLHttpRequest();
        (r.open("POST", "/api/admin/session.php", !1),
          r.setRequestHeader("Content-Type", "application/json"),
          r.send(JSON.stringify({ username: u, password: p })));
        if (r.status === 200) {
          const j = JSON.parse(r.responseText || "{}");
          if (j && j.success && j.token)
            return (localStorage.setItem("sh_admin_token", j.token), !0);
          window.__mvAuthErr = "server";
        } else r.status !== 401 && (window.__mvAuthErr = "server");
      } catch {
        window.__mvAuthErr = "server";
      }
      return !1;
    },
    Ps = (i) => {
      if ((i.preventDefault(), Jr())) {
        ia(!1);
        return;
      }
      window.__mvAuthErr = "";
      const B = Cl.trim() !== "",
        q = Sl !== "",
        me =
          vt.trim() !== "" &&
          (vt.trim() === Sl.trim() ||
            vt.trim().toLowerCase() ===
              String(Zl || "")
                .trim()
                .toLowerCase());
      B &&
      q &&
      me &&
      (window.__mvLoginGate
        ? window.__mvLoginGate(Cl.trim(), Sl, vt.trim(), !1)
        : mvSrvAuth(Cl.trim(), Sl))
        ? (Al(""),
          ia(!1),
          Ns(!0),
          xi === "dashboard" ? (Jl(!0), Ll("/admin")) : mi(),
          La(""),
          Ba(""),
          Oa(""))
        : window.__mvAuthErr === "server"
          ? (Al(
              b === "ar"
                ? "تعذر الاتصال بالخادم. حاول مرة أخرى."
                : "Could not reach the server. Please try again.",
            ),
            Oa(""))
          : (localStorage.setItem(
              "sh_auth_lock_until",
              String(Date.now() + 36e7),
            ),
            ia(!1),
            La(""),
            Ba(""),
            Oa(""),
            alert(
              b === "ar"
                ? "فشلت المصادقة. تم قفل الوصول لمدة 100 ساعة."
                : "Authentication failed. Access is locked for 100 hours.",
            ));
    },
    [Rl, en] = x.useState([!0, !1, !1, !1]),
    [cr, dr] = x.useState("");
  (x.useEffect(() => {
    const i = `p-${f.PALETTE || "blue"}`,
      B = ["p-blue", "p-emerald", "p-violet", "p-amber", "p-dark"];
    for (const o of B)
      o !== i &&
        (document.body.classList.remove(o),
        document.documentElement.classList.remove(o));
    (document.body.classList.add(i), document.documentElement.classList.add(i));
  }, [f.PALETTE]),
    x.useEffect(() => {
      ((document.documentElement.dir = b === "ar" ? "rtl" : "ltr"),
        (document.documentElement.lang = b),
        localStorage.setItem("sh_lang", b));
    }, [b]),
    x.useEffect(() => {
      if (te) {
        Ml(!1);
        return;
      }
      const i = () => {
        try {
          const B = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (
            B &&
            (B.startsWith("Europe/") ||
              B.startsWith("Atlantic/Azores") ||
              B.startsWith("Atlantic/Canary") ||
              B.startsWith("Europe/London") ||
              B.startsWith("Europe/Dublin") ||
              B.includes("UTC") ||
              B.includes("GMT"))
          )
            return !0;
          const q = navigator.languages || [navigator.language],
            me = [
              "fr",
              "de",
              "it",
              "es",
              "pt",
              "nl",
              "be",
              "lu",
              "ie",
              "at",
              "fi",
              "se",
              "dk",
              "pl",
              "cz",
              "sk",
              "hu",
              "ro",
              "bg",
              "hr",
              "si",
              "gr",
              "cy",
              "mt",
              "ee",
              "lv",
              "lt",
              "gb",
            ];
          for (const ge of q) {
            const xe = ge.split("-")[1]?.toLowerCase();
            if (xe && me.includes(xe)) return !0;
          }
        } catch {}
        return !1;
      };
      if (!la)
        if (i()) Ml(!0);
        else {
          const B = {
            necessary: !0,
            analytics: !0,
            marketing: !0,
            timestamp: Date.now(),
            version: "1.0",
          };
          (jn(B),
            Zs(!0),
            Js(!0),
            localStorage.setItem("sh_cookie_consent", JSON.stringify(B)));
        }
    }, [la, te]),
    x.useEffect(() => {
      if (te) return;
      const i = () => {
          if (la && la.marketing) {
            const q = "adsense-script";
            if (
              !document.getElementById(q) &&
              f.ADSENSE_CLIENT &&
              f.ADSENSE_CLIENT !== "ca-pub-XXXXXXXXXXXXXXXX"
            ) {
              const ge = document.createElement("script");
              ((ge.id = q),
                (ge.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${f.ADSENSE_CLIENT}`),
                (ge.async = !0),
                (ge.crossOrigin = "anonymous"),
                document.head.appendChild(ge));
            }
            const me = "yandex-script";
            if (
              !document.getElementById(me) &&
              f.YANDEX_BLOCK &&
              f.YANDEX_BLOCK !== "R-A-XXXXXXX-1"
            ) {
              const ge = document.createElement("script");
              ((ge.id = me),
                (ge.src = "https://ya.ru/js/sdk/v2/clb.js"),
                (ge.async = !0),
                document.head.appendChild(ge));
            }
          }
          if (la && la.analytics && !/^G-X+$/.test("G-XXXXXXXXXX")) {
            const q = "ga-script";
            if (!document.getElementById(q)) {
              const me = document.createElement("script");
              ((me.id = q),
                (me.src =
                  "https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX"),
                (me.async = !0),
                document.head.appendChild(me));
              const ge = document.createElement("script");
              ((ge.id = "ga-init-script"),
                (ge.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-XXXXXXXXXX');
          `),
                document.head.appendChild(ge));
            }
          }
        },
        B = setTimeout(() => {
          typeof window.requestIdleCallback == "function"
            ? window.requestIdleCallback(() => i())
            : i();
        }, 2500);
      return () => clearTimeout(B);
    }, [la, f.ADSENSE_CLIENT, f.YANDEX_BLOCK, te]),
    x.useEffect(() => {
      if (te) return;
      let i = !1,
        B = null;
      const q = async () => {
          if (i) return;
          let ge = !1;
          try {
            const Ce = document.createElement("div");
            ((Ce.className = "adsbygoogle ads-box ad-banner ad-placement"),
              Ce.setAttribute(
                "style",
                "position: absolute; left: -9999px; top: -9999px; width: 10px; height: 10px; display: block !important;",
              ),
              document.body.appendChild(Ce));
            const Zt = window.getComputedStyle(Ce);
            ((ge =
              Ce.offsetHeight === 0 ||
              Ce.offsetWidth === 0 ||
              Zt.display === "none" ||
              Zt.visibility === "hidden"),
              document.body.removeChild(Ce));
          } catch {}
          let xe = !1;
          if (ge)
            try {
              await fetch(
                "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
                { method: "HEAD", mode: "no-cors", cache: "no-store" },
              );
            } catch {
              xe = !0;
            }
          i || eo(!!(ge && xe));
        },
        me = () => {
          B = setTimeout(q, 2e3);
        };
      return (
        document.readyState === "complete"
          ? me()
          : window.addEventListener("load", me),
        () => {
          ((i = !0),
            B && clearTimeout(B),
            window.removeEventListener("load", me));
        }
      );
    }, [te]),
    x.useEffect(() => {
      let i = null;
      const B = window.location.search;
      if (B && B.length >= 2) {
        const xe = B.substring(1),
          Ce = /(?:^|&)u=([^&]+)/.exec(xe);
        if (Ce) {
          try {
            let Ot = Ce[1].replace(/-/g, "+").replace(/_/g, "/");
            for (; Ot.length % 4;) Ot += "=";
            const Tl = decodeURIComponent(escape(window.atob(Ot)));
            /^https?:\/\//i.test(Tl) &&
              (/(?:^|&)p=1(?:&|$)/.test(xe)
                ? (Ve("preview"), Me(Tl))
                : (Ve("resolving"), Me(Tl), window.location.replace(Tl)));
          } catch {
            oi();
          }
          return;
        }
        const Zt = xe.split("&")[0],
          ca = [
            "p",
            "u",
            "code",
            "go",
            "confirm",
            "ref",
            "fbclid",
            "gclid",
            "utm_source",
            "utm_medium",
          ];
        if (Zt.indexOf("=") === -1 && !ca.includes(Zt.toLowerCase())) {
          const Ot = decodeURIComponent(Zt.replace(/\/$/, "")).toLowerCase();
          /^[a-z0-9_-]+$/.test(Ot) && (i = Ot);
        }
      }
      if (
        !i &&
        window.location.pathname &&
        window.location.pathname !== "/" &&
        window.location.pathname !== "/index.html"
      ) {
        const xe = window.location.pathname.replace(/^\/+|\/+$/g, ""),
          Ce = hd;
        xe &&
          /^[a-z0-9_-]+$/i.test(xe) &&
          !Ce.includes(xe.toLowerCase()) &&
          (i = xe.toLowerCase());
      }
      if (!i) {
        Ve(null);
        return;
      }
      i && ot(i);
      const q = async (xe) => {
          if (
            xe.onlyUsaCaUk ||
            (Array.isArray(xe.otherCountries) && xe.otherCountries.length > 0)
          ) {
            let Ot = "";
            try {
              const Ma = await fetch("/api/visitor-country");
              Ma.ok &&
                (Ot = ((await Ma.json()).countryCode || "").toUpperCase());
            } catch (Ma) {
              console.error("Failed to check visitor country:", Ma);
            }
            if (!Ot)
              try {
                const Ma = await fetch("https://ipapi.co/json/");
                Ma.ok &&
                  (Ot = ((await Ma.json()).country_code || "").toUpperCase());
              } catch {}
            const Tl = [];
            if (
              (xe.onlyUsaCaUk && Tl.push("US", "CA", "GB", "UK"),
              Array.isArray(xe.otherCountries) &&
                Tl.push(
                  ...xe.otherCountries.map((Ma) => String(Ma).toUpperCase()),
                ),
              Ot && !Tl.includes(Ot))
            ) {
              (console.log(
                `[Geo Restricted] Visitor country "${Ot}" not allowed for this link. Allowed: ${Tl.join(",")}. Redirecting home.`,
              ),
                window.location.replace(
                  window.location.origin + window.location.pathname,
                ));
              return;
            }
          }
          const Zt = new URLSearchParams(window.location.search),
            ca = Zt.has("go") || Zt.has("direct") || Zt.has("confirm");
          xe.preview && !ca
            ? (Ze(xe.title || null),
              $e(xe.previewDescription || xe.description || null),
              Oe(xe.previewAccentColor || null),
              nt(xe.previewBgColor || null),
              oe(xe.image || null),
              C(xe.multiDealsData || null),
              X(!!(xe.showStoreLogo || xe.storeLogo)),
              Ht(xe.storeLandingPage || null),
              Vt(xe.storeLandingTheme || "classic-store"),
              ye(!!xe.storeBackgroundImage),
              $t(xe.storeCardBg || null),
              Ve("preview"),
              Me(xe.url))
            : window.location.replace(xe.url);
        },
        me = window.__INITIAL_LINK_DATA__;
      if (me && me.url) {
        q(me);
        return;
      }
      if (
        /XXXX|your-app-default/i.test(ri(f.FIREBASE_URL)) ||
        !ri(f.FIREBASE_URL)
      )
        try {
          const xe = JSON.parse(localStorage.getItem("sh_local_links") || "{}"),
            Ce = i ? xe[i] : null;
          Ce && Ce.url
            ? setTimeout(() => {
                q(Ce);
              }, 300)
            : oi();
        } catch {
          oi();
        }
      else if (i) {
        const xe = nf(f.FIREBASE_URL);
        (async () => {
          for (const Ce of xe)
            try {
              const ca = await (await fetch(`${Ce}/links/${i}.json`)).json();
              if (ca && ca.url && /^https?:\/\//i.test(ca.url)) {
                q(ca);
                return;
              }
            } catch {}
          oi();
        })();
      }
    }, [f.FIREBASE_URL]),
    x.useEffect(() => {}, [b]));
  const ur = (i) => {
      const B = { ...i, FIREBASE_URL: Qx(i.FIREBASE_URL) };
      (V(B),
        fetch("/api/settings", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(B),
        }).catch((q) =>
          console.error("Failed to sync settings with server:", q),
        ));
    },
    xr = () => {
      (V(ni),
        localStorage.removeItem("sh_settings"),
        fetch("/api/settings", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        }).catch((i) =>
          console.error("Failed to sync reset settings with server:", i),
        ));
    },
    Pl = {
      bad: {
        en: "Enter a destination starting with http:// or https://",
        ar: "أدخل رابطًا يبدأ بـ http:// أو https://",
      },
      saving: { en: "Creating your link...", ar: "جارٍ إنشاء الرابط..." },
      done: {
        en: "Short link ready. Copy it and share it.",
        ar: "الرابط جاهز. انسخه وشاركه.",
      },
      copied: { en: "Copied!", ar: "تم النسخ!" },
      net: {
        en: "Could not reach the database. Check FIREBASE_URL in Settings.",
        ar: "تعذر الاتصال بقاعدة البيانات. تحقق من العنوان في الإعدادات.",
      },
      cfg: {
        en: "Please set up your FIREBASE_URL first.",
        ar: "يرجى تعيين عنوان قاعدة بيانات Firebase أولاً.",
      },
      empty: { en: "Nothing to copy yet.", ar: "لا يوجد رابط للنسخ بعد." },
      aboutTitle: { en: "About this tool", ar: "عن الأداة" },
      aboutLead: {
        en: "Unlock seamless CPA marketing with our powerful URL shortener. Create clean, branded short links optimized for global platforms including Facebook, Instagram, TikTok, YouTube, X (Twitter), Telegram, and Discord. Fully compatible with affiliate & influencer networks like Mavely, Collective Voice, Shopyoulikes, Amazon Associates, ShareASale, ClickBank, Impact, CJ Affiliate, and more. Track clicks, conversions, and performance in real-time with advanced analytics, custom domains, and QR codes.",
        ar: "اكتشف أداة تقصير الروابط القوية المصممة خصيصًا لتسويق عروض CPA وحملات العمولة. أنشئ روابط قصيرة نظيفة ومخصصة تعمل بكفاءة على جميع المنصات العالمية: فيسبوك، إنستغرام، تيك توك، يوتيوب، إكس (تويتر)، تيليجرام، وديسكورد. متوافقة تمامًا مع شبكات التسويق بالعمولة مثل Mavely، Collective Voice، Shopyoulikes، Amazon Associates، ShareASale، ClickBank، Impact، CJ Affiliate، وغيرها الكثير.",
      },
      noticeTitle: { en: "Important notice", ar: "تنبيه هام" },
      noticeLead: {
        en: "If any links on our site are no longer working or have expired, please use our alternative website. All content and services are fully available there.",
        ar: "إذا كانت أي روابط على موقعنا غير فعالة أو قد انتهت صلاحيتها، يُرجى استخدام موقعنا البديل. جميع المحتويات والخدمات متوفرة بالكامل هناك.",
      },
      whyTitle: { en: "Why use it", ar: "لماذا تستخدمها؟" },
      whyHeading: {
        en: "Built for marketers, not just for shortening",
        ar: "مصممة للمسوّقين، وليس للتقصير فقط",
      },
      faqTitle: { en: "FAQ", ar: "الأسئلة الشائعة" },
      freeTag: {
        en: "Free forever · No signup · Unlimited links",
        ar: "مجاني دائمًا · بدون تسجيل · روابط غير محدودة",
      },
      inputPlaceholder: { en: "Paste a long url", ar: "ألصق رابطًا طويلًا" },
      shortenBtn: { en: "Shorten", ar: "اختصار" },
      previewOption: {
        en: "Add a Free Landing Page (safer for Facebook)",
        ar: "إضافة صفحة هبوط مجانية (أكثر أمانًا لفيسبوك)",
      },
      geoOption: {
        en: "🇺🇸 🇨🇦 🇬🇧 Only USA/CA/UK",
        ar: "🇺🇸 🇨🇦 🇬🇧 أمريكا وكندا وبريطانيا فقط",
      },
      ticks1: { en: "No account needed", ar: "بدون حساب" },
      ticks2: { en: "Works on every platform", ar: "يعمل على كل المنصات" },
      ticks3: { en: "Links never expire", ar: "روابط لا تنتهي" },
      copyBtn: { en: "Copy link", ar: "نسخ" },
    },
    Kt = (i) => (Pl[i] ? Pl[i][b] : "");
  x.useEffect(() => {
    if (At && Ke) {
      const i = Ke.trim();
      i &&
        fetch("/api/deals/link-shortened", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            longUrl: i,
            newShortlink: At,
            useDescription: ta,
            customDescription: ta && je && je.trim() ? je.trim() : null,
          }),
        })
          .then(() => {
            (window.dispatchEvent(new Event("sh_link_shortened")),
              Ae((B) => B + 1));
          })
          .catch((B) =>
            console.error("Error updating deal shortener link:", B),
          );
    }
  }, [ta, je]);
  const to = () => {
      const i = Ke.trim();
      if (!/^https?:\/\//i.test(i)) {
        (tl("bad"), It(!1));
        return;
      }
      if (xt && O && le.slice(0, G).some((ge) => ge.trim() && !Kx(ge))) {
        (tl("bad"), It(!1));
        return;
      }
      (yl(""), vn(!0), tl("saving"), It(!0));
      const B =
        /XXXX|your-app-default/i.test(ri(f.FIREBASE_URL)) ||
        !ri(f.FIREBASE_URL);
      fetch("/api/shorten", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          url: i,
          preview: xt,
          onlyUsaCaUk: Lt,
          otherCountries: Bt,
          creatorId: I,
          fbLink: MvFb || void 0,
          customDescription: ta && je && je.trim() ? je.trim() : null,
          previewDescription: xt ? gt : null,
          previewAccentColor: xt ? va : null,
          previewBgColor: xt ? Ta : null,
          multiDeals: xt && O,
          multiDealsCount: xt && O ? G : null,
          multiDealsLinks: xt && O ? le.slice(0, G).filter(Boolean) : null,
          showStoreLogo: xt ? D : !1,
          storeLogo: xt ? D : !1,
          storeLandingPage: xt ? pe : null,
          storeLandingTheme: xt && pe ? Xt : null,
          storeBackgroundImage: xt && pe ? Te : !1,
          storeCardBg: xt && pe ? bt() : null,
          store: ea,
        }),
      })
        .then((q) => {
          if (!q.ok) throw new Error("Server failed to shorten");
          return q.json();
        })
        .then((q) => {
          if (q.success && q.code) {
            const me = q.code,
              ge = q.payload;
            if (B)
              try {
                const Ce = JSON.parse(
                  localStorage.getItem("sh_local_links") || "{}",
                );
                ((Ce[me] = ge),
                  localStorage.setItem("sh_local_links", JSON.stringify(Ce)));
              } catch (Ce) {
                console.error("Local storage save failed:", Ce);
              }
            const xe =
              (MvFb ? MvFbPre : "") +
              `${(typeof window.__mvShortOrigin == "function" && window.__mvShortOrigin(me)) || window.location.origin}/${me}`;
            (yl(xe),
              tl("done"),
              It(!0),
              window.dispatchEvent(new Event("sh_link_shortened")),
              Ae((Ce) => Ce + 1),
              xm(ge?.store, ge?.resolvedUrl || ge?.finalUrl || i),
              fetch("/api/deals/link-shortened", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  longUrl: i,
                  resolvedUrl: ge?.resolvedUrl || ge?.finalUrl || i,
                  newShortlink: xe,
                  useDescription: ta,
                  customDescription: ta && je && je.trim() ? je.trim() : null,
                }),
              })
                .then(() => {
                  (window.dispatchEvent(new Event("sh_link_shortened")),
                    Ae((Ce) => Ce + 1));
                })
                .catch((Ce) =>
                  console.error("Error linking deal shortener:", Ce),
                ));
          } else (tl("net"), It(!1));
        })
        .catch((q) => {
          (console.error("Shortening API call failed:", q), tl("net"), It(!1));
        })
        .finally(() => {
          vn(!1);
        });
    },
    bi = () => {
      xa ||
        !At ||
        !ua ||
        (navigator.clipboard.writeText(ua), tl("copied"), It(!0));
    },
    fr = () => {
      const i = kl.trim();
      if (!i) {
        (S(
          b === "ar"
            ? "يرجى إدخال رابط فيديو فيسبوك."
            : "Please enter a Facebook video URL.",
        ),
          Q(null));
        return;
      }
      if (!/facebook\.com|fb\.watch|fb\.gg/i.test(i)) {
        (S(
          b === "ar"
            ? "رابط غير صالح. يرجى إدخال رابط فيديو فيسبوك صالح."
            : "Invalid URL. Please enter a valid Facebook video link.",
        ),
          Q(null));
        return;
      }
      (za(!0),
        S(""),
        Q(null),
        fetch("/api/download-fb-video", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url: i }),
        })
          .then((q) =>
            q.ok
              ? q.json()
              : q.json().then((me) => {
                  throw new Error(
                    me.error || "Failed to extract video details.",
                  );
                }),
          )
          .then((q) => {
            Q(q);
          })
          .catch((q) => {
            S(
              q.message ||
                "Failed to download Facebook video. Please check the URL and try again.",
            );
          })
          .finally(() => {
            za(!1);
          }));
    },
    kn = (i) => {
      const B = i !== void 0 ? i : E.trim();
      (K(!0),
        ce(""),
        fetch(`/api/ip-lookup?ip=${encodeURIComponent(B)}`)
          .then((q) => {
            if (!q.ok) throw new Error("Failed to lookup IP");
            return q.json();
          })
          .then((q) => {
            q && q.ip
              ? (pt(q), Z(q.ip))
              : ce(
                  b === "ar"
                    ? "فشل فحص الـ IP. يرجى المحاولة مرة أخرى."
                    : "Failed to resolve IP details.",
                );
          })
          .catch((q) => {
            (console.error("IP lookup error:", q),
              ce(
                b === "ar"
                  ? "تعذر فحص الـ IP. يرجى التحقق من الاتصال."
                  : "Could not reach IP registry. Verify connection.",
              ));
          })
          .finally(() => {
            K(!1);
          }));
    };
  x.useEffect(() => {
    _a === "ip" && !he && !M && kn("");
  }, [_a]);
  const _ = b === "ar";
  if (te)
    return l.jsx(pd, {
      mode: te,
      code: st,
      dest: ue,
      title: ke,
      description: it,
      image: Nt,
      language: b,
      theme: f.THEME || "modern-dark",
      palette: f.PALETTE,
      previewAccentColor: kt,
      previewBgColor: Pe,
      multiDealsData: Re,
      showStoreLogo: y,
      storeLandingPage: Ct,
      storeLandingTheme: ba || Xt,
      storeBackgroundImage: ht,
      storeCardBg: ul || bt(),
      onGoHome: () => {
        (window.history.pushState({}, "", window.location.pathname), Ve(null));
      },
    });
  if (nr)
    return l.jsx(om, {
      settings: f,
      onSaveSettings: ur,
      onResetSettings: xr,
      onGoHome: () => {
        (Jl(!1), window.history.pushState({}, "", "/"));
      },
      onLogout: () => {
        (localStorage.removeItem("sh_admin_token"),
          Ns(!1),
          Jl(!1),
          window.history.pushState({}, "", "/"));
      },
    });
  const ct = lf(f.THEME, f.PALETTE),
    A = f.THEME === "neon-cyber",
    Cn = () => {
      if (f.THEME && f.THEME !== "modern-dark") return;
      const i = f.CITY_BG_OPTION || "real_city";
      return i === "vector_city"
        ? {
            backgroundImage:
              "linear-gradient(rgba(10, 15, 30, 0.45), rgba(10, 15, 30, 0.60)), url('/city.svg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
          }
        : i === "dark_gradient"
          ? {
              background:
                "linear-gradient(135deg, #060d1b 0%, #0a192f 50%, #0f2744 100%)",
            }
          : {
              backgroundImage:
                "linear-gradient(rgba(10, 15, 30, 0.45), rgba(10, 15, 30, 0.60)), url('/content.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundAttachment: "fixed",
              backgroundRepeat: "no-repeat",
            };
    };
  return l.jsxs("div", {
    className: ct.wrapperBgClass + " mv-rd-app",
    ref: MvAppRef,
    style: Cn(),
    children: [
      l.jsx("header", {
        className: ct.headerClass + " mv-rd-head",
        children: l.jsxs("div", {
          className:
            "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3.5 flex items-center justify-between mv-rd-head-in",
          children: [
            l.jsxs("a", {
              href: "/",
              className:
                "flex items-center gap-2.5 hover:opacity-90 transition-opacity",
              children: [
                l.jsx("span", {
                  className:
                    "w-8.5 h-8.5 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 text-white flex items-center justify-center text-sm font-black shadow-md",
                  children: "🔗",
                }),
                l.jsx("span", {
                  className:
                    "font-extrabold text-base tracking-tight capitalize drop-shadow-sm",
                  children: f.BRAND,
                }),
              ],
            }),
            l.jsxs("nav", {
              "aria-label": "Social media channels",
              className: "flex items-center gap-2",
              children: [
                l.jsx("a", {
                  href: f.WHATSAPP,
                  target: "_blank",
                  rel: "noopener nofollow",
                  className:
                    "w-9 h-9 rounded-full bg-[#0f7d3f]/30 hover:bg-[#0f7d3f]/60 border border-[#0f7d3f]/50 text-emerald-400 flex items-center justify-center transition-all shadow-md hover:scale-110 active:scale-95 cursor-pointer",
                  title: "WhatsApp",
                  "aria-label": "WhatsApp",
                  children: l.jsx(Xp, { size: 18 }),
                }),
                l.jsx("a", {
                  href: f.FACEBOOK,
                  target: "_blank",
                  rel: "noopener nofollow",
                  className:
                    "w-9 h-9 rounded-full bg-[#1461c9]/30 hover:bg-[#1461c9]/60 border border-[#1461c9]/50 text-blue-400 flex items-center justify-center transition-all shadow-md hover:scale-110 active:scale-95 cursor-pointer",
                  title: "Facebook",
                  "aria-label": "Facebook",
                  children: l.jsx(Yp, { size: 18 }),
                }),
                l.jsx("a", {
                  href: f.TELEGRAM,
                  target: "_blank",
                  rel: "noopener nofollow",
                  className:
                    "w-9 h-9 rounded-full bg-[#16708f]/30 hover:bg-[#16708f]/60 border border-[#16708f]/50 text-sky-400 flex items-center justify-center transition-all shadow-md hover:scale-110 active:scale-95 cursor-pointer",
                  title: "Telegram",
                  "aria-label": "Telegram",
                  children: l.jsx(Ip, { size: 18 }),
                }),
                l.jsx("a", {
                  href: f.YOUTUBE,
                  target: "_blank",
                  rel: "noopener nofollow",
                  className:
                    "w-9 h-9 rounded-full bg-[#c8001f]/30 hover:bg-[#c8001f]/60 border border-[#c8001f]/50 text-rose-400 flex items-center justify-center transition-all shadow-md hover:scale-110 active:scale-95 cursor-pointer",
                  title: "YouTube",
                  "aria-label": "YouTube",
                  children: l.jsx(qp, { size: 18 }),
                }),
              ],
            }),
            l.jsxs("div", {
              className:
                "flex items-center gap-1.5 bg-slate-900/60 backdrop-blur-md p-1 rounded-xl border border-white/10 mv-rd-langs",
              children: [
                l.jsx("button", {
                  onClick: () => h("en"),
                  className: `px-3 py-1.5 text-xs font-bold rounded-lg cursor-pointer transition-all ${b === "en" ? "bg-blue-600 text-white shadow-md" : "text-slate-300 hover:text-white"}`,
                  children: "English",
                }),
                l.jsx("button", {
                  onClick: () => h("ar"),
                  className: `px-3 py-1.5 text-xs font-bold rounded-lg cursor-pointer transition-all ${b === "ar" ? "bg-blue-600 text-white shadow-md" : "text-slate-300 hover:text-white"}`,
                  children: "العربية",
                }),
              ],
            }),
          ],
        }),
      }),
      l.jsx("section", {
        className:
          "relative pt-8 pb-6 md:pt-12 md:pb-8 overflow-hidden select-none mv-rd-hero",
        children: l.jsx("div", {
          className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mv-rd-hero-in",
          children: l.jsxs("div", {
            className: ct.heroGridClass + " mv-rd-grid",
            children: [
              l.jsx("aside", {
                className: "mv-rd-left",
                "data-mv-rd": "left",
                children: l.jsx("div", {
                  className: "mv-rd-left-in",
                  children: l.jsx(x.Suspense, {
                    fallback: l.jsx("div", {
                      className:
                        "mv-rd-left-load w-full bg-[#0b132b] border border-slate-700/60 rounded-2xl p-5 text-center min-h-[200px] flex items-center justify-center",
                      children: l.jsx("div", {
                        className:
                          "w-6 h-6 border-2 border-purple-500 border-t-transparent rounded-full animate-spin",
                      }),
                    }),
                    children: l.jsx(pm, { language: b, refreshKey: W }),
                  }),
                }),
              }),
              l.jsxs("div", {
                className: ct.formOrderClass + " mv-rd-center",
                children: [
                  l.jsx("div", {
                    className: `${ct.badgeContainerClass}`,
                    children: l.jsxs("div", {
                      className: `px-4 py-2 text-xs font-extrabold ${ct.badgeClass}`,
                      children: [
                        l.jsx("span", {
                          className:
                            "w-2.5 h-2.5 bg-emerald-500 rounded-full shadow-[0_0_0_4px_rgba(16,185,129,0.3)] animate-pulse inline-block mr-2",
                        }),
                        l.jsx("span", { children: Kt("freeTag") }),
                      ],
                    }),
                  }),
                  l.jsx("h1", {
                    className: `text-3xl sm:text-4xl md:text-5xl font-black tracking-tight leading-tight mb-4 select-text ${ct.headingTextClass}`,
                    children: _
                      ? l.jsxs(l.Fragment, {
                          children: [
                            "مختصر روابط ذكي لأجل",
                            l.jsx("br", {}),
                            l.jsx("span", {
                              className: `inline-block min-h-[1.2em] ${ct.typewriterClass}`,
                              "data-mv-tw": "",
                              children: l.jsx(MvTw, { lang: b }),
                            }),
                            l.jsx("span", {
                              className:
                                "inline-block w-1 h-[0.9em] bg-current mr-1 animate-[blink_1s_steps(2)_infinite]",
                            }),
                          ],
                        })
                      : l.jsxs(l.Fragment, {
                          children: [
                            "Smart link shortener for",
                            l.jsx("br", {}),
                            l.jsx("span", {
                              className: `inline-block min-h-[1.2em] ${ct.typewriterClass}`,
                              "data-mv-tw": "",
                              children: l.jsx(MvTw, { lang: b }),
                            }),
                            l.jsx("span", {
                              className:
                                "inline-block w-1 h-[0.9em] bg-current ml-1 animate-[blink_1s_steps(2)_infinite]",
                            }),
                          ],
                        }),
                  }),
                  l.jsx("p", {
                    className: `text-sm sm:text-base md:text-lg max-w-xl leading-relaxed mb-8 select-text ${ct.subTextClass}`,
                    children: _
                      ? "حوّل الروابط الطويلة إلى روابط قصيرة نظيفة تعمل على فيسبوك وإنستغرام وتيك توك ويوتيوب وإكس وتيليجرام وديسكورد. مصممة لتسويق CPA والتسويق بالعمولة."
                      : "Turn long tracking URLs into clean, branded short links that work on Facebook, Instagram, TikTok, YouTube, X, Telegram and Discord. Built for CPA marketing and affiliate campaigns.",
                  }),
                  ct.stepWorkflowVisible &&
                    l.jsxs("div", {
                      className:
                        "w-full max-w-xl mb-4 bg-slate-200/90 border-2 border-slate-300 rounded-lg p-2.5 flex items-center justify-between text-xs font-mono font-bold text-slate-800",
                      children: [
                        l.jsxs("div", {
                          className: `flex items-center gap-1.5 ${_a === "shorten" ? "text-slate-950 font-extrabold" : "text-slate-600"}`,
                          children: [
                            l.jsx("span", {
                              className:
                                "w-5 h-5 rounded bg-slate-900 text-white text-[10px] flex items-center justify-center",
                              children: "1",
                            }),
                            l.jsx("span", {
                              children: _ ? "اختيار الأداة" : "Select Tool",
                            }),
                          ],
                        }),
                        l.jsx("span", {
                          className: "text-slate-400",
                          children: "➔",
                        }),
                        l.jsxs("div", {
                          className:
                            "flex items-center gap-1.5 text-slate-900 font-extrabold",
                          children: [
                            l.jsx("span", {
                              className:
                                "w-5 h-5 rounded bg-slate-900 text-white text-[10px] flex items-center justify-center",
                              children: "2",
                            }),
                            l.jsx("span", {
                              children: _ ? "إدخال الرابط" : "Input Link",
                            }),
                          ],
                        }),
                        l.jsx("span", {
                          className: "text-slate-400",
                          children: "➔",
                        }),
                        l.jsxs("div", {
                          className: "flex items-center gap-1.5 text-slate-600",
                          children: [
                            l.jsx("span", {
                              className:
                                "w-5 h-5 rounded bg-slate-400 text-white text-[10px] flex items-center justify-center",
                              children: "3",
                            }),
                            l.jsx("span", {
                              children: _ ? "إنشاء الرابط" : "Generate Link",
                            }),
                          ],
                        }),
                      ],
                    }),
                  l.jsxs("div", {
                    className: ct.tabsLayoutClass + " mv-rd-modes",
                    children: [
                      l.jsx("button", {
                        onClick: () => ir("shorten"),
                        className: `px-4.5 py-2.5 text-xs sm:text-sm font-extrabold transition-all cursor-pointer ${_a === "shorten" ? ct.activeTabClass : ct.inactiveTabClass}`,
                        children: b === "ar" ? "تقصير الروابط" : "Shorten",
                      }),
                      l.jsx("button", {
                        onClick: () => ir("ip"),
                        className: `px-4.5 py-2.5 text-xs sm:text-sm font-extrabold transition-all cursor-pointer ${_a === "ip" ? ct.activeTabClass : ct.inactiveTabClass}`,
                        children: b === "ar" ? "مكتشف IP" : "IP Detective",
                      }),
                      l.jsx("button", {
                        onClick: () => ir("download"),
                        className: `px-4.5 py-2.5 text-xs sm:text-sm font-extrabold transition-all cursor-pointer ${_a === "download" ? ct.activeTabClass : ct.inactiveTabClass}`,
                        children:
                          b === "ar" ? "تحميل فيديو FB" : "Download Video FB",
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: `w-full max-w-xl space-y-3.5 transition-all duration-300 ${ct.cardClass} mv-rd-card`,
                    children: [
                      _a === "shorten" &&
                        l.jsxs(l.Fragment, {
                          children: [
                            Ua &&
                              l.jsxs("div", {
                                className:
                                  "bg-rose-50 border border-rose-200 text-rose-800 p-4 rounded-xl text-xs sm:text-sm font-medium leading-relaxed space-y-1.5 select-text text-start",
                                children: [
                                  l.jsx("div", {
                                    className:
                                      "flex items-center gap-1.5 text-rose-600 font-extrabold text-sm uppercase tracking-wide",
                                    children: l.jsxs("span", {
                                      children: [
                                        "⚠️ ",
                                        _
                                          ? "تم اكتشاف مانع الإعلانات"
                                          : "Ad Blocker Detected",
                                      ],
                                    }),
                                  }),
                                  l.jsx("p", {
                                    children: _
                                      ? "موقعنا يعتمد بالكامل على الإعلانات لتوفير خدمة تقصير الروابط المجانية وحماية الروابط لجميع المستخدمين. لقد قمنا بتعطيل ميزة تقصير الروابط حتى تقوم بإلغاء تنشيط مانع الإعلانات."
                                      : "Our free service is funded by advertisements. To maintain and protect our link shortener, we disable the link shortening functionality while an ad blocker is active. Please turn off your ad blocker and reload the page to continue.",
                                  }),
                                  l.jsx("div", {
                                    className: "pt-1",
                                    children: l.jsx("button", {
                                      onClick: () => window.location.reload(),
                                      className:
                                        "px-3 py-1 bg-rose-600 hover:bg-rose-700 text-white rounded-lg font-bold text-xs cursor-pointer transition-colors",
                                      children: _
                                        ? "إعادة تحميل الصفحة"
                                        : "Reload Page",
                                    }),
                                  }),
                                ],
                              }),
                            l.jsxs("div", {
                              className:
                                "flex flex-col sm:flex-row gap-2.5 items-stretch sm:items-center mv-fbl-row",
                              children: [
                                l.jsxs("div", {
                                  className: "flex-1 flex gap-2",
                                  children: [
                                    l.jsx("input", {
                                      type: "url",
                                      inputMode: "url",
                                      placeholder: Kt("inputPlaceholder"),
                                      value: Ke,
                                      onChange: (i) => Fl(i.target.value),
                                      onKeyDown: (i) => {
                                        i.key === "Enter" && !Ua && to();
                                      },
                                      disabled: xa || Ua,
                                      className:
                                        "flex-1 p-3.5 border-2 border-slate-300 bg-white rounded-xl text-sm sm:text-base font-bold text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-600 transition-colors min-w-0 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm",
                                    }),
                                    l.jsx("button", {
                                      type: "button",
                                      onClick: () => Fl(""),
                                      disabled: Ua,
                                      className:
                                        "px-3.5 bg-rose-500 hover:bg-rose-600 text-white rounded-xl flex items-center justify-center transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer shadow-sm border border-rose-400/20",
                                      title: _ ? "مسح الرابط" : "Clear URL",
                                      children: l.jsx(qa, { size: 20 }),
                                    }),
                                  ],
                                }),
                                l.jsxs("div", {
                                  className:
                                    "flex items-center gap-2 mv-fbl-grp",
                                  children: [
                                    l.jsx(MvFbOpt, {
                                      on: MvFb,
                                      set: MvSetFb,
                                      off: Ua,
                                      neon: A,
                                      ar: _,
                                    }),
                                    l.jsxs("label", {
                                      className: `flex items-center gap-1.5 px-3 py-2.5 rounded-xl text-xs font-bold cursor-pointer select-none transition-all shrink-0 active:scale-95 shadow-sm border ${A ? "bg-[#050814] hover:bg-[#0c132c] border-cyan-500/50 text-cyan-100" : "bg-slate-100 hover:bg-slate-200 border-slate-300 text-slate-900"}`,
                                      title: _
                                        ? "إنشاء كود QR مع الرابط القصير"
                                        : "Create QR code with short link",
                                      children: [
                                        l.jsx("input", {
                                          type: "checkbox",
                                          checked: jl,
                                          onChange: (i) => aa(i.target.checked),
                                          disabled: Ua,
                                          className:
                                            "w-4 h-4 accent-cyan-500 cursor-pointer rounded",
                                        }),
                                        l.jsx(Lx, {
                                          size: 15,
                                          className: A
                                            ? "text-cyan-400 shrink-0"
                                            : "text-blue-600 shrink-0",
                                        }),
                                        l.jsx("span", {
                                          className: A
                                            ? "whitespace-nowrap text-cyan-100 font-extrabold"
                                            : "whitespace-nowrap text-slate-900 font-extrabold",
                                          children: _ ? "كود QR" : "QR Code",
                                        }),
                                      ],
                                    }),
                                    l.jsx("button", {
                                      onClick: to,
                                      disabled: xa || Ua,
                                      className:
                                        "bg-blue-600 hover:bg-blue-700 active:scale-[0.985] text-white font-extrabold px-6 py-3.5 rounded-xl shadow-lg shadow-blue-600/30 border border-blue-500/30 cursor-pointer transition-all shrink-0 text-sm disabled:from-slate-400 disabled:to-slate-500 disabled:bg-slate-400 disabled:cursor-not-allowed disabled:shadow-none",
                                      children: Kt("shortenBtn"),
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            l.jsx("div", {
                              className: `pt-2.5 border-t mt-1.5 ${A ? "border-cyan-500/30" : "border-slate-200"}`,
                              children: l.jsxs("div", {
                                className:
                                  "flex flex-col sm:flex-row sm:items-start justify-between gap-3",
                                children: [
                                  l.jsxs("label", {
                                    className:
                                      "flex items-center gap-2.5 cursor-pointer select-none text-xs sm:text-sm font-extrabold pt-0.5",
                                    children: [
                                      l.jsx("input", {
                                        type: "checkbox",
                                        checked: xt,
                                        onChange: (i) => ys(i.target.checked),
                                        className:
                                          "w-4.5 h-4.5 accent-cyan-500 cursor-pointer rounded",
                                      }),
                                      l.jsx("span", {
                                        className: A
                                          ? "text-cyan-100 font-extrabold"
                                          : "text-slate-900 font-extrabold",
                                        children: Kt("previewOption"),
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className:
                                      "flex flex-col items-start sm:items-end gap-1.5",
                                    children: [
                                      l.jsxs("div", {
                                        className: "flex items-center gap-1.5",
                                        children: [
                                          l.jsxs("label", {
                                            className:
                                              "flex items-center gap-2.5 cursor-pointer select-none text-xs sm:text-sm font-extrabold",
                                            children: [
                                              l.jsx("input", {
                                                type: "checkbox",
                                                checked: Lt,
                                                onChange: (i) => {
                                                  const B = i.target.checked;
                                                  (ft(B), B && el(!0));
                                                },
                                                className:
                                                  "w-4.5 h-4.5 accent-indigo-500 cursor-pointer rounded",
                                              }),
                                              l.jsxs("span", {
                                                className: `font-extrabold flex items-center gap-1.5 ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                children: [
                                                  l.jsx("img", {
                                                    src: "https://flagcdn.com/w40/us.png",
                                                    alt: "US",
                                                    className:
                                                      "w-4 h-3 object-cover rounded-sm border border-slate-300 shadow-sm shrink-0",
                                                  }),
                                                  l.jsx("img", {
                                                    src: "https://flagcdn.com/w40/ca.png",
                                                    alt: "CA",
                                                    className:
                                                      "w-4 h-3 object-cover rounded-sm border border-slate-300 shadow-sm shrink-0",
                                                  }),
                                                  l.jsx("img", {
                                                    src: "https://flagcdn.com/w40/gb.png",
                                                    alt: "UK",
                                                    className:
                                                      "w-4 h-3 object-cover rounded-sm border border-slate-300 shadow-sm shrink-0",
                                                  }),
                                                  l.jsx("span", {
                                                    children: _
                                                      ? "أمريكا وكندا وبريطانيا فقط"
                                                      : "Only USA/CA/UK",
                                                  }),
                                                ],
                                              }),
                                            ],
                                          }),
                                          l.jsx("button", {
                                            type: "button",
                                            onClick: (i) => {
                                              (i.preventDefault(),
                                                i.stopPropagation(),
                                                el(!0));
                                            },
                                            title: _
                                              ? "معلومات تقييد الدول"
                                              : "Country restriction info",
                                            className: `p-1 rounded-full transition-all cursor-pointer ${A ? "text-cyan-400 hover:bg-cyan-950/80 hover:text-cyan-200" : "text-indigo-600 hover:bg-indigo-50 hover:text-indigo-800"}`,
                                            children: l.jsx(af, { size: 14 }),
                                          }),
                                        ],
                                      }),
                                      l.jsx(cm, {
                                        selectedCountries: Bt,
                                        onChange: (i) => {
                                          (Pt(i), i.length > 0 && el(!0));
                                        },
                                        onInfoClick: () => el(!0),
                                        isDarkCard: A,
                                        isAr: _,
                                      }),
                                    ],
                                  }),
                                ],
                              }),
                            }),
                            xt &&
                              l.jsxs("div", {
                                className: `border-2 border-dashed rounded-2xl p-4 sm:p-5 space-y-4 animate-[revealUp_0.2s_ease-out] text-start shadow-sm ${A ? "bg-[#050814]/90 border-cyan-500/50 text-cyan-100" : "bg-slate-50 border-slate-300 text-slate-900"}`,
                                children: [
                                  l.jsxs("div", {
                                    className:
                                      "flex items-center justify-between",
                                    children: [
                                      l.jsxs("span", {
                                        className: `text-xs font-black uppercase tracking-wider flex items-center gap-1.5 ${A ? "text-cyan-300" : "text-blue-700"}`,
                                        children: [
                                          "🎨 ",
                                          _
                                            ? "تخصيص صفحة المعاينة"
                                            : "Preview Page Customization",
                                        ],
                                      }),
                                      l.jsx("span", {
                                        className: `text-[10px] px-2.5 py-0.5 rounded-full font-extrabold ${A ? "bg-cyan-950 text-cyan-300 border border-cyan-500/40" : "bg-blue-100 text-blue-800"}`,
                                        children: _
                                          ? "ميزة احترافية"
                                          : "PRO FEATURE",
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className: "space-y-1.5",
                                    children: [
                                      l.jsx("label", {
                                        className: `block text-xs font-black ${A ? "text-cyan-100" : "text-slate-900"}`,
                                        children: _
                                          ? "عبارة صفحة المعاينة (يمكنك كتابة نص مخصص أو اختيار عبارة جاهزة):"
                                          : "Choose a Redirect Description Preset (or type your own):",
                                      }),
                                      l.jsxs("div", {
                                        className:
                                          "flex flex-col sm:flex-row gap-2",
                                        children: [
                                          l.jsx("input", {
                                            type: "text",
                                            value: gt,
                                            onChange: (i) => js(i.target.value),
                                            placeholder: _
                                              ? "اكتب عبارة المعاينة هنا..."
                                              : "Type custom description here...",
                                            disabled: Ua,
                                            className: `flex-1 p-2.5 border-2 rounded-xl text-xs font-bold transition-colors shadow-sm min-w-0 ${A ? "bg-[#02050e] border-cyan-500/60 text-cyan-100 placeholder:text-cyan-600/70 focus:outline-none focus:border-fuchsia-500" : "bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-600"}`,
                                          }),
                                          l.jsxs("select", {
                                            value: [
                                              "🔥 Almost gone — tap Continue before it sells out.",
                                              "⏳ Price may end soon — tap Continue now.",
                                              "Your deal is ready 👇 Tap Continue to unlock it.",
                                              "One tap away 👉 Continue to see today's price.",
                                              "💰 Lowest price today — tap Continue to claim it.",
                                              "Handpicked deal",
                                              "Tap Continue to open the link safely.",
                                            ].includes(gt)
                                              ? gt
                                              : "custom",
                                            onChange: (i) => {
                                              const B = i.target.value;
                                              B !== "custom" && js(B);
                                            },
                                            disabled: Ua,
                                            className: `p-2.5 border-2 rounded-xl text-xs font-bold transition-colors shadow-sm shrink-0 sm:w-48 cursor-pointer ${A ? "bg-[#02050e] border-cyan-500/60 text-cyan-100 focus:outline-none focus:border-fuchsia-500" : "bg-white border-slate-300 text-slate-900 focus:outline-none focus:border-blue-600"}`,
                                            children: [
                                              l.jsx("option", {
                                                value: "custom",
                                                children: _
                                                  ? "⚡ اختيارات جاهزة..."
                                                  : "⚡ Select Preset...",
                                              }),
                                              l.jsxs("optgroup", {
                                                label: _
                                                  ? "الاستعجال والندرة"
                                                  : "Urgency / Scarcity",
                                                children: [
                                                  l.jsx("option", {
                                                    value:
                                                      "🔥 Almost gone — tap Continue before it sells out.",
                                                    children:
                                                      "🔥 Almost gone...",
                                                  }),
                                                  l.jsx("option", {
                                                    value:
                                                      "⏳ Price may end soon — tap Continue now.",
                                                    children:
                                                      "⏳ Price may end soon...",
                                                  }),
                                                ],
                                              }),
                                              l.jsxs("optgroup", {
                                                label: _
                                                  ? "فضول واهتمام"
                                                  : "Curiosity",
                                                children: [
                                                  l.jsx("option", {
                                                    value:
                                                      "Your deal is ready 👇 Tap Continue to unlock it.",
                                                    children:
                                                      "Your deal is ready...",
                                                  }),
                                                  l.jsx("option", {
                                                    value:
                                                      "One tap away 👉 Continue to see today's price.",
                                                    children: "One tap away...",
                                                  }),
                                                ],
                                              }),
                                              l.jsxs("optgroup", {
                                                label: _
                                                  ? "قيمة وخصم"
                                                  : "Value",
                                                children: [
                                                  l.jsx("option", {
                                                    value:
                                                      "💰 Lowest price today — tap Continue to claim it.",
                                                    children:
                                                      "💰 Lowest price today...",
                                                  }),
                                                  l.jsx("option", {
                                                    value: "Handpicked deal",
                                                    children: "Handpicked deal",
                                                  }),
                                                ],
                                              }),
                                              l.jsx("optgroup", {
                                                label: _ ? "مبسط" : "Minimal",
                                                children: l.jsx("option", {
                                                  value:
                                                    "Tap Continue to open the link safely.",
                                                  children: "Tap Continue...",
                                                }),
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className: `space-y-2 p-3 rounded-2xl border ${A ? "bg-[#030611] border-cyan-500/40 text-cyan-100" : "bg-slate-50/80 border-slate-200/80 text-slate-900"}`,
                                    children: [
                                      l.jsxs("div", {
                                        className:
                                          "flex items-center justify-between",
                                        children: [
                                          l.jsx("label", {
                                            className: `block text-xs font-black ${A ? "text-cyan-100" : "text-slate-900"}`,
                                            children: _
                                              ? "لون زر المتابعة والعناصر:"
                                              : "Accent Color for the Preview Page:",
                                          }),
                                          l.jsxs("div", {
                                            className: `flex p-0.5 rounded-lg text-[10px] font-bold ${A ? "bg-[#0a0f24] border border-cyan-500/30" : "bg-slate-200/80"}`,
                                            children: [
                                              l.jsx("button", {
                                                type: "button",
                                                onClick: () => {
                                                  (vs("solid"),
                                                    va.includes("gradient") &&
                                                      wl(Qa));
                                                },
                                                className: `px-2 py-0.5 rounded-md transition-all cursor-pointer ${zt === "solid" ? (A ? "bg-cyan-500 text-slate-950 shadow-sm" : "bg-white text-slate-900 shadow-sm") : A ? "text-cyan-300" : "text-slate-600"}`,
                                                children: _
                                                  ? "لون صلب"
                                                  : "Solid",
                                              }),
                                              l.jsx("button", {
                                                type: "button",
                                                onClick: () => {
                                                  (vs("gradient"),
                                                    ml(Qa, Ka, Za));
                                                },
                                                className: `px-2 py-0.5 rounded-md transition-all cursor-pointer ${zt === "gradient" ? (A ? "bg-cyan-500 text-slate-950 shadow-sm" : "bg-white text-slate-900 shadow-sm") : A ? "text-cyan-300" : "text-slate-600"}`,
                                                children: _
                                                  ? "تدرج (Gradient)"
                                                  : "Gradient",
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      zt === "solid"
                                        ? l.jsxs("div", {
                                            className:
                                              "flex flex-col sm:flex-row gap-3 items-start sm:items-center",
                                            children: [
                                              l.jsxs("div", {
                                                className: `flex items-center gap-1.5 rounded-xl p-1.5 pr-3 shadow-sm shrink-0 border ${A ? "bg-[#02050e] border-cyan-500/50 text-cyan-100" : "bg-white border-slate-300 text-slate-900"}`,
                                                children: [
                                                  l.jsx("input", {
                                                    type: "color",
                                                    value: va.includes(
                                                      "gradient",
                                                    )
                                                      ? Qa
                                                      : va,
                                                    onChange: (i) => {
                                                      (Il(i.target.value),
                                                        wl(i.target.value));
                                                    },
                                                    className:
                                                      "w-7 h-7 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                  }),
                                                  l.jsx("span", {
                                                    className: `font-mono text-[11px] font-black uppercase ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                    children: va.includes(
                                                      "gradient",
                                                    )
                                                      ? Qa
                                                      : va,
                                                  }),
                                                ],
                                              }),
                                              l.jsx("div", {
                                                className:
                                                  "flex flex-wrap gap-1.5 items-center",
                                                children: [
                                                  {
                                                    name: "Rose",
                                                    hex: "#F43F5E",
                                                  },
                                                  {
                                                    name: "Blue",
                                                    hex: "#1668e3",
                                                  },
                                                  {
                                                    name: "Emerald",
                                                    hex: "#10b981",
                                                  },
                                                  {
                                                    name: "Violet",
                                                    hex: "#8b5cf6",
                                                  },
                                                  {
                                                    name: "Amber",
                                                    hex: "#f59e0b",
                                                  },
                                                  {
                                                    name: "Slate",
                                                    hex: "#475569",
                                                  },
                                                  {
                                                    name: "Dark",
                                                    hex: "#0f172a",
                                                  },
                                                ].map((i) =>
                                                  l.jsx(
                                                    "button",
                                                    {
                                                      type: "button",
                                                      onClick: () => {
                                                        (Il(i.hex), wl(i.hex));
                                                      },
                                                      className:
                                                        "w-6 h-6 rounded-full border border-white shadow-sm transition-all hover:scale-110 active:scale-95 cursor-pointer relative",
                                                      style: {
                                                        backgroundColor: i.hex,
                                                      },
                                                      title: i.name,
                                                      children:
                                                        va.toLowerCase() ===
                                                          i.hex.toLowerCase() &&
                                                        l.jsx("span", {
                                                          className:
                                                            "absolute inset-0 flex items-center justify-center text-[10px] text-white font-bold",
                                                          children: "✓",
                                                        }),
                                                    },
                                                    i.hex,
                                                  ),
                                                ),
                                              }),
                                            ],
                                          })
                                        : l.jsxs("div", {
                                            className: "space-y-2",
                                            children: [
                                              l.jsxs("div", {
                                                className:
                                                  "flex flex-wrap gap-2 items-center text-xs",
                                                children: [
                                                  l.jsxs("div", {
                                                    className: `flex items-center gap-1.5 rounded-xl p-1 shadow-sm border ${A ? "bg-[#02050e] border-cyan-500/50" : "bg-white border-slate-300"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className: `text-[10px] font-extrabold pl-1 ${A ? "text-cyan-300" : "text-slate-500"}`,
                                                        children: "C1:",
                                                      }),
                                                      l.jsx("input", {
                                                        type: "color",
                                                        value: Qa,
                                                        onChange: (i) =>
                                                          ml(
                                                            i.target.value,
                                                            Ka,
                                                            Za,
                                                          ),
                                                        className:
                                                          "w-6 h-6 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                      }),
                                                    ],
                                                  }),
                                                  l.jsxs("div", {
                                                    className: `flex items-center gap-1.5 rounded-xl p-1 shadow-sm border ${A ? "bg-[#02050e] border-cyan-500/50" : "bg-white border-slate-300"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className: `text-[10px] font-extrabold pl-1 ${A ? "text-cyan-300" : "text-slate-500"}`,
                                                        children: "C2:",
                                                      }),
                                                      l.jsx("input", {
                                                        type: "color",
                                                        value: Ka,
                                                        onChange: (i) =>
                                                          ml(
                                                            Qa,
                                                            i.target.value,
                                                            Za,
                                                          ),
                                                        className:
                                                          "w-6 h-6 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                      }),
                                                    ],
                                                  }),
                                                  l.jsxs("select", {
                                                    value: Za,
                                                    onChange: (i) =>
                                                      ml(
                                                        Qa,
                                                        Ka,
                                                        i.target.value,
                                                      ),
                                                    className: `rounded-xl px-2 py-1 text-xs font-bold border shadow-sm outline-none ${A ? "bg-[#02050e] border-cyan-500/50 text-cyan-100" : "bg-white border-slate-300 text-slate-800"}`,
                                                    children: [
                                                      l.jsx("option", {
                                                        value: "135deg",
                                                        children:
                                                          "↘ Bottom Right",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "to right",
                                                        children: "➔ To Right",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "to bottom",
                                                        children: "⬇ To Bottom",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "225deg",
                                                        children:
                                                          "↙ Bottom Left",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "circle",
                                                        children:
                                                          "⭕ Radial Circle",
                                                      }),
                                                    ],
                                                  }),
                                                ],
                                              }),
                                              l.jsxs("div", {
                                                className:
                                                  "flex flex-wrap gap-1.5 items-center pt-1",
                                                children: [
                                                  l.jsx("span", {
                                                    className: `text-[10px] font-extrabold mr-1 ${A ? "text-cyan-400" : "text-slate-500"}`,
                                                    children: "Presets:",
                                                  }),
                                                  [
                                                    {
                                                      name: "Sunset",
                                                      c1: "#F43F5E",
                                                      c2: "#F59E0B",
                                                    },
                                                    {
                                                      name: "Fire",
                                                      c1: "#EF4444",
                                                      c2: "#EAB308",
                                                    },
                                                    {
                                                      name: "Ocean",
                                                      c1: "#1668E3",
                                                      c2: "#06B6D4",
                                                    },
                                                    {
                                                      name: "Purple Glow",
                                                      c1: "#8B5CF6",
                                                      c2: "#EC4899",
                                                    },
                                                    {
                                                      name: "Emerald",
                                                      c1: "#059669",
                                                      c2: "#10B981",
                                                    },
                                                    {
                                                      name: "Dark Neon",
                                                      c1: "#0F172A",
                                                      c2: "#F43F5E",
                                                    },
                                                  ].map((i) =>
                                                    l.jsx(
                                                      "button",
                                                      {
                                                        type: "button",
                                                        onClick: () =>
                                                          ml(
                                                            i.c1,
                                                            i.c2,
                                                            "135deg",
                                                          ),
                                                        className:
                                                          "w-6 h-6 rounded-full border border-white shadow-sm transition-all hover:scale-110 active:scale-95 cursor-pointer relative",
                                                        style: {
                                                          background: `linear-gradient(135deg, ${i.c1}, ${i.c2})`,
                                                        },
                                                        title: i.name,
                                                      },
                                                      i.name,
                                                    ),
                                                  ),
                                                ],
                                              }),
                                            ],
                                          }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className: `space-y-2 p-3 rounded-2xl border ${A ? "bg-[#030611] border-cyan-500/40 text-cyan-100" : "bg-slate-50/80 border-slate-200/80 text-slate-900"}`,
                                    children: [
                                      l.jsxs("div", {
                                        className:
                                          "flex items-center justify-between",
                                        children: [
                                          l.jsx("label", {
                                            className: `block text-xs font-black ${A ? "text-cyan-100" : "text-slate-900"}`,
                                            children: _
                                              ? "لون خلفية صفحة المعاينة:"
                                              : "Background Color for the Preview Page:",
                                          }),
                                          l.jsxs("div", {
                                            className: `flex p-0.5 rounded-lg text-[10px] font-bold ${A ? "bg-[#0a0f24] border border-cyan-500/30" : "bg-slate-200/80"}`,
                                            children: [
                                              l.jsx("button", {
                                                type: "button",
                                                onClick: () => {
                                                  (Wa("solid"),
                                                    Ta.includes("gradient") &&
                                                      qt(Pa));
                                                },
                                                className: `px-2 py-0.5 rounded-md transition-all cursor-pointer ${Ja === "solid" ? (A ? "bg-cyan-500 text-slate-950 shadow-sm" : "bg-white text-slate-900 shadow-sm") : A ? "text-cyan-300" : "text-slate-600"}`,
                                                children: _
                                                  ? "لون صلب"
                                                  : "Solid",
                                              }),
                                              l.jsx("button", {
                                                type: "button",
                                                onClick: () => {
                                                  (Wa("gradient"),
                                                    hl(Pa, fl, ql));
                                                },
                                                className: `px-2 py-0.5 rounded-md transition-all cursor-pointer ${Ja === "gradient" ? (A ? "bg-cyan-500 text-slate-950 shadow-sm" : "bg-white text-slate-900 shadow-sm") : A ? "text-cyan-300" : "text-slate-600"}`,
                                                children: _
                                                  ? "تدرج (Gradient)"
                                                  : "Gradient",
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      Ja === "solid"
                                        ? l.jsxs("div", {
                                            className:
                                              "flex flex-col sm:flex-row gap-3 items-start sm:items-center",
                                            children: [
                                              l.jsxs("div", {
                                                className: `flex items-center gap-1.5 rounded-xl p-1.5 pr-3 shadow-sm shrink-0 border ${A ? "bg-[#02050e] border-cyan-500/50 text-cyan-100" : "bg-white border-slate-300 text-slate-900"}`,
                                                children: [
                                                  l.jsx("input", {
                                                    type: "color",
                                                    value: Ta.includes(
                                                      "gradient",
                                                    )
                                                      ? Pa
                                                      : Ta,
                                                    onChange: (i) => {
                                                      (xl(i.target.value),
                                                        qt(i.target.value));
                                                    },
                                                    className:
                                                      "w-7 h-7 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                  }),
                                                  l.jsx("span", {
                                                    className: `font-mono text-[11px] font-black uppercase ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                    children: Ta.includes(
                                                      "gradient",
                                                    )
                                                      ? Pa
                                                      : Ta,
                                                  }),
                                                ],
                                              }),
                                              l.jsx("div", {
                                                className:
                                                  "flex flex-wrap gap-1.5 items-center",
                                                children: [
                                                  {
                                                    name: "Bright Yellow",
                                                    hex: "#F3F722",
                                                  },
                                                  {
                                                    name: "Blue",
                                                    hex: "#1668e3",
                                                  },
                                                  {
                                                    name: "Emerald",
                                                    hex: "#10b981",
                                                  },
                                                  {
                                                    name: "Violet",
                                                    hex: "#8b5cf6",
                                                  },
                                                  {
                                                    name: "White",
                                                    hex: "#ffffff",
                                                  },
                                                  {
                                                    name: "Rose",
                                                    hex: "#f43f5e",
                                                  },
                                                  {
                                                    name: "Dark Slate",
                                                    hex: "#0f172a",
                                                  },
                                                  {
                                                    name: "Pitch Black",
                                                    hex: "#000000",
                                                  },
                                                ].map((i) =>
                                                  l.jsx(
                                                    "button",
                                                    {
                                                      type: "button",
                                                      onClick: () => {
                                                        (xl(i.hex), qt(i.hex));
                                                      },
                                                      className: `w-6 h-6 rounded-full border shadow-sm transition-all hover:scale-110 active:scale-95 cursor-pointer relative ${i.hex === "#ffffff" ? "border-slate-300" : "border-white"}`,
                                                      style: {
                                                        backgroundColor: i.hex,
                                                      },
                                                      title: i.name,
                                                      children:
                                                        Ta.toLowerCase() ===
                                                          i.hex.toLowerCase() &&
                                                        l.jsx("span", {
                                                          className: `absolute inset-0 flex items-center justify-center text-[10px] font-bold ${i.hex === "#ffffff" || i.hex === "#F3F722" ? "text-slate-900" : "text-white"}`,
                                                          children: "✓",
                                                        }),
                                                    },
                                                    i.hex,
                                                  ),
                                                ),
                                              }),
                                            ],
                                          })
                                        : l.jsxs("div", {
                                            className: "space-y-2",
                                            children: [
                                              l.jsxs("div", {
                                                className:
                                                  "flex flex-wrap gap-2 items-center text-xs",
                                                children: [
                                                  l.jsxs("div", {
                                                    className: `flex items-center gap-1.5 rounded-xl p-1 shadow-sm border ${A ? "bg-[#02050e] border-cyan-500/50" : "bg-white border-slate-300"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className: `text-[10px] font-extrabold pl-1 ${A ? "text-cyan-300" : "text-slate-500"}`,
                                                        children: "C1:",
                                                      }),
                                                      l.jsx("input", {
                                                        type: "color",
                                                        value: Pa,
                                                        onChange: (i) =>
                                                          hl(
                                                            i.target.value,
                                                            fl,
                                                            ql,
                                                          ),
                                                        className:
                                                          "w-6 h-6 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                      }),
                                                    ],
                                                  }),
                                                  l.jsxs("div", {
                                                    className: `flex items-center gap-1.5 rounded-xl p-1 shadow-sm border ${A ? "bg-[#02050e] border-cyan-500/50" : "bg-white border-slate-300"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className: `text-[10px] font-extrabold pl-1 ${A ? "text-cyan-300" : "text-slate-500"}`,
                                                        children: "C2:",
                                                      }),
                                                      l.jsx("input", {
                                                        type: "color",
                                                        value: fl,
                                                        onChange: (i) =>
                                                          hl(
                                                            Pa,
                                                            i.target.value,
                                                            ql,
                                                          ),
                                                        className:
                                                          "w-6 h-6 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                      }),
                                                    ],
                                                  }),
                                                  l.jsxs("select", {
                                                    value: ql,
                                                    onChange: (i) =>
                                                      hl(
                                                        Pa,
                                                        fl,
                                                        i.target.value,
                                                      ),
                                                    className: `rounded-xl px-2 py-1 text-xs font-bold border shadow-sm outline-none ${A ? "bg-[#02050e] border-cyan-500/50 text-cyan-100" : "bg-white border-slate-300 text-slate-800"}`,
                                                    children: [
                                                      l.jsx("option", {
                                                        value: "135deg",
                                                        children:
                                                          "↘ Bottom Right",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "to right",
                                                        children: "➔ To Right",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "to bottom",
                                                        children: "⬇ To Bottom",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "225deg",
                                                        children:
                                                          "↙ Bottom Left",
                                                      }),
                                                      l.jsx("option", {
                                                        value: "circle",
                                                        children:
                                                          "⭕ Radial Circle",
                                                      }),
                                                    ],
                                                  }),
                                                ],
                                              }),
                                              l.jsxs("div", {
                                                className:
                                                  "flex flex-wrap gap-1.5 items-center pt-1",
                                                children: [
                                                  l.jsx("span", {
                                                    className: `text-[10px] font-extrabold mr-1 ${A ? "text-cyan-400" : "text-slate-500"}`,
                                                    children: "Presets:",
                                                  }),
                                                  [
                                                    {
                                                      name: "Yellow Gold",
                                                      c1: "#F3F722",
                                                      c2: "#FF9900",
                                                    },
                                                    {
                                                      name: "Neon Sunset",
                                                      c1: "#F3F722",
                                                      c2: "#F43F5E",
                                                    },
                                                    {
                                                      name: "Ocean Blue",
                                                      c1: "#1668E3",
                                                      c2: "#0284C7",
                                                    },
                                                    {
                                                      name: "Royal Purple",
                                                      c1: "#2E1065",
                                                      c2: "#7E22CE",
                                                    },
                                                    {
                                                      name: "Fire Amber",
                                                      c1: "#B91C1C",
                                                      c2: "#F59E0B",
                                                    },
                                                    {
                                                      name: "Soft Mint",
                                                      c1: "#A8FF78",
                                                      c2: "#78FFD6",
                                                    },
                                                    {
                                                      name: "Dark Velvet",
                                                      c1: "#0F172A",
                                                      c2: "#1E1B4B",
                                                    },
                                                  ].map((i) =>
                                                    l.jsx(
                                                      "button",
                                                      {
                                                        type: "button",
                                                        onClick: () =>
                                                          hl(
                                                            i.c1,
                                                            i.c2,
                                                            "135deg",
                                                          ),
                                                        className:
                                                          "w-6 h-6 rounded-full border border-white shadow-sm transition-all hover:scale-110 active:scale-95 cursor-pointer relative",
                                                        style: {
                                                          background: `linear-gradient(135deg, ${i.c1}, ${i.c2})`,
                                                        },
                                                        title: i.name,
                                                      },
                                                      i.name,
                                                    ),
                                                  ),
                                                ],
                                              }),
                                            ],
                                          }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className: `space-y-3 pt-3 border-t ${A ? "border-cyan-500/30" : "border-slate-200/80"}`,
                                    children: [
                                      l.jsxs("div", {
                                        className:
                                          "flex flex-wrap items-center gap-4",
                                        children: [
                                          l.jsxs("label", {
                                            className:
                                              "flex items-center gap-2 cursor-pointer select-none",
                                            children: [
                                              l.jsx("input", {
                                                type: "checkbox",
                                                checked: D,
                                                onChange: (i) =>
                                                  U(i.target.checked),
                                                className:
                                                  "w-4 h-4 rounded text-rose-500 focus:ring-rose-400 border-slate-300 cursor-pointer",
                                              }),
                                              l.jsx("span", {
                                                className: `text-xs font-black ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                children: _
                                                  ? "شعار المتجر (Store Logo)"
                                                  : "Store Logo",
                                              }),
                                            ],
                                          }),
                                          l.jsxs("label", {
                                            className:
                                              "flex items-center gap-2 cursor-pointer select-none",
                                            children: [
                                              l.jsx("input", {
                                                type: "checkbox",
                                                checked: O,
                                                onChange: (i) =>
                                                  H(i.target.checked),
                                                className:
                                                  "w-4 h-4 rounded text-rose-500 focus:ring-rose-400 border-slate-300 cursor-pointer",
                                              }),
                                              l.jsx("span", {
                                                className: `text-xs font-black ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                children: _
                                                  ? "صفقات متعددة في نفس صفحة المعاينة"
                                                  : "Multi Deals in same landing page",
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      l.jsxs("div", {
                                        className: `pt-2.5 pb-2 border-t space-y-2 ${A ? "border-cyan-500/30" : "border-slate-200/80"}`,
                                        children: [
                                          l.jsx("div", {
                                            className: `text-xs font-black ${A ? "text-cyan-200" : "text-slate-800"}`,
                                            children: _
                                              ? "صفحة هبوط المتجر المخصصة (Store Branded Landing Page):"
                                              : "Store Branded Landing Page:",
                                          }),
                                          l.jsxs("div", {
                                            className:
                                              "flex flex-wrap items-center gap-3",
                                            children: [
                                              l.jsxs("label", {
                                                className:
                                                  "flex items-center gap-1.5 cursor-pointer select-none",
                                                children: [
                                                  l.jsx("input", {
                                                    type: "checkbox",
                                                    checked: pe === "walmart",
                                                    onChange: (i) =>
                                                      Ie(
                                                        i.target.checked
                                                          ? "walmart"
                                                          : null,
                                                      ),
                                                    className:
                                                      "w-4 h-4 rounded text-blue-600 focus:ring-blue-500 border-slate-300 cursor-pointer",
                                                  }),
                                                  l.jsxs("span", {
                                                    className: `text-xs font-black flex items-center gap-1 ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className:
                                                          "w-2.5 h-2.5 rounded-full bg-[#0071CE] inline-block",
                                                      }),
                                                      "Walmart Landing Page",
                                                    ],
                                                  }),
                                                ],
                                              }),
                                              l.jsxs("label", {
                                                className:
                                                  "flex items-center gap-1.5 cursor-pointer select-none",
                                                children: [
                                                  l.jsx("input", {
                                                    type: "checkbox",
                                                    checked: pe === "amazon",
                                                    onChange: (i) =>
                                                      Ie(
                                                        i.target.checked
                                                          ? "amazon"
                                                          : null,
                                                      ),
                                                    className:
                                                      "w-4 h-4 rounded text-amber-500 focus:ring-amber-400 border-slate-300 cursor-pointer",
                                                  }),
                                                  l.jsxs("span", {
                                                    className: `text-xs font-black flex items-center gap-1 ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className:
                                                          "w-2.5 h-2.5 rounded-full bg-[#FF9900] inline-block",
                                                      }),
                                                      "Amazon Landing Page",
                                                    ],
                                                  }),
                                                ],
                                              }),
                                              l.jsxs("label", {
                                                className:
                                                  "flex items-center gap-1.5 cursor-pointer select-none",
                                                children: [
                                                  l.jsx("input", {
                                                    type: "checkbox",
                                                    checked:
                                                      pe === "aliexpress",
                                                    onChange: (i) =>
                                                      Ie(
                                                        i.target.checked
                                                          ? "aliexpress"
                                                          : null,
                                                      ),
                                                    className:
                                                      "w-4 h-4 rounded text-red-500 focus:ring-red-400 border-slate-300 cursor-pointer",
                                                  }),
                                                  l.jsxs("span", {
                                                    className: `text-xs font-black flex items-center gap-1 ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className:
                                                          "w-2.5 h-2.5 rounded-full bg-[#FF4747] inline-block",
                                                      }),
                                                      "AliExpress Landing Page",
                                                    ],
                                                  }),
                                                ],
                                              }),
                                              l.jsxs("label", {
                                                className:
                                                  "flex items-center gap-1.5 cursor-pointer select-none border-l pl-3 border-slate-300/60",
                                                children: [
                                                  l.jsx("input", {
                                                    type: "checkbox",
                                                    checked: Te,
                                                    onChange: (i) =>
                                                      _e(i.target.checked),
                                                    className:
                                                      "w-4 h-4 rounded text-blue-600 focus:ring-blue-500 border-slate-300 cursor-pointer",
                                                  }),
                                                  l.jsxs("span", {
                                                    className: `text-xs font-black flex items-center gap-1 ${A ? "text-cyan-100" : "text-slate-900"}`,
                                                    children: [
                                                      l.jsx("span", {
                                                        className:
                                                          "w-2.5 h-2.5 rounded-full bg-indigo-500 inline-block",
                                                      }),
                                                      _
                                                        ? "صورة الخلفية"
                                                        : "Background Image",
                                                    ],
                                                  }),
                                                ],
                                              }),
                                            ],
                                          }),
                                          pe &&
                                            l.jsxs("div", {
                                              className: `mt-2.5 pt-2.5 border-t space-y-2.5 ${A ? "border-cyan-500/30" : "border-slate-200/80"}`,
                                              children: [
                                                l.jsxs("div", {
                                                  className: "space-y-1.5 pb-1",
                                                  children: [
                                                    l.jsxs("div", {
                                                      className: `text-xs font-black flex items-center justify-between flex-wrap gap-1 ${A ? "text-cyan-200" : "text-slate-800"}`,
                                                      children: [
                                                        l.jsxs("span", {
                                                          className:
                                                            "flex items-center gap-1.5",
                                                          children: [
                                                            "🎨 ",
                                                            _
                                                              ? "ثيم صفحة الهبوط (Theme Landing Page):"
                                                              : "Theme Landing Page:",
                                                          ],
                                                        }),
                                                        l.jsxs("div", {
                                                          className:
                                                            "flex items-center gap-1.5",
                                                          children: [
                                                            l.jsxs("button", {
                                                              type: "button",
                                                              onClick: () =>
                                                                Y(Xt),
                                                              className:
                                                                "px-2.5 py-0.5 rounded-full text-[10px] font-black bg-blue-600 text-white hover:bg-blue-500 shadow-xs flex items-center gap-1 transition-all cursor-pointer border border-blue-400/50",
                                                              children: [
                                                                "👁️ ",
                                                                _
                                                                  ? "معاينة الثيم"
                                                                  : "Preview Theme",
                                                              ],
                                                            }),
                                                            l.jsxs("span", {
                                                              className: `text-[10px] px-2 py-0.5 rounded-full font-black border ${A ? "bg-cyan-500/20 text-cyan-300 border-cyan-500/40" : "bg-blue-50 text-blue-700 border-blue-200"}`,
                                                              children: [
                                                                "10 ",
                                                                _
                                                                  ? "ثيمات متميزة"
                                                                  : "Unique Themes",
                                                              ],
                                                            }),
                                                          ],
                                                        }),
                                                      ],
                                                    }),
                                                    l.jsx("div", {
                                                      className:
                                                        "grid grid-cols-2 sm:grid-cols-5 gap-1.5 pt-1",
                                                      children: [
                                                        {
                                                          key: "classic-store",
                                                          nameEn:
                                                            "1. Classic Store",
                                                          nameAr:
                                                            "1. متجر كلاسيكي",
                                                          previewClass:
                                                            "bg-blue-600 text-white",
                                                        },
                                                        {
                                                          key: "dark-premium",
                                                          nameEn:
                                                            "2. Dark Premium",
                                                          nameAr:
                                                            "2. داكن فاخر",
                                                          previewClass:
                                                            "bg-slate-900 text-amber-400",
                                                        },
                                                        {
                                                          key: "minimal-white",
                                                          nameEn:
                                                            "3. Minimal White",
                                                          nameAr:
                                                            "3. أبيض بسيط",
                                                          previewClass:
                                                            "bg-slate-100 text-slate-800 border-slate-300",
                                                        },
                                                        {
                                                          key: "gradient-neon",
                                                          nameEn:
                                                            "4. Gradient Neon",
                                                          nameAr:
                                                            "4. تدرج نيون",
                                                          previewClass:
                                                            "bg-gradient-to-r from-purple-600 to-pink-600 text-white",
                                                        },
                                                        {
                                                          key: "soft-pastel",
                                                          nameEn:
                                                            "5. Soft Pastel",
                                                          nameAr:
                                                            "5. باستيل ناعم",
                                                          previewClass:
                                                            "bg-pink-300 text-slate-900",
                                                        },
                                                        {
                                                          key: "bold-magazine",
                                                          nameEn:
                                                            "6. Bold Magazine",
                                                          nameAr:
                                                            "6. مجلة عصرية",
                                                          previewClass:
                                                            "bg-amber-400 text-slate-950 font-black",
                                                        },
                                                        {
                                                          key: "elegant-gold",
                                                          nameEn:
                                                            "7. Black & Gold",
                                                          nameAr:
                                                            "7. أسود وذهبي",
                                                          previewClass:
                                                            "bg-gradient-to-r from-yellow-700 via-amber-600 to-yellow-500 text-white",
                                                        },
                                                        {
                                                          key: "fresh-nature",
                                                          nameEn:
                                                            "8. Fresh Nature",
                                                          nameAr:
                                                            "8. طبيعة خضراء",
                                                          previewClass:
                                                            "bg-emerald-600 text-white",
                                                        },
                                                        {
                                                          key: "retro-pop",
                                                          nameEn:
                                                            "9. Retro Pop",
                                                          nameAr:
                                                            "9. ريترو بوب",
                                                          previewClass:
                                                            "bg-yellow-400 text-slate-950 border-2 border-slate-900",
                                                        },
                                                        {
                                                          key: "ultra-corporate",
                                                          nameEn:
                                                            "10. Ultra Clean",
                                                          nameAr:
                                                            "10. شركة احترافي",
                                                          previewClass:
                                                            "bg-cyan-700 text-white",
                                                        },
                                                      ].map((i) =>
                                                        l.jsxs(
                                                          "button",
                                                          {
                                                            type: "button",
                                                            onClick: () => {
                                                              const B = i.key;
                                                              (St(B), Y(B));
                                                            },
                                                            className: `px-2 py-1.5 rounded-xl text-[11px] font-black transition-all flex items-center justify-center gap-1 cursor-pointer border shadow-xs ${Xt === i.key ? "ring-2 ring-blue-500 border-blue-500 scale-105 z-10 font-black" : A ? "bg-[#02050e] border-cyan-500/30 text-cyan-100 hover:border-cyan-400" : "bg-white border-slate-200 text-slate-800 hover:border-blue-400"}`,
                                                            children: [
                                                              l.jsx("span", {
                                                                className: `w-2.5 h-2.5 rounded-full shrink-0 ${i.previewClass}`,
                                                              }),
                                                              l.jsx("span", {
                                                                className:
                                                                  "truncate",
                                                                children: _
                                                                  ? i.nameAr
                                                                  : i.nameEn,
                                                              }),
                                                            ],
                                                          },
                                                          i.key,
                                                        ),
                                                      ),
                                                    }),
                                                  ],
                                                }),
                                                l.jsxs("div", {
                                                  className:
                                                    "flex items-center justify-between flex-wrap gap-2",
                                                  children: [
                                                    l.jsxs("div", {
                                                      className: `text-xs font-black flex items-center gap-1.5 ${A ? "text-cyan-200" : "text-slate-800"}`,
                                                      children: [
                                                        l.jsx("span", {
                                                          className:
                                                            "w-3.5 h-3.5 rounded-full border border-white/60 inline-block shadow-xs shrink-0",
                                                          style: {
                                                            background: bt(),
                                                          },
                                                        }),
                                                        l.jsx("span", {
                                                          children: _
                                                            ? "لون خلفية بطاقات الصفقات:"
                                                            : "Deal Cards Background Color:",
                                                        }),
                                                      ],
                                                    }),
                                                    l.jsxs("div", {
                                                      className: `flex items-center gap-1 p-0.5 rounded-lg border text-[11px] font-bold ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-slate-100 border-slate-300"}`,
                                                      children: [
                                                        l.jsx("button", {
                                                          type: "button",
                                                          onClick: () =>
                                                            Qe("solid"),
                                                          className: `px-2 py-0.5 rounded-md transition-all cursor-pointer ${Fa === "solid" ? "bg-blue-600 text-white shadow-xs font-black" : A ? "text-cyan-300 hover:text-white" : "text-slate-600 hover:text-slate-900"}`,
                                                          children: _
                                                            ? "لون أحادي"
                                                            : "Solid",
                                                        }),
                                                        l.jsx("button", {
                                                          type: "button",
                                                          onClick: () =>
                                                            Qe("gradient"),
                                                          className: `px-2 py-0.5 rounded-md transition-all cursor-pointer ${Fa === "gradient" ? "bg-blue-600 text-white shadow-xs font-black" : A ? "text-cyan-300 hover:text-white" : "text-slate-600 hover:text-slate-900"}`,
                                                          children: _
                                                            ? "تدرج ملون"
                                                            : "Gradient",
                                                        }),
                                                      ],
                                                    }),
                                                  ],
                                                }),
                                                Fa === "solid"
                                                  ? l.jsx("div", {
                                                      className: "space-y-2",
                                                      children: l.jsxs("div", {
                                                        className:
                                                          "flex flex-wrap items-center gap-2",
                                                        children: [
                                                          l.jsxs("div", {
                                                            className: `flex items-center gap-1.5 rounded-xl p-1 shadow-xs border ${A ? "bg-[#02050e] border-cyan-500/50" : "bg-white border-slate-300"}`,
                                                            children: [
                                                              l.jsx("input", {
                                                                type: "color",
                                                                value: da,
                                                                onChange: (i) =>
                                                                  Aa(
                                                                    i.target
                                                                      .value,
                                                                  ),
                                                                className:
                                                                  "w-6 h-6 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                              }),
                                                              l.jsx("span", {
                                                                className: `text-xs font-mono font-bold pr-1.5 ${A ? "text-cyan-200" : "text-slate-700"}`,
                                                                children:
                                                                  da.toUpperCase(),
                                                              }),
                                                            ],
                                                          }),
                                                          l.jsxs("div", {
                                                            className:
                                                              "flex flex-wrap items-center gap-1",
                                                            children: [
                                                              l.jsx("span", {
                                                                className: `text-[10px] font-extrabold mr-0.5 ${A ? "text-cyan-400" : "text-slate-500"}`,
                                                                children: _
                                                                  ? "جاهز:"
                                                                  : "Presets:",
                                                              }),
                                                              [
                                                                {
                                                                  name: "Walmart Blue",
                                                                  hex: "#0071CE",
                                                                },
                                                                {
                                                                  name: "Amazon Amber",
                                                                  hex: "#FF9900",
                                                                },
                                                                {
                                                                  name: "AliExpress Red",
                                                                  hex: "#FF4747",
                                                                },
                                                                {
                                                                  name: "Emerald",
                                                                  hex: "#059669",
                                                                },
                                                                {
                                                                  name: "Indigo",
                                                                  hex: "#4F46E5",
                                                                },
                                                                {
                                                                  name: "Rose",
                                                                  hex: "#E11D48",
                                                                },
                                                                {
                                                                  name: "Purple",
                                                                  hex: "#7C3AED",
                                                                },
                                                                {
                                                                  name: "Midnight",
                                                                  hex: "#0F172A",
                                                                },
                                                              ].map((i) =>
                                                                l.jsx(
                                                                  "button",
                                                                  {
                                                                    type: "button",
                                                                    onClick:
                                                                      () =>
                                                                        Aa(
                                                                          i.hex,
                                                                        ),
                                                                    className: `w-5 h-5 rounded-full border shadow-xs transition-all hover:scale-110 active:scale-95 cursor-pointer relative ${i.hex === "#ffffff" ? "border-slate-300" : "border-white/80"}`,
                                                                    style: {
                                                                      backgroundColor:
                                                                        i.hex,
                                                                    },
                                                                    title:
                                                                      i.name,
                                                                    children:
                                                                      da.toLowerCase() ===
                                                                        i.hex.toLowerCase() &&
                                                                      l.jsx(
                                                                        "span",
                                                                        {
                                                                          className:
                                                                            "absolute inset-0 flex items-center justify-center text-[9px] font-black text-white drop-shadow-xs",
                                                                          children:
                                                                            "✓",
                                                                        },
                                                                      ),
                                                                  },
                                                                  i.name,
                                                                ),
                                                              ),
                                                            ],
                                                          }),
                                                        ],
                                                      }),
                                                    })
                                                  : l.jsxs("div", {
                                                      className: "space-y-2",
                                                      children: [
                                                        l.jsxs("div", {
                                                          className:
                                                            "flex flex-wrap items-center gap-2 text-xs",
                                                          children: [
                                                            l.jsxs("div", {
                                                              className: `flex items-center gap-1.5 rounded-xl p-1 shadow-xs border ${A ? "bg-[#02050e] border-cyan-500/50" : "bg-white border-slate-300"}`,
                                                              children: [
                                                                l.jsx("span", {
                                                                  className: `text-[10px] font-extrabold pl-1 ${A ? "text-cyan-300" : "text-slate-500"}`,
                                                                  children:
                                                                    "C1:",
                                                                }),
                                                                l.jsx("input", {
                                                                  type: "color",
                                                                  value: da,
                                                                  onChange: (
                                                                    i,
                                                                  ) =>
                                                                    Aa(
                                                                      i.target
                                                                        .value,
                                                                    ),
                                                                  className:
                                                                    "w-6 h-6 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                                }),
                                                              ],
                                                            }),
                                                            l.jsxs("div", {
                                                              className: `flex items-center gap-1.5 rounded-xl p-1 shadow-xs border ${A ? "bg-[#02050e] border-cyan-500/50" : "bg-white border-slate-300"}`,
                                                              children: [
                                                                l.jsx("span", {
                                                                  className: `text-[10px] font-extrabold pl-1 ${A ? "text-cyan-300" : "text-slate-500"}`,
                                                                  children:
                                                                    "C2:",
                                                                }),
                                                                l.jsx("input", {
                                                                  type: "color",
                                                                  value: Va,
                                                                  onChange: (
                                                                    i,
                                                                  ) =>
                                                                    bs(
                                                                      i.target
                                                                        .value,
                                                                    ),
                                                                  className:
                                                                    "w-6 h-6 rounded-lg border border-slate-300 cursor-pointer overflow-hidden p-0 bg-transparent shrink-0",
                                                                }),
                                                              ],
                                                            }),
                                                            l.jsxs("select", {
                                                              value: $a,
                                                              onChange: (i) =>
                                                                gs(
                                                                  i.target
                                                                    .value,
                                                                ),
                                                              className: `rounded-xl px-2 py-1 text-xs font-bold border shadow-xs outline-none cursor-pointer ${A ? "bg-[#02050e] border-cyan-500/50 text-cyan-100" : "bg-white border-slate-300 text-slate-800"}`,
                                                              children: [
                                                                l.jsx(
                                                                  "option",
                                                                  {
                                                                    value:
                                                                      "135deg",
                                                                    children:
                                                                      "↘ Bottom Right",
                                                                  },
                                                                ),
                                                                l.jsx(
                                                                  "option",
                                                                  {
                                                                    value:
                                                                      "to right",
                                                                    children:
                                                                      "➔ To Right",
                                                                  },
                                                                ),
                                                                l.jsx(
                                                                  "option",
                                                                  {
                                                                    value:
                                                                      "to bottom",
                                                                    children:
                                                                      "⬇ To Bottom",
                                                                  },
                                                                ),
                                                                l.jsx(
                                                                  "option",
                                                                  {
                                                                    value:
                                                                      "225deg",
                                                                    children:
                                                                      "↙ Bottom Left",
                                                                  },
                                                                ),
                                                                l.jsx(
                                                                  "option",
                                                                  {
                                                                    value:
                                                                      "circle",
                                                                    children:
                                                                      "⭕ Radial Circle",
                                                                  },
                                                                ),
                                                              ],
                                                            }),
                                                          ],
                                                        }),
                                                        l.jsxs("div", {
                                                          className:
                                                            "flex flex-wrap items-center gap-1.5 pt-0.5",
                                                          children: [
                                                            l.jsx("span", {
                                                              className: `text-[10px] font-extrabold mr-0.5 ${A ? "text-cyan-400" : "text-slate-500"}`,
                                                              children: _
                                                                ? "تدرجات:"
                                                                : "Gradients:",
                                                            }),
                                                            [
                                                              {
                                                                name: "Default Blue",
                                                                c1: "#0071CE",
                                                                c2: "#004B8D",
                                                              },
                                                              {
                                                                name: "Ocean Sapphire",
                                                                c1: "#0284C7",
                                                                c2: "#1E3A8A",
                                                              },
                                                              {
                                                                name: "Sunset Gold",
                                                                c1: "#FF4747",
                                                                c2: "#FF9900",
                                                              },
                                                              {
                                                                name: "Royal Magenta",
                                                                c1: "#7C3AED",
                                                                c2: "#C026D3",
                                                              },
                                                              {
                                                                name: "Emerald Forest",
                                                                c1: "#059669",
                                                                c2: "#064E3B",
                                                              },
                                                              {
                                                                name: "Dark Cyber",
                                                                c1: "#0F172A",
                                                                c2: "#1E1B4B",
                                                              },
                                                            ].map((i) =>
                                                              l.jsx(
                                                                "button",
                                                                {
                                                                  type: "button",
                                                                  onClick:
                                                                    () => {
                                                                      (Aa(i.c1),
                                                                        bs(
                                                                          i.c2,
                                                                        ));
                                                                    },
                                                                  className:
                                                                    "px-2 py-0.5 rounded-lg text-[10px] font-extrabold text-white shadow-xs border border-white/30 hover:scale-105 active:scale-95 transition-all cursor-pointer",
                                                                  style: {
                                                                    background: `linear-gradient(135deg, ${i.c1}, ${i.c2})`,
                                                                  },
                                                                  children:
                                                                    i.name,
                                                                },
                                                                i.name,
                                                              ),
                                                            ),
                                                          ],
                                                        }),
                                                      ],
                                                    }),
                                              ],
                                            }),
                                        ],
                                      }),
                                      O &&
                                        l.jsxs("div", {
                                          className: "space-y-3 pt-1",
                                          children: [
                                            l.jsxs("div", {
                                              className: "space-y-1.5",
                                              children: [
                                                l.jsx("label", {
                                                  className: `block text-[11px] font-extrabold ${A ? "text-cyan-300" : "text-slate-700"}`,
                                                  children: _
                                                    ? "اختر عدد الصفقات:"
                                                    : "Select Deals Quantity:",
                                                }),
                                                l.jsx("div", {
                                                  className:
                                                    "flex items-center gap-2",
                                                  children: [2, 4, 8].map((i) =>
                                                    l.jsxs(
                                                      "button",
                                                      {
                                                        type: "button",
                                                        onClick: () => F(i),
                                                        className: `px-3 py-1.5 rounded-xl text-xs font-black transition-all cursor-pointer ${G === i ? "bg-rose-500 text-white shadow-md ring-2 ring-rose-300 scale-105" : A ? "bg-[#02050e] text-cyan-200 border border-cyan-500/40 hover:bg-[#0c132c]" : "bg-white text-slate-700 border border-slate-300 hover:bg-slate-50"}`,
                                                        children: [
                                                          i,
                                                          " ",
                                                          _ ? "صفقات" : "Deals",
                                                        ],
                                                      },
                                                      i,
                                                    ),
                                                  ),
                                                }),
                                              ],
                                            }),
                                            l.jsxs("div", {
                                              className: `p-3 rounded-xl text-xs flex items-center gap-2 shadow-xs border ${A ? "bg-[#0c132c] border-cyan-500/50 text-cyan-200" : "bg-blue-50/90 border-blue-200 text-blue-900"}`,
                                              children: [
                                                l.jsx("span", {
                                                  className: `text-base shrink-0 ${A ? "text-cyan-400" : "text-blue-600"}`,
                                                  children: "ℹ️",
                                                }),
                                                l.jsx("div", {
                                                  className:
                                                    "font-extrabold text-[11px] leading-relaxed",
                                                  children: _
                                                    ? "يتم قبول روابط Mavely Link القصيرة فقط."
                                                    : "Only short links from Mavely Link are accepted.",
                                                }),
                                              ],
                                            }),
                                            l.jsxs("div", {
                                              className: "space-y-2",
                                              children: [
                                                l.jsx("label", {
                                                  className: `block text-[11px] font-extrabold ${A ? "text-cyan-300" : "text-slate-700"}`,
                                                  children: _
                                                    ? "أدخل الروابط القصيرة:"
                                                    : "Add Short Links:",
                                                }),
                                                le.slice(0, G).map((i, B) => {
                                                  const q = !i.trim() || Kx(i);
                                                  return l.jsxs(
                                                    "div",
                                                    {
                                                      className: "space-y-1",
                                                      children: [
                                                        l.jsxs("div", {
                                                          className:
                                                            "flex items-center gap-2",
                                                          children: [
                                                            l.jsxs("span", {
                                                              className: `text-[11px] font-black w-16 shrink-0 ${A ? "text-cyan-300" : "text-slate-600"}`,
                                                              children: [
                                                                _
                                                                  ? `صفقة #${B + 1}`
                                                                  : `Deal #${B + 1}`,
                                                                ":",
                                                              ],
                                                            }),
                                                            l.jsx("input", {
                                                              type: "text",
                                                              value: i,
                                                              onChange: (
                                                                me,
                                                              ) => {
                                                                const ge = [
                                                                  ...le,
                                                                ];
                                                                ((ge[B] =
                                                                  me.target.value),
                                                                  ie(ge));
                                                              },
                                                              placeholder: `https://mavelylink.ai.studio/?shortcode${B + 1}`,
                                                              className: `w-full px-3 py-1.5 text-xs font-mono rounded-xl border transition-colors font-bold ${q ? (A ? "bg-[#02050e] border-cyan-500/60 text-cyan-100 placeholder:text-cyan-600/70 focus:border-fuchsia-500" : "bg-white border-slate-300 text-slate-900 focus:ring-rose-400") : "border-red-500 text-red-900 bg-red-50 focus:ring-red-400"}`,
                                                            }),
                                                          ],
                                                        }),
                                                        !q &&
                                                          l.jsx("p", {
                                                            className:
                                                              "text-[10px] font-black text-red-600 pl-18",
                                                            children: _
                                                              ? "خطأ: يتم قبول روابط Mavely Link القصيرة فقط."
                                                              : "Error: Only short links from Mavely Link are accepted.",
                                                          }),
                                                      ],
                                                    },
                                                    B,
                                                  );
                                                }),
                                              ],
                                            }),
                                          ],
                                        }),
                                    ],
                                  }),
                                ],
                              }),
                            l.jsxs("div", {
                              className: `space-y-3 pt-2 border-t ${A ? "border-cyan-500/30" : "border-slate-200"}`,
                              children: [
                                l.jsxs("div", {
                                  className: "flex items-start gap-3",
                                  children: [
                                    l.jsx("div", {
                                      className: "flex-1",
                                      children: l.jsx("textarea", {
                                        id: "customDescriptionInput",
                                        rows: 2,
                                        value: je,
                                        onChange: (i) => ws(i.target.value),
                                        disabled: Ua,
                                        placeholder: _
                                          ? "اكتب وصفاً مخصصاً هنا..."
                                          : "Type custom description here...",
                                        className: `w-full p-3 border-2 rounded-xl text-sm font-bold transition-colors resize-none disabled:opacity-50 disabled:cursor-not-allowed font-sans shadow-sm ${A ? "bg-[#02050e] border-cyan-500/60 text-cyan-100 placeholder:text-cyan-600/70 focus:outline-none focus:border-fuchsia-500" : "bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-600"}`,
                                      }),
                                    }),
                                    l.jsxs("div", {
                                      className: "relative shrink-0 mt-1",
                                      children: [
                                        l.jsx("button", {
                                          type: "button",
                                          onClick: () => Qt(!Bl),
                                          disabled: Ua,
                                          className: `w-11 h-11 rounded-full flex items-center justify-center text-xl shadow-sm transition-all active:scale-95 border disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer ${A ? "bg-[#0c132c] border-cyan-500/50 text-amber-300 hover:bg-[#162148]" : "bg-amber-100 hover:bg-amber-200 text-amber-700 border-amber-300/60"}`,
                                          title: _
                                            ? "إضافة إيموجي"
                                            : "Add Emoji",
                                          children: "🙂",
                                        }),
                                        Bl &&
                                          l.jsxs("div", {
                                            className: `absolute right-0 mt-2 p-3 border rounded-2xl z-50 w-64 max-h-48 overflow-y-auto text-start ${A ? "bg-[#090e24] border-cyan-500/60 text-cyan-100 shadow-[0_0_20px_rgba(6,182,212,0.3)]" : "bg-white border-slate-300 text-slate-800 shadow-2xl"}`,
                                            children: [
                                              l.jsxs("div", {
                                                className: `flex items-center justify-between mb-2 pb-1 border-b ${A ? "border-cyan-500/40" : "border-slate-200"}`,
                                                children: [
                                                  l.jsx("span", {
                                                    className: `text-[11px] font-black ${A ? "text-cyan-100" : "text-slate-800"}`,
                                                    children: _
                                                      ? "اختر إيموجي"
                                                      : "Select Emoji",
                                                  }),
                                                  l.jsx("button", {
                                                    type: "button",
                                                    onClick: () => Qt(!1),
                                                    className:
                                                      "text-xs font-bold text-rose-500 hover:text-rose-400",
                                                    children: _
                                                      ? "إغلاق"
                                                      : "Close",
                                                  }),
                                                ],
                                              }),
                                              l.jsx("div", {
                                                className:
                                                  "grid grid-cols-6 gap-2",
                                                children: [
                                                  "❤️",
                                                  "🔥",
                                                  "⭐",
                                                  "🌟",
                                                  "✨",
                                                  "💥",
                                                  "🙂",
                                                  "😊",
                                                  "😍",
                                                  "😂",
                                                  "😉",
                                                  "😎",
                                                  "👉",
                                                  "👉🏻",
                                                  "👈",
                                                  "👈🏻",
                                                  "👍",
                                                  "👍🏻",
                                                  "📢",
                                                  "🎁",
                                                  "💎",
                                                  "💡",
                                                  "📌",
                                                  "📍",
                                                  "✅",
                                                  "✔️",
                                                  "❌",
                                                  "⚠️",
                                                  "➡️",
                                                  "⬇️",
                                                ].map((i) =>
                                                  l.jsx(
                                                    "button",
                                                    {
                                                      type: "button",
                                                      onClick: () => {
                                                        Qs(i);
                                                      },
                                                      className: `w-8 h-8 flex items-center justify-center text-lg rounded-lg transition-all active:scale-90 cursor-pointer ${A ? "hover:bg-[#131d45]" : "hover:bg-slate-100"}`,
                                                      children: i,
                                                    },
                                                    i,
                                                  ),
                                                ),
                                              }),
                                            ],
                                          }),
                                      ],
                                    }),
                                  ],
                                }),
                                l.jsxs("label", {
                                  className:
                                    "flex items-center gap-2.5 px-1 py-0.5 cursor-pointer select-none text-xs sm:text-sm font-black",
                                  children: [
                                    l.jsx("input", {
                                      type: "checkbox",
                                      checked: ta,
                                      onChange: (i) => yn(i.target.checked),
                                      disabled: Ua,
                                      className:
                                        "w-4.5 h-4.5 accent-cyan-500 cursor-pointer rounded",
                                    }),
                                    l.jsx("span", {
                                      className: A
                                        ? "text-cyan-100 font-black"
                                        : "text-slate-900 font-black",
                                      children: _
                                        ? "إضافة الوصف الخاص بي مع الرابط القصير"
                                        : "Add my Description with my short link",
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            l.jsxs("div", {
                              className: `flex flex-col sm:flex-row gap-2.5 pt-2 border-t ${A ? "border-cyan-500/30" : "border-slate-200"}`,
                              children: [
                                l.jsx("textarea", {
                                  readOnly: !0,
                                  rows: ua.includes(`
`)
                                    ? 3
                                    : 1,
                                  placeholder: _
                                    ? "رابطك القصير الجديد"
                                    : "Your new short link",
                                  value: ua,
                                  onClick: (i) => {
                                    i.target.select();
                                  },
                                  className: `flex-1 p-3 border-2 rounded-xl text-sm font-black outline-none min-w-0 cursor-text resize-none font-sans shadow-inner ${A ? "bg-[#02050e] border-cyan-500/60 text-cyan-300 placeholder:text-cyan-600/70" : "bg-slate-50 border-slate-300 text-blue-700 placeholder:text-slate-400"}`,
                                }),
                                l.jsxs("button", {
                                  onClick: bi,
                                  disabled: xa || !At,
                                  className:
                                    "bg-blue-600 hover:bg-blue-700 active:scale-95 text-white font-extrabold px-6 py-3 rounded-xl transition-all cursor-pointer text-xs shrink-0 flex items-center justify-center gap-1.5 shadow-md shadow-blue-600/20 border border-blue-500/30 disabled:opacity-50 disabled:bg-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed disabled:shadow-none min-w-[120px]",
                                  children: [
                                    l.jsx(ui, { size: 15 }),
                                    l.jsx("span", { children: Kt("copyBtn") }),
                                  ],
                                }),
                              ],
                            }),
                            ya &&
                              l.jsxs("div", {
                                className: `mt-3 p-4 border-2 border-dashed rounded-2xl flex flex-col items-center gap-3 animate-[revealUp_0.2s_ease-out] text-center ${A ? "bg-[#050814] border-cyan-500/60 text-cyan-100" : "bg-slate-50 border-blue-400/50 text-slate-900"}`,
                                children: [
                                  l.jsxs("div", {
                                    className: `w-full flex items-center justify-between border-b pb-2.5 ${A ? "border-cyan-500/30" : "border-slate-200"}`,
                                    children: [
                                      l.jsxs("div", {
                                        className: `flex items-center gap-1.5 text-xs font-black ${A ? "text-cyan-100" : "text-slate-900"}`,
                                        children: [
                                          l.jsx(Lx, {
                                            size: 16,
                                            className: A
                                              ? "text-cyan-400"
                                              : "text-blue-600",
                                          }),
                                          l.jsx("span", {
                                            className: A
                                              ? "text-cyan-100 font-black"
                                              : "text-slate-900 font-black",
                                            children: _
                                              ? "رمز QR للرابط القصير"
                                              : "Short Link QR Code",
                                          }),
                                        ],
                                      }),
                                      l.jsxs("button", {
                                        onClick: wn,
                                        className:
                                          "px-3 py-1.5 bg-emerald-600 hover:bg-emerald-500 active:scale-95 text-white font-extrabold text-xs rounded-xl shadow-sm transition-all cursor-pointer flex items-center gap-1.5 border border-emerald-400/30",
                                        title: _
                                          ? "تحميل صورة QR"
                                          : "Download QR Code",
                                        children: [
                                          l.jsx(Zx, { size: 14 }),
                                          l.jsx("span", {
                                            children: _ ? "تحميل" : "Download",
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  l.jsx("div", {
                                    className:
                                      "relative group cursor-pointer my-1",
                                    children: l.jsxs("div", {
                                      onClick: $s,
                                      className: `p-3 rounded-2xl border-2 transition-all shadow-md hover:shadow-xl active:scale-95 relative ${A ? "bg-[#0a0f24] border-cyan-500/60 hover:border-cyan-400" : "bg-white border-slate-200 hover:border-blue-600"}`,
                                      title: _
                                        ? "انقر على الصورة لنسخها للحافظة"
                                        : "Click image to copy to clipboard",
                                      children: [
                                        l.jsx("img", {
                                          src: ya,
                                          alt: "QR Code",
                                          className:
                                            "w-44 h-44 object-contain rounded-lg",
                                        }),
                                        l.jsxs("div", {
                                          className:
                                            "absolute inset-0 bg-blue-900/70 opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl flex flex-col items-center justify-center text-white p-2 text-center pointer-events-none",
                                          children: [
                                            l.jsx(ui, {
                                              size: 26,
                                              className:
                                                "mb-1 animate-bounce text-white",
                                            }),
                                            l.jsx("span", {
                                              className:
                                                "text-xs font-extrabold",
                                              children: _
                                                ? "اضغط لنسخ الصورة"
                                                : "Click to copy image",
                                            }),
                                          ],
                                        }),
                                      ],
                                    }),
                                  }),
                                  l.jsx("button", {
                                    onClick: $s,
                                    className: `px-4 py-2 rounded-xl font-extrabold text-xs transition-all flex items-center gap-2 cursor-pointer shadow-sm ${Nl ? "bg-emerald-600 text-white shadow-emerald-600/30" : A ? "bg-[#0c132c] hover:bg-[#162148] text-cyan-100 border border-cyan-500/50" : "bg-white hover:bg-slate-100 text-slate-900 border border-slate-300"}`,
                                    children: Nl
                                      ? l.jsxs(l.Fragment, {
                                          children: [
                                            l.jsx(ms, { size: 15 }),
                                            l.jsx("span", {
                                              children: _
                                                ? "تم نسخ صورة الـ QR بنجاح!"
                                                : "QR Code Image Copied!",
                                            }),
                                          ],
                                        })
                                      : l.jsxs(l.Fragment, {
                                          children: [
                                            l.jsx(ui, {
                                              size: 15,
                                              className: A
                                                ? "text-cyan-400"
                                                : "text-blue-600",
                                            }),
                                            l.jsx("span", {
                                              children: _
                                                ? "نسخ صورة الـ QR"
                                                : "Copy QR Image",
                                            }),
                                          ],
                                        }),
                                  }),
                                ],
                              }),
                            l.jsx("div", {
                              className: `text-center font-bold text-xs pt-1 ${vl ? "text-emerald-600" : "text-rose-600"}`,
                              children: et
                                ? Kt(et)
                                : l.jsx("span", {
                                    className: "opacity-0",
                                    children: "-",
                                  }),
                            }),
                          ],
                        }),
                      _a === "ip" &&
                        l.jsxs(l.Fragment, {
                          children: [
                            l.jsxs("div", {
                              className: "flex flex-col sm:flex-row gap-2.5",
                              children: [
                                l.jsx("input", {
                                  type: "text",
                                  placeholder: _
                                    ? "أدخل عنوان IP (مثال: 8.8.8.8)"
                                    : "Enter IP address (e.g. 8.8.8.8)",
                                  value: E,
                                  onChange: (i) => Z(i.target.value),
                                  onKeyDown: (i) => {
                                    i.key === "Enter" && !M && kn();
                                  },
                                  disabled: M,
                                  className: `flex-1 p-3.5 border-2 rounded-xl text-sm sm:text-base font-bold transition-colors min-w-0 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm font-sans ${A ? "bg-[#050814] border-cyan-500/70 text-cyan-100 placeholder:text-cyan-600/80 focus:outline-none focus:border-fuchsia-500" : "bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-600"}`,
                                }),
                                l.jsx("button", {
                                  onClick: () => kn(),
                                  disabled: M,
                                  className:
                                    "bg-blue-600 hover:bg-blue-700 active:scale-95 text-white font-extrabold px-6 py-3.5 rounded-xl transition-all cursor-pointer shrink-0 text-sm disabled:opacity-50 disabled:bg-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed flex items-center justify-center gap-1.5 min-w-[110px] shadow-md shadow-blue-600/20 border border-blue-500/30",
                                  children: M
                                    ? l.jsxs(l.Fragment, {
                                        children: [
                                          l.jsx("span", {
                                            className:
                                              "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin",
                                          }),
                                          l.jsx("span", {
                                            children: _
                                              ? "جاري..."
                                              : "Processing...",
                                          }),
                                        ],
                                      })
                                    : l.jsx("span", {
                                        children: _ ? "فحص" : "Lookup",
                                      }),
                                }),
                              ],
                            }),
                            ne &&
                              l.jsxs("div", {
                                className:
                                  "bg-rose-50 border border-rose-200 text-rose-800 p-4 rounded-xl text-xs sm:text-sm font-bold leading-relaxed space-y-1 select-text text-start shadow-sm",
                                children: [
                                  l.jsx("div", {
                                    className:
                                      "flex items-center gap-1.5 text-rose-600 font-extrabold text-xs uppercase tracking-wide",
                                    children: l.jsxs("span", {
                                      children: ["⚠️ ", _ ? "خطأ" : "Error"],
                                    }),
                                  }),
                                  l.jsx("p", { children: ne }),
                                ],
                              }),
                            he &&
                              l.jsxs("div", {
                                className: `border-2 rounded-2xl p-4 space-y-3.5 text-start animate-fade-in select-text shadow-sm ${A ? "bg-[#050814]/90 border-cyan-500/50 text-cyan-100" : "bg-slate-50 border-slate-200/80 text-slate-900"}`,
                                children: [
                                  l.jsxs("div", {
                                    className: `flex flex-col sm:flex-row sm:items-center justify-between pb-3 border-b gap-2 ${A ? "border-cyan-500/30" : "border-slate-200"}`,
                                    children: [
                                      l.jsxs("h4", {
                                        className: `font-black text-sm flex items-center gap-2 ${A ? "text-cyan-300" : "text-slate-900"}`,
                                        children: [
                                          l.jsx("span", {
                                            className: A
                                              ? "text-cyan-400 text-base"
                                              : "text-blue-600 text-base",
                                            children: "🔍",
                                          }),
                                          l.jsx("span", {
                                            children: _
                                              ? "تفاصيل الـ IP"
                                              : "IP Address Details",
                                          }),
                                        ],
                                      }),
                                      l.jsxs("div", {
                                        className:
                                          "flex items-center gap-2 flex-wrap",
                                        children: [
                                          M
                                            ? l.jsxs("span", {
                                                className:
                                                  "inline-flex items-center gap-1.5 text-[11px] font-black px-2.5 py-1 rounded-lg text-slate-700 bg-slate-200 border border-slate-300 animate-pulse",
                                                children: [
                                                  l.jsx("span", {
                                                    className:
                                                      "w-1.5 h-1.5 rounded-full bg-slate-400 animate-ping",
                                                  }),
                                                  _
                                                    ? "جاري فحص VPN..."
                                                    : "Checking VPN...",
                                                ],
                                              })
                                            : he.vpnStatus === "yes"
                                              ? l.jsxs("span", {
                                                  className:
                                                    "inline-flex items-center gap-1 text-[11px] font-black px-2.5 py-1 rounded-lg text-white bg-rose-600 shadow-sm",
                                                  children: [
                                                    "🛡️ ",
                                                    _
                                                      ? "تم اكتشاف VPN"
                                                      : "VPN Detected",
                                                  ],
                                                })
                                              : he.vpnStatus === "no"
                                                ? l.jsxs("span", {
                                                    className:
                                                      "inline-flex items-center gap-1 text-[11px] font-black px-2.5 py-1 rounded-lg text-white bg-emerald-600 shadow-sm",
                                                    children: [
                                                      "✅ ",
                                                      _
                                                        ? "لم يتم اكتشاف VPN"
                                                        : "No VPN Detected",
                                                    ],
                                                  })
                                                : l.jsxs("span", {
                                                    className:
                                                      "inline-flex items-center gap-1 text-[11px] font-black px-2.5 py-1 rounded-lg text-slate-700 bg-slate-200 border border-slate-300",
                                                    children: [
                                                      "❓ ",
                                                      _
                                                        ? "حالة الـ VPN غير معروفة"
                                                        : "VPN Status Unknown",
                                                    ],
                                                  }),
                                          l.jsx("span", {
                                            className: `text-xs font-mono font-black px-2.5 py-1 rounded-lg border shadow-sm ${A ? "bg-[#02050e] text-cyan-300 border-cyan-500/50" : "bg-white text-blue-700 border-slate-200"}`,
                                            children: he.ip,
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className:
                                      "grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs",
                                    children: [
                                      l.jsxs("div", {
                                        className: `p-3 rounded-xl border shadow-sm space-y-1 ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-white border-slate-200/80"}`,
                                        children: [
                                          l.jsx("span", {
                                            className: `text-[10px] uppercase font-black tracking-wider text-start block ${A ? "text-cyan-400" : "text-slate-500"}`,
                                            children: _
                                              ? "الدولة والمنطقة"
                                              : "Country & Region",
                                          }),
                                          l.jsxs("div", {
                                            className: `font-extrabold flex items-center gap-1.5 text-xs sm:text-sm ${A ? "text-cyan-100" : "text-slate-900"}`,
                                            children: [
                                              l.jsx("span", { children: "🌍" }),
                                              l.jsxs("span", {
                                                children: [
                                                  he.country,
                                                  he.region &&
                                                  he.region !== "Unknown"
                                                    ? `, ${he.region}`
                                                    : "",
                                                ],
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      l.jsxs("div", {
                                        className: `p-3 rounded-xl border shadow-sm space-y-1 ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-white border-slate-200/80"}`,
                                        children: [
                                          l.jsx("span", {
                                            className: `text-[10px] uppercase font-black tracking-wider text-start block ${A ? "text-cyan-400" : "text-slate-500"}`,
                                            children: _ ? "المدينة" : "City",
                                          }),
                                          l.jsxs("div", {
                                            className: `font-extrabold flex items-center gap-1.5 text-xs sm:text-sm ${A ? "text-cyan-100" : "text-slate-900"}`,
                                            children: [
                                              l.jsx("span", { children: "📍" }),
                                              l.jsx("span", {
                                                children: he.city,
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      l.jsxs("div", {
                                        className: `p-3 rounded-xl border shadow-sm space-y-1 ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-white border-slate-200/80"}`,
                                        children: [
                                          l.jsx("span", {
                                            className: `text-[10px] uppercase font-black tracking-wider text-start block ${A ? "text-cyan-400" : "text-slate-500"}`,
                                            children: _
                                              ? "الشبكة (ASN)"
                                              : "Network (ASN)",
                                          }),
                                          l.jsxs("div", {
                                            className: `font-extrabold font-mono flex items-center gap-1.5 text-xs sm:text-sm ${A ? "text-cyan-300" : "text-blue-700"}`,
                                            children: [
                                              l.jsx("span", { children: "🔢" }),
                                              l.jsx("span", {
                                                children: he.asn,
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      l.jsxs("div", {
                                        className: `p-3 rounded-xl border shadow-sm space-y-1 ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-white border-slate-200/80"}`,
                                        children: [
                                          l.jsx("span", {
                                            className: `text-[10px] uppercase font-black tracking-wider text-start block ${A ? "text-cyan-400" : "text-slate-500"}`,
                                            children: _
                                              ? "مزود الخدمة (ISP)"
                                              : "ISP / Organization",
                                          }),
                                          l.jsxs("div", {
                                            className: `font-extrabold truncate flex items-center gap-1.5 text-xs sm:text-sm ${A ? "text-cyan-100" : "text-slate-900"}`,
                                            title: he.isp,
                                            children: [
                                              l.jsx("span", { children: "🏢" }),
                                              l.jsx("span", {
                                                className: "truncate",
                                                children: he.isp,
                                              }),
                                            ],
                                          }),
                                        ],
                                      }),
                                      l.jsxs("div", {
                                        className: `p-3 rounded-xl border shadow-sm space-y-1 ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-white border-slate-200/80"}`,
                                        children: [
                                          l.jsx("span", {
                                            className: `text-[10px] uppercase font-black tracking-wider text-start block ${A ? "text-cyan-400" : "text-slate-500"}`,
                                            children: _
                                              ? "نوع الاتصال"
                                              : "Connection Type",
                                          }),
                                          l.jsx("div", {
                                            children: l.jsxs("span", {
                                              className: `inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-black border ${he.type.includes("Hosting") ? "bg-amber-50 text-amber-800 border-amber-200" : he.type.includes("Cellular") ? "bg-purple-50 text-purple-800 border-purple-200" : "bg-emerald-50 text-emerald-800 border-emerald-200"}`,
                                              children: ["⚡ ", he.type],
                                            }),
                                          }),
                                        ],
                                      }),
                                      l.jsxs("div", {
                                        className: `p-3 rounded-xl border shadow-sm space-y-1 ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-white border-slate-200/80"}`,
                                        children: [
                                          l.jsx("span", {
                                            className: `text-[10px] uppercase font-black tracking-wider text-start block ${A ? "text-cyan-400" : "text-slate-500"}`,
                                            children: _
                                              ? "مؤشر البوت"
                                              : "Bot Indicator",
                                          }),
                                          l.jsx("div", {
                                            children: l.jsxs("span", {
                                              className: `inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-black border ${he.isBot !== "No" ? "bg-rose-50 text-rose-800 border-rose-200 animate-pulse" : "bg-emerald-50 text-emerald-800 border-emerald-200"}`,
                                              children: ["🤖 ", he.isBot],
                                            }),
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                ],
                              }),
                          ],
                        }),
                      _a === "download" &&
                        l.jsxs(l.Fragment, {
                          children: [
                            l.jsxs("div", {
                              className: "flex flex-col sm:flex-row gap-2.5",
                              children: [
                                l.jsx("input", {
                                  type: "url",
                                  inputMode: "url",
                                  placeholder: _
                                    ? "ألصق رابط فيديو فيسبوك هنا"
                                    : "Paste Facebook video or reel link",
                                  value: kl,
                                  onChange: (i) => Da(i.target.value),
                                  onKeyDown: (i) => {
                                    i.key === "Enter" && !Ul && fr();
                                  },
                                  disabled: Ul,
                                  className: `flex-1 p-3.5 border-2 rounded-xl text-sm sm:text-base font-bold transition-colors min-w-0 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm font-sans ${A ? "bg-[#050814] border-cyan-500/70 text-cyan-100 placeholder:text-cyan-600/80 focus:outline-none focus:border-fuchsia-500" : "bg-white border-slate-300 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-blue-600"}`,
                                }),
                                l.jsx("button", {
                                  onClick: fr,
                                  disabled: Ul,
                                  className:
                                    "bg-blue-600 hover:bg-blue-700 active:scale-95 text-white font-extrabold px-6 py-3.5 rounded-xl transition-all cursor-pointer shrink-0 text-sm disabled:opacity-50 disabled:bg-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed flex items-center justify-center gap-1.5 min-w-[110px] shadow-md shadow-blue-600/20 border border-blue-500/30",
                                  children: Ul
                                    ? l.jsxs(l.Fragment, {
                                        children: [
                                          l.jsx("span", {
                                            className:
                                              "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin",
                                          }),
                                          l.jsx("span", {
                                            children: _
                                              ? "جاري..."
                                              : "Processing...",
                                          }),
                                        ],
                                      })
                                    : l.jsx("span", {
                                        children: _ ? "تحميل" : "Download",
                                      }),
                                }),
                              ],
                            }),
                            d &&
                              l.jsxs("div", {
                                className:
                                  "bg-rose-50 border border-rose-200 text-rose-800 p-4 rounded-xl text-xs sm:text-sm font-bold leading-relaxed space-y-1 select-text text-start shadow-sm",
                                children: [
                                  l.jsx("div", {
                                    className:
                                      "flex items-center gap-1.5 text-rose-600 font-extrabold text-xs uppercase tracking-wide",
                                    children: l.jsxs("span", {
                                      children: ["⚠️ ", _ ? "خطأ" : "Error"],
                                    }),
                                  }),
                                  l.jsx("p", { children: d }),
                                ],
                              }),
                            p &&
                              l.jsxs("div", {
                                className: `border-2 rounded-2xl p-4 space-y-4 text-start animate-fade-in select-text shadow-sm ${A ? "bg-[#050814]/90 border-cyan-500/50 text-cyan-100" : "bg-slate-50 border-slate-200/80 text-slate-900"}`,
                                children: [
                                  l.jsxs("div", {
                                    className: `flex flex-col sm:flex-row gap-3 p-3 rounded-xl border shadow-sm ${A ? "bg-[#02050e] border-cyan-500/40" : "bg-white border-slate-200/80"}`,
                                    children: [
                                      p.thumbnail &&
                                        l.jsxs("div", {
                                          className:
                                            "relative w-full sm:w-28 h-20 bg-slate-200 rounded-lg overflow-hidden shrink-0 self-start shadow-inner",
                                          children: [
                                            l.jsx("img", {
                                              src: p.thumbnail,
                                              referrerPolicy: "no-referrer",
                                              alt: p.title,
                                              className:
                                                "w-full h-full object-cover",
                                              loading: "lazy",
                                            }),
                                            p.duration
                                              ? l.jsxs("span", {
                                                  className:
                                                    "absolute bottom-1 right-1 bg-black/80 text-white text-[10px] px-1.5 py-0.5 rounded font-black font-mono",
                                                  children: [
                                                    Math.floor(p.duration / 60),
                                                    ":",
                                                    String(
                                                      p.duration % 60,
                                                    ).padStart(2, "0"),
                                                  ],
                                                })
                                              : null,
                                          ],
                                        }),
                                      l.jsxs("div", {
                                        className: "flex-1 space-y-1",
                                        children: [
                                          l.jsx("h4", {
                                            className: `font-black text-xs sm:text-sm line-clamp-2 ${A ? "text-cyan-100" : "text-slate-900"}`,
                                            children: p.title,
                                          }),
                                          p.description &&
                                            l.jsx("p", {
                                              className: `text-[11px] font-medium line-clamp-2 leading-relaxed ${A ? "text-cyan-300/80" : "text-slate-600"}`,
                                              children: p.description,
                                            }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className:
                                      "grid grid-cols-1 sm:grid-cols-2 gap-2.5 pt-1",
                                    children: [
                                      p.downloads?.hd?.url &&
                                        l.jsxs("a", {
                                          href: p.downloads.hd.proxyUrl,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          className:
                                            "flex items-center justify-center gap-2 py-3 px-4 bg-blue-600 hover:bg-blue-700 active:scale-95 text-white font-extrabold rounded-xl shadow-md shadow-blue-600/20 text-xs cursor-pointer text-center transition-all border border-blue-500/30",
                                          children: [
                                            l.jsx("span", { children: "📥" }),
                                            l.jsx("span", {
                                              children: _
                                                ? "تحميل بجودة عالية HD"
                                                : "Download HD (720p)",
                                            }),
                                          ],
                                        }),
                                      p.downloads?.sd?.url &&
                                        l.jsxs("a", {
                                          href: p.downloads.sd.proxyUrl,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          className:
                                            "flex items-center justify-center gap-2 py-3 px-4 bg-slate-200 hover:bg-slate-300 active:scale-95 text-slate-800 font-extrabold rounded-xl text-xs cursor-pointer text-center transition-all border border-slate-300",
                                          children: [
                                            l.jsx("span", { children: "📥" }),
                                            l.jsx("span", {
                                              children: _
                                                ? "تحميل بجودة عادية SD"
                                                : "Download SD (360p)",
                                            }),
                                          ],
                                        }),
                                    ],
                                  }),
                                ],
                              }),
                          ],
                        }),
                    ],
                  }),
                  l.jsxs("ul", {
                    className:
                      "flex flex-wrap items-center gap-x-6 gap-y-2.5 mt-6 mv-rd-ticks",
                    children: [
                      l.jsxs("li", {
                        className:
                          "flex items-center gap-1.5 text-xs font-bold text-[var(--slate)]",
                        children: [
                          l.jsx(ms, {
                            size: 14,
                            className: "text-emerald-500 shrink-0",
                            strokeWidth: 3,
                          }),
                          l.jsx("span", { children: Kt("ticks1") }),
                        ],
                      }),
                      l.jsxs("li", {
                        className:
                          "flex items-center gap-1.5 text-xs font-bold text-[var(--slate)]",
                        children: [
                          l.jsx(ms, {
                            size: 14,
                            className: "text-emerald-500 shrink-0",
                            strokeWidth: 3,
                          }),
                          l.jsx("span", { children: Kt("ticks2") }),
                        ],
                      }),
                      l.jsxs("li", {
                        className:
                          "flex items-center gap-1.5 text-xs font-bold text-[var(--slate)]",
                        children: [
                          l.jsx(ms, {
                            size: 14,
                            className: "text-emerald-500 shrink-0",
                            strokeWidth: 3,
                          }),
                          l.jsx("span", { children: Kt("ticks3") }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              l.jsxs("div", {
                className: `${ct.timerOrderClass} flex flex-col gap-3 justify-start items-center w-full mv-rd-right`,
                children: [
                  l.jsx("div", {
                    className: "w-full",
                    children: l.jsxs("div", {
                      className:
                        "grid grid-cols-2 sm:grid-cols-4 gap-1 p-1.5 bg-slate-900/90 border border-slate-700/80 rounded-xl w-full shadow-lg backdrop-blur-md mv-rd-strip",
                      children: [
                        l.jsxs("button", {
                          onClick: () => ja("timer"),
                          className: `px-2 py-2 rounded-lg font-extrabold text-[11px] sm:text-xs transition-all cursor-pointer flex items-center justify-center gap-1.5 ${j === "timer" ? "bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-sm" : "text-slate-400 hover:text-white hover:bg-slate-800/60"}`,
                          children: [
                            l.jsx(cd, {
                              size: 12,
                              className:
                                j === "timer"
                                  ? "text-white animate-pulse"
                                  : "text-slate-400",
                            }),
                            l.jsx("span", {
                              className: "truncate",
                              children: "TIMER USA",
                            }),
                          ],
                        }),
                        l.jsxs("button", {
                          onClick: () => {
                            (ja("deals"), R());
                          },
                          className: `px-2 py-2 rounded-lg font-extrabold text-[11px] sm:text-xs transition-all cursor-pointer flex items-center justify-center gap-1.5 ${j === "deals" ? "bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-sm" : "text-slate-400 hover:text-white hover:bg-slate-800/60"}`,
                          children: [
                            l.jsx(cd, {
                              size: 12,
                              className:
                                j === "deals"
                                  ? "text-white animate-pulse"
                                  : "text-slate-400",
                            }),
                            l.jsx("span", {
                              className: "truncate",
                              children: "DEALS LIST",
                            }),
                          ],
                        }),
                        l.jsxs("button", {
                          onClick: () => ja("manual_deals"),
                          className: `px-2 py-2 rounded-lg font-extrabold text-[11px] sm:text-xs transition-all cursor-pointer flex items-center justify-center gap-1.5 ${j === "manual_deals" ? "bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-sm" : "text-slate-400 hover:text-white hover:bg-slate-800/60"}`,
                          children: [
                            l.jsx(cd, {
                              size: 12,
                              className:
                                j === "manual_deals"
                                  ? "text-white animate-pulse"
                                  : "text-slate-400",
                            }),
                            l.jsx("span", {
                              className: "truncate",
                              children: "MANUAL DEAL LIST",
                            }),
                          ],
                        }),
                        l.jsxs("button", {
                          onClick: () => ja("network_leads"),
                          className: `px-2 py-2 rounded-lg font-extrabold text-[11px] sm:text-xs transition-all cursor-pointer flex items-center justify-center gap-1.5 ${j === "network_leads" ? "bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-sm" : "text-slate-400 hover:text-white hover:bg-slate-800/60"}`,
                          children: [
                            l.jsx(ef, {
                              size: 12,
                              className:
                                j === "network_leads"
                                  ? "text-amber-300 fill-amber-300 animate-pulse"
                                  : "text-slate-400",
                            }),
                            l.jsx("span", {
                              className: "truncate",
                              children: "NETWORK LIVE LEADS",
                            }),
                          ],
                        }),
                      ],
                    }),
                  }),
                  l.jsxs("div", {
                    className: "w-full mv-rd-rpanel",
                    children: [
                      j === "timer" &&
                        l.jsx(x.Suspense, {
                          fallback: l.jsx("div", {
                            className:
                              "w-full bg-slate-900/90 border border-slate-800 rounded-2xl p-5 text-center min-h-[140px] flex items-center justify-center",
                            children: l.jsx("div", {
                              className:
                                "w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin",
                            }),
                          }),
                          children: l.jsx(fm, {
                            language: b,
                            theme: f.THEME || "modern-dark",
                            palette: f.PALETTE,
                            onLockRotation: R,
                            onNextWidget: () => ja("deals"),
                            onPrevWidget: () => ja("network_leads"),
                          }),
                        }),
                      j === "deals" &&
                        l.jsx(x.Suspense, {
                          fallback: l.jsx("div", {
                            className:
                              "w-full bg-[#0b132b] border border-purple-500/30 rounded-2xl p-5 text-center min-h-[200px] flex items-center justify-center",
                            children: l.jsx("div", {
                              className:
                                "w-6 h-6 border-2 border-purple-500 border-t-transparent rounded-full animate-spin",
                            }),
                          }),
                          children: l.jsx(pm, {
                            language: b,
                            refreshKey: W,
                            mvSeeJust: !0,
                            onLockRotation: R,
                            onNextWidget: () => ja("manual_deals"),
                            onPrevWidget: () => ja("timer"),
                          }),
                        }),
                      j === "manual_deals" &&
                        l.jsx(x.Suspense, {
                          fallback: l.jsx("div", {
                            className:
                              "w-full bg-[#0b132b] border border-slate-700/60 rounded-2xl p-5 text-center min-h-[200px] flex items-center justify-center",
                            children: l.jsx("div", {
                              className:
                                "w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin",
                            }),
                          }),
                          children: l.jsx(mm, {
                            language: b,
                            onLockRotation: R,
                            onNextWidget: () => ja("network_leads"),
                            onPrevWidget: () => ja("deals"),
                          }),
                        }),
                      j === "network_leads" &&
                        l.jsx(x.Suspense, {
                          fallback: l.jsx("div", {
                            className:
                              "w-full bg-[#0d0a26] border border-indigo-950 rounded-2xl p-5 text-center min-h-[200px] flex items-center justify-center",
                            children: l.jsx("div", {
                              className:
                                "w-6 h-6 border-2 border-amber-400 border-t-transparent rounded-full animate-spin",
                            }),
                          }),
                          children: l.jsx(hm, {
                            language: b,
                            onLockRotation: R,
                            onNextWidget: () => ja("timer"),
                            onPrevWidget: () => ja("manual_deals"),
                          }),
                        }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        }),
      }),
      l.jsx(MvNets, { language: b }),
      l.jsx("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 select-none",
        children: l.jsxs("div", {
          className: "grid grid-cols-1 xl:grid-cols-12 gap-6 items-start",
          children: [
            l.jsx("aside", {
              className: "hidden xl:block xl:col-span-3 sticky top-[78px]",
              children: l.jsxs("div", {
                className:
                  "glass-card rounded-3xl h-[600px] flex flex-col items-center justify-between p-4 text-center shadow-2xl select-none overflow-hidden text-slate-900",
                children: [
                  l.jsx("span", {
                    className:
                      "text-[10px] uppercase font-bold tracking-widest text-slate-500 block mb-2",
                    children: "Advertisement Slot",
                  }),
                  f.YANDEX_MODE === "custom_image" ||
                  f.YANDEX_BLOCK === "R-A-XXXXXXX-1"
                    ? l.jsx("div", {
                        className:
                          "w-full flex-1 rounded-2xl overflow-hidden flex items-center justify-center bg-black/5 relative group border border-slate-200",
                        children:
                          f.YANDEX_CPA_CHECK && f.YANDEX_CPA_URL
                            ? l.jsxs("a", {
                                href: f.YANDEX_CPA_URL,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "w-full h-full block cursor-pointer",
                                children: [
                                  l.jsx("img", {
                                    src:
                                      f.YANDEX_IMAGE_URL ||
                                      "https://iili.io/CSegoOP.png",
                                    alt: "Yandex Custom Advertisement",
                                    referrerPolicy: "no-referrer",
                                    className:
                                      "w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]",
                                    loading: "lazy",
                                  }),
                                  l.jsx("div", {
                                    className:
                                      "absolute inset-x-0 bottom-0 bg-black/60 text-white py-1 px-2 text-[10px] font-black opacity-0 group-hover:opacity-100 transition-opacity",
                                    children: "Click to view offer",
                                  }),
                                ],
                              })
                            : l.jsx("img", {
                                src:
                                  f.YANDEX_IMAGE_URL ||
                                  "https://iili.io/CSegoOP.png",
                                alt: "Yandex Custom Advertisement",
                                referrerPolicy: "no-referrer",
                                className: "w-full h-full object-cover",
                                loading: "lazy",
                              }),
                      })
                    : l.jsx("div", {
                        className:
                          "border-2 border-dashed border-slate-300 w-full flex-1 rounded-2xl flex items-center justify-center p-4",
                        children: l.jsx("p", {
                          className:
                            "text-xs text-slate-500 font-mono whitespace-pre-wrap",
                          children:
                            f.YANDEX_BLOCK !== "R-A-XXXXXXX-1"
                              ? `Yandex Ad RTB ID:
${f.YANDEX_BLOCK}`
                              : "Yandex Block",
                        }),
                      }),
                ],
              }),
            }),
            l.jsxs("main", {
              className: "xl:col-span-6 space-y-6",
              children: [
                l.jsxs("section", {
                  className:
                    "glass-card rounded-3xl p-6 shadow-2xl text-slate-900",
                  children: [
                    l.jsx("div", {
                      className:
                        "text-[10px] uppercase font-extrabold tracking-widest text-blue-600 mb-2",
                      children: Kt("aboutTitle"),
                    }),
                    l.jsx("p", {
                      className:
                        "text-sm sm:text-base leading-relaxed text-slate-700 select-text",
                      children: Kt("aboutLead"),
                    }),
                  ],
                }),
                l.jsxs("section", {
                  className:
                    "bg-slate-900/90 text-white border border-slate-700 backdrop-blur-md rounded-3xl p-6 text-center space-y-2 shadow-2xl",
                  children: [
                    l.jsx("h2", {
                      className: "text-base font-black text-blue-400",
                      children: Kt("noticeTitle"),
                    }),
                    l.jsx("p", {
                      className:
                        "text-xs sm:text-sm text-slate-200 select-text leading-relaxed",
                      children: Kt("noticeLead"),
                    }),
                  ],
                }),
                l.jsx("a", {
                  href: f.ALT_SITE,
                  target: "_blank",
                  rel: "noopener",
                  className:
                    "block bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-black text-center text-sm sm:text-base py-4.5 px-6 rounded-3xl shadow-2xl shadow-blue-600/40 transition-all cursor-pointer border border-blue-400/30",
                  children: _ ? f.SITE_BUTTON_AR : f.SITE_BUTTON_EN,
                }),
                l.jsxs("section", {
                  className:
                    "glass-card rounded-3xl p-6 shadow-2xl text-slate-900",
                  children: [
                    l.jsx("div", {
                      className:
                        "text-[10px] uppercase font-extrabold tracking-widest text-blue-600 mb-2",
                      children: Kt("whyTitle"),
                    }),
                    l.jsx("h2", {
                      className:
                        "text-lg font-extrabold text-slate-900 leading-tight mb-4 select-text",
                      children: Kt("whyHeading"),
                    }),
                    l.jsxs("div", {
                      className: "grid grid-cols-1 sm:grid-cols-2 gap-3.5",
                      children: [
                        l.jsxs("div", {
                          className:
                            "bg-slate-50 border border-slate-200 rounded-2xl p-4",
                          children: [
                            l.jsx("h3", {
                              className:
                                "font-extrabold text-sm text-slate-900 mb-1",
                              children: _ ? "بدون حساب" : "No account needed",
                            }),
                            l.jsx("p", {
                              className: "text-xs text-slate-600 select-text",
                              children: _
                                ? "الصق الوجهة واحصل على رابط قصير بنقرة واحدة. بدون تسجيل ولا بريد إلكتروني."
                                : "Paste a destination and get a short link in one click. No signup, no email.",
                            }),
                          ],
                        }),
                        l.jsxs("div", {
                          className:
                            "bg-slate-50 border border-slate-200 rounded-2xl p-4",
                          children: [
                            l.jsx("h3", {
                              className:
                                "font-extrabold text-sm text-slate-900 mb-1",
                              children: _
                                ? "آمن على المنصات"
                                : "Safe on social",
                            }),
                            l.jsx("p", {
                              className: "text-xs text-slate-600 select-text",
                              children: _
                                ? "صفحة المتابعة تحمي روابطك على فيسبوك وواتساب وتيليجرام."
                                : "The optional Continue page keeps links working on Facebook, WhatsApp and Telegram.",
                            }),
                          ],
                        }),
                        l.jsxs("div", {
                          className:
                            "bg-slate-50 border border-slate-200 rounded-2xl p-4",
                          children: [
                            l.jsx("h3", {
                              className:
                                "font-extrabold text-sm text-slate-900 mb-1",
                              children: _
                                ? "جاهز للتسويق بالعمولة"
                                : "Affiliate ready",
                            }),
                            l.jsx("p", {
                              className: "text-xs text-slate-600 select-text",
                              children: _
                                ? "يعمل مع Mavely وShareASale وClickBank وImpact وCJ Affiliate وAmazon Associates."
                                : "Works with Mavely, ShareASale, ClickBank, Impact, CJ Affiliate and Amazon Associates.",
                            }),
                          ],
                        }),
                        l.jsxs("div", {
                          className:
                            "bg-slate-50 border border-slate-200 rounded-2xl p-4",
                          children: [
                            l.jsx("h3", {
                              className:
                                "font-extrabold text-sm text-slate-900 mb-1",
                              children: _
                                ? "سريع ومهيأ للجوال"
                                : "Fast and mobile first",
                            }),
                            l.jsx("p", {
                              className: "text-xs text-slate-600 select-text",
                              children: _
                                ? "بدون مكتبات أو خطوط ثقيلة خارجية، فتفتح الصفحة فورًا على أي هاتف."
                                : "No heavy frameworks, no extra web fonts. The page loads instantly, even on a slow connection.",
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
                l.jsxs("section", {
                  className:
                    "glass-card rounded-3xl p-6 shadow-2xl text-slate-900",
                  children: [
                    l.jsx("div", {
                      className:
                        "text-[10px] uppercase font-extrabold tracking-widest text-blue-600 mb-4",
                      children: Kt("faqTitle"),
                    }),
                    l.jsxs("div", {
                      className: "divide-y divide-slate-200",
                      children: [
                        l.jsxs("div", {
                          className: "py-3",
                          children: [
                            l.jsxs("button", {
                              onClick: () =>
                                en((i) => [!i[0], i[1], i[2], i[3]]),
                              className:
                                "w-full flex justify-between items-center text-start font-bold text-sm text-slate-900 cursor-pointer py-1 hover:text-blue-600",
                              children: [
                                l.jsx("span", {
                                  children: _
                                    ? "هل الأداة مجانية؟"
                                    : "Is this URL shortener free?",
                                }),
                                l.jsx(ar, {
                                  size: 15,
                                  className: `text-blue-600 transform transition-transform duration-200 ${Rl[0] ? "rotate-180" : ""}`,
                                }),
                              ],
                            }),
                            Rl[0] &&
                              l.jsx("p", {
                                className:
                                  "text-xs sm:text-sm text-slate-600 mt-2 select-text leading-relaxed",
                                children: _
                                  ? "نعم. إنشاء الروابط مجاني تمامًا ولا يتطلب إنشاء حساب."
                                  : "Yes. Creating short links is completely free and no account is required.",
                              }),
                          ],
                        }),
                        l.jsxs("div", {
                          className: "py-3",
                          children: [
                            l.jsxs("button", {
                              onClick: () =>
                                en((i) => [i[0], !i[1], i[2], i[3]]),
                              className:
                                "w-full flex justify-between items-center text-start font-bold text-sm text-slate-900 cursor-pointer py-1 hover:text-blue-600",
                              children: [
                                l.jsx("span", {
                                  children: _
                                    ? "هل تعمل الروابط على فيسبوك وواتساب؟"
                                    : "Do the links work on Facebook and WhatsApp?",
                                }),
                                l.jsx(ar, {
                                  size: 15,
                                  className: `text-blue-600 transform transition-transform duration-200 ${Rl[1] ? "rotate-180" : ""}`,
                                }),
                              ],
                            }),
                            Rl[1] &&
                              l.jsx("p", {
                                className:
                                  "text-xs sm:text-sm text-slate-600 mt-2 select-text leading-relaxed",
                                children: _
                                  ? "نعم. فعّل خيار صفحة المعاينة لإضافة زر متابعة، وهو الأسلوب الأكثر أمانًا للمشاركة."
                                  : "Yes. Turn on the preview page option to add a Continue screen, which is the safest way to share on Facebook, WhatsApp and Telegram.",
                              }),
                          ],
                        }),
                        l.jsxs("div", {
                          className: "py-3",
                          children: [
                            l.jsxs("button", {
                              onClick: () =>
                                en((i) => [i[0], i[1], !i[2], i[3]]),
                              className:
                                "w-full flex justify-between items-center text-start font-bold text-sm text-slate-900 cursor-pointer py-1 hover:text-blue-600",
                              children: [
                                l.jsx("span", {
                                  children: _
                                    ? "هل يمكنني استخدامها في حملات العمولة والعملات الرقمية؟"
                                    : "Can I use short links for affiliate and crypto campaigns?",
                                }),
                                l.jsx(ar, {
                                  size: 15,
                                  className: `text-blue-600 transform transition-transform duration-200 ${Rl[2] ? "rotate-180" : ""}`,
                                }),
                              ],
                            }),
                            Rl[2] &&
                              l.jsx("p", {
                                className:
                                  "text-xs sm:text-sm text-slate-600 mt-2 select-text leading-relaxed",
                                children: _
                                  ? "نعم. تعمل الروابط مع شبكات التسويق بالعمولة مثل Mavely وCollective Voice وShopyoulikes وAmazon Associates وShareASale وClickBank وImpact وCJ Affiliate."
                                  : "Yes. The links work with affiliate and influencer networks such as Mavely, Collective Voice, Shopyoulikes, Amazon Associates, ShareASale, ClickBank, Impact and CJ Affiliate.",
                              }),
                          ],
                        }),
                        l.jsxs("div", {
                          className: "py-3",
                          children: [
                            l.jsxs("button", {
                              onClick: () =>
                                en((i) => [i[0], i[1], i[2], !i[3]]),
                              className:
                                "w-full flex justify-between items-center text-start font-bold text-sm text-slate-900 cursor-pointer py-1 hover:text-blue-600",
                              children: [
                                l.jsx("span", {
                                  children: _
                                    ? "هل تنتهي صلاحية الروابط؟"
                                    : "Do short links expire?",
                                }),
                                l.jsx(ar, {
                                  size: 15,
                                  className: `text-blue-600 transform transition-transform duration-200 ${Rl[3] ? "rotate-180" : ""}`,
                                }),
                              ],
                            }),
                            Rl[3] &&
                              l.jsx("p", {
                                className:
                                  "text-xs sm:text-sm text-slate-600 mt-2 select-text leading-relaxed",
                                children: _
                                  ? "لا. يظل الرابط القصير فعالًا حتى تتم إزالته. إذا توقف أي رابط فاستخدم الموقع البديل أعلاه."
                                  : "No. A short link stays active until it is removed. If a link ever stops working, use the alternative site listed above.",
                              }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
            l.jsx("aside", {
              className: "hidden xl:block xl:col-span-3 sticky top-[78px]",
              children: l.jsxs("div", {
                className:
                  "glass-card rounded-3xl h-[600px] flex flex-col items-center justify-between p-4 text-center shadow-2xl select-none overflow-hidden text-slate-900",
                children: [
                  l.jsx("span", {
                    className:
                      "text-[10px] uppercase font-bold tracking-widest text-slate-500 block mb-2",
                    children: "Advertisement Slot",
                  }),
                  f.ADSENSE_MODE === "custom_image" ||
                  f.ADSENSE_CLIENT === "ca-pub-XXXXXXXXXXXXXXXX"
                    ? l.jsx("div", {
                        className:
                          "w-full flex-1 rounded-2xl overflow-hidden flex items-center justify-center bg-black/5 relative group border border-slate-200",
                        children:
                          f.ADSENSE_CPA_CHECK && f.ADSENSE_CPA_URL
                            ? l.jsxs("a", {
                                href: f.ADSENSE_CPA_URL,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "w-full h-full block cursor-pointer",
                                children: [
                                  l.jsx("img", {
                                    src:
                                      f.ADSENSE_IMAGE_URL ||
                                      "https://iili.io/CSegoOP.png",
                                    alt: "Google AdSense Custom Advertisement",
                                    referrerPolicy: "no-referrer",
                                    className:
                                      "w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]",
                                    loading: "lazy",
                                  }),
                                  l.jsx("div", {
                                    className:
                                      "absolute inset-x-0 bottom-0 bg-black/60 text-white py-1 px-2 text-[10px] font-black opacity-0 group-hover:opacity-100 transition-opacity",
                                    children: "Click to view offer",
                                  }),
                                ],
                              })
                            : l.jsx("img", {
                                src:
                                  f.ADSENSE_IMAGE_URL ||
                                  "https://iili.io/CSegoOP.png",
                                alt: "Google AdSense Custom Advertisement",
                                referrerPolicy: "no-referrer",
                                className: "w-full h-full object-cover",
                                loading: "lazy",
                              }),
                      })
                    : l.jsx("div", {
                        className:
                          "border-2 border-dashed border-slate-300 w-full flex-1 rounded-2xl flex items-center justify-center p-4",
                        children: l.jsx("p", {
                          className:
                            "text-xs text-slate-500 font-mono whitespace-pre-wrap",
                          children:
                            f.ADSENSE_CLIENT !== "ca-pub-XXXXXXXXXXXXXXXX"
                              ? `AdSense Publisher ID:
${f.ADSENSE_CLIENT}
Slot:
${f.ADSENSE_SLOT}`
                              : "Google AdSense Slot",
                        }),
                      }),
                ],
              }),
            }),
          ],
        }),
      }),
      l.jsx("footer", {
        className:
          "bg-slate-950/90 text-slate-300 py-8 border-t border-slate-800 backdrop-blur-md select-none text-xs sm:text-sm",
        children: l.jsxs("div", {
          className:
            "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-4",
          children: [
            l.jsxs("nav", {
              "aria-label": "Site policy documents",
              className:
                "flex flex-wrap justify-center gap-x-6 gap-y-3 font-bold",
              children: [
                l.jsx("button", {
                  onClick: () => Ws("privacy"),
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "سياسة الخصوصية" : "Privacy Policy",
                }),
                l.jsx("button", {
                  onClick: () => Ws("cookie"),
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "سياسة ملفات تعريف الارتباط" : "Cookie Policy",
                }),
                l.jsx("button", {
                  onClick: () => {
                    (Zs(la ? la.analytics : !1),
                      Js(la ? la.marketing : !1),
                      Wl(!0));
                  },
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "إعدادات الكوكيز" : "Cookie Settings",
                }),
                l.jsx("button", {
                  onClick: () => Ws("terms"),
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "الشروط" : "Terms",
                }),
                l.jsx("button", {
                  onClick: () => Ws("contact"),
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "اتصل بنا" : "Contact",
                }),
                l.jsx("button", {
                  onClick: () => Ws("about"),
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "من نحن" : "About",
                }),
                l.jsx("button", {
                  onClick: () => Wr("dashboard"),
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "تسجيل الدخول" : "Login",
                }),
                l.jsx("button", {
                  onClick: () => Wr("settings"),
                  className:
                    "hover:text-white transition-colors cursor-pointer",
                  children: _ ? "تعديل الإعدادات" : "Configure",
                }),
              ],
            }),
            l.jsxs("p", {
              className: "text-[var(--foot-dim)] text-xs",
              children: [
                "© ",
                new Date().getFullYear(),
                " ",
                l.jsx("span", { className: "capitalize", children: f.BRAND }),
                ". All rights reserved.",
              ],
            }),
          ],
        }),
      }),
      l.jsx(x.Suspense, {
        fallback: null,
        children: l.jsx(bm, {
          isOpen: pa !== null,
          docType: pa,
          language: b,
          onClose: () => pi(),
          brand: f.BRAND,
          email: f.CONTACT_EMAIL,
        }),
      }),
      He &&
        l.jsx("div", {
          className:
            "fixed inset-0 z-[100] bg-slate-950/80 backdrop-blur-md flex items-center justify-center p-4",
          children: l.jsxs("div", {
            className:
              "bg-[var(--card)] border border-[var(--line)] rounded-2xl p-6 w-full max-w-sm shadow-2xl relative animate-[revealUp_0.2s_ease-out_forwards] flex flex-col text-start",
            children: [
              l.jsx("button", {
                onClick: () => ia(!1),
                className:
                  "absolute top-4 right-4 text-[var(--slate)] hover:text-[var(--ink)] cursor-pointer font-bold text-sm",
                children: "✕",
              }),
              l.jsxs("div", {
                className: "flex items-center gap-2 mb-4",
                children: [
                  l.jsx("span", {
                    className:
                      "p-2 rounded-lg bg-gradient-to-br from-[var(--blue-l)] to-[var(--blue-d)] text-white",
                    children: l.jsx(Bx, { size: 18 }),
                  }),
                  l.jsx("h3", {
                    className: "font-extrabold text-base text-[var(--ink)]",
                    children:
                      b === "ar" ? "مطلوب مصادقة" : "Authentication Required",
                  }),
                ],
              }),
              l.jsxs("form", {
                onSubmit: Ps,
                className: "space-y-3.5",
                children: [
                  l.jsxs("div", {
                    children: [
                      l.jsx("label", {
                        className:
                          "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                        children: b === "ar" ? "اسم المستخدم" : "Username",
                      }),
                      l.jsxs("div", {
                        className: "relative",
                        children: [
                          l.jsx("span", {
                            className:
                              "absolute inset-y-0 left-3 flex items-center text-[var(--slate)] pointer-events-none",
                            children: l.jsx(Fp, { size: 15 }),
                          }),
                          l.jsx("input", {
                            type: "text",
                            required: !0,
                            value: Cl,
                            onChange: (i) => La(i.target.value),
                            className:
                              "w-full pl-9 pr-3 py-2 border-2 border-[var(--line)] bg-[var(--bg-soft)] rounded-xl text-sm font-medium text-[var(--ink)] focus:outline-none focus:border-[var(--blue)]",
                            placeholder: "Enter username",
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    children: [
                      l.jsx("label", {
                        className:
                          "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                        children: b === "ar" ? "كلمة المرور" : "Password",
                      }),
                      l.jsxs("div", {
                        className: "relative",
                        children: [
                          l.jsx("span", {
                            className:
                              "absolute inset-y-0 left-3 flex items-center text-[var(--slate)] pointer-events-none",
                            children: l.jsx(Bx, { size: 15 }),
                          }),
                          l.jsx("input", {
                            type: "password",
                            required: !0,
                            value: Sl,
                            onChange: (i) => Ba(i.target.value),
                            className:
                              "w-full pl-9 pr-3 py-2 border-2 border-[var(--line)] bg-[var(--bg-soft)] rounded-xl text-sm font-medium text-[var(--ink)] focus:outline-none focus:border-[var(--blue)]",
                            placeholder: "Enter password",
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className: "pt-1",
                    children: [
                      l.jsx("label", {
                        className:
                          "block text-xs font-extrabold text-[var(--slate)] mb-1 uppercase tracking-wider",
                        children:
                          b === "ar"
                            ? "رمز التحقق (Captcha)"
                            : "Security Captcha",
                      }),
                      l.jsxs("div", {
                        className:
                          "mb-2 p-2.5 bg-slate-900 border border-slate-700 rounded-xl text-center select-none relative overflow-hidden flex items-center justify-center",
                        children: [
                          l.jsx("div", {
                            className:
                              "absolute inset-0 bg-[radial-gradient(#38bdf8_1px,transparent_1px)] [background-size:8px_8px] opacity-20 pointer-events-none",
                          }),
                          l.jsx("span", {
                            className:
                              "text-lg font-mono font-black italic tracking-widest text-indigo-300 transform -rotate-1 skew-x-3 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]",
                            children: Zl,
                          }),
                        ],
                      }),
                      l.jsx("input", {
                        type: "text",
                        required: !0,
                        value: vt,
                        onChange: (i) => Oa(i.target.value),
                        className:
                          "w-full px-3 py-2 border-2 border-[var(--line)] bg-[var(--bg-soft)] rounded-xl text-sm font-medium text-[var(--ink)] focus:outline-none focus:border-[var(--blue)]",
                        placeholder: "Type the word above",
                      }),
                    ],
                  }),
                  El &&
                    l.jsx("div", {
                      className: "text-xs text-rose-500 font-bold text-center",
                      children: El,
                    }),
                  l.jsxs("div", {
                    className: "flex flex-col gap-2 pt-1",
                    children: [
                      l.jsx("button", {
                        type: "submit",
                        className:
                          "w-full py-2.5 bg-black hover:bg-slate-900 active:scale-[0.985] text-white font-extrabold rounded-xl transition-all shadow-md text-sm cursor-pointer border border-slate-800",
                        children: b === "ar" ? "تحقق" : "Verify",
                      }),
                      l.jsx("button", {
                        type: "submit",
                        className:
                          "w-full py-2.5 bg-gradient-to-br from-[var(--blue-l)] to-[var(--blue-d)] hover:brightness-105 active:scale-[0.985] text-white font-extrabold rounded-xl transition-all shadow-md text-sm cursor-pointer",
                        children: b === "ar" ? "تسجيل الدخول" : "Login",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        }),
      l.jsx(x.Suspense, {
        fallback: null,
        children: l.jsx(gm, {
          settings: f,
          onSave: ur,
          onReset: xr,
          isOpen: wa,
          onClose: () => hi(),
        }),
      }),
      (fi || rr) &&
        l.jsxs("div", {
          className:
            "fixed bottom-4 left-4 right-4 md:left-auto md:max-w-md md:bottom-6 md:right-6 z-[100] bg-[var(--card)] border border-[var(--line)] rounded-2xl p-5 shadow-2xl text-start flex flex-col space-y-4",
          children: [
            l.jsxs("div", {
              className:
                "flex items-center justify-between border-b border-[var(--line)] pb-2.5",
              children: [
                l.jsxs("h3", {
                  className:
                    "font-extrabold text-sm text-[var(--ink)] flex items-center gap-1.5",
                  children: [
                    l.jsx("span", { children: "🍪" }),
                    l.jsx("span", {
                      children:
                        b === "ar"
                          ? "إعدادات ملفات تعريف الارتباط"
                          : "Cookie Consent Preferences",
                    }),
                  ],
                }),
                l.jsx("button", {
                  onClick: () => {
                    (Ml(!1), Wl(!1));
                  },
                  className:
                    "text-[var(--slate)] hover:text-[var(--ink)] cursor-pointer text-xs font-bold",
                  children: "✕",
                }),
              ],
            }),
            l.jsxs("p", {
              className:
                "text-xs text-[var(--slate)] leading-relaxed select-text",
              children: [
                b === "ar"
                  ? "نحن نستخدم ملفات تعريف الارتباط لتحسين تجربتك، وعرض الإعلانات المخصصة، وتحليل حركة المرور لدينا. يرجى مراجعة وتحديد تفضيلاتك أدناه قبل المتابعة."
                  : "We use cookies to personalize content and ads, provide social media features, and analyze our traffic. Please review and configure your preferences below before continuing.",
                " ",
                l.jsx("button", {
                  onClick: () => {
                    (Tt("privacy"), Ml(!1), Wl(!1));
                  },
                  className:
                    "text-[var(--blue)] font-bold hover:underline cursor-pointer",
                  children: b === "ar" ? "سياسة الخصوصية" : "Privacy Policy",
                }),
                " ",
                b === "ar" ? "و" : "and",
                " ",
                l.jsx("button", {
                  onClick: () => {
                    (Tt("cookie"), Ml(!1), Wl(!1));
                  },
                  className:
                    "text-[var(--blue)] font-bold hover:underline cursor-pointer",
                  children:
                    b === "ar" ? "سياسة ملفات الارتباط" : "Cookie Policy",
                }),
                ".",
              ],
            }),
            l.jsxs("div", {
              className:
                "space-y-2.5 bg-[var(--bg-soft)] p-3 rounded-xl border border-[var(--line)]",
              children: [
                l.jsxs("label", {
                  className:
                    "flex items-center justify-between cursor-not-allowed opacity-80 text-xs",
                  children: [
                    l.jsxs("div", {
                      className: "flex flex-col",
                      children: [
                        l.jsx("span", {
                          className: "font-extrabold text-[var(--ink)]",
                          children: b === "ar" ? "ضرورية" : "Necessary",
                        }),
                        l.jsx("span", {
                          className: "text-[10px] text-[var(--slate)]",
                          children:
                            b === "ar"
                              ? "دائما نشطة لتشغيل الموقع"
                              : "Required for core features",
                        }),
                      ],
                    }),
                    l.jsx("input", {
                      type: "checkbox",
                      checked: !0,
                      disabled: !0,
                      className: "accent-[var(--blue)] cursor-not-allowed",
                    }),
                  ],
                }),
                l.jsxs("label", {
                  className:
                    "flex items-center justify-between cursor-pointer text-xs",
                  children: [
                    l.jsxs("div", {
                      className: "flex flex-col",
                      children: [
                        l.jsx("span", {
                          className: "font-extrabold text-[var(--ink)]",
                          children: b === "ar" ? "التحليلات" : "Analytics",
                        }),
                        l.jsx("span", {
                          className: "text-[10px] text-[var(--slate)]",
                          children:
                            b === "ar"
                              ? "مراقبة أداء وزوار الموقع"
                              : "Performance and usage stats",
                        }),
                      ],
                    }),
                    l.jsx("input", {
                      type: "checkbox",
                      checked: Pr,
                      onChange: (i) => Zs(i.target.checked),
                      className: "accent-[var(--blue)] cursor-pointer",
                    }),
                  ],
                }),
                l.jsxs("label", {
                  className:
                    "flex items-center justify-between cursor-pointer text-xs",
                  children: [
                    l.jsxs("div", {
                      className: "flex flex-col",
                      children: [
                        l.jsx("span", {
                          className: "font-extrabold text-[var(--ink)]",
                          children:
                            b === "ar"
                              ? "التسويق والإعلانات"
                              : "Marketing / Ads",
                        }),
                        l.jsx("span", {
                          className: "text-[10px] text-[var(--slate)]",
                          children:
                            b === "ar"
                              ? "إعلانات مخصصة (جوجل وياندكس)"
                              : "Google & Yandex personalized ads",
                        }),
                      ],
                    }),
                    l.jsx("input", {
                      type: "checkbox",
                      checked: or,
                      onChange: (i) => Js(i.target.checked),
                      className: "accent-[var(--blue)] cursor-pointer",
                    }),
                  ],
                }),
              ],
            }),
            l.jsxs("div", {
              className: "grid grid-cols-2 gap-2 pt-1",
              children: [
                l.jsx("button", {
                  onClick: () => {
                    const i = {
                      necessary: !0,
                      analytics: !0,
                      marketing: !0,
                      timestamp: Date.now(),
                      version: "1.0",
                    };
                    (jn(i),
                      Zs(!0),
                      Js(!0),
                      localStorage.setItem(
                        "sh_cookie_consent",
                        JSON.stringify(i),
                      ),
                      Ml(!1),
                      Wl(!1));
                  },
                  className:
                    "py-2 px-3 bg-gradient-to-br from-[var(--blue-l)] to-[var(--blue-d)] hover:brightness-105 active:scale-[0.985] text-white font-extrabold rounded-lg shadow-sm text-xs cursor-pointer text-center",
                  children: b === "ar" ? "قبول الكل" : "Accept All",
                }),
                l.jsx("button", {
                  onClick: () => {
                    const i = {
                      necessary: !0,
                      analytics: !1,
                      marketing: !1,
                      timestamp: Date.now(),
                      version: "1.0",
                    };
                    (jn(i),
                      Zs(!1),
                      Js(!1),
                      localStorage.setItem(
                        "sh_cookie_consent",
                        JSON.stringify(i),
                      ),
                      Ml(!1),
                      Wl(!1));
                  },
                  className:
                    "py-2 px-3 bg-slate-200 hover:bg-slate-300 dark:bg-slate-800 dark:hover:bg-slate-700 text-[var(--ink)] font-extrabold rounded-lg text-xs cursor-pointer text-center",
                  children: b === "ar" ? "رفض الكل" : "Reject All",
                }),
              ],
            }),
            l.jsx("button", {
              onClick: () => {
                const i = {
                  necessary: !0,
                  analytics: Pr,
                  marketing: or,
                  timestamp: Date.now(),
                  version: "1.0",
                };
                (jn(i),
                  localStorage.setItem("sh_cookie_consent", JSON.stringify(i)),
                  Ml(!1),
                  Wl(!1));
              },
              className:
                "w-full py-2 bg-[var(--ink)] text-white hover:brightness-125 font-extrabold rounded-lg text-xs cursor-pointer transition-colors",
              children: b === "ar" ? "حفظ التفضيلات" : "Save Preferences",
            }),
          ],
        }),
      Yt &&
        l.jsx("div", {
          className:
            "fixed inset-0 z-50 bg-black/40 backdrop-blur-xs flex items-center justify-center lg:justify-end p-2 sm:p-4 lg:p-6 lg:pr-8 overflow-hidden transition-all duration-300 animate-in fade-in",
          onClick: (i) => {
            i.target === i.currentTarget && Y(null);
          },
          children: l.jsxs("div", {
            className:
              "bg-slate-900 border border-slate-700/90 rounded-2xl w-full max-w-[680px] lg:max-w-[760px] xl:max-w-[820px] h-[92vh] max-h-[740px] flex flex-col shadow-2xl overflow-hidden ring-1 ring-white/10 animate-in fade-in slide-in-from-right-8 duration-300",
            children: [
              l.jsxs("div", {
                className:
                  "px-3.5 py-2.5 bg-slate-950 border-b border-slate-800/90 flex flex-wrap items-center justify-between gap-2 shrink-0",
                children: [
                  l.jsxs("div", {
                    className: "flex items-center gap-2.5",
                    children: [
                      l.jsxs("div", {
                        className: "flex items-center gap-1.5 shrink-0",
                        children: [
                          l.jsx("span", {
                            className:
                              "w-2.5 h-2.5 rounded-full bg-rose-500/80 inline-block",
                          }),
                          l.jsx("span", {
                            className:
                              "w-2.5 h-2.5 rounded-full bg-amber-500/80 inline-block",
                          }),
                          l.jsx("span", {
                            className:
                              "w-2.5 h-2.5 rounded-full bg-emerald-500/80 inline-block",
                          }),
                        ],
                      }),
                      l.jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                          l.jsxs("span", {
                            className:
                              "text-xs font-black text-white flex items-center gap-1.5",
                            children: [
                              l.jsx("span", { children: "🎨" }),
                              l.jsx("span", {
                                children: _ ? "معاينة الثيم" : "Theme Preview",
                              }),
                            ],
                          }),
                          l.jsx("span", {
                            className:
                              "px-2 py-0.5 rounded-md text-[10px] font-extrabold bg-blue-600/30 text-blue-300 border border-blue-500/40",
                            children: [
                              {
                                key: "classic-store",
                                nameEn: "1. Classic Store",
                                nameAr: "1. متجر كلاسيكي",
                              },
                              {
                                key: "dark-premium",
                                nameEn: "2. Dark Premium",
                                nameAr: "2. داكن فاخر",
                              },
                              {
                                key: "minimal-white",
                                nameEn: "3. Minimal White",
                                nameAr: "3. أبيض بسيط",
                              },
                              {
                                key: "gradient-neon",
                                nameEn: "4. Gradient Neon",
                                nameAr: "4. تدرج نيون",
                              },
                              {
                                key: "soft-pastel",
                                nameEn: "5. Soft Pastel",
                                nameAr: "5. باستيل ناعم",
                              },
                              {
                                key: "bold-magazine",
                                nameEn: "6. Bold Magazine",
                                nameAr: "6. مجلة عصرية",
                              },
                              {
                                key: "elegant-gold",
                                nameEn: "7. Black & Gold",
                                nameAr: "7. أسود وذهبي",
                              },
                              {
                                key: "fresh-nature",
                                nameEn: "8. Fresh Nature",
                                nameAr: "8. طبيعة خضراء",
                              },
                              {
                                key: "retro-pop",
                                nameEn: "9. Retro Pop",
                                nameAr: "9. ريترو بوب",
                              },
                              {
                                key: "ultra-corporate",
                                nameEn: "10. Ultra Clean",
                                nameAr: "10. شركة احترافي",
                              },
                            ].find((i) => i.key === Yt)?.[
                              _ ? "nameAr" : "nameEn"
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  l.jsx("div", {
                    className:
                      "flex items-center gap-1 overflow-x-auto max-w-[220px] sm:max-w-xs md:max-w-md py-0.5 no-scrollbar",
                    children: [
                      {
                        key: "classic-store",
                        nameEn: "Classic",
                        nameAr: "كلاسيكي",
                      },
                      { key: "dark-premium", nameEn: "Dark", nameAr: "داكن" },
                      {
                        key: "minimal-white",
                        nameEn: "Minimal",
                        nameAr: "بسيط",
                      },
                      { key: "gradient-neon", nameEn: "Neon", nameAr: "نيون" },
                      {
                        key: "soft-pastel",
                        nameEn: "Pastel",
                        nameAr: "باستيل",
                      },
                      { key: "bold-magazine", nameEn: "Bold", nameAr: "مجلة" },
                      { key: "elegant-gold", nameEn: "Gold", nameAr: "ذهبي" },
                      {
                        key: "fresh-nature",
                        nameEn: "Nature",
                        nameAr: "طبيعة",
                      },
                      { key: "retro-pop", nameEn: "Retro", nameAr: "ريترو" },
                      {
                        key: "ultra-corporate",
                        nameEn: "Clean",
                        nameAr: "احترافي",
                      },
                    ].map((i) =>
                      l.jsx(
                        "button",
                        {
                          type: "button",
                          onClick: () => {
                            const B = i.key;
                            (St(B), Y(B));
                          },
                          className: `px-2 py-0.5 rounded-md text-[10px] font-bold whitespace-nowrap transition-all cursor-pointer border ${Yt === i.key ? "bg-blue-600 text-white border-blue-400 font-black shadow-xs" : "bg-slate-800/80 text-slate-300 border-slate-700 hover:bg-slate-700 hover:text-white"}`,
                          children: _ ? i.nameAr : i.nameEn,
                        },
                        i.key,
                      ),
                    ),
                  }),
                  l.jsxs("button", {
                    type: "button",
                    onClick: () => Y(null),
                    className:
                      "px-2.5 py-1 rounded-lg bg-rose-600/20 text-rose-300 hover:bg-rose-600 hover:text-white border border-rose-500/40 transition-all font-black text-xs flex items-center gap-1 cursor-pointer shrink-0 ml-auto",
                    title: "Close Preview",
                    children: [
                      l.jsx("span", { children: "✕" }),
                      l.jsx("span", { children: _ ? "إغلاق" : "Close" }),
                    ],
                  }),
                ],
              }),
              l.jsxs("div", {
                className:
                  "px-3 py-1.5 bg-slate-900/90 border-b border-slate-800 flex items-center justify-between gap-2 text-[10px] text-slate-400 font-mono shrink-0 select-none",
                children: [
                  l.jsxs("div", {
                    className:
                      "flex items-center bg-slate-950 p-0.5 rounded-lg border border-slate-800 shrink-0 font-sans",
                    children: [
                      l.jsxs("button", {
                        type: "button",
                        onClick: () => ve("desktop"),
                        className: `px-2.5 py-1 rounded-md text-[10px] font-black transition-all flex items-center gap-1 cursor-pointer ${re === "desktop" ? "bg-blue-600 text-white shadow-xs" : "text-slate-400 hover:text-slate-200"}`,
                        children: [
                          l.jsx("span", { children: "💻" }),
                          l.jsx("span", {
                            children: _ ? "سطح المكتب" : "Desktop",
                          }),
                        ],
                      }),
                      l.jsxs("button", {
                        type: "button",
                        onClick: () => ve("mobile"),
                        className: `px-2.5 py-1 rounded-md text-[10px] font-black transition-all flex items-center gap-1 cursor-pointer ${re === "mobile" ? "bg-blue-600 text-white shadow-xs" : "text-slate-400 hover:text-slate-200"}`,
                        children: [
                          l.jsx("span", { children: "📱" }),
                          l.jsx("span", { children: _ ? "جوال" : "Mobile" }),
                        ],
                      }),
                    ],
                  }),
                  l.jsxs("div", {
                    className:
                      "flex-1 text-center truncate px-2 font-mono text-[10px] text-slate-400/90 bg-slate-950/80 py-0.5 px-3 rounded-md border border-slate-800/80",
                    children: [
                      "🔒 https://deal-preview.retailer.com/view?theme=",
                      Yt,
                      "&device=",
                      re,
                    ],
                  }),
                ],
              }),
              l.jsx("div", {
                className:
                  "flex-1 overflow-hidden bg-slate-950 relative flex items-center justify-center p-2 sm:p-3",
                children:
                  re === "desktop"
                    ? l.jsx("div", {
                        className:
                          "w-full h-full flex items-center justify-center overflow-hidden",
                        children: l.jsx("div", {
                          className:
                            "pointer-events-none select-none origin-center transform scale-[0.38] sm:scale-[0.42] md:scale-[0.46] lg:scale-[0.50] xl:scale-[0.52] transition-all duration-300 flex flex-col items-center justify-center",
                          style: { width: "1280px", height: "860px" },
                          children: l.jsx("div", {
                            className:
                              "w-full h-full rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-slate-900 flex flex-col",
                            children: l.jsx(pd, {
                              mode: "preview",
                              code: "DEMO-PREVIEW",
                              dest: Ke || "https://walmart.com",
                              title:
                                je && je.trim()
                                  ? je.trim()
                                  : "SMARTFOOD WHITE CHEDDAR CHEESE POPCORN 6.0OZ",
                              description:
                                gt && gt.trim()
                                  ? gt.trim()
                                  : "🔥 Almost gone — tap Confirm & Go To Retailer before it sells out.",
                              image:
                                "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=600&q=80",
                              language: b,
                              showStoreLogo: D,
                              storeLandingPage: pe || "walmart",
                              storeLandingTheme: Yt,
                              storeBackgroundImage: Te,
                              storeCardBg: bt(),
                              multiDealsData: O
                                ? [
                                    {
                                      code: "DEAL1",
                                      title:
                                        je && je.trim()
                                          ? je.trim()
                                          : "Smartfood White Cheddar Popcorn 6.0oz",
                                      previewDescription:
                                        gt && gt.trim()
                                          ? gt.trim()
                                          : "🔥 Almost gone — tap Continue before it sells out.",
                                      image:
                                        "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                    {
                                      code: "DEAL2",
                                      title:
                                        "Ninja Air Fryer XL 5.5-Quart Capacity",
                                      previewDescription:
                                        "⚡ Flash Deal — Save 45% off MSRP today only.",
                                      image:
                                        "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                    {
                                      code: "DEAL3",
                                      title:
                                        "Apple AirPods Pro Wireless Noise Canceling",
                                      previewDescription:
                                        "✨ Top Seller — Free express shipping included.",
                                      image:
                                        "https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                    {
                                      code: "DEAL4",
                                      title:
                                        "Dyson V12 Detect Cordless Vacuum Cleaner",
                                      previewDescription:
                                        "🏷️ Verified Outlet Deal — Limited stock remaining.",
                                      image:
                                        "https://images.unsplash.com/photo-1558317374-067fb5f30001?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                    {
                                      code: "DEAL5",
                                      title:
                                        "Keurig K-Express Coffee Maker Single Serve",
                                      previewDescription:
                                        "☕ Best Morning Deal — Instant coupon applied.",
                                      image:
                                        "https://images.unsplash.com/photo-1517668808822-9a48914b4629?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                    {
                                      code: "DEAL6",
                                      title:
                                        "Sony WH-1000XM5 Wireless Headphones",
                                      previewDescription:
                                        "🎧 Noise Canceling — Lowest price of the season.",
                                      image:
                                        "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                    {
                                      code: "DEAL7",
                                      title:
                                        "Instant Pot Duo 7-in-1 Pressure Cooker",
                                      previewDescription:
                                        "⭐ 4.8 Stars — Top rated home kitchen deal.",
                                      image:
                                        "https://images.unsplash.com/photo-1544816155-12df9643f363?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                    {
                                      code: "DEAL8",
                                      title:
                                        'Samsung 55" Class 4K Crystal UHD Smart TV',
                                      previewDescription:
                                        "📺 Ultra HD — Special clearance pricing today.",
                                      image:
                                        "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=600&q=80",
                                      url: Ke || "https://walmart.com",
                                      store: pe || "Walmart",
                                    },
                                  ].slice(0, G)
                                : null,
                              onGoHome: () => Y(null),
                            }),
                          }),
                        }),
                      })
                    : l.jsx("div", {
                        className:
                          "w-full h-full flex items-center justify-center overflow-hidden",
                        children: l.jsx("div", {
                          className:
                            "pointer-events-none select-none origin-center transform scale-[0.62] sm:scale-[0.68] md:scale-[0.74] transition-all duration-300 flex flex-col items-center justify-center",
                          children: l.jsxs("div", {
                            className:
                              "w-[375px] h-[720px] rounded-[42px] p-2 bg-slate-900 border-[5px] border-slate-700/90 shadow-2xl relative overflow-hidden ring-1 ring-white/10 flex flex-col",
                            children: [
                              l.jsxs("div", {
                                className:
                                  "w-full h-7 bg-slate-950 px-5 flex items-center justify-between text-[11px] text-white font-semibold shrink-0 z-20",
                                children: [
                                  l.jsx("span", { children: "4:26 AM" }),
                                  l.jsxs("div", {
                                    className:
                                      "w-22 h-4 bg-slate-900 rounded-b-xl flex items-center justify-center gap-1.5 shadow-xs",
                                    children: [
                                      l.jsx("div", {
                                        className:
                                          "w-6 h-1 bg-slate-700 rounded-full",
                                      }),
                                      l.jsx("div", {
                                        className:
                                          "w-1.5 h-1.5 bg-slate-700 rounded-full",
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className:
                                      "flex items-center gap-1 text-[10px] text-slate-200",
                                    children: [
                                      l.jsx("span", {
                                        className: "font-bold text-[9px]",
                                        children: "5G",
                                      }),
                                      l.jsx("span", {
                                        className: "text-[10px]",
                                        children: "🔋",
                                      }),
                                    ],
                                  }),
                                ],
                              }),
                              l.jsx("div", {
                                className:
                                  "w-full flex-1 rounded-[24px] overflow-hidden bg-slate-950 relative flex flex-col",
                                children: l.jsx("div", {
                                  className:
                                    "w-full h-full overflow-y-auto no-scrollbar pointer-events-auto",
                                  children: l.jsx(pd, {
                                    mode: "preview",
                                    code: "DEMO-PREVIEW",
                                    dest: Ke || "https://walmart.com",
                                    title:
                                      je && je.trim()
                                        ? je.trim()
                                        : "SMARTFOOD WHITE CHEDDAR CHEESE POPCORN 6.0OZ",
                                    description:
                                      gt && gt.trim()
                                        ? gt.trim()
                                        : "🔥 Almost gone — tap Confirm & Go To Retailer before it sells out.",
                                    image:
                                      "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=600&q=80",
                                    language: b,
                                    showStoreLogo: D,
                                    storeLandingPage: pe || "walmart",
                                    storeLandingTheme: Yt,
                                    storeBackgroundImage: Te,
                                    storeCardBg: bt(),
                                    multiDealsData: O
                                      ? [
                                          {
                                            code: "DEAL1",
                                            title:
                                              je && je.trim()
                                                ? je.trim()
                                                : "Smartfood White Cheddar Popcorn 6.0oz",
                                            previewDescription:
                                              gt && gt.trim()
                                                ? gt.trim()
                                                : "🔥 Almost gone — tap Continue before it sells out.",
                                            image:
                                              "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                          {
                                            code: "DEAL2",
                                            title:
                                              "Ninja Air Fryer XL 5.5-Quart Capacity",
                                            previewDescription:
                                              "⚡ Flash Deal — Save 45% off MSRP today only.",
                                            image:
                                              "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                          {
                                            code: "DEAL3",
                                            title:
                                              "Apple AirPods Pro Wireless Noise Canceling",
                                            previewDescription:
                                              "✨ Top Seller — Free express shipping included.",
                                            image:
                                              "https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                          {
                                            code: "DEAL4",
                                            title:
                                              "Dyson V12 Detect Cordless Vacuum Cleaner",
                                            previewDescription:
                                              "🏷️ Verified Outlet Deal — Limited stock remaining.",
                                            image:
                                              "https://images.unsplash.com/photo-1558317374-067fb5f30001?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                          {
                                            code: "DEAL5",
                                            title:
                                              "Keurig K-Express Coffee Maker Single Serve",
                                            previewDescription:
                                              "☕ Best Morning Deal — Instant coupon applied.",
                                            image:
                                              "https://images.unsplash.com/photo-1517668808822-9a48914b4629?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                          {
                                            code: "DEAL6",
                                            title:
                                              "Sony WH-1000XM5 Wireless Headphones",
                                            previewDescription:
                                              "🎧 Noise Canceling — Lowest price of the season.",
                                            image:
                                              "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                          {
                                            code: "DEAL7",
                                            title:
                                              "Instant Pot Duo 7-in-1 Pressure Cooker",
                                            previewDescription:
                                              "⭐ 4.8 Stars — Top rated home kitchen deal.",
                                            image:
                                              "https://images.unsplash.com/photo-1544816155-12df9643f363?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                          {
                                            code: "DEAL8",
                                            title:
                                              'Samsung 55" Class 4K Crystal UHD Smart TV',
                                            previewDescription:
                                              "📺 Ultra HD — Special clearance pricing today.",
                                            image:
                                              "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=600&q=80",
                                            url: Ke || "https://walmart.com",
                                            store: pe || "Walmart",
                                          },
                                        ].slice(0, G)
                                      : null,
                                    onGoHome: () => Y(null),
                                  }),
                                }),
                              }),
                              l.jsxs("div", {
                                className:
                                  "w-full bg-slate-950 border-t border-slate-800/80 px-2.5 py-1 flex flex-col gap-1 shrink-0 z-20 text-[10px]",
                                children: [
                                  l.jsxs("div", {
                                    className:
                                      "w-full bg-slate-900/90 rounded-xl px-3 py-1 flex items-center justify-between text-slate-300 font-sans border border-slate-800 shadow-inner",
                                    children: [
                                      l.jsx("span", {
                                        className:
                                          "font-extrabold text-[10px] text-slate-400",
                                        children: "AA",
                                      }),
                                      l.jsxs("span", {
                                        className:
                                          "flex items-center gap-1 font-mono text-[9px] text-slate-300 truncate",
                                        children: [
                                          l.jsx("span", { children: "🔒" }),
                                          " mavelylink.ai.studio",
                                        ],
                                      }),
                                      l.jsx("span", {
                                        className:
                                          "text-[10px] text-slate-400 font-bold",
                                        children: "↻",
                                      }),
                                    ],
                                  }),
                                  l.jsxs("div", {
                                    className:
                                      "flex items-center justify-between px-4 text-slate-400 text-xs pb-0.5 pt-0.5",
                                    children: [
                                      l.jsx("span", {
                                        className: "font-bold",
                                        children: "‹",
                                      }),
                                      l.jsx("span", {
                                        className: "font-bold",
                                        children: "›",
                                      }),
                                      l.jsx("span", { children: "↑" }),
                                      l.jsx("span", { children: "📖" }),
                                      l.jsx("span", { children: "▢" }),
                                    ],
                                  }),
                                ],
                              }),
                            ],
                          }),
                        }),
                      }),
              }),
            ],
          }),
        }),
      bl &&
        l.jsx("div", {
          className:
            "fixed inset-0 z-[999999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-xs animate-in fade-in duration-200",
          onClick: qe,
          children: l.jsxs("div", {
            className: `relative max-w-sm w-full p-5 rounded-2xl border-2 shadow-2xl animate-in zoom-in-95 duration-200 text-start ${A ? "bg-[#0b1428] border-cyan-500/80 text-cyan-100 shadow-cyan-950/80" : "bg-white border-blue-600 text-slate-900 shadow-2xl shadow-blue-900/40"}`,
            onClick: (i) => i.stopPropagation(),
            children: [
              l.jsx("button", {
                type: "button",
                onClick: qe,
                className: `absolute top-3 right-3 p-1 rounded-full transition-colors cursor-pointer ${A ? "text-cyan-400 hover:bg-cyan-900/60 hover:text-cyan-100" : "text-slate-400 hover:bg-slate-100 hover:text-slate-700"}`,
                children: l.jsx(hs, { size: 16 }),
              }),
              l.jsxs("div", {
                className: "flex items-start gap-3.5",
                children: [
                  l.jsx("div", {
                    className: `p-2.5 rounded-xl shrink-0 ${A ? "bg-cyan-500/20 text-cyan-300 border border-cyan-400/40" : "bg-blue-100 text-blue-700"}`,
                    children: l.jsx(tf, { className: "w-5 h-5" }),
                  }),
                  l.jsxs("div", {
                    className: "pr-4",
                    children: [
                      l.jsx("h4", {
                        className:
                          "text-sm font-black mb-1.5 flex items-center gap-1.5",
                        children: _ ? "تقييد الدول" : "Country Restriction",
                      }),
                      l.jsx("p", {
                        className:
                          "text-xs font-semibold leading-relaxed opacity-90",
                        children: _
                          ? "هذا الخيار يجعل رابطك القصير يعمل فقط في الدول التي تحددها. الزوار من باقي الدول لن يتمكنوا من فتح الرابط."
                          : "This option makes your short link work only in the countries you select. Visitors from other countries will not be able to open the link.",
                      }),
                    ],
                  }),
                ],
              }),
              l.jsxs("div", {
                className: "mt-5 flex items-center justify-end gap-2.5",
                children: [
                  l.jsx("button", {
                    type: "button",
                    onClick: qe,
                    className: `px-3.5 py-1.5 rounded-xl text-xs font-bold cursor-pointer transition-colors ${A ? "bg-slate-800/80 hover:bg-slate-700 text-slate-300 border border-slate-700" : "bg-slate-100 hover:bg-slate-200 text-slate-700 border border-slate-300"}`,
                    children: _ ? "إلغاء" : "Cancel",
                  }),
                  l.jsx("button", {
                    type: "button",
                    onClick: gl,
                    className: `px-4 py-1.5 rounded-xl text-xs font-black cursor-pointer shadow-xs transition-transform active:scale-95 ${A ? "bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-extrabold" : "bg-blue-600 hover:bg-blue-700 text-white"}`,
                    children: _ ? "أوافق" : "Agree",
                  }),
                ],
              }),
            ],
          }),
        }),
    ],
  });
}
Pp.createRoot(document.getElementById("root")).render(
  l.jsx(x.StrictMode, { children: l.jsx(vm, {}) }),
);
export { am as c, lf as g, l as j, jm as m, Ll as u };
